import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Duration: any;
  JSON: any;
  Login: any;
  Map: any;
  MapString: any;
  Object: any;
  PermissibleMutation: any;
  Time: Date;
  URL: string;
  UUID: string;
  Upload: any;
  VariableValueInput: any;
  YAML: any;
};

export type ApiKey = {
  __typename?: 'APIKey';
  createdAt: Scalars['Time'];
  description: Scalars['String'];
  id: Scalars['UUID'];
  name: Scalars['String'];
  token: Scalars['String'];
};

export type AwsAccount = {
  __typename?: 'AWSAccount';
  accountID?: Maybe<Scalars['String']>;
  awsIamPolicies?: Maybe<Array<AwsIamPolicy>>;
  awsPolicyJson?: Maybe<AwsPolicyJson>;
  awsResources: AwsResourcesOutput;
  cloudFormationReadOnlyURL: Scalars['String'];
  cloudFormationURL: Scalars['String'];
  cloudQuery?: Maybe<CloudQueryService>;
  clusters?: Maybe<Array<Cluster>>;
  connected?: Maybe<Scalars['Boolean']>;
  connectedV2?: Maybe<CloudConnectionInfo>;
  costs: Array<AwsCostItem>;
  costsByService: Array<GroupedAwsCostItem>;
  createdAt: Scalars['Time'];
  externalID?: Maybe<Scalars['String']>;
  iamUsers?: Maybe<Array<AwsUser>>;
  id: Scalars['UUID'];
  name: Scalars['String'];
  networks?: Maybe<Array<Network>>;
  projectV3Adapters?: Maybe<ProjectV3AdapterConnection>;
  projects?: Maybe<ProjectConnection>;
  rightSizingRecommendations?: Maybe<Array<RightSizingRecommendation>>;
  roleARN?: Maybe<Scalars['String']>;
  savingsPlanRecommendations?: Maybe<SavingsPlanRecommendation>;
  state: AwsAccountState;
  updatedAt: Scalars['Time'];
  userIamConnections?: Maybe<Array<UserIamConnection>>;
};


export type AwsAccountAwsPolicyJsonArgs = {
  input: AwsPolicyJsonInput;
};


export type AwsAccountAwsResourcesArgs = {
  input?: InputMaybe<AwsResourceSearchInput>;
};


export type AwsAccountCostsArgs = {
  input: AwsCostsInput;
};


export type AwsAccountCostsByServiceArgs = {
  input: AwsCostsByServiceInput;
};


export type AwsAccountProjectsArgs = {
  input?: InputMaybe<ProjectsInput>;
};


export type AwsAccountSavingsPlanRecommendationsArgs = {
  input: SavingsPlanRecommendationsInput;
};

export enum AwsAccountState {
  Error = 'ERROR',
  Success = 'SUCCESS',
  Waiting = 'WAITING'
}

export type AwsLambda = {
  __typename?: 'AWSLambda';
  apiGatewayUrl?: Maybe<Scalars['String']>;
  arn?: Maybe<Scalars['String']>;
  awsAccount?: Maybe<AwsAccount>;
  id: Scalars['UUID'];
  name: Scalars['String'];
  region?: Maybe<Scalars['String']>;
};

export type AwsLinks = {
  __typename?: 'AWSLinks';
  apiGateway?: Maybe<Scalars['String']>;
  cloudformation?: Maybe<Scalars['String']>;
  cloudwatchLogs?: Maybe<Scalars['String']>;
  cloudwatchMetrics?: Maybe<Scalars['String']>;
  ec2?: Maybe<Scalars['String']>;
  eks?: Maybe<Scalars['String']>;
  iam?: Maybe<Scalars['String']>;
  lambda?: Maybe<Scalars['String']>;
  rds?: Maybe<Scalars['String']>;
  vpc?: Maybe<Scalars['String']>;
};

export type AcceleratorSpec = {
  __typename?: 'AcceleratorSpec';
  count?: Maybe<Scalars['Int']>;
  tpuTfVersion?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type AcceleratorSpecInput = {
  count: Scalars['Int'];
  tpuTfVersion?: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
};

export type AdapterStatusCriterion = {
  value?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type AddAwsAccountInput = {
  accountID: Scalars['String'];
  userID: Scalars['UUID'];
};

export type AddAzureAccountInput = {
  clientID: Scalars['String'];
  clientSecret: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  subscriptionID: Scalars['String'];
  tenantID: Scalars['String'];
  userID: Scalars['UUID'];
};

export type AddCdnInput = {
  domains?: InputMaybe<Array<Scalars['String']>>;
  id: Scalars['UUID'];
  provider: CdnProvider;
};

export type AddClusterInput = {
  awsAccountID?: InputMaybe<Scalars['UUID']>;
  gcpAccountID?: InputMaybe<Scalars['UUID']>;
  isPlaceholder?: InputMaybe<Scalars['Boolean']>;
  kubeconfig?: InputMaybe<Scalars['Upload']>;
  name?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  userID: Scalars['UUID'];
};

export type AddContainerRegistryInput = {
  name: Scalars['String'];
  password: Scalars['String'];
  registry: Scalars['String'];
  userID: Scalars['UUID'];
  username: Scalars['String'];
};

export type AddCoreWeaveAccountInput = {
  kubeconfig?: InputMaybe<Scalars['Upload']>;
  userID: Scalars['UUID'];
};

export type AddDoAccountInput = {
  accessToken: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  userID: Scalars['UUID'];
};

export type AddGcpAccountInput = {
  credentials: Scalars['Upload'];
  projectID: Scalars['String'];
  userID: Scalars['UUID'];
};

export type AddLinodeAccountInput = {
  accessToken: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  userID: Scalars['UUID'];
};

export type AddProjectCollaboratorInput = {
  id: Scalars['ID'];
  role: ProjectCollaboratorRole;
  user: Scalars['String'];
};

/** Defines the input parameters required to add a custom domain to a repository. */
export type AddRepoCustomDomainInput = {
  /**
   * Optional. Updates the challenge type used by the certificate manager for verifying domain ownership and issuing SSL certificates.
   * This can affect how domain verification is performed, with options like 'dns01' and 'http01'.
   */
  certManagerChallengerType?: InputMaybe<CertManagerChallengeType>;
  /**
   * Optional. Specifies whether to disable the automatic SSL certificate management for this domain.
   * Useful when handling certificates through external mechanisms or different processes.
   */
  disableCertManager?: InputMaybe<Scalars['Boolean']>;
  /** The domain name to be added and configured for the repository. This domain cannot be changed once set. */
  domain: Scalars['String'];
  /** The unique identifier of the repository to which the custom domain will be added. */
  id: Scalars['UUID'];
  /** Optional. The target external port to be used for the custom domain. If not provided, the first https port will be used. */
  servicePort?: InputMaybe<Scalars['Int']>;
  /**
   * Optional. The unique identifier of another custom domain certificate that this new domain should sync with.
   * This removes the need to manage certificates separately, ensuring consistent configurations across multiple domains.
   */
  syncDomainID?: InputMaybe<Scalars['UUID']>;
};

export type AddTeamMemberInput = {
  id: Scalars['UUID'];
  role: TeamMemberRole;
  userID?: InputMaybe<Scalars['UUID']>;
  username?: InputMaybe<Scalars['String']>;
};

export type AddVultrAccountInput = {
  accessToken: Scalars['String'];
  name: Scalars['String'];
  userID: Scalars['UUID'];
};

export type AlternativeImage = {
  __typename?: 'AlternativeImage';
  name?: Maybe<Scalars['String']>;
  reference?: Maybe<Scalars['String']>;
  tag?: Maybe<Scalars['String']>;
};

export type ApiAccess = Product & {
  __typename?: 'ApiAccess';
  benefits: Array<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  displayPrice?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  productTypeMetadata?: Maybe<ProductTypeMetadata>;
  sku: Scalars['ID'];
  usage: Array<Usage>;
};

export type AttachAwsPolicyToUser = {
  awsAccountCredentialsId: Scalars['UUID'];
  awsUsername: Scalars['String'];
  policyArn: Scalars['String'];
  userID: Scalars['UUID'];
};

export type AttachedAwsIamPolicy = {
  __typename?: 'AttachedAwsIamPolicy';
  arn: Scalars['String'];
  groupName: Scalars['String'];
  policyName: Scalars['String'];
};

export type Autoscaling = {
  __typename?: 'Autoscaling';
  coolDownPeriod?: Maybe<Scalars['Int']>;
  kedaScaledObjectSpec?: Maybe<Scalars['String']>;
  maxReplicas: Scalars['Int'];
  minReplicas: Scalars['Int'];
  triggers?: Maybe<Array<AutoscalingTrigger>>;
};

export type AutoscalingInput = {
  coolDownPeriod?: InputMaybe<Scalars['Int']>;
  kedaScaledObjectSpec?: InputMaybe<Scalars['String']>;
  maxReplicas: Scalars['Int'];
  minReplicas: Scalars['Int'];
  triggers?: InputMaybe<Array<AutoscalingTriggerInput>>;
};

export type AutoscalingTrigger = {
  __typename?: 'AutoscalingTrigger';
  spec: Scalars['YAML'];
  type: AutoscalingType;
};

export type AutoscalingTriggerInput = {
  spec: Scalars['YAML'];
  type: AutoscalingType;
};

export enum AutoscalingType {
  Cpu = 'CPU',
  Custom = 'CUSTOM',
  Memory = 'MEMORY',
  Prometheus = 'PROMETHEUS'
}

export type AwsCostItem = {
  __typename?: 'AwsCostItem';
  timePeriod: TimePeriod;
  total: AwsCostTotal;
};

export type AwsCostTotal = {
  __typename?: 'AwsCostTotal';
  amount: Scalars['String'];
  unit: Scalars['String'];
};

export type AwsCostsByServiceInput = {
  endAt: Scalars['Time'];
  includeCredit: Scalars['Boolean'];
  services: Array<Scalars['String']>;
  startAt: Scalars['Time'];
  timeFilter: TimeFilter;
};

export type AwsCostsInput = {
  endAt: Scalars['Time'];
  includeCredit: Scalars['Boolean'];
  startAt: Scalars['Time'];
  timeFilter: TimeFilter;
};

export type AwsIamPolicy = {
  __typename?: 'AwsIamPolicy';
  arn: Scalars['String'];
  awsAccountId: Scalars['String'];
  policyName: Scalars['String'];
};

export type AwsPolicyJson = {
  __typename?: 'AwsPolicyJson';
  awsPolicyJson: Scalars['JSON'];
};

export type AwsRegionStatus = {
  __typename?: 'AwsRegionStatus';
  enabled: Scalars['Boolean'];
  message?: Maybe<Scalars['String']>;
  region: Scalars['String'];
  regionName?: Maybe<Scalars['String']>;
};

export type AwsResource = {
  __typename?: 'AwsResource';
  arn: Scalars['String'];
  region?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type AwsResourceSearchInput = {
  nextToken?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  tag?: InputMaybe<Scalars['String']>;
};

export type AwsResourcesOutput = {
  __typename?: 'AwsResourcesOutput';
  awsResources?: Maybe<Array<AwsResource>>;
  nextToken?: Maybe<Scalars['String']>;
};

export type AwsSamGeneratorConfiguration = {
  __typename?: 'AwsSamGeneratorConfiguration';
  buildImage?: Maybe<Scalars['String']>;
  customDomainCertificateArn?: Maybe<Scalars['String']>;
  customDomainHost?: Maybe<Scalars['String']>;
  envVars?: Maybe<Array<EnvVar>>;
  httpPort?: Maybe<Scalars['String']>;
  runCommand?: Maybe<Scalars['String']>;
  serverlessArch?: Maybe<Scalars['String']>;
  serverlessMemory?: Maybe<Scalars['Int']>;
};

export type AwsSamGeneratorConfigurationInput = {
  buildImage?: InputMaybe<Scalars['String']>;
  customDomainCertificateArn?: InputMaybe<Scalars['String']>;
  customDomainHost?: InputMaybe<Scalars['String']>;
  envVars?: InputMaybe<Array<InputMaybe<EnvVarInput>>>;
  httpPort?: InputMaybe<Scalars['String']>;
  runCommand?: InputMaybe<Scalars['String']>;
  serverlessArch?: InputMaybe<Scalars['String']>;
  serverlessMemory?: InputMaybe<Scalars['Int']>;
};

export type AwsSamProjectV3Configuration = {
  __typename?: 'AwsSamProjectV3Configuration';
  awsAccountId: Scalars['UUID'];
  awsRegion?: Maybe<Scalars['String']>;
  generator?: Maybe<AwsSamGeneratorConfiguration>;
  stackName: Scalars['String'];
};

export type AwsSamProjectV3ConfigurationInput = {
  awsAccountId: Scalars['UUID'];
  awsRegion?: InputMaybe<Scalars['String']>;
  generator?: InputMaybe<AwsSamGeneratorConfigurationInput>;
  stackName: Scalars['String'];
};

export type AwsServiceCostItem = {
  __typename?: 'AwsServiceCostItem';
  service: Scalars['String'];
  total: AwsCostTotal;
};

export type AwsUser = {
  __typename?: 'AwsUser';
  arn: Scalars['String'];
  attachedAwsPolicies: Array<Maybe<AttachedAwsIamPolicy>>;
  awsAccountId: Scalars['String'];
  userId: Scalars['String'];
  username: Scalars['String'];
};

export type AzureAccount = {
  __typename?: 'AzureAccount';
  clientID?: Maybe<Scalars['String']>;
  clusters?: Maybe<Array<Cluster>>;
  connected?: Maybe<Scalars['Boolean']>;
  connectedV2?: Maybe<CloudConnectionInfo>;
  createdAt: Scalars['Time'];
  id: Scalars['UUID'];
  name: Scalars['String'];
  projectV3Adapters?: Maybe<ProjectV3AdapterConnection>;
  projects?: Maybe<ProjectConnection>;
  state: CloudAccountState;
  subscriptionID?: Maybe<Scalars['String']>;
  tenantID?: Maybe<Scalars['String']>;
  updatedAt: Scalars['Time'];
};


export type AzureAccountProjectsArgs = {
  input?: InputMaybe<ProjectsInput>;
};

export type BetterStackIntegration = {
  __typename?: 'BetterStackIntegration';
  token: Scalars['String'];
};

export type BetterStackIntegrationInput = {
  token: Scalars['String'];
};

/** A sentinel value returned when we are not able to facilitate self-service for a desired action */
export enum BillingActionNotAllowed {
  /** You are not authorized to perform this billing action */
  ContactBillingAdministrator = 'CONTACT_BILLING_ADMINISTRATOR',
  /** Please contact Zeet Support for assistance */
  ContactUs = 'CONTACT_US'
}

export type BillingOverview = {
  __typename?: 'BillingOverview';
  currentProducts?: Maybe<Array<Product>>;
  externalLinks?: Maybe<ExternalBillingProviderLinks>;
  hasUpgradedProducts: Scalars['Boolean'];
  isBillingSetup: Scalars['Boolean'];
  subscriptionFeatures: SubscriptionFeatures;
  subscriptionUsageAllowed: SubscriptionUsageAllowed;
};

export type BitbucketAccount = {
  __typename?: 'BitbucketAccount';
  username: Scalars['String'];
};

export type BitbucketIntegration = Integration & {
  __typename?: 'BitbucketIntegration';
  account?: Maybe<BitbucketAccount>;
  apiUrl: Scalars['URL'];
  authType: BitbucketIntegrationAuthType;
  connected?: Maybe<Scalars['Boolean']>;
  createdAt: Scalars['Time'];
  description: Scalars['String'];
  id: Scalars['UUID'];
  image: Scalars['String'];
  name: Scalars['String'];
  type: IntegrationType;
  updatedAt: Scalars['Time'];
  webhookToken: Scalars['String'];
  webhookUrl: Scalars['URL'];
};

export enum BitbucketIntegrationAuthType {
  AccessToken = 'ACCESS_TOKEN',
  Oauth2 = 'OAUTH2'
}

export type BitbucketRepoIntegration = GitRepoIntegration & {
  __typename?: 'BitbucketRepoIntegration';
  autoDeployBranch: Scalars['Boolean'];
  autoStopBranch: Scalars['Boolean'];
  autoStopPullRequest: Scalars['Boolean'];
  bitbucketIntegration?: Maybe<BitbucketIntegration>;
  bitbucketRepository?: Maybe<BitbucketRepository>;
  branchIgnore: Scalars['String'];
  branchStopIgnore: Scalars['String'];
  id: Scalars['UUID'];
};

export type BitbucketRepository = CiSource & GitRepository & {
  __typename?: 'BitbucketRepository';
  branches?: Maybe<Array<GitBranch>>;
  defaultBranch?: Maybe<GitBranch>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isFork: Scalars['Boolean'];
  isPrivate: Scalars['Boolean'];
  name: Scalars['String'];
  owner: Scalars['String'];
  primaryLanguage?: Maybe<Scalars['String']>;
  provider: GitProvider;
  providerID: Scalars['ID'];
  updatedAt: Scalars['Time'];
  url: Scalars['URL'];
};

export type Blueprint = {
  __typename?: 'Blueprint';
  allowedCloudProviders: Array<CloudProvider>;
  configuration?: Maybe<BlueprintConfiguration>;
  description?: Maybe<Scalars['String']>;
  displayName: Scalars['String'];
  docsUrl?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  id: Scalars['UUID'];
  isOfficial?: Maybe<Scalars['Boolean']>;
  logoUrl?: Maybe<Scalars['String']>;
  owner?: Maybe<BlueprintOwner>;
  projectCount: Scalars['Int'];
  published: Scalars['Boolean'];
  richInputSchema?: Maybe<Scalars['JSON']>;
  slug: Scalars['String'];
  tags: Array<Scalars['String']>;
  type: BlueprintType;
  variables: Array<BlueprintVariableSpec>;
};

export type BlueprintConfiguration = BlueprintHelmConfiguration | BlueprintManifestConfiguration | BlueprintTerraformConfiguration;

export type BlueprintConfigurationInput = {
  helm?: InputMaybe<BlueprintHelmConfigurationInput>;
  manifest?: InputMaybe<BlueprintManifestConfigurationInput>;
  terraform?: InputMaybe<BlueprintTerraformConfigurationInput>;
};

export type BlueprintConfigurationUpdate = {
  helm?: InputMaybe<BlueprintHelmConfigurationUpdate>;
  kubernetesManifest?: InputMaybe<BlueprintManifestConfigurationUpdate>;
  terraform?: InputMaybe<BlueprintTerraformConfigurationUpdate>;
};

export type BlueprintConnection = {
  __typename?: 'BlueprintConnection';
  nodes: Array<Blueprint>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export enum BlueprintDriver {
  Helm = 'HELM',
  KubernetesManifest = 'KUBERNETES_MANIFEST',
  Terraform = 'TERRAFORM'
}

export enum BlueprintDriverAction {
  Apply = 'APPLY',
  Approve = 'APPROVE',
  Plan = 'PLAN',
  PlanDestroy = 'PLAN_DESTROY'
}

export type BlueprintDriverActionExecution = {
  __typename?: 'BlueprintDriverActionExecution';
  action: BlueprintDriverAction;
  approvedAt?: Maybe<Scalars['Time']>;
  createdAt: Scalars['Time'];
  driver: BlueprintDriver;
  id: Scalars['UUID'];
  jobRun?: Maybe<JobRun>;
  planExecution?: Maybe<BlueprintDriverActionExecution>;
  updatedAt: Scalars['Time'];
};

export type BlueprintDriverActionExecutionConnection = {
  __typename?: 'BlueprintDriverActionExecutionConnection';
  nodes: Array<BlueprintDriverActionExecution>;
  pageInfo: PageInfo;
};

export type BlueprintDriverActionInput = {
  action: BlueprintDriverAction;
  driver: BlueprintDriver;
  /**
   * Action-dependent input for the action execution
   *
   * Because GraphQL does not support Input Unions, this field cannot be statically type-checked.
   * To document the structure for this field, we publish the input types in this schema.
   * For example, if you are issuing the APPLY action to the TERRAFORM driver, look for TerraformPlanActionParameters.
   */
  parameters?: InputMaybe<Scalars['Object']>;
  /** - v0.ProjectV3ID */
  projectID: Scalars['UUID'];
};

export type BlueprintDriverActionResult = {
  __typename?: 'BlueprintDriverActionResult';
  execution?: Maybe<BlueprintDriverActionExecution>;
};

/**
 * CAUTION: Experimental!
 *
 * Provides a similar interface to the ProjectV3Workflow type.
 */
export type BlueprintDriverWorkflow = {
  __typename?: 'BlueprintDriverWorkflow';
  createdAt: Scalars['Time'];
  id: Scalars['UUID'];
  /**
   * The driver action execution records. NOTE: will not have a record for PROJECT_DELETE.
   * @deprecated this field is replaced by 'steps'
   */
  jobs?: Maybe<Array<BlueprintDriverActionExecution>>;
  status: ProjectV3WorkflowStatus;
  /**
   * The sequence of actions in the workflow. Useful for identifying the presence of a PROJECT_DELETE step.
   * @deprecated this field is replaced by 'steps'
   */
  stepActions: Array<BlueprintDriverWorkflowStepAction>;
  steps: Array<BlueprintDriverWorkflowStep>;
  updatedAt: Scalars['Time'];
};

export type BlueprintDriverWorkflowInput = {
  /** The driver to execute the actions */
  driver: BlueprintDriver;
  /**
   * The steps to execute. This list must not be empty, and must represent a valid workflow.
   *
   * - Plan-type actions must come first.
   * - An Approval action must follow a Plan-type action.
   * - An Apply action may follow a Plan-type or Approval action.
   * - The "Project Delete" action must follow an Apply action, and the workflow must begin with the "Plan Destroy" action
   */
  steps: Array<BlueprintDriverWorkflowStepAction>;
};

export type BlueprintDriverWorkflowStep = {
  __typename?: 'BlueprintDriverWorkflowStep';
  action: BlueprintDriverWorkflowStepAction;
  execution?: Maybe<BlueprintDriverActionExecution>;
  status: BlueprintDriverWorkflowStepStatus;
};

export enum BlueprintDriverWorkflowStepAction {
  DriverApply = 'DRIVER_APPLY',
  DriverApprove = 'DRIVER_APPROVE',
  DriverPlan = 'DRIVER_PLAN',
  DriverPlanDestroy = 'DRIVER_PLAN_DESTROY',
  ProjectDelete = 'PROJECT_DELETE'
}

export enum BlueprintDriverWorkflowStepStatus {
  Aborted = 'ABORTED',
  Completed = 'COMPLETED',
  Error = 'ERROR',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Running = 'RUNNING'
}

export type BlueprintHelmConfiguration = {
  __typename?: 'BlueprintHelmConfiguration';
  source?: Maybe<Source>;
};

export type BlueprintHelmConfigurationInput = {
  source?: InputMaybe<SourceInput>;
};

export type BlueprintHelmConfigurationUpdate = {
  source?: InputMaybe<SourceInput>;
};

export type BlueprintManifestConfiguration = {
  __typename?: 'BlueprintManifestConfiguration';
  generator?: Maybe<KubernetesManifestGeneratorConfiguration>;
  source?: Maybe<Source>;
  useKustomize?: Maybe<Scalars['Boolean']>;
};

export type BlueprintManifestConfigurationInput = {
  source?: InputMaybe<SourceInput>;
  useKustomize?: InputMaybe<Scalars['Boolean']>;
};

export type BlueprintManifestConfigurationUpdate = {
  source?: InputMaybe<SourceInput>;
  useKustomize?: InputMaybe<Scalars['Boolean']>;
};

export type BlueprintMetadata = {
  __typename?: 'BlueprintMetadata';
  applicationVersion?: Maybe<Scalars['String']>;
  availableVersions: Array<Scalars['String']>;
  createdAt?: Maybe<Scalars['Time']>;
  description?: Maybe<Scalars['String']>;
  displayName: Scalars['String'];
  id: Scalars['UUID'];
  latestVersion?: Maybe<Scalars['String']>;
  logoUrl?: Maybe<Scalars['String']>;
  metatags?: Maybe<Array<Maybe<BlueprintMetadataMetaTag>>>;
  name: Scalars['String'];
  organizationDisplayName?: Maybe<Scalars['String']>;
  organizationName?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  tags: Array<Scalars['String']>;
  type: BlueprintType;
  updatedAt?: Maybe<Scalars['Time']>;
  version?: Maybe<Scalars['String']>;
  versions: Array<BlueprintMetadataVersion>;
};

export type BlueprintMetadataConnection = {
  __typename?: 'BlueprintMetadataConnection';
  nodes: Array<BlueprintMetadata>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type BlueprintMetadataFilter = {
  name?: InputMaybe<StringCriterion>;
};

export type BlueprintMetadataMetaTag = {
  __typename?: 'BlueprintMetadataMetaTag';
  name: Scalars['String'];
  value: Scalars['String'];
};

export type BlueprintMetadataVersion = {
  __typename?: 'BlueprintMetadataVersion';
  prerelease?: Maybe<Scalars['Boolean']>;
  timestamp?: Maybe<Scalars['Time']>;
  version: Scalars['String'];
};

export enum BlueprintOutputDataSource {
  Input = 'INPUT',
  Output = 'OUTPUT',
  Resource = 'RESOURCE'
}

export type BlueprintOutputSchema = {
  entries?: InputMaybe<Array<BlueprintOutputSchemaEntry>>;
};

export type BlueprintOutputSchemaEntry = {
  dataPath?: InputMaybe<Scalars['String']>;
  dataSource?: InputMaybe<BlueprintOutputDataSource>;
  displayName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  transformationContext?: InputMaybe<BlueprintOutputTransformationContext>;
  transformations?: InputMaybe<Array<BlueprintOutputTransformationType>>;
  type?: InputMaybe<VariableType>;
};

export type BlueprintOutputTransformationContext = {
  yaml?: InputMaybe<BlueprintOutputTransformationYamlContext>;
};

export enum BlueprintOutputTransformationType {
  ClusterIp = 'CLUSTER_IP',
  DecodeBase64 = 'DECODE_BASE64',
  Yaml = 'YAML'
}

export type BlueprintOutputTransformationYamlContext = {
  path: Scalars['String'];
};

export type BlueprintOwner = ProfileOwner & {
  __typename?: 'BlueprintOwner';
  avatar?: Maybe<Scalars['URL']>;
  login: Scalars['Login'];
  name: Scalars['String'];
};

export type BlueprintTerraformConfiguration = {
  __typename?: 'BlueprintTerraformConfiguration';
  /** @deprecated use moduleSource field instead */
  githubSource?: Maybe<Scalars['String']>;
  moduleSource?: Maybe<TerraformModuleSource>;
  /** @deprecated use moduleSource field instead */
  moduleVersionConstraint?: Maybe<Scalars['String']>;
  outputConfiguration?: Maybe<TerraformOutputConfiguration>;
  /** @deprecated use moduleSource field instead */
  registrySource?: Maybe<Scalars['String']>;
  terraformVersion?: Maybe<Scalars['String']>;
};

export type BlueprintTerraformConfigurationInput = {
  /** @deprecated use moduleSource field instead */
  gitIntegration?: InputMaybe<GitSourceIntegrationInput>;
  /** @deprecated use moduleSource field instead */
  githubSource?: InputMaybe<Scalars['String']>;
  moduleSource?: InputMaybe<TerraformModuleSourceInput>;
  /** @deprecated use moduleSource field instead */
  moduleVersionConstraint?: InputMaybe<Scalars['String']>;
  outputConfiguration?: InputMaybe<TerraformOutputConfigurationInput>;
  /** @deprecated use moduleSource field instead */
  registrySource?: InputMaybe<Scalars['String']>;
  terraformVersion?: InputMaybe<Scalars['String']>;
};

export type BlueprintTerraformConfigurationUpdate = {
  gitIntegration?: InputMaybe<GitSourceIntegrationInput>;
  /** @deprecated use moduleSource field instead */
  githubSource?: InputMaybe<Scalars['String']>;
  moduleSource?: InputMaybe<TerraformModuleSourceInput>;
  /** @deprecated use moduleSource field instead */
  moduleVersionConstraint?: InputMaybe<Scalars['String']>;
  /** @deprecated use moduleSource field instead */
  registrySource?: InputMaybe<Scalars['String']>;
};

export enum BlueprintType {
  Helm = 'HELM',
  KubernetesManifest = 'KUBERNETES_MANIFEST',
  Terraform = 'TERRAFORM',
  ZeetAwsLambda = 'ZEET_AWS_LAMBDA',
  ZeetGcpCloudRun = 'ZEET_GCP_CLOUD_RUN',
  ZeetKubernetes = 'ZEET_KUBERNETES'
}

export type BlueprintVariable = BlueprintVariableBoolean | BlueprintVariableFloat | BlueprintVariableInt | BlueprintVariableJson | BlueprintVariableString;

export type BlueprintVariableBoolean = {
  __typename?: 'BlueprintVariableBoolean';
  id: Scalars['UUID'];
  name: Scalars['String'];
  value: Scalars['Boolean'];
  variableSpecID?: Maybe<Scalars['UUID']>;
};

export type BlueprintVariableFloat = {
  __typename?: 'BlueprintVariableFloat';
  id: Scalars['UUID'];
  name: Scalars['String'];
  value: Scalars['Float'];
  variableSpecID?: Maybe<Scalars['UUID']>;
};

/**
 * A ProjectV3's BlueprintVariable represent key-value pairs: each a variable name and its value.
 * These variables can either reference a variable spec, as defined by the Blueprint, or they can be declared
 * as "custom variables" for the ProjectV3.
 *
 * To reference a variable spec, specify either variableSpecID or the variableName that corresponds to a variable spec.
 *
 * To declare a custom variable, specify the variableName and the variableType.
 * If there is a variableSpec with the same name, the variableType will be ignored, and the variableSpec will take precedence.
 *
 * All BlueprintVariables must specify their value. The VariableValueInput is serialized as a string, and is parsed
 * server-side according to the variableType.
 */
export type BlueprintVariableInput = {
  /**
   * The variable value. Always a string value, which will be parsed according to the variableType, determined either
   * by the referenced variableSpec, or the provided variableType
   */
  value: Scalars['VariableValueInput'];
  /**
   * Name of the corresponding variable spec, or name to use when declaring a variable without referencing a variable spec.
   * Must be present if variableSpecID is not specified.
   */
  variableName?: InputMaybe<Scalars['String']>;
  /** ID of the corresponding variable spec. Must be present if variableName is not specified. */
  variableSpecID?: InputMaybe<Scalars['UUID']>;
  /** Type specification is required when variable is being declared without referencing a variable spec. */
  variableType?: InputMaybe<BlueprintVariableType>;
};

export type BlueprintVariableInt = {
  __typename?: 'BlueprintVariableInt';
  id: Scalars['UUID'];
  name: Scalars['String'];
  value: Scalars['Int'];
  variableSpecID?: Maybe<Scalars['UUID']>;
};

export type BlueprintVariableJson = {
  __typename?: 'BlueprintVariableJSON';
  id: Scalars['UUID'];
  name: Scalars['String'];
  value: Scalars['JSON'];
  variableSpecID?: Maybe<Scalars['UUID']>;
};

export type BlueprintVariableSpec = {
  __typename?: 'BlueprintVariableSpec';
  id: Scalars['UUID'];
  name: Scalars['String'];
  required: Scalars['Boolean'];
  type: BlueprintVariableType;
};

export type BlueprintVariableSpecInput = {
  name: Scalars['String'];
  required: Scalars['Boolean'];
  type: BlueprintVariableType;
};

export type BlueprintVariableSpecUpdate = {
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  remove?: InputMaybe<Scalars['Boolean']>;
  required: Scalars['Boolean'];
  type: BlueprintVariableType;
};

export type BlueprintVariableString = {
  __typename?: 'BlueprintVariableString';
  id: Scalars['UUID'];
  name: Scalars['String'];
  value: Scalars['String'];
  variableSpecID?: Maybe<Scalars['UUID']>;
};

export enum BlueprintVariableType {
  Boolean = 'BOOLEAN',
  Float = 'FLOAT',
  Integer = 'INTEGER',
  Json = 'JSON',
  String = 'STRING'
}

export type BlueprintsMarketplace = {
  __typename?: 'BlueprintsMarketplace';
  blueprint?: Maybe<Blueprint>;
  blueprintMetadata?: Maybe<BlueprintMetadata>;
  blueprintMetadataList?: Maybe<BlueprintMetadataConnection>;
  blueprints?: Maybe<BlueprintConnection>;
};


export type BlueprintsMarketplaceBlueprintArgs = {
  owner: Scalars['Login'];
  slug: Scalars['String'];
};


export type BlueprintsMarketplaceBlueprintMetadataArgs = {
  owner?: InputMaybe<Scalars['Login']>;
  slug: Scalars['String'];
  version?: InputMaybe<Scalars['String']>;
};


export type BlueprintsMarketplaceBlueprintMetadataListArgs = {
  filter: FilterInput;
};


export type BlueprintsMarketplaceBlueprintsArgs = {
  page?: InputMaybe<PageInput>;
};

export type BooleanCriterion = {
  value: Scalars['Boolean'];
};

export type BranchInput = {
  active?: InputMaybe<Scalars['Boolean']>;
};

export type Build = {
  __typename?: 'Build';
  backend?: Maybe<Scalars['String']>;
  buildID?: Maybe<Scalars['String']>;
  createdAt: Scalars['Time'];
  errorMessage?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  image?: Maybe<Scalars['String']>;
  logs?: Maybe<Logs>;
  metrics?: Maybe<Array<Metric>>;
  state: BuildState;
  updatedAt: Scalars['Time'];
  version?: Maybe<Scalars['String']>;
};


export type BuildMetricsArgs = {
  name: Scalars['String'];
};

export type BuildLogsInput = {
  after?: InputMaybe<Scalars['String']>;
  deploymentID: Scalars['ID'];
};

export type BuildMethod = {
  __typename?: 'BuildMethod';
  buildCommand?: Maybe<Scalars['String']>;
  dockerfilePath?: Maybe<Scalars['String']>;
  golangVersion?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  nodejsVersion?: Maybe<Scalars['String']>;
  pythonVersion?: Maybe<Scalars['String']>;
  releaseCommand?: Maybe<Scalars['String']>;
  runCommand?: Maybe<Scalars['String']>;
  staticPath?: Maybe<Scalars['String']>;
  type: BuildType;
  workingDirectory?: Maybe<Scalars['String']>;
};

export type BuildStage = IPipelineStage & {
  __typename?: 'BuildStage';
  build?: Maybe<Build>;
  buildTemplates?: Maybe<Array<BuildTemplate>>;
  id: Scalars['UUID'];
  job?: Maybe<JobRun>;
  logs?: Maybe<Logs>;
  metrics?: Maybe<Array<Metric>>;
};


export type BuildStageMetricsArgs = {
  name: Scalars['String'];
};

export enum BuildState {
  BuildFailed = 'BUILD_FAILED',
  BuildInProgress = 'BUILD_IN_PROGRESS',
  BuildStarting = 'BUILD_STARTING',
  BuildSucceeded = 'BUILD_SUCCEEDED'
}

export enum BuildTarget {
  ClusterRegistry = 'CLUSTER_REGISTRY',
  ContainerRegistry = 'CONTAINER_REGISTRY',
  NullRegistry = 'NULL_REGISTRY'
}

export type BuildTargetInput = {
  buildTarget: BuildTarget;
  clusterID?: InputMaybe<Scalars['UUID']>;
};

export type BuildTemplate = {
  __typename?: 'BuildTemplate';
  output?: Maybe<Scalars['String']>;
  type: BuildTemplateType;
};

export enum BuildTemplateType {
  Dockerfile = 'DOCKERFILE'
}

export enum BuildType {
  Buildpacks = 'BUILDPACKS',
  Docker = 'DOCKER',
  ElixirPhoenix = 'ELIXIR_PHOENIX',
  GolangModules = 'GOLANG_MODULES',
  Herokuish = 'HEROKUISH',
  Node = 'NODE',
  NodeNextjs = 'NODE_NEXTJS',
  NodeStatic = 'NODE_STATIC',
  Python = 'PYTHON',
  PythonDjango = 'PYTHON_DJANGO',
  Ubuntu = 'UBUNTU'
}

export type Cdn = {
  __typename?: 'CDN';
  certificate?: Maybe<Certificate>;
  domains?: Maybe<Array<CdnDomain>>;
  endpoint?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  origin?: Maybe<Scalars['String']>;
  provider: CdnProvider;
  state: Scalars['String'];
};

export type CdnDomain = {
  __typename?: 'CDNDomain';
  certReady?: Maybe<Scalars['Boolean']>;
  domain: Scalars['String'];
  instruction?: Maybe<DnsRecord>;
  routeReady?: Maybe<Scalars['Boolean']>;
};

export enum CdnProvider {
  AwsCloudfront = 'AWS_CLOUDFRONT'
}

export type CiSource = {
  description?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  owner: Scalars['String'];
  url: Scalars['URL'];
};

export type CancelJobInput = {
  id: Scalars['UUID'];
};

export enum CatalogProductStatus {
  Current = 'CURRENT',
  Downgrade = 'DOWNGRADE',
  Upgrade = 'UPGRADE'
}

export type CatalogProductView = {
  __typename?: 'CatalogProductView';
  /** Whether this product is available for self-service purchasing. */
  available: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  product: Product;
  /**
   * Indicates if this is part of the current subscription, or represents an upgrade or downgrade over the current product.
   * Null if no user is being queried.
   */
  status?: Maybe<CatalogProductStatus>;
};

export enum CertManagerChallengeType {
  Dns01 = 'dns01',
  Http01 = 'http01'
}

export type Certificate = {
  __typename?: 'Certificate';
  challenges?: Maybe<Array<CertificateChallenge>>;
  createdAt: Scalars['Time'];
  dnsNames?: Maybe<Array<Scalars['String']>>;
  instructions?: Maybe<Array<DnsRecord>>;
  issuing: Scalars['Boolean'];
  provider?: Maybe<CertificateProivder>;
  ready: Scalars['Boolean'];
  updatedAt: Scalars['Time'];
};

export type CertificateChallenge = {
  __typename?: 'CertificateChallenge';
  dnsName: Scalars['String'];
  solver: Scalars['String'];
  statusReason: Scalars['String'];
  statusState: Scalars['String'];
  type: Scalars['String'];
  wildcard: Scalars['Boolean'];
};

export enum CertificateProivder {
  AwsAcm = 'AWS_ACM',
  CertManager = 'CERT_MANAGER'
}

export type CheckPriceInput = {
  cpu?: InputMaybe<Scalars['String']>;
  dedicated?: InputMaybe<Scalars['Boolean']>;
  dockerImage?: InputMaybe<Scalars['String']>;
  gpu?: InputMaybe<Scalars['String']>;
  installation?: InputMaybe<Scalars['ID']>;
  memory?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  ports?: InputMaybe<Scalars['JSON']>;
  replication?: InputMaybe<Array<ReplicationInput>>;
  repo?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<RepoSourceType>;
  teamId?: InputMaybe<Scalars['UUID']>;
  volumes?: InputMaybe<Scalars['JSON']>;
};

export type CheckPriceOutput = {
  __typename?: 'CheckPriceOutput';
  bandwidth: PriceComponent;
  canBeFreeTier: Scalars['Boolean'];
  cpu: PriceComponent;
  gpu: PriceComponent;
  memory: PriceComponent;
  misc: PriceComponent;
  subTotal: PriceComponent;
  total: PriceComponent;
  volumes: PriceComponent;
};

export type CheckProjectNameInput = {
  name: Scalars['String'];
};

export type CloudAccount = AwsAccount | AzureAccount | CoreWeaveAccount | DoAccount | GcpAccount | LinodeAccount | VultrAccount;

export enum CloudAccountState {
  Error = 'ERROR',
  Success = 'SUCCESS',
  Waiting = 'WAITING'
}

export type CloudConnectionInfo = {
  __typename?: 'CloudConnectionInfo';
  connected?: Maybe<Scalars['Boolean']>;
  connectionError?: Maybe<ZeetError>;
};

export enum CloudProvider {
  Alibaba = 'ALIBABA',
  Aws = 'AWS',
  Azure = 'AZURE',
  Coreweave = 'COREWEAVE',
  Do = 'DO',
  Gcp = 'GCP',
  Ibm = 'IBM',
  Linode = 'LINODE',
  Oci = 'OCI',
  Ovh = 'OVH',
  Scaleway = 'SCALEWAY',
  Tencent = 'TENCENT',
  Unknown = 'UNKNOWN',
  Vultr = 'VULTR',
  Zeet = 'ZEET'
}

export type CloudQueryService = {
  __typename?: 'CloudQueryService';
  id: Scalars['UUID'];
  state: CloudQueryState;
};

export enum CloudQueryState {
  Creating = 'CREATING',
  Deleting = 'DELETING',
  Error = 'ERROR',
  Ready = 'READY'
}

export type CloudResource = {
  __typename?: 'CloudResource';
  id: Scalars['String'];
  region: Scalars['String'];
  resourceType: CloudResourceType;
  shared: Scalars['Boolean'];
};

export enum CloudResourceType {
  Cluster = 'Cluster',
  Disk = 'Disk',
  LoadBalancer = 'LoadBalancer',
  Machine = 'Machine',
  Vpc = 'VPC'
}

export type CloudRuntime = {
  __typename?: 'CloudRuntime';
  awsFargate?: Maybe<Scalars['String']>;
  awsLambda?: Maybe<Scalars['String']>;
  azureApp?: Maybe<Scalars['String']>;
  cloud?: Maybe<CloudAccount>;
  gcpCloudRun?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
};

export type Cluster = {
  __typename?: 'Cluster';
  /** All configured cluster add-ons, whether currently enabled or disabled */
  addOns?: Maybe<Array<ClusterAddOn>>;
  awsAccount?: Maybe<AwsAccount>;
  azureAccount?: Maybe<AzureAccount>;
  cloudAccount?: Maybe<CloudAccount>;
  cloudProvider?: Maybe<CloudProvider>;
  clusterIssuers?: Maybe<Array<Scalars['String']>>;
  clusterProvider?: Maybe<ClusterProvider>;
  components?: Maybe<Array<Maybe<ClusterComponent>>>;
  connected?: Maybe<Scalars['Boolean']>;
  containerCacheRepository?: Maybe<Scalars['String']>;
  containerRegistry?: Maybe<ContainerRegistry>;
  containerRepository?: Maybe<Scalars['String']>;
  createdAt: Scalars['Time'];
  customDomains?: Maybe<Array<ClusterCustomDomain>>;
  cwAccount?: Maybe<CoreWeaveAccount>;
  deployJob?: Maybe<JobRun>;
  destroyJob?: Maybe<JobRun>;
  doAccount?: Maybe<DoAccount>;
  domain?: Maybe<Scalars['String']>;
  gcpAccount?: Maybe<GcpAccount>;
  grafana?: Maybe<Grafana>;
  id: Scalars['UUID'];
  ingressDNS?: Maybe<Scalars['String']>;
  ingressIP?: Maybe<Scalars['String']>;
  isEjected?: Maybe<Scalars['Boolean']>;
  isExternal?: Maybe<Scalars['Boolean']>;
  kubeconfig?: Maybe<Scalars['String']>;
  linodeAccount?: Maybe<LinodeAccount>;
  machines?: Maybe<Array<Machine>>;
  name: Scalars['String'];
  namespace?: Maybe<Scalars['String']>;
  network?: Maybe<Network>;
  private: Scalars['Boolean'];
  projectV3Adapters?: Maybe<ProjectV3AdapterConnection>;
  projects?: Maybe<ProjectConnection>;
  prometheus?: Maybe<Prometheus>;
  region?: Maybe<Scalars['String']>;
  serverVersion: Scalars['String'];
  state: ClusterState;
  stateBackend?: Maybe<TerraformStateBackend>;
  staticIPs?: Maybe<Array<Scalars['String']>>;
  status?: Maybe<ClusterStatus>;
  supportsEphemeralContainer: Scalars['Boolean'];
  terraformProjectUrl?: Maybe<Scalars['String']>;
  updatedAt: Scalars['Time'];
  vultrAccount?: Maybe<VultrAccount>;
};


export type ClusterProjectsArgs = {
  input?: InputMaybe<ProjectsInput>;
};

export type ClusterAddOn = {
  __typename?: 'ClusterAddOn';
  helmValues?: Maybe<Scalars['YAML']>;
  slug: Scalars['String'];
  state: ClusterAddOnState;
};

export enum ClusterAddOnState {
  Disabled = 'DISABLED',
  Enabled = 'ENABLED'
}

export type ClusterComponent = {
  __typename?: 'ClusterComponent';
  exists: Scalars['Boolean'];
  helmMetadata?: Maybe<HelmClusterComponentMetadata>;
  isInstalledByZeet: Scalars['Boolean'];
  name: Scalars['String'];
  project?: Maybe<ProjectV3Adapter>;
  status: ClusterComponentEjectedStatus;
  terraformMetadata?: Maybe<TerraformClusterComponentMetadata>;
  type: ClusterComponentType;
};

export enum ClusterComponentEjectedStatus {
  Detected = 'DETECTED',
  NotFound = 'NOT_FOUND'
}

export enum ClusterComponentType {
  Helm = 'HELM',
  Terraform = 'TERRAFORM'
}

export type ClusterCustomDomain = {
  __typename?: 'ClusterCustomDomain';
  cluster?: Maybe<Cluster>;
  customDomain?: Maybe<CustomDomain>;
  id: Scalars['UUID'];
  repo?: Maybe<Repo>;
};

export type ClusterDomains = {
  __typename?: 'ClusterDomains';
  cluster: Cluster;
  domains?: Maybe<Array<CustomDomain>>;
  id: Scalars['ID'];
};

export enum ClusterProvider {
  Coreweave = 'COREWEAVE',
  Doks = 'DOKS',
  Eks = 'EKS',
  Generic = 'GENERIC',
  Gke = 'GKE',
  Lke = 'LKE',
  Vke = 'VKE'
}

export enum ClusterState {
  Creating = 'CREATING',
  Deleting = 'DELETING',
  Error = 'ERROR',
  ErrorDeleting = 'ERROR_DELETING',
  Healthy = 'HEALTHY',
  Pending = 'PENDING',
  PendingSetup = 'PENDING_SETUP'
}

export enum ClusterStatus {
  Creating = 'CREATING',
  Deleting = 'DELETING',
  Error = 'ERROR',
  ErrorDeleting = 'ERROR_DELETING',
  Healthy = 'HEALTHY',
  Pending = 'PENDING',
  PendingSetup = 'PENDING_SETUP',
  Unreachable = 'UNREACHABLE'
}

export type ClusterValidation = {
  __typename?: 'ClusterValidation';
  errors?: Maybe<Array<ClusterValidationError>>;
};

export type ClusterValidationError = {
  __typename?: 'ClusterValidationError';
  docs: Scalars['String'];
  fixable: Scalars['Boolean'];
  message: Scalars['String'];
  type: ClusterValidationErrorType;
};

export enum ClusterValidationErrorType {
  BillingNotEnabled = 'BILLING_NOT_ENABLED',
  OutOfQuota = 'OUT_OF_QUOTA'
}

export type ClusterValidationInput = {
  awsAccountCredentialsID?: InputMaybe<Scalars['UUID']>;
  azureAccountCredentialsID?: InputMaybe<Scalars['UUID']>;
  cloudProvider: CloudProvider;
  doAccountCredentialsID?: InputMaybe<Scalars['UUID']>;
  domainName?: InputMaybe<Scalars['String']>;
  gcpAccountCredentialsID?: InputMaybe<Scalars['UUID']>;
  linodeAccountCredentialsID?: InputMaybe<Scalars['UUID']>;
  region?: InputMaybe<Scalars['String']>;
};

export type ComplexLogs = {
  __typename?: 'ComplexLogs';
  current?: Maybe<Array<LogEntry>>;
  expired: Scalars['Boolean'];
  previous?: Maybe<Array<LogEntry>>;
};

export type ConnectUserToIamInput = {
  awsAccountId?: InputMaybe<Scalars['String']>;
  awsIamArn?: InputMaybe<Scalars['String']>;
  userID: Scalars['UUID'];
};

/** A sentinel value returned when we are not able to facilitate self-service for a desired action */
export enum ContactUs {
  /** @deprecated Use BillingActionNotAllowed instead. */
  ContactUs = 'CONTACT_US'
}

export type Container = {
  __typename?: 'Container';
  id: Scalars['UUID'];
  status: ContainerStatus;
};

export type ContainerRegistry = {
  __typename?: 'ContainerRegistry';
  credentialProvider?: Maybe<ContainerRegistryCredentialProvider>;
  id: Scalars['UUID'];
  name: Scalars['String'];
  registry: Scalars['String'];
  username?: Maybe<Scalars['String']>;
};

export enum ContainerRegistryCredentialProvider {
  Docker = 'DOCKER',
  Docr = 'DOCR',
  Ecr = 'ECR',
  Gcr = 'GCR'
}

export type ContainerRegistrySource = {
  __typename?: 'ContainerRegistrySource';
  registryID?: Maybe<Scalars['UUID']>;
  registryURL?: Maybe<Scalars['URL']>;
  repository: Scalars['String'];
  tag?: Maybe<Scalars['String']>;
};

export type ContainerRegistrySourceInput = {
  registryID?: InputMaybe<Scalars['UUID']>;
  registryURL?: InputMaybe<Scalars['URL']>;
  repository: Scalars['String'];
  tag?: InputMaybe<Scalars['String']>;
};

export type ContainerResourcesSpec = {
  __typename?: 'ContainerResourcesSpec';
  accelerator?: Maybe<AcceleratorSpec>;
  cpu?: Maybe<Scalars['Float']>;
  ephemeralStorage?: Maybe<Scalars['Float']>;
  memory?: Maybe<Scalars['Float']>;
  spot?: Maybe<Scalars['Boolean']>;
};

export type ContainerResourcesSpecInput = {
  accelerator?: InputMaybe<AcceleratorSpecInput>;
  cpu: Scalars['Float'];
  ephemeralStorage?: InputMaybe<Scalars['Float']>;
  memory: Scalars['Float'];
  spot?: InputMaybe<Scalars['Boolean']>;
};

export type ContainerSpec = {
  __typename?: 'ContainerSpec';
  cpu?: Maybe<Scalars['Float']>;
  gpu?: Maybe<Scalars['Float']>;
  memory?: Maybe<Scalars['Float']>;
};

export type ContainerStatus = {
  __typename?: 'ContainerStatus';
  ready: Scalars['Boolean'];
  running: Scalars['Boolean'];
  scheduled: Scalars['Boolean'];
};

export type CoreWeaveAccount = {
  __typename?: 'CoreWeaveAccount';
  clusters?: Maybe<Array<Cluster>>;
  connected?: Maybe<Scalars['Boolean']>;
  connectedV2?: Maybe<CloudConnectionInfo>;
  createdAt: Scalars['Time'];
  id: Scalars['UUID'];
  name: Scalars['String'];
  namespace?: Maybe<Scalars['String']>;
  networks?: Maybe<Array<Network>>;
  projectV3Adapters?: Maybe<ProjectV3AdapterConnection>;
  state: CloudAccountState;
  updatedAt: Scalars['Time'];
};

export type Cost = {
  __typename?: 'Cost';
  periodEnd?: Maybe<Scalars['String']>;
  periodStart?: Maybe<Scalars['String']>;
  service?: Maybe<Scalars['String']>;
  unblendedCostAmount?: Maybe<Scalars['Float']>;
  unblendedCostUnit?: Maybe<Scalars['String']>;
};

export type CostByServiceWhere = {
  services: Array<Scalars['String']>;
};

export type CostUsageWhere = {
  dimension1In: Array<Scalars['String']>;
  dimension2NotIn: Array<Scalars['String']>;
  dimensionType1: Scalars['String'];
  dimensionType2: Scalars['String'];
  granularity: Scalars['String'];
};

export type CreateApiKeyInput = {
  name: Scalars['String'];
  userID: Scalars['UUID'];
};

export type CreateBitbucketIntegrationInput = {
  accessToken: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  userID: Scalars['UUID'];
};

export type CreateBlueprintInput = {
  configuration?: InputMaybe<BlueprintConfigurationInput>;
  description?: InputMaybe<Scalars['String']>;
  displayName: Scalars['String'];
  logoUrl?: InputMaybe<Scalars['String']>;
  published: Scalars['Boolean'];
  richInputSchema?: InputMaybe<Scalars['JSON']>;
  slug: Scalars['String'];
  tags?: InputMaybe<Array<Scalars['String']>>;
  type: BlueprintType;
  userID: Scalars['UUID'];
  variables: Array<BlueprintVariableSpecInput>;
};

export type CreateClusterInput = {
  awsAccountID?: InputMaybe<Scalars['UUID']>;
  azureAccountID?: InputMaybe<Scalars['UUID']>;
  coreweaveAccountID?: InputMaybe<Scalars['UUID']>;
  doAccountID?: InputMaybe<Scalars['UUID']>;
  domainName?: InputMaybe<Scalars['String']>;
  gcpAccountID?: InputMaybe<Scalars['UUID']>;
  gcpClusterCreationOptions?: InputMaybe<GcpClusterCreationOptions>;
  isExternal?: InputMaybe<Scalars['Boolean']>;
  linodeAccountID?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  placeholderClusterID?: InputMaybe<Scalars['UUID']>;
  region: Scalars['String'];
  userID: Scalars['UUID'];
  vultrAccountID?: InputMaybe<Scalars['UUID']>;
};

export type CreateDatabaseInput = {
  deployTarget: DatabaseDeployTargetInput;
  engine: DatabaseEngineType;
  /** - v0.EnvironmentID or v1.SubGroupID */
  environmentID?: InputMaybe<Scalars['UUID']>;
  environmentName?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  options?: InputMaybe<DatabaseOptions>;
  /** - v0.ProjectID or v1.GroupID */
  projectID?: InputMaybe<Scalars['UUID']>;
  projectName?: InputMaybe<Scalars['String']>;
  userID: Scalars['UUID'];
  version: Scalars['String'];
};

export type CreateDatadogIntegrationInput = {
  apiKey: Scalars['String'];
  userID: Scalars['UUID'];
};

export type CreateEmailIntegrationInput = {
  emailAddress: Scalars['String'];
  userID: Scalars['UUID'];
};

export type CreateEphemeralContainerInput = {
  image: Scalars['String'];
};

export type CreateEventIntegrationInput = {
  clusterID?: InputMaybe<Scalars['UUID']>;
  eventType: EventIntegrationType;
  userID: Scalars['UUID'];
};

export type CreateGitlabIntegrationInput = {
  accessToken: Scalars['String'];
  apiUrl?: InputMaybe<Scalars['URL']>;
  name?: InputMaybe<Scalars['String']>;
  userID: Scalars['UUID'];
};

export type CreateIpfsServiceInput = {
  awsAccountID: Scalars['UUID'];
  clusterID: Scalars['UUID'];
  name: Scalars['String'];
  userID: Scalars['UUID'];
};

export type CreateProjectDockerInput = {
  cpu?: InputMaybe<Scalars['String']>;
  dedicated?: InputMaybe<Scalars['Boolean']>;
  deployTarget?: InputMaybe<ProjectDeployInput>;
  dockerImage: Scalars['String'];
  enabled?: InputMaybe<Scalars['Boolean']>;
  /** - v0.EnvironmentID or v1.SubGroupID */
  environmentID?: InputMaybe<Scalars['UUID']>;
  environmentName?: InputMaybe<Scalars['String']>;
  envs?: InputMaybe<Array<EnvVarInput>>;
  ephemeralStorage?: InputMaybe<Scalars['Float']>;
  gpu?: InputMaybe<Scalars['String']>;
  memory?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  ports?: InputMaybe<Scalars['JSON']>;
  /** - v0.ProjectID or v1.GroupID */
  projectID?: InputMaybe<Scalars['UUID']>;
  projectName?: InputMaybe<Scalars['String']>;
  replication?: InputMaybe<Array<ReplicationInput>>;
  teamID?: InputMaybe<Scalars['ID']>;
  userID?: InputMaybe<Scalars['UUID']>;
  volumes?: InputMaybe<Scalars['JSON']>;
};

export type CreateProjectEnvironmentInput = {
  name: Scalars['String'];
  /** - v0.ProjectID or v1.GroupID */
  projectID: Scalars['UUID'];
  repos?: InputMaybe<Array<Scalars['UUID']>>;
};

export type CreateProjectFromProjectTemplateInput = {
  deployTarget?: InputMaybe<ProjectDeployInput>;
  envs?: InputMaybe<Array<EnvVarInput>>;
  id: Scalars['ID'];
};

export type CreateProjectGitInput = {
  autoRetry?: InputMaybe<Scalars['Boolean']>;
  autoRollback?: InputMaybe<Scalars['Boolean']>;
  autoscaling?: InputMaybe<AutoscalingInput>;
  branchIgnore?: InputMaybe<Scalars['String']>;
  branchResources?: InputMaybe<ContainerResourcesSpecInput>;
  build?: InputMaybe<ProjectBuildInput>;
  buildResources?: InputMaybe<ContainerResourcesSpecInput>;
  buildTarget?: InputMaybe<BuildTargetInput>;
  clusterIssuerName?: InputMaybe<Scalars['String']>;
  containerCacheRepository?: InputMaybe<Scalars['String']>;
  containerRegistryID?: InputMaybe<Scalars['UUID']>;
  containerRepository?: InputMaybe<Scalars['String']>;
  datadogApmEnabled?: InputMaybe<Scalars['Boolean']>;
  deployBranch?: InputMaybe<Scalars['Boolean']>;
  deployJob?: InputMaybe<Scalars['Boolean']>;
  deployService?: InputMaybe<Scalars['Boolean']>;
  deployStrategy?: InputMaybe<DeployStrategy>;
  deployTarget?: InputMaybe<ProjectDeployInput>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  /** - v0.EnvironmentID or v1.SubGroupID */
  environmentID?: InputMaybe<Scalars['UUID']>;
  environmentName?: InputMaybe<Scalars['String']>;
  envs?: InputMaybe<Array<EnvVarInput>>;
  hostNetwork?: InputMaybe<Scalars['Boolean']>;
  kanikoFlags?: InputMaybe<KanikoFlagsInput>;
  livenessProbe?: InputMaybe<ProbeInput>;
  logShipper?: InputMaybe<LogShipperInput>;
  manualDeploy?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  noBuildCache?: InputMaybe<Scalars['Boolean']>;
  nodeSelector?: InputMaybe<Scalars['JSON']>;
  path?: InputMaybe<Scalars['String']>;
  pipelineClusterID?: InputMaybe<Scalars['UUID']>;
  ports?: InputMaybe<Array<PortInput>>;
  preStopSleep?: InputMaybe<Scalars['Int']>;
  productionBranch?: InputMaybe<Scalars['String']>;
  /** - v0.ProjectID or v1.GroupID */
  projectID?: InputMaybe<Scalars['UUID']>;
  projectName?: InputMaybe<Scalars['String']>;
  prometheusScrape?: InputMaybe<PrometheusScrapeInput>;
  readinessProbe?: InputMaybe<ProbeInput>;
  replication?: InputMaybe<Array<ReplicationInput>>;
  resources?: InputMaybe<ContainerResourcesSpecInput>;
  runCommand?: InputMaybe<Scalars['String']>;
  startupProbe?: InputMaybe<ProbeInput>;
  staticIP?: InputMaybe<Scalars['Boolean']>;
  terminationGracePeriodSeconds?: InputMaybe<Scalars['Int']>;
  url: Scalars['String'];
  userID?: InputMaybe<Scalars['UUID']>;
  volumes?: InputMaybe<Array<VolumeInput>>;
};

export type CreateProjectHelmInput = {
  chart?: InputMaybe<Scalars['String']>;
  deployTarget: ProjectDeployInput;
  enabled?: InputMaybe<Scalars['Boolean']>;
  /** - v0.EnvironmentID or v1.SubGroupID */
  environmentID?: InputMaybe<Scalars['UUID']>;
  environmentName?: InputMaybe<Scalars['String']>;
  gitReference?: InputMaybe<Scalars['String']>;
  gitRepository?: InputMaybe<Scalars['String']>;
  githubConnection?: InputMaybe<GithubConnectionInput>;
  name: Scalars['String'];
  namespace?: InputMaybe<Scalars['String']>;
  /** - v0.ProjectID or v1.GroupID */
  projectID?: InputMaybe<Scalars['UUID']>;
  releaseName: Scalars['String'];
  repository?: InputMaybe<Scalars['String']>;
  userID: Scalars['UUID'];
  values?: InputMaybe<Scalars['String']>;
  valuesRef?: InputMaybe<Scalars['String']>;
  workingDirectory?: InputMaybe<Scalars['String']>;
};

export type CreateProjectTerraformInput = {
  deployTarget: ProjectDeployInput;
  enabled?: InputMaybe<Scalars['Boolean']>;
  envs?: InputMaybe<Array<EnvVarInput>>;
  gitReference?: InputMaybe<Scalars['String']>;
  gitRepository?: InputMaybe<Scalars['String']>;
  githubConnection?: InputMaybe<GithubConnectionInput>;
  manualApproval?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  terraformVersion?: InputMaybe<Scalars['String']>;
  userID: Scalars['UUID'];
  variables?: InputMaybe<Scalars['JSON']>;
  workingDirectory?: InputMaybe<Scalars['String']>;
};

export type CreateProjectV2Input = {
  name: Scalars['String'];
  userID: Scalars['UUID'];
};

export type CreateProjectV3Input = {
  awsSamConfiguration?: InputMaybe<AwsSamProjectV3ConfigurationInput>;
  blueprintConfiguration?: InputMaybe<BlueprintConfigurationInput>;
  blueprintID: Scalars['UUID'];
  /** - v0.EnvironmentID or v1.SubGroupID */
  environmentID?: InputMaybe<Scalars['UUID']>;
  environmentName?: InputMaybe<Scalars['String']>;
  gcpCloudRunConfiguration?: InputMaybe<GcpCloudRunProjectV3ConfigurationInput>;
  helmConfiguration?: InputMaybe<HelmProjectV3ConfigurationInput>;
  isDeployV2?: InputMaybe<Scalars['Boolean']>;
  manifestConfiguration?: InputMaybe<ManifestProjectV3ConfigurationInput>;
  name: Scalars['String'];
  /** - v0.ProjectID or v1.GroupID */
  projectID?: InputMaybe<Scalars['UUID']>;
  projectName?: InputMaybe<Scalars['String']>;
  requirePlanApproval?: InputMaybe<Scalars['Boolean']>;
  terraformConfiguration?: InputMaybe<TerraformProjectV3ConfigurationInput>;
  userID: Scalars['UUID'];
  variables: Array<BlueprintVariableInput>;
};

export type CreateProjectsFromTemplateInput = {
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  projects?: InputMaybe<Array<CreateProjectFromProjectTemplateInput>>;
  userID?: InputMaybe<Scalars['UUID']>;
};

export type CreateRepoPipelineLinkInput = {
  sourceEvent: RepoEvent;
  sourceRepoID: Scalars['UUID'];
  targetAction: RepoAction;
  targetEnvironmentID?: InputMaybe<Scalars['UUID']>;
  targetRepoID?: InputMaybe<Scalars['UUID']>;
};

export type CreateResourceAlphaInput = {
  appID?: InputMaybe<Scalars['String']>;
  blueprintID?: InputMaybe<Scalars['UUID']>;
  branch?: InputMaybe<ResourceBranchInput>;
  build?: InputMaybe<ResourceBuildInput>;
  database?: InputMaybe<ResourceDatabaseInput>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  /** - v0.EnvironmentID or v1.SubGroupID */
  environmentID?: InputMaybe<Scalars['UUID']>;
  environmentName?: InputMaybe<Scalars['String']>;
  kubernetes?: InputMaybe<ResourceKubernetesInput>;
  name: Scalars['String'];
  /** - v0.ProjectID or v1.GroupID */
  projectID?: InputMaybe<Scalars['UUID']>;
  projectName?: InputMaybe<Scalars['String']>;
  serverless?: InputMaybe<ResourceServerlessInput>;
  source?: InputMaybe<SourceInput>;
  terraform?: InputMaybe<ResourceTerraformInput>;
  userID: Scalars['UUID'];
  workflow?: InputMaybe<ResourceWorkflowInput>;
};

export type CreateTeamInput = {
  avatar?: InputMaybe<Scalars['String']>;
  billingEmail: Scalars['String'];
  billingPeriod?: InputMaybe<PlanBillingPeriod>;
  login?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  paymentMethod?: InputMaybe<Scalars['String']>;
  tier?: InputMaybe<PlanTier>;
};

export type CreateWeb3ChallengeInput = {
  address: Scalars['String'];
};

export type CreateWebhookIntegrationInput = {
  url: Scalars['String'];
  userID: Scalars['UUID'];
};

export type CrispAuth = {
  __typename?: 'CrispAuth';
  email: Scalars['String'];
  hmac: Scalars['String'];
  nickname: Scalars['String'];
  participants: Scalars['String'];
};

export type CustomDomain = {
  __typename?: 'CustomDomain';
  certManagerChallengeType?: Maybe<CertManagerChallengeType>;
  certificate?: Maybe<Certificate>;
  cnameTargets?: Maybe<Array<Scalars['String']>>;
  disableCertManager?: Maybe<Scalars['Boolean']>;
  domain: Scalars['String'];
  id: Scalars['ID'];
  instructions?: Maybe<Array<DnsRecord>>;
  ipTargets?: Maybe<Array<Scalars['String']>>;
  isApex: Scalars['Boolean'];
  port?: Maybe<Port>;
  syncDomain?: Maybe<CustomDomain>;
};

export type DnsRecord = {
  __typename?: 'DNSRecord';
  domain: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  type: DnsRecordType;
  value?: Maybe<Scalars['String']>;
};

export enum DnsRecordType {
  A = 'A',
  Cname = 'CNAME',
  Txt = 'TXT'
}

export type DoAccount = {
  __typename?: 'DOAccount';
  accessToken?: Maybe<Scalars['String']>;
  accessTokenPrefix?: Maybe<Scalars['String']>;
  clusters?: Maybe<Array<Cluster>>;
  connected?: Maybe<Scalars['Boolean']>;
  connectedV2?: Maybe<CloudConnectionInfo>;
  createdAt: Scalars['Time'];
  defaultProject?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  name: Scalars['String'];
  networks?: Maybe<Array<Network>>;
  projectV3Adapters?: Maybe<ProjectV3AdapterConnection>;
  projects?: Maybe<ProjectConnection>;
  state: DoAccountState;
  updatedAt: Scalars['Time'];
};


export type DoAccountProjectsArgs = {
  input?: InputMaybe<ProjectsInput>;
};

export enum DoAccountState {
  Error = 'ERROR',
  Success = 'SUCCESS',
  Waiting = 'WAITING'
}

export type DatabaseDeployTargetInput = {
  awsAccountID?: InputMaybe<Scalars['UUID']>;
  clusterID?: InputMaybe<Scalars['UUID']>;
  doAccountID?: InputMaybe<Scalars['UUID']>;
  gcpAccountID?: InputMaybe<Scalars['UUID']>;
  linodeAccountID?: InputMaybe<Scalars['UUID']>;
  provider: DatabaseProviderType;
  region?: InputMaybe<Scalars['String']>;
  vultrAccountID?: InputMaybe<Scalars['UUID']>;
};

export enum DatabaseEngineType {
  Kafka = 'KAFKA',
  Mongodb = 'MONGODB',
  Mysql = 'MYSQL',
  Nats = 'NATS',
  Postgres = 'POSTGRES',
  Redis = 'REDIS'
}

export type DatabaseLink = {
  __typename?: 'DatabaseLink';
  database: Repo;
  envPrefix?: Maybe<Scalars['String']>;
  envs?: Maybe<Array<EnvVar>>;
  id: Scalars['UUID'];
  repo: Repo;
};

export type DatabaseOptions = {
  database?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  username?: InputMaybe<Scalars['String']>;
};

export enum DatabaseProviderType {
  AwsRds = 'AWS_RDS',
  Docker = 'DOCKER',
  DoDatabase = 'DO_DATABASE',
  GcpCloudSql = 'GCP_CLOUD_SQL'
}

export type DatadogIntegration = Integration & {
  __typename?: 'DatadogIntegration';
  apiKey?: Maybe<Scalars['String']>;
  createdAt: Scalars['Time'];
  description: Scalars['String'];
  id: Scalars['UUID'];
  image: Scalars['String'];
  name: Scalars['String'];
  type: IntegrationType;
  updatedAt: Scalars['Time'];
};

export type DatadogLogIntegration = {
  __typename?: 'DatadogLogIntegration';
  host?: Maybe<Scalars['String']>;
  key: Scalars['String'];
};

export type DatadogLogIntegrationInput = {
  host?: InputMaybe<Scalars['String']>;
  key: Scalars['String'];
};

export type DeployRepoBranchInput = {
  branch: Scalars['String'];
  gitRef?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

export enum DeployRuntime {
  AwsEcs = 'AWS_ECS',
  AwsLambda = 'AWS_LAMBDA',
  GcpCloudRun = 'GCP_CLOUD_RUN',
  Knative = 'KNATIVE',
  Kubernetes = 'KUBERNETES'
}

export type DeployStatus = {
  __typename?: 'DeployStatus';
  active: Scalars['Boolean'];
  errorMessage?: Maybe<Scalars['String']>;
  publicIPs?: Maybe<Array<Scalars['String']>>;
  readyReplicas: Scalars['Int'];
  replicas: Scalars['Int'];
  runningReplicas: Scalars['Int'];
  state: Scalars['String'];
  troubleshooting?: Maybe<Troubleshooting>;
};

export enum DeployStrategy {
  BlueGreen = 'BLUE_GREEN',
  Canary = 'CANARY',
  RedBlack = 'RED_BLACK',
  Restart = 'RESTART',
  Rolling = 'ROLLING'
}

export enum DeployTarget {
  AwsCdk = 'AWS_CDK',
  AwsCloudformation = 'AWS_CLOUDFORMATION',
  AwsSam = 'AWS_SAM',
  GcpCloudRun = 'GCP_CLOUD_RUN',
  Kubernetes = 'KUBERNETES',
  Pulumi = 'PULUMI',
  Serverless = 'SERVERLESS',
  Terraform = 'TERRAFORM'
}

export type DeployTemplate = {
  __typename?: 'DeployTemplate';
  output?: Maybe<Scalars['String']>;
  type: DeployTemplateType;
};

export enum DeployTemplateType {
  Yaml = 'YAML'
}

export enum DeployType {
  Helm = 'HELM',
  Knative = 'KNATIVE',
  Kubectl = 'KUBECTL',
  Kubernetes = 'KUBERNETES',
  KubernetesUnstructured = 'KUBERNETES_UNSTRUCTURED'
}

export type DeployableDriverActionExecutionFilter = {
  actionTypes?: InputMaybe<DriverActionTypeCriterion>;
  ids?: InputMaybe<MultiEntityCriterion>;
  resourceIds?: InputMaybe<MultiEntityCriterion>;
};

export type Deployment = {
  __typename?: 'Deployment';
  alert?: Maybe<DeploymentAlert>;
  /**
   * List the history of alerts for this deployment.
   *
   * The `page` input only supports `first`, and one of `before` or `after`. Default is 10 most recent alerts.
   */
  alerts?: Maybe<DeploymentAlertConnection>;
  alternativeImages?: Maybe<Array<AlternativeImage>>;
  awsLinks?: Maybe<AwsLinks>;
  branch?: Maybe<Scalars['String']>;
  build?: Maybe<Build>;
  buildStage?: Maybe<BuildStage>;
  containers?: Maybe<Array<Container>>;
  createdAt: Scalars['Time'];
  dataOut?: Maybe<Scalars['String']>;
  deleteStage?: Maybe<PipelineStage>;
  deployStage?: Maybe<PipelineStage>;
  deployStatus?: Maybe<DeployStatus>;
  deployStep?: Maybe<PipelineStep>;
  deployTemplates?: Maybe<Array<Maybe<DeployTemplate>>>;
  /** An optional structured error, containing more information than the simple 'errorMessage' */
  deploymentError?: Maybe<DeploymentError>;
  description?: Maybe<Scalars['String']>;
  endpoints?: Maybe<Array<Scalars['String']>>;
  ephemeralContainers?: Maybe<Array<Maybe<EphemeralContainer>>>;
  errorMessage?: Maybe<Scalars['String']>;
  events: Array<Event>;
  gcpLinks?: Maybe<GcpLinks>;
  gitRef?: Maybe<Scalars['String']>;
  githubLinks?: Maybe<GithubLinks>;
  helmRelease?: Maybe<HelmRelease>;
  id: Scalars['ID'];
  loadBalancers?: Maybe<Array<LoadBalancer>>;
  logs?: Maybe<Array<LogEntry>>;
  logsV2?: Maybe<ComplexLogs>;
  metrics?: Maybe<Array<Metric>>;
  metricsV2?: Maybe<Array<MetricStream>>;
  pipelineCluster?: Maybe<Cluster>;
  privateEndpoint?: Maybe<Scalars['String']>;
  release?: Maybe<Release>;
  releaseStage?: Maybe<PipelineStage>;
  repo?: Maybe<Repo>;
  runtime?: Maybe<Runtime>;
  status: DeploymentStatus;
  terraformOperation?: Maybe<TerraformOperation>;
  testStage?: Maybe<PipelineStage>;
  updatedAt: Scalars['Time'];
  version: Scalars['String'];
  volumes?: Maybe<Array<Volume>>;
};


export type DeploymentAlertArgs = {
  id: Scalars['UUID'];
};


export type DeploymentAlertsArgs = {
  page?: InputMaybe<PageInput>;
};


export type DeploymentMetricsArgs = {
  name: Scalars['String'];
};


export type DeploymentMetricsV2Args = {
  deploymentID: Scalars['UUID'];
  metricType: MetricType;
  queryOptions?: InputMaybe<MetricQueryOptions>;
};

export type DeploymentAlert = {
  createdAt: Scalars['Time'];
  resolvedAt?: Maybe<Scalars['Time']>;
};

export type DeploymentAlertConnection = {
  __typename?: 'DeploymentAlertConnection';
  nodes: Array<DeploymentAlert>;
  pageInfo: PageInfo;
};

export type DeploymentConnection = {
  __typename?: 'DeploymentConnection';
  nodes: Array<Deployment>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type DeploymentError = {
  __typename?: 'DeploymentError';
  errorCode?: Maybe<Scalars['String']>;
  errorID?: Maybe<Scalars['String']>;
  message: Scalars['String'];
};

export type DeploymentPodCrashAlert = DeploymentAlert & {
  __typename?: 'DeploymentPodCrashAlert';
  createdAt: Scalars['Time'];
  id: Scalars['UUID'];
  namespace?: Maybe<Scalars['String']>;
  podName?: Maybe<Scalars['String']>;
  previousPodLogs?: Maybe<Logs>;
  resolvedAt?: Maybe<Scalars['Time']>;
};

export enum DeploymentStatus {
  BuildAborted = 'BUILD_ABORTED',
  BuildFailed = 'BUILD_FAILED',
  BuildInProgress = 'BUILD_IN_PROGRESS',
  BuildPending = 'BUILD_PENDING',
  BuildSucceeded = 'BUILD_SUCCEEDED',
  DeployCrashing = 'DEPLOY_CRASHING',
  DeployFailed = 'DEPLOY_FAILED',
  DeployHealhty = 'DEPLOY_HEALHTY',
  DeployInProgress = 'DEPLOY_IN_PROGRESS',
  DeployPending = 'DEPLOY_PENDING',
  DeployStopped = 'DEPLOY_STOPPED',
  DeploySucceeded = 'DEPLOY_SUCCEEDED',
  ReleaseInProgress = 'RELEASE_IN_PROGRESS'
}

export type DeploymentsInput = {
  after?: InputMaybe<Scalars['String']>;
  branch?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};

export type DetachAwsPolicyToUser = {
  awsAccountCredentialsId: Scalars['UUID'];
  awsUsername: Scalars['String'];
  policyArn: Scalars['String'];
  userID: Scalars['UUID'];
};

export enum DisableReason {
  FreeTrialEnded = 'FREE_TRIAL_ENDED',
  PaymentError = 'PAYMENT_ERROR',
  UserAction = 'USER_ACTION',
  UserBanned = 'USER_BANNED'
}

export type DiscordIntegration = Integration & {
  __typename?: 'DiscordIntegration';
  createdAt: Scalars['Time'];
  description: Scalars['String'];
  id: Scalars['UUID'];
  image: Scalars['String'];
  name: Scalars['String'];
  type: IntegrationType;
  updatedAt: Scalars['Time'];
};

export type DiscordWebhookIntegration = Integration & NotificationIntegration & {
  __typename?: 'DiscordWebhookIntegration';
  createdAt: Scalars['Time'];
  deliveryError?: Maybe<NotificationDeliveryError>;
  description: Scalars['String'];
  id: Scalars['UUID'];
  image: Scalars['String'];
  name: Scalars['String'];
  notificationSettings?: Maybe<NotificationIntegrationSettings>;
  type: IntegrationType;
  updatedAt: Scalars['Time'];
  url?: Maybe<Scalars['String']>;
};

export type DockerImage = {
  __typename?: 'DockerImage';
  digest: Scalars['String'];
  id: Scalars['ID'];
  repository: DockerRepository;
  tag: Scalars['String'];
};

export type DockerRepository = CiSource & {
  __typename?: 'DockerRepository';
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  image?: Maybe<DockerImage>;
  images?: Maybe<Array<DockerImage>>;
  isPrivate: Scalars['Boolean'];
  name: Scalars['String'];
  owner: Scalars['String'];
  ports?: Maybe<Array<Port>>;
  url: Scalars['URL'];
  volumes?: Maybe<Array<VolumeSpec>>;
};


export type DockerRepositoryImageArgs = {
  tag: Scalars['String'];
};

export type DriverActionTypeCriterion = {
  operator?: InputMaybe<FilterCriterionOperatorType>;
  value?: InputMaybe<Array<InputMaybe<BlueprintDriverAction>>>;
};

export type DuplicateBlueprintInput = {
  id: Scalars['UUID'];
  name: Scalars['String'];
  published: Scalars['Boolean'];
  slug: Scalars['String'];
  userID: Scalars['UUID'];
};

export type DuplicateProjectInput = {
  enabled: Scalars['Boolean'];
  /**
   * Put the new repo in an existing environment within the specified project
   * - v0.EnvironmentID or v1.SubGroupID
   */
  environmentID?: InputMaybe<Scalars['UUID']>;
  /** Creates a new environment by name */
  environmentName?: InputMaybe<Scalars['String']>;
  /** - v0.RepoID */
  id: Scalars['UUID'];
  name: Scalars['String'];
  /**
   * Duplicate repo to existing project
   * - v0.ProjectID or v1.GroupID
   */
  projectID?: InputMaybe<Scalars['UUID']>;
};

export type DuplicateProjectV3Input = {
  /** - v0.EnvironmentID or v1.SubGroupID */
  environmentID?: InputMaybe<Scalars['UUID']>;
  environmentName?: InputMaybe<Scalars['String']>;
  /** - v0.ProjectV3ID */
  id: Scalars['UUID'];
  name: Scalars['String'];
  /** - v0.ProjectID or v1.GroupID */
  projectID?: InputMaybe<Scalars['UUID']>;
  projectName?: InputMaybe<Scalars['String']>;
};

export type EmailIntegration = Integration & NotificationIntegration & {
  __typename?: 'EmailIntegration';
  /** An email integration must be confirmed by the recipient before it can be considered active. */
  activated?: Maybe<Scalars['Boolean']>;
  createdAt: Scalars['Time'];
  deliveryError?: Maybe<NotificationDeliveryError>;
  description: Scalars['String'];
  emailAddress: Scalars['String'];
  id: Scalars['UUID'];
  image: Scalars['String'];
  name: Scalars['String'];
  notificationSettings?: Maybe<NotificationIntegrationSettings>;
  type: IntegrationType;
  updatedAt: Scalars['Time'];
};

export type EnvVar = {
  __typename?: 'EnvVar';
  createdAt: Scalars['Time'];
  id: Scalars['ID'];
  name: Scalars['String'];
  sealed: Scalars['Boolean'];
  source?: Maybe<EnvVarSource>;
  updatedAt: Scalars['Time'];
  value: Scalars['String'];
  visible: Scalars['Boolean'];
};

export type EnvVarInput = {
  name: Scalars['String'];
  sealed?: InputMaybe<Scalars['Boolean']>;
  value: Scalars['String'];
};

export type EnvVarSource = {
  __typename?: 'EnvVarSource';
  type: EnvVarSourceType;
};

export enum EnvVarSourceType {
  Cluster = 'CLUSTER',
  Database = 'DATABASE',
  Environment = 'ENVIRONMENT',
  Project = 'PROJECT',
  ProjectLink = 'PROJECT_LINK',
  Zeet = 'ZEET'
}

export type EnvVarTemplate = {
  __typename?: 'EnvVarTemplate';
  description: Scalars['String'];
  generator?: Maybe<Scalars['String']>;
  hidden: Scalars['Boolean'];
  locked: Scalars['Boolean'];
  name: Scalars['String'];
  options?: Maybe<Array<Scalars['String']>>;
  reference?: Maybe<Scalars['String']>;
  required: Scalars['Boolean'];
  value?: Maybe<Scalars['String']>;
};

export type EnvironmentOverview = {
  __typename?: 'EnvironmentOverview';
  count?: Maybe<Scalars['Int']>;
  deploymentStatus?: Maybe<DeploymentStatus>;
};

export type EnvironmentOverviewV2 = {
  __typename?: 'EnvironmentOverviewV2';
  count: Scalars['Int'];
  deploymentStatus: ProjectV3AdapterStatus;
};

export type EphemeralContainer = {
  __typename?: 'EphemeralContainer';
  image: Scalars['String'];
  name: Scalars['String'];
  ready: Scalars['Boolean'];
};

export enum ErrorCode {
  CardDeclined = 'CardDeclined',
  InternalServerError = 'InternalServerError',
  NeedAuth = 'NeedAuth',
  NeedPaymentDetails = 'NeedPaymentDetails',
  NoActiveBuildMethodError = 'NoActiveBuildMethodError',
  NoContainers = 'NoContainers',
  NoDockerfilePresent = 'NoDockerfilePresent',
  NoPortsExposed = 'NoPortsExposed'
}

export type Event = {
  __typename?: 'Event';
  count: Scalars['Int'];
  id: Scalars['String'];
  lastSeenAt: Scalars['Time'];
  message: Scalars['String'];
  source: Scalars['String'];
  type: EventType;
};

export type EventIntegration = {
  __typename?: 'EventIntegration';
  clusterID?: Maybe<Scalars['UUID']>;
  eventType: EventIntegrationType;
  id: Scalars['UUID'];
  integrationKey: Scalars['String'];
  integrationUrl: Scalars['URL'];
};

export enum EventIntegrationType {
  Sns = 'SNS'
}

export enum EventType {
  Error = 'ERROR',
  Info = 'INFO',
  Warning = 'WARNING'
}

export type ExternalBillingProviderLinks = {
  __typename?: 'ExternalBillingProviderLinks';
  downgrade: UrlOrContactUs;
  help: UrlOrContactUs;
  invoiceHistory: UrlOrContactUs;
  managePaymentMethod: UrlOrContactUs;
};

export enum FeatureKey {
  AdvancedAutoscaling = 'ADVANCED_AUTOSCALING',
  DatadogApm = 'DATADOG_APM',
  StaticEgress = 'STATIC_EGRESS',
  SupportCenter = 'SUPPORT_CENTER'
}

export type FilterCriterion = {
  blueprintMetadataFilter?: InputMaybe<BlueprintMetadataFilter>;
  deployableDriverActionExecutionFilter?: InputMaybe<DeployableDriverActionExecutionFilter>;
  repoFilter?: InputMaybe<RepoFilter>;
  resourceAdapterFilter?: InputMaybe<ResourceAdapterFilter>;
  resourceFilter?: InputMaybe<ResourceFilter>;
  userFilter?: InputMaybe<UserFilter>;
};

export enum FilterCriterionOperatorType {
  Contains = 'CONTAINS',
  Ends = 'ENDS',
  Equals = 'EQUALS',
  Excludes = 'EXCLUDES',
  Includes = 'INCLUDES',
  NotEquals = 'NOT_EQUALS',
  Starts = 'STARTS'
}

export type FilterExpression = {
  filters?: InputMaybe<Array<FilterNode>>;
  operator?: InputMaybe<FilterExpressionOperator>;
};

export enum FilterExpressionOperator {
  And = 'AND',
  Not = 'NOT',
  Or = 'OR'
}

export type FilterInput = {
  filter: FilterNode;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<SortInput>;
};

export type FilterNode = {
  criterion?: InputMaybe<FilterCriterion>;
  expression?: InputMaybe<FilterExpression>;
};

export type GcpAccount = {
  __typename?: 'GCPAccount';
  clientEmail?: Maybe<Scalars['String']>;
  clusters?: Maybe<Array<Cluster>>;
  connected?: Maybe<Scalars['Boolean']>;
  connectedV2?: Maybe<CloudConnectionInfo>;
  createdAt: Scalars['Time'];
  credentials?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  name: Scalars['String'];
  networks?: Maybe<Array<Network>>;
  projectID?: Maybe<Scalars['String']>;
  projectV3Adapters?: Maybe<ProjectV3AdapterConnection>;
  projects?: Maybe<ProjectConnection>;
  state: GcpAccountState;
  updatedAt: Scalars['Time'];
};


export type GcpAccountProjectsArgs = {
  input?: InputMaybe<ProjectsInput>;
};

export enum GcpAccountState {
  Error = 'ERROR',
  Success = 'SUCCESS',
  Waiting = 'WAITING'
}

export type GcpLinks = {
  __typename?: 'GCPLinks';
  cloudFunctions?: Maybe<Scalars['String']>;
  cloudFunctionsTrigger?: Maybe<Scalars['String']>;
  cloudLogging?: Maybe<Scalars['String']>;
  cloudMonitoring?: Maybe<Scalars['String']>;
  cloudRun?: Maybe<Scalars['String']>;
  deploymentManager?: Maybe<Scalars['String']>;
  gke?: Maybe<Scalars['String']>;
};

export type GcsBucketBackendInput = {
  bucketName: Scalars['String'];
  gcpAccountID: Scalars['UUID'];
  location: Scalars['String'];
  prefix?: InputMaybe<Scalars['String']>;
};

export type GcsBucketConfiguration = {
  __typename?: 'GCSBucketConfiguration';
  bucketName: Scalars['String'];
  gcpAccountID: Scalars['UUID'];
  location: Scalars['String'];
  prefix?: Maybe<Scalars['String']>;
};

export type GpuInput = {
  count: Scalars['Int'];
  type?: InputMaybe<Scalars['String']>;
};

export type GpuSpec = {
  __typename?: 'GPUSpec';
  count: Scalars['Int'];
  type?: Maybe<Scalars['String']>;
};

export type GcpCloudRunGeneratorConfiguration = {
  __typename?: 'GcpCloudRunGeneratorConfiguration';
  containerCpu?: Maybe<Scalars['Float']>;
  containerMemory?: Maybe<Scalars['Float']>;
  envVars?: Maybe<Array<EnvVar>>;
  httpPort?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  runCommand?: Maybe<Scalars['String']>;
};

export type GcpCloudRunGeneratorConfigurationInput = {
  containerCpu?: InputMaybe<Scalars['Float']>;
  containerMemory?: InputMaybe<Scalars['Float']>;
  envVars?: InputMaybe<Array<InputMaybe<EnvVarInput>>>;
  httpPort?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  runCommand?: InputMaybe<Scalars['String']>;
};

export type GcpCloudRunProjectV3Configuration = {
  __typename?: 'GcpCloudRunProjectV3Configuration';
  gcpAccountId: Scalars['UUID'];
  gcpRegion?: Maybe<Scalars['String']>;
  generator?: Maybe<GcpCloudRunGeneratorConfiguration>;
};

export type GcpCloudRunProjectV3ConfigurationInput = {
  gcpAccountId: Scalars['UUID'];
  gcpRegion?: InputMaybe<Scalars['String']>;
  generator?: InputMaybe<GcpCloudRunGeneratorConfigurationInput>;
};

export type GcpClusterCreationOptions = {
  enableA100: Scalars['Boolean'];
  enableL4: Scalars['Boolean'];
};

export type GitBranch = {
  __typename?: 'GitBranch';
  commit: GitCommit;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type GitCommit = {
  __typename?: 'GitCommit';
  abbreviatedOid: Scalars['String'];
  createdAt: Scalars['Time'];
  id: Scalars['ID'];
  message: Scalars['String'];
  oid: Scalars['String'];
};

export type GitHubInstallation = {
  __typename?: 'GitHubInstallation';
  account: GitHubUser;
  appID: Scalars['Int'];
  id: Scalars['ID'];
  integrationType: GithubIntegrationType;
  repositories?: Maybe<Array<GitHubRepository>>;
  repositorySelection: Scalars['String'];
  targetType: Scalars['String'];
};

export type GitHubRepoIntegration = GitRepoIntegration & {
  __typename?: 'GitHubRepoIntegration';
  autoDeployBranch: Scalars['Boolean'];
  autoStopBranch: Scalars['Boolean'];
  autoStopPullRequest: Scalars['Boolean'];
  branchIgnore: Scalars['String'];
  branchStopIgnore: Scalars['String'];
  githubConnectionID?: Maybe<Scalars['Int']>;
  githubRepository?: Maybe<GitHubRepository>;
  id: Scalars['UUID'];
};

export type GitHubRepoIntegrationInput = {
  autoDeployBranch?: InputMaybe<Scalars['Boolean']>;
  autoStopBranch?: InputMaybe<Scalars['Boolean']>;
  autoStopPullRequest?: InputMaybe<Scalars['Boolean']>;
  branchIgnore?: InputMaybe<Scalars['String']>;
  branchStopIgnore?: InputMaybe<Scalars['String']>;
  githubConnectionID?: InputMaybe<Scalars['Int']>;
  githubName?: InputMaybe<Scalars['String']>;
  githubOwner?: InputMaybe<Scalars['String']>;
};

export type GitHubRepository = CiSource & GitRepository & {
  __typename?: 'GitHubRepository';
  branches?: Maybe<Array<GitBranch>>;
  buildMethodSuggestions?: Maybe<Array<BuildMethod>>;
  defaultBranch?: Maybe<GitBranch>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isFork: Scalars['Boolean'];
  isPrivate: Scalars['Boolean'];
  name: Scalars['String'];
  owner: Scalars['String'];
  ports?: Maybe<Array<Port>>;
  primaryLanguage?: Maybe<Scalars['String']>;
  provider: GitProvider;
  providerID: Scalars['ID'];
  serverless?: Maybe<ServerlessConfig>;
  updatedAt: Scalars['Time'];
  url: Scalars['URL'];
  volumes?: Maybe<Array<VolumeSpec>>;
};

export type GitHubUser = {
  __typename?: 'GitHubUser';
  avatar?: Maybe<Scalars['URL']>;
  id: Scalars['ID'];
  login: Scalars['String'];
  type: GithubUserType;
};

export enum GitProvider {
  Bitbucket = 'BITBUCKET',
  Github = 'GITHUB',
  Gitlab = 'GITLAB'
}

export type GitRepoIntegration = {
  autoDeployBranch: Scalars['Boolean'];
  autoStopBranch: Scalars['Boolean'];
  autoStopPullRequest: Scalars['Boolean'];
  branchIgnore: Scalars['String'];
  branchStopIgnore: Scalars['String'];
};

export type GitRepository = {
  branches?: Maybe<Array<GitBranch>>;
  defaultBranch?: Maybe<GitBranch>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isFork: Scalars['Boolean'];
  isPrivate: Scalars['Boolean'];
  name: Scalars['String'];
  owner: Scalars['String'];
  primaryLanguage?: Maybe<Scalars['String']>;
  provider: GitProvider;
  providerID: Scalars['ID'];
  updatedAt: Scalars['Time'];
  url: Scalars['URL'];
};

export type GitSource = {
  __typename?: 'GitSource';
  integration?: Maybe<GitSourceIntegration>;
  path?: Maybe<Scalars['String']>;
  ref?: Maybe<Scalars['String']>;
  repository: Scalars['String'];
};

export type GitSourceInput = {
  integration?: InputMaybe<GitSourceIntegrationInput>;
  path?: InputMaybe<Scalars['String']>;
  ref?: InputMaybe<Scalars['String']>;
  repository: Scalars['String'];
};

export type GitSourceIntegration = {
  __typename?: 'GitSourceIntegration';
  bitbucketIntegrationID?: Maybe<Scalars['UUID']>;
  githubInstallationID?: Maybe<Scalars['Int']>;
  githubIntegrationID?: Maybe<Scalars['UUID']>;
  gitlabIntegrationID?: Maybe<Scalars['UUID']>;
};

export type GitSourceIntegrationInput = {
  bitbucketIntegrationID?: InputMaybe<Scalars['UUID']>;
  githubInstallationID?: InputMaybe<Scalars['Int']>;
  githubIntegrationID?: InputMaybe<Scalars['UUID']>;
  gitlabIntegrationID?: InputMaybe<Scalars['UUID']>;
};

export enum GitSubmodulesType {
  None = 'NONE',
  Recursive = 'RECURSIVE'
}

export type GithubCommitResult = {
  __typename?: 'GithubCommitResult';
  processing: Scalars['Boolean'];
};

export type GithubConnectionInput = {
  apiUrl?: InputMaybe<Scalars['URL']>;
  installation: Scalars['String'];
  owner: Scalars['String'];
  repo: Scalars['String'];
};

export type GithubIntegration = Integration & {
  __typename?: 'GithubIntegration';
  appID: Scalars['Int'];
  createdAt: Scalars['Time'];
  description: Scalars['String'];
  id: Scalars['UUID'];
  image: Scalars['String'];
  installationID: Scalars['Int'];
  login: Scalars['String'];
  name: Scalars['String'];
  targetType: Scalars['String'];
  type: IntegrationType;
  updatedAt: Scalars['Time'];
};

export enum GithubIntegrationType {
  Team = 'Team',
  User = 'User'
}

export type GithubLinks = {
  __typename?: 'GithubLinks';
  commitURL?: Maybe<Scalars['String']>;
};

export enum GithubUserType {
  Organization = 'Organization',
  User = 'User'
}

export type GitlabConnectionInput = {
  gitlabIntegrationID: Scalars['UUID'];
  projectPath?: InputMaybe<Scalars['String']>;
};

export type GitlabIntegration = Integration & {
  __typename?: 'GitlabIntegration';
  accessTokenPrefix?: Maybe<Scalars['String']>;
  apiUrl: Scalars['URL'];
  createdAt: Scalars['Time'];
  description: Scalars['String'];
  id: Scalars['UUID'];
  image: Scalars['String'];
  name: Scalars['String'];
  type: IntegrationType;
  updatedAt: Scalars['Time'];
  webhookToken: Scalars['String'];
  webhookUrl: Scalars['URL'];
};

export type GitlabRepoIntegration = GitRepoIntegration & {
  __typename?: 'GitlabRepoIntegration';
  autoDeployBranch: Scalars['Boolean'];
  autoStopBranch: Scalars['Boolean'];
  autoStopPullRequest: Scalars['Boolean'];
  branchIgnore: Scalars['String'];
  branchStopIgnore: Scalars['String'];
  gitlabIntegration?: Maybe<GitlabIntegration>;
  gitlabRepository?: Maybe<GitlabRepository>;
  id: Scalars['UUID'];
};

export type GitlabRepoIntegrationInput = {
  autoDeployBranch?: InputMaybe<Scalars['Boolean']>;
  autoStopBranch?: InputMaybe<Scalars['Boolean']>;
  autoStopPullRequest?: InputMaybe<Scalars['Boolean']>;
  branchIgnore?: InputMaybe<Scalars['String']>;
  branchStopIgnore?: InputMaybe<Scalars['String']>;
  gitlabConnection?: InputMaybe<GitlabConnectionInput>;
};

export type GitlabRepository = CiSource & GitRepository & {
  __typename?: 'GitlabRepository';
  branches?: Maybe<Array<GitBranch>>;
  defaultBranch?: Maybe<GitBranch>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isFork: Scalars['Boolean'];
  isPrivate: Scalars['Boolean'];
  name: Scalars['String'];
  owner: Scalars['String'];
  primaryLanguage?: Maybe<Scalars['String']>;
  provider: GitProvider;
  providerID: Scalars['ID'];
  updatedAt: Scalars['Time'];
  url: Scalars['URL'];
};

export type Grafana = {
  __typename?: 'Grafana';
  password?: Maybe<Scalars['String']>;
  url: Scalars['String'];
  user?: Maybe<Scalars['String']>;
};

export type GroupedAwsCostItem = {
  __typename?: 'GroupedAwsCostItem';
  groups: Array<AwsServiceCostItem>;
  timePeriod: TimePeriod;
};

export type HttpProbe = {
  __typename?: 'HTTPProbe';
  host?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
  port: Scalars['String'];
};

export type HelmChart = {
  __typename?: 'HelmChart';
  app_version?: Maybe<Scalars['String']>;
  deprecated?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  logoImage?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  normalized_name?: Maybe<Scalars['String']>;
  repository: HelmRepository;
  stars?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['String']>;
};

export type HelmChartConnection = {
  __typename?: 'HelmChartConnection';
  nodes: Array<HelmChart>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type HelmClusterComponentMetadata = {
  __typename?: 'HelmClusterComponentMetadata';
  chartName: Scalars['String'];
  chartRepoGuess?: Maybe<Scalars['String']>;
  chartVersion: Scalars['String'];
  namespace: Scalars['String'];
  releaseName: Scalars['String'];
  values: Scalars['String'];
};

export type HelmProjectV3Configuration = {
  __typename?: 'HelmProjectV3Configuration';
  clusterID: Scalars['UUID'];
  namespace?: Maybe<Scalars['String']>;
  releaseName: Scalars['String'];
  values?: Maybe<Scalars['YAML']>;
};

export type HelmProjectV3ConfigurationInput = {
  clusterID: Scalars['UUID'];
  namespace?: InputMaybe<Scalars['String']>;
  releaseName: Scalars['String'];
  values?: InputMaybe<Scalars['YAML']>;
};

export type HelmRelease = {
  __typename?: 'HelmRelease';
  chart: HelmChart;
  id: Scalars['String'];
  version: Scalars['String'];
};

export type HelmRepository = {
  __typename?: 'HelmRepository';
  chart: HelmChart;
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  organization_name?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};


export type HelmRepositoryChartArgs = {
  name: Scalars['String'];
};

export type HelmRepositorySource = {
  __typename?: 'HelmRepositorySource';
  chart: Scalars['String'];
  repositoryURL: Scalars['URL'];
  version?: Maybe<Scalars['String']>;
};

export type HelmRepositorySourceInput = {
  chart: Scalars['String'];
  repositoryURL: Scalars['URL'];
  version?: InputMaybe<Scalars['String']>;
};

export type IpfsService = {
  __typename?: 'IPFSService';
  accessToken?: Maybe<Scalars['String']>;
  api?: Maybe<Project>;
  apiURL?: Maybe<Scalars['String']>;
  cluster?: Maybe<Cluster>;
  id: Scalars['UUID'];
  nodeURL?: Maybe<Scalars['String']>;
  owner: User;
  state: IpfsServiceState;
};

export enum IpfsServiceState {
  Creating = 'CREATING',
  Deleting = 'DELETING',
  Error = 'ERROR',
  Healthy = 'HEALTHY'
}

export type IPipelineStage = {
  id: Scalars['UUID'];
  job?: Maybe<JobRun>;
  logs?: Maybe<Logs>;
  metrics?: Maybe<Array<Metric>>;
};


export type IPipelineStageMetricsArgs = {
  name: Scalars['String'];
};

export type Integration = {
  createdAt: Scalars['Time'];
  description: Scalars['String'];
  id: Scalars['UUID'];
  image: Scalars['String'];
  name: Scalars['String'];
  type: IntegrationType;
  updatedAt: Scalars['Time'];
};

export enum IntegrationType {
  Bitbucket = 'BITBUCKET',
  Datadog = 'DATADOG',
  Discord = 'DISCORD',
  DiscordWebhook = 'DISCORD_WEBHOOK',
  Email = 'EMAIL',
  Github = 'GITHUB',
  Gitlab = 'GITLAB',
  Slack = 'SLACK',
  SlackWebhook = 'SLACK_WEBHOOK'
}

export type InviteTeamMemberInput = {
  email?: InputMaybe<Scalars['String']>;
  expiresAt?: InputMaybe<Scalars['Time']>;
  id: Scalars['UUID'];
  role: TeamMemberRole;
};

export type JobRun = {
  __typename?: 'JobRun';
  build?: Maybe<Build>;
  command: Scalars['String'];
  createdAt?: Maybe<Scalars['Time']>;
  deployment?: Maybe<Deployment>;
  errorMessage?: Maybe<Scalars['String']>;
  exitCode?: Maybe<Scalars['Int']>;
  id: Scalars['UUID'];
  logs?: Maybe<Logs>;
  metrics?: Maybe<Array<Metric>>;
  state: JobRunState;
  updatedAt?: Maybe<Scalars['Time']>;
};


export type JobRunMetricsArgs = {
  name: Scalars['String'];
};

export type JobRunConnection = {
  __typename?: 'JobRunConnection';
  nodes: Array<JobRun>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export enum JobRunState {
  JobRunFailed = 'JOB_RUN_FAILED',
  JobRunPendingApproval = 'JOB_RUN_PENDING_APPROVAL',
  JobRunPendingBuild = 'JOB_RUN_PENDING_BUILD',
  JobRunRunning = 'JOB_RUN_RUNNING',
  JobRunStarting = 'JOB_RUN_STARTING',
  JobRunSucceeded = 'JOB_RUN_SUCCEEDED'
}

export enum KAppType {
  Auto = 'AUTO',
  Deployment = 'DEPLOYMENT',
  Statefulset = 'STATEFULSET'
}

export type KanikoFlags = {
  __typename?: 'KanikoFlags';
  compressedCaching?: Maybe<Scalars['Boolean']>;
};

export type KanikoFlagsInput = {
  compressedCaching?: InputMaybe<Scalars['Boolean']>;
};

export type KubernetesCustomization = {
  __typename?: 'KubernetesCustomization';
  clusterIssuerName?: Maybe<Scalars['String']>;
  hostNetwork?: Maybe<Scalars['Boolean']>;
  ingressAnnotations?: Maybe<Scalars['MapString']>;
  ingressSpecPatch?: Maybe<Scalars['YAML']>;
  kappType?: Maybe<KAppType>;
  nodeSelector?: Maybe<Scalars['MapString']>;
  podAnnotations?: Maybe<Scalars['MapString']>;
  podSpecPatch?: Maybe<Scalars['YAML']>;
  serviceAccountName?: Maybe<Scalars['String']>;
  serviceAnnotations?: Maybe<Scalars['MapString']>;
};

export type KubernetesCustomizationInput = {
  clusterIssuerName?: InputMaybe<Scalars['String']>;
  hostNetwork?: InputMaybe<Scalars['Boolean']>;
  ingressAnnotations?: InputMaybe<Scalars['JSON']>;
  ingressSpecPatch?: InputMaybe<Scalars['YAML']>;
  kappType?: InputMaybe<KAppType>;
  nodeSelector?: InputMaybe<Scalars['JSON']>;
  podAnnotations?: InputMaybe<Scalars['JSON']>;
  podSpecPatch?: InputMaybe<Scalars['YAML']>;
  serviceAnnotations?: InputMaybe<Scalars['JSON']>;
};

export type KubernetesManifestGeneratorConfiguration = {
  __typename?: 'KubernetesManifestGeneratorConfiguration';
  buildImage?: Maybe<Scalars['String']>;
  customDomainCertificateArn?: Maybe<Scalars['String']>;
  customDomainHost?: Maybe<Scalars['String']>;
  envVars?: Maybe<Array<EnvVar>>;
  httpPort?: Maybe<Scalars['String']>;
  runCommand?: Maybe<Scalars['String']>;
  serverlessArch?: Maybe<Scalars['String']>;
  serverlessMemory?: Maybe<Scalars['Int']>;
};

export type KubernetesManifestGeneratorConfigurationInput = {
  buildImage?: InputMaybe<Scalars['String']>;
  customDomainCertificateArn?: InputMaybe<Scalars['String']>;
  customDomainHost?: InputMaybe<Scalars['String']>;
  envVars?: InputMaybe<Array<EnvVarInput>>;
  httpPort?: InputMaybe<Scalars['String']>;
  runCommand?: InputMaybe<Scalars['String']>;
  serverlessArch?: InputMaybe<Scalars['String']>;
  serverlessMemory?: InputMaybe<Scalars['Int']>;
};

export type KubernetesRuntime = {
  __typename?: 'KubernetesRuntime';
  cluster?: Maybe<Cluster>;
  region?: Maybe<Scalars['String']>;
};

export type KubernetesSecretMount = {
  __typename?: 'KubernetesSecretMount';
  mountPath: Scalars['String'];
  readOnly: Scalars['Boolean'];
  secretName: Scalars['String'];
};

export type KubernetesSecretMountInput = {
  mountPath: Scalars['String'];
  secretName: Scalars['String'];
};

export enum LabelSelectorOperator {
  DoesNotExist = 'DoesNotExist',
  Exists = 'Exists',
  In = 'In',
  NotIn = 'NotIn'
}

export type LabelSelectorRequirement = {
  __typename?: 'LabelSelectorRequirement';
  key: Scalars['String'];
  operator: LabelSelectorOperator;
  values?: Maybe<Array<Scalars['String']>>;
};

export type LabelSelectorRequirementInput = {
  key: Scalars['String'];
  operator: LabelSelectorOperator;
  values?: InputMaybe<Array<Scalars['String']>>;
};

export type LabelSelectors = {
  __typename?: 'LabelSelectors';
  matchExpressions?: Maybe<Array<LabelSelectorRequirement>>;
  matchLabels?: Maybe<Scalars['MapString']>;
};

export type LabelSelectorsInput = {
  matchExpressions?: InputMaybe<Array<LabelSelectorRequirementInput>>;
  matchLabels?: InputMaybe<Scalars['MapString']>;
};

export type LinkCloudToClusterInput = {
  cloudAZ?: InputMaybe<Scalars['String']>;
  cloudId: Scalars['UUID'];
  cloudRegion?: InputMaybe<Scalars['String']>;
  cloudType: CloudProvider;
  clusterID: Scalars['UUID'];
};

export type LinkDatabaseInput = {
  databaseID: Scalars['UUID'];
  envPrefix?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

export type LinodeAccount = {
  __typename?: 'LinodeAccount';
  accessToken?: Maybe<Scalars['String']>;
  accessTokenPrefix?: Maybe<Scalars['String']>;
  clusters?: Maybe<Array<Cluster>>;
  connected?: Maybe<Scalars['Boolean']>;
  connectedV2?: Maybe<CloudConnectionInfo>;
  createdAt: Scalars['Time'];
  id: Scalars['UUID'];
  name: Scalars['String'];
  networks?: Maybe<Array<Network>>;
  projectV3Adapters?: Maybe<ProjectV3AdapterConnection>;
  projects?: Maybe<ProjectConnection>;
  state: CloudAccountState;
  updatedAt: Scalars['Time'];
};


export type LinodeAccountProjectsArgs = {
  input?: InputMaybe<ProjectsInput>;
};

export type LinodeBucketBackendInput = {
  accessKey: Scalars['String'];
  bucketName: Scalars['String'];
  key: Scalars['String'];
  linodeAccountID: Scalars['UUID'];
  region: Scalars['String'];
  secretAccessKey: Scalars['String'];
};

export type LinodeBucketConfiguration = {
  __typename?: 'LinodeBucketConfiguration';
  accessKey: Scalars['String'];
  bucketName: Scalars['String'];
  key: Scalars['String'];
  linodeAccountId: Scalars['UUID'];
  region: Scalars['String'];
  secretAccessKey: Scalars['String'];
};

export type LoadBalancer = {
  __typename?: 'LoadBalancer';
  dns: Array<Scalars['String']>;
  ips: Array<Scalars['String']>;
  name: Scalars['String'];
  ports?: Maybe<Array<Scalars['Int']>>;
};

export type LogDnaIntegration = {
  __typename?: 'LogDNAIntegration';
  key: Scalars['String'];
};

export type LogDnaIntegrationInput = {
  key: Scalars['String'];
};

export type LogEntry = {
  __typename?: 'LogEntry';
  text: Scalars['String'];
  timestamp?: Maybe<Scalars['Time']>;
};

export type LogShipper = {
  __typename?: 'LogShipper';
  betterstack?: Maybe<BetterStackIntegration>;
  datadog?: Maybe<DatadogLogIntegration>;
  logDNA?: Maybe<LogDnaIntegration>;
  logz?: Maybe<LogzIntegration>;
  syslog?: Maybe<SyslogIntegration>;
  type: LogShipperType;
};

export type LogShipperInput = {
  betterstack?: InputMaybe<BetterStackIntegrationInput>;
  datadog?: InputMaybe<DatadogLogIntegrationInput>;
  logDNA?: InputMaybe<LogDnaIntegrationInput>;
  logz?: InputMaybe<LogzIntegrationInput>;
  syslog?: InputMaybe<SyslogIntegrationInput>;
  type?: InputMaybe<LogShipperType>;
};

export enum LogShipperType {
  Betterstack = 'BETTERSTACK',
  Datadog = 'DATADOG',
  Logdna = 'LOGDNA',
  Logzio = 'LOGZIO',
  Syslog = 'SYSLOG'
}

export type Logs = {
  __typename?: 'Logs';
  completed: Scalars['Boolean'];
  cursor?: Maybe<Scalars['String']>;
  entries?: Maybe<Array<LogEntry>>;
  expired: Scalars['Boolean'];
  id: Scalars['ID'];
};

export type LogzIntegration = {
  __typename?: 'LogzIntegration';
  token: Scalars['String'];
  url?: Maybe<Scalars['String']>;
};

export type LogzIntegrationInput = {
  token: Scalars['String'];
  url: Scalars['String'];
};

export type Machine = {
  __typename?: 'Machine';
  cluster?: Maybe<Cluster>;
  data?: Maybe<Scalars['JSON']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  network?: Maybe<Network>;
  projects?: Maybe<ProjectConnection>;
  region: Scalars['String'];
};


export type MachineProjectsArgs = {
  input?: InputMaybe<ProjectsInput>;
};

export type Manifest = {
  __typename?: 'Manifest';
  kustomizeDirs?: Maybe<Array<Scalars['String']>>;
  manifestValue?: Maybe<Scalars['String']>;
  manifests?: Maybe<Array<Scalars['String']>>;
};

export type ManifestProjectV3Configuration = {
  __typename?: 'ManifestProjectV3Configuration';
  clusterID: Scalars['UUID'];
  namespace?: Maybe<Scalars['String']>;
};

export type ManifestProjectV3ConfigurationInput = {
  clusterID: Scalars['UUID'];
  generator?: InputMaybe<KubernetesManifestGeneratorConfigurationInput>;
  namespace?: InputMaybe<Scalars['String']>;
};

export type Metric = {
  __typename?: 'Metric';
  timestamp: Scalars['Time'];
  value?: Maybe<Scalars['Float']>;
};

export type MetricAnnotation = {
  __typename?: 'MetricAnnotation';
  direction: MetricAnnotationDirection;
  function?: Maybe<MetricAnnotationFunction>;
  label?: Maybe<Scalars['String']>;
  type: MetricAnnotationType;
  value?: Maybe<Scalars['Float']>;
};

export enum MetricAnnotationDirection {
  Horizontal = 'HORIZONTAL',
  Vertical = 'VERTICAL'
}

export enum MetricAnnotationFunction {
  Average = 'AVERAGE',
  Max = 'MAX',
  Min = 'MIN'
}

export enum MetricAnnotationType {
  Line = 'LINE',
  Point = 'POINT'
}

export type MetricEntry = {
  __typename?: 'MetricEntry';
  timestamp: Scalars['Time'];
  value?: Maybe<Scalars['Float']>;
};

export enum MetricLabelType {
  Container = 'CONTAINER',
  Pod = 'POD'
}

export type MetricQueryOptions = {
  groupBy?: InputMaybe<Array<MetricLabelType>>;
  range: ObservabilityRange;
};

export type MetricStream = {
  __typename?: 'MetricStream';
  annotations?: Maybe<Array<MetricAnnotation>>;
  entries?: Maybe<Array<MetricEntry>>;
  labels?: Maybe<Array<MetricStreamLabel>>;
  query: Scalars['String'];
  type?: Maybe<MetricType>;
};

export type MetricStreamLabel = {
  __typename?: 'MetricStreamLabel';
  label: MetricLabelType;
  value: Scalars['String'];
};

export enum MetricType {
  Cpu = 'CPU',
  CpuUtilization = 'CPU_UTILIZATION',
  FunctionConcurrent = 'FUNCTION_CONCURRENT',
  FunctionDuration = 'FUNCTION_DURATION',
  FunctionError = 'FUNCTION_ERROR',
  FunctionInvocation = 'FUNCTION_INVOCATION',
  InstanceCount = 'INSTANCE_COUNT',
  Memory = 'MEMORY',
  MemoryUtilization = 'MEMORY_UTILIZATION',
  Network = 'NETWORK',
  Query = 'QUERY',
  RequestCount = 'REQUEST_COUNT',
  Storage = 'STORAGE'
}

export type MoveRepoInput = {
  /** - v0.EnvironmentID or v1.SubGroupID */
  environmentID?: InputMaybe<Scalars['UUID']>;
  environmentName?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  name?: InputMaybe<Scalars['String']>;
  /** - v0.ProjectID or v1.GroupID */
  projectID?: InputMaybe<Scalars['UUID']>;
};

export type MultiEntityCriterion = {
  value?: InputMaybe<Array<Scalars['UUID']>>;
};

export type Mutation = {
  __typename?: 'Mutation';
  abortBlueprintDriverWorkflow?: Maybe<Scalars['UUID']>;
  abortBuild: Repo;
  acceptTeamMemberInvitation: Team;
  acknowledgeNotificationDeliveryError?: Maybe<NotificationDeliveryError>;
  addAWSAccount: AwsAccount;
  addAzureAccount: AzureAccount;
  addCDN: Cdn;
  addCluster: Cluster;
  addContainerRegistry: ContainerRegistry;
  addCoreWeaveAccount: CoreWeaveAccount;
  addDOAccount: DoAccount;
  addGCPAccount: GcpAccount;
  addLinodeAccount: LinodeAccount;
  addProjectCollaborator: Repo;
  addRepoCustomDomain: Repo;
  addTeamMember: Team;
  addVultrAccount: VultrAccount;
  approveBlueprintDriverWorkflow?: Maybe<BlueprintDriverWorkflow>;
  attachAwsPolicyToUser: Scalars['Boolean'];
  buildRepo: Repo;
  cancelJob: JobRun;
  checkAwsRegionConnection: AwsRegionStatus;
  /** - projectID: v0.ProjectV3ID */
  commitProjectV3ToGithubRepo: GithubCommitResult;
  configureGitopsForProjectV3: ProjectV3;
  /**
   * Configures project permissions, for one or more projects, assigning the specified role to the specified users.
   * All projects must belong to a single team, and all the targeted users must belong to that same team.
   */
  configureProjectPermissions: Scalars['Boolean'];
  connectUserToIam: Scalars['Boolean'];
  copyEnvVars?: Maybe<Repo>;
  createAPIKey: ApiKey;
  createBitbucketIntegration: BitbucketIntegration;
  createBlueprint: Blueprint;
  createCluster: Cluster;
  createDatadogIntegration: DatadogIntegration;
  createDiscordWebhookIntegration: DiscordWebhookIntegration;
  /** Always creates a new discord webhook integration. */
  createDiscordWebhookIntegrationV2: DiscordWebhookIntegration;
  createEmailIntegration: EmailIntegration;
  createEphemeralContainer: EphemeralContainer;
  createEventIntegration: EventIntegration;
  createGitlabIntegration: GitlabIntegration;
  createIPFSService: IpfsService;
  createProjectDocker: Repo;
  createProjectEnvironment: ProjectEnvironment;
  createProjectGit: Repo;
  createProjectHelm: Repo;
  createProjectTerraform: Repo;
  createProjectV2: Project;
  createProjectV3: ProjectV3;
  createProjectsFromTemplate: Array<Repo>;
  createRepoPipelineLink: RepoPipelineLink;
  createResourceAlpha: Repo;
  createSlackWebhookIntegration: SlackWebhookIntegration;
  /** Always creates a new slack webhook integration. */
  createSlackWebhookIntegrationV2: SlackWebhookIntegration;
  createTeam: Team;
  createWeb3Challenge: Web3Challenge;
  deleteAPIKey: Scalars['Boolean'];
  deleteBlueprint: Scalars['Boolean'];
  deleteCluster: Scalars['Boolean'];
  /** - id: v0.RepoID */
  deleteProjectBranch: Scalars['Boolean'];
  deleteProjectEnvironment: Scalars['Boolean'];
  deleteProjectV2: Scalars['Boolean'];
  /** - id: v0.ProjectV3ID */
  deleteProjectV3: Scalars['Boolean'];
  deleteRepo: Scalars['Boolean'];
  deleteRepoPipelineLink?: Maybe<Scalars['Boolean']>;
  deleteTeam: Scalars['Boolean'];
  deleteTeamMemberInvitation: Scalars['Boolean'];
  deleteUser: Scalars['Boolean'];
  deployRepo: Repo;
  deployRepoBranch: Repo;
  detachAwsPolicyToUser: Scalars['Boolean'];
  disableRepo: Repo;
  disconnectUserFromIam: Scalars['Boolean'];
  dispatchRepoGroupAction?: Maybe<Scalars['Boolean']>;
  duplicateBlueprint: Blueprint;
  /** Create a copy of a repo, optionally specifying the target project and project environment */
  duplicateProject: Repo;
  duplicateProjectV3: ProjectV3;
  enableRepo: Repo;
  ensureCloudqueryEnabled: Scalars['Boolean'];
  /**
   * DEPRECATED: use 'submitBlueprintDriverWorkflow' instead"
   * @deprecated(reason: "single-action execution for blueprint drivers is replaced by driver workflows. use the 'submitBlueprintDriverWorkflow' mutation instead")
   */
  executeBlueprintDriverAction: BlueprintDriverActionResult;
  freezeRepo: Template;
  generateDownloadableLogLink: Scalars['String'];
  invalidateCDNCache: Cdn;
  inviteTeamMember: TeamMemberInvitation;
  linkCloudToCluster: Cluster;
  linkDatabase: Repo;
  maybeCreateBlueprintFromMetadata: Blueprint;
  /** - id: v0.RepoID */
  migrateGithubConnection: Repo;
  /** Converts an existing Zeet Repo into a Blueprint-based project. Only supports some repo types. */
  migrateRepoToProjectV3: ProjectV3;
  moveRepoToProjectEnvironment: Repo;
  /** Modify the user's subscription using the subscriptionCart, and initiate recurring billing for the user's payment method on file. */
  purchaseSubscription: SubscriptionPurchaseResponse;
  reissueCustomDomainCertificate: Repo;
  removeAWSAccount: Scalars['Boolean'];
  removeAzureAccount: Scalars['Boolean'];
  removeCDN: Scalars['Boolean'];
  removeContainerRegistry: Scalars['Boolean'];
  removeCoreWeaveAccount: Scalars['Boolean'];
  removeDOAccount: Scalars['Boolean'];
  removeGCPAccount: Scalars['Boolean'];
  removeLinodeAccount: Scalars['Boolean'];
  /** - id: v0.RepoID */
  removeLogShipper: Scalars['Boolean'];
  removeProbe: Repo;
  removeProjectCollaborator: Repo;
  removeRepoCustomDomain: Repo;
  removeTeamMember: Team;
  removeUserIntegration: Scalars['Boolean'];
  removeVultrAccount: Scalars['Boolean'];
  resendTeamMemberInvitation: Scalars['Boolean'];
  /** - projectID: v0.RepoID */
  rollbackProjectToDeployment: Repo;
  runJob: JobRun;
  setPaymentMethod: User;
  setRepoEnvs: Repo;
  signInWithWeb3: UserAuth;
  /**
   * CAUTION: Experimental!
   *
   * Submits a driver workflow to the workflow queue.
   * Driver workflows are immutable: steps cannot be added after a workflow has been submitted.
   * - projectID: v0.ProjectV3ID
   * @deprecated use the new 'submitWorkflow' from v1 api
   */
  submitBlueprintDriverWorkflow?: Maybe<BlueprintDriverWorkflow>;
  transferProject: Repo;
  unlinkCluster: Scalars['Boolean'];
  unlinkDatabase?: Maybe<Scalars['Boolean']>;
  unlinkRepo: Scalars['Boolean'];
  updateAWSAccount: Scalars['Boolean'];
  updateAzureAccount: Scalars['Boolean'];
  updateBitbucketIntegration: BitbucketIntegration;
  updateBlueprint: Blueprint;
  updateBranch: RepoBranchV2;
  updateCDN: Cdn;
  updateCluster: Cluster;
  updateClusterDomain: Cluster;
  updateCoreWeaveAccount: Scalars['Boolean'];
  updateDOAccount: Scalars['Boolean'];
  updateDatabaseLink: Repo;
  updateDiscordWebhookIntegration: DiscordWebhookIntegration;
  updateGCPAccount: Scalars['Boolean'];
  updateGitlabIntegration: GitlabIntegration;
  updateLinodeAccount: Scalars['Boolean'];
  updateMarketplaceBlueprint: Blueprint;
  /**
   * Updates notification settings, in two ways:
   * 1. when integrationID is NOT specified: configures global settings for the user
   * OR
   * 2. when integrationID IS specified: configures per-integration settings
   */
  updateNotificationIntegrationSettings?: Maybe<NotificationIntegrationSettings>;
  updateProject: Repo;
  updateProjectDanger: Repo;
  updateProjectEnvironment: ProjectEnvironment;
  updateProjectV2: Project;
  /** - projectID: v0.ProjectV3ID */
  updateProjectV3: ProjectV3;
  updateRepoCustomDomain: Repo;
  updateRepoPipelineLink: RepoPipelineLink;
  updateResourceAlpha: Repo;
  updateSlackWebhookIntegration: SlackWebhookIntegration;
  updateTeam: Team;
  updateTeamMemberRole: UserTeamEdge;
  updateUser: User;
  updateVultrAccount: Scalars['Boolean'];
  uploadDockerCompose: Template;
  verifyAWSAccount: AwsAccount;
};


export type MutationAbortBlueprintDriverWorkflowArgs = {
  workflowID: Scalars['UUID'];
};


export type MutationAbortBuildArgs = {
  id: Scalars['UUID'];
};


export type MutationAcceptTeamMemberInvitationArgs = {
  token: Scalars['String'];
};


export type MutationAcknowledgeNotificationDeliveryErrorArgs = {
  integrationID: Scalars['UUID'];
  userID: Scalars['UUID'];
};


export type MutationAddAwsAccountArgs = {
  input: AddAwsAccountInput;
};


export type MutationAddAzureAccountArgs = {
  input: AddAzureAccountInput;
};


export type MutationAddCdnArgs = {
  input: AddCdnInput;
};


export type MutationAddClusterArgs = {
  input: AddClusterInput;
};


export type MutationAddContainerRegistryArgs = {
  input: AddContainerRegistryInput;
};


export type MutationAddCoreWeaveAccountArgs = {
  input: AddCoreWeaveAccountInput;
};


export type MutationAddDoAccountArgs = {
  input: AddDoAccountInput;
};


export type MutationAddGcpAccountArgs = {
  input: AddGcpAccountInput;
};


export type MutationAddLinodeAccountArgs = {
  input: AddLinodeAccountInput;
};


export type MutationAddProjectCollaboratorArgs = {
  input: AddProjectCollaboratorInput;
};


export type MutationAddRepoCustomDomainArgs = {
  input: AddRepoCustomDomainInput;
};


export type MutationAddTeamMemberArgs = {
  input: AddTeamMemberInput;
};


export type MutationAddVultrAccountArgs = {
  input: AddVultrAccountInput;
};


export type MutationApproveBlueprintDriverWorkflowArgs = {
  workflowID: Scalars['UUID'];
};


export type MutationAttachAwsPolicyToUserArgs = {
  input: AttachAwsPolicyToUser;
};


export type MutationBuildRepoArgs = {
  branch?: InputMaybe<Scalars['String']>;
  gitRef?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  noCache?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCancelJobArgs = {
  input: CancelJobInput;
};


export type MutationCheckAwsRegionConnectionArgs = {
  awsAccountID: Scalars['UUID'];
  region: Scalars['String'];
};


export type MutationCommitProjectV3ToGithubRepoArgs = {
  projectID: Scalars['UUID'];
};


export type MutationConfigureGitopsForProjectV3Args = {
  input: ProjectV3GitopsInput;
};


export type MutationConfigureProjectPermissionsArgs = {
  permissions: ProjectPermissionsInput;
  projectIds: Array<Scalars['UUID']>;
};


export type MutationConnectUserToIamArgs = {
  input: ConnectUserToIamInput;
};


export type MutationCopyEnvVarsArgs = {
  from: Scalars['ID'];
  to: Scalars['ID'];
};


export type MutationCreateApiKeyArgs = {
  input?: InputMaybe<CreateApiKeyInput>;
};


export type MutationCreateBitbucketIntegrationArgs = {
  input: CreateBitbucketIntegrationInput;
};


export type MutationCreateBlueprintArgs = {
  input: CreateBlueprintInput;
};


export type MutationCreateClusterArgs = {
  input: CreateClusterInput;
};


export type MutationCreateDatadogIntegrationArgs = {
  input: CreateDatadogIntegrationInput;
};


export type MutationCreateDiscordWebhookIntegrationArgs = {
  input: CreateWebhookIntegrationInput;
};


export type MutationCreateDiscordWebhookIntegrationV2Args = {
  input: CreateWebhookIntegrationInput;
};


export type MutationCreateEmailIntegrationArgs = {
  input: CreateEmailIntegrationInput;
};


export type MutationCreateEphemeralContainerArgs = {
  deploymentId: Scalars['UUID'];
  input: CreateEphemeralContainerInput;
};


export type MutationCreateEventIntegrationArgs = {
  input: CreateEventIntegrationInput;
};


export type MutationCreateGitlabIntegrationArgs = {
  input: CreateGitlabIntegrationInput;
};


export type MutationCreateIpfsServiceArgs = {
  input: CreateIpfsServiceInput;
};


export type MutationCreateProjectDockerArgs = {
  input?: InputMaybe<CreateProjectDockerInput>;
};


export type MutationCreateProjectEnvironmentArgs = {
  input: CreateProjectEnvironmentInput;
};


export type MutationCreateProjectGitArgs = {
  input?: InputMaybe<CreateProjectGitInput>;
};


export type MutationCreateProjectHelmArgs = {
  input?: InputMaybe<CreateProjectHelmInput>;
};


export type MutationCreateProjectTerraformArgs = {
  input?: InputMaybe<CreateProjectTerraformInput>;
};


export type MutationCreateProjectV2Args = {
  input: CreateProjectV2Input;
};


export type MutationCreateProjectV3Args = {
  input: CreateProjectV3Input;
};


export type MutationCreateProjectsFromTemplateArgs = {
  input: CreateProjectsFromTemplateInput;
};


export type MutationCreateRepoPipelineLinkArgs = {
  input: CreateRepoPipelineLinkInput;
};


export type MutationCreateResourceAlphaArgs = {
  input: CreateResourceAlphaInput;
};


export type MutationCreateSlackWebhookIntegrationArgs = {
  input: CreateWebhookIntegrationInput;
};


export type MutationCreateSlackWebhookIntegrationV2Args = {
  input: CreateWebhookIntegrationInput;
};


export type MutationCreateTeamArgs = {
  input: CreateTeamInput;
};


export type MutationCreateWeb3ChallengeArgs = {
  input: CreateWeb3ChallengeInput;
};


export type MutationDeleteApiKeyArgs = {
  id: Scalars['UUID'];
};


export type MutationDeleteBlueprintArgs = {
  id: Scalars['UUID'];
};


export type MutationDeleteClusterArgs = {
  id: Scalars['UUID'];
};


export type MutationDeleteProjectBranchArgs = {
  branch: Scalars['String'];
  id: Scalars['UUID'];
};


export type MutationDeleteProjectEnvironmentArgs = {
  id: Scalars['UUID'];
};


export type MutationDeleteProjectV2Args = {
  id: Scalars['UUID'];
};


export type MutationDeleteProjectV3Args = {
  id: Scalars['UUID'];
};


export type MutationDeleteRepoArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteRepoPipelineLinkArgs = {
  id: Scalars['UUID'];
};


export type MutationDeleteTeamArgs = {
  id: Scalars['UUID'];
};


export type MutationDeleteTeamMemberInvitationArgs = {
  id: Scalars['UUID'];
};


export type MutationDeployRepoArgs = {
  id: Scalars['ID'];
};


export type MutationDeployRepoBranchArgs = {
  input: DeployRepoBranchInput;
};


export type MutationDetachAwsPolicyToUserArgs = {
  input: DetachAwsPolicyToUser;
};


export type MutationDisableRepoArgs = {
  id: Scalars['ID'];
};


export type MutationDisconnectUserFromIamArgs = {
  id: Scalars['UUID'];
};


export type MutationDispatchRepoGroupActionArgs = {
  input: DispatchRepoGroupActionInput;
};


export type MutationDuplicateBlueprintArgs = {
  input: DuplicateBlueprintInput;
};


export type MutationDuplicateProjectArgs = {
  input: DuplicateProjectInput;
};


export type MutationDuplicateProjectV3Args = {
  input: DuplicateProjectV3Input;
};


export type MutationEnableRepoArgs = {
  id: Scalars['ID'];
};


export type MutationEnsureCloudqueryEnabledArgs = {
  awsAccountId: Scalars['UUID'];
};


export type MutationExecuteBlueprintDriverActionArgs = {
  input: BlueprintDriverActionInput;
};


export type MutationFreezeRepoArgs = {
  id: Scalars['UUID'];
};


export type MutationGenerateDownloadableLogLinkArgs = {
  deploymentID: Scalars['UUID'];
};


export type MutationInvalidateCdnCacheArgs = {
  id: Scalars['UUID'];
};


export type MutationInviteTeamMemberArgs = {
  input: InviteTeamMemberInput;
};


export type MutationLinkCloudToClusterArgs = {
  input: LinkCloudToClusterInput;
};


export type MutationLinkDatabaseArgs = {
  input: LinkDatabaseInput;
};


export type MutationMaybeCreateBlueprintFromMetadataArgs = {
  slug: Scalars['String'];
  version: Scalars['String'];
};


export type MutationMigrateGithubConnectionArgs = {
  id: Scalars['UUID'];
  installationID: Scalars['String'];
};


export type MutationMigrateRepoToProjectV3Args = {
  repoID: Scalars['UUID'];
};


export type MutationMoveRepoToProjectEnvironmentArgs = {
  input: MoveRepoInput;
};


export type MutationPurchaseSubscriptionArgs = {
  forUserID: Scalars['UUID'];
  subscriptionCart: SubscriptionCart;
};


export type MutationReissueCustomDomainCertificateArgs = {
  input: ReissueCustomDomainCertificateInput;
};


export type MutationRemoveAwsAccountArgs = {
  id: Scalars['UUID'];
};


export type MutationRemoveAzureAccountArgs = {
  id: Scalars['UUID'];
};


export type MutationRemoveCdnArgs = {
  id: Scalars['UUID'];
};


export type MutationRemoveContainerRegistryArgs = {
  id: Scalars['UUID'];
};


export type MutationRemoveCoreWeaveAccountArgs = {
  id: Scalars['UUID'];
};


export type MutationRemoveDoAccountArgs = {
  id: Scalars['UUID'];
};


export type MutationRemoveGcpAccountArgs = {
  id: Scalars['UUID'];
};


export type MutationRemoveLinodeAccountArgs = {
  id: Scalars['UUID'];
};


export type MutationRemoveLogShipperArgs = {
  id: Scalars['UUID'];
};


export type MutationRemoveProbeArgs = {
  input: RemoveProbeInput;
};


export type MutationRemoveProjectCollaboratorArgs = {
  id: Scalars['ID'];
};


export type MutationRemoveRepoCustomDomainArgs = {
  input: RemoveRepoCustomDomainInput;
};


export type MutationRemoveTeamMemberArgs = {
  input: RemoveTeamMemberInput;
};


export type MutationRemoveUserIntegrationArgs = {
  input: RemoveUserIntegrationInput;
};


export type MutationRemoveVultrAccountArgs = {
  id: Scalars['UUID'];
};


export type MutationResendTeamMemberInvitationArgs = {
  id: Scalars['UUID'];
};


export type MutationRollbackProjectToDeploymentArgs = {
  deploymentID: Scalars['UUID'];
  projectID: Scalars['UUID'];
};


export type MutationRunJobArgs = {
  input: RunJobInput;
};


export type MutationSetPaymentMethodArgs = {
  paymentMethod: Scalars['String'];
};


export type MutationSetRepoEnvsArgs = {
  input: SetRepoEnvsInput;
};


export type MutationSignInWithWeb3Args = {
  input: SignInWithWeb3Input;
};


export type MutationSubmitBlueprintDriverWorkflowArgs = {
  input: BlueprintDriverWorkflowInput;
  projectID: Scalars['UUID'];
};


export type MutationTransferProjectArgs = {
  input: TransferProjectInput;
};


export type MutationUnlinkClusterArgs = {
  id: Scalars['UUID'];
};


export type MutationUnlinkDatabaseArgs = {
  id: Scalars['UUID'];
};


export type MutationUnlinkRepoArgs = {
  id: Scalars['ID'];
};


export type MutationUpdateAwsAccountArgs = {
  input: UpdateAwsAccountInput;
};


export type MutationUpdateAzureAccountArgs = {
  input: UpdateAzureAccountInput;
};


export type MutationUpdateBitbucketIntegrationArgs = {
  input: UpdateBitbucketIntegrationInput;
};


export type MutationUpdateBlueprintArgs = {
  blueprintID: Scalars['UUID'];
  input: UpdateBlueprintInput;
};


export type MutationUpdateBranchArgs = {
  input: UpdateBranchInput;
};


export type MutationUpdateCdnArgs = {
  input: UpdateCdnInput;
};


export type MutationUpdateClusterArgs = {
  input: UpdateClusterInput;
};


export type MutationUpdateClusterDomainArgs = {
  input: UpdateClusterDomainInput;
};


export type MutationUpdateCoreWeaveAccountArgs = {
  input: UpdateCoreWeaveAccountInput;
};


export type MutationUpdateDoAccountArgs = {
  input: UpdateDoAccountInput;
};


export type MutationUpdateDatabaseLinkArgs = {
  input: UpdateDatabaseLinkInput;
};


export type MutationUpdateDiscordWebhookIntegrationArgs = {
  input: UpdateWebhookIntegrationInput;
};


export type MutationUpdateGcpAccountArgs = {
  input: UpdateGcpAccountInput;
};


export type MutationUpdateGitlabIntegrationArgs = {
  input: UpdateGitlabIntegrationInput;
};


export type MutationUpdateLinodeAccountArgs = {
  input: UpdateLinodeAccountInput;
};


export type MutationUpdateMarketplaceBlueprintArgs = {
  input: UpdateMarketplaceBlueprintInput;
};


export type MutationUpdateNotificationIntegrationSettingsArgs = {
  input: NotificationIntegrationSettingsInput;
  integrationID?: InputMaybe<Scalars['UUID']>;
  userID: Scalars['UUID'];
};


export type MutationUpdateProjectArgs = {
  input: UpdateProjectInput;
};


export type MutationUpdateProjectDangerArgs = {
  input: UpdateProjectDangerInput;
};


export type MutationUpdateProjectEnvironmentArgs = {
  input: UpdateProjectEnvironmentInput;
};


export type MutationUpdateProjectV2Args = {
  input: UpdateProjectV2Input;
};


export type MutationUpdateProjectV3Args = {
  input: UpdateProjectV3Input;
  projectID: Scalars['UUID'];
};


export type MutationUpdateRepoCustomDomainArgs = {
  input: UpdateRepoCustomDomainInput;
};


export type MutationUpdateRepoPipelineLinkArgs = {
  input: UpdateRepoPipelineLinkInput;
};


export type MutationUpdateResourceAlphaArgs = {
  input: UpdateResourceAlphaInput;
  repoID: Scalars['UUID'];
};


export type MutationUpdateSlackWebhookIntegrationArgs = {
  input: UpdateWebhookIntegrationInput;
};


export type MutationUpdateTeamArgs = {
  input: UpdateTeamInput;
};


export type MutationUpdateTeamMemberRoleArgs = {
  input: UpdateTeamMemberRoleInput;
};


export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};


export type MutationUpdateVultrAccountArgs = {
  input: UpdateVultrAccountInput;
};


export type MutationUploadDockerComposeArgs = {
  contents: Scalars['String'];
};


export type MutationVerifyAwsAccountArgs = {
  id: Scalars['UUID'];
};

export type Network = {
  __typename?: 'Network';
  cloud?: Maybe<CloudAccount>;
  clusters?: Maybe<Array<Cluster>>;
  data?: Maybe<Scalars['JSON']>;
  id: Scalars['ID'];
  machines?: Maybe<Array<Maybe<Machine>>>;
  name: Scalars['String'];
  region: Scalars['String'];
};

/**
 * A notification condition represents a test of some attribute against a target value. A NotificationCondition is evaluated
 * to a true/false value, and can be combined via  NotificationConditionGroup.
 *
 * For example: {operator: EQUALS, key: PROJECT_ID, value: "abc-123"} will test a given notification for `event.project_id == "abc-123"`
 */
export type NotificationCondition = {
  __typename?: 'NotificationCondition';
  /** The key to test using the operator and value */
  key?: Maybe<NotificationConditionKey>;
  /** The method by which the key is tested relative to the target value */
  operator?: Maybe<NotificationConditionOperator>;
  /**
   * The required value to satisfy the operator against the specific key.
   * The type of this will depend on the key and the operator, for example: {operator: EQUALS, key: PROJECT_ID}
   * will expect a string value.
   *
   * For example, if the IN operator is used with the PROJECT_ID key, the value will be a a json array: ["abc-123", "def-456"]
   */
  value?: Maybe<Scalars['JSON']>;
};

/** Represents the logical combination of one or more conditions */
export type NotificationConditionGroup = {
  __typename?: 'NotificationConditionGroup';
  /**
   * The child conditions and/or condition groups to be evaluated using the specified operator.
   * WARNING: Only 1 NotificationCondition is currently supported
   */
  conditions: Array<NotificationConditionProvider>;
  /** The operator used to combine the conditions */
  operator?: Maybe<NotificationConditionGroupOperator>;
};

export type NotificationConditionGroupInput = {
  conditions: Array<NotificationConditionInput>;
  operator: NotificationConditionGroupOperator;
};

export enum NotificationConditionGroupOperator {
  /** The condition group is satisfied when ALL child conditions are satisfied */
  All = 'ALL',
  /**
   * The condition group is satisfied when ANY of the child conditions are satisfied.
   * WARNING: Not yet supported
   */
  Any = 'ANY'
}

export type NotificationConditionInput = {
  key: NotificationConditionKey;
  operator: NotificationConditionOperator;
  value: Scalars['JSON'];
};

/** The set of available condition keys */
export enum NotificationConditionKey {
  /** This is the id of the project environment (called a 'SubGroup' in v1) which the notification originated from. */
  ProjectEnvironmentId = 'PROJECT_ENVIRONMENT_ID',
  /** This is the id of the project (called a 'Group' in v1 API) which the notification originated from. */
  ProjectId = 'PROJECT_ID',
  /** This is the id of the ProjectV3Adapter ('Project' in v1 API) which the notification originated from. */
  ProjectV3AdapterId = 'PROJECT_V3_ADAPTER_ID'
}

export enum NotificationConditionOperator {
  /** The equality (==) operator, i.e. <key> == <value> */
  Equals = 'EQUALS'
}

/**
 * Conditions can be provided as either a singular condition or a group of combined conditions.
 * When a notification is triggered by Zeet, a NotificationConditionProvider, if configured, will be evaluated against the notification's attributes.
 * If the NotificationConditionProvider is satisfied (i.e. evaluates to 'true'), then the notification will be forwarded to the target integration.
 */
export type NotificationConditionProvider = NotificationCondition | NotificationConditionGroup;

/**
 * The definition for notification conditions or notification.
 *
 * An instance of this input type can represent one of the following:
 * - a single condition group: the 'groups' list is not empty, and the operator is not present
 * - a combination of condition groups: the 'groups' list contains multiple members, and the operator is present
 * - a single condition: the 'condition' field is present
 * - clearing any configured conditions: the noConditions field is present and set to true
 */
export type NotificationConditionProviderInput = {
  condition?: InputMaybe<NotificationConditionInput>;
  groups?: InputMaybe<Array<NotificationConditionGroupInput>>;
  noConditions?: InputMaybe<Scalars['Boolean']>;
  operator?: InputMaybe<NotificationConditionGroupOperator>;
};

export type NotificationDeliveryError = {
  __typename?: 'NotificationDeliveryError';
  /** A user may "acknowledge" this delivery error, which will set this timestamp. */
  acknowledgedAt?: Maybe<Scalars['Time']>;
  errorCode?: Maybe<Scalars['String']>;
  errorID?: Maybe<Scalars['String']>;
  message: Scalars['String'];
};

/** A destination for Zeet notifications. */
export type NotificationIntegration = {
  /** The latest error that prevented delivery of a notification via this integration. */
  deliveryError?: Maybe<NotificationDeliveryError>;
  /**
   * A notification integration can independently configure notification settings. When null, this integration will use the user's notificationIntegrationSettings.
   *
   * NOTE: These settings are NOT individually "merged" with the user's notificationIntegrationSettings, either the integration's settings are used, or the user's settings are used as a fallback.
   */
  notificationSettings?: Maybe<NotificationIntegrationSettings>;
};

export type NotificationIntegrationSettings = {
  __typename?: 'NotificationIntegrationSettings';
  /** Enable/Disable build notifications */
  build?: Maybe<Scalars['Boolean']>;
  /**
   * The condition that must be satisfied for a notification to be forwarded to this integration.
   * A null value indicates all configured notifications will be forwarded.
   *
   * Conditions apply to _all_ configured notification types. To apply different conditions independently to each notification type,
   * create a separate notification integration for each notification type, and apply the desired conditions to each.
   *
   * NOTE: Conditions cannot be configured "globally" for a user.
   */
  conditions?: Maybe<NotificationConditionProvider>;
  /** Enable/Disable deploy notifications */
  deploy?: Maybe<Scalars['Boolean']>;
  /** Enable/Disable kubernetes pod crash notifications */
  podCrash?: Maybe<Scalars['Boolean']>;
};

export type NotificationIntegrationSettingsInput = {
  /**
   * Enable/Disable build notifications, null causes no change to current setting
   *
   * NOTE: not applicable to "global" settings, only applicable to integration-specific settings
   */
  build?: InputMaybe<Scalars['Boolean']>;
  /** NOTE: Conditions cannot be configured "globally" for a user. Conditions may only be configured for a specific integration. */
  conditions?: InputMaybe<NotificationConditionProviderInput>;
  /**
   * Enable/Disable deploy notifications, null causes no change to current setting
   *
   * NOTE: not applicable to "global" settings, only applicable to integration-specific settings
   */
  deploy?: InputMaybe<Scalars['Boolean']>;
  /** Enable/Disable kubernetes pod crash notifications, null causes no change to current setting */
  podCrash?: InputMaybe<Scalars['Boolean']>;
};

export type ObservabilityRange = {
  end?: InputMaybe<Scalars['Time']>;
  start: Scalars['Time'];
  step?: InputMaybe<Scalars['Duration']>;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor: Scalars['String'];
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor: Scalars['String'];
};

export type PageInput = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
};

export type PipelineStage = IPipelineStage & {
  __typename?: 'PipelineStage';
  id: Scalars['UUID'];
  job?: Maybe<JobRun>;
  logs?: Maybe<Logs>;
  metrics?: Maybe<Array<Metric>>;
};


export type PipelineStageMetricsArgs = {
  name: Scalars['String'];
};

export type PipelineStep = {
  __typename?: 'PipelineStep';
  id: Scalars['UUID'];
  logs?: Maybe<Logs>;
};

export type Plan = {
  __typename?: 'Plan';
  billingPeriod?: Maybe<PlanBillingPeriod>;
  stripeSubscription?: Maybe<StripeSubscription>;
  tier: PlanTier;
};

export enum PlanBillingPeriod {
  Annually = 'ANNUALLY',
  Monthly = 'MONTHLY'
}

export enum PlanTier {
  Basic = 'BASIC',
  /** @deprecated LEGACY plan tier is no longer supported */
  Legacy = 'LEGACY',
  Pro = 'PRO'
}

export type PlanTierV2 = Product & {
  __typename?: 'PlanTierV2';
  benefits: Array<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  displayPrice?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  productTypeMetadata?: Maybe<ProductTypeMetadata>;
  sku: Scalars['ID'];
  usage: Array<Usage>;
};

export type Port = {
  __typename?: 'Port';
  externalPort: Scalars['String'];
  grpc: Scalars['Boolean'];
  https: Scalars['Boolean'];
  loadBalancer: Scalars['Boolean'];
  port: Scalars['String'];
  protocol: Scalars['String'];
  public: Scalars['Boolean'];
};

/**
 * Represents the configuration parameters for a service port.
 * Allows specifying external port exposure, protocol handling, and LoadBalancer provisioning.
 */
export type PortInput = {
  /**
   * Optional. The external port number or range exposed outside the Kubernetes cluster.
   * Useful for configuring load balancers or ingress controllers for external exposure on a different port.
   * If a port range is provided for 'port', this field must be either empty or the same as the 'port' value.
   * If a single port is specified for 'port', this field can be used to expose the service on a different external port.
   */
  externalPort?: InputMaybe<Scalars['String']>;
  /**
   * Optional. Indicates support for the gRPC protocol over HTTPS.
   * Only relevant when 'https' is 'true'.
   * If 'true', the load balancer's traffic handling is adjusted to accommodate gRPC traffic.
   */
  grpc?: InputMaybe<Scalars['Boolean']>;
  /**
   * Specifies whether HTTPS should be used for secure communication.
   * When 'true' and 'public' is also 'true', secure external access is enabled via an Ingress.
   * Setting 'https' to 'true' is not allowed when 'public' is 'false', as it contradicts the internal-only port configuration.
   */
  https: Scalars['Boolean'];
  /**
   * Optional. Specifies whether Zeet should provision the Kubernetes service in LoadBalancer mode.
   * When 'true', the service is accessible through a cloud LoadBalancer with its own IP and port, enabling direct external access.
   * This option is useful for services that require external access without an ingress controller.
   */
  loadBalancer?: InputMaybe<Scalars['Boolean']>;
  /**
   * The internal port number or range that the service runs on within the cluster.
   * Specified as a string in the format "start-end" for port ranges (e.g., "3000-3005").
   * If a range is provided, it will be applied to both internal and external ports.
   * In this case, 'externalPort' must not be specified.
   */
  port: Scalars['String'];
  /**
   * The protocol used for data transmission through this port.
   * Supported protocols are defined in the PortProtocol enum (e.g., TCP, UDP).
   */
  protocol: PortProtocol;
  /**
   * Determines the exposure of the port.
   * - When 'true' and 'https' is also 'true', an Ingress is created for secure external access.
   * - When 'true' and 'https' is 'false', the port is exposed using "HostPort" on the container for unsecured external access.
   * - When 'false', the port is only accessible thru a Service within the cluster.
   */
  public: Scalars['Boolean'];
};

export enum PortProtocol {
  Tcp = 'tcp',
  Udp = 'udp'
}

export type PriceComponent = {
  __typename?: 'PriceComponent';
  cost: Scalars['Int'];
  explanation: Scalars['String'];
};

export type Prices = {
  __typename?: 'Prices';
  cpuCore: Scalars['Float'];
  dedicatedCpuCore: Scalars['Float'];
  dedicatedGPU: Scalars['Float'];
  dedicatedRamGB: Scalars['Float'];
  ramGB: Scalars['Float'];
  storageGB: Scalars['Float'];
};

export type Probe = {
  __typename?: 'Probe';
  command?: Maybe<Scalars['String']>;
  failureThreshold: Scalars['Int'];
  http?: Maybe<HttpProbe>;
  initialDelaySeconds: Scalars['Int'];
  periodSeconds: Scalars['Int'];
  successThreshold: Scalars['Int'];
  tcp?: Maybe<TcpProbe>;
  timeoutSeconds: Scalars['Int'];
};

export type ProbeInput = {
  command?: InputMaybe<Scalars['String']>;
  failureThreshold?: InputMaybe<Scalars['Int']>;
  httpEndpoint?: InputMaybe<Scalars['String']>;
  initialDelaySeconds?: InputMaybe<Scalars['Int']>;
  periodSeconds?: InputMaybe<Scalars['Int']>;
  successThreshold?: InputMaybe<Scalars['Int']>;
  tcpEndpoint?: InputMaybe<Scalars['String']>;
  timeoutSeconds?: InputMaybe<Scalars['Int']>;
};

export type Product = {
  /** Any benefit descriptions. */
  benefits: Array<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  /** A string used to communicate the price of this product. No currency or format should be assumed. */
  displayPrice?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  productTypeMetadata?: Maybe<ProductTypeMetadata>;
  sku: Scalars['ID'];
  /** Any usage governed by this Product. */
  usage: Array<Usage>;
};

export type ProductCatalog = {
  __typename?: 'ProductCatalog';
  /**
   * Returns a preview of the new invoice that would result from modifying the user's existing subscription based on the subscriptionCart.
   *
   * This query should be checked before attempting purchaseSubscription with the same cart.
   */
  previewSubscription: SubscriptionPurchasePreview;
  /**
   * Shows all available products in the catalog. When no user is specified, it shows all available products.
   * When a user is specified, the response can be enriched with information from their current subscription (if one exists).
   */
  products: Array<ProductCatalogSection>;
};


export type ProductCatalogPreviewSubscriptionArgs = {
  forUserID: Scalars['UUID'];
  subscriptionCart: SubscriptionCart;
};


export type ProductCatalogProductsArgs = {
  forUserID?: InputMaybe<Scalars['UUID']>;
};

/** A section of the product catalog, showing products of a single type (Plan Tier, Support Tier, etc) */
export type ProductCatalogSection = {
  __typename?: 'ProductCatalogSection';
  /** All available products, regardless of the current subscription. */
  allProducts: Array<CatalogProductView>;
  /** Metadata for the product type this section is for */
  productTypeMetadata?: Maybe<ProductTypeMetadata>;
  sectionName: Scalars['String'];
};

export type ProductPurchasePreview = {
  __typename?: 'ProductPurchasePreview';
  /** The current product on the subscription that is possibly being replaced by newProduct. */
  currentProduct?: Maybe<Product>;
  /** The product that will replace currentProduct, or currentProduct if no change is being made. */
  newProduct?: Maybe<Product>;
  /** The status of newProduct relative to the currentProduct (i.e. downgrade/no change/upgrade) */
  newProductStatus?: Maybe<CatalogProductStatus>;
  /** Metadata for the product type of the two products in this preview. */
  productTypeMetadata?: Maybe<ProductTypeMetadata>;
  /** The section name that the products in this preview would appear under in the product catalog. */
  sectionName: Scalars['String'];
};

export enum ProductType {
  ApiAccess = 'API_ACCESS',
  PlanTier = 'PLAN_TIER',
  ProjectPack = 'PROJECT_PACK',
  SupportTier = 'SUPPORT_TIER'
}

export type ProductTypeMetadata = {
  __typename?: 'ProductTypeMetadata';
  displayName?: Maybe<Scalars['String']>;
  pricingPageAnchor?: Maybe<Scalars['String']>;
  productType?: Maybe<ProductType>;
};

export type ProfileOwner = {
  avatar?: Maybe<Scalars['URL']>;
  login: Scalars['Login'];
  name: Scalars['String'];
};

export type Project = {
  __typename?: 'Project';
  active: Scalars['Boolean'];
  /** When true, this project will be automatically deleted when the last Repo or ProjectV3 is deleted. */
  autoCleanupEnabled: Scalars['Boolean'];
  createdAt: Scalars['Time'];
  defaultEnvironment: ProjectEnvironment;
  defaultRepo?: Maybe<Repo>;
  /** - id: v0.EnvironmentID or v1.SubGroupID */
  environment: ProjectEnvironment;
  environments: Array<ProjectEnvironment>;
  envs?: Maybe<Array<EnvVar>>;
  /** - v0.ProjectID or v1.GroupID */
  id: Scalars['UUID'];
  isMultiRepo: Scalars['Boolean'];
  name: Scalars['String'];
  owner: User;
  permissions?: Maybe<ProjectPermissions>;
  repo?: Maybe<Repo>;
  repos: Array<Repo>;
  revisions?: Maybe<ProjectRevisionConnection>;
  updatedAt: Scalars['Time'];
};


export type ProjectEnvironmentArgs = {
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
};


export type ProjectRepoArgs = {
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
};


export type ProjectRevisionsArgs = {
  page?: InputMaybe<PageInput>;
};

export type ProjectBuildInput = {
  buildCommand?: InputMaybe<Scalars['String']>;
  buildType?: InputMaybe<BuildType>;
  dockerfilePath?: InputMaybe<Scalars['String']>;
  golangVersion?: InputMaybe<Scalars['String']>;
  nodejsVersion?: InputMaybe<Scalars['String']>;
  pythonVersion?: InputMaybe<Scalars['String']>;
  runCommand?: InputMaybe<Scalars['String']>;
  staticPath?: InputMaybe<Scalars['String']>;
  workingDirectory?: InputMaybe<Scalars['String']>;
};

export type ProjectCollaborator = {
  __typename?: 'ProjectCollaborator';
  id: Scalars['ID'];
  role: ProjectCollaboratorRole;
  user: User;
};

export type ProjectCollaboratorInvitation = {
  __typename?: 'ProjectCollaboratorInvitation';
  email: Scalars['String'];
  id: Scalars['ID'];
  link: Scalars['String'];
  project: Repo;
  role: ProjectCollaboratorRole;
};

export enum ProjectCollaboratorRole {
  Editor = 'EDITOR',
  Owner = 'OWNER',
  Viewer = 'VIEWER'
}

export type ProjectConnection = {
  __typename?: 'ProjectConnection';
  edges: Array<ProjectEdge>;
  nodes: Array<Project>;
  pageInfo: PageInfo;
};

export type ProjectConnector = {
  fields?: InputMaybe<Array<ProjectConnectorField>>;
  type?: InputMaybe<ProjectConnectorType>;
};

export type ProjectConnectorField = {
  displayName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<VariableType>;
  value?: InputMaybe<Scalars['String']>;
};

export type ProjectConnectorSchema = {
  entries?: InputMaybe<Array<ProjectConnectorSchemaEntry>>;
};

export type ProjectConnectorSchemaEntry = {
  fields?: InputMaybe<Array<ProjectConnectorSchemaField>>;
  type?: InputMaybe<ProjectConnectorType>;
};

export type ProjectConnectorSchemaField = {
  displayName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<ProjectConnectorSchemaFieldType>;
};

export enum ProjectConnectorSchemaFieldType {
  Output = 'OUTPUT'
}

export enum ProjectConnectorType {
  DatabaseConnection = 'DATABASE_CONNECTION'
}

export type ProjectDeployInput = {
  awsAccountID?: InputMaybe<Scalars['UUID']>;
  clusterID?: InputMaybe<Scalars['UUID']>;
  deployRuntime?: InputMaybe<DeployRuntime>;
  deployTarget: DeployTarget;
  deployType?: InputMaybe<DeployType>;
  doAccountID?: InputMaybe<Scalars['UUID']>;
  gcpAccountID?: InputMaybe<Scalars['UUID']>;
  linodeAccountID?: InputMaybe<Scalars['UUID']>;
  region?: InputMaybe<Scalars['String']>;
  vultrAccountID?: InputMaybe<Scalars['UUID']>;
};

export type ProjectEdge = {
  __typename?: 'ProjectEdge';
  cursor: Scalars['String'];
  node: Project;
};

export type ProjectEnvironment = {
  __typename?: 'ProjectEnvironment';
  createdAt: Scalars['Time'];
  defaultRepo?: Maybe<Repo>;
  envs?: Maybe<Array<EnvVar>>;
  /** - v0.EnvironmentID or v1.SubGroupID */
  id: Scalars['UUID'];
  name: Scalars['String'];
  overview?: Maybe<Array<Maybe<EnvironmentOverview>>>;
  overviewV2?: Maybe<Array<Maybe<EnvironmentOverviewV2>>>;
  project?: Maybe<Project>;
  projectV3Adapters?: Maybe<ProjectV3AdapterConnection>;
  repo?: Maybe<Repo>;
  repoConnection: RepoConnection;
  repos: Array<Repo>;
  revisions?: Maybe<ProjectEnvironmentRevisionConnection>;
  updatedAt: Scalars['Time'];
};


export type ProjectEnvironmentRepoArgs = {
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
};


export type ProjectEnvironmentRepoConnectionArgs = {
  page?: InputMaybe<PageInput>;
  repoFilter?: InputMaybe<RepoFilterInput>;
};


export type ProjectEnvironmentRevisionsArgs = {
  page?: InputMaybe<PageInput>;
};

export type ProjectEnvironmentRevision = RevisableEntity & {
  __typename?: 'ProjectEnvironmentRevision';
  revisionData: Scalars['JSON'];
  revisionMetadata: RevisionMetadata;
};

export type ProjectEnvironmentRevisionConnection = RevisionConnection & {
  __typename?: 'ProjectEnvironmentRevisionConnection';
  nodes: Array<ProjectEnvironmentRevision>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type ProjectOwner = {
  projects: ProjectConnection;
};


export type ProjectOwnerProjectsArgs = {
  input?: InputMaybe<ProjectsInput>;
};

export type ProjectPack = Product & {
  __typename?: 'ProjectPack';
  benefits: Array<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  displayPrice?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  productTypeMetadata?: Maybe<ProductTypeMetadata>;
  sku: Scalars['ID'];
  usage: Array<Usage>;
};

export type ProjectPermissions = {
  __typename?: 'ProjectPermissions';
  availableRoles: Array<TeamMemberProjectRole>;
  users: Array<ProjectUserPermissions>;
};

export type ProjectPermissionsInput = {
  /** The name of the project role to apply to all users specified by `userIds`. Null unsets the project role. */
  teamMemberProjectRoleName?: InputMaybe<Scalars['String']>;
  /** The users to apply the role to. */
  userIds: Array<Scalars['UUID']>;
};

export type ProjectRevision = RevisableEntity & {
  __typename?: 'ProjectRevision';
  revisionData: Scalars['JSON'];
  revisionMetadata: RevisionMetadata;
};

export type ProjectRevisionConnection = RevisionConnection & {
  __typename?: 'ProjectRevisionConnection';
  nodes: Array<ProjectRevision>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type ProjectTemplate = {
  __typename?: 'ProjectTemplate';
  cpu: Scalars['Float'];
  dedicated?: Maybe<Scalars['Boolean']>;
  description: Scalars['String'];
  envs?: Maybe<Array<EnvVarTemplate>>;
  gpu?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  image: Scalars['String'];
  memory: Scalars['Float'];
  name: Scalars['String'];
  ports?: Maybe<Array<Port>>;
  replication?: Maybe<Array<Replication>>;
  source: RepoSource;
  volumes?: Maybe<Array<VolumeSpec>>;
};

export type ProjectUserPermissions = {
  __typename?: 'ProjectUserPermissions';
  projectRole?: Maybe<TeamMemberProjectRole>;
  teamRole?: Maybe<TeamMemberRole>;
  user?: Maybe<User>;
};

export type ProjectV3 = {
  __typename?: 'ProjectV3';
  blueprint?: Maybe<Blueprint>;
  /** The 'blueprint configuration overrides' applied to this project. */
  blueprintConfiguration?: Maybe<BlueprintConfiguration>;
  blueprintID: Scalars['UUID'];
  configuration?: Maybe<ProjectV3Configuration>;
  /**
   * Driver workflows submitted for this project.
   * NOTE: this field will not surface actions executed via the deprecated 'executeBlueprintDriverAction' mutation.
   */
  driverWorkflows?: Maybe<Array<BlueprintDriverWorkflow>>;
  /**
   * The 'effective blueprint configuration' is a view of the BlueprintConfiguration that will be used by the Blueprint Driver.
   *
   * It is the result of merging two BlueprintConfiguration objects:
   * 1. This project's blueprint.configuration
   * 2. This project's blueprintConfiguration ("configuration overrides"), if defined.
   */
  effectiveBlueprintConfiguration?: Maybe<BlueprintConfiguration>;
  /** - v0.ProjectV3ID */
  id: Scalars['UUID'];
  name: Scalars['String'];
  project?: Maybe<Project>;
  projectEnvironment?: Maybe<ProjectEnvironment>;
  requirePlanApproval: Scalars['Boolean'];
  variables: Array<BlueprintVariable>;
  /**
   * Provides a view over driver action executions, grouping together Plan-type actions with their Approve and Apply steps (if they exist)
   * @deprecated use 'driverWorkflows' instead
   */
  workflows?: Maybe<Array<ProjectV3Workflow>>;
};

export type ProjectV3Adapter = {
  __typename?: 'ProjectV3Adapter';
  billable?: Maybe<Scalars['Boolean']>;
  createdAt: Scalars['Time'];
  /** - v0.ProjectAdapterID or v1.ProjectID */
  id: Scalars['UUID'];
  isDeployV2: Scalars['Boolean'];
  name: Scalars['String'];
  project?: Maybe<Project>;
  projectEnvironment?: Maybe<ProjectEnvironment>;
  projectV3?: Maybe<ProjectV3>;
  repo?: Maybe<Repo>;
  status?: Maybe<ProjectV3AdapterStatus>;
  updatedAt: Scalars['Time'];
};

export type ProjectV3AdapterConnection = {
  __typename?: 'ProjectV3AdapterConnection';
  nodes: Array<ProjectV3Adapter>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export enum ProjectV3AdapterStatus {
  BuildAborted = 'BUILD_ABORTED',
  BuildFailed = 'BUILD_FAILED',
  BuildInProgress = 'BUILD_IN_PROGRESS',
  BuildPending = 'BUILD_PENDING',
  BuildSucceeded = 'BUILD_SUCCEEDED',
  ContainerPulling = 'CONTAINER_PULLING',
  DeployCrashing = 'DEPLOY_CRASHING',
  DeployFailed = 'DEPLOY_FAILED',
  DeployHealthy = 'DEPLOY_HEALTHY',
  DeployInProgress = 'DEPLOY_IN_PROGRESS',
  DeployPending = 'DEPLOY_PENDING',
  DeployStopped = 'DEPLOY_STOPPED',
  DeploySucceeded = 'DEPLOY_SUCCEEDED',
  Draft = 'DRAFT',
  HealthChecking = 'HEALTH_CHECKING',
  Inactive = 'INACTIVE',
  JobRunCancelled = 'JOB_RUN_CANCELLED',
  JobRunFailed = 'JOB_RUN_FAILED',
  JobRunPendingApproval = 'JOB_RUN_PENDING_APPROVAL',
  JobRunRunning = 'JOB_RUN_RUNNING',
  JobRunStarting = 'JOB_RUN_STARTING',
  JobRunSucceeded = 'JOB_RUN_SUCCEEDED',
  NodeProvisioning = 'NODE_PROVISIONING',
  Paused = 'PAUSED',
  PendingHealthyCluster = 'PENDING_HEALTHY_CLUSTER',
  Unknown = 'UNKNOWN'
}

export type ProjectV3Configuration = HelmProjectV3Configuration | ManifestProjectV3Configuration | TerraformProjectV3Configuration;

export type ProjectV3Connection = {
  __typename?: 'ProjectV3Connection';
  nodes: Array<ProjectV3>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type ProjectV3GitopsInput = {
  githubConnectionID: Scalars['Int'];
  githubRepoID: Scalars['String'];
  githubRepoName: Scalars['String'];
  githubRepoOwner: Scalars['String'];
  /** - v0.ProjectV3ID */
  projectID: Scalars['UUID'];
  subdirectoryPath?: InputMaybe<Scalars['String']>;
};

/** DEPRECATED: prefer BlueprintDriverWorkflow type instead. */
export type ProjectV3Workflow = {
  __typename?: 'ProjectV3Workflow';
  createdAt: Scalars['Time'];
  jobs?: Maybe<Array<BlueprintDriverActionExecution>>;
  /** @deprecated use `status` property instead. */
  state: JobRunState;
  status: ProjectV3WorkflowStatus;
  updatedAt: Scalars['Time'];
};

export enum ProjectV3WorkflowStatus {
  Aborted = 'ABORTED',
  Failed = 'FAILED',
  PendingApproval = 'PENDING_APPROVAL',
  PendingManualAction = 'PENDING_MANUAL_ACTION',
  Queued = 'QUEUED',
  Running = 'RUNNING',
  Starting = 'STARTING',
  Succeeded = 'SUCCEEDED'
}

export type ProjectsInput = {
  /** When not null, will filter for projects that are active (true) or paused (false). */
  active?: InputMaybe<Scalars['Boolean']>;
  page?: InputMaybe<PageInput>;
};

export type Prometheus = {
  __typename?: 'Prometheus';
  password?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  url: Scalars['String'];
  user?: Maybe<Scalars['String']>;
};

export type PrometheusScrape = {
  __typename?: 'PrometheusScrape';
  path: Scalars['String'];
  port: Scalars['Int'];
};

export type PrometheusScrapeInput = {
  path: Scalars['String'];
  port: Scalars['Int'];
};

export type Query = {
  __typename?: 'Query';
  awsCostByService: Array<Cost>;
  awsCostUsage2: Array<Cost>;
  blueprint?: Maybe<Blueprint>;
  blueprintsMarketplace?: Maybe<BlueprintsMarketplace>;
  checkPrice: CheckPriceOutput;
  currentUser: User;
  dockerRepository?: Maybe<DockerRepository>;
  helmRepository: HelmRepository;
  prices: Prices;
  productCatalog: ProductCatalog;
  /** - v0.ProjectID or v1.GroupID */
  project?: Maybe<Project>;
  repo?: Maybe<Repo>;
  searchHelmCharts: HelmChartConnection;
  team?: Maybe<Team>;
  template: Template;
  terraformRegistry: TerraformRegistry;
  user: User;
};


export type QueryAwsCostByServiceArgs = {
  awsAccountId: Scalars['UUID'];
  where: CostByServiceWhere;
};


export type QueryAwsCostUsage2Args = {
  awsAccountId: Scalars['UUID'];
  where: CostUsageWhere;
};


export type QueryBlueprintArgs = {
  id: Scalars['UUID'];
};


export type QueryCheckPriceArgs = {
  input: CheckPriceInput;
};


export type QueryDockerRepositoryArgs = {
  image: Scalars['String'];
};


export type QueryHelmRepositoryArgs = {
  url: Scalars['String'];
};


export type QueryProjectArgs = {
  id?: InputMaybe<Scalars['UUID']>;
  path?: InputMaybe<Scalars['String']>;
};


export type QueryRepoArgs = {
  id?: InputMaybe<Scalars['UUID']>;
  path?: InputMaybe<Scalars['String']>;
};


export type QuerySearchHelmChartsArgs = {
  input: SearchHelmChartsInput;
};


export type QueryTeamArgs = {
  id?: InputMaybe<Scalars['UUID']>;
  path?: InputMaybe<Scalars['String']>;
};


export type QueryTemplateArgs = {
  id?: InputMaybe<Scalars['UUID']>;
  slug?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};


export type QueryTerraformRegistryArgs = {
  url?: InputMaybe<Scalars['URL']>;
};


export type QueryUserArgs = {
  id: Scalars['ID'];
};

export type ReissueCustomDomainCertificateInput = {
  id: Scalars['UUID'];
};

export type Release = {
  __typename?: 'Release';
  id: Scalars['UUID'];
  logs?: Maybe<Logs>;
};

export type RemoveProbeInput = {
  /** - v0.RepoID */
  id: Scalars['ID'];
  livenessProbe?: InputMaybe<Scalars['Boolean']>;
  readinessProbe?: InputMaybe<Scalars['Boolean']>;
  startupProbe?: InputMaybe<Scalars['Boolean']>;
};

export type RemoveRepoCustomDomainInput = {
  domainID: Scalars['UUID'];
  id: Scalars['UUID'];
};

export type RemoveTeamMemberInput = {
  id: Scalars['UUID'];
  userID: Scalars['UUID'];
};

export type RemoveUserIntegrationInput = {
  id: Scalars['UUID'];
  userID: Scalars['UUID'];
};

export type Replication = {
  __typename?: 'Replication';
  cluster?: Maybe<Cluster>;
  region: Scalars['String'];
  replicas?: Maybe<Scalars['Int']>;
};

export type ReplicationInput = {
  clusterID?: InputMaybe<Scalars['UUID']>;
  region: Scalars['String'];
  replicas: Scalars['Int'];
};

export type Repo = {
  __typename?: 'Repo';
  alternativeImageTagTemplates?: Maybe<Array<Scalars['String']>>;
  appID?: Maybe<Scalars['String']>;
  autoRetry?: Maybe<Scalars['Boolean']>;
  autoRollback?: Maybe<Scalars['Boolean']>;
  autoscaling?: Maybe<Autoscaling>;
  awsAccount?: Maybe<AwsAccount>;
  awsIamRole?: Maybe<Scalars['String']>;
  bitbucketIntegration?: Maybe<BitbucketRepoIntegration>;
  branch?: Maybe<RepoBranchV2>;
  branchIgnore?: Maybe<Scalars['String']>;
  branchResources?: Maybe<ContainerResourcesSpec>;
  branches?: Maybe<Array<RepoBranch>>;
  branchesV2?: Maybe<RepoBranchConnection>;
  buildMethod?: Maybe<BuildMethod>;
  buildMethodSuggestions?: Maybe<Array<BuildMethod>>;
  buildResources?: Maybe<ContainerResourcesSpec>;
  buildSpec?: Maybe<ContainerSpec>;
  canDeploy?: Maybe<Scalars['Boolean']>;
  cdns?: Maybe<Array<Cdn>>;
  cluster?: Maybe<Cluster>;
  clusterDomains?: Maybe<Array<ClusterDomains>>;
  clusterIssuerName?: Maybe<Scalars['String']>;
  collaboratorInvitations?: Maybe<Array<ProjectCollaboratorInvitation>>;
  collaborators?: Maybe<Array<ProjectCollaborator>>;
  containerRegistry?: Maybe<ContainerRegistry>;
  cpu?: Maybe<Scalars['String']>;
  createdAt: Scalars['Time'];
  cronJobSchedule?: Maybe<Scalars['String']>;
  databaseEngine?: Maybe<DatabaseEngineType>;
  databaseEnvs: Array<EnvVar>;
  databaseLinks: Array<DatabaseLink>;
  databaseProvider?: Maybe<DatabaseProviderType>;
  databaseVersion?: Maybe<Scalars['String']>;
  datadogApmEnabled?: Maybe<Scalars['Boolean']>;
  dedicated?: Maybe<Scalars['Boolean']>;
  defaultIngressDomain?: Maybe<Scalars['String']>;
  deployBranch?: Maybe<Scalars['Boolean']>;
  deployJob?: Maybe<Scalars['Boolean']>;
  deployService?: Maybe<Scalars['Boolean']>;
  deployStrategy?: Maybe<DeployStrategy>;
  deployTarget?: Maybe<DeployTarget>;
  deployTimeoutSeconds?: Maybe<Scalars['Int']>;
  deployType?: Maybe<DeployType>;
  deployment?: Maybe<Deployment>;
  deploymentConfiguration: RepoDeploymentConfiguration;
  deploymentConfigurationRevisions: RepoDeploymentConfigurationConnection;
  deployments?: Maybe<Array<Deployment>>;
  disableReason?: Maybe<DisableReason>;
  enabled: Scalars['Boolean'];
  envs?: Maybe<Array<EnvVar>>;
  ephemeralStorage?: Maybe<Scalars['Float']>;
  free?: Maybe<Scalars['Boolean']>;
  fullPath: Scalars['String'];
  gcpAccount?: Maybe<GcpAccount>;
  gcpServiceAccount?: Maybe<Scalars['String']>;
  gitSubmodules?: Maybe<GitSubmodulesType>;
  githubIntegration?: Maybe<GitHubRepoIntegration>;
  githubRepository?: Maybe<GitHubRepository>;
  gitlabIntegration?: Maybe<GitlabRepoIntegration>;
  gpu?: Maybe<GpuSpec>;
  hasBuildStage?: Maybe<Scalars['Boolean']>;
  hasDeployStage?: Maybe<Scalars['Boolean']>;
  helmChart?: Maybe<HelmChart>;
  helmValues?: Maybe<Scalars['String']>;
  hostNetwork?: Maybe<Scalars['Boolean']>;
  /** - v0.RepoID */
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  jobRun: JobRun;
  jobRuns?: Maybe<JobRunConnection>;
  kanikoFlags?: Maybe<KanikoFlags>;
  kappID?: Maybe<Scalars['String']>;
  kubernetesCustomization?: Maybe<KubernetesCustomization>;
  linkedProjects: Array<DatabaseLink>;
  livenessProbe?: Maybe<Probe>;
  logShipper?: Maybe<LogShipper>;
  machines?: Maybe<Array<Machine>>;
  manifest?: Maybe<Manifest>;
  manualDeploy?: Maybe<Scalars['Boolean']>;
  memory?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  namespace?: Maybe<Scalars['String']>;
  noBuildCache?: Maybe<Scalars['Boolean']>;
  nodeSelector?: Maybe<Scalars['JSON']>;
  owner: User;
  path: Scalars['String'];
  pipelineCluster?: Maybe<Cluster>;
  pipelineLinks?: Maybe<Array<RepoPipelineLink>>;
  ports?: Maybe<Array<Port>>;
  preStopSleep?: Maybe<Scalars['Int']>;
  productionBranch?: Maybe<Scalars['String']>;
  productionBranchV2?: Maybe<RepoBranchV2>;
  productionDeployment?: Maybe<Deployment>;
  project?: Maybe<Project>;
  projectEnvironment?: Maybe<ProjectEnvironment>;
  prometheusScrape?: Maybe<PrometheusScrape>;
  readinessProbe?: Maybe<Probe>;
  replication?: Maybe<Array<Replication>>;
  resources?: Maybe<ContainerResourcesSpec>;
  secretMounts?: Maybe<Array<KubernetesSecretMount>>;
  serverlessRegion?: Maybe<Scalars['String']>;
  serverlessResources?: Maybe<ServerlessResourceSpec>;
  source: RepoSource;
  startupProbe?: Maybe<Probe>;
  staticIP?: Maybe<Scalars['Boolean']>;
  terminationGracePeriodSeconds?: Maybe<Scalars['Int']>;
  terraformVariables?: Maybe<Scalars['JSON']>;
  terraformVersion?: Maybe<Scalars['String']>;
  tpu?: Maybe<TpuSpec>;
  updatedAt: Scalars['Time'];
  useHumanReadableKubernetesName?: Maybe<Scalars['Boolean']>;
  volumes?: Maybe<Array<VolumeSpec>>;
};


export type RepoBranchArgs = {
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
};


export type RepoBranchesV2Args = {
  input?: InputMaybe<BranchInput>;
  page?: InputMaybe<PageInput>;
};


export type RepoDeploymentArgs = {
  id: Scalars['ID'];
};


export type RepoDeploymentConfigurationArgs = {
  revisionId?: InputMaybe<Scalars['UUID']>;
  sequenceId?: InputMaybe<Scalars['Int']>;
};


export type RepoDeploymentConfigurationRevisionsArgs = {
  page?: InputMaybe<PageInput>;
};


export type RepoDeploymentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  input?: InputMaybe<DeploymentsInput>;
};


export type RepoJobRunArgs = {
  id: Scalars['UUID'];
};

export enum RepoAction {
  Deploy = 'DEPLOY'
}

export type RepoActionInput = {
  action: RepoAction;
  setImage?: InputMaybe<Scalars['String']>;
};

export type RepoBranch = {
  __typename?: 'RepoBranch';
  deployments?: Maybe<Array<Deployment>>;
  id: Scalars['ID'];
  name: Scalars['String'];
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Time']>;
};

export type RepoBranchConnection = {
  __typename?: 'RepoBranchConnection';
  nodes: Array<RepoBranchV2>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type RepoBranchV2 = {
  __typename?: 'RepoBranchV2';
  awsLinks?: Maybe<AwsLinks>;
  branchSlug?: Maybe<Scalars['String']>;
  createdAt: Scalars['Time'];
  deployments?: Maybe<DeploymentConnection>;
  endpoints?: Maybe<Array<Scalars['String']>>;
  environmentSlug?: Maybe<Scalars['String']>;
  gcpLinks?: Maybe<GcpLinks>;
  gitRef?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  image?: Maybe<Scalars['String']>;
  kappID?: Maybe<Scalars['String']>;
  latestDeployment?: Maybe<Deployment>;
  loadBalancers?: Maybe<Array<LoadBalancer>>;
  metrics?: Maybe<Array<Metric>>;
  name: Scalars['String'];
  namespace?: Maybe<Scalars['String']>;
  patchedPodSpec?: Maybe<Scalars['String']>;
  privateEndpoints?: Maybe<Array<Scalars['String']>>;
  renderIngress?: Maybe<Scalars['String']>;
  renderPodSpec?: Maybe<Scalars['String']>;
  repo?: Maybe<Repo>;
  resources?: Maybe<Array<CloudResource>>;
  state?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  /**
   * This will indicate possible issues with the current configuration, i.e. if the git branch no longer exists.
   * This will NOT be used to communicate issues about the status of deployed resources, i.e. if builds are failing or the deployment is crashing.
   */
  troubleshooting?: Maybe<Troubleshooting>;
  updatedAt: Scalars['Time'];
};


export type RepoBranchV2DeploymentsArgs = {
  page?: InputMaybe<PageInput>;
};


export type RepoBranchV2MetricsArgs = {
  name: Scalars['String'];
};


export type RepoBranchV2RenderIngressArgs = {
  patch?: InputMaybe<Scalars['String']>;
};


export type RepoBranchV2RenderPodSpecArgs = {
  patch?: InputMaybe<Scalars['String']>;
};

export type RepoConnection = {
  __typename?: 'RepoConnection';
  nodes: Array<Repo>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type RepoDeploymentConfiguration = RevisableEntity & {
  __typename?: 'RepoDeploymentConfiguration';
  revisionData: Scalars['JSON'];
  revisionMetadata: RevisionMetadata;
};

export type RepoDeploymentConfigurationConnection = RevisionConnection & {
  __typename?: 'RepoDeploymentConfigurationConnection';
  nodes: Array<RepoDeploymentConfiguration>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export enum RepoEvent {
  BuildSucceeded = 'BUILD_SUCCEEDED',
  DeploySucceeded = 'DEPLOY_SUCCEEDED'
}

export type RepoFilter = {
  status?: InputMaybe<RepoStatusCriterion>;
};

export type RepoGroup = {
  __typename?: 'RepoGroup';
  description?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  name?: Maybe<Scalars['String']>;
  repos?: Maybe<Array<Repo>>;
  selector?: Maybe<LabelSelectors>;
};

export type RepoPipelineLink = {
  __typename?: 'RepoPipelineLink';
  /** - v0.RepoID */
  id: Scalars['UUID'];
  source: Repo;
  sourceEvent: RepoEvent;
  targetAction: RepoAction;
  targetGroup: RepoGroup;
};

export type RepoSource = {
  __typename?: 'RepoSource';
  id: Scalars['ID'];
  name: Scalars['String'];
  type: RepoSourceType;
};

export enum RepoSourceType {
  Bitbucket = 'BITBUCKET',
  Docker = 'DOCKER',
  DockerHub = 'DOCKER_HUB',
  Git = 'GIT',
  Github = 'GITHUB',
  GithubPublic = 'GITHUB_PUBLIC',
  Gitlab = 'GITLAB',
  Helm = 'HELM',
  Terraform = 'TERRAFORM'
}

export type RepoStatusCriterion = {
  operator?: InputMaybe<FilterCriterionOperatorType>;
  value?: InputMaybe<Scalars['String']>;
};

export type ReposInput = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  showDisabled?: InputMaybe<Scalars['Boolean']>;
  team?: InputMaybe<Scalars['ID']>;
};

export type ResourceAdapterFilter = {
  /** Active=true or Paused=false */
  active?: InputMaybe<BooleanCriterion>;
  deployableIds?: InputMaybe<MultiEntityCriterion>;
  environmentName?: InputMaybe<StringCriterion>;
  ids?: InputMaybe<MultiEntityCriterion>;
  name?: InputMaybe<StringCriterion>;
  projectName?: InputMaybe<StringCriterion>;
  repoIds?: InputMaybe<MultiEntityCriterion>;
  resourceIds?: InputMaybe<MultiEntityCriterion>;
  status?: InputMaybe<AdapterStatusCriterion>;
};

export type ResourceBranchInput = {
  autoDeployBranch?: InputMaybe<Scalars['Boolean']>;
  autoStopBranch?: InputMaybe<Scalars['Boolean']>;
  branchIgnore?: InputMaybe<Scalars['String']>;
  branchStopIgnore?: InputMaybe<Scalars['String']>;
  productionBranch?: InputMaybe<Scalars['String']>;
};

export type ResourceBuildInput = {
  build?: InputMaybe<ProjectBuildInput>;
  buildResources?: InputMaybe<ContainerResourcesSpecInput>;
  buildTarget?: InputMaybe<BuildTargetInput>;
  containerCacheRepository?: InputMaybe<Scalars['String']>;
  containerRegistryID?: InputMaybe<Scalars['UUID']>;
  containerRepository?: InputMaybe<Scalars['String']>;
  gitSubmodules?: InputMaybe<GitSubmodulesType>;
  kanikoFlags?: InputMaybe<KanikoFlagsInput>;
  noBuildCache?: InputMaybe<Scalars['Boolean']>;
};

export type ResourceDatabaseInput = {
  deployTarget: DatabaseDeployTargetInput;
  engine: DatabaseEngineType;
  options?: InputMaybe<DatabaseOptions>;
  version: Scalars['String'];
};

export type ResourceFilter = {
  deployableIds?: InputMaybe<MultiEntityCriterion>;
  ids?: InputMaybe<MultiEntityCriterion>;
  userIds?: InputMaybe<MultiEntityCriterion>;
};

export type ResourceKubernetesAppInput = {
  autoscaling?: InputMaybe<AutoscalingInput>;
  awsIamRole?: InputMaybe<Scalars['String']>;
  branchResources?: InputMaybe<ContainerResourcesSpecInput>;
  customization?: InputMaybe<KubernetesCustomizationInput>;
  datadogApmEnabled?: InputMaybe<Scalars['Boolean']>;
  defaultIngressDomain?: InputMaybe<Scalars['String']>;
  deployJob?: InputMaybe<Scalars['Boolean']>;
  deployService?: InputMaybe<Scalars['Boolean']>;
  deployStrategy?: InputMaybe<DeployStrategy>;
  envs?: InputMaybe<Array<EnvVarInput>>;
  gcpServiceAccount?: InputMaybe<Scalars['String']>;
  livenessProbe?: InputMaybe<ProbeInput>;
  logShipper?: InputMaybe<LogShipperInput>;
  ports?: InputMaybe<Array<PortInput>>;
  preStopSleep?: InputMaybe<Scalars['Int']>;
  prometheusScrape?: InputMaybe<PrometheusScrapeInput>;
  readinessProbe?: InputMaybe<ProbeInput>;
  releaseCommand?: InputMaybe<Scalars['String']>;
  replication?: InputMaybe<Array<InputMaybe<ReplicationInput>>>;
  resources?: InputMaybe<ContainerResourcesSpecInput>;
  runCommand?: InputMaybe<Scalars['String']>;
  secretMounts?: InputMaybe<Array<KubernetesSecretMountInput>>;
  startupProbe?: InputMaybe<ProbeInput>;
  staticIP?: InputMaybe<Scalars['Boolean']>;
  terminationGracePeriodSeconds?: InputMaybe<Scalars['Int']>;
  useHumanReadableName?: InputMaybe<Scalars['Boolean']>;
  volumes?: InputMaybe<Array<VolumeInput>>;
};

export type ResourceKubernetesHelmInput = {
  releaseName?: InputMaybe<Scalars['String']>;
  values?: InputMaybe<Scalars['YAML']>;
  valuesFiles?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ResourceKubernetesInput = {
  app?: InputMaybe<ResourceKubernetesAppInput>;
  deployTarget?: InputMaybe<ProjectDeployInput>;
  helm?: InputMaybe<ResourceKubernetesHelmInput>;
  manifest?: InputMaybe<ResourceKubernetesManifestInput>;
  namespace?: InputMaybe<Scalars['String']>;
};

export type ResourceKubernetesManifestInput = {
  kustomizeDirs?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  manifestValue?: InputMaybe<Scalars['YAML']>;
  manifests?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ResourceServerlessInput = {
  deployService?: InputMaybe<Scalars['Boolean']>;
  deployTarget?: InputMaybe<ProjectDeployInput>;
  envs?: InputMaybe<Array<InputMaybe<EnvVarInput>>>;
  ports?: InputMaybe<Array<PortInput>>;
  serverlessResources?: InputMaybe<ServerlessResourcesSpecInput>;
};

export type ResourceTerraformInput = {
  deployTarget?: InputMaybe<ProjectDeployInput>;
  variables?: InputMaybe<Scalars['JSON']>;
};

export enum ResourceType {
  Container = 'CONTAINER',
  Daemonset = 'DAEMONSET',
  Deployment = 'DEPLOYMENT',
  Job = 'JOB',
  Pod = 'POD',
  Replicaset = 'REPLICASET',
  Service = 'SERVICE',
  Statefulset = 'STATEFULSET'
}

export type ResourceWorkflowInput = {
  autoRetry?: InputMaybe<Scalars['Boolean']>;
  autoRollback?: InputMaybe<Scalars['Boolean']>;
  deployTimeoutSeconds?: InputMaybe<Scalars['Int']>;
  manualDeploy?: InputMaybe<Scalars['Boolean']>;
  pipelineClusterID?: InputMaybe<Scalars['UUID']>;
};

export type RevisableEntity = {
  revisionData: Scalars['JSON'];
  revisionMetadata: RevisionMetadata;
};

export type RevisionConnection = {
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type RevisionMetadata = {
  __typename?: 'RevisionMetadata';
  createdAt: Scalars['Time'];
  createdBy: User;
  description: Scalars['String'];
  id: Scalars['UUID'];
  sequenceId: Scalars['Int'];
};

export type RightSizingInstance = {
  __typename?: 'RightSizingInstance';
  hourlyCost?: Maybe<Scalars['String']>;
  memory?: Maybe<Scalars['String']>;
  monthlyCost?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  resourceId?: Maybe<Scalars['String']>;
  storage?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  utilization?: Maybe<RightSizingUtilization>;
  vcpu?: Maybe<Scalars['String']>;
};

export type RightSizingRecommendation = {
  __typename?: 'RightSizingRecommendation';
  currentInstance?: Maybe<RightSizingInstance>;
  reasons: Array<Scalars['String']>;
  recommendations?: Maybe<Array<RightSizingRecommendationDetail>>;
};

export type RightSizingRecommendationDetail = {
  __typename?: 'RightSizingRecommendationDetail';
  estimatedMonthlyCost?: Maybe<Scalars['String']>;
  estimatedMonthlySavings?: Maybe<Scalars['String']>;
  instance?: Maybe<RightSizingInstance>;
  platformDifferences?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type RightSizingUtilization = {
  __typename?: 'RightSizingUtilization';
  maxCpuUtilizationPercentage?: Maybe<Scalars['String']>;
  maxMemoryUtilizationPercentage?: Maybe<Scalars['String']>;
  maxStorageUtilizationPercentage?: Maybe<Scalars['String']>;
};

export type RunJobInput = {
  build?: InputMaybe<Scalars['Boolean']>;
  envs?: InputMaybe<Array<EnvVarInput>>;
  id: Scalars['UUID'];
  runCommand?: InputMaybe<Scalars['String']>;
};

export type Runtime = CloudRuntime | KubernetesRuntime;

export type S3BucketBackendInput = {
  awsAccountID: Scalars['UUID'];
  bucketName: Scalars['String'];
  key?: InputMaybe<Scalars['String']>;
  region: Scalars['String'];
};

export type S3BucketConfiguration = {
  __typename?: 'S3BucketConfiguration';
  awsAccountID: Scalars['UUID'];
  bucketName: Scalars['String'];
  key?: Maybe<Scalars['String']>;
  region: Scalars['String'];
};

export enum SavingsPlanPaymentOption {
  AllUpfront = 'ALL_UPFRONT',
  HeavyUtilization = 'HEAVY_UTILIZATION',
  LightUtilization = 'LIGHT_UTILIZATION',
  MediumUtilization = 'MEDIUM_UTILIZATION',
  NoUpfront = 'NO_UPFRONT',
  PartialUpfront = 'PARTIAL_UPFRONT'
}

export type SavingsPlanRecommendation = {
  __typename?: 'SavingsPlanRecommendation';
  currentOnDemandSpend?: Maybe<Scalars['String']>;
  details?: Maybe<Array<SavingsPlanRecommendationDetail>>;
  estimatedMonthlySavingsAmount?: Maybe<Scalars['String']>;
  estimatedOnDemandCostWithCurrentCommitment?: Maybe<Scalars['String']>;
  estimatedSavingsAmount?: Maybe<Scalars['String']>;
  estimatedSavingsPercentage?: Maybe<Scalars['String']>;
  hourlyCommitmentToPurchase?: Maybe<Scalars['String']>;
};

export type SavingsPlanRecommendationDetail = {
  __typename?: 'SavingsPlanRecommendationDetail';
  currentAverageHourlyOnDemandSpend?: Maybe<Scalars['String']>;
  estimatedAverageUtilization?: Maybe<Scalars['String']>;
  estimatedMonthlySavingsAmount?: Maybe<Scalars['String']>;
  hourlyCommitmentToPurchase?: Maybe<Scalars['String']>;
  instanceFamily?: Maybe<Scalars['String']>;
  offeringId?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  upfrontCost?: Maybe<Scalars['String']>;
};

export type SavingsPlanRecommendationsInput = {
  paymentOption: SavingsPlanPaymentOption;
  term: SavingsPlanTerm;
  type: SavingsPlanType;
};

export enum SavingsPlanTerm {
  OneYear = 'ONE_YEAR',
  ThreeYears = 'THREE_YEARS'
}

export enum SavingsPlanType {
  ComputeSp = 'COMPUTE_SP',
  Ec2InstanceSp = 'EC2_INSTANCE_SP',
  SagemakerSp = 'SAGEMAKER_SP'
}

export type SearchHelmChartsInput = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
};

export type ServerlessConfig = {
  __typename?: 'ServerlessConfig';
  awsStackName?: Maybe<Scalars['String']>;
  functions?: Maybe<Array<ServerlessFunction>>;
  provider?: Maybe<ServerlessProvider>;
  service?: Maybe<Scalars['String']>;
};

export type ServerlessFunction = {
  __typename?: 'ServerlessFunction';
  handler?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type ServerlessProvider = {
  __typename?: 'ServerlessProvider';
  name?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  runtime?: Maybe<Scalars['String']>;
  stackName?: Maybe<Scalars['String']>;
  stage?: Maybe<Scalars['String']>;
};

export type ServerlessResourceSpec = {
  __typename?: 'ServerlessResourceSpec';
  cpu?: Maybe<Scalars['Float']>;
  memory?: Maybe<Scalars['Float']>;
};

export type ServerlessResourcesSpecInput = {
  cpu?: InputMaybe<Scalars['Float']>;
  memory: Scalars['Float'];
};

export type SetRepoEnvsInput = {
  envs: Array<EnvVarInput>;
  id: Scalars['ID'];
};

export type SignInWithWeb3Input = {
  challengeId: Scalars['UUID'];
  signature: Scalars['String'];
};

export type SimpleZeetError = ZeetError & {
  __typename?: 'SimpleZeetError';
  errorCode?: Maybe<Scalars['String']>;
  errorID?: Maybe<Scalars['String']>;
  message: Scalars['String'];
};

export type SlackIntegration = Integration & {
  __typename?: 'SlackIntegration';
  createdAt: Scalars['Time'];
  description: Scalars['String'];
  id: Scalars['UUID'];
  image: Scalars['String'];
  name: Scalars['String'];
  type: IntegrationType;
  updatedAt: Scalars['Time'];
};

export type SlackWebhookIntegration = Integration & NotificationIntegration & {
  __typename?: 'SlackWebhookIntegration';
  createdAt: Scalars['Time'];
  deliveryError?: Maybe<NotificationDeliveryError>;
  description: Scalars['String'];
  id: Scalars['UUID'];
  image: Scalars['String'];
  name: Scalars['String'];
  notificationSettings?: Maybe<NotificationIntegrationSettings>;
  type: IntegrationType;
  updatedAt: Scalars['Time'];
  url?: Maybe<Scalars['String']>;
};

export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type SortInput = {
  direction?: InputMaybe<SortDirection>;
  field?: InputMaybe<Scalars['String']>;
};

export type Source = {
  __typename?: 'Source';
  containerRegistry?: Maybe<ContainerRegistrySource>;
  git?: Maybe<GitSource>;
  helmRepository?: Maybe<HelmRepositorySource>;
  terraformRegistry?: Maybe<TerraformRegistrySource>;
};

export type SourceInput = {
  containerRegistry?: InputMaybe<ContainerRegistrySourceInput>;
  git?: InputMaybe<GitSourceInput>;
  helmRepository?: InputMaybe<HelmRepositorySourceInput>;
  terraformRegistry?: InputMaybe<TerraformRegistrySourceInput>;
};

export type StringCriterion = {
  operator?: InputMaybe<FilterCriterionOperatorType>;
  value?: InputMaybe<Scalars['String']>;
};

export type StripePrice = {
  __typename?: 'StripePrice';
  id: Scalars['ID'];
  product: StripeProduct;
  unitAmount: Scalars['Int'];
};

export type StripeProduct = {
  __typename?: 'StripeProduct';
  description: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type StripeSubscription = {
  __typename?: 'StripeSubscription';
  createdAt: Scalars['Time'];
  id: Scalars['ID'];
  items: Array<StripeSubscriptionItem>;
  status: StripeSubscriptionStatus;
};

export type StripeSubscriptionItem = {
  __typename?: 'StripeSubscriptionItem';
  id: Scalars['ID'];
  price: StripePrice;
  quantity: Scalars['Int'];
};

export enum StripeSubscriptionStatus {
  Active = 'active',
  Canceled = 'canceled',
  Incomplete = 'incomplete',
  IncompleteExpired = 'incomplete_expired',
  PastDue = 'past_due',
  Trialing = 'trialing',
  Unpaid = 'unpaid'
}

export type StripeUser = {
  __typename?: 'StripeUser';
  balance: Scalars['Int'];
  id: Scalars['ID'];
};

export type Subscription = {
  __typename?: 'Subscription';
  deploymentBuildLogsAdded: LogEntry;
  deploymentUpdated: Deployment;
  repoUpdated: Repo;
};


export type SubscriptionDeploymentBuildLogsAddedArgs = {
  input: BuildLogsInput;
};


export type SubscriptionDeploymentUpdatedArgs = {
  id: Scalars['ID'];
};


export type SubscriptionRepoUpdatedArgs = {
  id: Scalars['UUID'];
};

export type SubscriptionCart = {
  apiAccessSku: Scalars['ID'];
  planTierSku: Scalars['ID'];
  projectPackSku: Scalars['ID'];
  supportTierSku: Scalars['ID'];
};

export type SubscriptionFeature = {
  __typename?: 'SubscriptionFeature';
  enabled?: Maybe<Scalars['Boolean']>;
  key: FeatureKey;
};

export type SubscriptionFeatures = {
  __typename?: 'SubscriptionFeatures';
  /** Query a specific subscription feature */
  byKey?: Maybe<SubscriptionFeature>;
};


export type SubscriptionFeaturesByKeyArgs = {
  featureKey: FeatureKey;
};

/**
 * A preview of the desired changes to a subscription.
 *
 * All fields should be checked for errors: if any errors are returned, a subsequent purchaseSubscription mutation would fail.
 */
export type SubscriptionPurchasePreview = {
  __typename?: 'SubscriptionPurchasePreview';
  /**
   * A short name indicating the payment method on file that will be used for this subscription.
   * If no payment method is on file, this will be null.
   * If no payment method is on file, _and_ one is required to complete the purchase, an error will be returned."
   */
  paymentMethodName?: Maybe<Scalars['String']>;
  products?: Maybe<Array<ProductPurchasePreview>>;
};

export type SubscriptionPurchaseResponse = {
  __typename?: 'SubscriptionPurchaseResponse';
  /** The new billing overview with the updated subscription */
  overview: BillingOverview;
};

/** Indicates if the team is able to create new entities within their subscription limits. */
export type SubscriptionUsageAllowed = {
  __typename?: 'SubscriptionUsageAllowed';
  cloudAccounts: Scalars['Boolean'];
  clusters: Scalars['Boolean'];
  customBlueprints: Scalars['Boolean'];
  projects: Scalars['Boolean'];
  seats: Scalars['Boolean'];
};

export type SuggestProjectNameInput = {
  name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type SuggestTemplateNameInput = {
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
};

export type SupportTier = Product & {
  __typename?: 'SupportTier';
  benefits: Array<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  displayPrice?: Maybe<Scalars['String']>;
  items?: Maybe<Scalars['Object']>;
  name?: Maybe<Scalars['String']>;
  productTypeMetadata?: Maybe<ProductTypeMetadata>;
  sku: Scalars['ID'];
  usage: Array<Usage>;
};

export type SyslogIntegration = {
  __typename?: 'SyslogIntegration';
  host: Scalars['String'];
  mode: Scalars['String'];
  port: Scalars['String'];
};

export type SyslogIntegrationInput = {
  host: Scalars['String'];
  mode: Scalars['String'];
  port: Scalars['String'];
};

export type TcpProbe = {
  __typename?: 'TCPProbe';
  host?: Maybe<Scalars['String']>;
  port: Scalars['String'];
};

export type TpuInput = {
  cores: Scalars['Int'];
  tfVersion: Scalars['String'];
  type: Scalars['String'];
};

export type TpuSpec = {
  __typename?: 'TPUSpec';
  cores: Scalars['Int'];
  tfVersion: Scalars['String'];
  type: Scalars['String'];
};

export type Team = ProfileOwner & ProjectOwner & {
  __typename?: 'Team';
  avatar?: Maybe<Scalars['URL']>;
  awsAccounts?: Maybe<Array<AwsAccount>>;
  children?: Maybe<Array<Team>>;
  id: Scalars['UUID'];
  login: Scalars['Login'];
  memberInvitations: Array<TeamMemberInvitation>;
  members: Array<UserTeamEdge>;
  name: Scalars['String'];
  parent?: Maybe<Team>;
  plan: Plan;
  projects: ProjectConnection;
  user: User;
};


export type TeamProjectsArgs = {
  input?: InputMaybe<ProjectsInput>;
};

export type TeamMemberInvitation = {
  __typename?: 'TeamMemberInvitation';
  createdAt: Scalars['Time'];
  email?: Maybe<Scalars['String']>;
  expiresAt?: Maybe<Scalars['Time']>;
  id: Scalars['UUID'];
  link: Scalars['String'];
  role: TeamMemberRole;
  team: Team;
};

export type TeamMemberProjectRole = {
  __typename?: 'TeamMemberProjectRole';
  description?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export enum TeamMemberRole {
  Admin = 'ADMIN',
  Member = 'MEMBER',
  Owner = 'OWNER',
  Viewer = 'VIEWER'
}

export type Template = {
  __typename?: 'Template';
  description: Scalars['String'];
  homepageURL?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  image: Scalars['String'];
  name: Scalars['String'];
  projects: Array<ProjectTemplate>;
  repositoryURL?: Maybe<Scalars['String']>;
  stats?: Maybe<TemplateStats>;
};

export type TemplateStats = {
  __typename?: 'TemplateStats';
  deploys: Scalars['Int'];
  forks: Scalars['Int'];
  stars: Scalars['Int'];
};

/** Input values for Terraform APPLY actions */
export type TerraformApplyActionParameters = {
  /** Zeet ID for the driver action execution of a Terraform PLAN action */
  planID: Scalars['UUID'];
};

/** Input values for Terraform APPROVE actions */
export type TerraformApproveActionParameters = {
  /** Zeet ID for the driver action execution of a Terraform PLAN action */
  planID: Scalars['UUID'];
};

export type TerraformAutomaticOutputConfiguration = {
  __typename?: 'TerraformAutomaticOutputConfiguration';
  /** Disable the 'automatic output' handler, which produces a single map named 'outputs' containing all module outputs. */
  disabled?: Maybe<Scalars['Boolean']>;
  /** The keys of any module outputs that should be excluded from the automatic output value. Ignored when 'disabled' is true. */
  excluded?: Maybe<Array<Scalars['String']>>;
  /** Mark the automatic output value as sensitive. This is required to be 'true' when 'disabled' is false and any sensitive module output is not in 'excluded'. */
  sensitive?: Maybe<Scalars['Boolean']>;
};

/** See TerraformAutomaticOutputConfiguration. */
export type TerraformAutomaticOutputConfigurationInput = {
  disabled?: InputMaybe<Scalars['Boolean']>;
  excluded?: InputMaybe<Array<Scalars['String']>>;
  sensitive?: InputMaybe<Scalars['Boolean']>;
};

export type TerraformClusterComponentMetadata = {
  __typename?: 'TerraformClusterComponentMetadata';
  jobRunState?: Maybe<JobRunState>;
};

export type TerraformModule = {
  __typename?: 'TerraformModule';
  description?: Maybe<Scalars['String']>;
  downloads?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  namespace?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['Time']>;
  registry: TerraformRegistry;
  source?: Maybe<Scalars['String']>;
  verified?: Maybe<Scalars['Boolean']>;
  version?: Maybe<Scalars['String']>;
};

export type TerraformModuleConnection = {
  __typename?: 'TerraformModuleConnection';
  nodes: Array<TerraformModule>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type TerraformModuleSource = {
  __typename?: 'TerraformModuleSource';
  /** Configuring an integration provides authentication to retrieve the module from private sources */
  integration?: Maybe<TerraformModuleSourceIntegration>;
  /** Any valid Terraform Module source: https://developer.hashicorp.com/terraform/language/modules/sources */
  source: Scalars['String'];
  /** The version field is only applicable to Terraform Registry sources */
  version?: Maybe<Scalars['String']>;
};

export type TerraformModuleSourceInput = {
  integration?: InputMaybe<TerraformModuleSourceIntegrationInput>;
  source: Scalars['String'];
  version?: InputMaybe<Scalars['String']>;
};

export type TerraformModuleSourceIntegration = {
  __typename?: 'TerraformModuleSourceIntegration';
  git?: Maybe<GitSourceIntegration>;
};

export type TerraformModuleSourceIntegrationInput = {
  git?: InputMaybe<GitSourceIntegrationInput>;
};

export type TerraformOperation = {
  __typename?: 'TerraformOperation';
  applyStage?: Maybe<PipelineStage>;
  approved: Scalars['Boolean'];
  config?: Maybe<Scalars['JSON']>;
  id: Scalars['UUID'];
  planStage?: Maybe<PipelineStage>;
  state: TerraformOperationState;
};

export enum TerraformOperationState {
  Applying = 'APPLYING',
  ApplyFailed = 'APPLY_FAILED',
  Canceled = 'CANCELED',
  Pending = 'PENDING',
  Planning = 'PLANNING',
  PlanFailed = 'PLAN_FAILED',
  Succeeded = 'SUCCEEDED',
  WaitingForApproval = 'WAITING_FOR_APPROVAL'
}

export type TerraformOutputConfiguration = {
  __typename?: 'TerraformOutputConfiguration';
  /** Configuration for the automatic output handler. This configuration does not affect output defined via 'customization'. */
  automatic?: Maybe<TerraformAutomaticOutputConfiguration>;
  /**
   * A JSON object using Terraform configuration syntax (https://developer.hashicorp.com/terraform/language/syntax/json), constituting a valid "output" block.
   *
   * Example:
   * ```
   * {
   *   "output": {
   *     "example": {
   *       "value": "${aws_instance.example}"
   *     }
   *   }
   * }
   * ```
   *
   * This must include the output block "envelope".
   *
   * To reference module values, use the expression mapping syntax: https://developer.hashicorp.com/terraform/language/syntax/json#expression-mapping
   */
  customization?: Maybe<Scalars['JSON']>;
};

/** See TerraformOutputConfiguration. */
export type TerraformOutputConfigurationInput = {
  automatic?: InputMaybe<TerraformAutomaticOutputConfigurationInput>;
  customization?: InputMaybe<Scalars['JSON']>;
};

/**
 * [DEPRECATED] Input values for Terraform PLAN actions.
 * Provider should be configured for the project, i.e. TerraformProjectV3ConfigurationInput,
 * When the project has a provider configured, these action parameters will be rejected.
 *
 * This input is deprecated, and will not be supported for executing Plan actions in the v1 API.
 */
export type TerraformPlanActionParameters = {
  /** Zeet ID for a connected AWS Account */
  awsAccountID?: InputMaybe<Scalars['UUID']>;
  /** Zeet ID for a connected DigitalOcean Account */
  doAccountID?: InputMaybe<Scalars['UUID']>;
  /** Zeet ID for a connected GCP Account */
  gcpAccountID?: InputMaybe<Scalars['UUID']>;
  /** Region name, when applicable */
  region?: InputMaybe<Scalars['String']>;
};

/**
 * [DEPRECATED] Input values for Terraform PLAN_DESTROY actions.
 * Provider should be configured for the project, i.e. TerraformProjectV3ConfigurationInput,
 * When the project has a provider configured, these action parameters will be rejected.
 *
 * This input is deprecated, and will not be supported for executing Plan actions in the v1 API.
 */
export type TerraformPlanDestroyActionParameters = {
  /** Zeet ID for a connected AWS Account */
  awsAccountID?: InputMaybe<Scalars['UUID']>;
  /** Zeet ID for a connected DigitalOcean Account */
  doAccountID?: InputMaybe<Scalars['UUID']>;
  /** Zeet ID for a connected GCP Account */
  gcpAccountID?: InputMaybe<Scalars['UUID']>;
  /** Region name, when applicable */
  region?: InputMaybe<Scalars['String']>;
};

export type TerraformProjectV3Configuration = {
  __typename?: 'TerraformProjectV3Configuration';
  moduleName?: Maybe<Scalars['String']>;
  provider?: Maybe<TerraformProvider>;
  stateBackend: TerraformStateBackend;
};

export type TerraformProjectV3ConfigurationInput = {
  moduleName?: InputMaybe<Scalars['String']>;
  /**
   * Terraform Provider configuration: Maps a zeet-connected cloud account to a terraform provider.
   * This parameter is optional for backwards compatibility. New Projects should specify their provider at creation,
   * instead of specifying the provider for each PLAN/PLAN_DESTROY action.
   *
   * This parameter will be required in the v1 API, and specifying provider "per-plan" will not be supported.
   */
  provider?: InputMaybe<TerraformProviderInput>;
  stateBackend: TerraformStateBackendInput;
};

/** The Zeet-connected cloud account which will be mapped to a terraform provider */
export type TerraformProvider = {
  __typename?: 'TerraformProvider';
  awsAccount?: Maybe<AwsAccount>;
  doAccount?: Maybe<DoAccount>;
  gcpAccount?: Maybe<GcpAccount>;
  linodeAccount?: Maybe<LinodeAccount>;
  /** Region name, when applicable */
  region?: Maybe<Scalars['String']>;
};

export type TerraformProviderInput = {
  /** Zeet ID for a connected AWS Account */
  awsAccountID?: InputMaybe<Scalars['UUID']>;
  /** Zeet ID for a connected DigitalOcean Account */
  doAccountID?: InputMaybe<Scalars['UUID']>;
  /** Zeet ID for a connected GCP Account */
  gcpAccountID?: InputMaybe<Scalars['UUID']>;
  /** Zeet ID for a connected Linode Account */
  linodeAccountID?: InputMaybe<Scalars['UUID']>;
  /** Region name, when applicable */
  region?: InputMaybe<Scalars['String']>;
};

export type TerraformRegistry = {
  __typename?: 'TerraformRegistry';
  id: Scalars['ID'];
  module: TerraformModule;
  url?: Maybe<Scalars['URL']>;
};


export type TerraformRegistryModuleArgs = {
  id: Scalars['ID'];
};

export type TerraformRegistrySource = {
  __typename?: 'TerraformRegistrySource';
  source: Scalars['String'];
  version?: Maybe<Scalars['String']>;
};

export type TerraformRegistrySourceInput = {
  source: Scalars['String'];
  version?: InputMaybe<Scalars['String']>;
};

export type TerraformStateBackend = {
  __typename?: 'TerraformStateBackend';
  /** DEPRECATED. */
  awsAccount?: Maybe<Scalars['UUID']>;
  /** DEPRECATED. */
  gcpAccount?: Maybe<Scalars['UUID']>;
  gcsBucket?: Maybe<GcsBucketConfiguration>;
  linodeBucket?: Maybe<LinodeBucketConfiguration>;
  /** DEPRECATED. */
  region?: Maybe<Scalars['String']>;
  s3Bucket?: Maybe<S3BucketConfiguration>;
};

export type TerraformStateBackendInput = {
  gcsBucket?: InputMaybe<GcsBucketBackendInput>;
  linodeBucket?: InputMaybe<LinodeBucketBackendInput>;
  s3Bucket?: InputMaybe<S3BucketBackendInput>;
};

export enum TimeFilter {
  Daily = 'Daily',
  Monthly = 'Monthly'
}

export type TimePeriod = {
  __typename?: 'TimePeriod';
  endAt: Scalars['Time'];
  startAt: Scalars['Time'];
};

export type TransferProjectInput = {
  id: Scalars['ID'];
  to: Scalars['ID'];
};

/** A minimal representation of some error state, and some possible triage, when available. */
export type Troubleshooting = {
  __typename?: 'Troubleshooting';
  /** The headline issue currently outstanding for this troubleshooting's parent object. */
  issue?: Maybe<TroubleshootingIssue>;
};

export type TroubleshootingIssue = {
  __typename?: 'TroubleshootingIssue';
  /** Zero or more blocks representing either evidence of an issue or corresponding user instructions */
  blocks?: Maybe<Array<TroubleshootingIssueBlock>>;
  issueCode?: Maybe<Scalars['String']>;
};

export type TroubleshootingIssueBlock = {
  __typename?: 'TroubleshootingIssueBlock';
  blockType?: Maybe<TroubleshootingIssueBlockType>;
  content?: Maybe<Scalars['String']>;
};

export enum TroubleshootingIssueBlockType {
  Evidence = 'EVIDENCE',
  Instruction = 'INSTRUCTION'
}

export type UpdateAwsAccountInput = {
  id: Scalars['UUID'];
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateAzureAccountInput = {
  clientID?: InputMaybe<Scalars['String']>;
  clientSecret?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  name?: InputMaybe<Scalars['String']>;
  subscriptionID?: InputMaybe<Scalars['String']>;
  tenantID?: InputMaybe<Scalars['String']>;
};

export type UpdateBitbucketIntegrationInput = {
  accessToken?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  name?: InputMaybe<Scalars['String']>;
  userID: Scalars['UUID'];
};

export type UpdateBlueprintInput = {
  configuration?: InputMaybe<BlueprintConfigurationUpdate>;
  connectorSchema?: InputMaybe<ProjectConnectorSchema>;
  description?: InputMaybe<Scalars['String']>;
  displayName?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  outputSchema?: InputMaybe<BlueprintOutputSchema>;
  published?: InputMaybe<Scalars['Boolean']>;
  richInputSchema?: InputMaybe<Scalars['JSON']>;
  slug?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  /**
   * Update the variables. Supports partial updates: only specify the variables that you wish to update.
   * To modify or remove an existing variable, you must specify the variable's ID.
   *
   * If ID is not present, the variable will be created (and the "remove" field will be ignored).
   */
  variables?: InputMaybe<Array<BlueprintVariableSpecUpdate>>;
};

export type UpdateBranchInput = {
  build?: InputMaybe<Scalars['Boolean']>;
  deploy?: InputMaybe<Scalars['Boolean']>;
  gitRef?: InputMaybe<Scalars['String']>;
  githubSha?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  image?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  repoID?: InputMaybe<Scalars['UUID']>;
};

export type UpdateCdnInput = {
  domains?: InputMaybe<Array<Scalars['String']>>;
  id: Scalars['UUID'];
};

export type UpdateClusterAddOn = {
  helmValues?: InputMaybe<Scalars['YAML']>;
  slug: Scalars['String'];
  state: ClusterAddOnState;
};

export type UpdateClusterDomainInput = {
  clusterID: Scalars['UUID'];
  domain: Scalars['String'];
};

export type UpdateClusterInput = {
  /**
   * The new configuration for cluster add-ons. When this field is provided (i.e. not-null), it must include
   * _all_ cluster add-ons present in `Cluster.addOns`, even if some of the add-ons are not being modified.
   *
   * This is because once an add-on is added to a cluster, it cannot be _removed_, only _disabled_.
   */
  addOns?: InputMaybe<Array<UpdateClusterAddOn>>;
  containerCacheRepository?: InputMaybe<Scalars['String']>;
  containerRegistryID?: InputMaybe<Scalars['UUID']>;
  containerRepository?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  kubeconfig?: InputMaybe<Scalars['Upload']>;
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateCoreWeaveAccountInput = {
  id: Scalars['UUID'];
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateDoAccountInput = {
  accessToken?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateGcpAccountInput = {
  id: Scalars['UUID'];
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateGitlabIntegrationInput = {
  accessToken: Scalars['String'];
  apiUrl?: InputMaybe<Scalars['URL']>;
  id: Scalars['UUID'];
  name?: InputMaybe<Scalars['String']>;
  userID: Scalars['UUID'];
};

export type UpdateIpfsServiceInput = {
  accessToken?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

export type UpdateLinodeAccountInput = {
  accessToken?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateMarketplaceBlueprintInput = {
  blueprintID: Scalars['UUID'];
  enabled?: InputMaybe<Scalars['Boolean']>;
  userID: Scalars['UUID'];
};

export type UpdateProjectDangerInput = {
  appID?: InputMaybe<Scalars['String']>;
  defaultIngressDomain?: InputMaybe<Scalars['String']>;
  deployTarget?: InputMaybe<ProjectDeployInput>;
  /** - v0.RepoID */
  id: Scalars['UUID'];
  namespace?: InputMaybe<Scalars['String']>;
  useHumanReadableKubernetesName?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateProjectEnvironmentInput = {
  envs?: InputMaybe<Array<EnvVarInput>>;
  id: Scalars['UUID'];
  name?: InputMaybe<Scalars['String']>;
  redeployRepoIDs?: InputMaybe<Array<Scalars['UUID']>>;
};

export type UpdateProjectInput = {
  alternativeImageTagTemplates?: InputMaybe<Array<Scalars['String']>>;
  autoRetry?: InputMaybe<Scalars['Boolean']>;
  autoRollback?: InputMaybe<Scalars['Boolean']>;
  autoscaling?: InputMaybe<AutoscalingInput>;
  awsIamRole?: InputMaybe<Scalars['String']>;
  branchIgnore?: InputMaybe<Scalars['String']>;
  branchResources?: InputMaybe<ContainerResourcesSpecInput>;
  buildCPU?: InputMaybe<Scalars['Float']>;
  buildCommand?: InputMaybe<Scalars['String']>;
  buildMemory?: InputMaybe<Scalars['Float']>;
  buildResources?: InputMaybe<ContainerResourcesSpecInput>;
  buildType?: InputMaybe<Scalars['String']>;
  clusterIssuerName?: InputMaybe<Scalars['String']>;
  containerCacheRepository?: InputMaybe<Scalars['String']>;
  containerRegistryID?: InputMaybe<Scalars['UUID']>;
  containerRepository?: InputMaybe<Scalars['String']>;
  cpu?: InputMaybe<Scalars['String']>;
  cronJobSchedule?: InputMaybe<Scalars['String']>;
  datadogApmEnabled?: InputMaybe<Scalars['Boolean']>;
  dedicated?: InputMaybe<Scalars['Boolean']>;
  deployBranch?: InputMaybe<Scalars['Boolean']>;
  deployJob?: InputMaybe<Scalars['Boolean']>;
  deployService?: InputMaybe<Scalars['Boolean']>;
  deployStrategy?: InputMaybe<DeployStrategy>;
  deployTarget?: InputMaybe<ProjectDeployInput>;
  deployTimeoutSeconds?: InputMaybe<Scalars['Int']>;
  dockerImage?: InputMaybe<Scalars['String']>;
  dockerfilePath?: InputMaybe<Scalars['String']>;
  dockerfileText?: InputMaybe<Scalars['String']>;
  ephemeralStorage?: InputMaybe<Scalars['Float']>;
  gcpServiceAccount?: InputMaybe<Scalars['String']>;
  gitSubmodules?: InputMaybe<GitSubmodulesType>;
  githubInstallationID?: InputMaybe<Scalars['String']>;
  githubIntegration?: InputMaybe<GitHubRepoIntegrationInput>;
  githubRepository?: InputMaybe<Scalars['String']>;
  gitlabIntegration?: InputMaybe<GitlabRepoIntegrationInput>;
  golangVersion?: InputMaybe<Scalars['String']>;
  gpu?: InputMaybe<GpuInput>;
  helmValues?: InputMaybe<Scalars['String']>;
  helmVersion?: InputMaybe<Scalars['String']>;
  hostNetwork?: InputMaybe<Scalars['Boolean']>;
  iamPolicies?: InputMaybe<Array<Scalars['String']>>;
  /** - v0.RepoID */
  id: Scalars['ID'];
  kanikoFlags?: InputMaybe<KanikoFlagsInput>;
  kubernetesCustomization?: InputMaybe<KubernetesCustomizationInput>;
  livenessProbe?: InputMaybe<ProbeInput>;
  logShipper?: InputMaybe<LogShipperInput>;
  manifest?: InputMaybe<ResourceKubernetesManifestInput>;
  manifestValue?: InputMaybe<Scalars['String']>;
  manifests?: InputMaybe<Array<Scalars['String']>>;
  manualDeploy?: InputMaybe<Scalars['Boolean']>;
  memory?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  noBuildCache?: InputMaybe<Scalars['Boolean']>;
  nodeSelector?: InputMaybe<Scalars['JSON']>;
  nodejsVersion?: InputMaybe<Scalars['String']>;
  path?: InputMaybe<Scalars['String']>;
  pipelineClusterID?: InputMaybe<Scalars['UUID']>;
  ports?: InputMaybe<Scalars['JSON']>;
  preStopSleep?: InputMaybe<Scalars['Int']>;
  productionBranch?: InputMaybe<Scalars['String']>;
  prometheusScrape?: InputMaybe<PrometheusScrapeInput>;
  pythonVersion?: InputMaybe<Scalars['String']>;
  readinessProbe?: InputMaybe<ProbeInput>;
  releaseCommand?: InputMaybe<Scalars['String']>;
  replication?: InputMaybe<Array<ReplicationInput>>;
  resources?: InputMaybe<ContainerResourcesSpecInput>;
  runCommand?: InputMaybe<Scalars['String']>;
  secretMounts?: InputMaybe<Array<KubernetesSecretMountInput>>;
  serverlessResources?: InputMaybe<ServerlessResourcesSpecInput>;
  startupProbe?: InputMaybe<ProbeInput>;
  staticIP?: InputMaybe<Scalars['Boolean']>;
  staticPath?: InputMaybe<Scalars['String']>;
  terminationGracePeriodSeconds?: InputMaybe<Scalars['Int']>;
  terraformSource?: InputMaybe<Scalars['String']>;
  terraformVariables?: InputMaybe<Scalars['String']>;
  terraformVersion?: InputMaybe<Scalars['String']>;
  tpu?: InputMaybe<TpuInput>;
  volumes?: InputMaybe<Scalars['JSON']>;
  workingDirectory?: InputMaybe<Scalars['String']>;
};

export type UpdateProjectV2Input = {
  /** Update the autoCleanupEnabled attribute. When null, no change is made. */
  autoCleanupEnabled?: InputMaybe<Scalars['Boolean']>;
  envs?: InputMaybe<Array<EnvVarInput>>;
  id: Scalars['UUID'];
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateProjectV3Input = {
  /**
   * Blueprint configuration overrides to apply to the project, or the configuration if this project is based on
   * a sourceless blueprint. If set to null, the configuration will be cleared. If omitted, no changes occur.
   * Otherwise, a partial PATCH update will be performed.
   */
  blueprintConfiguration?: InputMaybe<BlueprintConfigurationInput>;
  /** - v0.EnvironmentID or v1.SubGroupID */
  environmentID?: InputMaybe<Scalars['UUID']>;
  helmConfiguration?: InputMaybe<HelmProjectV3ConfigurationInput>;
  manifestConfiguration?: InputMaybe<ManifestProjectV3ConfigurationInput>;
  name?: InputMaybe<Scalars['String']>;
  /** Override the output schema for this project. */
  outputSchema?: InputMaybe<BlueprintOutputSchema>;
  /** - v0.ProjectID or v1.GroupID */
  projectID?: InputMaybe<Scalars['UUID']>;
  requirePlanApproval?: InputMaybe<Scalars['Boolean']>;
  terraformConfiguration?: InputMaybe<TerraformProjectV3ConfigurationInput>;
  variables?: InputMaybe<Array<BlueprintVariableInput>>;
};

/** Defines the input parameters required to update an existing custom domain configuration for a repository. */
export type UpdateRepoCustomDomainInput = {
  /**
   * Optional. Updates the challenge type used by the certificate manager for verifying domain ownership and issuing SSL certificates.
   * This can affect how domain verification is performed, with options like 'dns01' and 'http01'.
   */
  certManagerChallengerType?: InputMaybe<CertManagerChallengeType>;
  /**
   * Optional. Specifies whether to disable the automatic SSL certificate management for this domain.
   * Useful when handling certificates through external mechanisms or different processes.
   */
  disableCertManager?: InputMaybe<Scalars['Boolean']>;
  /** The unique identifier of the custom domain configuration to be updated. */
  id: Scalars['UUID'];
  /** Optional. The target external port to be used for the custom domain. If not provided, the first https port will be used. */
  servicePort?: InputMaybe<Scalars['Int']>;
  /**
   * Optional. The unique identifier of another custom domain certificate that this new domain should sync with.
   * This removes the need to manage certificates separately, ensuring consistent configurations across multiple domains.
   */
  syncDomainID?: InputMaybe<Scalars['UUID']>;
};

export type UpdateRepoPipelineLinkInput = {
  /** - v0.RepoID */
  id: Scalars['UUID'];
  sourceEvent?: InputMaybe<RepoEvent>;
  targetAction?: InputMaybe<RepoAction>;
  /** - v0.EnvironmentID or v1.SubGroupID */
  targetEnvironmentID?: InputMaybe<Scalars['UUID']>;
  targetRepoID?: InputMaybe<Scalars['UUID']>;
};

export type UpdateResourceAlphaInput = {
  source?: InputMaybe<SourceInput>;
};

export type UpdateTeamInput = {
  id: Scalars['UUID'];
  paymentMethod?: InputMaybe<Scalars['String']>;
  plan?: InputMaybe<UpdateTeamPlanInput>;
};

export type UpdateTeamMemberRoleInput = {
  id: Scalars['UUID'];
  role: TeamMemberRole;
};

export type UpdateTeamPlanInput = {
  billingPeriod: PlanBillingPeriod;
  tier: PlanTier;
};

export type UpdateUserInput = {
  avatar?: InputMaybe<Scalars['URL']>;
  email?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  login?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateVultrAccountInput = {
  id: Scalars['UUID'];
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateWebhookIntegrationInput = {
  id: Scalars['UUID'];
  url: Scalars['String'];
  userID: Scalars['UUID'];
};

/** If a self-service link is available, url will be non-null. If url is null, notAllowed should be non-null. */
export type UrlOrContactUs = {
  __typename?: 'UrlOrContactUs';
  /** If no self-service link is available, please get in touch with us via this URL. */
  contactUrl: Scalars['URL'];
  /** @deprecated Use notAllowed instead. */
  contactUs?: Maybe<ContactUs>;
  /** True if url is a self-service link, false if url is the contact url. */
  hasUrl: Scalars['Boolean'];
  notAllowed?: Maybe<BillingActionNotAllowed>;
  /** When applicable, some help text explaining why a url is or is not available. */
  tooltip?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['URL']>;
};

/** A usage indicator */
export type Usage = {
  __typename?: 'Usage';
  /** When the query is not for a specific user, currentUsage will be null */
  currentUsage?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  /** A header display name */
  displayName: Scalars['String'];
  /** Null indicates unlimited usage allowed */
  maximumUsage?: Maybe<Scalars['Int']>;
  unit: Scalars['String'];
  unitPlural: Scalars['String'];
};

export type User = ProfileOwner & ProjectOwner & {
  __typename?: 'User';
  advanced?: Maybe<Scalars['Boolean']>;
  apiKeys?: Maybe<Array<ApiKey>>;
  avatar?: Maybe<Scalars['URL']>;
  awsAccount?: Maybe<AwsAccount>;
  awsAccounts?: Maybe<Array<AwsAccount>>;
  azureAccount?: Maybe<AzureAccount>;
  azureAccounts?: Maybe<Array<AzureAccount>>;
  billingEmail?: Maybe<Scalars['String']>;
  /** Billing Overview only exists for users with subscriptions, i.e. a team */
  billingOverview?: Maybe<BillingOverview>;
  billingURL?: Maybe<Scalars['String']>;
  blueprint?: Maybe<Blueprint>;
  blueprintDriverWorkflow?: Maybe<BlueprintDriverWorkflow>;
  blueprints?: Maybe<BlueprintConnection>;
  canDeploy?: Maybe<Scalars['Boolean']>;
  checkProjectName: Scalars['Boolean'];
  cloudAccount?: Maybe<CloudAccount>;
  cluster?: Maybe<Cluster>;
  clusters?: Maybe<Array<Cluster>>;
  containerRegistries?: Maybe<Array<ContainerRegistry>>;
  coreweaveAccount?: Maybe<CoreWeaveAccount>;
  coreweaveAccounts?: Maybe<Array<CoreWeaveAccount>>;
  createdAt?: Maybe<Scalars['Time']>;
  crispAuth?: Maybe<CrispAuth>;
  defaultCluster?: Maybe<Cluster>;
  deployment?: Maybe<Deployment>;
  doAccount?: Maybe<DoAccount>;
  doAccounts?: Maybe<Array<DoAccount>>;
  dockerRepository?: Maybe<DockerRepository>;
  email?: Maybe<Scalars['String']>;
  eventIntegrations?: Maybe<Array<EventIntegration>>;
  fixCloud: Scalars['Boolean'];
  freeLimitExceeded?: Maybe<Scalars['Boolean']>;
  freeQuota?: Maybe<Scalars['Int']>;
  freeTrialEndsAt?: Maybe<Scalars['Time']>;
  gcpAccount?: Maybe<GcpAccount>;
  gcpAccounts?: Maybe<Array<GcpAccount>>;
  githubInstallations?: Maybe<Array<GitHubInstallation>>;
  githubRepositories?: Maybe<Array<GitHubRepository>>;
  githubRepository?: Maybe<GitHubRepository>;
  hasOnboarded?: Maybe<Scalars['Boolean']>;
  hasPaymentMethod?: Maybe<Scalars['Boolean']>;
  hasZeetCloud?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  integrations?: Maybe<Array<Integration>>;
  ipfsServices?: Maybe<Array<IpfsService>>;
  isTeam?: Maybe<Scalars['Boolean']>;
  jobRun: JobRun;
  linodeAccount?: Maybe<LinodeAccount>;
  linodeAccounts?: Maybe<Array<LinodeAccount>>;
  login: Scalars['Login'];
  name: Scalars['String'];
  /** @deprecated no longer supported: use User.billingOverview.externalLinks instead */
  needsPaymentMethod?: Maybe<Scalars['Boolean']>;
  /** Global settings for notification integrations. These settings may be overriden per-integration. */
  notificationIntegrationSettings?: Maybe<NotificationIntegrationSettings>;
  paymentAuthorizationError?: Maybe<Scalars['String']>;
  /** @deprecated no longer used */
  paymentError?: Maybe<Scalars['String']>;
  permissions?: Maybe<UserPermissionsConnection>;
  projectV3?: Maybe<ProjectV3>;
  projectV3Adapters?: Maybe<ProjectV3AdapterConnection>;
  projectV3DriverActionExecutions?: Maybe<BlueprintDriverActionExecutionConnection>;
  projectV3s?: Maybe<ProjectV3Connection>;
  projects: ProjectConnection;
  repo?: Maybe<Repo>;
  repos?: Maybe<Array<Repo>>;
  stripe?: Maybe<StripeUser>;
  suggestProjectName: Scalars['String'];
  suggestTemplateName: Scalars['String'];
  team?: Maybe<Team>;
  teams?: Maybe<Array<UserTeamEdge>>;
  validateCloud: ClusterValidation;
  vultrAccount?: Maybe<VultrAccount>;
  vultrAccounts?: Maybe<Array<VultrAccount>>;
};


export type UserAwsAccountArgs = {
  id: Scalars['UUID'];
};


export type UserAzureAccountArgs = {
  id: Scalars['UUID'];
};


export type UserBlueprintArgs = {
  id: Scalars['UUID'];
};


export type UserBlueprintDriverWorkflowArgs = {
  id: Scalars['UUID'];
};


export type UserBlueprintsArgs = {
  page?: InputMaybe<PageInput>;
};


export type UserCheckProjectNameArgs = {
  input: CheckProjectNameInput;
};


export type UserCloudAccountArgs = {
  id: Scalars['ID'];
};


export type UserClusterArgs = {
  id: Scalars['UUID'];
};


export type UserCoreweaveAccountArgs = {
  id: Scalars['UUID'];
};


export type UserDeploymentArgs = {
  id: Scalars['ID'];
};


export type UserDoAccountArgs = {
  id: Scalars['UUID'];
};


export type UserDockerRepositoryArgs = {
  image: Scalars['String'];
};


export type UserFixCloudArgs = {
  context: ClusterValidationInput;
  errorType: ClusterValidationErrorType;
};


export type UserGcpAccountArgs = {
  id: Scalars['UUID'];
};


export type UserGithubRepositoriesArgs = {
  installationID: Scalars['ID'];
};


export type UserGithubRepositoryArgs = {
  installationID: Scalars['ID'];
  owner: Scalars['String'];
  repo: Scalars['String'];
};


export type UserJobRunArgs = {
  id: Scalars['UUID'];
};


export type UserLinodeAccountArgs = {
  id: Scalars['UUID'];
};


export type UserProjectV3Args = {
  id: Scalars['UUID'];
};


export type UserProjectV3AdaptersArgs = {
  filter: FilterInput;
};


export type UserProjectV3DriverActionExecutionsArgs = {
  filter: FilterInput;
};


export type UserProjectV3sArgs = {
  filter: FilterInput;
};


export type UserProjectsArgs = {
  input?: InputMaybe<ProjectsInput>;
};


export type UserRepoArgs = {
  id: Scalars['ID'];
};


export type UserReposArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  input?: InputMaybe<ReposInput>;
};


export type UserSuggestProjectNameArgs = {
  input: SuggestProjectNameInput;
};


export type UserSuggestTemplateNameArgs = {
  input: SuggestTemplateNameInput;
};


export type UserTeamArgs = {
  id: Scalars['ID'];
};


export type UserValidateCloudArgs = {
  context: ClusterValidationInput;
};


export type UserVultrAccountArgs = {
  id: Scalars['UUID'];
};

export enum UserAction {
  EditBilling = 'EDIT_BILLING',
  ReadPrivate = 'READ_PRIVATE'
}

export type UserAuth = {
  __typename?: 'UserAuth';
  authToken: Scalars['String'];
};

export type UserFilter = {
  ids?: InputMaybe<MultiEntityCriterion>;
};

export type UserIamConnection = {
  __typename?: 'UserIamConnection';
  awsAccountId: Scalars['String'];
  awsIamArn: Scalars['String'];
  id: Scalars['UUID'];
  userId: Scalars['String'];
};

export type UserPermissionsConnection = {
  __typename?: 'UserPermissionsConnection';
  principal?: Maybe<User>;
  user?: Maybe<UserPermissionsUserConnection>;
};


export type UserPermissionsConnectionUserArgs = {
  userID: Scalars['UUID'];
};

export type UserPermissionsUserConnection = {
  __typename?: 'UserPermissionsUserConnection';
  mutations: Array<Scalars['PermissibleMutation']>;
  user?: Maybe<User>;
};

export type UserTeamEdge = {
  __typename?: 'UserTeamEdge';
  id: Scalars['UUID'];
  role: TeamMemberRole;
  team: Team;
  user: User;
};

export enum VariableType {
  Boolean = 'BOOLEAN',
  Float = 'FLOAT',
  Integer = 'INTEGER',
  String = 'STRING'
}

export type Volume = {
  __typename?: 'Volume';
  id: Scalars['ID'];
  spec: VolumeSpec;
};

export type VolumeInput = {
  mountPath: Scalars['String'];
  size: Scalars['Int'];
};

export type VolumeSpec = {
  __typename?: 'VolumeSpec';
  mountPath: Scalars['String'];
  size: Scalars['Int'];
};

export type VultrAccount = {
  __typename?: 'VultrAccount';
  accessToken?: Maybe<Scalars['String']>;
  clusters?: Maybe<Array<Cluster>>;
  connected?: Maybe<Scalars['Boolean']>;
  connectedV2?: Maybe<CloudConnectionInfo>;
  createdAt: Scalars['Time'];
  id: Scalars['UUID'];
  name: Scalars['String'];
  networks?: Maybe<Array<Network>>;
  projectV3Adapters?: Maybe<ProjectV3AdapterConnection>;
  projects?: Maybe<ProjectConnection>;
  state: CloudAccountState;
  updatedAt: Scalars['Time'];
};


export type VultrAccountProjectsArgs = {
  input?: InputMaybe<ProjectsInput>;
};

export type Web3Challenge = {
  __typename?: 'Web3Challenge';
  address: Scalars['String'];
  id: Scalars['UUID'];
  nonce: Scalars['String'];
};

export type ZeetError = {
  errorCode?: Maybe<Scalars['String']>;
  errorID?: Maybe<Scalars['String']>;
  message: Scalars['String'];
};

export type AwsPolicyJsonInput = {
  arn?: InputMaybe<Scalars['String']>;
  policyName?: InputMaybe<Scalars['String']>;
  username?: InputMaybe<Scalars['String']>;
};

export type DispatchRepoGroupActionInput = {
  action: RepoActionInput;
  groupID?: InputMaybe<Scalars['UUID']>;
  selector?: InputMaybe<LabelSelectorsInput>;
};

export type RepoFilterInput = {
  deploymentStatus?: InputMaybe<Array<InputMaybe<DeploymentStatus>>>;
};

export type UpdateDatabaseLinkInput = {
  envPrefix?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

export type UserPublicCommonFragment = { __typename?: 'User', id: string, name: string, login: any, avatar?: string | null, isTeam?: boolean | null };

export type UserCommonFragment = { __typename?: 'User', id: string, email?: string | null, createdAt?: Date | null, freeTrialEndsAt?: Date | null, hasPaymentMethod?: boolean | null, paymentError?: string | null, paymentAuthorizationError?: string | null, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null };

export type RepoBasicFragment = { __typename?: 'Repo', id: string, path: string, enabled: boolean, image?: string | null, name: string, owner: { __typename?: 'User', id: string, login: any }, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, owner: { __typename?: 'User', id: string, login: any } } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null };

export type RepoCommonFragment = { __typename?: 'Repo', id: string, path: string, enabled: boolean, productionBranch?: string | null, deployTarget?: DeployTarget | null, deployType?: DeployType | null, deployService?: boolean | null, deployJob?: boolean | null, image?: string | null, cpu?: string | null, memory?: string | null, updatedAt: Date, disableReason?: DisableReason | null, databaseProvider?: DatabaseProviderType | null, databaseEngine?: DatabaseEngineType | null, name: string, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, projectID?: string | null } | null, gpu?: { __typename?: 'GPUSpec', type?: string | null, count: number } | null, tpu?: { __typename?: 'TPUSpec', tfVersion: string, type: string, cores: number } | null, cluster?: { __typename?: 'Cluster', id: string, name: string, domain?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null } | null, autoscaling?: { __typename?: 'Autoscaling', minReplicas: number, maxReplicas: number } | null, owner: { __typename?: 'User', id: string, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, owner: { __typename?: 'User', id: string, login: any } } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null };

export type RepoListItemFragment = { __typename?: 'Repo', id: string, path: string, enabled: boolean, productionBranch?: string | null, deployTarget?: DeployTarget | null, deployType?: DeployType | null, deployService?: boolean | null, deployJob?: boolean | null, image?: string | null, cpu?: string | null, memory?: string | null, updatedAt: Date, disableReason?: DisableReason | null, databaseProvider?: DatabaseProviderType | null, databaseEngine?: DatabaseEngineType | null, name: string, productionDeployment?: { __typename?: 'Deployment', id: string, description?: string | null, version: string, status: DeploymentStatus, branch?: string | null, endpoints?: Array<string> | null, privateEndpoint?: string | null, errorMessage?: string | null, updatedAt: Date, createdAt: Date, deployStatus?: { __typename?: 'DeployStatus', active: boolean, replicas: number, publicIPs?: Array<string> | null, state: string, errorMessage?: string | null, troubleshooting?: { __typename?: 'Troubleshooting', issue?: { __typename?: 'TroubleshootingIssue', blocks?: Array<{ __typename?: 'TroubleshootingIssueBlock', blockType?: TroubleshootingIssueBlockType | null, content?: string | null }> | null } | null } | null } | null, build?: { __typename?: 'Build', id: string, image?: string | null } | null, alternativeImages?: Array<{ __typename?: 'AlternativeImage', reference?: string | null, tag?: string | null, name?: string | null }> | null } | null, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, projectID?: string | null } | null, gpu?: { __typename?: 'GPUSpec', type?: string | null, count: number } | null, tpu?: { __typename?: 'TPUSpec', tfVersion: string, type: string, cores: number } | null, cluster?: { __typename?: 'Cluster', id: string, name: string, domain?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null } | null, autoscaling?: { __typename?: 'Autoscaling', minReplicas: number, maxReplicas: number } | null, owner: { __typename?: 'User', id: string, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, owner: { __typename?: 'User', id: string, login: any } } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null };

export type DeploymentCommonFragment = { __typename?: 'Deployment', id: string, description?: string | null, version: string, status: DeploymentStatus, branch?: string | null, endpoints?: Array<string> | null, privateEndpoint?: string | null, errorMessage?: string | null, updatedAt: Date, createdAt: Date, deployStatus?: { __typename?: 'DeployStatus', active: boolean, replicas: number, publicIPs?: Array<string> | null, state: string, errorMessage?: string | null, troubleshooting?: { __typename?: 'Troubleshooting', issue?: { __typename?: 'TroubleshootingIssue', blocks?: Array<{ __typename?: 'TroubleshootingIssueBlock', blockType?: TroubleshootingIssueBlockType | null, content?: string | null }> | null } | null } | null } | null, build?: { __typename?: 'Build', id: string, image?: string | null } | null, alternativeImages?: Array<{ __typename?: 'AlternativeImage', reference?: string | null, tag?: string | null, name?: string | null }> | null };

export type DeploymentDetailFragment = { __typename?: 'Deployment', branch?: string | null, createdAt: Date, updatedAt: Date, id: string, description?: string | null, version: string, status: DeploymentStatus, endpoints?: Array<string> | null, privateEndpoint?: string | null, errorMessage?: string | null, buildStage?: { __typename?: 'BuildStage', id: string } | null, releaseStage?: { __typename?: 'PipelineStage', id: string } | null, deployStage?: { __typename?: 'PipelineStage', id: string } | null, repo?: { __typename?: 'Repo', id: string, path: string, enabled: boolean, productionBranch?: string | null, deployTarget?: DeployTarget | null, deployType?: DeployType | null, deployService?: boolean | null, deployJob?: boolean | null, image?: string | null, cpu?: string | null, memory?: string | null, updatedAt: Date, disableReason?: DisableReason | null, databaseProvider?: DatabaseProviderType | null, databaseEngine?: DatabaseEngineType | null, name: string, ports?: Array<{ __typename?: 'Port', https: boolean, public: boolean }> | null, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, projectID?: string | null } | null, gpu?: { __typename?: 'GPUSpec', type?: string | null, count: number } | null, tpu?: { __typename?: 'TPUSpec', tfVersion: string, type: string, cores: number } | null, cluster?: { __typename?: 'Cluster', id: string, name: string, domain?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null } | null, autoscaling?: { __typename?: 'Autoscaling', minReplicas: number, maxReplicas: number } | null, owner: { __typename?: 'User', id: string, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, owner: { __typename?: 'User', id: string, login: any } } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null } | null, awsLinks?: { __typename?: 'AWSLinks', rds?: string | null, cloudformation?: string | null, lambda?: string | null, apiGateway?: string | null, cloudwatchLogs?: string | null, cloudwatchMetrics?: string | null } | null, gcpLinks?: { __typename?: 'GCPLinks', deploymentManager?: string | null, cloudRun?: string | null, cloudFunctions?: string | null, cloudFunctionsTrigger?: string | null, cloudLogging?: string | null, cloudMonitoring?: string | null } | null, deploymentError?: { __typename?: 'DeploymentError', errorID?: string | null, errorCode?: string | null, message: string } | null, deployStatus?: { __typename?: 'DeployStatus', active: boolean, replicas: number, publicIPs?: Array<string> | null, state: string, errorMessage?: string | null, troubleshooting?: { __typename?: 'Troubleshooting', issue?: { __typename?: 'TroubleshootingIssue', blocks?: Array<{ __typename?: 'TroubleshootingIssueBlock', blockType?: TroubleshootingIssueBlockType | null, content?: string | null }> | null } | null } | null } | null, build?: { __typename?: 'Build', id: string, image?: string | null } | null, alternativeImages?: Array<{ __typename?: 'AlternativeImage', reference?: string | null, tag?: string | null, name?: string | null }> | null };

export type ResourcesFragment = { __typename?: 'ContainerResourcesSpec', cpu?: number | null, memory?: number | null, ephemeralStorage?: number | null, spot?: boolean | null, accelerator?: { __typename?: 'AcceleratorSpec', type?: string | null, count?: number | null } | null };

export type ProbeDetailFragment = { __typename?: 'Probe', command?: string | null, initialDelaySeconds: number, periodSeconds: number, successThreshold: number, failureThreshold: number, timeoutSeconds: number, http?: { __typename?: 'HTTPProbe', host?: string | null, port: string, path?: string | null } | null, tcp?: { __typename?: 'TCPProbe', host?: string | null, port: string } | null };

export type LambdaLinksFragment = { __typename?: 'AWSLinks', cloudformation?: string | null, lambda?: string | null, apiGateway?: string | null, cloudwatchLogs?: string | null, cloudwatchMetrics?: string | null };

export type CloudFunctionsLinksFragment = { __typename?: 'GCPLinks', deploymentManager?: string | null, cloudRun?: string | null, cloudFunctions?: string | null, cloudFunctionsTrigger?: string | null, cloudLogging?: string | null, cloudMonitoring?: string | null };

export type RepoBuildFragment = { __typename?: 'Repo', noBuildCache?: boolean | null, gitSubmodules?: GitSubmodulesType | null, alternativeImageTagTemplates?: Array<string> | null, buildMethod?: { __typename?: 'BuildMethod', name: string, type: BuildType, workingDirectory?: string | null, dockerfilePath?: string | null, buildCommand?: string | null, staticPath?: string | null, runCommand?: string | null, releaseCommand?: string | null, nodejsVersion?: string | null, pythonVersion?: string | null, golangVersion?: string | null } | null, buildResources?: { __typename?: 'ContainerResourcesSpec', cpu?: number | null, memory?: number | null, ephemeralStorage?: number | null, spot?: boolean | null } | null, buildSpec?: { __typename?: 'ContainerSpec', cpu?: number | null, memory?: number | null } | null, kanikoFlags?: { __typename?: 'KanikoFlags', compressedCaching?: boolean | null } | null };

export type RepoDetailFragment = { __typename?: 'Repo', appID?: string | null, defaultIngressDomain?: string | null, kappID?: string | null, useHumanReadableKubernetesName?: boolean | null, namespace?: string | null, deployTarget?: DeployTarget | null, manualDeploy?: boolean | null, deployStrategy?: DeployStrategy | null, free?: boolean | null, cpu?: string | null, memory?: string | null, ephemeralStorage?: number | null, dedicated?: boolean | null, productionBranch?: string | null, serverlessRegion?: string | null, helmValues?: string | null, terraformVersion?: string | null, terraformVariables?: any | null, deployService?: boolean | null, deployJob?: boolean | null, preStopSleep?: number | null, terminationGracePeriodSeconds?: number | null, databaseProvider?: DatabaseProviderType | null, databaseEngine?: DatabaseEngineType | null, databaseVersion?: string | null, autoRetry?: boolean | null, autoRollback?: boolean | null, canDeploy?: boolean | null, awsIamRole?: string | null, gcpServiceAccount?: string | null, datadogApmEnabled?: boolean | null, deployTimeoutSeconds?: number | null, id: string, path: string, enabled: boolean, deployType?: DeployType | null, image?: string | null, updatedAt: Date, disableReason?: DisableReason | null, hostNetwork?: boolean | null, staticIP?: boolean | null, noBuildCache?: boolean | null, gitSubmodules?: GitSubmodulesType | null, alternativeImageTagTemplates?: Array<string> | null, name: string, secretMounts?: Array<{ __typename?: 'KubernetesSecretMount', secretName: string, mountPath: string, readOnly: boolean }> | null, kubernetesCustomization?: { __typename?: 'KubernetesCustomization', serviceAccountName?: string | null, podAnnotations?: any | null, serviceAnnotations?: any | null, ingressAnnotations?: any | null } | null, manifest?: { __typename?: 'Manifest', manifests?: Array<string> | null, manifestValue?: string | null, kustomizeDirs?: Array<string> | null } | null, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, environments: Array<{ __typename?: 'ProjectEnvironment', id: string, name: string }>, envs?: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string, visible: boolean, sealed: boolean, source?: { __typename?: 'EnvVarSource', type: EnvVarSourceType } | null }> | null, owner: { __typename?: 'User', id: string, login: any } } | null, productionDeployment?: { __typename?: 'Deployment', id: string, description?: string | null, version: string, status: DeploymentStatus, branch?: string | null, endpoints?: Array<string> | null, privateEndpoint?: string | null, errorMessage?: string | null, updatedAt: Date, createdAt: Date, awsLinks?: { __typename?: 'AWSLinks', rds?: string | null, cloudformation?: string | null, lambda?: string | null, apiGateway?: string | null, cloudwatchLogs?: string | null, cloudwatchMetrics?: string | null } | null, gcpLinks?: { __typename?: 'GCPLinks', deploymentManager?: string | null, cloudRun?: string | null, cloudFunctions?: string | null, cloudFunctionsTrigger?: string | null, cloudLogging?: string | null, cloudMonitoring?: string | null } | null, loadBalancers?: Array<{ __typename?: 'LoadBalancer', dns: Array<string>, ips: Array<string>, ports?: Array<number> | null }> | null, deployStatus?: { __typename?: 'DeployStatus', active: boolean, replicas: number, publicIPs?: Array<string> | null, state: string, errorMessage?: string | null, troubleshooting?: { __typename?: 'Troubleshooting', issue?: { __typename?: 'TroubleshootingIssue', blocks?: Array<{ __typename?: 'TroubleshootingIssueBlock', blockType?: TroubleshootingIssueBlockType | null, content?: string | null }> | null } | null } | null } | null, build?: { __typename?: 'Build', id: string, image?: string | null } | null, alternativeImages?: Array<{ __typename?: 'AlternativeImage', reference?: string | null, tag?: string | null, name?: string | null }> | null } | null, envs?: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string, visible: boolean, sealed: boolean, source?: { __typename?: 'EnvVarSource', type: EnvVarSourceType } | null }> | null, collaborators?: Array<{ __typename?: 'ProjectCollaborator', id: string, role: ProjectCollaboratorRole, user: { __typename?: 'User', id: string, name: string, login: any, avatar?: string | null, isTeam?: boolean | null } }> | null, volumes?: Array<{ __typename?: 'VolumeSpec', mountPath: string, size: number }> | null, replication?: Array<{ __typename?: 'Replication', region: string, replicas?: number | null, cluster?: { __typename?: 'Cluster', id: string, name: string, region?: string | null } | null }> | null, cluster?: { __typename?: 'Cluster', id: string, name: string, region?: string | null, ingressIP?: string | null, connected?: boolean | null, staticIPs?: Array<string> | null, cloudProvider?: CloudProvider | null, clusterProvider?: ClusterProvider | null, state: ClusterState, domain?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, projectID?: string | null } | null, logShipper?: { __typename?: 'LogShipper', type: LogShipperType, logz?: { __typename?: 'LogzIntegration', token: string, url?: string | null } | null, syslog?: { __typename?: 'SyslogIntegration', host: string, port: string, mode: string } | null, logDNA?: { __typename?: 'LogDNAIntegration', key: string } | null, datadog?: { __typename?: 'DatadogLogIntegration', key: string, host?: string | null } | null, betterstack?: { __typename?: 'BetterStackIntegration', token: string } | null } | null, readinessProbe?: { __typename?: 'Probe', command?: string | null, initialDelaySeconds: number, periodSeconds: number, successThreshold: number, failureThreshold: number, timeoutSeconds: number, http?: { __typename?: 'HTTPProbe', host?: string | null, port: string, path?: string | null } | null, tcp?: { __typename?: 'TCPProbe', host?: string | null, port: string } | null } | null, livenessProbe?: { __typename?: 'Probe', command?: string | null, initialDelaySeconds: number, periodSeconds: number, successThreshold: number, failureThreshold: number, timeoutSeconds: number, http?: { __typename?: 'HTTPProbe', host?: string | null, port: string, path?: string | null } | null, tcp?: { __typename?: 'TCPProbe', host?: string | null, port: string } | null } | null, startupProbe?: { __typename?: 'Probe', command?: string | null, initialDelaySeconds: number, periodSeconds: number, successThreshold: number, failureThreshold: number, timeoutSeconds: number, http?: { __typename?: 'HTTPProbe', host?: string | null, port: string, path?: string | null } | null, tcp?: { __typename?: 'TCPProbe', host?: string | null, port: string } | null } | null, gpu?: { __typename?: 'GPUSpec', type?: string | null, count: number } | null, tpu?: { __typename?: 'TPUSpec', type: string, cores: number, tfVersion: string } | null, githubIntegration?: { __typename?: 'GitHubRepoIntegration', id: string, autoDeployBranch: boolean, autoStopBranch: boolean, branchIgnore: string, branchStopIgnore: string, githubRepository?: { __typename?: 'GitHubRepository', id: string, owner: string, name: string } | null } | null, gitlabIntegration?: { __typename?: 'GitlabRepoIntegration', id: string, autoDeployBranch: boolean, autoStopBranch: boolean, branchIgnore: string, branchStopIgnore: string } | null, branchResources?: { __typename?: 'ContainerResourcesSpec', cpu?: number | null, memory?: number | null, ephemeralStorage?: number | null, spot?: boolean | null, accelerator?: { __typename?: 'AcceleratorSpec', type?: string | null, count?: number | null } | null } | null, serverlessResources?: { __typename?: 'ServerlessResourceSpec', cpu?: number | null, memory?: number | null } | null, prometheusScrape?: { __typename?: 'PrometheusScrape', path: string, port: number } | null, jobRuns?: { __typename?: 'JobRunConnection', totalCount: number } | null, autoscaling?: { __typename?: 'Autoscaling', kedaScaledObjectSpec?: string | null, minReplicas: number, maxReplicas: number, coolDownPeriod?: number | null, triggers?: Array<{ __typename?: 'AutoscalingTrigger', type: AutoscalingType, spec: any }> | null } | null, containerRegistry?: { __typename?: 'ContainerRegistry', id: string } | null, databaseEnvs: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string }>, databaseLinks: Array<{ __typename?: 'DatabaseLink', id: string, envPrefix?: string | null, envs?: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string }> | null, database: { __typename?: 'Repo', id: string, path: string, enabled: boolean, productionBranch?: string | null, deployTarget?: DeployTarget | null, deployType?: DeployType | null, deployService?: boolean | null, deployJob?: boolean | null, image?: string | null, cpu?: string | null, memory?: string | null, updatedAt: Date, disableReason?: DisableReason | null, databaseProvider?: DatabaseProviderType | null, databaseEngine?: DatabaseEngineType | null, name: string, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, projectID?: string | null } | null, gpu?: { __typename?: 'GPUSpec', type?: string | null, count: number } | null, tpu?: { __typename?: 'TPUSpec', tfVersion: string, type: string, cores: number } | null, cluster?: { __typename?: 'Cluster', id: string, name: string, domain?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null } | null, autoscaling?: { __typename?: 'Autoscaling', minReplicas: number, maxReplicas: number } | null, owner: { __typename?: 'User', id: string, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, owner: { __typename?: 'User', id: string, login: any } } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null } }>, linkedProjects: Array<{ __typename?: 'DatabaseLink', id: string, envPrefix?: string | null, repo: { __typename?: 'Repo', id: string, path: string, enabled: boolean, productionBranch?: string | null, deployTarget?: DeployTarget | null, deployType?: DeployType | null, deployService?: boolean | null, deployJob?: boolean | null, image?: string | null, cpu?: string | null, memory?: string | null, updatedAt: Date, disableReason?: DisableReason | null, databaseProvider?: DatabaseProviderType | null, databaseEngine?: DatabaseEngineType | null, name: string, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, projectID?: string | null } | null, gpu?: { __typename?: 'GPUSpec', type?: string | null, count: number } | null, tpu?: { __typename?: 'TPUSpec', tfVersion: string, type: string, cores: number } | null, cluster?: { __typename?: 'Cluster', id: string, name: string, domain?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null } | null, autoscaling?: { __typename?: 'Autoscaling', minReplicas: number, maxReplicas: number } | null, owner: { __typename?: 'User', id: string, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, owner: { __typename?: 'User', id: string, login: any } } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null } }>, pipelineCluster?: { __typename?: 'Cluster', id: string } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string, envs?: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string, visible: boolean, sealed: boolean, source?: { __typename?: 'EnvVarSource', type: EnvVarSourceType } | null }> | null } | null, pipelineLinks?: Array<{ __typename?: 'RepoPipelineLink', id: string, sourceEvent: RepoEvent, targetAction: RepoAction, source: { __typename?: 'Repo', id: string }, targetGroup: { __typename?: 'RepoGroup', id: string, selector?: { __typename?: 'LabelSelectors', matchLabels?: any | null } | null } }> | null, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null } | null, owner: { __typename?: 'User', id: string, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, clusterDomains?: Array<{ __typename?: 'ClusterDomains', id: string, cluster: { __typename?: 'Cluster', id: string, name: string }, domains?: Array<{ __typename?: 'CustomDomain', id: string, domain: string, isApex: boolean, cnameTargets?: Array<string> | null, ipTargets?: Array<string> | null, disableCertManager?: boolean | null, certManagerChallengeType?: CertManagerChallengeType | null, syncDomain?: { __typename?: 'CustomDomain', id: string } | null, instructions?: Array<{ __typename?: 'DNSRecord', domain: string, type: DnsRecordType, value?: string | null }> | null, certificate?: { __typename?: 'Certificate', dnsNames?: Array<string> | null, ready: boolean, issuing: boolean, challenges?: Array<{ __typename?: 'CertificateChallenge', dnsName: string, solver: string, statusReason: string, statusState: string, type: string, wildcard: boolean }> | null, instructions?: Array<{ __typename?: 'DNSRecord', domain: string, type: DnsRecordType, value?: string | null }> | null } | null }> | null }> | null, cdns?: Array<{ __typename?: 'CDN', id: string, endpoint?: string | null, state: string, domains?: Array<{ __typename?: 'CDNDomain', domain: string, certReady?: boolean | null, routeReady?: boolean | null, instruction?: { __typename?: 'DNSRecord', domain: string, type: DnsRecordType, value?: string | null } | null }> | null, certificate?: { __typename?: 'Certificate', dnsNames?: Array<string> | null, ready: boolean, issuing: boolean, instructions?: Array<{ __typename?: 'DNSRecord', name?: string | null, domain: string, type: DnsRecordType, value?: string | null }> | null } | null }> | null, ports?: Array<{ __typename?: 'Port', port: string, externalPort: string, protocol: string, public: boolean, https: boolean, grpc: boolean, loadBalancer: boolean }> | null, buildMethod?: { __typename?: 'BuildMethod', name: string, type: BuildType, workingDirectory?: string | null, dockerfilePath?: string | null, buildCommand?: string | null, staticPath?: string | null, runCommand?: string | null, releaseCommand?: string | null, nodejsVersion?: string | null, pythonVersion?: string | null, golangVersion?: string | null } | null, buildResources?: { __typename?: 'ContainerResourcesSpec', cpu?: number | null, memory?: number | null, ephemeralStorage?: number | null, spot?: boolean | null } | null, buildSpec?: { __typename?: 'ContainerSpec', cpu?: number | null, memory?: number | null } | null, kanikoFlags?: { __typename?: 'KanikoFlags', compressedCaching?: boolean | null } | null };

export type RepoPipelineLinkDetailFragment = { __typename?: 'RepoPipelineLink', id: string, sourceEvent: RepoEvent, targetAction: RepoAction, source: { __typename?: 'Repo', id: string }, targetGroup: { __typename?: 'RepoGroup', id: string, selector?: { __typename?: 'LabelSelectors', matchLabels?: any | null } | null } };

export type UserDetailFragment = { __typename?: 'User', id: string, hasZeetCloud?: boolean | null, hasOnboarded?: boolean | null, canDeploy?: boolean | null, email?: string | null, createdAt?: Date | null, freeTrialEndsAt?: Date | null, hasPaymentMethod?: boolean | null, paymentError?: string | null, paymentAuthorizationError?: string | null, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null };

export type GitHubRepoFragment = { __typename?: 'GitHubRepository', id: string, name: string, owner: string, url: string, description?: string | null, isFork: boolean, isPrivate: boolean, primaryLanguage?: string | null, updatedAt: Date };

export type CollaboratorCommonFragment = { __typename?: 'ProjectCollaborator', id: string, role: ProjectCollaboratorRole, user: { __typename?: 'User', id: string, name: string, login: any, avatar?: string | null, isTeam?: boolean | null } };

export type ProjectConnectionListItemFragment = { __typename?: 'ProjectConnection', pageInfo: { __typename?: 'PageInfo', startCursor: string, endCursor: string, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'Project', id: string, repo?: { __typename?: 'Repo', id: string, path: string, enabled: boolean, productionBranch?: string | null, deployTarget?: DeployTarget | null, deployType?: DeployType | null, deployService?: boolean | null, deployJob?: boolean | null, image?: string | null, cpu?: string | null, memory?: string | null, updatedAt: Date, disableReason?: DisableReason | null, databaseProvider?: DatabaseProviderType | null, databaseEngine?: DatabaseEngineType | null, name: string, productionDeployment?: { __typename?: 'Deployment', id: string, description?: string | null, version: string, status: DeploymentStatus, branch?: string | null, endpoints?: Array<string> | null, privateEndpoint?: string | null, errorMessage?: string | null, updatedAt: Date, createdAt: Date, deployStatus?: { __typename?: 'DeployStatus', active: boolean, replicas: number, publicIPs?: Array<string> | null, state: string, errorMessage?: string | null, troubleshooting?: { __typename?: 'Troubleshooting', issue?: { __typename?: 'TroubleshootingIssue', blocks?: Array<{ __typename?: 'TroubleshootingIssueBlock', blockType?: TroubleshootingIssueBlockType | null, content?: string | null }> | null } | null } | null } | null, build?: { __typename?: 'Build', id: string, image?: string | null } | null, alternativeImages?: Array<{ __typename?: 'AlternativeImage', reference?: string | null, tag?: string | null, name?: string | null }> | null } | null, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, projectID?: string | null } | null, gpu?: { __typename?: 'GPUSpec', type?: string | null, count: number } | null, tpu?: { __typename?: 'TPUSpec', tfVersion: string, type: string, cores: number } | null, cluster?: { __typename?: 'Cluster', id: string, name: string, domain?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null } | null, autoscaling?: { __typename?: 'Autoscaling', minReplicas: number, maxReplicas: number } | null, owner: { __typename?: 'User', id: string, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, owner: { __typename?: 'User', id: string, login: any } } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null } | null }> };

export type EnvVarDetailFragment = { __typename?: 'EnvVar', id: string, name: string, value: string, visible: boolean, sealed: boolean, source?: { __typename?: 'EnvVarSource', type: EnvVarSourceType } | null };

export type MetricStreamFragment = { __typename?: 'MetricStream', type?: MetricType | null, query: string, annotations?: Array<{ __typename?: 'MetricAnnotation', type: MetricAnnotationType, direction: MetricAnnotationDirection, function?: MetricAnnotationFunction | null, label?: string | null, value?: number | null }> | null, labels?: Array<{ __typename?: 'MetricStreamLabel', label: MetricLabelType, value: string }> | null, entries?: Array<{ __typename?: 'MetricEntry', value?: number | null, timestamp: Date }> | null };

export type CreateApiKeyMutationVariables = Exact<{
  input: CreateApiKeyInput;
}>;


export type CreateApiKeyMutation = { __typename?: 'Mutation', createAPIKey: { __typename?: 'APIKey', id: string, token: string, name: string, description: string, createdAt: Date } };

export type DeleteApiKeyMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DeleteApiKeyMutation = { __typename?: 'Mutation', deleteAPIKey: boolean };

export type PurchaseSubscriptionMutationVariables = Exact<{
  forUserID: Scalars['UUID'];
  subscriptionCart: SubscriptionCart;
}>;


export type PurchaseSubscriptionMutation = { __typename?: 'Mutation', purchaseSubscription: { __typename?: 'SubscriptionPurchaseResponse', overview: { __typename?: 'BillingOverview', currentProducts?: Array<{ __typename?: 'ApiAccess', name?: string | null, description?: string | null, sku: string, displayPrice?: string | null, benefits: Array<string>, productTypeMetadata?: { __typename?: 'ProductTypeMetadata', productType?: ProductType | null, displayName?: string | null, pricingPageAnchor?: string | null } | null, usage: Array<{ __typename?: 'Usage', unit: string, unitPlural: string, displayName: string, currentUsage?: number | null, maximumUsage?: number | null, description?: string | null }> } | { __typename?: 'PlanTierV2', name?: string | null, description?: string | null, sku: string, displayPrice?: string | null, benefits: Array<string>, productTypeMetadata?: { __typename?: 'ProductTypeMetadata', productType?: ProductType | null, displayName?: string | null, pricingPageAnchor?: string | null } | null, usage: Array<{ __typename?: 'Usage', unit: string, unitPlural: string, displayName: string, currentUsage?: number | null, maximumUsage?: number | null, description?: string | null }> } | { __typename?: 'ProjectPack', name?: string | null, description?: string | null, sku: string, displayPrice?: string | null, benefits: Array<string>, productTypeMetadata?: { __typename?: 'ProductTypeMetadata', productType?: ProductType | null, displayName?: string | null, pricingPageAnchor?: string | null } | null, usage: Array<{ __typename?: 'Usage', unit: string, unitPlural: string, displayName: string, currentUsage?: number | null, maximumUsage?: number | null, description?: string | null }> } | { __typename?: 'SupportTier', name?: string | null, description?: string | null, sku: string, displayPrice?: string | null, benefits: Array<string>, productTypeMetadata?: { __typename?: 'ProductTypeMetadata', productType?: ProductType | null, displayName?: string | null, pricingPageAnchor?: string | null } | null, usage: Array<{ __typename?: 'Usage', unit: string, unitPlural: string, displayName: string, currentUsage?: number | null, maximumUsage?: number | null, description?: string | null }> }> | null } } };

export type CreateBlueprintMutationVariables = Exact<{
  input: CreateBlueprintInput;
}>;


export type CreateBlueprintMutation = { __typename?: 'Mutation', createBlueprint: { __typename?: 'Blueprint', id: string } };

export type MaybeCreateBlueprintFromMetadataMutationVariables = Exact<{
  slug: Scalars['String'];
  version: Scalars['String'];
}>;


export type MaybeCreateBlueprintFromMetadataMutation = { __typename?: 'Mutation', maybeCreateBlueprintFromMetadata: { __typename?: 'Blueprint', id: string } };

export type UpdateBlueprintMutationVariables = Exact<{
  id: Scalars['UUID'];
  input: UpdateBlueprintInput;
}>;


export type UpdateBlueprintMutation = { __typename?: 'Mutation', updateBlueprint: { __typename?: 'Blueprint', id: string } };

export type UpdateMarketplaceBlueprintMutationVariables = Exact<{
  input: UpdateMarketplaceBlueprintInput;
}>;


export type UpdateMarketplaceBlueprintMutation = { __typename?: 'Mutation', updateMarketplaceBlueprint: { __typename?: 'Blueprint', id: string } };

export type DuplicateBlueprintMutationVariables = Exact<{
  input: DuplicateBlueprintInput;
}>;


export type DuplicateBlueprintMutation = { __typename?: 'Mutation', duplicateBlueprint: { __typename?: 'Blueprint', id: string } };

export type DeleteBlueprintMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DeleteBlueprintMutation = { __typename?: 'Mutation', deleteBlueprint: boolean };

export type CreateBranchMutationVariables = Exact<{
  input: UpdateBranchInput;
}>;


export type CreateBranchMutation = { __typename?: 'Mutation', updateBranch: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null, createdAt: Date, updatedAt: Date, state?: string | null, endpoints?: Array<string> | null, latestDeployment?: { __typename?: 'Deployment', id: string, description?: string | null, version: string, status: DeploymentStatus, branch?: string | null, endpoints?: Array<string> | null, privateEndpoint?: string | null, errorMessage?: string | null, updatedAt: Date, createdAt: Date, deployStatus?: { __typename?: 'DeployStatus', active: boolean, replicas: number, publicIPs?: Array<string> | null, state: string, errorMessage?: string | null, troubleshooting?: { __typename?: 'Troubleshooting', issue?: { __typename?: 'TroubleshootingIssue', blocks?: Array<{ __typename?: 'TroubleshootingIssueBlock', blockType?: TroubleshootingIssueBlockType | null, content?: string | null }> | null } | null } | null } | null, build?: { __typename?: 'Build', id: string, image?: string | null } | null, alternativeImages?: Array<{ __typename?: 'AlternativeImage', reference?: string | null, tag?: string | null, name?: string | null }> | null } | null } };

export type DeleteProjectBranchMutationVariables = Exact<{
  id: Scalars['UUID'];
  branch: Scalars['String'];
}>;


export type DeleteProjectBranchMutation = { __typename?: 'Mutation', deleteProjectBranch: boolean };

export type AddAwsAccountMutationVariables = Exact<{
  input: AddAwsAccountInput;
}>;


export type AddAwsAccountMutation = { __typename?: 'Mutation', addAWSAccount: { __typename?: 'AWSAccount', id: string, name: string, state: AwsAccountState, accountID?: string | null, roleARN?: string | null, cloudFormationURL: string, connected?: boolean | null } };

export type RemoveAwsAccountMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type RemoveAwsAccountMutation = { __typename?: 'Mutation', removeAWSAccount: boolean };

export type UpdateAwsAccountMutationVariables = Exact<{
  input: UpdateAwsAccountInput;
}>;


export type UpdateAwsAccountMutation = { __typename?: 'Mutation', updateAWSAccount: boolean };

export type AddGcpAccountMutationVariables = Exact<{
  input: AddGcpAccountInput;
}>;


export type AddGcpAccountMutation = { __typename?: 'Mutation', addGCPAccount: { __typename?: 'GCPAccount', id: string, name: string, state: GcpAccountState, projectID?: string | null, clientEmail?: string | null, connected?: boolean | null, error?: string | null } };

export type RemoveGcpAccountMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type RemoveGcpAccountMutation = { __typename?: 'Mutation', removeGCPAccount: boolean };

export type UpdateGcpAccountMutationVariables = Exact<{
  input: UpdateGcpAccountInput;
}>;


export type UpdateGcpAccountMutation = { __typename?: 'Mutation', updateGCPAccount: boolean };

export type AddDoAccountMutationVariables = Exact<{
  input: AddDoAccountInput;
}>;


export type AddDoAccountMutation = { __typename?: 'Mutation', addDOAccount: { __typename?: 'DOAccount', id: string, name: string, state: DoAccountState, accessTokenPrefix?: string | null, defaultProject?: string | null, connected?: boolean | null } };

export type RemoveDoAccountMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type RemoveDoAccountMutation = { __typename?: 'Mutation', removeDOAccount: boolean };

export type UpdateDoAccountMutationVariables = Exact<{
  input: UpdateDoAccountInput;
}>;


export type UpdateDoAccountMutation = { __typename?: 'Mutation', updateDOAccount: boolean };

export type AddLinodeAccountMutationVariables = Exact<{
  input: AddLinodeAccountInput;
}>;


export type AddLinodeAccountMutation = { __typename?: 'Mutation', addLinodeAccount: { __typename?: 'LinodeAccount', id: string, name: string, state: CloudAccountState, accessTokenPrefix?: string | null, connected?: boolean | null } };

export type RemoveLinodeAccountMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type RemoveLinodeAccountMutation = { __typename?: 'Mutation', removeLinodeAccount: boolean };

export type UpdateLinodeAccountMutationVariables = Exact<{
  input: UpdateLinodeAccountInput;
}>;


export type UpdateLinodeAccountMutation = { __typename?: 'Mutation', updateLinodeAccount: boolean };

export type AddVultrAccountMutationVariables = Exact<{
  input: AddVultrAccountInput;
}>;


export type AddVultrAccountMutation = { __typename?: 'Mutation', addVultrAccount: { __typename?: 'VultrAccount', id: string, name: string, state: CloudAccountState, connected?: boolean | null } };

export type RemoveVultrAccountMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type RemoveVultrAccountMutation = { __typename?: 'Mutation', removeVultrAccount: boolean };

export type UpdateVultrAccountMutationVariables = Exact<{
  input: UpdateVultrAccountInput;
}>;


export type UpdateVultrAccountMutation = { __typename?: 'Mutation', updateVultrAccount: boolean };

export type AddCoreWeaveAccountMutationVariables = Exact<{
  input: AddCoreWeaveAccountInput;
}>;


export type AddCoreWeaveAccountMutation = { __typename?: 'Mutation', addCoreWeaveAccount: { __typename?: 'CoreWeaveAccount', id: string, name: string, state: CloudAccountState, namespace?: string | null, connected?: boolean | null } };

export type RemoveCoreWeaveAccountMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type RemoveCoreWeaveAccountMutation = { __typename?: 'Mutation', removeCoreWeaveAccount: boolean };

export type UpdateCoreWeaveAccountMutationVariables = Exact<{
  input: UpdateCoreWeaveAccountInput;
}>;


export type UpdateCoreWeaveAccountMutation = { __typename?: 'Mutation', updateCoreWeaveAccount: boolean };

export type AddAzureAccountMutationVariables = Exact<{
  input: AddAzureAccountInput;
}>;


export type AddAzureAccountMutation = { __typename?: 'Mutation', addAzureAccount: { __typename?: 'AzureAccount', id: string, name: string, state: CloudAccountState, connected?: boolean | null, subscriptionID?: string | null, tenantID?: string | null, clientID?: string | null } };

export type RemoveAzureAccountMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type RemoveAzureAccountMutation = { __typename?: 'Mutation', removeAzureAccount: boolean };

export type UpdateAzureAccountMutationVariables = Exact<{
  input: UpdateAzureAccountInput;
}>;


export type UpdateAzureAccountMutation = { __typename?: 'Mutation', updateAzureAccount: boolean };

export type EnsureCloudqueryEnabledMutationVariables = Exact<{
  awsAccountId: Scalars['UUID'];
}>;


export type EnsureCloudqueryEnabledMutation = { __typename?: 'Mutation', ensureCloudqueryEnabled: boolean };

export type CreateClusterMutationVariables = Exact<{
  input: CreateClusterInput;
}>;


export type CreateClusterMutation = { __typename?: 'Mutation', createCluster: { __typename?: 'Cluster', id: string, ingressIP?: string | null, ingressDNS?: string | null, clusterProvider?: ClusterProvider | null, cloudProvider?: CloudProvider | null, terraformProjectUrl?: string | null, containerRepository?: string | null, containerCacheRepository?: string | null, name: string, region?: string | null, state: ClusterState, status?: ClusterStatus | null, connected?: boolean | null, domain?: string | null, isExternal?: boolean | null, isEjected?: boolean | null, updatedAt: Date, createdAt: Date, prometheus?: { __typename?: 'Prometheus', url: string, user?: string | null, password?: string | null, token?: string | null } | null, grafana?: { __typename?: 'Grafana', url: string, user?: string | null, password?: string | null } | null, deployJob?: { __typename?: 'JobRun', id: string, state: JobRunState } | null, projects?: { __typename?: 'ProjectConnection', pageInfo: { __typename?: 'PageInfo', startCursor: string, endCursor: string, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'Project', id: string, repo?: { __typename?: 'Repo', id: string, path: string, enabled: boolean, productionBranch?: string | null, deployTarget?: DeployTarget | null, deployType?: DeployType | null, deployService?: boolean | null, deployJob?: boolean | null, image?: string | null, cpu?: string | null, memory?: string | null, updatedAt: Date, disableReason?: DisableReason | null, databaseProvider?: DatabaseProviderType | null, databaseEngine?: DatabaseEngineType | null, name: string, productionDeployment?: { __typename?: 'Deployment', id: string, description?: string | null, version: string, status: DeploymentStatus, branch?: string | null, endpoints?: Array<string> | null, privateEndpoint?: string | null, errorMessage?: string | null, updatedAt: Date, createdAt: Date, deployStatus?: { __typename?: 'DeployStatus', active: boolean, replicas: number, publicIPs?: Array<string> | null, state: string, errorMessage?: string | null, troubleshooting?: { __typename?: 'Troubleshooting', issue?: { __typename?: 'TroubleshootingIssue', blocks?: Array<{ __typename?: 'TroubleshootingIssueBlock', blockType?: TroubleshootingIssueBlockType | null, content?: string | null }> | null } | null } | null } | null, build?: { __typename?: 'Build', id: string, image?: string | null } | null, alternativeImages?: Array<{ __typename?: 'AlternativeImage', reference?: string | null, tag?: string | null, name?: string | null }> | null } | null, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, projectID?: string | null } | null, gpu?: { __typename?: 'GPUSpec', type?: string | null, count: number } | null, tpu?: { __typename?: 'TPUSpec', tfVersion: string, type: string, cores: number } | null, cluster?: { __typename?: 'Cluster', id: string, name: string, domain?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null } | null, autoscaling?: { __typename?: 'Autoscaling', minReplicas: number, maxReplicas: number } | null, owner: { __typename?: 'User', id: string, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, owner: { __typename?: 'User', id: string, login: any } } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null } | null }> } | null, projectV3Adapters?: { __typename?: 'ProjectV3AdapterConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor: string, endCursor: string, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'ProjectV3Adapter', id: string, name: string, project?: { __typename?: 'Project', id: string, name: string } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null }> } | null, components?: Array<{ __typename?: 'ClusterComponent', name: string, type: ClusterComponentType, status: ClusterComponentEjectedStatus, isInstalledByZeet: boolean, exists: boolean, project?: { __typename?: 'ProjectV3Adapter', id: string, name: string, project?: { __typename?: 'Project', name: string } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', name: string } | null } | null, helmMetadata?: { __typename?: 'HelmClusterComponentMetadata', values: string, namespace: string, releaseName: string, chartRepoGuess?: string | null, chartVersion: string, chartName: string } | null, terraformMetadata?: { __typename?: 'TerraformClusterComponentMetadata', jobRunState?: JobRunState | null } | null } | null> | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null, cloudAccount?: { __typename?: 'AWSAccount', id: string } | { __typename?: 'AzureAccount', id: string } | { __typename?: 'CoreWeaveAccount', id: string } | { __typename?: 'DOAccount', id: string } | { __typename?: 'GCPAccount', id: string } | { __typename?: 'LinodeAccount', id: string } | { __typename?: 'VultrAccount', id: string } | null, containerRegistry?: { __typename?: 'ContainerRegistry', id: string, name: string, credentialProvider?: ContainerRegistryCredentialProvider | null, username?: string | null } | null } };

export type AddClusterMutationVariables = Exact<{
  input: AddClusterInput;
}>;


export type AddClusterMutation = { __typename?: 'Mutation', addCluster: { __typename?: 'Cluster', id: string, ingressIP?: string | null, ingressDNS?: string | null, clusterProvider?: ClusterProvider | null, cloudProvider?: CloudProvider | null, terraformProjectUrl?: string | null, containerRepository?: string | null, containerCacheRepository?: string | null, name: string, region?: string | null, state: ClusterState, status?: ClusterStatus | null, connected?: boolean | null, domain?: string | null, isExternal?: boolean | null, isEjected?: boolean | null, updatedAt: Date, createdAt: Date, prometheus?: { __typename?: 'Prometheus', url: string, user?: string | null, password?: string | null, token?: string | null } | null, grafana?: { __typename?: 'Grafana', url: string, user?: string | null, password?: string | null } | null, deployJob?: { __typename?: 'JobRun', id: string, state: JobRunState } | null, projects?: { __typename?: 'ProjectConnection', pageInfo: { __typename?: 'PageInfo', startCursor: string, endCursor: string, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'Project', id: string, repo?: { __typename?: 'Repo', id: string, path: string, enabled: boolean, productionBranch?: string | null, deployTarget?: DeployTarget | null, deployType?: DeployType | null, deployService?: boolean | null, deployJob?: boolean | null, image?: string | null, cpu?: string | null, memory?: string | null, updatedAt: Date, disableReason?: DisableReason | null, databaseProvider?: DatabaseProviderType | null, databaseEngine?: DatabaseEngineType | null, name: string, productionDeployment?: { __typename?: 'Deployment', id: string, description?: string | null, version: string, status: DeploymentStatus, branch?: string | null, endpoints?: Array<string> | null, privateEndpoint?: string | null, errorMessage?: string | null, updatedAt: Date, createdAt: Date, deployStatus?: { __typename?: 'DeployStatus', active: boolean, replicas: number, publicIPs?: Array<string> | null, state: string, errorMessage?: string | null, troubleshooting?: { __typename?: 'Troubleshooting', issue?: { __typename?: 'TroubleshootingIssue', blocks?: Array<{ __typename?: 'TroubleshootingIssueBlock', blockType?: TroubleshootingIssueBlockType | null, content?: string | null }> | null } | null } | null } | null, build?: { __typename?: 'Build', id: string, image?: string | null } | null, alternativeImages?: Array<{ __typename?: 'AlternativeImage', reference?: string | null, tag?: string | null, name?: string | null }> | null } | null, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, projectID?: string | null } | null, gpu?: { __typename?: 'GPUSpec', type?: string | null, count: number } | null, tpu?: { __typename?: 'TPUSpec', tfVersion: string, type: string, cores: number } | null, cluster?: { __typename?: 'Cluster', id: string, name: string, domain?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null } | null, autoscaling?: { __typename?: 'Autoscaling', minReplicas: number, maxReplicas: number } | null, owner: { __typename?: 'User', id: string, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, owner: { __typename?: 'User', id: string, login: any } } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null } | null }> } | null, projectV3Adapters?: { __typename?: 'ProjectV3AdapterConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor: string, endCursor: string, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'ProjectV3Adapter', id: string, name: string, project?: { __typename?: 'Project', id: string, name: string } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null }> } | null, components?: Array<{ __typename?: 'ClusterComponent', name: string, type: ClusterComponentType, status: ClusterComponentEjectedStatus, isInstalledByZeet: boolean, exists: boolean, project?: { __typename?: 'ProjectV3Adapter', id: string, name: string, project?: { __typename?: 'Project', name: string } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', name: string } | null } | null, helmMetadata?: { __typename?: 'HelmClusterComponentMetadata', values: string, namespace: string, releaseName: string, chartRepoGuess?: string | null, chartVersion: string, chartName: string } | null, terraformMetadata?: { __typename?: 'TerraformClusterComponentMetadata', jobRunState?: JobRunState | null } | null } | null> | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null, cloudAccount?: { __typename?: 'AWSAccount', id: string } | { __typename?: 'AzureAccount', id: string } | { __typename?: 'CoreWeaveAccount', id: string } | { __typename?: 'DOAccount', id: string } | { __typename?: 'GCPAccount', id: string } | { __typename?: 'LinodeAccount', id: string } | { __typename?: 'VultrAccount', id: string } | null, containerRegistry?: { __typename?: 'ContainerRegistry', id: string, name: string, credentialProvider?: ContainerRegistryCredentialProvider | null, username?: string | null } | null } };

export type UpdateClusterMutationVariables = Exact<{
  input: UpdateClusterInput;
}>;


export type UpdateClusterMutation = { __typename?: 'Mutation', updateCluster: { __typename?: 'Cluster', id: string, ingressIP?: string | null, ingressDNS?: string | null, clusterProvider?: ClusterProvider | null, cloudProvider?: CloudProvider | null, terraformProjectUrl?: string | null, containerRepository?: string | null, containerCacheRepository?: string | null, name: string, region?: string | null, state: ClusterState, status?: ClusterStatus | null, connected?: boolean | null, domain?: string | null, isExternal?: boolean | null, isEjected?: boolean | null, updatedAt: Date, createdAt: Date, prometheus?: { __typename?: 'Prometheus', url: string, user?: string | null, password?: string | null, token?: string | null } | null, grafana?: { __typename?: 'Grafana', url: string, user?: string | null, password?: string | null } | null, deployJob?: { __typename?: 'JobRun', id: string, state: JobRunState } | null, projects?: { __typename?: 'ProjectConnection', pageInfo: { __typename?: 'PageInfo', startCursor: string, endCursor: string, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'Project', id: string, repo?: { __typename?: 'Repo', id: string, path: string, enabled: boolean, productionBranch?: string | null, deployTarget?: DeployTarget | null, deployType?: DeployType | null, deployService?: boolean | null, deployJob?: boolean | null, image?: string | null, cpu?: string | null, memory?: string | null, updatedAt: Date, disableReason?: DisableReason | null, databaseProvider?: DatabaseProviderType | null, databaseEngine?: DatabaseEngineType | null, name: string, productionDeployment?: { __typename?: 'Deployment', id: string, description?: string | null, version: string, status: DeploymentStatus, branch?: string | null, endpoints?: Array<string> | null, privateEndpoint?: string | null, errorMessage?: string | null, updatedAt: Date, createdAt: Date, deployStatus?: { __typename?: 'DeployStatus', active: boolean, replicas: number, publicIPs?: Array<string> | null, state: string, errorMessage?: string | null, troubleshooting?: { __typename?: 'Troubleshooting', issue?: { __typename?: 'TroubleshootingIssue', blocks?: Array<{ __typename?: 'TroubleshootingIssueBlock', blockType?: TroubleshootingIssueBlockType | null, content?: string | null }> | null } | null } | null } | null, build?: { __typename?: 'Build', id: string, image?: string | null } | null, alternativeImages?: Array<{ __typename?: 'AlternativeImage', reference?: string | null, tag?: string | null, name?: string | null }> | null } | null, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, projectID?: string | null } | null, gpu?: { __typename?: 'GPUSpec', type?: string | null, count: number } | null, tpu?: { __typename?: 'TPUSpec', tfVersion: string, type: string, cores: number } | null, cluster?: { __typename?: 'Cluster', id: string, name: string, domain?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null } | null, autoscaling?: { __typename?: 'Autoscaling', minReplicas: number, maxReplicas: number } | null, owner: { __typename?: 'User', id: string, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, owner: { __typename?: 'User', id: string, login: any } } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null } | null }> } | null, projectV3Adapters?: { __typename?: 'ProjectV3AdapterConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor: string, endCursor: string, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'ProjectV3Adapter', id: string, name: string, project?: { __typename?: 'Project', id: string, name: string } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null }> } | null, components?: Array<{ __typename?: 'ClusterComponent', name: string, type: ClusterComponentType, status: ClusterComponentEjectedStatus, isInstalledByZeet: boolean, exists: boolean, project?: { __typename?: 'ProjectV3Adapter', id: string, name: string, project?: { __typename?: 'Project', name: string } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', name: string } | null } | null, helmMetadata?: { __typename?: 'HelmClusterComponentMetadata', values: string, namespace: string, releaseName: string, chartRepoGuess?: string | null, chartVersion: string, chartName: string } | null, terraformMetadata?: { __typename?: 'TerraformClusterComponentMetadata', jobRunState?: JobRunState | null } | null } | null> | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null, cloudAccount?: { __typename?: 'AWSAccount', id: string } | { __typename?: 'AzureAccount', id: string } | { __typename?: 'CoreWeaveAccount', id: string } | { __typename?: 'DOAccount', id: string } | { __typename?: 'GCPAccount', id: string } | { __typename?: 'LinodeAccount', id: string } | { __typename?: 'VultrAccount', id: string } | null, containerRegistry?: { __typename?: 'ContainerRegistry', id: string, name: string, credentialProvider?: ContainerRegistryCredentialProvider | null, username?: string | null } | null } };

export type DeleteClusterMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DeleteClusterMutation = { __typename?: 'Mutation', deleteCluster: boolean };

export type UnlinkClusterMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type UnlinkClusterMutation = { __typename?: 'Mutation', unlinkCluster: boolean };

export type UpdateClusterDomainMutationVariables = Exact<{
  input: UpdateClusterDomainInput;
}>;


export type UpdateClusterDomainMutation = { __typename?: 'Mutation', updateClusterDomain: { __typename?: 'Cluster', id: string, ingressIP?: string | null, ingressDNS?: string | null, clusterProvider?: ClusterProvider | null, cloudProvider?: CloudProvider | null, terraformProjectUrl?: string | null, containerRepository?: string | null, containerCacheRepository?: string | null, name: string, region?: string | null, state: ClusterState, status?: ClusterStatus | null, connected?: boolean | null, domain?: string | null, isExternal?: boolean | null, isEjected?: boolean | null, updatedAt: Date, createdAt: Date, prometheus?: { __typename?: 'Prometheus', url: string, user?: string | null, password?: string | null, token?: string | null } | null, grafana?: { __typename?: 'Grafana', url: string, user?: string | null, password?: string | null } | null, deployJob?: { __typename?: 'JobRun', id: string, state: JobRunState } | null, projects?: { __typename?: 'ProjectConnection', pageInfo: { __typename?: 'PageInfo', startCursor: string, endCursor: string, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'Project', id: string, repo?: { __typename?: 'Repo', id: string, path: string, enabled: boolean, productionBranch?: string | null, deployTarget?: DeployTarget | null, deployType?: DeployType | null, deployService?: boolean | null, deployJob?: boolean | null, image?: string | null, cpu?: string | null, memory?: string | null, updatedAt: Date, disableReason?: DisableReason | null, databaseProvider?: DatabaseProviderType | null, databaseEngine?: DatabaseEngineType | null, name: string, productionDeployment?: { __typename?: 'Deployment', id: string, description?: string | null, version: string, status: DeploymentStatus, branch?: string | null, endpoints?: Array<string> | null, privateEndpoint?: string | null, errorMessage?: string | null, updatedAt: Date, createdAt: Date, deployStatus?: { __typename?: 'DeployStatus', active: boolean, replicas: number, publicIPs?: Array<string> | null, state: string, errorMessage?: string | null, troubleshooting?: { __typename?: 'Troubleshooting', issue?: { __typename?: 'TroubleshootingIssue', blocks?: Array<{ __typename?: 'TroubleshootingIssueBlock', blockType?: TroubleshootingIssueBlockType | null, content?: string | null }> | null } | null } | null } | null, build?: { __typename?: 'Build', id: string, image?: string | null } | null, alternativeImages?: Array<{ __typename?: 'AlternativeImage', reference?: string | null, tag?: string | null, name?: string | null }> | null } | null, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, projectID?: string | null } | null, gpu?: { __typename?: 'GPUSpec', type?: string | null, count: number } | null, tpu?: { __typename?: 'TPUSpec', tfVersion: string, type: string, cores: number } | null, cluster?: { __typename?: 'Cluster', id: string, name: string, domain?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null } | null, autoscaling?: { __typename?: 'Autoscaling', minReplicas: number, maxReplicas: number } | null, owner: { __typename?: 'User', id: string, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, owner: { __typename?: 'User', id: string, login: any } } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null } | null }> } | null, projectV3Adapters?: { __typename?: 'ProjectV3AdapterConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor: string, endCursor: string, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'ProjectV3Adapter', id: string, name: string, project?: { __typename?: 'Project', id: string, name: string } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null }> } | null, components?: Array<{ __typename?: 'ClusterComponent', name: string, type: ClusterComponentType, status: ClusterComponentEjectedStatus, isInstalledByZeet: boolean, exists: boolean, project?: { __typename?: 'ProjectV3Adapter', id: string, name: string, project?: { __typename?: 'Project', name: string } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', name: string } | null } | null, helmMetadata?: { __typename?: 'HelmClusterComponentMetadata', values: string, namespace: string, releaseName: string, chartRepoGuess?: string | null, chartVersion: string, chartName: string } | null, terraformMetadata?: { __typename?: 'TerraformClusterComponentMetadata', jobRunState?: JobRunState | null } | null } | null> | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null, cloudAccount?: { __typename?: 'AWSAccount', id: string } | { __typename?: 'AzureAccount', id: string } | { __typename?: 'CoreWeaveAccount', id: string } | { __typename?: 'DOAccount', id: string } | { __typename?: 'GCPAccount', id: string } | { __typename?: 'LinodeAccount', id: string } | { __typename?: 'VultrAccount', id: string } | null, containerRegistry?: { __typename?: 'ContainerRegistry', id: string, name: string, credentialProvider?: ContainerRegistryCredentialProvider | null, username?: string | null } | null } };

export type LinkClusterToCloudMutationVariables = Exact<{
  input: LinkCloudToClusterInput;
}>;


export type LinkClusterToCloudMutation = { __typename?: 'Mutation', linkCloudToCluster: { __typename?: 'Cluster', id: string, ingressIP?: string | null, ingressDNS?: string | null, clusterProvider?: ClusterProvider | null, cloudProvider?: CloudProvider | null, terraformProjectUrl?: string | null, containerRepository?: string | null, containerCacheRepository?: string | null, name: string, region?: string | null, state: ClusterState, status?: ClusterStatus | null, connected?: boolean | null, domain?: string | null, isExternal?: boolean | null, isEjected?: boolean | null, updatedAt: Date, createdAt: Date, prometheus?: { __typename?: 'Prometheus', url: string, user?: string | null, password?: string | null, token?: string | null } | null, grafana?: { __typename?: 'Grafana', url: string, user?: string | null, password?: string | null } | null, deployJob?: { __typename?: 'JobRun', id: string, state: JobRunState } | null, projects?: { __typename?: 'ProjectConnection', pageInfo: { __typename?: 'PageInfo', startCursor: string, endCursor: string, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'Project', id: string, repo?: { __typename?: 'Repo', id: string, path: string, enabled: boolean, productionBranch?: string | null, deployTarget?: DeployTarget | null, deployType?: DeployType | null, deployService?: boolean | null, deployJob?: boolean | null, image?: string | null, cpu?: string | null, memory?: string | null, updatedAt: Date, disableReason?: DisableReason | null, databaseProvider?: DatabaseProviderType | null, databaseEngine?: DatabaseEngineType | null, name: string, productionDeployment?: { __typename?: 'Deployment', id: string, description?: string | null, version: string, status: DeploymentStatus, branch?: string | null, endpoints?: Array<string> | null, privateEndpoint?: string | null, errorMessage?: string | null, updatedAt: Date, createdAt: Date, deployStatus?: { __typename?: 'DeployStatus', active: boolean, replicas: number, publicIPs?: Array<string> | null, state: string, errorMessage?: string | null, troubleshooting?: { __typename?: 'Troubleshooting', issue?: { __typename?: 'TroubleshootingIssue', blocks?: Array<{ __typename?: 'TroubleshootingIssueBlock', blockType?: TroubleshootingIssueBlockType | null, content?: string | null }> | null } | null } | null } | null, build?: { __typename?: 'Build', id: string, image?: string | null } | null, alternativeImages?: Array<{ __typename?: 'AlternativeImage', reference?: string | null, tag?: string | null, name?: string | null }> | null } | null, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, projectID?: string | null } | null, gpu?: { __typename?: 'GPUSpec', type?: string | null, count: number } | null, tpu?: { __typename?: 'TPUSpec', tfVersion: string, type: string, cores: number } | null, cluster?: { __typename?: 'Cluster', id: string, name: string, domain?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null } | null, autoscaling?: { __typename?: 'Autoscaling', minReplicas: number, maxReplicas: number } | null, owner: { __typename?: 'User', id: string, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, owner: { __typename?: 'User', id: string, login: any } } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null } | null }> } | null, projectV3Adapters?: { __typename?: 'ProjectV3AdapterConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor: string, endCursor: string, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'ProjectV3Adapter', id: string, name: string, project?: { __typename?: 'Project', id: string, name: string } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null }> } | null, components?: Array<{ __typename?: 'ClusterComponent', name: string, type: ClusterComponentType, status: ClusterComponentEjectedStatus, isInstalledByZeet: boolean, exists: boolean, project?: { __typename?: 'ProjectV3Adapter', id: string, name: string, project?: { __typename?: 'Project', name: string } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', name: string } | null } | null, helmMetadata?: { __typename?: 'HelmClusterComponentMetadata', values: string, namespace: string, releaseName: string, chartRepoGuess?: string | null, chartVersion: string, chartName: string } | null, terraformMetadata?: { __typename?: 'TerraformClusterComponentMetadata', jobRunState?: JobRunState | null } | null } | null> | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null, cloudAccount?: { __typename?: 'AWSAccount', id: string } | { __typename?: 'AzureAccount', id: string } | { __typename?: 'CoreWeaveAccount', id: string } | { __typename?: 'DOAccount', id: string } | { __typename?: 'GCPAccount', id: string } | { __typename?: 'LinodeAccount', id: string } | { __typename?: 'VultrAccount', id: string } | null, containerRegistry?: { __typename?: 'ContainerRegistry', id: string, name: string, credentialProvider?: ContainerRegistryCredentialProvider | null, username?: string | null } | null } };

export type UpdateClusterDetailsExternalMutationVariables = Exact<{
  updateClusterInput: UpdateClusterInput;
  updateClusterDomainInput: UpdateClusterDomainInput;
}>;


export type UpdateClusterDetailsExternalMutation = { __typename?: 'Mutation', updateCluster: { __typename?: 'Cluster', id: string, ingressIP?: string | null, ingressDNS?: string | null, clusterProvider?: ClusterProvider | null, cloudProvider?: CloudProvider | null, terraformProjectUrl?: string | null, containerRepository?: string | null, containerCacheRepository?: string | null, name: string, region?: string | null, state: ClusterState, status?: ClusterStatus | null, connected?: boolean | null, domain?: string | null, isExternal?: boolean | null, isEjected?: boolean | null, updatedAt: Date, createdAt: Date, prometheus?: { __typename?: 'Prometheus', url: string, user?: string | null, password?: string | null, token?: string | null } | null, grafana?: { __typename?: 'Grafana', url: string, user?: string | null, password?: string | null } | null, deployJob?: { __typename?: 'JobRun', id: string, state: JobRunState } | null, projects?: { __typename?: 'ProjectConnection', pageInfo: { __typename?: 'PageInfo', startCursor: string, endCursor: string, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'Project', id: string, repo?: { __typename?: 'Repo', id: string, path: string, enabled: boolean, productionBranch?: string | null, deployTarget?: DeployTarget | null, deployType?: DeployType | null, deployService?: boolean | null, deployJob?: boolean | null, image?: string | null, cpu?: string | null, memory?: string | null, updatedAt: Date, disableReason?: DisableReason | null, databaseProvider?: DatabaseProviderType | null, databaseEngine?: DatabaseEngineType | null, name: string, productionDeployment?: { __typename?: 'Deployment', id: string, description?: string | null, version: string, status: DeploymentStatus, branch?: string | null, endpoints?: Array<string> | null, privateEndpoint?: string | null, errorMessage?: string | null, updatedAt: Date, createdAt: Date, deployStatus?: { __typename?: 'DeployStatus', active: boolean, replicas: number, publicIPs?: Array<string> | null, state: string, errorMessage?: string | null, troubleshooting?: { __typename?: 'Troubleshooting', issue?: { __typename?: 'TroubleshootingIssue', blocks?: Array<{ __typename?: 'TroubleshootingIssueBlock', blockType?: TroubleshootingIssueBlockType | null, content?: string | null }> | null } | null } | null } | null, build?: { __typename?: 'Build', id: string, image?: string | null } | null, alternativeImages?: Array<{ __typename?: 'AlternativeImage', reference?: string | null, tag?: string | null, name?: string | null }> | null } | null, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, projectID?: string | null } | null, gpu?: { __typename?: 'GPUSpec', type?: string | null, count: number } | null, tpu?: { __typename?: 'TPUSpec', tfVersion: string, type: string, cores: number } | null, cluster?: { __typename?: 'Cluster', id: string, name: string, domain?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null } | null, autoscaling?: { __typename?: 'Autoscaling', minReplicas: number, maxReplicas: number } | null, owner: { __typename?: 'User', id: string, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, owner: { __typename?: 'User', id: string, login: any } } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null } | null }> } | null, projectV3Adapters?: { __typename?: 'ProjectV3AdapterConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor: string, endCursor: string, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'ProjectV3Adapter', id: string, name: string, project?: { __typename?: 'Project', id: string, name: string } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null }> } | null, components?: Array<{ __typename?: 'ClusterComponent', name: string, type: ClusterComponentType, status: ClusterComponentEjectedStatus, isInstalledByZeet: boolean, exists: boolean, project?: { __typename?: 'ProjectV3Adapter', id: string, name: string, project?: { __typename?: 'Project', name: string } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', name: string } | null } | null, helmMetadata?: { __typename?: 'HelmClusterComponentMetadata', values: string, namespace: string, releaseName: string, chartRepoGuess?: string | null, chartVersion: string, chartName: string } | null, terraformMetadata?: { __typename?: 'TerraformClusterComponentMetadata', jobRunState?: JobRunState | null } | null } | null> | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null, cloudAccount?: { __typename?: 'AWSAccount', id: string } | { __typename?: 'AzureAccount', id: string } | { __typename?: 'CoreWeaveAccount', id: string } | { __typename?: 'DOAccount', id: string } | { __typename?: 'GCPAccount', id: string } | { __typename?: 'LinodeAccount', id: string } | { __typename?: 'VultrAccount', id: string } | null, containerRegistry?: { __typename?: 'ContainerRegistry', id: string, name: string, credentialProvider?: ContainerRegistryCredentialProvider | null, username?: string | null } | null }, updateClusterDomain: { __typename?: 'Cluster', id: string, ingressIP?: string | null, ingressDNS?: string | null, clusterProvider?: ClusterProvider | null, cloudProvider?: CloudProvider | null, terraformProjectUrl?: string | null, containerRepository?: string | null, containerCacheRepository?: string | null, name: string, region?: string | null, state: ClusterState, status?: ClusterStatus | null, connected?: boolean | null, domain?: string | null, isExternal?: boolean | null, isEjected?: boolean | null, updatedAt: Date, createdAt: Date, prometheus?: { __typename?: 'Prometheus', url: string, user?: string | null, password?: string | null, token?: string | null } | null, grafana?: { __typename?: 'Grafana', url: string, user?: string | null, password?: string | null } | null, deployJob?: { __typename?: 'JobRun', id: string, state: JobRunState } | null, projects?: { __typename?: 'ProjectConnection', pageInfo: { __typename?: 'PageInfo', startCursor: string, endCursor: string, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'Project', id: string, repo?: { __typename?: 'Repo', id: string, path: string, enabled: boolean, productionBranch?: string | null, deployTarget?: DeployTarget | null, deployType?: DeployType | null, deployService?: boolean | null, deployJob?: boolean | null, image?: string | null, cpu?: string | null, memory?: string | null, updatedAt: Date, disableReason?: DisableReason | null, databaseProvider?: DatabaseProviderType | null, databaseEngine?: DatabaseEngineType | null, name: string, productionDeployment?: { __typename?: 'Deployment', id: string, description?: string | null, version: string, status: DeploymentStatus, branch?: string | null, endpoints?: Array<string> | null, privateEndpoint?: string | null, errorMessage?: string | null, updatedAt: Date, createdAt: Date, deployStatus?: { __typename?: 'DeployStatus', active: boolean, replicas: number, publicIPs?: Array<string> | null, state: string, errorMessage?: string | null, troubleshooting?: { __typename?: 'Troubleshooting', issue?: { __typename?: 'TroubleshootingIssue', blocks?: Array<{ __typename?: 'TroubleshootingIssueBlock', blockType?: TroubleshootingIssueBlockType | null, content?: string | null }> | null } | null } | null } | null, build?: { __typename?: 'Build', id: string, image?: string | null } | null, alternativeImages?: Array<{ __typename?: 'AlternativeImage', reference?: string | null, tag?: string | null, name?: string | null }> | null } | null, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, projectID?: string | null } | null, gpu?: { __typename?: 'GPUSpec', type?: string | null, count: number } | null, tpu?: { __typename?: 'TPUSpec', tfVersion: string, type: string, cores: number } | null, cluster?: { __typename?: 'Cluster', id: string, name: string, domain?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null } | null, autoscaling?: { __typename?: 'Autoscaling', minReplicas: number, maxReplicas: number } | null, owner: { __typename?: 'User', id: string, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, owner: { __typename?: 'User', id: string, login: any } } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null } | null }> } | null, projectV3Adapters?: { __typename?: 'ProjectV3AdapterConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor: string, endCursor: string, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'ProjectV3Adapter', id: string, name: string, project?: { __typename?: 'Project', id: string, name: string } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null }> } | null, components?: Array<{ __typename?: 'ClusterComponent', name: string, type: ClusterComponentType, status: ClusterComponentEjectedStatus, isInstalledByZeet: boolean, exists: boolean, project?: { __typename?: 'ProjectV3Adapter', id: string, name: string, project?: { __typename?: 'Project', name: string } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', name: string } | null } | null, helmMetadata?: { __typename?: 'HelmClusterComponentMetadata', values: string, namespace: string, releaseName: string, chartRepoGuess?: string | null, chartVersion: string, chartName: string } | null, terraformMetadata?: { __typename?: 'TerraformClusterComponentMetadata', jobRunState?: JobRunState | null } | null } | null> | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null, cloudAccount?: { __typename?: 'AWSAccount', id: string } | { __typename?: 'AzureAccount', id: string } | { __typename?: 'CoreWeaveAccount', id: string } | { __typename?: 'DOAccount', id: string } | { __typename?: 'GCPAccount', id: string } | { __typename?: 'LinodeAccount', id: string } | { __typename?: 'VultrAccount', id: string } | null, containerRegistry?: { __typename?: 'ContainerRegistry', id: string, name: string, credentialProvider?: ContainerRegistryCredentialProvider | null, username?: string | null } | null } };

export type UpdateClusterDetailsExternalLinkMutationVariables = Exact<{
  updateClusterInput: UpdateClusterInput;
  updateClusterDomainInput: UpdateClusterDomainInput;
  linkCloudToClusterInput: LinkCloudToClusterInput;
}>;


export type UpdateClusterDetailsExternalLinkMutation = { __typename?: 'Mutation', updateCluster: { __typename?: 'Cluster', id: string, ingressIP?: string | null, ingressDNS?: string | null, clusterProvider?: ClusterProvider | null, cloudProvider?: CloudProvider | null, terraformProjectUrl?: string | null, containerRepository?: string | null, containerCacheRepository?: string | null, name: string, region?: string | null, state: ClusterState, status?: ClusterStatus | null, connected?: boolean | null, domain?: string | null, isExternal?: boolean | null, isEjected?: boolean | null, updatedAt: Date, createdAt: Date, prometheus?: { __typename?: 'Prometheus', url: string, user?: string | null, password?: string | null, token?: string | null } | null, grafana?: { __typename?: 'Grafana', url: string, user?: string | null, password?: string | null } | null, deployJob?: { __typename?: 'JobRun', id: string, state: JobRunState } | null, projects?: { __typename?: 'ProjectConnection', pageInfo: { __typename?: 'PageInfo', startCursor: string, endCursor: string, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'Project', id: string, repo?: { __typename?: 'Repo', id: string, path: string, enabled: boolean, productionBranch?: string | null, deployTarget?: DeployTarget | null, deployType?: DeployType | null, deployService?: boolean | null, deployJob?: boolean | null, image?: string | null, cpu?: string | null, memory?: string | null, updatedAt: Date, disableReason?: DisableReason | null, databaseProvider?: DatabaseProviderType | null, databaseEngine?: DatabaseEngineType | null, name: string, productionDeployment?: { __typename?: 'Deployment', id: string, description?: string | null, version: string, status: DeploymentStatus, branch?: string | null, endpoints?: Array<string> | null, privateEndpoint?: string | null, errorMessage?: string | null, updatedAt: Date, createdAt: Date, deployStatus?: { __typename?: 'DeployStatus', active: boolean, replicas: number, publicIPs?: Array<string> | null, state: string, errorMessage?: string | null, troubleshooting?: { __typename?: 'Troubleshooting', issue?: { __typename?: 'TroubleshootingIssue', blocks?: Array<{ __typename?: 'TroubleshootingIssueBlock', blockType?: TroubleshootingIssueBlockType | null, content?: string | null }> | null } | null } | null } | null, build?: { __typename?: 'Build', id: string, image?: string | null } | null, alternativeImages?: Array<{ __typename?: 'AlternativeImage', reference?: string | null, tag?: string | null, name?: string | null }> | null } | null, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, projectID?: string | null } | null, gpu?: { __typename?: 'GPUSpec', type?: string | null, count: number } | null, tpu?: { __typename?: 'TPUSpec', tfVersion: string, type: string, cores: number } | null, cluster?: { __typename?: 'Cluster', id: string, name: string, domain?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null } | null, autoscaling?: { __typename?: 'Autoscaling', minReplicas: number, maxReplicas: number } | null, owner: { __typename?: 'User', id: string, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, owner: { __typename?: 'User', id: string, login: any } } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null } | null }> } | null, projectV3Adapters?: { __typename?: 'ProjectV3AdapterConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor: string, endCursor: string, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'ProjectV3Adapter', id: string, name: string, project?: { __typename?: 'Project', id: string, name: string } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null }> } | null, components?: Array<{ __typename?: 'ClusterComponent', name: string, type: ClusterComponentType, status: ClusterComponentEjectedStatus, isInstalledByZeet: boolean, exists: boolean, project?: { __typename?: 'ProjectV3Adapter', id: string, name: string, project?: { __typename?: 'Project', name: string } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', name: string } | null } | null, helmMetadata?: { __typename?: 'HelmClusterComponentMetadata', values: string, namespace: string, releaseName: string, chartRepoGuess?: string | null, chartVersion: string, chartName: string } | null, terraformMetadata?: { __typename?: 'TerraformClusterComponentMetadata', jobRunState?: JobRunState | null } | null } | null> | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null, cloudAccount?: { __typename?: 'AWSAccount', id: string } | { __typename?: 'AzureAccount', id: string } | { __typename?: 'CoreWeaveAccount', id: string } | { __typename?: 'DOAccount', id: string } | { __typename?: 'GCPAccount', id: string } | { __typename?: 'LinodeAccount', id: string } | { __typename?: 'VultrAccount', id: string } | null, containerRegistry?: { __typename?: 'ContainerRegistry', id: string, name: string, credentialProvider?: ContainerRegistryCredentialProvider | null, username?: string | null } | null }, updateClusterDomain: { __typename?: 'Cluster', id: string, ingressIP?: string | null, ingressDNS?: string | null, clusterProvider?: ClusterProvider | null, cloudProvider?: CloudProvider | null, terraformProjectUrl?: string | null, containerRepository?: string | null, containerCacheRepository?: string | null, name: string, region?: string | null, state: ClusterState, status?: ClusterStatus | null, connected?: boolean | null, domain?: string | null, isExternal?: boolean | null, isEjected?: boolean | null, updatedAt: Date, createdAt: Date, prometheus?: { __typename?: 'Prometheus', url: string, user?: string | null, password?: string | null, token?: string | null } | null, grafana?: { __typename?: 'Grafana', url: string, user?: string | null, password?: string | null } | null, deployJob?: { __typename?: 'JobRun', id: string, state: JobRunState } | null, projects?: { __typename?: 'ProjectConnection', pageInfo: { __typename?: 'PageInfo', startCursor: string, endCursor: string, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'Project', id: string, repo?: { __typename?: 'Repo', id: string, path: string, enabled: boolean, productionBranch?: string | null, deployTarget?: DeployTarget | null, deployType?: DeployType | null, deployService?: boolean | null, deployJob?: boolean | null, image?: string | null, cpu?: string | null, memory?: string | null, updatedAt: Date, disableReason?: DisableReason | null, databaseProvider?: DatabaseProviderType | null, databaseEngine?: DatabaseEngineType | null, name: string, productionDeployment?: { __typename?: 'Deployment', id: string, description?: string | null, version: string, status: DeploymentStatus, branch?: string | null, endpoints?: Array<string> | null, privateEndpoint?: string | null, errorMessage?: string | null, updatedAt: Date, createdAt: Date, deployStatus?: { __typename?: 'DeployStatus', active: boolean, replicas: number, publicIPs?: Array<string> | null, state: string, errorMessage?: string | null, troubleshooting?: { __typename?: 'Troubleshooting', issue?: { __typename?: 'TroubleshootingIssue', blocks?: Array<{ __typename?: 'TroubleshootingIssueBlock', blockType?: TroubleshootingIssueBlockType | null, content?: string | null }> | null } | null } | null } | null, build?: { __typename?: 'Build', id: string, image?: string | null } | null, alternativeImages?: Array<{ __typename?: 'AlternativeImage', reference?: string | null, tag?: string | null, name?: string | null }> | null } | null, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, projectID?: string | null } | null, gpu?: { __typename?: 'GPUSpec', type?: string | null, count: number } | null, tpu?: { __typename?: 'TPUSpec', tfVersion: string, type: string, cores: number } | null, cluster?: { __typename?: 'Cluster', id: string, name: string, domain?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null } | null, autoscaling?: { __typename?: 'Autoscaling', minReplicas: number, maxReplicas: number } | null, owner: { __typename?: 'User', id: string, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, owner: { __typename?: 'User', id: string, login: any } } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null } | null }> } | null, projectV3Adapters?: { __typename?: 'ProjectV3AdapterConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor: string, endCursor: string, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'ProjectV3Adapter', id: string, name: string, project?: { __typename?: 'Project', id: string, name: string } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null }> } | null, components?: Array<{ __typename?: 'ClusterComponent', name: string, type: ClusterComponentType, status: ClusterComponentEjectedStatus, isInstalledByZeet: boolean, exists: boolean, project?: { __typename?: 'ProjectV3Adapter', id: string, name: string, project?: { __typename?: 'Project', name: string } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', name: string } | null } | null, helmMetadata?: { __typename?: 'HelmClusterComponentMetadata', values: string, namespace: string, releaseName: string, chartRepoGuess?: string | null, chartVersion: string, chartName: string } | null, terraformMetadata?: { __typename?: 'TerraformClusterComponentMetadata', jobRunState?: JobRunState | null } | null } | null> | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null, cloudAccount?: { __typename?: 'AWSAccount', id: string } | { __typename?: 'AzureAccount', id: string } | { __typename?: 'CoreWeaveAccount', id: string } | { __typename?: 'DOAccount', id: string } | { __typename?: 'GCPAccount', id: string } | { __typename?: 'LinodeAccount', id: string } | { __typename?: 'VultrAccount', id: string } | null, containerRegistry?: { __typename?: 'ContainerRegistry', id: string, name: string, credentialProvider?: ContainerRegistryCredentialProvider | null, username?: string | null } | null }, linkCloudToCluster: { __typename?: 'Cluster', id: string, ingressIP?: string | null, ingressDNS?: string | null, clusterProvider?: ClusterProvider | null, cloudProvider?: CloudProvider | null, terraformProjectUrl?: string | null, containerRepository?: string | null, containerCacheRepository?: string | null, name: string, region?: string | null, state: ClusterState, status?: ClusterStatus | null, connected?: boolean | null, domain?: string | null, isExternal?: boolean | null, isEjected?: boolean | null, updatedAt: Date, createdAt: Date, prometheus?: { __typename?: 'Prometheus', url: string, user?: string | null, password?: string | null, token?: string | null } | null, grafana?: { __typename?: 'Grafana', url: string, user?: string | null, password?: string | null } | null, deployJob?: { __typename?: 'JobRun', id: string, state: JobRunState } | null, projects?: { __typename?: 'ProjectConnection', pageInfo: { __typename?: 'PageInfo', startCursor: string, endCursor: string, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'Project', id: string, repo?: { __typename?: 'Repo', id: string, path: string, enabled: boolean, productionBranch?: string | null, deployTarget?: DeployTarget | null, deployType?: DeployType | null, deployService?: boolean | null, deployJob?: boolean | null, image?: string | null, cpu?: string | null, memory?: string | null, updatedAt: Date, disableReason?: DisableReason | null, databaseProvider?: DatabaseProviderType | null, databaseEngine?: DatabaseEngineType | null, name: string, productionDeployment?: { __typename?: 'Deployment', id: string, description?: string | null, version: string, status: DeploymentStatus, branch?: string | null, endpoints?: Array<string> | null, privateEndpoint?: string | null, errorMessage?: string | null, updatedAt: Date, createdAt: Date, deployStatus?: { __typename?: 'DeployStatus', active: boolean, replicas: number, publicIPs?: Array<string> | null, state: string, errorMessage?: string | null, troubleshooting?: { __typename?: 'Troubleshooting', issue?: { __typename?: 'TroubleshootingIssue', blocks?: Array<{ __typename?: 'TroubleshootingIssueBlock', blockType?: TroubleshootingIssueBlockType | null, content?: string | null }> | null } | null } | null } | null, build?: { __typename?: 'Build', id: string, image?: string | null } | null, alternativeImages?: Array<{ __typename?: 'AlternativeImage', reference?: string | null, tag?: string | null, name?: string | null }> | null } | null, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, projectID?: string | null } | null, gpu?: { __typename?: 'GPUSpec', type?: string | null, count: number } | null, tpu?: { __typename?: 'TPUSpec', tfVersion: string, type: string, cores: number } | null, cluster?: { __typename?: 'Cluster', id: string, name: string, domain?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null } | null, autoscaling?: { __typename?: 'Autoscaling', minReplicas: number, maxReplicas: number } | null, owner: { __typename?: 'User', id: string, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, owner: { __typename?: 'User', id: string, login: any } } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null } | null }> } | null, projectV3Adapters?: { __typename?: 'ProjectV3AdapterConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor: string, endCursor: string, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'ProjectV3Adapter', id: string, name: string, project?: { __typename?: 'Project', id: string, name: string } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null }> } | null, components?: Array<{ __typename?: 'ClusterComponent', name: string, type: ClusterComponentType, status: ClusterComponentEjectedStatus, isInstalledByZeet: boolean, exists: boolean, project?: { __typename?: 'ProjectV3Adapter', id: string, name: string, project?: { __typename?: 'Project', name: string } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', name: string } | null } | null, helmMetadata?: { __typename?: 'HelmClusterComponentMetadata', values: string, namespace: string, releaseName: string, chartRepoGuess?: string | null, chartVersion: string, chartName: string } | null, terraformMetadata?: { __typename?: 'TerraformClusterComponentMetadata', jobRunState?: JobRunState | null } | null } | null> | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null, cloudAccount?: { __typename?: 'AWSAccount', id: string } | { __typename?: 'AzureAccount', id: string } | { __typename?: 'CoreWeaveAccount', id: string } | { __typename?: 'DOAccount', id: string } | { __typename?: 'GCPAccount', id: string } | { __typename?: 'LinodeAccount', id: string } | { __typename?: 'VultrAccount', id: string } | null, containerRegistry?: { __typename?: 'ContainerRegistry', id: string, name: string, credentialProvider?: ContainerRegistryCredentialProvider | null, username?: string | null } | null } };

export type UpdateClusterDetailsZeetMutationVariables = Exact<{
  updateClusterInput: UpdateClusterInput;
}>;


export type UpdateClusterDetailsZeetMutation = { __typename?: 'Mutation', updateCluster: { __typename?: 'Cluster', id: string, ingressIP?: string | null, ingressDNS?: string | null, clusterProvider?: ClusterProvider | null, cloudProvider?: CloudProvider | null, terraformProjectUrl?: string | null, containerRepository?: string | null, containerCacheRepository?: string | null, name: string, region?: string | null, state: ClusterState, status?: ClusterStatus | null, connected?: boolean | null, domain?: string | null, isExternal?: boolean | null, isEjected?: boolean | null, updatedAt: Date, createdAt: Date, prometheus?: { __typename?: 'Prometheus', url: string, user?: string | null, password?: string | null, token?: string | null } | null, grafana?: { __typename?: 'Grafana', url: string, user?: string | null, password?: string | null } | null, deployJob?: { __typename?: 'JobRun', id: string, state: JobRunState } | null, projects?: { __typename?: 'ProjectConnection', pageInfo: { __typename?: 'PageInfo', startCursor: string, endCursor: string, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'Project', id: string, repo?: { __typename?: 'Repo', id: string, path: string, enabled: boolean, productionBranch?: string | null, deployTarget?: DeployTarget | null, deployType?: DeployType | null, deployService?: boolean | null, deployJob?: boolean | null, image?: string | null, cpu?: string | null, memory?: string | null, updatedAt: Date, disableReason?: DisableReason | null, databaseProvider?: DatabaseProviderType | null, databaseEngine?: DatabaseEngineType | null, name: string, productionDeployment?: { __typename?: 'Deployment', id: string, description?: string | null, version: string, status: DeploymentStatus, branch?: string | null, endpoints?: Array<string> | null, privateEndpoint?: string | null, errorMessage?: string | null, updatedAt: Date, createdAt: Date, deployStatus?: { __typename?: 'DeployStatus', active: boolean, replicas: number, publicIPs?: Array<string> | null, state: string, errorMessage?: string | null, troubleshooting?: { __typename?: 'Troubleshooting', issue?: { __typename?: 'TroubleshootingIssue', blocks?: Array<{ __typename?: 'TroubleshootingIssueBlock', blockType?: TroubleshootingIssueBlockType | null, content?: string | null }> | null } | null } | null } | null, build?: { __typename?: 'Build', id: string, image?: string | null } | null, alternativeImages?: Array<{ __typename?: 'AlternativeImage', reference?: string | null, tag?: string | null, name?: string | null }> | null } | null, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, projectID?: string | null } | null, gpu?: { __typename?: 'GPUSpec', type?: string | null, count: number } | null, tpu?: { __typename?: 'TPUSpec', tfVersion: string, type: string, cores: number } | null, cluster?: { __typename?: 'Cluster', id: string, name: string, domain?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null } | null, autoscaling?: { __typename?: 'Autoscaling', minReplicas: number, maxReplicas: number } | null, owner: { __typename?: 'User', id: string, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, owner: { __typename?: 'User', id: string, login: any } } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null } | null }> } | null, projectV3Adapters?: { __typename?: 'ProjectV3AdapterConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor: string, endCursor: string, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'ProjectV3Adapter', id: string, name: string, project?: { __typename?: 'Project', id: string, name: string } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null }> } | null, components?: Array<{ __typename?: 'ClusterComponent', name: string, type: ClusterComponentType, status: ClusterComponentEjectedStatus, isInstalledByZeet: boolean, exists: boolean, project?: { __typename?: 'ProjectV3Adapter', id: string, name: string, project?: { __typename?: 'Project', name: string } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', name: string } | null } | null, helmMetadata?: { __typename?: 'HelmClusterComponentMetadata', values: string, namespace: string, releaseName: string, chartRepoGuess?: string | null, chartVersion: string, chartName: string } | null, terraformMetadata?: { __typename?: 'TerraformClusterComponentMetadata', jobRunState?: JobRunState | null } | null } | null> | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null, cloudAccount?: { __typename?: 'AWSAccount', id: string } | { __typename?: 'AzureAccount', id: string } | { __typename?: 'CoreWeaveAccount', id: string } | { __typename?: 'DOAccount', id: string } | { __typename?: 'GCPAccount', id: string } | { __typename?: 'LinodeAccount', id: string } | { __typename?: 'VultrAccount', id: string } | null, containerRegistry?: { __typename?: 'ContainerRegistry', id: string, name: string, credentialProvider?: ContainerRegistryCredentialProvider | null, username?: string | null } | null } };

export type UpdateClusterDetailsZeetLinkMutationVariables = Exact<{
  updateClusterInput: UpdateClusterInput;
  linkCloudToClusterInput: LinkCloudToClusterInput;
}>;


export type UpdateClusterDetailsZeetLinkMutation = { __typename?: 'Mutation', updateCluster: { __typename?: 'Cluster', id: string, ingressIP?: string | null, ingressDNS?: string | null, clusterProvider?: ClusterProvider | null, cloudProvider?: CloudProvider | null, terraformProjectUrl?: string | null, containerRepository?: string | null, containerCacheRepository?: string | null, name: string, region?: string | null, state: ClusterState, status?: ClusterStatus | null, connected?: boolean | null, domain?: string | null, isExternal?: boolean | null, isEjected?: boolean | null, updatedAt: Date, createdAt: Date, prometheus?: { __typename?: 'Prometheus', url: string, user?: string | null, password?: string | null, token?: string | null } | null, grafana?: { __typename?: 'Grafana', url: string, user?: string | null, password?: string | null } | null, deployJob?: { __typename?: 'JobRun', id: string, state: JobRunState } | null, projects?: { __typename?: 'ProjectConnection', pageInfo: { __typename?: 'PageInfo', startCursor: string, endCursor: string, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'Project', id: string, repo?: { __typename?: 'Repo', id: string, path: string, enabled: boolean, productionBranch?: string | null, deployTarget?: DeployTarget | null, deployType?: DeployType | null, deployService?: boolean | null, deployJob?: boolean | null, image?: string | null, cpu?: string | null, memory?: string | null, updatedAt: Date, disableReason?: DisableReason | null, databaseProvider?: DatabaseProviderType | null, databaseEngine?: DatabaseEngineType | null, name: string, productionDeployment?: { __typename?: 'Deployment', id: string, description?: string | null, version: string, status: DeploymentStatus, branch?: string | null, endpoints?: Array<string> | null, privateEndpoint?: string | null, errorMessage?: string | null, updatedAt: Date, createdAt: Date, deployStatus?: { __typename?: 'DeployStatus', active: boolean, replicas: number, publicIPs?: Array<string> | null, state: string, errorMessage?: string | null, troubleshooting?: { __typename?: 'Troubleshooting', issue?: { __typename?: 'TroubleshootingIssue', blocks?: Array<{ __typename?: 'TroubleshootingIssueBlock', blockType?: TroubleshootingIssueBlockType | null, content?: string | null }> | null } | null } | null } | null, build?: { __typename?: 'Build', id: string, image?: string | null } | null, alternativeImages?: Array<{ __typename?: 'AlternativeImage', reference?: string | null, tag?: string | null, name?: string | null }> | null } | null, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, projectID?: string | null } | null, gpu?: { __typename?: 'GPUSpec', type?: string | null, count: number } | null, tpu?: { __typename?: 'TPUSpec', tfVersion: string, type: string, cores: number } | null, cluster?: { __typename?: 'Cluster', id: string, name: string, domain?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null } | null, autoscaling?: { __typename?: 'Autoscaling', minReplicas: number, maxReplicas: number } | null, owner: { __typename?: 'User', id: string, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, owner: { __typename?: 'User', id: string, login: any } } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null } | null }> } | null, projectV3Adapters?: { __typename?: 'ProjectV3AdapterConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor: string, endCursor: string, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'ProjectV3Adapter', id: string, name: string, project?: { __typename?: 'Project', id: string, name: string } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null }> } | null, components?: Array<{ __typename?: 'ClusterComponent', name: string, type: ClusterComponentType, status: ClusterComponentEjectedStatus, isInstalledByZeet: boolean, exists: boolean, project?: { __typename?: 'ProjectV3Adapter', id: string, name: string, project?: { __typename?: 'Project', name: string } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', name: string } | null } | null, helmMetadata?: { __typename?: 'HelmClusterComponentMetadata', values: string, namespace: string, releaseName: string, chartRepoGuess?: string | null, chartVersion: string, chartName: string } | null, terraformMetadata?: { __typename?: 'TerraformClusterComponentMetadata', jobRunState?: JobRunState | null } | null } | null> | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null, cloudAccount?: { __typename?: 'AWSAccount', id: string } | { __typename?: 'AzureAccount', id: string } | { __typename?: 'CoreWeaveAccount', id: string } | { __typename?: 'DOAccount', id: string } | { __typename?: 'GCPAccount', id: string } | { __typename?: 'LinodeAccount', id: string } | { __typename?: 'VultrAccount', id: string } | null, containerRegistry?: { __typename?: 'ContainerRegistry', id: string, name: string, credentialProvider?: ContainerRegistryCredentialProvider | null, username?: string | null } | null }, linkCloudToCluster: { __typename?: 'Cluster', id: string, ingressIP?: string | null, ingressDNS?: string | null, clusterProvider?: ClusterProvider | null, cloudProvider?: CloudProvider | null, terraformProjectUrl?: string | null, containerRepository?: string | null, containerCacheRepository?: string | null, name: string, region?: string | null, state: ClusterState, status?: ClusterStatus | null, connected?: boolean | null, domain?: string | null, isExternal?: boolean | null, isEjected?: boolean | null, updatedAt: Date, createdAt: Date, prometheus?: { __typename?: 'Prometheus', url: string, user?: string | null, password?: string | null, token?: string | null } | null, grafana?: { __typename?: 'Grafana', url: string, user?: string | null, password?: string | null } | null, deployJob?: { __typename?: 'JobRun', id: string, state: JobRunState } | null, projects?: { __typename?: 'ProjectConnection', pageInfo: { __typename?: 'PageInfo', startCursor: string, endCursor: string, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'Project', id: string, repo?: { __typename?: 'Repo', id: string, path: string, enabled: boolean, productionBranch?: string | null, deployTarget?: DeployTarget | null, deployType?: DeployType | null, deployService?: boolean | null, deployJob?: boolean | null, image?: string | null, cpu?: string | null, memory?: string | null, updatedAt: Date, disableReason?: DisableReason | null, databaseProvider?: DatabaseProviderType | null, databaseEngine?: DatabaseEngineType | null, name: string, productionDeployment?: { __typename?: 'Deployment', id: string, description?: string | null, version: string, status: DeploymentStatus, branch?: string | null, endpoints?: Array<string> | null, privateEndpoint?: string | null, errorMessage?: string | null, updatedAt: Date, createdAt: Date, deployStatus?: { __typename?: 'DeployStatus', active: boolean, replicas: number, publicIPs?: Array<string> | null, state: string, errorMessage?: string | null, troubleshooting?: { __typename?: 'Troubleshooting', issue?: { __typename?: 'TroubleshootingIssue', blocks?: Array<{ __typename?: 'TroubleshootingIssueBlock', blockType?: TroubleshootingIssueBlockType | null, content?: string | null }> | null } | null } | null } | null, build?: { __typename?: 'Build', id: string, image?: string | null } | null, alternativeImages?: Array<{ __typename?: 'AlternativeImage', reference?: string | null, tag?: string | null, name?: string | null }> | null } | null, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, projectID?: string | null } | null, gpu?: { __typename?: 'GPUSpec', type?: string | null, count: number } | null, tpu?: { __typename?: 'TPUSpec', tfVersion: string, type: string, cores: number } | null, cluster?: { __typename?: 'Cluster', id: string, name: string, domain?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null } | null, autoscaling?: { __typename?: 'Autoscaling', minReplicas: number, maxReplicas: number } | null, owner: { __typename?: 'User', id: string, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, owner: { __typename?: 'User', id: string, login: any } } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null } | null }> } | null, projectV3Adapters?: { __typename?: 'ProjectV3AdapterConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor: string, endCursor: string, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'ProjectV3Adapter', id: string, name: string, project?: { __typename?: 'Project', id: string, name: string } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null }> } | null, components?: Array<{ __typename?: 'ClusterComponent', name: string, type: ClusterComponentType, status: ClusterComponentEjectedStatus, isInstalledByZeet: boolean, exists: boolean, project?: { __typename?: 'ProjectV3Adapter', id: string, name: string, project?: { __typename?: 'Project', name: string } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', name: string } | null } | null, helmMetadata?: { __typename?: 'HelmClusterComponentMetadata', values: string, namespace: string, releaseName: string, chartRepoGuess?: string | null, chartVersion: string, chartName: string } | null, terraformMetadata?: { __typename?: 'TerraformClusterComponentMetadata', jobRunState?: JobRunState | null } | null } | null> | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null, cloudAccount?: { __typename?: 'AWSAccount', id: string } | { __typename?: 'AzureAccount', id: string } | { __typename?: 'CoreWeaveAccount', id: string } | { __typename?: 'DOAccount', id: string } | { __typename?: 'GCPAccount', id: string } | { __typename?: 'LinodeAccount', id: string } | { __typename?: 'VultrAccount', id: string } | null, containerRegistry?: { __typename?: 'ContainerRegistry', id: string, name: string, credentialProvider?: ContainerRegistryCredentialProvider | null, username?: string | null } | null } };

export type CreateProjectDockerMutationVariables = Exact<{
  input?: InputMaybe<CreateProjectDockerInput>;
}>;


export type CreateProjectDockerMutation = { __typename?: 'Mutation', createProjectDocker: { __typename?: 'Repo', appID?: string | null, defaultIngressDomain?: string | null, kappID?: string | null, useHumanReadableKubernetesName?: boolean | null, namespace?: string | null, deployTarget?: DeployTarget | null, manualDeploy?: boolean | null, deployStrategy?: DeployStrategy | null, free?: boolean | null, cpu?: string | null, memory?: string | null, ephemeralStorage?: number | null, dedicated?: boolean | null, productionBranch?: string | null, serverlessRegion?: string | null, helmValues?: string | null, terraformVersion?: string | null, terraformVariables?: any | null, deployService?: boolean | null, deployJob?: boolean | null, preStopSleep?: number | null, terminationGracePeriodSeconds?: number | null, databaseProvider?: DatabaseProviderType | null, databaseEngine?: DatabaseEngineType | null, databaseVersion?: string | null, autoRetry?: boolean | null, autoRollback?: boolean | null, canDeploy?: boolean | null, awsIamRole?: string | null, gcpServiceAccount?: string | null, datadogApmEnabled?: boolean | null, deployTimeoutSeconds?: number | null, id: string, path: string, enabled: boolean, deployType?: DeployType | null, image?: string | null, updatedAt: Date, disableReason?: DisableReason | null, hostNetwork?: boolean | null, staticIP?: boolean | null, noBuildCache?: boolean | null, gitSubmodules?: GitSubmodulesType | null, alternativeImageTagTemplates?: Array<string> | null, name: string, secretMounts?: Array<{ __typename?: 'KubernetesSecretMount', secretName: string, mountPath: string, readOnly: boolean }> | null, kubernetesCustomization?: { __typename?: 'KubernetesCustomization', serviceAccountName?: string | null, podAnnotations?: any | null, serviceAnnotations?: any | null, ingressAnnotations?: any | null } | null, manifest?: { __typename?: 'Manifest', manifests?: Array<string> | null, manifestValue?: string | null, kustomizeDirs?: Array<string> | null } | null, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, environments: Array<{ __typename?: 'ProjectEnvironment', id: string, name: string }>, envs?: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string, visible: boolean, sealed: boolean, source?: { __typename?: 'EnvVarSource', type: EnvVarSourceType } | null }> | null, owner: { __typename?: 'User', id: string, login: any } } | null, productionDeployment?: { __typename?: 'Deployment', id: string, description?: string | null, version: string, status: DeploymentStatus, branch?: string | null, endpoints?: Array<string> | null, privateEndpoint?: string | null, errorMessage?: string | null, updatedAt: Date, createdAt: Date, awsLinks?: { __typename?: 'AWSLinks', rds?: string | null, cloudformation?: string | null, lambda?: string | null, apiGateway?: string | null, cloudwatchLogs?: string | null, cloudwatchMetrics?: string | null } | null, gcpLinks?: { __typename?: 'GCPLinks', deploymentManager?: string | null, cloudRun?: string | null, cloudFunctions?: string | null, cloudFunctionsTrigger?: string | null, cloudLogging?: string | null, cloudMonitoring?: string | null } | null, loadBalancers?: Array<{ __typename?: 'LoadBalancer', dns: Array<string>, ips: Array<string>, ports?: Array<number> | null }> | null, deployStatus?: { __typename?: 'DeployStatus', active: boolean, replicas: number, publicIPs?: Array<string> | null, state: string, errorMessage?: string | null, troubleshooting?: { __typename?: 'Troubleshooting', issue?: { __typename?: 'TroubleshootingIssue', blocks?: Array<{ __typename?: 'TroubleshootingIssueBlock', blockType?: TroubleshootingIssueBlockType | null, content?: string | null }> | null } | null } | null } | null, build?: { __typename?: 'Build', id: string, image?: string | null } | null, alternativeImages?: Array<{ __typename?: 'AlternativeImage', reference?: string | null, tag?: string | null, name?: string | null }> | null } | null, envs?: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string, visible: boolean, sealed: boolean, source?: { __typename?: 'EnvVarSource', type: EnvVarSourceType } | null }> | null, collaborators?: Array<{ __typename?: 'ProjectCollaborator', id: string, role: ProjectCollaboratorRole, user: { __typename?: 'User', id: string, name: string, login: any, avatar?: string | null, isTeam?: boolean | null } }> | null, volumes?: Array<{ __typename?: 'VolumeSpec', mountPath: string, size: number }> | null, replication?: Array<{ __typename?: 'Replication', region: string, replicas?: number | null, cluster?: { __typename?: 'Cluster', id: string, name: string, region?: string | null } | null }> | null, cluster?: { __typename?: 'Cluster', id: string, name: string, region?: string | null, ingressIP?: string | null, connected?: boolean | null, staticIPs?: Array<string> | null, cloudProvider?: CloudProvider | null, clusterProvider?: ClusterProvider | null, state: ClusterState, domain?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, projectID?: string | null } | null, logShipper?: { __typename?: 'LogShipper', type: LogShipperType, logz?: { __typename?: 'LogzIntegration', token: string, url?: string | null } | null, syslog?: { __typename?: 'SyslogIntegration', host: string, port: string, mode: string } | null, logDNA?: { __typename?: 'LogDNAIntegration', key: string } | null, datadog?: { __typename?: 'DatadogLogIntegration', key: string, host?: string | null } | null, betterstack?: { __typename?: 'BetterStackIntegration', token: string } | null } | null, readinessProbe?: { __typename?: 'Probe', command?: string | null, initialDelaySeconds: number, periodSeconds: number, successThreshold: number, failureThreshold: number, timeoutSeconds: number, http?: { __typename?: 'HTTPProbe', host?: string | null, port: string, path?: string | null } | null, tcp?: { __typename?: 'TCPProbe', host?: string | null, port: string } | null } | null, livenessProbe?: { __typename?: 'Probe', command?: string | null, initialDelaySeconds: number, periodSeconds: number, successThreshold: number, failureThreshold: number, timeoutSeconds: number, http?: { __typename?: 'HTTPProbe', host?: string | null, port: string, path?: string | null } | null, tcp?: { __typename?: 'TCPProbe', host?: string | null, port: string } | null } | null, startupProbe?: { __typename?: 'Probe', command?: string | null, initialDelaySeconds: number, periodSeconds: number, successThreshold: number, failureThreshold: number, timeoutSeconds: number, http?: { __typename?: 'HTTPProbe', host?: string | null, port: string, path?: string | null } | null, tcp?: { __typename?: 'TCPProbe', host?: string | null, port: string } | null } | null, gpu?: { __typename?: 'GPUSpec', type?: string | null, count: number } | null, tpu?: { __typename?: 'TPUSpec', type: string, cores: number, tfVersion: string } | null, githubIntegration?: { __typename?: 'GitHubRepoIntegration', id: string, autoDeployBranch: boolean, autoStopBranch: boolean, branchIgnore: string, branchStopIgnore: string, githubRepository?: { __typename?: 'GitHubRepository', id: string, owner: string, name: string } | null } | null, gitlabIntegration?: { __typename?: 'GitlabRepoIntegration', id: string, autoDeployBranch: boolean, autoStopBranch: boolean, branchIgnore: string, branchStopIgnore: string } | null, branchResources?: { __typename?: 'ContainerResourcesSpec', cpu?: number | null, memory?: number | null, ephemeralStorage?: number | null, spot?: boolean | null, accelerator?: { __typename?: 'AcceleratorSpec', type?: string | null, count?: number | null } | null } | null, serverlessResources?: { __typename?: 'ServerlessResourceSpec', cpu?: number | null, memory?: number | null } | null, prometheusScrape?: { __typename?: 'PrometheusScrape', path: string, port: number } | null, jobRuns?: { __typename?: 'JobRunConnection', totalCount: number } | null, autoscaling?: { __typename?: 'Autoscaling', kedaScaledObjectSpec?: string | null, minReplicas: number, maxReplicas: number, coolDownPeriod?: number | null, triggers?: Array<{ __typename?: 'AutoscalingTrigger', type: AutoscalingType, spec: any }> | null } | null, containerRegistry?: { __typename?: 'ContainerRegistry', id: string } | null, databaseEnvs: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string }>, databaseLinks: Array<{ __typename?: 'DatabaseLink', id: string, envPrefix?: string | null, envs?: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string }> | null, database: { __typename?: 'Repo', id: string, path: string, enabled: boolean, productionBranch?: string | null, deployTarget?: DeployTarget | null, deployType?: DeployType | null, deployService?: boolean | null, deployJob?: boolean | null, image?: string | null, cpu?: string | null, memory?: string | null, updatedAt: Date, disableReason?: DisableReason | null, databaseProvider?: DatabaseProviderType | null, databaseEngine?: DatabaseEngineType | null, name: string, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, projectID?: string | null } | null, gpu?: { __typename?: 'GPUSpec', type?: string | null, count: number } | null, tpu?: { __typename?: 'TPUSpec', tfVersion: string, type: string, cores: number } | null, cluster?: { __typename?: 'Cluster', id: string, name: string, domain?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null } | null, autoscaling?: { __typename?: 'Autoscaling', minReplicas: number, maxReplicas: number } | null, owner: { __typename?: 'User', id: string, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, owner: { __typename?: 'User', id: string, login: any } } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null } }>, linkedProjects: Array<{ __typename?: 'DatabaseLink', id: string, envPrefix?: string | null, repo: { __typename?: 'Repo', id: string, path: string, enabled: boolean, productionBranch?: string | null, deployTarget?: DeployTarget | null, deployType?: DeployType | null, deployService?: boolean | null, deployJob?: boolean | null, image?: string | null, cpu?: string | null, memory?: string | null, updatedAt: Date, disableReason?: DisableReason | null, databaseProvider?: DatabaseProviderType | null, databaseEngine?: DatabaseEngineType | null, name: string, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, projectID?: string | null } | null, gpu?: { __typename?: 'GPUSpec', type?: string | null, count: number } | null, tpu?: { __typename?: 'TPUSpec', tfVersion: string, type: string, cores: number } | null, cluster?: { __typename?: 'Cluster', id: string, name: string, domain?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null } | null, autoscaling?: { __typename?: 'Autoscaling', minReplicas: number, maxReplicas: number } | null, owner: { __typename?: 'User', id: string, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, owner: { __typename?: 'User', id: string, login: any } } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null } }>, pipelineCluster?: { __typename?: 'Cluster', id: string } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string, envs?: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string, visible: boolean, sealed: boolean, source?: { __typename?: 'EnvVarSource', type: EnvVarSourceType } | null }> | null } | null, pipelineLinks?: Array<{ __typename?: 'RepoPipelineLink', id: string, sourceEvent: RepoEvent, targetAction: RepoAction, source: { __typename?: 'Repo', id: string }, targetGroup: { __typename?: 'RepoGroup', id: string, selector?: { __typename?: 'LabelSelectors', matchLabels?: any | null } | null } }> | null, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null } | null, owner: { __typename?: 'User', id: string, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, clusterDomains?: Array<{ __typename?: 'ClusterDomains', id: string, cluster: { __typename?: 'Cluster', id: string, name: string }, domains?: Array<{ __typename?: 'CustomDomain', id: string, domain: string, isApex: boolean, cnameTargets?: Array<string> | null, ipTargets?: Array<string> | null, disableCertManager?: boolean | null, certManagerChallengeType?: CertManagerChallengeType | null, syncDomain?: { __typename?: 'CustomDomain', id: string } | null, instructions?: Array<{ __typename?: 'DNSRecord', domain: string, type: DnsRecordType, value?: string | null }> | null, certificate?: { __typename?: 'Certificate', dnsNames?: Array<string> | null, ready: boolean, issuing: boolean, challenges?: Array<{ __typename?: 'CertificateChallenge', dnsName: string, solver: string, statusReason: string, statusState: string, type: string, wildcard: boolean }> | null, instructions?: Array<{ __typename?: 'DNSRecord', domain: string, type: DnsRecordType, value?: string | null }> | null } | null }> | null }> | null, cdns?: Array<{ __typename?: 'CDN', id: string, endpoint?: string | null, state: string, domains?: Array<{ __typename?: 'CDNDomain', domain: string, certReady?: boolean | null, routeReady?: boolean | null, instruction?: { __typename?: 'DNSRecord', domain: string, type: DnsRecordType, value?: string | null } | null }> | null, certificate?: { __typename?: 'Certificate', dnsNames?: Array<string> | null, ready: boolean, issuing: boolean, instructions?: Array<{ __typename?: 'DNSRecord', name?: string | null, domain: string, type: DnsRecordType, value?: string | null }> | null } | null }> | null, ports?: Array<{ __typename?: 'Port', port: string, externalPort: string, protocol: string, public: boolean, https: boolean, grpc: boolean, loadBalancer: boolean }> | null, buildMethod?: { __typename?: 'BuildMethod', name: string, type: BuildType, workingDirectory?: string | null, dockerfilePath?: string | null, buildCommand?: string | null, staticPath?: string | null, runCommand?: string | null, releaseCommand?: string | null, nodejsVersion?: string | null, pythonVersion?: string | null, golangVersion?: string | null } | null, buildResources?: { __typename?: 'ContainerResourcesSpec', cpu?: number | null, memory?: number | null, ephemeralStorage?: number | null, spot?: boolean | null } | null, buildSpec?: { __typename?: 'ContainerSpec', cpu?: number | null, memory?: number | null } | null, kanikoFlags?: { __typename?: 'KanikoFlags', compressedCaching?: boolean | null } | null } };

export type CreateProjectGitMutationVariables = Exact<{
  input?: InputMaybe<CreateProjectGitInput>;
}>;


export type CreateProjectGitMutation = { __typename?: 'Mutation', createProjectGit: { __typename?: 'Repo', appID?: string | null, defaultIngressDomain?: string | null, kappID?: string | null, useHumanReadableKubernetesName?: boolean | null, namespace?: string | null, deployTarget?: DeployTarget | null, manualDeploy?: boolean | null, deployStrategy?: DeployStrategy | null, free?: boolean | null, cpu?: string | null, memory?: string | null, ephemeralStorage?: number | null, dedicated?: boolean | null, productionBranch?: string | null, serverlessRegion?: string | null, helmValues?: string | null, terraformVersion?: string | null, terraformVariables?: any | null, deployService?: boolean | null, deployJob?: boolean | null, preStopSleep?: number | null, terminationGracePeriodSeconds?: number | null, databaseProvider?: DatabaseProviderType | null, databaseEngine?: DatabaseEngineType | null, databaseVersion?: string | null, autoRetry?: boolean | null, autoRollback?: boolean | null, canDeploy?: boolean | null, awsIamRole?: string | null, gcpServiceAccount?: string | null, datadogApmEnabled?: boolean | null, deployTimeoutSeconds?: number | null, id: string, path: string, enabled: boolean, deployType?: DeployType | null, image?: string | null, updatedAt: Date, disableReason?: DisableReason | null, hostNetwork?: boolean | null, staticIP?: boolean | null, noBuildCache?: boolean | null, gitSubmodules?: GitSubmodulesType | null, alternativeImageTagTemplates?: Array<string> | null, name: string, secretMounts?: Array<{ __typename?: 'KubernetesSecretMount', secretName: string, mountPath: string, readOnly: boolean }> | null, kubernetesCustomization?: { __typename?: 'KubernetesCustomization', serviceAccountName?: string | null, podAnnotations?: any | null, serviceAnnotations?: any | null, ingressAnnotations?: any | null } | null, manifest?: { __typename?: 'Manifest', manifests?: Array<string> | null, manifestValue?: string | null, kustomizeDirs?: Array<string> | null } | null, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, environments: Array<{ __typename?: 'ProjectEnvironment', id: string, name: string }>, envs?: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string, visible: boolean, sealed: boolean, source?: { __typename?: 'EnvVarSource', type: EnvVarSourceType } | null }> | null, owner: { __typename?: 'User', id: string, login: any } } | null, productionDeployment?: { __typename?: 'Deployment', id: string, description?: string | null, version: string, status: DeploymentStatus, branch?: string | null, endpoints?: Array<string> | null, privateEndpoint?: string | null, errorMessage?: string | null, updatedAt: Date, createdAt: Date, awsLinks?: { __typename?: 'AWSLinks', rds?: string | null, cloudformation?: string | null, lambda?: string | null, apiGateway?: string | null, cloudwatchLogs?: string | null, cloudwatchMetrics?: string | null } | null, gcpLinks?: { __typename?: 'GCPLinks', deploymentManager?: string | null, cloudRun?: string | null, cloudFunctions?: string | null, cloudFunctionsTrigger?: string | null, cloudLogging?: string | null, cloudMonitoring?: string | null } | null, loadBalancers?: Array<{ __typename?: 'LoadBalancer', dns: Array<string>, ips: Array<string>, ports?: Array<number> | null }> | null, deployStatus?: { __typename?: 'DeployStatus', active: boolean, replicas: number, publicIPs?: Array<string> | null, state: string, errorMessage?: string | null, troubleshooting?: { __typename?: 'Troubleshooting', issue?: { __typename?: 'TroubleshootingIssue', blocks?: Array<{ __typename?: 'TroubleshootingIssueBlock', blockType?: TroubleshootingIssueBlockType | null, content?: string | null }> | null } | null } | null } | null, build?: { __typename?: 'Build', id: string, image?: string | null } | null, alternativeImages?: Array<{ __typename?: 'AlternativeImage', reference?: string | null, tag?: string | null, name?: string | null }> | null } | null, envs?: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string, visible: boolean, sealed: boolean, source?: { __typename?: 'EnvVarSource', type: EnvVarSourceType } | null }> | null, collaborators?: Array<{ __typename?: 'ProjectCollaborator', id: string, role: ProjectCollaboratorRole, user: { __typename?: 'User', id: string, name: string, login: any, avatar?: string | null, isTeam?: boolean | null } }> | null, volumes?: Array<{ __typename?: 'VolumeSpec', mountPath: string, size: number }> | null, replication?: Array<{ __typename?: 'Replication', region: string, replicas?: number | null, cluster?: { __typename?: 'Cluster', id: string, name: string, region?: string | null } | null }> | null, cluster?: { __typename?: 'Cluster', id: string, name: string, region?: string | null, ingressIP?: string | null, connected?: boolean | null, staticIPs?: Array<string> | null, cloudProvider?: CloudProvider | null, clusterProvider?: ClusterProvider | null, state: ClusterState, domain?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, projectID?: string | null } | null, logShipper?: { __typename?: 'LogShipper', type: LogShipperType, logz?: { __typename?: 'LogzIntegration', token: string, url?: string | null } | null, syslog?: { __typename?: 'SyslogIntegration', host: string, port: string, mode: string } | null, logDNA?: { __typename?: 'LogDNAIntegration', key: string } | null, datadog?: { __typename?: 'DatadogLogIntegration', key: string, host?: string | null } | null, betterstack?: { __typename?: 'BetterStackIntegration', token: string } | null } | null, readinessProbe?: { __typename?: 'Probe', command?: string | null, initialDelaySeconds: number, periodSeconds: number, successThreshold: number, failureThreshold: number, timeoutSeconds: number, http?: { __typename?: 'HTTPProbe', host?: string | null, port: string, path?: string | null } | null, tcp?: { __typename?: 'TCPProbe', host?: string | null, port: string } | null } | null, livenessProbe?: { __typename?: 'Probe', command?: string | null, initialDelaySeconds: number, periodSeconds: number, successThreshold: number, failureThreshold: number, timeoutSeconds: number, http?: { __typename?: 'HTTPProbe', host?: string | null, port: string, path?: string | null } | null, tcp?: { __typename?: 'TCPProbe', host?: string | null, port: string } | null } | null, startupProbe?: { __typename?: 'Probe', command?: string | null, initialDelaySeconds: number, periodSeconds: number, successThreshold: number, failureThreshold: number, timeoutSeconds: number, http?: { __typename?: 'HTTPProbe', host?: string | null, port: string, path?: string | null } | null, tcp?: { __typename?: 'TCPProbe', host?: string | null, port: string } | null } | null, gpu?: { __typename?: 'GPUSpec', type?: string | null, count: number } | null, tpu?: { __typename?: 'TPUSpec', type: string, cores: number, tfVersion: string } | null, githubIntegration?: { __typename?: 'GitHubRepoIntegration', id: string, autoDeployBranch: boolean, autoStopBranch: boolean, branchIgnore: string, branchStopIgnore: string, githubRepository?: { __typename?: 'GitHubRepository', id: string, owner: string, name: string } | null } | null, gitlabIntegration?: { __typename?: 'GitlabRepoIntegration', id: string, autoDeployBranch: boolean, autoStopBranch: boolean, branchIgnore: string, branchStopIgnore: string } | null, branchResources?: { __typename?: 'ContainerResourcesSpec', cpu?: number | null, memory?: number | null, ephemeralStorage?: number | null, spot?: boolean | null, accelerator?: { __typename?: 'AcceleratorSpec', type?: string | null, count?: number | null } | null } | null, serverlessResources?: { __typename?: 'ServerlessResourceSpec', cpu?: number | null, memory?: number | null } | null, prometheusScrape?: { __typename?: 'PrometheusScrape', path: string, port: number } | null, jobRuns?: { __typename?: 'JobRunConnection', totalCount: number } | null, autoscaling?: { __typename?: 'Autoscaling', kedaScaledObjectSpec?: string | null, minReplicas: number, maxReplicas: number, coolDownPeriod?: number | null, triggers?: Array<{ __typename?: 'AutoscalingTrigger', type: AutoscalingType, spec: any }> | null } | null, containerRegistry?: { __typename?: 'ContainerRegistry', id: string } | null, databaseEnvs: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string }>, databaseLinks: Array<{ __typename?: 'DatabaseLink', id: string, envPrefix?: string | null, envs?: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string }> | null, database: { __typename?: 'Repo', id: string, path: string, enabled: boolean, productionBranch?: string | null, deployTarget?: DeployTarget | null, deployType?: DeployType | null, deployService?: boolean | null, deployJob?: boolean | null, image?: string | null, cpu?: string | null, memory?: string | null, updatedAt: Date, disableReason?: DisableReason | null, databaseProvider?: DatabaseProviderType | null, databaseEngine?: DatabaseEngineType | null, name: string, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, projectID?: string | null } | null, gpu?: { __typename?: 'GPUSpec', type?: string | null, count: number } | null, tpu?: { __typename?: 'TPUSpec', tfVersion: string, type: string, cores: number } | null, cluster?: { __typename?: 'Cluster', id: string, name: string, domain?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null } | null, autoscaling?: { __typename?: 'Autoscaling', minReplicas: number, maxReplicas: number } | null, owner: { __typename?: 'User', id: string, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, owner: { __typename?: 'User', id: string, login: any } } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null } }>, linkedProjects: Array<{ __typename?: 'DatabaseLink', id: string, envPrefix?: string | null, repo: { __typename?: 'Repo', id: string, path: string, enabled: boolean, productionBranch?: string | null, deployTarget?: DeployTarget | null, deployType?: DeployType | null, deployService?: boolean | null, deployJob?: boolean | null, image?: string | null, cpu?: string | null, memory?: string | null, updatedAt: Date, disableReason?: DisableReason | null, databaseProvider?: DatabaseProviderType | null, databaseEngine?: DatabaseEngineType | null, name: string, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, projectID?: string | null } | null, gpu?: { __typename?: 'GPUSpec', type?: string | null, count: number } | null, tpu?: { __typename?: 'TPUSpec', tfVersion: string, type: string, cores: number } | null, cluster?: { __typename?: 'Cluster', id: string, name: string, domain?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null } | null, autoscaling?: { __typename?: 'Autoscaling', minReplicas: number, maxReplicas: number } | null, owner: { __typename?: 'User', id: string, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, owner: { __typename?: 'User', id: string, login: any } } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null } }>, pipelineCluster?: { __typename?: 'Cluster', id: string } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string, envs?: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string, visible: boolean, sealed: boolean, source?: { __typename?: 'EnvVarSource', type: EnvVarSourceType } | null }> | null } | null, pipelineLinks?: Array<{ __typename?: 'RepoPipelineLink', id: string, sourceEvent: RepoEvent, targetAction: RepoAction, source: { __typename?: 'Repo', id: string }, targetGroup: { __typename?: 'RepoGroup', id: string, selector?: { __typename?: 'LabelSelectors', matchLabels?: any | null } | null } }> | null, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null } | null, owner: { __typename?: 'User', id: string, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, clusterDomains?: Array<{ __typename?: 'ClusterDomains', id: string, cluster: { __typename?: 'Cluster', id: string, name: string }, domains?: Array<{ __typename?: 'CustomDomain', id: string, domain: string, isApex: boolean, cnameTargets?: Array<string> | null, ipTargets?: Array<string> | null, disableCertManager?: boolean | null, certManagerChallengeType?: CertManagerChallengeType | null, syncDomain?: { __typename?: 'CustomDomain', id: string } | null, instructions?: Array<{ __typename?: 'DNSRecord', domain: string, type: DnsRecordType, value?: string | null }> | null, certificate?: { __typename?: 'Certificate', dnsNames?: Array<string> | null, ready: boolean, issuing: boolean, challenges?: Array<{ __typename?: 'CertificateChallenge', dnsName: string, solver: string, statusReason: string, statusState: string, type: string, wildcard: boolean }> | null, instructions?: Array<{ __typename?: 'DNSRecord', domain: string, type: DnsRecordType, value?: string | null }> | null } | null }> | null }> | null, cdns?: Array<{ __typename?: 'CDN', id: string, endpoint?: string | null, state: string, domains?: Array<{ __typename?: 'CDNDomain', domain: string, certReady?: boolean | null, routeReady?: boolean | null, instruction?: { __typename?: 'DNSRecord', domain: string, type: DnsRecordType, value?: string | null } | null }> | null, certificate?: { __typename?: 'Certificate', dnsNames?: Array<string> | null, ready: boolean, issuing: boolean, instructions?: Array<{ __typename?: 'DNSRecord', name?: string | null, domain: string, type: DnsRecordType, value?: string | null }> | null } | null }> | null, ports?: Array<{ __typename?: 'Port', port: string, externalPort: string, protocol: string, public: boolean, https: boolean, grpc: boolean, loadBalancer: boolean }> | null, buildMethod?: { __typename?: 'BuildMethod', name: string, type: BuildType, workingDirectory?: string | null, dockerfilePath?: string | null, buildCommand?: string | null, staticPath?: string | null, runCommand?: string | null, releaseCommand?: string | null, nodejsVersion?: string | null, pythonVersion?: string | null, golangVersion?: string | null } | null, buildResources?: { __typename?: 'ContainerResourcesSpec', cpu?: number | null, memory?: number | null, ephemeralStorage?: number | null, spot?: boolean | null } | null, buildSpec?: { __typename?: 'ContainerSpec', cpu?: number | null, memory?: number | null } | null, kanikoFlags?: { __typename?: 'KanikoFlags', compressedCaching?: boolean | null } | null } };

export type LinkDatabaseMutationVariables = Exact<{
  input: LinkDatabaseInput;
}>;


export type LinkDatabaseMutation = { __typename?: 'Mutation', linkDatabase: { __typename?: 'Repo', appID?: string | null, defaultIngressDomain?: string | null, kappID?: string | null, useHumanReadableKubernetesName?: boolean | null, namespace?: string | null, deployTarget?: DeployTarget | null, manualDeploy?: boolean | null, deployStrategy?: DeployStrategy | null, free?: boolean | null, cpu?: string | null, memory?: string | null, ephemeralStorage?: number | null, dedicated?: boolean | null, productionBranch?: string | null, serverlessRegion?: string | null, helmValues?: string | null, terraformVersion?: string | null, terraformVariables?: any | null, deployService?: boolean | null, deployJob?: boolean | null, preStopSleep?: number | null, terminationGracePeriodSeconds?: number | null, databaseProvider?: DatabaseProviderType | null, databaseEngine?: DatabaseEngineType | null, databaseVersion?: string | null, autoRetry?: boolean | null, autoRollback?: boolean | null, canDeploy?: boolean | null, awsIamRole?: string | null, gcpServiceAccount?: string | null, datadogApmEnabled?: boolean | null, deployTimeoutSeconds?: number | null, id: string, path: string, enabled: boolean, deployType?: DeployType | null, image?: string | null, updatedAt: Date, disableReason?: DisableReason | null, hostNetwork?: boolean | null, staticIP?: boolean | null, noBuildCache?: boolean | null, gitSubmodules?: GitSubmodulesType | null, alternativeImageTagTemplates?: Array<string> | null, name: string, secretMounts?: Array<{ __typename?: 'KubernetesSecretMount', secretName: string, mountPath: string, readOnly: boolean }> | null, kubernetesCustomization?: { __typename?: 'KubernetesCustomization', serviceAccountName?: string | null, podAnnotations?: any | null, serviceAnnotations?: any | null, ingressAnnotations?: any | null } | null, manifest?: { __typename?: 'Manifest', manifests?: Array<string> | null, manifestValue?: string | null, kustomizeDirs?: Array<string> | null } | null, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, environments: Array<{ __typename?: 'ProjectEnvironment', id: string, name: string }>, envs?: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string, visible: boolean, sealed: boolean, source?: { __typename?: 'EnvVarSource', type: EnvVarSourceType } | null }> | null, owner: { __typename?: 'User', id: string, login: any } } | null, productionDeployment?: { __typename?: 'Deployment', id: string, description?: string | null, version: string, status: DeploymentStatus, branch?: string | null, endpoints?: Array<string> | null, privateEndpoint?: string | null, errorMessage?: string | null, updatedAt: Date, createdAt: Date, awsLinks?: { __typename?: 'AWSLinks', rds?: string | null, cloudformation?: string | null, lambda?: string | null, apiGateway?: string | null, cloudwatchLogs?: string | null, cloudwatchMetrics?: string | null } | null, gcpLinks?: { __typename?: 'GCPLinks', deploymentManager?: string | null, cloudRun?: string | null, cloudFunctions?: string | null, cloudFunctionsTrigger?: string | null, cloudLogging?: string | null, cloudMonitoring?: string | null } | null, loadBalancers?: Array<{ __typename?: 'LoadBalancer', dns: Array<string>, ips: Array<string>, ports?: Array<number> | null }> | null, deployStatus?: { __typename?: 'DeployStatus', active: boolean, replicas: number, publicIPs?: Array<string> | null, state: string, errorMessage?: string | null, troubleshooting?: { __typename?: 'Troubleshooting', issue?: { __typename?: 'TroubleshootingIssue', blocks?: Array<{ __typename?: 'TroubleshootingIssueBlock', blockType?: TroubleshootingIssueBlockType | null, content?: string | null }> | null } | null } | null } | null, build?: { __typename?: 'Build', id: string, image?: string | null } | null, alternativeImages?: Array<{ __typename?: 'AlternativeImage', reference?: string | null, tag?: string | null, name?: string | null }> | null } | null, envs?: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string, visible: boolean, sealed: boolean, source?: { __typename?: 'EnvVarSource', type: EnvVarSourceType } | null }> | null, collaborators?: Array<{ __typename?: 'ProjectCollaborator', id: string, role: ProjectCollaboratorRole, user: { __typename?: 'User', id: string, name: string, login: any, avatar?: string | null, isTeam?: boolean | null } }> | null, volumes?: Array<{ __typename?: 'VolumeSpec', mountPath: string, size: number }> | null, replication?: Array<{ __typename?: 'Replication', region: string, replicas?: number | null, cluster?: { __typename?: 'Cluster', id: string, name: string, region?: string | null } | null }> | null, cluster?: { __typename?: 'Cluster', id: string, name: string, region?: string | null, ingressIP?: string | null, connected?: boolean | null, staticIPs?: Array<string> | null, cloudProvider?: CloudProvider | null, clusterProvider?: ClusterProvider | null, state: ClusterState, domain?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, projectID?: string | null } | null, logShipper?: { __typename?: 'LogShipper', type: LogShipperType, logz?: { __typename?: 'LogzIntegration', token: string, url?: string | null } | null, syslog?: { __typename?: 'SyslogIntegration', host: string, port: string, mode: string } | null, logDNA?: { __typename?: 'LogDNAIntegration', key: string } | null, datadog?: { __typename?: 'DatadogLogIntegration', key: string, host?: string | null } | null, betterstack?: { __typename?: 'BetterStackIntegration', token: string } | null } | null, readinessProbe?: { __typename?: 'Probe', command?: string | null, initialDelaySeconds: number, periodSeconds: number, successThreshold: number, failureThreshold: number, timeoutSeconds: number, http?: { __typename?: 'HTTPProbe', host?: string | null, port: string, path?: string | null } | null, tcp?: { __typename?: 'TCPProbe', host?: string | null, port: string } | null } | null, livenessProbe?: { __typename?: 'Probe', command?: string | null, initialDelaySeconds: number, periodSeconds: number, successThreshold: number, failureThreshold: number, timeoutSeconds: number, http?: { __typename?: 'HTTPProbe', host?: string | null, port: string, path?: string | null } | null, tcp?: { __typename?: 'TCPProbe', host?: string | null, port: string } | null } | null, startupProbe?: { __typename?: 'Probe', command?: string | null, initialDelaySeconds: number, periodSeconds: number, successThreshold: number, failureThreshold: number, timeoutSeconds: number, http?: { __typename?: 'HTTPProbe', host?: string | null, port: string, path?: string | null } | null, tcp?: { __typename?: 'TCPProbe', host?: string | null, port: string } | null } | null, gpu?: { __typename?: 'GPUSpec', type?: string | null, count: number } | null, tpu?: { __typename?: 'TPUSpec', type: string, cores: number, tfVersion: string } | null, githubIntegration?: { __typename?: 'GitHubRepoIntegration', id: string, autoDeployBranch: boolean, autoStopBranch: boolean, branchIgnore: string, branchStopIgnore: string, githubRepository?: { __typename?: 'GitHubRepository', id: string, owner: string, name: string } | null } | null, gitlabIntegration?: { __typename?: 'GitlabRepoIntegration', id: string, autoDeployBranch: boolean, autoStopBranch: boolean, branchIgnore: string, branchStopIgnore: string } | null, branchResources?: { __typename?: 'ContainerResourcesSpec', cpu?: number | null, memory?: number | null, ephemeralStorage?: number | null, spot?: boolean | null, accelerator?: { __typename?: 'AcceleratorSpec', type?: string | null, count?: number | null } | null } | null, serverlessResources?: { __typename?: 'ServerlessResourceSpec', cpu?: number | null, memory?: number | null } | null, prometheusScrape?: { __typename?: 'PrometheusScrape', path: string, port: number } | null, jobRuns?: { __typename?: 'JobRunConnection', totalCount: number } | null, autoscaling?: { __typename?: 'Autoscaling', kedaScaledObjectSpec?: string | null, minReplicas: number, maxReplicas: number, coolDownPeriod?: number | null, triggers?: Array<{ __typename?: 'AutoscalingTrigger', type: AutoscalingType, spec: any }> | null } | null, containerRegistry?: { __typename?: 'ContainerRegistry', id: string } | null, databaseEnvs: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string }>, databaseLinks: Array<{ __typename?: 'DatabaseLink', id: string, envPrefix?: string | null, envs?: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string }> | null, database: { __typename?: 'Repo', id: string, path: string, enabled: boolean, productionBranch?: string | null, deployTarget?: DeployTarget | null, deployType?: DeployType | null, deployService?: boolean | null, deployJob?: boolean | null, image?: string | null, cpu?: string | null, memory?: string | null, updatedAt: Date, disableReason?: DisableReason | null, databaseProvider?: DatabaseProviderType | null, databaseEngine?: DatabaseEngineType | null, name: string, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, projectID?: string | null } | null, gpu?: { __typename?: 'GPUSpec', type?: string | null, count: number } | null, tpu?: { __typename?: 'TPUSpec', tfVersion: string, type: string, cores: number } | null, cluster?: { __typename?: 'Cluster', id: string, name: string, domain?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null } | null, autoscaling?: { __typename?: 'Autoscaling', minReplicas: number, maxReplicas: number } | null, owner: { __typename?: 'User', id: string, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, owner: { __typename?: 'User', id: string, login: any } } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null } }>, linkedProjects: Array<{ __typename?: 'DatabaseLink', id: string, envPrefix?: string | null, repo: { __typename?: 'Repo', id: string, path: string, enabled: boolean, productionBranch?: string | null, deployTarget?: DeployTarget | null, deployType?: DeployType | null, deployService?: boolean | null, deployJob?: boolean | null, image?: string | null, cpu?: string | null, memory?: string | null, updatedAt: Date, disableReason?: DisableReason | null, databaseProvider?: DatabaseProviderType | null, databaseEngine?: DatabaseEngineType | null, name: string, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, projectID?: string | null } | null, gpu?: { __typename?: 'GPUSpec', type?: string | null, count: number } | null, tpu?: { __typename?: 'TPUSpec', tfVersion: string, type: string, cores: number } | null, cluster?: { __typename?: 'Cluster', id: string, name: string, domain?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null } | null, autoscaling?: { __typename?: 'Autoscaling', minReplicas: number, maxReplicas: number } | null, owner: { __typename?: 'User', id: string, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, owner: { __typename?: 'User', id: string, login: any } } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null } }>, pipelineCluster?: { __typename?: 'Cluster', id: string } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string, envs?: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string, visible: boolean, sealed: boolean, source?: { __typename?: 'EnvVarSource', type: EnvVarSourceType } | null }> | null } | null, pipelineLinks?: Array<{ __typename?: 'RepoPipelineLink', id: string, sourceEvent: RepoEvent, targetAction: RepoAction, source: { __typename?: 'Repo', id: string }, targetGroup: { __typename?: 'RepoGroup', id: string, selector?: { __typename?: 'LabelSelectors', matchLabels?: any | null } | null } }> | null, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null } | null, owner: { __typename?: 'User', id: string, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, clusterDomains?: Array<{ __typename?: 'ClusterDomains', id: string, cluster: { __typename?: 'Cluster', id: string, name: string }, domains?: Array<{ __typename?: 'CustomDomain', id: string, domain: string, isApex: boolean, cnameTargets?: Array<string> | null, ipTargets?: Array<string> | null, disableCertManager?: boolean | null, certManagerChallengeType?: CertManagerChallengeType | null, syncDomain?: { __typename?: 'CustomDomain', id: string } | null, instructions?: Array<{ __typename?: 'DNSRecord', domain: string, type: DnsRecordType, value?: string | null }> | null, certificate?: { __typename?: 'Certificate', dnsNames?: Array<string> | null, ready: boolean, issuing: boolean, challenges?: Array<{ __typename?: 'CertificateChallenge', dnsName: string, solver: string, statusReason: string, statusState: string, type: string, wildcard: boolean }> | null, instructions?: Array<{ __typename?: 'DNSRecord', domain: string, type: DnsRecordType, value?: string | null }> | null } | null }> | null }> | null, cdns?: Array<{ __typename?: 'CDN', id: string, endpoint?: string | null, state: string, domains?: Array<{ __typename?: 'CDNDomain', domain: string, certReady?: boolean | null, routeReady?: boolean | null, instruction?: { __typename?: 'DNSRecord', domain: string, type: DnsRecordType, value?: string | null } | null }> | null, certificate?: { __typename?: 'Certificate', dnsNames?: Array<string> | null, ready: boolean, issuing: boolean, instructions?: Array<{ __typename?: 'DNSRecord', name?: string | null, domain: string, type: DnsRecordType, value?: string | null }> | null } | null }> | null, ports?: Array<{ __typename?: 'Port', port: string, externalPort: string, protocol: string, public: boolean, https: boolean, grpc: boolean, loadBalancer: boolean }> | null, buildMethod?: { __typename?: 'BuildMethod', name: string, type: BuildType, workingDirectory?: string | null, dockerfilePath?: string | null, buildCommand?: string | null, staticPath?: string | null, runCommand?: string | null, releaseCommand?: string | null, nodejsVersion?: string | null, pythonVersion?: string | null, golangVersion?: string | null } | null, buildResources?: { __typename?: 'ContainerResourcesSpec', cpu?: number | null, memory?: number | null, ephemeralStorage?: number | null, spot?: boolean | null } | null, buildSpec?: { __typename?: 'ContainerSpec', cpu?: number | null, memory?: number | null } | null, kanikoFlags?: { __typename?: 'KanikoFlags', compressedCaching?: boolean | null } | null } };

export type UnlinkDatabaseMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type UnlinkDatabaseMutation = { __typename?: 'Mutation', unlinkDatabase?: boolean | null };

export type UpdateDatabaseLinkMutationVariables = Exact<{
  input: UpdateDatabaseLinkInput;
}>;


export type UpdateDatabaseLinkMutation = { __typename?: 'Mutation', updateDatabaseLink: { __typename?: 'Repo', appID?: string | null, defaultIngressDomain?: string | null, kappID?: string | null, useHumanReadableKubernetesName?: boolean | null, namespace?: string | null, deployTarget?: DeployTarget | null, manualDeploy?: boolean | null, deployStrategy?: DeployStrategy | null, free?: boolean | null, cpu?: string | null, memory?: string | null, ephemeralStorage?: number | null, dedicated?: boolean | null, productionBranch?: string | null, serverlessRegion?: string | null, helmValues?: string | null, terraformVersion?: string | null, terraformVariables?: any | null, deployService?: boolean | null, deployJob?: boolean | null, preStopSleep?: number | null, terminationGracePeriodSeconds?: number | null, databaseProvider?: DatabaseProviderType | null, databaseEngine?: DatabaseEngineType | null, databaseVersion?: string | null, autoRetry?: boolean | null, autoRollback?: boolean | null, canDeploy?: boolean | null, awsIamRole?: string | null, gcpServiceAccount?: string | null, datadogApmEnabled?: boolean | null, deployTimeoutSeconds?: number | null, id: string, path: string, enabled: boolean, deployType?: DeployType | null, image?: string | null, updatedAt: Date, disableReason?: DisableReason | null, hostNetwork?: boolean | null, staticIP?: boolean | null, noBuildCache?: boolean | null, gitSubmodules?: GitSubmodulesType | null, alternativeImageTagTemplates?: Array<string> | null, name: string, secretMounts?: Array<{ __typename?: 'KubernetesSecretMount', secretName: string, mountPath: string, readOnly: boolean }> | null, kubernetesCustomization?: { __typename?: 'KubernetesCustomization', serviceAccountName?: string | null, podAnnotations?: any | null, serviceAnnotations?: any | null, ingressAnnotations?: any | null } | null, manifest?: { __typename?: 'Manifest', manifests?: Array<string> | null, manifestValue?: string | null, kustomizeDirs?: Array<string> | null } | null, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, environments: Array<{ __typename?: 'ProjectEnvironment', id: string, name: string }>, envs?: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string, visible: boolean, sealed: boolean, source?: { __typename?: 'EnvVarSource', type: EnvVarSourceType } | null }> | null, owner: { __typename?: 'User', id: string, login: any } } | null, productionDeployment?: { __typename?: 'Deployment', id: string, description?: string | null, version: string, status: DeploymentStatus, branch?: string | null, endpoints?: Array<string> | null, privateEndpoint?: string | null, errorMessage?: string | null, updatedAt: Date, createdAt: Date, awsLinks?: { __typename?: 'AWSLinks', rds?: string | null, cloudformation?: string | null, lambda?: string | null, apiGateway?: string | null, cloudwatchLogs?: string | null, cloudwatchMetrics?: string | null } | null, gcpLinks?: { __typename?: 'GCPLinks', deploymentManager?: string | null, cloudRun?: string | null, cloudFunctions?: string | null, cloudFunctionsTrigger?: string | null, cloudLogging?: string | null, cloudMonitoring?: string | null } | null, loadBalancers?: Array<{ __typename?: 'LoadBalancer', dns: Array<string>, ips: Array<string>, ports?: Array<number> | null }> | null, deployStatus?: { __typename?: 'DeployStatus', active: boolean, replicas: number, publicIPs?: Array<string> | null, state: string, errorMessage?: string | null, troubleshooting?: { __typename?: 'Troubleshooting', issue?: { __typename?: 'TroubleshootingIssue', blocks?: Array<{ __typename?: 'TroubleshootingIssueBlock', blockType?: TroubleshootingIssueBlockType | null, content?: string | null }> | null } | null } | null } | null, build?: { __typename?: 'Build', id: string, image?: string | null } | null, alternativeImages?: Array<{ __typename?: 'AlternativeImage', reference?: string | null, tag?: string | null, name?: string | null }> | null } | null, envs?: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string, visible: boolean, sealed: boolean, source?: { __typename?: 'EnvVarSource', type: EnvVarSourceType } | null }> | null, collaborators?: Array<{ __typename?: 'ProjectCollaborator', id: string, role: ProjectCollaboratorRole, user: { __typename?: 'User', id: string, name: string, login: any, avatar?: string | null, isTeam?: boolean | null } }> | null, volumes?: Array<{ __typename?: 'VolumeSpec', mountPath: string, size: number }> | null, replication?: Array<{ __typename?: 'Replication', region: string, replicas?: number | null, cluster?: { __typename?: 'Cluster', id: string, name: string, region?: string | null } | null }> | null, cluster?: { __typename?: 'Cluster', id: string, name: string, region?: string | null, ingressIP?: string | null, connected?: boolean | null, staticIPs?: Array<string> | null, cloudProvider?: CloudProvider | null, clusterProvider?: ClusterProvider | null, state: ClusterState, domain?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, projectID?: string | null } | null, logShipper?: { __typename?: 'LogShipper', type: LogShipperType, logz?: { __typename?: 'LogzIntegration', token: string, url?: string | null } | null, syslog?: { __typename?: 'SyslogIntegration', host: string, port: string, mode: string } | null, logDNA?: { __typename?: 'LogDNAIntegration', key: string } | null, datadog?: { __typename?: 'DatadogLogIntegration', key: string, host?: string | null } | null, betterstack?: { __typename?: 'BetterStackIntegration', token: string } | null } | null, readinessProbe?: { __typename?: 'Probe', command?: string | null, initialDelaySeconds: number, periodSeconds: number, successThreshold: number, failureThreshold: number, timeoutSeconds: number, http?: { __typename?: 'HTTPProbe', host?: string | null, port: string, path?: string | null } | null, tcp?: { __typename?: 'TCPProbe', host?: string | null, port: string } | null } | null, livenessProbe?: { __typename?: 'Probe', command?: string | null, initialDelaySeconds: number, periodSeconds: number, successThreshold: number, failureThreshold: number, timeoutSeconds: number, http?: { __typename?: 'HTTPProbe', host?: string | null, port: string, path?: string | null } | null, tcp?: { __typename?: 'TCPProbe', host?: string | null, port: string } | null } | null, startupProbe?: { __typename?: 'Probe', command?: string | null, initialDelaySeconds: number, periodSeconds: number, successThreshold: number, failureThreshold: number, timeoutSeconds: number, http?: { __typename?: 'HTTPProbe', host?: string | null, port: string, path?: string | null } | null, tcp?: { __typename?: 'TCPProbe', host?: string | null, port: string } | null } | null, gpu?: { __typename?: 'GPUSpec', type?: string | null, count: number } | null, tpu?: { __typename?: 'TPUSpec', type: string, cores: number, tfVersion: string } | null, githubIntegration?: { __typename?: 'GitHubRepoIntegration', id: string, autoDeployBranch: boolean, autoStopBranch: boolean, branchIgnore: string, branchStopIgnore: string, githubRepository?: { __typename?: 'GitHubRepository', id: string, owner: string, name: string } | null } | null, gitlabIntegration?: { __typename?: 'GitlabRepoIntegration', id: string, autoDeployBranch: boolean, autoStopBranch: boolean, branchIgnore: string, branchStopIgnore: string } | null, branchResources?: { __typename?: 'ContainerResourcesSpec', cpu?: number | null, memory?: number | null, ephemeralStorage?: number | null, spot?: boolean | null, accelerator?: { __typename?: 'AcceleratorSpec', type?: string | null, count?: number | null } | null } | null, serverlessResources?: { __typename?: 'ServerlessResourceSpec', cpu?: number | null, memory?: number | null } | null, prometheusScrape?: { __typename?: 'PrometheusScrape', path: string, port: number } | null, jobRuns?: { __typename?: 'JobRunConnection', totalCount: number } | null, autoscaling?: { __typename?: 'Autoscaling', kedaScaledObjectSpec?: string | null, minReplicas: number, maxReplicas: number, coolDownPeriod?: number | null, triggers?: Array<{ __typename?: 'AutoscalingTrigger', type: AutoscalingType, spec: any }> | null } | null, containerRegistry?: { __typename?: 'ContainerRegistry', id: string } | null, databaseEnvs: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string }>, databaseLinks: Array<{ __typename?: 'DatabaseLink', id: string, envPrefix?: string | null, envs?: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string }> | null, database: { __typename?: 'Repo', id: string, path: string, enabled: boolean, productionBranch?: string | null, deployTarget?: DeployTarget | null, deployType?: DeployType | null, deployService?: boolean | null, deployJob?: boolean | null, image?: string | null, cpu?: string | null, memory?: string | null, updatedAt: Date, disableReason?: DisableReason | null, databaseProvider?: DatabaseProviderType | null, databaseEngine?: DatabaseEngineType | null, name: string, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, projectID?: string | null } | null, gpu?: { __typename?: 'GPUSpec', type?: string | null, count: number } | null, tpu?: { __typename?: 'TPUSpec', tfVersion: string, type: string, cores: number } | null, cluster?: { __typename?: 'Cluster', id: string, name: string, domain?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null } | null, autoscaling?: { __typename?: 'Autoscaling', minReplicas: number, maxReplicas: number } | null, owner: { __typename?: 'User', id: string, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, owner: { __typename?: 'User', id: string, login: any } } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null } }>, linkedProjects: Array<{ __typename?: 'DatabaseLink', id: string, envPrefix?: string | null, repo: { __typename?: 'Repo', id: string, path: string, enabled: boolean, productionBranch?: string | null, deployTarget?: DeployTarget | null, deployType?: DeployType | null, deployService?: boolean | null, deployJob?: boolean | null, image?: string | null, cpu?: string | null, memory?: string | null, updatedAt: Date, disableReason?: DisableReason | null, databaseProvider?: DatabaseProviderType | null, databaseEngine?: DatabaseEngineType | null, name: string, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, projectID?: string | null } | null, gpu?: { __typename?: 'GPUSpec', type?: string | null, count: number } | null, tpu?: { __typename?: 'TPUSpec', tfVersion: string, type: string, cores: number } | null, cluster?: { __typename?: 'Cluster', id: string, name: string, domain?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null } | null, autoscaling?: { __typename?: 'Autoscaling', minReplicas: number, maxReplicas: number } | null, owner: { __typename?: 'User', id: string, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, owner: { __typename?: 'User', id: string, login: any } } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null } }>, pipelineCluster?: { __typename?: 'Cluster', id: string } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string, envs?: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string, visible: boolean, sealed: boolean, source?: { __typename?: 'EnvVarSource', type: EnvVarSourceType } | null }> | null } | null, pipelineLinks?: Array<{ __typename?: 'RepoPipelineLink', id: string, sourceEvent: RepoEvent, targetAction: RepoAction, source: { __typename?: 'Repo', id: string }, targetGroup: { __typename?: 'RepoGroup', id: string, selector?: { __typename?: 'LabelSelectors', matchLabels?: any | null } | null } }> | null, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null } | null, owner: { __typename?: 'User', id: string, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, clusterDomains?: Array<{ __typename?: 'ClusterDomains', id: string, cluster: { __typename?: 'Cluster', id: string, name: string }, domains?: Array<{ __typename?: 'CustomDomain', id: string, domain: string, isApex: boolean, cnameTargets?: Array<string> | null, ipTargets?: Array<string> | null, disableCertManager?: boolean | null, certManagerChallengeType?: CertManagerChallengeType | null, syncDomain?: { __typename?: 'CustomDomain', id: string } | null, instructions?: Array<{ __typename?: 'DNSRecord', domain: string, type: DnsRecordType, value?: string | null }> | null, certificate?: { __typename?: 'Certificate', dnsNames?: Array<string> | null, ready: boolean, issuing: boolean, challenges?: Array<{ __typename?: 'CertificateChallenge', dnsName: string, solver: string, statusReason: string, statusState: string, type: string, wildcard: boolean }> | null, instructions?: Array<{ __typename?: 'DNSRecord', domain: string, type: DnsRecordType, value?: string | null }> | null } | null }> | null }> | null, cdns?: Array<{ __typename?: 'CDN', id: string, endpoint?: string | null, state: string, domains?: Array<{ __typename?: 'CDNDomain', domain: string, certReady?: boolean | null, routeReady?: boolean | null, instruction?: { __typename?: 'DNSRecord', domain: string, type: DnsRecordType, value?: string | null } | null }> | null, certificate?: { __typename?: 'Certificate', dnsNames?: Array<string> | null, ready: boolean, issuing: boolean, instructions?: Array<{ __typename?: 'DNSRecord', name?: string | null, domain: string, type: DnsRecordType, value?: string | null }> | null } | null }> | null, ports?: Array<{ __typename?: 'Port', port: string, externalPort: string, protocol: string, public: boolean, https: boolean, grpc: boolean, loadBalancer: boolean }> | null, buildMethod?: { __typename?: 'BuildMethod', name: string, type: BuildType, workingDirectory?: string | null, dockerfilePath?: string | null, buildCommand?: string | null, staticPath?: string | null, runCommand?: string | null, releaseCommand?: string | null, nodejsVersion?: string | null, pythonVersion?: string | null, golangVersion?: string | null } | null, buildResources?: { __typename?: 'ContainerResourcesSpec', cpu?: number | null, memory?: number | null, ephemeralStorage?: number | null, spot?: boolean | null } | null, buildSpec?: { __typename?: 'ContainerSpec', cpu?: number | null, memory?: number | null } | null, kanikoFlags?: { __typename?: 'KanikoFlags', compressedCaching?: boolean | null } | null } };

export type GenerateDownloadableLogLinkMutationVariables = Exact<{
  deploymentID: Scalars['UUID'];
}>;


export type GenerateDownloadableLogLinkMutation = { __typename?: 'Mutation', generateDownloadableLogLink: string };

export type CreateProjectHelmMutationVariables = Exact<{
  input?: InputMaybe<CreateProjectHelmInput>;
}>;


export type CreateProjectHelmMutation = { __typename?: 'Mutation', createProjectHelm: { __typename?: 'Repo', id: string, path: string, enabled: boolean, productionBranch?: string | null, deployTarget?: DeployTarget | null, deployType?: DeployType | null, deployService?: boolean | null, deployJob?: boolean | null, image?: string | null, cpu?: string | null, memory?: string | null, updatedAt: Date, disableReason?: DisableReason | null, databaseProvider?: DatabaseProviderType | null, databaseEngine?: DatabaseEngineType | null, name: string, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, projectID?: string | null } | null, gpu?: { __typename?: 'GPUSpec', type?: string | null, count: number } | null, tpu?: { __typename?: 'TPUSpec', tfVersion: string, type: string, cores: number } | null, cluster?: { __typename?: 'Cluster', id: string, name: string, domain?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null } | null, autoscaling?: { __typename?: 'Autoscaling', minReplicas: number, maxReplicas: number } | null, owner: { __typename?: 'User', id: string, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, owner: { __typename?: 'User', id: string, login: any } } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null } };

export type CreateDiscordWebhookIntegrationMutationVariables = Exact<{
  input: CreateWebhookIntegrationInput;
}>;


export type CreateDiscordWebhookIntegrationMutation = { __typename?: 'Mutation', createDiscordWebhookIntegrationV2: { __typename?: 'DiscordWebhookIntegration', url?: string | null, id: string, type: IntegrationType, name: string, description: string, image: string, createdAt: Date, updatedAt: Date } };

export type UpdateDiscordWebhookIntegrationMutationVariables = Exact<{
  input: UpdateWebhookIntegrationInput;
}>;


export type UpdateDiscordWebhookIntegrationMutation = { __typename?: 'Mutation', updateDiscordWebhookIntegration: { __typename?: 'DiscordWebhookIntegration', url?: string | null, id: string, type: IntegrationType, name: string, description: string, image: string, createdAt: Date, updatedAt: Date } };

export type CreateSlackWebhookIntegrationMutationVariables = Exact<{
  input: CreateWebhookIntegrationInput;
}>;


export type CreateSlackWebhookIntegrationMutation = { __typename?: 'Mutation', createSlackWebhookIntegrationV2: { __typename?: 'SlackWebhookIntegration', url?: string | null, id: string, type: IntegrationType, name: string, description: string, image: string, createdAt: Date, updatedAt: Date } };

export type UpdateSlackWebhookIntegrationMutationVariables = Exact<{
  input: UpdateWebhookIntegrationInput;
}>;


export type UpdateSlackWebhookIntegrationMutation = { __typename?: 'Mutation', updateSlackWebhookIntegration: { __typename?: 'SlackWebhookIntegration', url?: string | null, id: string, type: IntegrationType, name: string, description: string, image: string, createdAt: Date, updatedAt: Date } };

export type CreateDatadogIntegrationMutationVariables = Exact<{
  input: CreateDatadogIntegrationInput;
}>;


export type CreateDatadogIntegrationMutation = { __typename?: 'Mutation', createDatadogIntegration: { __typename?: 'DatadogIntegration', apiKey?: string | null, id: string, type: IntegrationType, name: string, description: string, image: string, createdAt: Date, updatedAt: Date } };

export type CreateGitlabIntegrationMutationVariables = Exact<{
  input: CreateGitlabIntegrationInput;
}>;


export type CreateGitlabIntegrationMutation = { __typename?: 'Mutation', createGitlabIntegration: { __typename?: 'GitlabIntegration', accessTokenPrefix?: string | null, webhookUrl: string, webhookToken: string, id: string, type: IntegrationType, name: string, description: string, image: string, createdAt: Date, updatedAt: Date } };

export type CreateEmailIntegrationMutationVariables = Exact<{
  input: CreateEmailIntegrationInput;
}>;


export type CreateEmailIntegrationMutation = { __typename?: 'Mutation', createEmailIntegration: { __typename?: 'EmailIntegration', emailAddress: string, activated?: boolean | null, id: string, type: IntegrationType, name: string, description: string, image: string, createdAt: Date, updatedAt: Date } };

export type UpdateGitlabIntegrationMutationVariables = Exact<{
  input: UpdateGitlabIntegrationInput;
}>;


export type UpdateGitlabIntegrationMutation = { __typename?: 'Mutation', updateGitlabIntegration: { __typename?: 'GitlabIntegration', accessTokenPrefix?: string | null, webhookUrl: string, webhookToken: string, id: string, type: IntegrationType, name: string, description: string, image: string, createdAt: Date, updatedAt: Date } };

export type DeleteIntegrationMutationVariables = Exact<{
  input: RemoveUserIntegrationInput;
}>;


export type DeleteIntegrationMutation = { __typename?: 'Mutation', removeUserIntegration: boolean };

export type UpdateNotificationIntegrationSettingsMutationVariables = Exact<{
  userID: Scalars['UUID'];
  input: NotificationIntegrationSettingsInput;
}>;


export type UpdateNotificationIntegrationSettingsMutation = { __typename?: 'Mutation', updateNotificationIntegrationSettings?: { __typename?: 'NotificationIntegrationSettings', build?: boolean | null, deploy?: boolean | null, podCrash?: boolean | null } | null };

export type UpdateNotificationIntegrationSpecificSettingsMutationVariables = Exact<{
  userID: Scalars['UUID'];
  integrationID: Scalars['UUID'];
  input: NotificationIntegrationSettingsInput;
}>;


export type UpdateNotificationIntegrationSpecificSettingsMutation = { __typename?: 'Mutation', updateNotificationIntegrationSettings?: { __typename?: 'NotificationIntegrationSettings', build?: boolean | null, deploy?: boolean | null, podCrash?: boolean | null } | null };

export type CreateBitbucketIntegrationMutationVariables = Exact<{
  userId: Scalars['UUID'];
  accessToken: Scalars['String'];
  name: Scalars['String'];
}>;


export type CreateBitbucketIntegrationMutation = { __typename?: 'Mutation', createBitbucketIntegration: { __typename?: 'BitbucketIntegration', id: string } };

export type UpdateBitbucketIntegrationMutationVariables = Exact<{
  id: Scalars['UUID'];
  userId: Scalars['UUID'];
  name: Scalars['String'];
}>;


export type UpdateBitbucketIntegrationMutation = { __typename?: 'Mutation', updateBitbucketIntegration: { __typename?: 'BitbucketIntegration', id: string } };

export type UpdateNotificationIntegrationConditionsMutationVariables = Exact<{
  userId: Scalars['UUID'];
  integrationId: Scalars['UUID'];
  input: NotificationConditionProviderInput;
}>;


export type UpdateNotificationIntegrationConditionsMutation = { __typename?: 'Mutation', updateNotificationIntegrationSettings?: { __typename?: 'NotificationIntegrationSettings', conditions?: { __typename?: 'NotificationCondition', key?: NotificationConditionKey | null, operator?: NotificationConditionOperator | null, value?: any | null } | { __typename?: 'NotificationConditionGroup' } | null } | null };

export type RunJobMutationVariables = Exact<{
  input: RunJobInput;
}>;


export type RunJobMutation = { __typename?: 'Mutation', runJob: { __typename?: 'JobRun', id: string, state: JobRunState, command: string, exitCode?: number | null, createdAt?: Date | null, build?: { __typename?: 'Build', id: string, version?: string | null } | null } };

export type BuildRepoMutationVariables = Exact<{
  id: Scalars['ID'];
  branch?: InputMaybe<Scalars['String']>;
  noCache?: InputMaybe<Scalars['Boolean']>;
}>;


export type BuildRepoMutation = { __typename?: 'Mutation', buildRepo: { __typename?: 'Repo', appID?: string | null, defaultIngressDomain?: string | null, kappID?: string | null, useHumanReadableKubernetesName?: boolean | null, namespace?: string | null, deployTarget?: DeployTarget | null, manualDeploy?: boolean | null, deployStrategy?: DeployStrategy | null, free?: boolean | null, cpu?: string | null, memory?: string | null, ephemeralStorage?: number | null, dedicated?: boolean | null, productionBranch?: string | null, serverlessRegion?: string | null, helmValues?: string | null, terraformVersion?: string | null, terraformVariables?: any | null, deployService?: boolean | null, deployJob?: boolean | null, preStopSleep?: number | null, terminationGracePeriodSeconds?: number | null, databaseProvider?: DatabaseProviderType | null, databaseEngine?: DatabaseEngineType | null, databaseVersion?: string | null, autoRetry?: boolean | null, autoRollback?: boolean | null, canDeploy?: boolean | null, awsIamRole?: string | null, gcpServiceAccount?: string | null, datadogApmEnabled?: boolean | null, deployTimeoutSeconds?: number | null, id: string, path: string, enabled: boolean, deployType?: DeployType | null, image?: string | null, updatedAt: Date, disableReason?: DisableReason | null, hostNetwork?: boolean | null, staticIP?: boolean | null, noBuildCache?: boolean | null, gitSubmodules?: GitSubmodulesType | null, alternativeImageTagTemplates?: Array<string> | null, name: string, secretMounts?: Array<{ __typename?: 'KubernetesSecretMount', secretName: string, mountPath: string, readOnly: boolean }> | null, kubernetesCustomization?: { __typename?: 'KubernetesCustomization', serviceAccountName?: string | null, podAnnotations?: any | null, serviceAnnotations?: any | null, ingressAnnotations?: any | null } | null, manifest?: { __typename?: 'Manifest', manifests?: Array<string> | null, manifestValue?: string | null, kustomizeDirs?: Array<string> | null } | null, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, environments: Array<{ __typename?: 'ProjectEnvironment', id: string, name: string }>, envs?: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string, visible: boolean, sealed: boolean, source?: { __typename?: 'EnvVarSource', type: EnvVarSourceType } | null }> | null, owner: { __typename?: 'User', id: string, login: any } } | null, productionDeployment?: { __typename?: 'Deployment', id: string, description?: string | null, version: string, status: DeploymentStatus, branch?: string | null, endpoints?: Array<string> | null, privateEndpoint?: string | null, errorMessage?: string | null, updatedAt: Date, createdAt: Date, awsLinks?: { __typename?: 'AWSLinks', rds?: string | null, cloudformation?: string | null, lambda?: string | null, apiGateway?: string | null, cloudwatchLogs?: string | null, cloudwatchMetrics?: string | null } | null, gcpLinks?: { __typename?: 'GCPLinks', deploymentManager?: string | null, cloudRun?: string | null, cloudFunctions?: string | null, cloudFunctionsTrigger?: string | null, cloudLogging?: string | null, cloudMonitoring?: string | null } | null, loadBalancers?: Array<{ __typename?: 'LoadBalancer', dns: Array<string>, ips: Array<string>, ports?: Array<number> | null }> | null, deployStatus?: { __typename?: 'DeployStatus', active: boolean, replicas: number, publicIPs?: Array<string> | null, state: string, errorMessage?: string | null, troubleshooting?: { __typename?: 'Troubleshooting', issue?: { __typename?: 'TroubleshootingIssue', blocks?: Array<{ __typename?: 'TroubleshootingIssueBlock', blockType?: TroubleshootingIssueBlockType | null, content?: string | null }> | null } | null } | null } | null, build?: { __typename?: 'Build', id: string, image?: string | null } | null, alternativeImages?: Array<{ __typename?: 'AlternativeImage', reference?: string | null, tag?: string | null, name?: string | null }> | null } | null, envs?: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string, visible: boolean, sealed: boolean, source?: { __typename?: 'EnvVarSource', type: EnvVarSourceType } | null }> | null, collaborators?: Array<{ __typename?: 'ProjectCollaborator', id: string, role: ProjectCollaboratorRole, user: { __typename?: 'User', id: string, name: string, login: any, avatar?: string | null, isTeam?: boolean | null } }> | null, volumes?: Array<{ __typename?: 'VolumeSpec', mountPath: string, size: number }> | null, replication?: Array<{ __typename?: 'Replication', region: string, replicas?: number | null, cluster?: { __typename?: 'Cluster', id: string, name: string, region?: string | null } | null }> | null, cluster?: { __typename?: 'Cluster', id: string, name: string, region?: string | null, ingressIP?: string | null, connected?: boolean | null, staticIPs?: Array<string> | null, cloudProvider?: CloudProvider | null, clusterProvider?: ClusterProvider | null, state: ClusterState, domain?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, projectID?: string | null } | null, logShipper?: { __typename?: 'LogShipper', type: LogShipperType, logz?: { __typename?: 'LogzIntegration', token: string, url?: string | null } | null, syslog?: { __typename?: 'SyslogIntegration', host: string, port: string, mode: string } | null, logDNA?: { __typename?: 'LogDNAIntegration', key: string } | null, datadog?: { __typename?: 'DatadogLogIntegration', key: string, host?: string | null } | null, betterstack?: { __typename?: 'BetterStackIntegration', token: string } | null } | null, readinessProbe?: { __typename?: 'Probe', command?: string | null, initialDelaySeconds: number, periodSeconds: number, successThreshold: number, failureThreshold: number, timeoutSeconds: number, http?: { __typename?: 'HTTPProbe', host?: string | null, port: string, path?: string | null } | null, tcp?: { __typename?: 'TCPProbe', host?: string | null, port: string } | null } | null, livenessProbe?: { __typename?: 'Probe', command?: string | null, initialDelaySeconds: number, periodSeconds: number, successThreshold: number, failureThreshold: number, timeoutSeconds: number, http?: { __typename?: 'HTTPProbe', host?: string | null, port: string, path?: string | null } | null, tcp?: { __typename?: 'TCPProbe', host?: string | null, port: string } | null } | null, startupProbe?: { __typename?: 'Probe', command?: string | null, initialDelaySeconds: number, periodSeconds: number, successThreshold: number, failureThreshold: number, timeoutSeconds: number, http?: { __typename?: 'HTTPProbe', host?: string | null, port: string, path?: string | null } | null, tcp?: { __typename?: 'TCPProbe', host?: string | null, port: string } | null } | null, gpu?: { __typename?: 'GPUSpec', type?: string | null, count: number } | null, tpu?: { __typename?: 'TPUSpec', type: string, cores: number, tfVersion: string } | null, githubIntegration?: { __typename?: 'GitHubRepoIntegration', id: string, autoDeployBranch: boolean, autoStopBranch: boolean, branchIgnore: string, branchStopIgnore: string, githubRepository?: { __typename?: 'GitHubRepository', id: string, owner: string, name: string } | null } | null, gitlabIntegration?: { __typename?: 'GitlabRepoIntegration', id: string, autoDeployBranch: boolean, autoStopBranch: boolean, branchIgnore: string, branchStopIgnore: string } | null, branchResources?: { __typename?: 'ContainerResourcesSpec', cpu?: number | null, memory?: number | null, ephemeralStorage?: number | null, spot?: boolean | null, accelerator?: { __typename?: 'AcceleratorSpec', type?: string | null, count?: number | null } | null } | null, serverlessResources?: { __typename?: 'ServerlessResourceSpec', cpu?: number | null, memory?: number | null } | null, prometheusScrape?: { __typename?: 'PrometheusScrape', path: string, port: number } | null, jobRuns?: { __typename?: 'JobRunConnection', totalCount: number } | null, autoscaling?: { __typename?: 'Autoscaling', kedaScaledObjectSpec?: string | null, minReplicas: number, maxReplicas: number, coolDownPeriod?: number | null, triggers?: Array<{ __typename?: 'AutoscalingTrigger', type: AutoscalingType, spec: any }> | null } | null, containerRegistry?: { __typename?: 'ContainerRegistry', id: string } | null, databaseEnvs: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string }>, databaseLinks: Array<{ __typename?: 'DatabaseLink', id: string, envPrefix?: string | null, envs?: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string }> | null, database: { __typename?: 'Repo', id: string, path: string, enabled: boolean, productionBranch?: string | null, deployTarget?: DeployTarget | null, deployType?: DeployType | null, deployService?: boolean | null, deployJob?: boolean | null, image?: string | null, cpu?: string | null, memory?: string | null, updatedAt: Date, disableReason?: DisableReason | null, databaseProvider?: DatabaseProviderType | null, databaseEngine?: DatabaseEngineType | null, name: string, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, projectID?: string | null } | null, gpu?: { __typename?: 'GPUSpec', type?: string | null, count: number } | null, tpu?: { __typename?: 'TPUSpec', tfVersion: string, type: string, cores: number } | null, cluster?: { __typename?: 'Cluster', id: string, name: string, domain?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null } | null, autoscaling?: { __typename?: 'Autoscaling', minReplicas: number, maxReplicas: number } | null, owner: { __typename?: 'User', id: string, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, owner: { __typename?: 'User', id: string, login: any } } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null } }>, linkedProjects: Array<{ __typename?: 'DatabaseLink', id: string, envPrefix?: string | null, repo: { __typename?: 'Repo', id: string, path: string, enabled: boolean, productionBranch?: string | null, deployTarget?: DeployTarget | null, deployType?: DeployType | null, deployService?: boolean | null, deployJob?: boolean | null, image?: string | null, cpu?: string | null, memory?: string | null, updatedAt: Date, disableReason?: DisableReason | null, databaseProvider?: DatabaseProviderType | null, databaseEngine?: DatabaseEngineType | null, name: string, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, projectID?: string | null } | null, gpu?: { __typename?: 'GPUSpec', type?: string | null, count: number } | null, tpu?: { __typename?: 'TPUSpec', tfVersion: string, type: string, cores: number } | null, cluster?: { __typename?: 'Cluster', id: string, name: string, domain?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null } | null, autoscaling?: { __typename?: 'Autoscaling', minReplicas: number, maxReplicas: number } | null, owner: { __typename?: 'User', id: string, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, owner: { __typename?: 'User', id: string, login: any } } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null } }>, pipelineCluster?: { __typename?: 'Cluster', id: string } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string, envs?: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string, visible: boolean, sealed: boolean, source?: { __typename?: 'EnvVarSource', type: EnvVarSourceType } | null }> | null } | null, pipelineLinks?: Array<{ __typename?: 'RepoPipelineLink', id: string, sourceEvent: RepoEvent, targetAction: RepoAction, source: { __typename?: 'Repo', id: string }, targetGroup: { __typename?: 'RepoGroup', id: string, selector?: { __typename?: 'LabelSelectors', matchLabels?: any | null } | null } }> | null, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null } | null, owner: { __typename?: 'User', id: string, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, clusterDomains?: Array<{ __typename?: 'ClusterDomains', id: string, cluster: { __typename?: 'Cluster', id: string, name: string }, domains?: Array<{ __typename?: 'CustomDomain', id: string, domain: string, isApex: boolean, cnameTargets?: Array<string> | null, ipTargets?: Array<string> | null, disableCertManager?: boolean | null, certManagerChallengeType?: CertManagerChallengeType | null, syncDomain?: { __typename?: 'CustomDomain', id: string } | null, instructions?: Array<{ __typename?: 'DNSRecord', domain: string, type: DnsRecordType, value?: string | null }> | null, certificate?: { __typename?: 'Certificate', dnsNames?: Array<string> | null, ready: boolean, issuing: boolean, challenges?: Array<{ __typename?: 'CertificateChallenge', dnsName: string, solver: string, statusReason: string, statusState: string, type: string, wildcard: boolean }> | null, instructions?: Array<{ __typename?: 'DNSRecord', domain: string, type: DnsRecordType, value?: string | null }> | null } | null }> | null }> | null, cdns?: Array<{ __typename?: 'CDN', id: string, endpoint?: string | null, state: string, domains?: Array<{ __typename?: 'CDNDomain', domain: string, certReady?: boolean | null, routeReady?: boolean | null, instruction?: { __typename?: 'DNSRecord', domain: string, type: DnsRecordType, value?: string | null } | null }> | null, certificate?: { __typename?: 'Certificate', dnsNames?: Array<string> | null, ready: boolean, issuing: boolean, instructions?: Array<{ __typename?: 'DNSRecord', name?: string | null, domain: string, type: DnsRecordType, value?: string | null }> | null } | null }> | null, ports?: Array<{ __typename?: 'Port', port: string, externalPort: string, protocol: string, public: boolean, https: boolean, grpc: boolean, loadBalancer: boolean }> | null, buildMethod?: { __typename?: 'BuildMethod', name: string, type: BuildType, workingDirectory?: string | null, dockerfilePath?: string | null, buildCommand?: string | null, staticPath?: string | null, runCommand?: string | null, releaseCommand?: string | null, nodejsVersion?: string | null, pythonVersion?: string | null, golangVersion?: string | null } | null, buildResources?: { __typename?: 'ContainerResourcesSpec', cpu?: number | null, memory?: number | null, ephemeralStorage?: number | null, spot?: boolean | null } | null, buildSpec?: { __typename?: 'ContainerSpec', cpu?: number | null, memory?: number | null } | null, kanikoFlags?: { __typename?: 'KanikoFlags', compressedCaching?: boolean | null } | null } };

export type SetPaymentMethodMutationVariables = Exact<{
  paymentMethod: Scalars['String'];
}>;


export type SetPaymentMethodMutation = { __typename?: 'Mutation', setPaymentMethod: { __typename?: 'User', id: string, hasPaymentMethod?: boolean | null } };

export type SetRepoEnvsMutationVariables = Exact<{
  input: SetRepoEnvsInput;
}>;


export type SetRepoEnvsMutation = { __typename?: 'Mutation', setRepoEnvs: { __typename?: 'Repo', id: string, envs?: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string, visible: boolean, sealed: boolean }> | null } };

export type AddProjectCollaboratorMutationVariables = Exact<{
  input: AddProjectCollaboratorInput;
}>;


export type AddProjectCollaboratorMutation = { __typename?: 'Mutation', addProjectCollaborator: { __typename?: 'Repo', id: string, collaborators?: Array<{ __typename?: 'ProjectCollaborator', id: string, role: ProjectCollaboratorRole, user: { __typename?: 'User', id: string, name: string, login: any, avatar?: string | null, isTeam?: boolean | null } }> | null } };

export type RemoveProjectCollaboratorMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RemoveProjectCollaboratorMutation = { __typename?: 'Mutation', removeProjectCollaborator: { __typename?: 'Repo', id: string, collaborators?: Array<{ __typename?: 'ProjectCollaborator', id: string, role: ProjectCollaboratorRole, user: { __typename?: 'User', id: string, name: string, login: any, avatar?: string | null, isTeam?: boolean | null } }> | null } };

export type CopyEnvVarsMutationVariables = Exact<{
  from: Scalars['ID'];
  to: Scalars['ID'];
}>;


export type CopyEnvVarsMutation = { __typename?: 'Mutation', copyEnvVars?: { __typename?: 'Repo', id: string, envs?: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string, visible: boolean, sealed: boolean }> | null } | null };

export type ReissueCertMutationVariables = Exact<{
  input: ReissueCustomDomainCertificateInput;
}>;


export type ReissueCertMutation = { __typename?: 'Mutation', reissueCustomDomainCertificate: { __typename?: 'Repo', id: string, appID?: string | null, defaultIngressDomain?: string | null, kappID?: string | null, useHumanReadableKubernetesName?: boolean | null, namespace?: string | null, deployTarget?: DeployTarget | null, manualDeploy?: boolean | null, deployStrategy?: DeployStrategy | null, free?: boolean | null, cpu?: string | null, memory?: string | null, ephemeralStorage?: number | null, dedicated?: boolean | null, productionBranch?: string | null, serverlessRegion?: string | null, helmValues?: string | null, terraformVersion?: string | null, terraformVariables?: any | null, deployService?: boolean | null, deployJob?: boolean | null, preStopSleep?: number | null, terminationGracePeriodSeconds?: number | null, databaseProvider?: DatabaseProviderType | null, databaseEngine?: DatabaseEngineType | null, databaseVersion?: string | null, autoRetry?: boolean | null, autoRollback?: boolean | null, canDeploy?: boolean | null, awsIamRole?: string | null, gcpServiceAccount?: string | null, datadogApmEnabled?: boolean | null, deployTimeoutSeconds?: number | null, path: string, enabled: boolean, deployType?: DeployType | null, image?: string | null, updatedAt: Date, disableReason?: DisableReason | null, hostNetwork?: boolean | null, staticIP?: boolean | null, noBuildCache?: boolean | null, gitSubmodules?: GitSubmodulesType | null, alternativeImageTagTemplates?: Array<string> | null, name: string, secretMounts?: Array<{ __typename?: 'KubernetesSecretMount', secretName: string, mountPath: string, readOnly: boolean }> | null, kubernetesCustomization?: { __typename?: 'KubernetesCustomization', serviceAccountName?: string | null, podAnnotations?: any | null, serviceAnnotations?: any | null, ingressAnnotations?: any | null } | null, manifest?: { __typename?: 'Manifest', manifests?: Array<string> | null, manifestValue?: string | null, kustomizeDirs?: Array<string> | null } | null, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, environments: Array<{ __typename?: 'ProjectEnvironment', id: string, name: string }>, envs?: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string, visible: boolean, sealed: boolean, source?: { __typename?: 'EnvVarSource', type: EnvVarSourceType } | null }> | null, owner: { __typename?: 'User', id: string, login: any } } | null, productionDeployment?: { __typename?: 'Deployment', id: string, description?: string | null, version: string, status: DeploymentStatus, branch?: string | null, endpoints?: Array<string> | null, privateEndpoint?: string | null, errorMessage?: string | null, updatedAt: Date, createdAt: Date, awsLinks?: { __typename?: 'AWSLinks', rds?: string | null, cloudformation?: string | null, lambda?: string | null, apiGateway?: string | null, cloudwatchLogs?: string | null, cloudwatchMetrics?: string | null } | null, gcpLinks?: { __typename?: 'GCPLinks', deploymentManager?: string | null, cloudRun?: string | null, cloudFunctions?: string | null, cloudFunctionsTrigger?: string | null, cloudLogging?: string | null, cloudMonitoring?: string | null } | null, loadBalancers?: Array<{ __typename?: 'LoadBalancer', dns: Array<string>, ips: Array<string>, ports?: Array<number> | null }> | null, deployStatus?: { __typename?: 'DeployStatus', active: boolean, replicas: number, publicIPs?: Array<string> | null, state: string, errorMessage?: string | null, troubleshooting?: { __typename?: 'Troubleshooting', issue?: { __typename?: 'TroubleshootingIssue', blocks?: Array<{ __typename?: 'TroubleshootingIssueBlock', blockType?: TroubleshootingIssueBlockType | null, content?: string | null }> | null } | null } | null } | null, build?: { __typename?: 'Build', id: string, image?: string | null } | null, alternativeImages?: Array<{ __typename?: 'AlternativeImage', reference?: string | null, tag?: string | null, name?: string | null }> | null } | null, envs?: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string, visible: boolean, sealed: boolean, source?: { __typename?: 'EnvVarSource', type: EnvVarSourceType } | null }> | null, collaborators?: Array<{ __typename?: 'ProjectCollaborator', id: string, role: ProjectCollaboratorRole, user: { __typename?: 'User', id: string, name: string, login: any, avatar?: string | null, isTeam?: boolean | null } }> | null, volumes?: Array<{ __typename?: 'VolumeSpec', mountPath: string, size: number }> | null, replication?: Array<{ __typename?: 'Replication', region: string, replicas?: number | null, cluster?: { __typename?: 'Cluster', id: string, name: string, region?: string | null } | null }> | null, cluster?: { __typename?: 'Cluster', id: string, name: string, region?: string | null, ingressIP?: string | null, connected?: boolean | null, staticIPs?: Array<string> | null, cloudProvider?: CloudProvider | null, clusterProvider?: ClusterProvider | null, state: ClusterState, domain?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, projectID?: string | null } | null, logShipper?: { __typename?: 'LogShipper', type: LogShipperType, logz?: { __typename?: 'LogzIntegration', token: string, url?: string | null } | null, syslog?: { __typename?: 'SyslogIntegration', host: string, port: string, mode: string } | null, logDNA?: { __typename?: 'LogDNAIntegration', key: string } | null, datadog?: { __typename?: 'DatadogLogIntegration', key: string, host?: string | null } | null, betterstack?: { __typename?: 'BetterStackIntegration', token: string } | null } | null, readinessProbe?: { __typename?: 'Probe', command?: string | null, initialDelaySeconds: number, periodSeconds: number, successThreshold: number, failureThreshold: number, timeoutSeconds: number, http?: { __typename?: 'HTTPProbe', host?: string | null, port: string, path?: string | null } | null, tcp?: { __typename?: 'TCPProbe', host?: string | null, port: string } | null } | null, livenessProbe?: { __typename?: 'Probe', command?: string | null, initialDelaySeconds: number, periodSeconds: number, successThreshold: number, failureThreshold: number, timeoutSeconds: number, http?: { __typename?: 'HTTPProbe', host?: string | null, port: string, path?: string | null } | null, tcp?: { __typename?: 'TCPProbe', host?: string | null, port: string } | null } | null, startupProbe?: { __typename?: 'Probe', command?: string | null, initialDelaySeconds: number, periodSeconds: number, successThreshold: number, failureThreshold: number, timeoutSeconds: number, http?: { __typename?: 'HTTPProbe', host?: string | null, port: string, path?: string | null } | null, tcp?: { __typename?: 'TCPProbe', host?: string | null, port: string } | null } | null, gpu?: { __typename?: 'GPUSpec', type?: string | null, count: number } | null, tpu?: { __typename?: 'TPUSpec', type: string, cores: number, tfVersion: string } | null, githubIntegration?: { __typename?: 'GitHubRepoIntegration', id: string, autoDeployBranch: boolean, autoStopBranch: boolean, branchIgnore: string, branchStopIgnore: string, githubRepository?: { __typename?: 'GitHubRepository', id: string, owner: string, name: string } | null } | null, gitlabIntegration?: { __typename?: 'GitlabRepoIntegration', id: string, autoDeployBranch: boolean, autoStopBranch: boolean, branchIgnore: string, branchStopIgnore: string } | null, branchResources?: { __typename?: 'ContainerResourcesSpec', cpu?: number | null, memory?: number | null, ephemeralStorage?: number | null, spot?: boolean | null, accelerator?: { __typename?: 'AcceleratorSpec', type?: string | null, count?: number | null } | null } | null, serverlessResources?: { __typename?: 'ServerlessResourceSpec', cpu?: number | null, memory?: number | null } | null, prometheusScrape?: { __typename?: 'PrometheusScrape', path: string, port: number } | null, jobRuns?: { __typename?: 'JobRunConnection', totalCount: number } | null, autoscaling?: { __typename?: 'Autoscaling', kedaScaledObjectSpec?: string | null, minReplicas: number, maxReplicas: number, coolDownPeriod?: number | null, triggers?: Array<{ __typename?: 'AutoscalingTrigger', type: AutoscalingType, spec: any }> | null } | null, containerRegistry?: { __typename?: 'ContainerRegistry', id: string } | null, databaseEnvs: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string }>, databaseLinks: Array<{ __typename?: 'DatabaseLink', id: string, envPrefix?: string | null, envs?: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string }> | null, database: { __typename?: 'Repo', id: string, path: string, enabled: boolean, productionBranch?: string | null, deployTarget?: DeployTarget | null, deployType?: DeployType | null, deployService?: boolean | null, deployJob?: boolean | null, image?: string | null, cpu?: string | null, memory?: string | null, updatedAt: Date, disableReason?: DisableReason | null, databaseProvider?: DatabaseProviderType | null, databaseEngine?: DatabaseEngineType | null, name: string, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, projectID?: string | null } | null, gpu?: { __typename?: 'GPUSpec', type?: string | null, count: number } | null, tpu?: { __typename?: 'TPUSpec', tfVersion: string, type: string, cores: number } | null, cluster?: { __typename?: 'Cluster', id: string, name: string, domain?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null } | null, autoscaling?: { __typename?: 'Autoscaling', minReplicas: number, maxReplicas: number } | null, owner: { __typename?: 'User', id: string, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, owner: { __typename?: 'User', id: string, login: any } } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null } }>, linkedProjects: Array<{ __typename?: 'DatabaseLink', id: string, envPrefix?: string | null, repo: { __typename?: 'Repo', id: string, path: string, enabled: boolean, productionBranch?: string | null, deployTarget?: DeployTarget | null, deployType?: DeployType | null, deployService?: boolean | null, deployJob?: boolean | null, image?: string | null, cpu?: string | null, memory?: string | null, updatedAt: Date, disableReason?: DisableReason | null, databaseProvider?: DatabaseProviderType | null, databaseEngine?: DatabaseEngineType | null, name: string, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, projectID?: string | null } | null, gpu?: { __typename?: 'GPUSpec', type?: string | null, count: number } | null, tpu?: { __typename?: 'TPUSpec', tfVersion: string, type: string, cores: number } | null, cluster?: { __typename?: 'Cluster', id: string, name: string, domain?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null } | null, autoscaling?: { __typename?: 'Autoscaling', minReplicas: number, maxReplicas: number } | null, owner: { __typename?: 'User', id: string, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, owner: { __typename?: 'User', id: string, login: any } } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null } }>, pipelineCluster?: { __typename?: 'Cluster', id: string } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string, envs?: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string, visible: boolean, sealed: boolean, source?: { __typename?: 'EnvVarSource', type: EnvVarSourceType } | null }> | null } | null, pipelineLinks?: Array<{ __typename?: 'RepoPipelineLink', id: string, sourceEvent: RepoEvent, targetAction: RepoAction, source: { __typename?: 'Repo', id: string }, targetGroup: { __typename?: 'RepoGroup', id: string, selector?: { __typename?: 'LabelSelectors', matchLabels?: any | null } | null } }> | null, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null } | null, owner: { __typename?: 'User', id: string, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, clusterDomains?: Array<{ __typename?: 'ClusterDomains', id: string, cluster: { __typename?: 'Cluster', id: string, name: string }, domains?: Array<{ __typename?: 'CustomDomain', id: string, domain: string, isApex: boolean, cnameTargets?: Array<string> | null, ipTargets?: Array<string> | null, disableCertManager?: boolean | null, certManagerChallengeType?: CertManagerChallengeType | null, syncDomain?: { __typename?: 'CustomDomain', id: string } | null, instructions?: Array<{ __typename?: 'DNSRecord', domain: string, type: DnsRecordType, value?: string | null }> | null, certificate?: { __typename?: 'Certificate', dnsNames?: Array<string> | null, ready: boolean, issuing: boolean, challenges?: Array<{ __typename?: 'CertificateChallenge', dnsName: string, solver: string, statusReason: string, statusState: string, type: string, wildcard: boolean }> | null, instructions?: Array<{ __typename?: 'DNSRecord', domain: string, type: DnsRecordType, value?: string | null }> | null } | null }> | null }> | null, cdns?: Array<{ __typename?: 'CDN', id: string, endpoint?: string | null, state: string, domains?: Array<{ __typename?: 'CDNDomain', domain: string, certReady?: boolean | null, routeReady?: boolean | null, instruction?: { __typename?: 'DNSRecord', domain: string, type: DnsRecordType, value?: string | null } | null }> | null, certificate?: { __typename?: 'Certificate', dnsNames?: Array<string> | null, ready: boolean, issuing: boolean, instructions?: Array<{ __typename?: 'DNSRecord', name?: string | null, domain: string, type: DnsRecordType, value?: string | null }> | null } | null }> | null, ports?: Array<{ __typename?: 'Port', port: string, externalPort: string, protocol: string, public: boolean, https: boolean, grpc: boolean, loadBalancer: boolean }> | null, buildMethod?: { __typename?: 'BuildMethod', name: string, type: BuildType, workingDirectory?: string | null, dockerfilePath?: string | null, buildCommand?: string | null, staticPath?: string | null, runCommand?: string | null, releaseCommand?: string | null, nodejsVersion?: string | null, pythonVersion?: string | null, golangVersion?: string | null } | null, buildResources?: { __typename?: 'ContainerResourcesSpec', cpu?: number | null, memory?: number | null, ephemeralStorage?: number | null, spot?: boolean | null } | null, buildSpec?: { __typename?: 'ContainerSpec', cpu?: number | null, memory?: number | null } | null, kanikoFlags?: { __typename?: 'KanikoFlags', compressedCaching?: boolean | null } | null } };

export type UpdateCertMutationVariables = Exact<{
  input: UpdateRepoCustomDomainInput;
}>;


export type UpdateCertMutation = { __typename?: 'Mutation', updateRepoCustomDomain: { __typename?: 'Repo', id: string, appID?: string | null, defaultIngressDomain?: string | null, kappID?: string | null, useHumanReadableKubernetesName?: boolean | null, namespace?: string | null, deployTarget?: DeployTarget | null, manualDeploy?: boolean | null, deployStrategy?: DeployStrategy | null, free?: boolean | null, cpu?: string | null, memory?: string | null, ephemeralStorage?: number | null, dedicated?: boolean | null, productionBranch?: string | null, serverlessRegion?: string | null, helmValues?: string | null, terraformVersion?: string | null, terraformVariables?: any | null, deployService?: boolean | null, deployJob?: boolean | null, preStopSleep?: number | null, terminationGracePeriodSeconds?: number | null, databaseProvider?: DatabaseProviderType | null, databaseEngine?: DatabaseEngineType | null, databaseVersion?: string | null, autoRetry?: boolean | null, autoRollback?: boolean | null, canDeploy?: boolean | null, awsIamRole?: string | null, gcpServiceAccount?: string | null, datadogApmEnabled?: boolean | null, deployTimeoutSeconds?: number | null, path: string, enabled: boolean, deployType?: DeployType | null, image?: string | null, updatedAt: Date, disableReason?: DisableReason | null, hostNetwork?: boolean | null, staticIP?: boolean | null, noBuildCache?: boolean | null, gitSubmodules?: GitSubmodulesType | null, alternativeImageTagTemplates?: Array<string> | null, name: string, secretMounts?: Array<{ __typename?: 'KubernetesSecretMount', secretName: string, mountPath: string, readOnly: boolean }> | null, kubernetesCustomization?: { __typename?: 'KubernetesCustomization', serviceAccountName?: string | null, podAnnotations?: any | null, serviceAnnotations?: any | null, ingressAnnotations?: any | null } | null, manifest?: { __typename?: 'Manifest', manifests?: Array<string> | null, manifestValue?: string | null, kustomizeDirs?: Array<string> | null } | null, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, environments: Array<{ __typename?: 'ProjectEnvironment', id: string, name: string }>, envs?: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string, visible: boolean, sealed: boolean, source?: { __typename?: 'EnvVarSource', type: EnvVarSourceType } | null }> | null, owner: { __typename?: 'User', id: string, login: any } } | null, productionDeployment?: { __typename?: 'Deployment', id: string, description?: string | null, version: string, status: DeploymentStatus, branch?: string | null, endpoints?: Array<string> | null, privateEndpoint?: string | null, errorMessage?: string | null, updatedAt: Date, createdAt: Date, awsLinks?: { __typename?: 'AWSLinks', rds?: string | null, cloudformation?: string | null, lambda?: string | null, apiGateway?: string | null, cloudwatchLogs?: string | null, cloudwatchMetrics?: string | null } | null, gcpLinks?: { __typename?: 'GCPLinks', deploymentManager?: string | null, cloudRun?: string | null, cloudFunctions?: string | null, cloudFunctionsTrigger?: string | null, cloudLogging?: string | null, cloudMonitoring?: string | null } | null, loadBalancers?: Array<{ __typename?: 'LoadBalancer', dns: Array<string>, ips: Array<string>, ports?: Array<number> | null }> | null, deployStatus?: { __typename?: 'DeployStatus', active: boolean, replicas: number, publicIPs?: Array<string> | null, state: string, errorMessage?: string | null, troubleshooting?: { __typename?: 'Troubleshooting', issue?: { __typename?: 'TroubleshootingIssue', blocks?: Array<{ __typename?: 'TroubleshootingIssueBlock', blockType?: TroubleshootingIssueBlockType | null, content?: string | null }> | null } | null } | null } | null, build?: { __typename?: 'Build', id: string, image?: string | null } | null, alternativeImages?: Array<{ __typename?: 'AlternativeImage', reference?: string | null, tag?: string | null, name?: string | null }> | null } | null, envs?: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string, visible: boolean, sealed: boolean, source?: { __typename?: 'EnvVarSource', type: EnvVarSourceType } | null }> | null, collaborators?: Array<{ __typename?: 'ProjectCollaborator', id: string, role: ProjectCollaboratorRole, user: { __typename?: 'User', id: string, name: string, login: any, avatar?: string | null, isTeam?: boolean | null } }> | null, volumes?: Array<{ __typename?: 'VolumeSpec', mountPath: string, size: number }> | null, replication?: Array<{ __typename?: 'Replication', region: string, replicas?: number | null, cluster?: { __typename?: 'Cluster', id: string, name: string, region?: string | null } | null }> | null, cluster?: { __typename?: 'Cluster', id: string, name: string, region?: string | null, ingressIP?: string | null, connected?: boolean | null, staticIPs?: Array<string> | null, cloudProvider?: CloudProvider | null, clusterProvider?: ClusterProvider | null, state: ClusterState, domain?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, projectID?: string | null } | null, logShipper?: { __typename?: 'LogShipper', type: LogShipperType, logz?: { __typename?: 'LogzIntegration', token: string, url?: string | null } | null, syslog?: { __typename?: 'SyslogIntegration', host: string, port: string, mode: string } | null, logDNA?: { __typename?: 'LogDNAIntegration', key: string } | null, datadog?: { __typename?: 'DatadogLogIntegration', key: string, host?: string | null } | null, betterstack?: { __typename?: 'BetterStackIntegration', token: string } | null } | null, readinessProbe?: { __typename?: 'Probe', command?: string | null, initialDelaySeconds: number, periodSeconds: number, successThreshold: number, failureThreshold: number, timeoutSeconds: number, http?: { __typename?: 'HTTPProbe', host?: string | null, port: string, path?: string | null } | null, tcp?: { __typename?: 'TCPProbe', host?: string | null, port: string } | null } | null, livenessProbe?: { __typename?: 'Probe', command?: string | null, initialDelaySeconds: number, periodSeconds: number, successThreshold: number, failureThreshold: number, timeoutSeconds: number, http?: { __typename?: 'HTTPProbe', host?: string | null, port: string, path?: string | null } | null, tcp?: { __typename?: 'TCPProbe', host?: string | null, port: string } | null } | null, startupProbe?: { __typename?: 'Probe', command?: string | null, initialDelaySeconds: number, periodSeconds: number, successThreshold: number, failureThreshold: number, timeoutSeconds: number, http?: { __typename?: 'HTTPProbe', host?: string | null, port: string, path?: string | null } | null, tcp?: { __typename?: 'TCPProbe', host?: string | null, port: string } | null } | null, gpu?: { __typename?: 'GPUSpec', type?: string | null, count: number } | null, tpu?: { __typename?: 'TPUSpec', type: string, cores: number, tfVersion: string } | null, githubIntegration?: { __typename?: 'GitHubRepoIntegration', id: string, autoDeployBranch: boolean, autoStopBranch: boolean, branchIgnore: string, branchStopIgnore: string, githubRepository?: { __typename?: 'GitHubRepository', id: string, owner: string, name: string } | null } | null, gitlabIntegration?: { __typename?: 'GitlabRepoIntegration', id: string, autoDeployBranch: boolean, autoStopBranch: boolean, branchIgnore: string, branchStopIgnore: string } | null, branchResources?: { __typename?: 'ContainerResourcesSpec', cpu?: number | null, memory?: number | null, ephemeralStorage?: number | null, spot?: boolean | null, accelerator?: { __typename?: 'AcceleratorSpec', type?: string | null, count?: number | null } | null } | null, serverlessResources?: { __typename?: 'ServerlessResourceSpec', cpu?: number | null, memory?: number | null } | null, prometheusScrape?: { __typename?: 'PrometheusScrape', path: string, port: number } | null, jobRuns?: { __typename?: 'JobRunConnection', totalCount: number } | null, autoscaling?: { __typename?: 'Autoscaling', kedaScaledObjectSpec?: string | null, minReplicas: number, maxReplicas: number, coolDownPeriod?: number | null, triggers?: Array<{ __typename?: 'AutoscalingTrigger', type: AutoscalingType, spec: any }> | null } | null, containerRegistry?: { __typename?: 'ContainerRegistry', id: string } | null, databaseEnvs: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string }>, databaseLinks: Array<{ __typename?: 'DatabaseLink', id: string, envPrefix?: string | null, envs?: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string }> | null, database: { __typename?: 'Repo', id: string, path: string, enabled: boolean, productionBranch?: string | null, deployTarget?: DeployTarget | null, deployType?: DeployType | null, deployService?: boolean | null, deployJob?: boolean | null, image?: string | null, cpu?: string | null, memory?: string | null, updatedAt: Date, disableReason?: DisableReason | null, databaseProvider?: DatabaseProviderType | null, databaseEngine?: DatabaseEngineType | null, name: string, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, projectID?: string | null } | null, gpu?: { __typename?: 'GPUSpec', type?: string | null, count: number } | null, tpu?: { __typename?: 'TPUSpec', tfVersion: string, type: string, cores: number } | null, cluster?: { __typename?: 'Cluster', id: string, name: string, domain?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null } | null, autoscaling?: { __typename?: 'Autoscaling', minReplicas: number, maxReplicas: number } | null, owner: { __typename?: 'User', id: string, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, owner: { __typename?: 'User', id: string, login: any } } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null } }>, linkedProjects: Array<{ __typename?: 'DatabaseLink', id: string, envPrefix?: string | null, repo: { __typename?: 'Repo', id: string, path: string, enabled: boolean, productionBranch?: string | null, deployTarget?: DeployTarget | null, deployType?: DeployType | null, deployService?: boolean | null, deployJob?: boolean | null, image?: string | null, cpu?: string | null, memory?: string | null, updatedAt: Date, disableReason?: DisableReason | null, databaseProvider?: DatabaseProviderType | null, databaseEngine?: DatabaseEngineType | null, name: string, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, projectID?: string | null } | null, gpu?: { __typename?: 'GPUSpec', type?: string | null, count: number } | null, tpu?: { __typename?: 'TPUSpec', tfVersion: string, type: string, cores: number } | null, cluster?: { __typename?: 'Cluster', id: string, name: string, domain?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null } | null, autoscaling?: { __typename?: 'Autoscaling', minReplicas: number, maxReplicas: number } | null, owner: { __typename?: 'User', id: string, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, owner: { __typename?: 'User', id: string, login: any } } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null } }>, pipelineCluster?: { __typename?: 'Cluster', id: string } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string, envs?: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string, visible: boolean, sealed: boolean, source?: { __typename?: 'EnvVarSource', type: EnvVarSourceType } | null }> | null } | null, pipelineLinks?: Array<{ __typename?: 'RepoPipelineLink', id: string, sourceEvent: RepoEvent, targetAction: RepoAction, source: { __typename?: 'Repo', id: string }, targetGroup: { __typename?: 'RepoGroup', id: string, selector?: { __typename?: 'LabelSelectors', matchLabels?: any | null } | null } }> | null, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null } | null, owner: { __typename?: 'User', id: string, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, clusterDomains?: Array<{ __typename?: 'ClusterDomains', id: string, cluster: { __typename?: 'Cluster', id: string, name: string }, domains?: Array<{ __typename?: 'CustomDomain', id: string, domain: string, isApex: boolean, cnameTargets?: Array<string> | null, ipTargets?: Array<string> | null, disableCertManager?: boolean | null, certManagerChallengeType?: CertManagerChallengeType | null, syncDomain?: { __typename?: 'CustomDomain', id: string } | null, instructions?: Array<{ __typename?: 'DNSRecord', domain: string, type: DnsRecordType, value?: string | null }> | null, certificate?: { __typename?: 'Certificate', dnsNames?: Array<string> | null, ready: boolean, issuing: boolean, challenges?: Array<{ __typename?: 'CertificateChallenge', dnsName: string, solver: string, statusReason: string, statusState: string, type: string, wildcard: boolean }> | null, instructions?: Array<{ __typename?: 'DNSRecord', domain: string, type: DnsRecordType, value?: string | null }> | null } | null }> | null }> | null, cdns?: Array<{ __typename?: 'CDN', id: string, endpoint?: string | null, state: string, domains?: Array<{ __typename?: 'CDNDomain', domain: string, certReady?: boolean | null, routeReady?: boolean | null, instruction?: { __typename?: 'DNSRecord', domain: string, type: DnsRecordType, value?: string | null } | null }> | null, certificate?: { __typename?: 'Certificate', dnsNames?: Array<string> | null, ready: boolean, issuing: boolean, instructions?: Array<{ __typename?: 'DNSRecord', name?: string | null, domain: string, type: DnsRecordType, value?: string | null }> | null } | null }> | null, ports?: Array<{ __typename?: 'Port', port: string, externalPort: string, protocol: string, public: boolean, https: boolean, grpc: boolean, loadBalancer: boolean }> | null, buildMethod?: { __typename?: 'BuildMethod', name: string, type: BuildType, workingDirectory?: string | null, dockerfilePath?: string | null, buildCommand?: string | null, staticPath?: string | null, runCommand?: string | null, releaseCommand?: string | null, nodejsVersion?: string | null, pythonVersion?: string | null, golangVersion?: string | null } | null, buildResources?: { __typename?: 'ContainerResourcesSpec', cpu?: number | null, memory?: number | null, ephemeralStorage?: number | null, spot?: boolean | null } | null, buildSpec?: { __typename?: 'ContainerSpec', cpu?: number | null, memory?: number | null } | null, kanikoFlags?: { __typename?: 'KanikoFlags', compressedCaching?: boolean | null } | null } };

export type AddCdnMutationVariables = Exact<{
  input: AddCdnInput;
}>;


export type AddCdnMutation = { __typename?: 'Mutation', addCDN: { __typename?: 'CDN', id: string, endpoint?: string | null, state: string, domains?: Array<{ __typename?: 'CDNDomain', domain: string, certReady?: boolean | null, routeReady?: boolean | null, instruction?: { __typename?: 'DNSRecord', domain: string, type: DnsRecordType, value?: string | null } | null }> | null, certificate?: { __typename?: 'Certificate', dnsNames?: Array<string> | null, ready: boolean, issuing: boolean, instructions?: Array<{ __typename?: 'DNSRecord', name?: string | null, domain: string, type: DnsRecordType, value?: string | null }> | null } | null } };

export type UpdateCdnMutationVariables = Exact<{
  input: UpdateCdnInput;
}>;


export type UpdateCdnMutation = { __typename?: 'Mutation', updateCDN: { __typename?: 'CDN', id: string, endpoint?: string | null, state: string, domains?: Array<{ __typename?: 'CDNDomain', domain: string, certReady?: boolean | null, routeReady?: boolean | null, instruction?: { __typename?: 'DNSRecord', domain: string, type: DnsRecordType, value?: string | null } | null }> | null, certificate?: { __typename?: 'Certificate', dnsNames?: Array<string> | null, ready: boolean, issuing: boolean, instructions?: Array<{ __typename?: 'DNSRecord', name?: string | null, domain: string, type: DnsRecordType, value?: string | null }> | null } | null } };

export type RemoveCdnMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type RemoveCdnMutation = { __typename?: 'Mutation', removeCDN: boolean };

export type RemoveProjectLogShipperMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type RemoveProjectLogShipperMutation = { __typename?: 'Mutation', removeLogShipper: boolean };

export type AddRepoCustomDomainMutationVariables = Exact<{
  input: AddRepoCustomDomainInput;
}>;


export type AddRepoCustomDomainMutation = { __typename?: 'Mutation', addRepoCustomDomain: { __typename?: 'Repo', id: string, clusterDomains?: Array<{ __typename?: 'ClusterDomains', id: string, cluster: { __typename?: 'Cluster', id: string, name: string }, domains?: Array<{ __typename?: 'CustomDomain', id: string, domain: string, isApex: boolean, cnameTargets?: Array<string> | null, ipTargets?: Array<string> | null, disableCertManager?: boolean | null, certManagerChallengeType?: CertManagerChallengeType | null, syncDomain?: { __typename?: 'CustomDomain', id: string } | null, instructions?: Array<{ __typename?: 'DNSRecord', domain: string, type: DnsRecordType, value?: string | null }> | null, certificate?: { __typename?: 'Certificate', dnsNames?: Array<string> | null, ready: boolean, issuing: boolean, challenges?: Array<{ __typename?: 'CertificateChallenge', dnsName: string, solver: string, statusReason: string, statusState: string, type: string, wildcard: boolean }> | null, instructions?: Array<{ __typename?: 'DNSRecord', domain: string, type: DnsRecordType, value?: string | null }> | null } | null }> | null }> | null } };

export type RemoveRepoCustomDomainMutationVariables = Exact<{
  input: RemoveRepoCustomDomainInput;
}>;


export type RemoveRepoCustomDomainMutation = { __typename?: 'Mutation', removeRepoCustomDomain: { __typename?: 'Repo', id: string, clusterDomains?: Array<{ __typename?: 'ClusterDomains', id: string, cluster: { __typename?: 'Cluster', id: string, name: string }, domains?: Array<{ __typename?: 'CustomDomain', id: string, domain: string, isApex: boolean, cnameTargets?: Array<string> | null, ipTargets?: Array<string> | null, disableCertManager?: boolean | null, certManagerChallengeType?: CertManagerChallengeType | null, syncDomain?: { __typename?: 'CustomDomain', id: string } | null, instructions?: Array<{ __typename?: 'DNSRecord', domain: string, type: DnsRecordType, value?: string | null }> | null, certificate?: { __typename?: 'Certificate', dnsNames?: Array<string> | null, ready: boolean, issuing: boolean, challenges?: Array<{ __typename?: 'CertificateChallenge', dnsName: string, solver: string, statusReason: string, statusState: string, type: string, wildcard: boolean }> | null, instructions?: Array<{ __typename?: 'DNSRecord', domain: string, type: DnsRecordType, value?: string | null }> | null } | null }> | null }> | null } };

export type RemoveProbeMutationVariables = Exact<{
  input: RemoveProbeInput;
}>;


export type RemoveProbeMutation = { __typename?: 'Mutation', removeProbe: { __typename?: 'Repo', id: string, appID?: string | null, defaultIngressDomain?: string | null, kappID?: string | null, useHumanReadableKubernetesName?: boolean | null, namespace?: string | null, deployTarget?: DeployTarget | null, manualDeploy?: boolean | null, deployStrategy?: DeployStrategy | null, free?: boolean | null, cpu?: string | null, memory?: string | null, ephemeralStorage?: number | null, dedicated?: boolean | null, productionBranch?: string | null, serverlessRegion?: string | null, helmValues?: string | null, terraformVersion?: string | null, terraformVariables?: any | null, deployService?: boolean | null, deployJob?: boolean | null, preStopSleep?: number | null, terminationGracePeriodSeconds?: number | null, databaseProvider?: DatabaseProviderType | null, databaseEngine?: DatabaseEngineType | null, databaseVersion?: string | null, autoRetry?: boolean | null, autoRollback?: boolean | null, canDeploy?: boolean | null, awsIamRole?: string | null, gcpServiceAccount?: string | null, datadogApmEnabled?: boolean | null, deployTimeoutSeconds?: number | null, path: string, enabled: boolean, deployType?: DeployType | null, image?: string | null, updatedAt: Date, disableReason?: DisableReason | null, hostNetwork?: boolean | null, staticIP?: boolean | null, noBuildCache?: boolean | null, gitSubmodules?: GitSubmodulesType | null, alternativeImageTagTemplates?: Array<string> | null, name: string, secretMounts?: Array<{ __typename?: 'KubernetesSecretMount', secretName: string, mountPath: string, readOnly: boolean }> | null, kubernetesCustomization?: { __typename?: 'KubernetesCustomization', serviceAccountName?: string | null, podAnnotations?: any | null, serviceAnnotations?: any | null, ingressAnnotations?: any | null } | null, manifest?: { __typename?: 'Manifest', manifests?: Array<string> | null, manifestValue?: string | null, kustomizeDirs?: Array<string> | null } | null, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, environments: Array<{ __typename?: 'ProjectEnvironment', id: string, name: string }>, envs?: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string, visible: boolean, sealed: boolean, source?: { __typename?: 'EnvVarSource', type: EnvVarSourceType } | null }> | null, owner: { __typename?: 'User', id: string, login: any } } | null, productionDeployment?: { __typename?: 'Deployment', id: string, description?: string | null, version: string, status: DeploymentStatus, branch?: string | null, endpoints?: Array<string> | null, privateEndpoint?: string | null, errorMessage?: string | null, updatedAt: Date, createdAt: Date, awsLinks?: { __typename?: 'AWSLinks', rds?: string | null, cloudformation?: string | null, lambda?: string | null, apiGateway?: string | null, cloudwatchLogs?: string | null, cloudwatchMetrics?: string | null } | null, gcpLinks?: { __typename?: 'GCPLinks', deploymentManager?: string | null, cloudRun?: string | null, cloudFunctions?: string | null, cloudFunctionsTrigger?: string | null, cloudLogging?: string | null, cloudMonitoring?: string | null } | null, loadBalancers?: Array<{ __typename?: 'LoadBalancer', dns: Array<string>, ips: Array<string>, ports?: Array<number> | null }> | null, deployStatus?: { __typename?: 'DeployStatus', active: boolean, replicas: number, publicIPs?: Array<string> | null, state: string, errorMessage?: string | null, troubleshooting?: { __typename?: 'Troubleshooting', issue?: { __typename?: 'TroubleshootingIssue', blocks?: Array<{ __typename?: 'TroubleshootingIssueBlock', blockType?: TroubleshootingIssueBlockType | null, content?: string | null }> | null } | null } | null } | null, build?: { __typename?: 'Build', id: string, image?: string | null } | null, alternativeImages?: Array<{ __typename?: 'AlternativeImage', reference?: string | null, tag?: string | null, name?: string | null }> | null } | null, envs?: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string, visible: boolean, sealed: boolean, source?: { __typename?: 'EnvVarSource', type: EnvVarSourceType } | null }> | null, collaborators?: Array<{ __typename?: 'ProjectCollaborator', id: string, role: ProjectCollaboratorRole, user: { __typename?: 'User', id: string, name: string, login: any, avatar?: string | null, isTeam?: boolean | null } }> | null, volumes?: Array<{ __typename?: 'VolumeSpec', mountPath: string, size: number }> | null, replication?: Array<{ __typename?: 'Replication', region: string, replicas?: number | null, cluster?: { __typename?: 'Cluster', id: string, name: string, region?: string | null } | null }> | null, cluster?: { __typename?: 'Cluster', id: string, name: string, region?: string | null, ingressIP?: string | null, connected?: boolean | null, staticIPs?: Array<string> | null, cloudProvider?: CloudProvider | null, clusterProvider?: ClusterProvider | null, state: ClusterState, domain?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, projectID?: string | null } | null, logShipper?: { __typename?: 'LogShipper', type: LogShipperType, logz?: { __typename?: 'LogzIntegration', token: string, url?: string | null } | null, syslog?: { __typename?: 'SyslogIntegration', host: string, port: string, mode: string } | null, logDNA?: { __typename?: 'LogDNAIntegration', key: string } | null, datadog?: { __typename?: 'DatadogLogIntegration', key: string, host?: string | null } | null, betterstack?: { __typename?: 'BetterStackIntegration', token: string } | null } | null, readinessProbe?: { __typename?: 'Probe', command?: string | null, initialDelaySeconds: number, periodSeconds: number, successThreshold: number, failureThreshold: number, timeoutSeconds: number, http?: { __typename?: 'HTTPProbe', host?: string | null, port: string, path?: string | null } | null, tcp?: { __typename?: 'TCPProbe', host?: string | null, port: string } | null } | null, livenessProbe?: { __typename?: 'Probe', command?: string | null, initialDelaySeconds: number, periodSeconds: number, successThreshold: number, failureThreshold: number, timeoutSeconds: number, http?: { __typename?: 'HTTPProbe', host?: string | null, port: string, path?: string | null } | null, tcp?: { __typename?: 'TCPProbe', host?: string | null, port: string } | null } | null, startupProbe?: { __typename?: 'Probe', command?: string | null, initialDelaySeconds: number, periodSeconds: number, successThreshold: number, failureThreshold: number, timeoutSeconds: number, http?: { __typename?: 'HTTPProbe', host?: string | null, port: string, path?: string | null } | null, tcp?: { __typename?: 'TCPProbe', host?: string | null, port: string } | null } | null, gpu?: { __typename?: 'GPUSpec', type?: string | null, count: number } | null, tpu?: { __typename?: 'TPUSpec', type: string, cores: number, tfVersion: string } | null, githubIntegration?: { __typename?: 'GitHubRepoIntegration', id: string, autoDeployBranch: boolean, autoStopBranch: boolean, branchIgnore: string, branchStopIgnore: string, githubRepository?: { __typename?: 'GitHubRepository', id: string, owner: string, name: string } | null } | null, gitlabIntegration?: { __typename?: 'GitlabRepoIntegration', id: string, autoDeployBranch: boolean, autoStopBranch: boolean, branchIgnore: string, branchStopIgnore: string } | null, branchResources?: { __typename?: 'ContainerResourcesSpec', cpu?: number | null, memory?: number | null, ephemeralStorage?: number | null, spot?: boolean | null, accelerator?: { __typename?: 'AcceleratorSpec', type?: string | null, count?: number | null } | null } | null, serverlessResources?: { __typename?: 'ServerlessResourceSpec', cpu?: number | null, memory?: number | null } | null, prometheusScrape?: { __typename?: 'PrometheusScrape', path: string, port: number } | null, jobRuns?: { __typename?: 'JobRunConnection', totalCount: number } | null, autoscaling?: { __typename?: 'Autoscaling', kedaScaledObjectSpec?: string | null, minReplicas: number, maxReplicas: number, coolDownPeriod?: number | null, triggers?: Array<{ __typename?: 'AutoscalingTrigger', type: AutoscalingType, spec: any }> | null } | null, containerRegistry?: { __typename?: 'ContainerRegistry', id: string } | null, databaseEnvs: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string }>, databaseLinks: Array<{ __typename?: 'DatabaseLink', id: string, envPrefix?: string | null, envs?: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string }> | null, database: { __typename?: 'Repo', id: string, path: string, enabled: boolean, productionBranch?: string | null, deployTarget?: DeployTarget | null, deployType?: DeployType | null, deployService?: boolean | null, deployJob?: boolean | null, image?: string | null, cpu?: string | null, memory?: string | null, updatedAt: Date, disableReason?: DisableReason | null, databaseProvider?: DatabaseProviderType | null, databaseEngine?: DatabaseEngineType | null, name: string, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, projectID?: string | null } | null, gpu?: { __typename?: 'GPUSpec', type?: string | null, count: number } | null, tpu?: { __typename?: 'TPUSpec', tfVersion: string, type: string, cores: number } | null, cluster?: { __typename?: 'Cluster', id: string, name: string, domain?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null } | null, autoscaling?: { __typename?: 'Autoscaling', minReplicas: number, maxReplicas: number } | null, owner: { __typename?: 'User', id: string, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, owner: { __typename?: 'User', id: string, login: any } } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null } }>, linkedProjects: Array<{ __typename?: 'DatabaseLink', id: string, envPrefix?: string | null, repo: { __typename?: 'Repo', id: string, path: string, enabled: boolean, productionBranch?: string | null, deployTarget?: DeployTarget | null, deployType?: DeployType | null, deployService?: boolean | null, deployJob?: boolean | null, image?: string | null, cpu?: string | null, memory?: string | null, updatedAt: Date, disableReason?: DisableReason | null, databaseProvider?: DatabaseProviderType | null, databaseEngine?: DatabaseEngineType | null, name: string, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, projectID?: string | null } | null, gpu?: { __typename?: 'GPUSpec', type?: string | null, count: number } | null, tpu?: { __typename?: 'TPUSpec', tfVersion: string, type: string, cores: number } | null, cluster?: { __typename?: 'Cluster', id: string, name: string, domain?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null } | null, autoscaling?: { __typename?: 'Autoscaling', minReplicas: number, maxReplicas: number } | null, owner: { __typename?: 'User', id: string, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, owner: { __typename?: 'User', id: string, login: any } } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null } }>, pipelineCluster?: { __typename?: 'Cluster', id: string } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string, envs?: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string, visible: boolean, sealed: boolean, source?: { __typename?: 'EnvVarSource', type: EnvVarSourceType } | null }> | null } | null, pipelineLinks?: Array<{ __typename?: 'RepoPipelineLink', id: string, sourceEvent: RepoEvent, targetAction: RepoAction, source: { __typename?: 'Repo', id: string }, targetGroup: { __typename?: 'RepoGroup', id: string, selector?: { __typename?: 'LabelSelectors', matchLabels?: any | null } | null } }> | null, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null } | null, owner: { __typename?: 'User', id: string, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, clusterDomains?: Array<{ __typename?: 'ClusterDomains', id: string, cluster: { __typename?: 'Cluster', id: string, name: string }, domains?: Array<{ __typename?: 'CustomDomain', id: string, domain: string, isApex: boolean, cnameTargets?: Array<string> | null, ipTargets?: Array<string> | null, disableCertManager?: boolean | null, certManagerChallengeType?: CertManagerChallengeType | null, syncDomain?: { __typename?: 'CustomDomain', id: string } | null, instructions?: Array<{ __typename?: 'DNSRecord', domain: string, type: DnsRecordType, value?: string | null }> | null, certificate?: { __typename?: 'Certificate', dnsNames?: Array<string> | null, ready: boolean, issuing: boolean, challenges?: Array<{ __typename?: 'CertificateChallenge', dnsName: string, solver: string, statusReason: string, statusState: string, type: string, wildcard: boolean }> | null, instructions?: Array<{ __typename?: 'DNSRecord', domain: string, type: DnsRecordType, value?: string | null }> | null } | null }> | null }> | null, cdns?: Array<{ __typename?: 'CDN', id: string, endpoint?: string | null, state: string, domains?: Array<{ __typename?: 'CDNDomain', domain: string, certReady?: boolean | null, routeReady?: boolean | null, instruction?: { __typename?: 'DNSRecord', domain: string, type: DnsRecordType, value?: string | null } | null }> | null, certificate?: { __typename?: 'Certificate', dnsNames?: Array<string> | null, ready: boolean, issuing: boolean, instructions?: Array<{ __typename?: 'DNSRecord', name?: string | null, domain: string, type: DnsRecordType, value?: string | null }> | null } | null }> | null, ports?: Array<{ __typename?: 'Port', port: string, externalPort: string, protocol: string, public: boolean, https: boolean, grpc: boolean, loadBalancer: boolean }> | null, buildMethod?: { __typename?: 'BuildMethod', name: string, type: BuildType, workingDirectory?: string | null, dockerfilePath?: string | null, buildCommand?: string | null, staticPath?: string | null, runCommand?: string | null, releaseCommand?: string | null, nodejsVersion?: string | null, pythonVersion?: string | null, golangVersion?: string | null } | null, buildResources?: { __typename?: 'ContainerResourcesSpec', cpu?: number | null, memory?: number | null, ephemeralStorage?: number | null, spot?: boolean | null } | null, buildSpec?: { __typename?: 'ContainerSpec', cpu?: number | null, memory?: number | null } | null, kanikoFlags?: { __typename?: 'KanikoFlags', compressedCaching?: boolean | null } | null } };

export type EnableProjectMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type EnableProjectMutation = { __typename?: 'Mutation', enableRepo: { __typename?: 'Repo', appID?: string | null, defaultIngressDomain?: string | null, kappID?: string | null, useHumanReadableKubernetesName?: boolean | null, namespace?: string | null, deployTarget?: DeployTarget | null, manualDeploy?: boolean | null, deployStrategy?: DeployStrategy | null, free?: boolean | null, cpu?: string | null, memory?: string | null, ephemeralStorage?: number | null, dedicated?: boolean | null, productionBranch?: string | null, serverlessRegion?: string | null, helmValues?: string | null, terraformVersion?: string | null, terraformVariables?: any | null, deployService?: boolean | null, deployJob?: boolean | null, preStopSleep?: number | null, terminationGracePeriodSeconds?: number | null, databaseProvider?: DatabaseProviderType | null, databaseEngine?: DatabaseEngineType | null, databaseVersion?: string | null, autoRetry?: boolean | null, autoRollback?: boolean | null, canDeploy?: boolean | null, awsIamRole?: string | null, gcpServiceAccount?: string | null, datadogApmEnabled?: boolean | null, deployTimeoutSeconds?: number | null, id: string, path: string, enabled: boolean, deployType?: DeployType | null, image?: string | null, updatedAt: Date, disableReason?: DisableReason | null, hostNetwork?: boolean | null, staticIP?: boolean | null, noBuildCache?: boolean | null, gitSubmodules?: GitSubmodulesType | null, alternativeImageTagTemplates?: Array<string> | null, name: string, secretMounts?: Array<{ __typename?: 'KubernetesSecretMount', secretName: string, mountPath: string, readOnly: boolean }> | null, kubernetesCustomization?: { __typename?: 'KubernetesCustomization', serviceAccountName?: string | null, podAnnotations?: any | null, serviceAnnotations?: any | null, ingressAnnotations?: any | null } | null, manifest?: { __typename?: 'Manifest', manifests?: Array<string> | null, manifestValue?: string | null, kustomizeDirs?: Array<string> | null } | null, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, environments: Array<{ __typename?: 'ProjectEnvironment', id: string, name: string }>, envs?: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string, visible: boolean, sealed: boolean, source?: { __typename?: 'EnvVarSource', type: EnvVarSourceType } | null }> | null, owner: { __typename?: 'User', id: string, login: any } } | null, productionDeployment?: { __typename?: 'Deployment', id: string, description?: string | null, version: string, status: DeploymentStatus, branch?: string | null, endpoints?: Array<string> | null, privateEndpoint?: string | null, errorMessage?: string | null, updatedAt: Date, createdAt: Date, awsLinks?: { __typename?: 'AWSLinks', rds?: string | null, cloudformation?: string | null, lambda?: string | null, apiGateway?: string | null, cloudwatchLogs?: string | null, cloudwatchMetrics?: string | null } | null, gcpLinks?: { __typename?: 'GCPLinks', deploymentManager?: string | null, cloudRun?: string | null, cloudFunctions?: string | null, cloudFunctionsTrigger?: string | null, cloudLogging?: string | null, cloudMonitoring?: string | null } | null, loadBalancers?: Array<{ __typename?: 'LoadBalancer', dns: Array<string>, ips: Array<string>, ports?: Array<number> | null }> | null, deployStatus?: { __typename?: 'DeployStatus', active: boolean, replicas: number, publicIPs?: Array<string> | null, state: string, errorMessage?: string | null, troubleshooting?: { __typename?: 'Troubleshooting', issue?: { __typename?: 'TroubleshootingIssue', blocks?: Array<{ __typename?: 'TroubleshootingIssueBlock', blockType?: TroubleshootingIssueBlockType | null, content?: string | null }> | null } | null } | null } | null, build?: { __typename?: 'Build', id: string, image?: string | null } | null, alternativeImages?: Array<{ __typename?: 'AlternativeImage', reference?: string | null, tag?: string | null, name?: string | null }> | null } | null, envs?: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string, visible: boolean, sealed: boolean, source?: { __typename?: 'EnvVarSource', type: EnvVarSourceType } | null }> | null, collaborators?: Array<{ __typename?: 'ProjectCollaborator', id: string, role: ProjectCollaboratorRole, user: { __typename?: 'User', id: string, name: string, login: any, avatar?: string | null, isTeam?: boolean | null } }> | null, volumes?: Array<{ __typename?: 'VolumeSpec', mountPath: string, size: number }> | null, replication?: Array<{ __typename?: 'Replication', region: string, replicas?: number | null, cluster?: { __typename?: 'Cluster', id: string, name: string, region?: string | null } | null }> | null, cluster?: { __typename?: 'Cluster', id: string, name: string, region?: string | null, ingressIP?: string | null, connected?: boolean | null, staticIPs?: Array<string> | null, cloudProvider?: CloudProvider | null, clusterProvider?: ClusterProvider | null, state: ClusterState, domain?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, projectID?: string | null } | null, logShipper?: { __typename?: 'LogShipper', type: LogShipperType, logz?: { __typename?: 'LogzIntegration', token: string, url?: string | null } | null, syslog?: { __typename?: 'SyslogIntegration', host: string, port: string, mode: string } | null, logDNA?: { __typename?: 'LogDNAIntegration', key: string } | null, datadog?: { __typename?: 'DatadogLogIntegration', key: string, host?: string | null } | null, betterstack?: { __typename?: 'BetterStackIntegration', token: string } | null } | null, readinessProbe?: { __typename?: 'Probe', command?: string | null, initialDelaySeconds: number, periodSeconds: number, successThreshold: number, failureThreshold: number, timeoutSeconds: number, http?: { __typename?: 'HTTPProbe', host?: string | null, port: string, path?: string | null } | null, tcp?: { __typename?: 'TCPProbe', host?: string | null, port: string } | null } | null, livenessProbe?: { __typename?: 'Probe', command?: string | null, initialDelaySeconds: number, periodSeconds: number, successThreshold: number, failureThreshold: number, timeoutSeconds: number, http?: { __typename?: 'HTTPProbe', host?: string | null, port: string, path?: string | null } | null, tcp?: { __typename?: 'TCPProbe', host?: string | null, port: string } | null } | null, startupProbe?: { __typename?: 'Probe', command?: string | null, initialDelaySeconds: number, periodSeconds: number, successThreshold: number, failureThreshold: number, timeoutSeconds: number, http?: { __typename?: 'HTTPProbe', host?: string | null, port: string, path?: string | null } | null, tcp?: { __typename?: 'TCPProbe', host?: string | null, port: string } | null } | null, gpu?: { __typename?: 'GPUSpec', type?: string | null, count: number } | null, tpu?: { __typename?: 'TPUSpec', type: string, cores: number, tfVersion: string } | null, githubIntegration?: { __typename?: 'GitHubRepoIntegration', id: string, autoDeployBranch: boolean, autoStopBranch: boolean, branchIgnore: string, branchStopIgnore: string, githubRepository?: { __typename?: 'GitHubRepository', id: string, owner: string, name: string } | null } | null, gitlabIntegration?: { __typename?: 'GitlabRepoIntegration', id: string, autoDeployBranch: boolean, autoStopBranch: boolean, branchIgnore: string, branchStopIgnore: string } | null, branchResources?: { __typename?: 'ContainerResourcesSpec', cpu?: number | null, memory?: number | null, ephemeralStorage?: number | null, spot?: boolean | null, accelerator?: { __typename?: 'AcceleratorSpec', type?: string | null, count?: number | null } | null } | null, serverlessResources?: { __typename?: 'ServerlessResourceSpec', cpu?: number | null, memory?: number | null } | null, prometheusScrape?: { __typename?: 'PrometheusScrape', path: string, port: number } | null, jobRuns?: { __typename?: 'JobRunConnection', totalCount: number } | null, autoscaling?: { __typename?: 'Autoscaling', kedaScaledObjectSpec?: string | null, minReplicas: number, maxReplicas: number, coolDownPeriod?: number | null, triggers?: Array<{ __typename?: 'AutoscalingTrigger', type: AutoscalingType, spec: any }> | null } | null, containerRegistry?: { __typename?: 'ContainerRegistry', id: string } | null, databaseEnvs: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string }>, databaseLinks: Array<{ __typename?: 'DatabaseLink', id: string, envPrefix?: string | null, envs?: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string }> | null, database: { __typename?: 'Repo', id: string, path: string, enabled: boolean, productionBranch?: string | null, deployTarget?: DeployTarget | null, deployType?: DeployType | null, deployService?: boolean | null, deployJob?: boolean | null, image?: string | null, cpu?: string | null, memory?: string | null, updatedAt: Date, disableReason?: DisableReason | null, databaseProvider?: DatabaseProviderType | null, databaseEngine?: DatabaseEngineType | null, name: string, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, projectID?: string | null } | null, gpu?: { __typename?: 'GPUSpec', type?: string | null, count: number } | null, tpu?: { __typename?: 'TPUSpec', tfVersion: string, type: string, cores: number } | null, cluster?: { __typename?: 'Cluster', id: string, name: string, domain?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null } | null, autoscaling?: { __typename?: 'Autoscaling', minReplicas: number, maxReplicas: number } | null, owner: { __typename?: 'User', id: string, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, owner: { __typename?: 'User', id: string, login: any } } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null } }>, linkedProjects: Array<{ __typename?: 'DatabaseLink', id: string, envPrefix?: string | null, repo: { __typename?: 'Repo', id: string, path: string, enabled: boolean, productionBranch?: string | null, deployTarget?: DeployTarget | null, deployType?: DeployType | null, deployService?: boolean | null, deployJob?: boolean | null, image?: string | null, cpu?: string | null, memory?: string | null, updatedAt: Date, disableReason?: DisableReason | null, databaseProvider?: DatabaseProviderType | null, databaseEngine?: DatabaseEngineType | null, name: string, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, projectID?: string | null } | null, gpu?: { __typename?: 'GPUSpec', type?: string | null, count: number } | null, tpu?: { __typename?: 'TPUSpec', tfVersion: string, type: string, cores: number } | null, cluster?: { __typename?: 'Cluster', id: string, name: string, domain?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null } | null, autoscaling?: { __typename?: 'Autoscaling', minReplicas: number, maxReplicas: number } | null, owner: { __typename?: 'User', id: string, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, owner: { __typename?: 'User', id: string, login: any } } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null } }>, pipelineCluster?: { __typename?: 'Cluster', id: string } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string, envs?: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string, visible: boolean, sealed: boolean, source?: { __typename?: 'EnvVarSource', type: EnvVarSourceType } | null }> | null } | null, pipelineLinks?: Array<{ __typename?: 'RepoPipelineLink', id: string, sourceEvent: RepoEvent, targetAction: RepoAction, source: { __typename?: 'Repo', id: string }, targetGroup: { __typename?: 'RepoGroup', id: string, selector?: { __typename?: 'LabelSelectors', matchLabels?: any | null } | null } }> | null, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null } | null, owner: { __typename?: 'User', id: string, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, clusterDomains?: Array<{ __typename?: 'ClusterDomains', id: string, cluster: { __typename?: 'Cluster', id: string, name: string }, domains?: Array<{ __typename?: 'CustomDomain', id: string, domain: string, isApex: boolean, cnameTargets?: Array<string> | null, ipTargets?: Array<string> | null, disableCertManager?: boolean | null, certManagerChallengeType?: CertManagerChallengeType | null, syncDomain?: { __typename?: 'CustomDomain', id: string } | null, instructions?: Array<{ __typename?: 'DNSRecord', domain: string, type: DnsRecordType, value?: string | null }> | null, certificate?: { __typename?: 'Certificate', dnsNames?: Array<string> | null, ready: boolean, issuing: boolean, challenges?: Array<{ __typename?: 'CertificateChallenge', dnsName: string, solver: string, statusReason: string, statusState: string, type: string, wildcard: boolean }> | null, instructions?: Array<{ __typename?: 'DNSRecord', domain: string, type: DnsRecordType, value?: string | null }> | null } | null }> | null }> | null, cdns?: Array<{ __typename?: 'CDN', id: string, endpoint?: string | null, state: string, domains?: Array<{ __typename?: 'CDNDomain', domain: string, certReady?: boolean | null, routeReady?: boolean | null, instruction?: { __typename?: 'DNSRecord', domain: string, type: DnsRecordType, value?: string | null } | null }> | null, certificate?: { __typename?: 'Certificate', dnsNames?: Array<string> | null, ready: boolean, issuing: boolean, instructions?: Array<{ __typename?: 'DNSRecord', name?: string | null, domain: string, type: DnsRecordType, value?: string | null }> | null } | null }> | null, ports?: Array<{ __typename?: 'Port', port: string, externalPort: string, protocol: string, public: boolean, https: boolean, grpc: boolean, loadBalancer: boolean }> | null, buildMethod?: { __typename?: 'BuildMethod', name: string, type: BuildType, workingDirectory?: string | null, dockerfilePath?: string | null, buildCommand?: string | null, staticPath?: string | null, runCommand?: string | null, releaseCommand?: string | null, nodejsVersion?: string | null, pythonVersion?: string | null, golangVersion?: string | null } | null, buildResources?: { __typename?: 'ContainerResourcesSpec', cpu?: number | null, memory?: number | null, ephemeralStorage?: number | null, spot?: boolean | null } | null, buildSpec?: { __typename?: 'ContainerSpec', cpu?: number | null, memory?: number | null } | null, kanikoFlags?: { __typename?: 'KanikoFlags', compressedCaching?: boolean | null } | null } };

export type DisableProjectMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DisableProjectMutation = { __typename?: 'Mutation', disableRepo: { __typename?: 'Repo', appID?: string | null, defaultIngressDomain?: string | null, kappID?: string | null, useHumanReadableKubernetesName?: boolean | null, namespace?: string | null, deployTarget?: DeployTarget | null, manualDeploy?: boolean | null, deployStrategy?: DeployStrategy | null, free?: boolean | null, cpu?: string | null, memory?: string | null, ephemeralStorage?: number | null, dedicated?: boolean | null, productionBranch?: string | null, serverlessRegion?: string | null, helmValues?: string | null, terraformVersion?: string | null, terraformVariables?: any | null, deployService?: boolean | null, deployJob?: boolean | null, preStopSleep?: number | null, terminationGracePeriodSeconds?: number | null, databaseProvider?: DatabaseProviderType | null, databaseEngine?: DatabaseEngineType | null, databaseVersion?: string | null, autoRetry?: boolean | null, autoRollback?: boolean | null, canDeploy?: boolean | null, awsIamRole?: string | null, gcpServiceAccount?: string | null, datadogApmEnabled?: boolean | null, deployTimeoutSeconds?: number | null, id: string, path: string, enabled: boolean, deployType?: DeployType | null, image?: string | null, updatedAt: Date, disableReason?: DisableReason | null, hostNetwork?: boolean | null, staticIP?: boolean | null, noBuildCache?: boolean | null, gitSubmodules?: GitSubmodulesType | null, alternativeImageTagTemplates?: Array<string> | null, name: string, secretMounts?: Array<{ __typename?: 'KubernetesSecretMount', secretName: string, mountPath: string, readOnly: boolean }> | null, kubernetesCustomization?: { __typename?: 'KubernetesCustomization', serviceAccountName?: string | null, podAnnotations?: any | null, serviceAnnotations?: any | null, ingressAnnotations?: any | null } | null, manifest?: { __typename?: 'Manifest', manifests?: Array<string> | null, manifestValue?: string | null, kustomizeDirs?: Array<string> | null } | null, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, environments: Array<{ __typename?: 'ProjectEnvironment', id: string, name: string }>, envs?: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string, visible: boolean, sealed: boolean, source?: { __typename?: 'EnvVarSource', type: EnvVarSourceType } | null }> | null, owner: { __typename?: 'User', id: string, login: any } } | null, productionDeployment?: { __typename?: 'Deployment', id: string, description?: string | null, version: string, status: DeploymentStatus, branch?: string | null, endpoints?: Array<string> | null, privateEndpoint?: string | null, errorMessage?: string | null, updatedAt: Date, createdAt: Date, awsLinks?: { __typename?: 'AWSLinks', rds?: string | null, cloudformation?: string | null, lambda?: string | null, apiGateway?: string | null, cloudwatchLogs?: string | null, cloudwatchMetrics?: string | null } | null, gcpLinks?: { __typename?: 'GCPLinks', deploymentManager?: string | null, cloudRun?: string | null, cloudFunctions?: string | null, cloudFunctionsTrigger?: string | null, cloudLogging?: string | null, cloudMonitoring?: string | null } | null, loadBalancers?: Array<{ __typename?: 'LoadBalancer', dns: Array<string>, ips: Array<string>, ports?: Array<number> | null }> | null, deployStatus?: { __typename?: 'DeployStatus', active: boolean, replicas: number, publicIPs?: Array<string> | null, state: string, errorMessage?: string | null, troubleshooting?: { __typename?: 'Troubleshooting', issue?: { __typename?: 'TroubleshootingIssue', blocks?: Array<{ __typename?: 'TroubleshootingIssueBlock', blockType?: TroubleshootingIssueBlockType | null, content?: string | null }> | null } | null } | null } | null, build?: { __typename?: 'Build', id: string, image?: string | null } | null, alternativeImages?: Array<{ __typename?: 'AlternativeImage', reference?: string | null, tag?: string | null, name?: string | null }> | null } | null, envs?: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string, visible: boolean, sealed: boolean, source?: { __typename?: 'EnvVarSource', type: EnvVarSourceType } | null }> | null, collaborators?: Array<{ __typename?: 'ProjectCollaborator', id: string, role: ProjectCollaboratorRole, user: { __typename?: 'User', id: string, name: string, login: any, avatar?: string | null, isTeam?: boolean | null } }> | null, volumes?: Array<{ __typename?: 'VolumeSpec', mountPath: string, size: number }> | null, replication?: Array<{ __typename?: 'Replication', region: string, replicas?: number | null, cluster?: { __typename?: 'Cluster', id: string, name: string, region?: string | null } | null }> | null, cluster?: { __typename?: 'Cluster', id: string, name: string, region?: string | null, ingressIP?: string | null, connected?: boolean | null, staticIPs?: Array<string> | null, cloudProvider?: CloudProvider | null, clusterProvider?: ClusterProvider | null, state: ClusterState, domain?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, projectID?: string | null } | null, logShipper?: { __typename?: 'LogShipper', type: LogShipperType, logz?: { __typename?: 'LogzIntegration', token: string, url?: string | null } | null, syslog?: { __typename?: 'SyslogIntegration', host: string, port: string, mode: string } | null, logDNA?: { __typename?: 'LogDNAIntegration', key: string } | null, datadog?: { __typename?: 'DatadogLogIntegration', key: string, host?: string | null } | null, betterstack?: { __typename?: 'BetterStackIntegration', token: string } | null } | null, readinessProbe?: { __typename?: 'Probe', command?: string | null, initialDelaySeconds: number, periodSeconds: number, successThreshold: number, failureThreshold: number, timeoutSeconds: number, http?: { __typename?: 'HTTPProbe', host?: string | null, port: string, path?: string | null } | null, tcp?: { __typename?: 'TCPProbe', host?: string | null, port: string } | null } | null, livenessProbe?: { __typename?: 'Probe', command?: string | null, initialDelaySeconds: number, periodSeconds: number, successThreshold: number, failureThreshold: number, timeoutSeconds: number, http?: { __typename?: 'HTTPProbe', host?: string | null, port: string, path?: string | null } | null, tcp?: { __typename?: 'TCPProbe', host?: string | null, port: string } | null } | null, startupProbe?: { __typename?: 'Probe', command?: string | null, initialDelaySeconds: number, periodSeconds: number, successThreshold: number, failureThreshold: number, timeoutSeconds: number, http?: { __typename?: 'HTTPProbe', host?: string | null, port: string, path?: string | null } | null, tcp?: { __typename?: 'TCPProbe', host?: string | null, port: string } | null } | null, gpu?: { __typename?: 'GPUSpec', type?: string | null, count: number } | null, tpu?: { __typename?: 'TPUSpec', type: string, cores: number, tfVersion: string } | null, githubIntegration?: { __typename?: 'GitHubRepoIntegration', id: string, autoDeployBranch: boolean, autoStopBranch: boolean, branchIgnore: string, branchStopIgnore: string, githubRepository?: { __typename?: 'GitHubRepository', id: string, owner: string, name: string } | null } | null, gitlabIntegration?: { __typename?: 'GitlabRepoIntegration', id: string, autoDeployBranch: boolean, autoStopBranch: boolean, branchIgnore: string, branchStopIgnore: string } | null, branchResources?: { __typename?: 'ContainerResourcesSpec', cpu?: number | null, memory?: number | null, ephemeralStorage?: number | null, spot?: boolean | null, accelerator?: { __typename?: 'AcceleratorSpec', type?: string | null, count?: number | null } | null } | null, serverlessResources?: { __typename?: 'ServerlessResourceSpec', cpu?: number | null, memory?: number | null } | null, prometheusScrape?: { __typename?: 'PrometheusScrape', path: string, port: number } | null, jobRuns?: { __typename?: 'JobRunConnection', totalCount: number } | null, autoscaling?: { __typename?: 'Autoscaling', kedaScaledObjectSpec?: string | null, minReplicas: number, maxReplicas: number, coolDownPeriod?: number | null, triggers?: Array<{ __typename?: 'AutoscalingTrigger', type: AutoscalingType, spec: any }> | null } | null, containerRegistry?: { __typename?: 'ContainerRegistry', id: string } | null, databaseEnvs: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string }>, databaseLinks: Array<{ __typename?: 'DatabaseLink', id: string, envPrefix?: string | null, envs?: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string }> | null, database: { __typename?: 'Repo', id: string, path: string, enabled: boolean, productionBranch?: string | null, deployTarget?: DeployTarget | null, deployType?: DeployType | null, deployService?: boolean | null, deployJob?: boolean | null, image?: string | null, cpu?: string | null, memory?: string | null, updatedAt: Date, disableReason?: DisableReason | null, databaseProvider?: DatabaseProviderType | null, databaseEngine?: DatabaseEngineType | null, name: string, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, projectID?: string | null } | null, gpu?: { __typename?: 'GPUSpec', type?: string | null, count: number } | null, tpu?: { __typename?: 'TPUSpec', tfVersion: string, type: string, cores: number } | null, cluster?: { __typename?: 'Cluster', id: string, name: string, domain?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null } | null, autoscaling?: { __typename?: 'Autoscaling', minReplicas: number, maxReplicas: number } | null, owner: { __typename?: 'User', id: string, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, owner: { __typename?: 'User', id: string, login: any } } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null } }>, linkedProjects: Array<{ __typename?: 'DatabaseLink', id: string, envPrefix?: string | null, repo: { __typename?: 'Repo', id: string, path: string, enabled: boolean, productionBranch?: string | null, deployTarget?: DeployTarget | null, deployType?: DeployType | null, deployService?: boolean | null, deployJob?: boolean | null, image?: string | null, cpu?: string | null, memory?: string | null, updatedAt: Date, disableReason?: DisableReason | null, databaseProvider?: DatabaseProviderType | null, databaseEngine?: DatabaseEngineType | null, name: string, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, projectID?: string | null } | null, gpu?: { __typename?: 'GPUSpec', type?: string | null, count: number } | null, tpu?: { __typename?: 'TPUSpec', tfVersion: string, type: string, cores: number } | null, cluster?: { __typename?: 'Cluster', id: string, name: string, domain?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null } | null, autoscaling?: { __typename?: 'Autoscaling', minReplicas: number, maxReplicas: number } | null, owner: { __typename?: 'User', id: string, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, owner: { __typename?: 'User', id: string, login: any } } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null } }>, pipelineCluster?: { __typename?: 'Cluster', id: string } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string, envs?: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string, visible: boolean, sealed: boolean, source?: { __typename?: 'EnvVarSource', type: EnvVarSourceType } | null }> | null } | null, pipelineLinks?: Array<{ __typename?: 'RepoPipelineLink', id: string, sourceEvent: RepoEvent, targetAction: RepoAction, source: { __typename?: 'Repo', id: string }, targetGroup: { __typename?: 'RepoGroup', id: string, selector?: { __typename?: 'LabelSelectors', matchLabels?: any | null } | null } }> | null, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null } | null, owner: { __typename?: 'User', id: string, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, clusterDomains?: Array<{ __typename?: 'ClusterDomains', id: string, cluster: { __typename?: 'Cluster', id: string, name: string }, domains?: Array<{ __typename?: 'CustomDomain', id: string, domain: string, isApex: boolean, cnameTargets?: Array<string> | null, ipTargets?: Array<string> | null, disableCertManager?: boolean | null, certManagerChallengeType?: CertManagerChallengeType | null, syncDomain?: { __typename?: 'CustomDomain', id: string } | null, instructions?: Array<{ __typename?: 'DNSRecord', domain: string, type: DnsRecordType, value?: string | null }> | null, certificate?: { __typename?: 'Certificate', dnsNames?: Array<string> | null, ready: boolean, issuing: boolean, challenges?: Array<{ __typename?: 'CertificateChallenge', dnsName: string, solver: string, statusReason: string, statusState: string, type: string, wildcard: boolean }> | null, instructions?: Array<{ __typename?: 'DNSRecord', domain: string, type: DnsRecordType, value?: string | null }> | null } | null }> | null }> | null, cdns?: Array<{ __typename?: 'CDN', id: string, endpoint?: string | null, state: string, domains?: Array<{ __typename?: 'CDNDomain', domain: string, certReady?: boolean | null, routeReady?: boolean | null, instruction?: { __typename?: 'DNSRecord', domain: string, type: DnsRecordType, value?: string | null } | null }> | null, certificate?: { __typename?: 'Certificate', dnsNames?: Array<string> | null, ready: boolean, issuing: boolean, instructions?: Array<{ __typename?: 'DNSRecord', name?: string | null, domain: string, type: DnsRecordType, value?: string | null }> | null } | null }> | null, ports?: Array<{ __typename?: 'Port', port: string, externalPort: string, protocol: string, public: boolean, https: boolean, grpc: boolean, loadBalancer: boolean }> | null, buildMethod?: { __typename?: 'BuildMethod', name: string, type: BuildType, workingDirectory?: string | null, dockerfilePath?: string | null, buildCommand?: string | null, staticPath?: string | null, runCommand?: string | null, releaseCommand?: string | null, nodejsVersion?: string | null, pythonVersion?: string | null, golangVersion?: string | null } | null, buildResources?: { __typename?: 'ContainerResourcesSpec', cpu?: number | null, memory?: number | null, ephemeralStorage?: number | null, spot?: boolean | null } | null, buildSpec?: { __typename?: 'ContainerSpec', cpu?: number | null, memory?: number | null } | null, kanikoFlags?: { __typename?: 'KanikoFlags', compressedCaching?: boolean | null } | null } };

export type DeleteProjectMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteProjectMutation = { __typename?: 'Mutation', deleteRepo: boolean };

export type UnlinkProjectMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UnlinkProjectMutation = { __typename?: 'Mutation', unlinkRepo: boolean };

export type DuplicateProjectMutationVariables = Exact<{
  input: DuplicateProjectInput;
}>;


export type DuplicateProjectMutation = { __typename?: 'Mutation', duplicateProject: { __typename?: 'Repo', appID?: string | null, defaultIngressDomain?: string | null, kappID?: string | null, useHumanReadableKubernetesName?: boolean | null, namespace?: string | null, deployTarget?: DeployTarget | null, manualDeploy?: boolean | null, deployStrategy?: DeployStrategy | null, free?: boolean | null, cpu?: string | null, memory?: string | null, ephemeralStorage?: number | null, dedicated?: boolean | null, productionBranch?: string | null, serverlessRegion?: string | null, helmValues?: string | null, terraformVersion?: string | null, terraformVariables?: any | null, deployService?: boolean | null, deployJob?: boolean | null, preStopSleep?: number | null, terminationGracePeriodSeconds?: number | null, databaseProvider?: DatabaseProviderType | null, databaseEngine?: DatabaseEngineType | null, databaseVersion?: string | null, autoRetry?: boolean | null, autoRollback?: boolean | null, canDeploy?: boolean | null, awsIamRole?: string | null, gcpServiceAccount?: string | null, datadogApmEnabled?: boolean | null, deployTimeoutSeconds?: number | null, id: string, path: string, enabled: boolean, deployType?: DeployType | null, image?: string | null, updatedAt: Date, disableReason?: DisableReason | null, hostNetwork?: boolean | null, staticIP?: boolean | null, noBuildCache?: boolean | null, gitSubmodules?: GitSubmodulesType | null, alternativeImageTagTemplates?: Array<string> | null, name: string, secretMounts?: Array<{ __typename?: 'KubernetesSecretMount', secretName: string, mountPath: string, readOnly: boolean }> | null, kubernetesCustomization?: { __typename?: 'KubernetesCustomization', serviceAccountName?: string | null, podAnnotations?: any | null, serviceAnnotations?: any | null, ingressAnnotations?: any | null } | null, manifest?: { __typename?: 'Manifest', manifests?: Array<string> | null, manifestValue?: string | null, kustomizeDirs?: Array<string> | null } | null, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, environments: Array<{ __typename?: 'ProjectEnvironment', id: string, name: string }>, envs?: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string, visible: boolean, sealed: boolean, source?: { __typename?: 'EnvVarSource', type: EnvVarSourceType } | null }> | null, owner: { __typename?: 'User', id: string, login: any } } | null, productionDeployment?: { __typename?: 'Deployment', id: string, description?: string | null, version: string, status: DeploymentStatus, branch?: string | null, endpoints?: Array<string> | null, privateEndpoint?: string | null, errorMessage?: string | null, updatedAt: Date, createdAt: Date, awsLinks?: { __typename?: 'AWSLinks', rds?: string | null, cloudformation?: string | null, lambda?: string | null, apiGateway?: string | null, cloudwatchLogs?: string | null, cloudwatchMetrics?: string | null } | null, gcpLinks?: { __typename?: 'GCPLinks', deploymentManager?: string | null, cloudRun?: string | null, cloudFunctions?: string | null, cloudFunctionsTrigger?: string | null, cloudLogging?: string | null, cloudMonitoring?: string | null } | null, loadBalancers?: Array<{ __typename?: 'LoadBalancer', dns: Array<string>, ips: Array<string>, ports?: Array<number> | null }> | null, deployStatus?: { __typename?: 'DeployStatus', active: boolean, replicas: number, publicIPs?: Array<string> | null, state: string, errorMessage?: string | null, troubleshooting?: { __typename?: 'Troubleshooting', issue?: { __typename?: 'TroubleshootingIssue', blocks?: Array<{ __typename?: 'TroubleshootingIssueBlock', blockType?: TroubleshootingIssueBlockType | null, content?: string | null }> | null } | null } | null } | null, build?: { __typename?: 'Build', id: string, image?: string | null } | null, alternativeImages?: Array<{ __typename?: 'AlternativeImage', reference?: string | null, tag?: string | null, name?: string | null }> | null } | null, envs?: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string, visible: boolean, sealed: boolean, source?: { __typename?: 'EnvVarSource', type: EnvVarSourceType } | null }> | null, collaborators?: Array<{ __typename?: 'ProjectCollaborator', id: string, role: ProjectCollaboratorRole, user: { __typename?: 'User', id: string, name: string, login: any, avatar?: string | null, isTeam?: boolean | null } }> | null, volumes?: Array<{ __typename?: 'VolumeSpec', mountPath: string, size: number }> | null, replication?: Array<{ __typename?: 'Replication', region: string, replicas?: number | null, cluster?: { __typename?: 'Cluster', id: string, name: string, region?: string | null } | null }> | null, cluster?: { __typename?: 'Cluster', id: string, name: string, region?: string | null, ingressIP?: string | null, connected?: boolean | null, staticIPs?: Array<string> | null, cloudProvider?: CloudProvider | null, clusterProvider?: ClusterProvider | null, state: ClusterState, domain?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, projectID?: string | null } | null, logShipper?: { __typename?: 'LogShipper', type: LogShipperType, logz?: { __typename?: 'LogzIntegration', token: string, url?: string | null } | null, syslog?: { __typename?: 'SyslogIntegration', host: string, port: string, mode: string } | null, logDNA?: { __typename?: 'LogDNAIntegration', key: string } | null, datadog?: { __typename?: 'DatadogLogIntegration', key: string, host?: string | null } | null, betterstack?: { __typename?: 'BetterStackIntegration', token: string } | null } | null, readinessProbe?: { __typename?: 'Probe', command?: string | null, initialDelaySeconds: number, periodSeconds: number, successThreshold: number, failureThreshold: number, timeoutSeconds: number, http?: { __typename?: 'HTTPProbe', host?: string | null, port: string, path?: string | null } | null, tcp?: { __typename?: 'TCPProbe', host?: string | null, port: string } | null } | null, livenessProbe?: { __typename?: 'Probe', command?: string | null, initialDelaySeconds: number, periodSeconds: number, successThreshold: number, failureThreshold: number, timeoutSeconds: number, http?: { __typename?: 'HTTPProbe', host?: string | null, port: string, path?: string | null } | null, tcp?: { __typename?: 'TCPProbe', host?: string | null, port: string } | null } | null, startupProbe?: { __typename?: 'Probe', command?: string | null, initialDelaySeconds: number, periodSeconds: number, successThreshold: number, failureThreshold: number, timeoutSeconds: number, http?: { __typename?: 'HTTPProbe', host?: string | null, port: string, path?: string | null } | null, tcp?: { __typename?: 'TCPProbe', host?: string | null, port: string } | null } | null, gpu?: { __typename?: 'GPUSpec', type?: string | null, count: number } | null, tpu?: { __typename?: 'TPUSpec', type: string, cores: number, tfVersion: string } | null, githubIntegration?: { __typename?: 'GitHubRepoIntegration', id: string, autoDeployBranch: boolean, autoStopBranch: boolean, branchIgnore: string, branchStopIgnore: string, githubRepository?: { __typename?: 'GitHubRepository', id: string, owner: string, name: string } | null } | null, gitlabIntegration?: { __typename?: 'GitlabRepoIntegration', id: string, autoDeployBranch: boolean, autoStopBranch: boolean, branchIgnore: string, branchStopIgnore: string } | null, branchResources?: { __typename?: 'ContainerResourcesSpec', cpu?: number | null, memory?: number | null, ephemeralStorage?: number | null, spot?: boolean | null, accelerator?: { __typename?: 'AcceleratorSpec', type?: string | null, count?: number | null } | null } | null, serverlessResources?: { __typename?: 'ServerlessResourceSpec', cpu?: number | null, memory?: number | null } | null, prometheusScrape?: { __typename?: 'PrometheusScrape', path: string, port: number } | null, jobRuns?: { __typename?: 'JobRunConnection', totalCount: number } | null, autoscaling?: { __typename?: 'Autoscaling', kedaScaledObjectSpec?: string | null, minReplicas: number, maxReplicas: number, coolDownPeriod?: number | null, triggers?: Array<{ __typename?: 'AutoscalingTrigger', type: AutoscalingType, spec: any }> | null } | null, containerRegistry?: { __typename?: 'ContainerRegistry', id: string } | null, databaseEnvs: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string }>, databaseLinks: Array<{ __typename?: 'DatabaseLink', id: string, envPrefix?: string | null, envs?: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string }> | null, database: { __typename?: 'Repo', id: string, path: string, enabled: boolean, productionBranch?: string | null, deployTarget?: DeployTarget | null, deployType?: DeployType | null, deployService?: boolean | null, deployJob?: boolean | null, image?: string | null, cpu?: string | null, memory?: string | null, updatedAt: Date, disableReason?: DisableReason | null, databaseProvider?: DatabaseProviderType | null, databaseEngine?: DatabaseEngineType | null, name: string, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, projectID?: string | null } | null, gpu?: { __typename?: 'GPUSpec', type?: string | null, count: number } | null, tpu?: { __typename?: 'TPUSpec', tfVersion: string, type: string, cores: number } | null, cluster?: { __typename?: 'Cluster', id: string, name: string, domain?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null } | null, autoscaling?: { __typename?: 'Autoscaling', minReplicas: number, maxReplicas: number } | null, owner: { __typename?: 'User', id: string, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, owner: { __typename?: 'User', id: string, login: any } } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null } }>, linkedProjects: Array<{ __typename?: 'DatabaseLink', id: string, envPrefix?: string | null, repo: { __typename?: 'Repo', id: string, path: string, enabled: boolean, productionBranch?: string | null, deployTarget?: DeployTarget | null, deployType?: DeployType | null, deployService?: boolean | null, deployJob?: boolean | null, image?: string | null, cpu?: string | null, memory?: string | null, updatedAt: Date, disableReason?: DisableReason | null, databaseProvider?: DatabaseProviderType | null, databaseEngine?: DatabaseEngineType | null, name: string, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, projectID?: string | null } | null, gpu?: { __typename?: 'GPUSpec', type?: string | null, count: number } | null, tpu?: { __typename?: 'TPUSpec', tfVersion: string, type: string, cores: number } | null, cluster?: { __typename?: 'Cluster', id: string, name: string, domain?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null } | null, autoscaling?: { __typename?: 'Autoscaling', minReplicas: number, maxReplicas: number } | null, owner: { __typename?: 'User', id: string, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, owner: { __typename?: 'User', id: string, login: any } } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null } }>, pipelineCluster?: { __typename?: 'Cluster', id: string } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string, envs?: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string, visible: boolean, sealed: boolean, source?: { __typename?: 'EnvVarSource', type: EnvVarSourceType } | null }> | null } | null, pipelineLinks?: Array<{ __typename?: 'RepoPipelineLink', id: string, sourceEvent: RepoEvent, targetAction: RepoAction, source: { __typename?: 'Repo', id: string }, targetGroup: { __typename?: 'RepoGroup', id: string, selector?: { __typename?: 'LabelSelectors', matchLabels?: any | null } | null } }> | null, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null } | null, owner: { __typename?: 'User', id: string, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, clusterDomains?: Array<{ __typename?: 'ClusterDomains', id: string, cluster: { __typename?: 'Cluster', id: string, name: string }, domains?: Array<{ __typename?: 'CustomDomain', id: string, domain: string, isApex: boolean, cnameTargets?: Array<string> | null, ipTargets?: Array<string> | null, disableCertManager?: boolean | null, certManagerChallengeType?: CertManagerChallengeType | null, syncDomain?: { __typename?: 'CustomDomain', id: string } | null, instructions?: Array<{ __typename?: 'DNSRecord', domain: string, type: DnsRecordType, value?: string | null }> | null, certificate?: { __typename?: 'Certificate', dnsNames?: Array<string> | null, ready: boolean, issuing: boolean, challenges?: Array<{ __typename?: 'CertificateChallenge', dnsName: string, solver: string, statusReason: string, statusState: string, type: string, wildcard: boolean }> | null, instructions?: Array<{ __typename?: 'DNSRecord', domain: string, type: DnsRecordType, value?: string | null }> | null } | null }> | null }> | null, cdns?: Array<{ __typename?: 'CDN', id: string, endpoint?: string | null, state: string, domains?: Array<{ __typename?: 'CDNDomain', domain: string, certReady?: boolean | null, routeReady?: boolean | null, instruction?: { __typename?: 'DNSRecord', domain: string, type: DnsRecordType, value?: string | null } | null }> | null, certificate?: { __typename?: 'Certificate', dnsNames?: Array<string> | null, ready: boolean, issuing: boolean, instructions?: Array<{ __typename?: 'DNSRecord', name?: string | null, domain: string, type: DnsRecordType, value?: string | null }> | null } | null }> | null, ports?: Array<{ __typename?: 'Port', port: string, externalPort: string, protocol: string, public: boolean, https: boolean, grpc: boolean, loadBalancer: boolean }> | null, buildMethod?: { __typename?: 'BuildMethod', name: string, type: BuildType, workingDirectory?: string | null, dockerfilePath?: string | null, buildCommand?: string | null, staticPath?: string | null, runCommand?: string | null, releaseCommand?: string | null, nodejsVersion?: string | null, pythonVersion?: string | null, golangVersion?: string | null } | null, buildResources?: { __typename?: 'ContainerResourcesSpec', cpu?: number | null, memory?: number | null, ephemeralStorage?: number | null, spot?: boolean | null } | null, buildSpec?: { __typename?: 'ContainerSpec', cpu?: number | null, memory?: number | null } | null, kanikoFlags?: { __typename?: 'KanikoFlags', compressedCaching?: boolean | null } | null } };

export type DeleteProjectV2MutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DeleteProjectV2Mutation = { __typename?: 'Mutation', deleteProjectV2: boolean };

export type DeleteProjectV3MutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DeleteProjectV3Mutation = { __typename?: 'Mutation', deleteProjectV3: boolean };

export type UpdateProjectV2MutationVariables = Exact<{
  input: UpdateProjectV2Input;
}>;


export type UpdateProjectV2Mutation = { __typename?: 'Mutation', updateProjectV2: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, owner: { __typename?: 'User', id: string, login: any } } };

export type MoveRepoTargetsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type MoveRepoTargetsQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, projects: { __typename?: 'ProjectConnection', nodes: Array<{ __typename?: 'Project', id: string, name: string, environments: Array<{ __typename?: 'ProjectEnvironment', id: string, name: string }> }> } } };

export type MoveRepoMutationVariables = Exact<{
  input: MoveRepoInput;
}>;


export type MoveRepoMutation = { __typename?: 'Mutation', moveRepoToProjectEnvironment: { __typename?: 'Repo', appID?: string | null, defaultIngressDomain?: string | null, kappID?: string | null, useHumanReadableKubernetesName?: boolean | null, namespace?: string | null, deployTarget?: DeployTarget | null, manualDeploy?: boolean | null, deployStrategy?: DeployStrategy | null, free?: boolean | null, cpu?: string | null, memory?: string | null, ephemeralStorage?: number | null, dedicated?: boolean | null, productionBranch?: string | null, serverlessRegion?: string | null, helmValues?: string | null, terraformVersion?: string | null, terraformVariables?: any | null, deployService?: boolean | null, deployJob?: boolean | null, preStopSleep?: number | null, terminationGracePeriodSeconds?: number | null, databaseProvider?: DatabaseProviderType | null, databaseEngine?: DatabaseEngineType | null, databaseVersion?: string | null, autoRetry?: boolean | null, autoRollback?: boolean | null, canDeploy?: boolean | null, awsIamRole?: string | null, gcpServiceAccount?: string | null, datadogApmEnabled?: boolean | null, deployTimeoutSeconds?: number | null, id: string, path: string, enabled: boolean, deployType?: DeployType | null, image?: string | null, updatedAt: Date, disableReason?: DisableReason | null, hostNetwork?: boolean | null, staticIP?: boolean | null, noBuildCache?: boolean | null, gitSubmodules?: GitSubmodulesType | null, alternativeImageTagTemplates?: Array<string> | null, name: string, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string, envs?: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string, visible: boolean, sealed: boolean, source?: { __typename?: 'EnvVarSource', type: EnvVarSourceType } | null }> | null } | null, secretMounts?: Array<{ __typename?: 'KubernetesSecretMount', secretName: string, mountPath: string, readOnly: boolean }> | null, kubernetesCustomization?: { __typename?: 'KubernetesCustomization', serviceAccountName?: string | null, podAnnotations?: any | null, serviceAnnotations?: any | null, ingressAnnotations?: any | null } | null, manifest?: { __typename?: 'Manifest', manifests?: Array<string> | null, manifestValue?: string | null, kustomizeDirs?: Array<string> | null } | null, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, environments: Array<{ __typename?: 'ProjectEnvironment', id: string, name: string }>, envs?: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string, visible: boolean, sealed: boolean, source?: { __typename?: 'EnvVarSource', type: EnvVarSourceType } | null }> | null, owner: { __typename?: 'User', id: string, login: any } } | null, productionDeployment?: { __typename?: 'Deployment', id: string, description?: string | null, version: string, status: DeploymentStatus, branch?: string | null, endpoints?: Array<string> | null, privateEndpoint?: string | null, errorMessage?: string | null, updatedAt: Date, createdAt: Date, awsLinks?: { __typename?: 'AWSLinks', rds?: string | null, cloudformation?: string | null, lambda?: string | null, apiGateway?: string | null, cloudwatchLogs?: string | null, cloudwatchMetrics?: string | null } | null, gcpLinks?: { __typename?: 'GCPLinks', deploymentManager?: string | null, cloudRun?: string | null, cloudFunctions?: string | null, cloudFunctionsTrigger?: string | null, cloudLogging?: string | null, cloudMonitoring?: string | null } | null, loadBalancers?: Array<{ __typename?: 'LoadBalancer', dns: Array<string>, ips: Array<string>, ports?: Array<number> | null }> | null, deployStatus?: { __typename?: 'DeployStatus', active: boolean, replicas: number, publicIPs?: Array<string> | null, state: string, errorMessage?: string | null, troubleshooting?: { __typename?: 'Troubleshooting', issue?: { __typename?: 'TroubleshootingIssue', blocks?: Array<{ __typename?: 'TroubleshootingIssueBlock', blockType?: TroubleshootingIssueBlockType | null, content?: string | null }> | null } | null } | null } | null, build?: { __typename?: 'Build', id: string, image?: string | null } | null, alternativeImages?: Array<{ __typename?: 'AlternativeImage', reference?: string | null, tag?: string | null, name?: string | null }> | null } | null, envs?: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string, visible: boolean, sealed: boolean, source?: { __typename?: 'EnvVarSource', type: EnvVarSourceType } | null }> | null, collaborators?: Array<{ __typename?: 'ProjectCollaborator', id: string, role: ProjectCollaboratorRole, user: { __typename?: 'User', id: string, name: string, login: any, avatar?: string | null, isTeam?: boolean | null } }> | null, volumes?: Array<{ __typename?: 'VolumeSpec', mountPath: string, size: number }> | null, replication?: Array<{ __typename?: 'Replication', region: string, replicas?: number | null, cluster?: { __typename?: 'Cluster', id: string, name: string, region?: string | null } | null }> | null, cluster?: { __typename?: 'Cluster', id: string, name: string, region?: string | null, ingressIP?: string | null, connected?: boolean | null, staticIPs?: Array<string> | null, cloudProvider?: CloudProvider | null, clusterProvider?: ClusterProvider | null, state: ClusterState, domain?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, projectID?: string | null } | null, logShipper?: { __typename?: 'LogShipper', type: LogShipperType, logz?: { __typename?: 'LogzIntegration', token: string, url?: string | null } | null, syslog?: { __typename?: 'SyslogIntegration', host: string, port: string, mode: string } | null, logDNA?: { __typename?: 'LogDNAIntegration', key: string } | null, datadog?: { __typename?: 'DatadogLogIntegration', key: string, host?: string | null } | null, betterstack?: { __typename?: 'BetterStackIntegration', token: string } | null } | null, readinessProbe?: { __typename?: 'Probe', command?: string | null, initialDelaySeconds: number, periodSeconds: number, successThreshold: number, failureThreshold: number, timeoutSeconds: number, http?: { __typename?: 'HTTPProbe', host?: string | null, port: string, path?: string | null } | null, tcp?: { __typename?: 'TCPProbe', host?: string | null, port: string } | null } | null, livenessProbe?: { __typename?: 'Probe', command?: string | null, initialDelaySeconds: number, periodSeconds: number, successThreshold: number, failureThreshold: number, timeoutSeconds: number, http?: { __typename?: 'HTTPProbe', host?: string | null, port: string, path?: string | null } | null, tcp?: { __typename?: 'TCPProbe', host?: string | null, port: string } | null } | null, startupProbe?: { __typename?: 'Probe', command?: string | null, initialDelaySeconds: number, periodSeconds: number, successThreshold: number, failureThreshold: number, timeoutSeconds: number, http?: { __typename?: 'HTTPProbe', host?: string | null, port: string, path?: string | null } | null, tcp?: { __typename?: 'TCPProbe', host?: string | null, port: string } | null } | null, gpu?: { __typename?: 'GPUSpec', type?: string | null, count: number } | null, tpu?: { __typename?: 'TPUSpec', type: string, cores: number, tfVersion: string } | null, githubIntegration?: { __typename?: 'GitHubRepoIntegration', id: string, autoDeployBranch: boolean, autoStopBranch: boolean, branchIgnore: string, branchStopIgnore: string, githubRepository?: { __typename?: 'GitHubRepository', id: string, owner: string, name: string } | null } | null, gitlabIntegration?: { __typename?: 'GitlabRepoIntegration', id: string, autoDeployBranch: boolean, autoStopBranch: boolean, branchIgnore: string, branchStopIgnore: string } | null, branchResources?: { __typename?: 'ContainerResourcesSpec', cpu?: number | null, memory?: number | null, ephemeralStorage?: number | null, spot?: boolean | null, accelerator?: { __typename?: 'AcceleratorSpec', type?: string | null, count?: number | null } | null } | null, serverlessResources?: { __typename?: 'ServerlessResourceSpec', cpu?: number | null, memory?: number | null } | null, prometheusScrape?: { __typename?: 'PrometheusScrape', path: string, port: number } | null, jobRuns?: { __typename?: 'JobRunConnection', totalCount: number } | null, autoscaling?: { __typename?: 'Autoscaling', kedaScaledObjectSpec?: string | null, minReplicas: number, maxReplicas: number, coolDownPeriod?: number | null, triggers?: Array<{ __typename?: 'AutoscalingTrigger', type: AutoscalingType, spec: any }> | null } | null, containerRegistry?: { __typename?: 'ContainerRegistry', id: string } | null, databaseEnvs: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string }>, databaseLinks: Array<{ __typename?: 'DatabaseLink', id: string, envPrefix?: string | null, envs?: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string }> | null, database: { __typename?: 'Repo', id: string, path: string, enabled: boolean, productionBranch?: string | null, deployTarget?: DeployTarget | null, deployType?: DeployType | null, deployService?: boolean | null, deployJob?: boolean | null, image?: string | null, cpu?: string | null, memory?: string | null, updatedAt: Date, disableReason?: DisableReason | null, databaseProvider?: DatabaseProviderType | null, databaseEngine?: DatabaseEngineType | null, name: string, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, projectID?: string | null } | null, gpu?: { __typename?: 'GPUSpec', type?: string | null, count: number } | null, tpu?: { __typename?: 'TPUSpec', tfVersion: string, type: string, cores: number } | null, cluster?: { __typename?: 'Cluster', id: string, name: string, domain?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null } | null, autoscaling?: { __typename?: 'Autoscaling', minReplicas: number, maxReplicas: number } | null, owner: { __typename?: 'User', id: string, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, owner: { __typename?: 'User', id: string, login: any } } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null } }>, linkedProjects: Array<{ __typename?: 'DatabaseLink', id: string, envPrefix?: string | null, repo: { __typename?: 'Repo', id: string, path: string, enabled: boolean, productionBranch?: string | null, deployTarget?: DeployTarget | null, deployType?: DeployType | null, deployService?: boolean | null, deployJob?: boolean | null, image?: string | null, cpu?: string | null, memory?: string | null, updatedAt: Date, disableReason?: DisableReason | null, databaseProvider?: DatabaseProviderType | null, databaseEngine?: DatabaseEngineType | null, name: string, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, projectID?: string | null } | null, gpu?: { __typename?: 'GPUSpec', type?: string | null, count: number } | null, tpu?: { __typename?: 'TPUSpec', tfVersion: string, type: string, cores: number } | null, cluster?: { __typename?: 'Cluster', id: string, name: string, domain?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null } | null, autoscaling?: { __typename?: 'Autoscaling', minReplicas: number, maxReplicas: number } | null, owner: { __typename?: 'User', id: string, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, owner: { __typename?: 'User', id: string, login: any } } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null } }>, pipelineCluster?: { __typename?: 'Cluster', id: string } | null, pipelineLinks?: Array<{ __typename?: 'RepoPipelineLink', id: string, sourceEvent: RepoEvent, targetAction: RepoAction, source: { __typename?: 'Repo', id: string }, targetGroup: { __typename?: 'RepoGroup', id: string, selector?: { __typename?: 'LabelSelectors', matchLabels?: any | null } | null } }> | null, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null } | null, owner: { __typename?: 'User', id: string, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, clusterDomains?: Array<{ __typename?: 'ClusterDomains', id: string, cluster: { __typename?: 'Cluster', id: string, name: string }, domains?: Array<{ __typename?: 'CustomDomain', id: string, domain: string, isApex: boolean, cnameTargets?: Array<string> | null, ipTargets?: Array<string> | null, disableCertManager?: boolean | null, certManagerChallengeType?: CertManagerChallengeType | null, syncDomain?: { __typename?: 'CustomDomain', id: string } | null, instructions?: Array<{ __typename?: 'DNSRecord', domain: string, type: DnsRecordType, value?: string | null }> | null, certificate?: { __typename?: 'Certificate', dnsNames?: Array<string> | null, ready: boolean, issuing: boolean, challenges?: Array<{ __typename?: 'CertificateChallenge', dnsName: string, solver: string, statusReason: string, statusState: string, type: string, wildcard: boolean }> | null, instructions?: Array<{ __typename?: 'DNSRecord', domain: string, type: DnsRecordType, value?: string | null }> | null } | null }> | null }> | null, cdns?: Array<{ __typename?: 'CDN', id: string, endpoint?: string | null, state: string, domains?: Array<{ __typename?: 'CDNDomain', domain: string, certReady?: boolean | null, routeReady?: boolean | null, instruction?: { __typename?: 'DNSRecord', domain: string, type: DnsRecordType, value?: string | null } | null }> | null, certificate?: { __typename?: 'Certificate', dnsNames?: Array<string> | null, ready: boolean, issuing: boolean, instructions?: Array<{ __typename?: 'DNSRecord', name?: string | null, domain: string, type: DnsRecordType, value?: string | null }> | null } | null }> | null, ports?: Array<{ __typename?: 'Port', port: string, externalPort: string, protocol: string, public: boolean, https: boolean, grpc: boolean, loadBalancer: boolean }> | null, buildMethod?: { __typename?: 'BuildMethod', name: string, type: BuildType, workingDirectory?: string | null, dockerfilePath?: string | null, buildCommand?: string | null, staticPath?: string | null, runCommand?: string | null, releaseCommand?: string | null, nodejsVersion?: string | null, pythonVersion?: string | null, golangVersion?: string | null } | null, buildResources?: { __typename?: 'ContainerResourcesSpec', cpu?: number | null, memory?: number | null, ephemeralStorage?: number | null, spot?: boolean | null } | null, buildSpec?: { __typename?: 'ContainerSpec', cpu?: number | null, memory?: number | null } | null, kanikoFlags?: { __typename?: 'KanikoFlags', compressedCaching?: boolean | null } | null } };

export type ConfigureUserProjectPermissionsMutationVariables = Exact<{
  projectID: Scalars['UUID'];
  permission: ProjectPermissionsInput;
}>;


export type ConfigureUserProjectPermissionsMutation = { __typename?: 'Mutation', configureProjectPermissions: boolean };

export type CreateProjectEnvironmentMutationVariables = Exact<{
  input: CreateProjectEnvironmentInput;
}>;


export type CreateProjectEnvironmentMutation = { __typename?: 'Mutation', createProjectEnvironment: { __typename?: 'ProjectEnvironment', id: string, name: string } };

export type UpdateProjectEnvironmentMutationVariables = Exact<{
  input: UpdateProjectEnvironmentInput;
}>;


export type UpdateProjectEnvironmentMutation = { __typename?: 'Mutation', updateProjectEnvironment: { __typename?: 'ProjectEnvironment', id: string, name: string } };

export type DeleteProjectEnvironmentMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DeleteProjectEnvironmentMutation = { __typename?: 'Mutation', deleteProjectEnvironment: boolean };

export type UpdateProjectEnvironmentVariablesMutationVariables = Exact<{
  input: UpdateProjectV2Input;
}>;


export type UpdateProjectEnvironmentVariablesMutation = { __typename?: 'Mutation', updateProjectV2: { __typename?: 'Project', id: string } };

export type UpdateEnvironmentEnvironmentVariablesMutationVariables = Exact<{
  input: UpdateProjectEnvironmentInput;
}>;


export type UpdateEnvironmentEnvironmentVariablesMutation = { __typename?: 'Mutation', updateProjectEnvironment: { __typename?: 'ProjectEnvironment', id: string, name: string, envs?: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string, visible: boolean, sealed: boolean, source?: { __typename?: 'EnvVarSource', type: EnvVarSourceType } | null }> | null } };

export type CreateResourceAlphaMutationVariables = Exact<{
  input: CreateResourceAlphaInput;
}>;


export type CreateResourceAlphaMutation = { __typename?: 'Mutation', createResourceAlpha: { __typename?: 'Repo', id: string, name: string, project?: { __typename?: 'Project', id: string, name: string } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null } };

export type CreateProjectV3MutationVariables = Exact<{
  input: CreateProjectV3Input;
}>;


export type CreateProjectV3Mutation = { __typename?: 'Mutation', createProjectV3: { __typename?: 'ProjectV3', id: string, requirePlanApproval: boolean, name: string, blueprintID: string, blueprintConfiguration?: { __typename?: 'BlueprintHelmConfiguration', source?: { __typename?: 'Source', git?: { __typename?: 'GitSource', repository: string, path?: string | null, ref?: string | null, integration?: { __typename?: 'GitSourceIntegration', githubInstallationID?: number | null, bitbucketIntegrationID?: string | null, gitlabIntegrationID?: string | null } | null } | null, helmRepository?: { __typename?: 'HelmRepositorySource', chart: string, version?: string | null, repositoryURL: string } | null, containerRegistry?: { __typename?: 'ContainerRegistrySource', registryID?: string | null, registryURL?: string | null, repository: string, tag?: string | null } | null } | null } | { __typename?: 'BlueprintManifestConfiguration', source?: { __typename?: 'Source', git?: { __typename?: 'GitSource', repository: string, path?: string | null, ref?: string | null, integration?: { __typename?: 'GitSourceIntegration', githubInstallationID?: number | null, bitbucketIntegrationID?: string | null, gitlabIntegrationID?: string | null } | null } | null } | null } | { __typename?: 'BlueprintTerraformConfiguration', registrySource?: string | null, moduleVersionConstraint?: string | null, githubSource?: string | null, moduleSource?: { __typename?: 'TerraformModuleSource', source: string, version?: string | null, integration?: { __typename?: 'TerraformModuleSourceIntegration', git?: { __typename?: 'GitSourceIntegration', githubInstallationID?: number | null, bitbucketIntegrationID?: string | null, gitlabIntegrationID?: string | null } | null } | null } | null } | null, configuration?: { __typename?: 'HelmProjectV3Configuration', clusterID: string, namespace?: string | null, releaseName: string, values?: any | null } | { __typename?: 'ManifestProjectV3Configuration', clusterID: string, namespace?: string | null } | { __typename?: 'TerraformProjectV3Configuration', stateBackend: { __typename?: 'TerraformStateBackend', s3Bucket?: { __typename?: 'S3BucketConfiguration', awsAccountID: string, bucketName: string, region: string, key?: string | null } | null, gcsBucket?: { __typename?: 'GCSBucketConfiguration', gcpAccountID: string, bucketName: string, location: string, prefix?: string | null } | null, linodeBucket?: { __typename?: 'LinodeBucketConfiguration', linodeAccountId: string, bucketName: string, region: string, key: string } | null }, provider?: { __typename?: 'TerraformProvider', region?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string } | null } | null } | null, variables: Array<{ __typename?: 'BlueprintVariableBoolean', id: string, variableSpecID?: string | null, name: string, booleanValue: boolean } | { __typename?: 'BlueprintVariableFloat', id: string, variableSpecID?: string | null, name: string, floatValue: number } | { __typename?: 'BlueprintVariableInt', id: string, variableSpecID?: string | null, name: string, intValue: number } | { __typename?: 'BlueprintVariableJSON', id: string, variableSpecID?: string | null, name: string, jsonValue: any } | { __typename?: 'BlueprintVariableString', id: string, variableSpecID?: string | null, name: string, stringValue: string }>, driverWorkflows?: Array<{ __typename?: 'BlueprintDriverWorkflow', id: string, status: ProjectV3WorkflowStatus, createdAt: Date, updatedAt: Date, steps: Array<{ __typename?: 'BlueprintDriverWorkflowStep', action: BlueprintDriverWorkflowStepAction, status: BlueprintDriverWorkflowStepStatus, execution?: { __typename?: 'BlueprintDriverActionExecution', id: string, driver: BlueprintDriver, action: BlueprintDriverAction, approvedAt?: Date | null, jobRun?: { __typename?: 'JobRun', id: string, state: JobRunState, createdAt?: Date | null, updatedAt?: Date | null } | null } | null }> }> | null } };

export type DuplicateProjectV3MutationVariables = Exact<{
  input: DuplicateProjectV3Input;
}>;


export type DuplicateProjectV3Mutation = { __typename?: 'Mutation', duplicateProjectV3: { __typename?: 'ProjectV3', id: string, name: string, project?: { __typename?: 'Project', id: string, name: string } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null } };

export type UpdateProjectV3MutationVariables = Exact<{
  projectID: Scalars['UUID'];
  input: UpdateProjectV3Input;
}>;


export type UpdateProjectV3Mutation = { __typename?: 'Mutation', updateProjectV3: { __typename?: 'ProjectV3', id: string } };

export type CreateBlueprintDriverWorkflowMutationVariables = Exact<{
  projectID: Scalars['UUID'];
  driver: BlueprintDriver;
  steps: Array<BlueprintDriverWorkflowStepAction> | BlueprintDriverWorkflowStepAction;
}>;


export type CreateBlueprintDriverWorkflowMutation = { __typename?: 'Mutation', submitBlueprintDriverWorkflow?: { __typename?: 'BlueprintDriverWorkflow', id: string, status: ProjectV3WorkflowStatus, createdAt: Date, updatedAt: Date, steps: Array<{ __typename?: 'BlueprintDriverWorkflowStep', action: BlueprintDriverWorkflowStepAction, status: BlueprintDriverWorkflowStepStatus, execution?: { __typename?: 'BlueprintDriverActionExecution', id: string, driver: BlueprintDriver, action: BlueprintDriverAction, approvedAt?: Date | null, jobRun?: { __typename?: 'JobRun', id: string, state: JobRunState, createdAt?: Date | null, updatedAt?: Date | null, logs?: { __typename?: 'Logs', id: string, completed: boolean, expired: boolean, entries?: Array<{ __typename?: 'LogEntry', text: string, timestamp?: Date | null }> | null } | null } | null } | null }> } | null };

export type ApproveBlueprintDriverWorkflowMutationVariables = Exact<{
  workflowID: Scalars['UUID'];
}>;


export type ApproveBlueprintDriverWorkflowMutation = { __typename?: 'Mutation', approveBlueprintDriverWorkflow?: { __typename?: 'BlueprintDriverWorkflow', id: string, status: ProjectV3WorkflowStatus, createdAt: Date, updatedAt: Date, steps: Array<{ __typename?: 'BlueprintDriverWorkflowStep', action: BlueprintDriverWorkflowStepAction, status: BlueprintDriverWorkflowStepStatus, execution?: { __typename?: 'BlueprintDriverActionExecution', id: string, driver: BlueprintDriver, action: BlueprintDriverAction, approvedAt?: Date | null, jobRun?: { __typename?: 'JobRun', id: string, state: JobRunState, createdAt?: Date | null, updatedAt?: Date | null, logs?: { __typename?: 'Logs', id: string, completed: boolean, expired: boolean, entries?: Array<{ __typename?: 'LogEntry', text: string, timestamp?: Date | null }> | null } | null } | null } | null }> } | null };

export type AbortBlueprintDriverWorkflowMutationVariables = Exact<{
  workflowID: Scalars['UUID'];
}>;


export type AbortBlueprintDriverWorkflowMutation = { __typename?: 'Mutation', abortBlueprintDriverWorkflow?: string | null };

export type RollbackToDeploymentMutationVariables = Exact<{
  projectID: Scalars['UUID'];
  deploymentID: Scalars['UUID'];
}>;


export type RollbackToDeploymentMutation = { __typename?: 'Mutation', rollbackProjectToDeployment: { __typename?: 'Repo', id: string, productionDeployment?: { __typename?: 'Deployment', id: string, status: DeploymentStatus, deployStatus?: { __typename?: 'DeployStatus', state: string, active: boolean } | null } | null } };

export type DeployRepoBranchMutationVariables = Exact<{
  input: DeployRepoBranchInput;
}>;


export type DeployRepoBranchMutation = { __typename?: 'Mutation', deployRepoBranch: { __typename?: 'Repo', appID?: string | null, defaultIngressDomain?: string | null, kappID?: string | null, useHumanReadableKubernetesName?: boolean | null, namespace?: string | null, deployTarget?: DeployTarget | null, manualDeploy?: boolean | null, deployStrategy?: DeployStrategy | null, free?: boolean | null, cpu?: string | null, memory?: string | null, ephemeralStorage?: number | null, dedicated?: boolean | null, productionBranch?: string | null, serverlessRegion?: string | null, helmValues?: string | null, terraformVersion?: string | null, terraformVariables?: any | null, deployService?: boolean | null, deployJob?: boolean | null, preStopSleep?: number | null, terminationGracePeriodSeconds?: number | null, databaseProvider?: DatabaseProviderType | null, databaseEngine?: DatabaseEngineType | null, databaseVersion?: string | null, autoRetry?: boolean | null, autoRollback?: boolean | null, canDeploy?: boolean | null, awsIamRole?: string | null, gcpServiceAccount?: string | null, datadogApmEnabled?: boolean | null, deployTimeoutSeconds?: number | null, id: string, path: string, enabled: boolean, deployType?: DeployType | null, image?: string | null, updatedAt: Date, disableReason?: DisableReason | null, hostNetwork?: boolean | null, staticIP?: boolean | null, noBuildCache?: boolean | null, gitSubmodules?: GitSubmodulesType | null, alternativeImageTagTemplates?: Array<string> | null, name: string, secretMounts?: Array<{ __typename?: 'KubernetesSecretMount', secretName: string, mountPath: string, readOnly: boolean }> | null, kubernetesCustomization?: { __typename?: 'KubernetesCustomization', serviceAccountName?: string | null, podAnnotations?: any | null, serviceAnnotations?: any | null, ingressAnnotations?: any | null } | null, manifest?: { __typename?: 'Manifest', manifests?: Array<string> | null, manifestValue?: string | null, kustomizeDirs?: Array<string> | null } | null, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, environments: Array<{ __typename?: 'ProjectEnvironment', id: string, name: string }>, envs?: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string, visible: boolean, sealed: boolean, source?: { __typename?: 'EnvVarSource', type: EnvVarSourceType } | null }> | null, owner: { __typename?: 'User', id: string, login: any } } | null, productionDeployment?: { __typename?: 'Deployment', id: string, description?: string | null, version: string, status: DeploymentStatus, branch?: string | null, endpoints?: Array<string> | null, privateEndpoint?: string | null, errorMessage?: string | null, updatedAt: Date, createdAt: Date, awsLinks?: { __typename?: 'AWSLinks', rds?: string | null, cloudformation?: string | null, lambda?: string | null, apiGateway?: string | null, cloudwatchLogs?: string | null, cloudwatchMetrics?: string | null } | null, gcpLinks?: { __typename?: 'GCPLinks', deploymentManager?: string | null, cloudRun?: string | null, cloudFunctions?: string | null, cloudFunctionsTrigger?: string | null, cloudLogging?: string | null, cloudMonitoring?: string | null } | null, loadBalancers?: Array<{ __typename?: 'LoadBalancer', dns: Array<string>, ips: Array<string>, ports?: Array<number> | null }> | null, deployStatus?: { __typename?: 'DeployStatus', active: boolean, replicas: number, publicIPs?: Array<string> | null, state: string, errorMessage?: string | null, troubleshooting?: { __typename?: 'Troubleshooting', issue?: { __typename?: 'TroubleshootingIssue', blocks?: Array<{ __typename?: 'TroubleshootingIssueBlock', blockType?: TroubleshootingIssueBlockType | null, content?: string | null }> | null } | null } | null } | null, build?: { __typename?: 'Build', id: string, image?: string | null } | null, alternativeImages?: Array<{ __typename?: 'AlternativeImage', reference?: string | null, tag?: string | null, name?: string | null }> | null } | null, envs?: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string, visible: boolean, sealed: boolean, source?: { __typename?: 'EnvVarSource', type: EnvVarSourceType } | null }> | null, collaborators?: Array<{ __typename?: 'ProjectCollaborator', id: string, role: ProjectCollaboratorRole, user: { __typename?: 'User', id: string, name: string, login: any, avatar?: string | null, isTeam?: boolean | null } }> | null, volumes?: Array<{ __typename?: 'VolumeSpec', mountPath: string, size: number }> | null, replication?: Array<{ __typename?: 'Replication', region: string, replicas?: number | null, cluster?: { __typename?: 'Cluster', id: string, name: string, region?: string | null } | null }> | null, cluster?: { __typename?: 'Cluster', id: string, name: string, region?: string | null, ingressIP?: string | null, connected?: boolean | null, staticIPs?: Array<string> | null, cloudProvider?: CloudProvider | null, clusterProvider?: ClusterProvider | null, state: ClusterState, domain?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, projectID?: string | null } | null, logShipper?: { __typename?: 'LogShipper', type: LogShipperType, logz?: { __typename?: 'LogzIntegration', token: string, url?: string | null } | null, syslog?: { __typename?: 'SyslogIntegration', host: string, port: string, mode: string } | null, logDNA?: { __typename?: 'LogDNAIntegration', key: string } | null, datadog?: { __typename?: 'DatadogLogIntegration', key: string, host?: string | null } | null, betterstack?: { __typename?: 'BetterStackIntegration', token: string } | null } | null, readinessProbe?: { __typename?: 'Probe', command?: string | null, initialDelaySeconds: number, periodSeconds: number, successThreshold: number, failureThreshold: number, timeoutSeconds: number, http?: { __typename?: 'HTTPProbe', host?: string | null, port: string, path?: string | null } | null, tcp?: { __typename?: 'TCPProbe', host?: string | null, port: string } | null } | null, livenessProbe?: { __typename?: 'Probe', command?: string | null, initialDelaySeconds: number, periodSeconds: number, successThreshold: number, failureThreshold: number, timeoutSeconds: number, http?: { __typename?: 'HTTPProbe', host?: string | null, port: string, path?: string | null } | null, tcp?: { __typename?: 'TCPProbe', host?: string | null, port: string } | null } | null, startupProbe?: { __typename?: 'Probe', command?: string | null, initialDelaySeconds: number, periodSeconds: number, successThreshold: number, failureThreshold: number, timeoutSeconds: number, http?: { __typename?: 'HTTPProbe', host?: string | null, port: string, path?: string | null } | null, tcp?: { __typename?: 'TCPProbe', host?: string | null, port: string } | null } | null, gpu?: { __typename?: 'GPUSpec', type?: string | null, count: number } | null, tpu?: { __typename?: 'TPUSpec', type: string, cores: number, tfVersion: string } | null, githubIntegration?: { __typename?: 'GitHubRepoIntegration', id: string, autoDeployBranch: boolean, autoStopBranch: boolean, branchIgnore: string, branchStopIgnore: string, githubRepository?: { __typename?: 'GitHubRepository', id: string, owner: string, name: string } | null } | null, gitlabIntegration?: { __typename?: 'GitlabRepoIntegration', id: string, autoDeployBranch: boolean, autoStopBranch: boolean, branchIgnore: string, branchStopIgnore: string } | null, branchResources?: { __typename?: 'ContainerResourcesSpec', cpu?: number | null, memory?: number | null, ephemeralStorage?: number | null, spot?: boolean | null, accelerator?: { __typename?: 'AcceleratorSpec', type?: string | null, count?: number | null } | null } | null, serverlessResources?: { __typename?: 'ServerlessResourceSpec', cpu?: number | null, memory?: number | null } | null, prometheusScrape?: { __typename?: 'PrometheusScrape', path: string, port: number } | null, jobRuns?: { __typename?: 'JobRunConnection', totalCount: number } | null, autoscaling?: { __typename?: 'Autoscaling', kedaScaledObjectSpec?: string | null, minReplicas: number, maxReplicas: number, coolDownPeriod?: number | null, triggers?: Array<{ __typename?: 'AutoscalingTrigger', type: AutoscalingType, spec: any }> | null } | null, containerRegistry?: { __typename?: 'ContainerRegistry', id: string } | null, databaseEnvs: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string }>, databaseLinks: Array<{ __typename?: 'DatabaseLink', id: string, envPrefix?: string | null, envs?: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string }> | null, database: { __typename?: 'Repo', id: string, path: string, enabled: boolean, productionBranch?: string | null, deployTarget?: DeployTarget | null, deployType?: DeployType | null, deployService?: boolean | null, deployJob?: boolean | null, image?: string | null, cpu?: string | null, memory?: string | null, updatedAt: Date, disableReason?: DisableReason | null, databaseProvider?: DatabaseProviderType | null, databaseEngine?: DatabaseEngineType | null, name: string, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, projectID?: string | null } | null, gpu?: { __typename?: 'GPUSpec', type?: string | null, count: number } | null, tpu?: { __typename?: 'TPUSpec', tfVersion: string, type: string, cores: number } | null, cluster?: { __typename?: 'Cluster', id: string, name: string, domain?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null } | null, autoscaling?: { __typename?: 'Autoscaling', minReplicas: number, maxReplicas: number } | null, owner: { __typename?: 'User', id: string, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, owner: { __typename?: 'User', id: string, login: any } } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null } }>, linkedProjects: Array<{ __typename?: 'DatabaseLink', id: string, envPrefix?: string | null, repo: { __typename?: 'Repo', id: string, path: string, enabled: boolean, productionBranch?: string | null, deployTarget?: DeployTarget | null, deployType?: DeployType | null, deployService?: boolean | null, deployJob?: boolean | null, image?: string | null, cpu?: string | null, memory?: string | null, updatedAt: Date, disableReason?: DisableReason | null, databaseProvider?: DatabaseProviderType | null, databaseEngine?: DatabaseEngineType | null, name: string, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, projectID?: string | null } | null, gpu?: { __typename?: 'GPUSpec', type?: string | null, count: number } | null, tpu?: { __typename?: 'TPUSpec', tfVersion: string, type: string, cores: number } | null, cluster?: { __typename?: 'Cluster', id: string, name: string, domain?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null } | null, autoscaling?: { __typename?: 'Autoscaling', minReplicas: number, maxReplicas: number } | null, owner: { __typename?: 'User', id: string, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, owner: { __typename?: 'User', id: string, login: any } } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null } }>, pipelineCluster?: { __typename?: 'Cluster', id: string } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string, envs?: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string, visible: boolean, sealed: boolean, source?: { __typename?: 'EnvVarSource', type: EnvVarSourceType } | null }> | null } | null, pipelineLinks?: Array<{ __typename?: 'RepoPipelineLink', id: string, sourceEvent: RepoEvent, targetAction: RepoAction, source: { __typename?: 'Repo', id: string }, targetGroup: { __typename?: 'RepoGroup', id: string, selector?: { __typename?: 'LabelSelectors', matchLabels?: any | null } | null } }> | null, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null } | null, owner: { __typename?: 'User', id: string, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, clusterDomains?: Array<{ __typename?: 'ClusterDomains', id: string, cluster: { __typename?: 'Cluster', id: string, name: string }, domains?: Array<{ __typename?: 'CustomDomain', id: string, domain: string, isApex: boolean, cnameTargets?: Array<string> | null, ipTargets?: Array<string> | null, disableCertManager?: boolean | null, certManagerChallengeType?: CertManagerChallengeType | null, syncDomain?: { __typename?: 'CustomDomain', id: string } | null, instructions?: Array<{ __typename?: 'DNSRecord', domain: string, type: DnsRecordType, value?: string | null }> | null, certificate?: { __typename?: 'Certificate', dnsNames?: Array<string> | null, ready: boolean, issuing: boolean, challenges?: Array<{ __typename?: 'CertificateChallenge', dnsName: string, solver: string, statusReason: string, statusState: string, type: string, wildcard: boolean }> | null, instructions?: Array<{ __typename?: 'DNSRecord', domain: string, type: DnsRecordType, value?: string | null }> | null } | null }> | null }> | null, cdns?: Array<{ __typename?: 'CDN', id: string, endpoint?: string | null, state: string, domains?: Array<{ __typename?: 'CDNDomain', domain: string, certReady?: boolean | null, routeReady?: boolean | null, instruction?: { __typename?: 'DNSRecord', domain: string, type: DnsRecordType, value?: string | null } | null }> | null, certificate?: { __typename?: 'Certificate', dnsNames?: Array<string> | null, ready: boolean, issuing: boolean, instructions?: Array<{ __typename?: 'DNSRecord', name?: string | null, domain: string, type: DnsRecordType, value?: string | null }> | null } | null }> | null, ports?: Array<{ __typename?: 'Port', port: string, externalPort: string, protocol: string, public: boolean, https: boolean, grpc: boolean, loadBalancer: boolean }> | null, buildMethod?: { __typename?: 'BuildMethod', name: string, type: BuildType, workingDirectory?: string | null, dockerfilePath?: string | null, buildCommand?: string | null, staticPath?: string | null, runCommand?: string | null, releaseCommand?: string | null, nodejsVersion?: string | null, pythonVersion?: string | null, golangVersion?: string | null } | null, buildResources?: { __typename?: 'ContainerResourcesSpec', cpu?: number | null, memory?: number | null, ephemeralStorage?: number | null, spot?: boolean | null } | null, buildSpec?: { __typename?: 'ContainerSpec', cpu?: number | null, memory?: number | null } | null, kanikoFlags?: { __typename?: 'KanikoFlags', compressedCaching?: boolean | null } | null } };

export type AbortBuildMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type AbortBuildMutation = { __typename?: 'Mutation', abortBuild: { __typename?: 'Repo', appID?: string | null, defaultIngressDomain?: string | null, kappID?: string | null, useHumanReadableKubernetesName?: boolean | null, namespace?: string | null, deployTarget?: DeployTarget | null, manualDeploy?: boolean | null, deployStrategy?: DeployStrategy | null, free?: boolean | null, cpu?: string | null, memory?: string | null, ephemeralStorage?: number | null, dedicated?: boolean | null, productionBranch?: string | null, serverlessRegion?: string | null, helmValues?: string | null, terraformVersion?: string | null, terraformVariables?: any | null, deployService?: boolean | null, deployJob?: boolean | null, preStopSleep?: number | null, terminationGracePeriodSeconds?: number | null, databaseProvider?: DatabaseProviderType | null, databaseEngine?: DatabaseEngineType | null, databaseVersion?: string | null, autoRetry?: boolean | null, autoRollback?: boolean | null, canDeploy?: boolean | null, awsIamRole?: string | null, gcpServiceAccount?: string | null, datadogApmEnabled?: boolean | null, deployTimeoutSeconds?: number | null, id: string, path: string, enabled: boolean, deployType?: DeployType | null, image?: string | null, updatedAt: Date, disableReason?: DisableReason | null, hostNetwork?: boolean | null, staticIP?: boolean | null, noBuildCache?: boolean | null, gitSubmodules?: GitSubmodulesType | null, alternativeImageTagTemplates?: Array<string> | null, name: string, secretMounts?: Array<{ __typename?: 'KubernetesSecretMount', secretName: string, mountPath: string, readOnly: boolean }> | null, kubernetesCustomization?: { __typename?: 'KubernetesCustomization', serviceAccountName?: string | null, podAnnotations?: any | null, serviceAnnotations?: any | null, ingressAnnotations?: any | null } | null, manifest?: { __typename?: 'Manifest', manifests?: Array<string> | null, manifestValue?: string | null, kustomizeDirs?: Array<string> | null } | null, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, environments: Array<{ __typename?: 'ProjectEnvironment', id: string, name: string }>, envs?: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string, visible: boolean, sealed: boolean, source?: { __typename?: 'EnvVarSource', type: EnvVarSourceType } | null }> | null, owner: { __typename?: 'User', id: string, login: any } } | null, productionDeployment?: { __typename?: 'Deployment', id: string, description?: string | null, version: string, status: DeploymentStatus, branch?: string | null, endpoints?: Array<string> | null, privateEndpoint?: string | null, errorMessage?: string | null, updatedAt: Date, createdAt: Date, awsLinks?: { __typename?: 'AWSLinks', rds?: string | null, cloudformation?: string | null, lambda?: string | null, apiGateway?: string | null, cloudwatchLogs?: string | null, cloudwatchMetrics?: string | null } | null, gcpLinks?: { __typename?: 'GCPLinks', deploymentManager?: string | null, cloudRun?: string | null, cloudFunctions?: string | null, cloudFunctionsTrigger?: string | null, cloudLogging?: string | null, cloudMonitoring?: string | null } | null, loadBalancers?: Array<{ __typename?: 'LoadBalancer', dns: Array<string>, ips: Array<string>, ports?: Array<number> | null }> | null, deployStatus?: { __typename?: 'DeployStatus', active: boolean, replicas: number, publicIPs?: Array<string> | null, state: string, errorMessage?: string | null, troubleshooting?: { __typename?: 'Troubleshooting', issue?: { __typename?: 'TroubleshootingIssue', blocks?: Array<{ __typename?: 'TroubleshootingIssueBlock', blockType?: TroubleshootingIssueBlockType | null, content?: string | null }> | null } | null } | null } | null, build?: { __typename?: 'Build', id: string, image?: string | null } | null, alternativeImages?: Array<{ __typename?: 'AlternativeImage', reference?: string | null, tag?: string | null, name?: string | null }> | null } | null, envs?: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string, visible: boolean, sealed: boolean, source?: { __typename?: 'EnvVarSource', type: EnvVarSourceType } | null }> | null, collaborators?: Array<{ __typename?: 'ProjectCollaborator', id: string, role: ProjectCollaboratorRole, user: { __typename?: 'User', id: string, name: string, login: any, avatar?: string | null, isTeam?: boolean | null } }> | null, volumes?: Array<{ __typename?: 'VolumeSpec', mountPath: string, size: number }> | null, replication?: Array<{ __typename?: 'Replication', region: string, replicas?: number | null, cluster?: { __typename?: 'Cluster', id: string, name: string, region?: string | null } | null }> | null, cluster?: { __typename?: 'Cluster', id: string, name: string, region?: string | null, ingressIP?: string | null, connected?: boolean | null, staticIPs?: Array<string> | null, cloudProvider?: CloudProvider | null, clusterProvider?: ClusterProvider | null, state: ClusterState, domain?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, projectID?: string | null } | null, logShipper?: { __typename?: 'LogShipper', type: LogShipperType, logz?: { __typename?: 'LogzIntegration', token: string, url?: string | null } | null, syslog?: { __typename?: 'SyslogIntegration', host: string, port: string, mode: string } | null, logDNA?: { __typename?: 'LogDNAIntegration', key: string } | null, datadog?: { __typename?: 'DatadogLogIntegration', key: string, host?: string | null } | null, betterstack?: { __typename?: 'BetterStackIntegration', token: string } | null } | null, readinessProbe?: { __typename?: 'Probe', command?: string | null, initialDelaySeconds: number, periodSeconds: number, successThreshold: number, failureThreshold: number, timeoutSeconds: number, http?: { __typename?: 'HTTPProbe', host?: string | null, port: string, path?: string | null } | null, tcp?: { __typename?: 'TCPProbe', host?: string | null, port: string } | null } | null, livenessProbe?: { __typename?: 'Probe', command?: string | null, initialDelaySeconds: number, periodSeconds: number, successThreshold: number, failureThreshold: number, timeoutSeconds: number, http?: { __typename?: 'HTTPProbe', host?: string | null, port: string, path?: string | null } | null, tcp?: { __typename?: 'TCPProbe', host?: string | null, port: string } | null } | null, startupProbe?: { __typename?: 'Probe', command?: string | null, initialDelaySeconds: number, periodSeconds: number, successThreshold: number, failureThreshold: number, timeoutSeconds: number, http?: { __typename?: 'HTTPProbe', host?: string | null, port: string, path?: string | null } | null, tcp?: { __typename?: 'TCPProbe', host?: string | null, port: string } | null } | null, gpu?: { __typename?: 'GPUSpec', type?: string | null, count: number } | null, tpu?: { __typename?: 'TPUSpec', type: string, cores: number, tfVersion: string } | null, githubIntegration?: { __typename?: 'GitHubRepoIntegration', id: string, autoDeployBranch: boolean, autoStopBranch: boolean, branchIgnore: string, branchStopIgnore: string, githubRepository?: { __typename?: 'GitHubRepository', id: string, owner: string, name: string } | null } | null, gitlabIntegration?: { __typename?: 'GitlabRepoIntegration', id: string, autoDeployBranch: boolean, autoStopBranch: boolean, branchIgnore: string, branchStopIgnore: string } | null, branchResources?: { __typename?: 'ContainerResourcesSpec', cpu?: number | null, memory?: number | null, ephemeralStorage?: number | null, spot?: boolean | null, accelerator?: { __typename?: 'AcceleratorSpec', type?: string | null, count?: number | null } | null } | null, serverlessResources?: { __typename?: 'ServerlessResourceSpec', cpu?: number | null, memory?: number | null } | null, prometheusScrape?: { __typename?: 'PrometheusScrape', path: string, port: number } | null, jobRuns?: { __typename?: 'JobRunConnection', totalCount: number } | null, autoscaling?: { __typename?: 'Autoscaling', kedaScaledObjectSpec?: string | null, minReplicas: number, maxReplicas: number, coolDownPeriod?: number | null, triggers?: Array<{ __typename?: 'AutoscalingTrigger', type: AutoscalingType, spec: any }> | null } | null, containerRegistry?: { __typename?: 'ContainerRegistry', id: string } | null, databaseEnvs: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string }>, databaseLinks: Array<{ __typename?: 'DatabaseLink', id: string, envPrefix?: string | null, envs?: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string }> | null, database: { __typename?: 'Repo', id: string, path: string, enabled: boolean, productionBranch?: string | null, deployTarget?: DeployTarget | null, deployType?: DeployType | null, deployService?: boolean | null, deployJob?: boolean | null, image?: string | null, cpu?: string | null, memory?: string | null, updatedAt: Date, disableReason?: DisableReason | null, databaseProvider?: DatabaseProviderType | null, databaseEngine?: DatabaseEngineType | null, name: string, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, projectID?: string | null } | null, gpu?: { __typename?: 'GPUSpec', type?: string | null, count: number } | null, tpu?: { __typename?: 'TPUSpec', tfVersion: string, type: string, cores: number } | null, cluster?: { __typename?: 'Cluster', id: string, name: string, domain?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null } | null, autoscaling?: { __typename?: 'Autoscaling', minReplicas: number, maxReplicas: number } | null, owner: { __typename?: 'User', id: string, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, owner: { __typename?: 'User', id: string, login: any } } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null } }>, linkedProjects: Array<{ __typename?: 'DatabaseLink', id: string, envPrefix?: string | null, repo: { __typename?: 'Repo', id: string, path: string, enabled: boolean, productionBranch?: string | null, deployTarget?: DeployTarget | null, deployType?: DeployType | null, deployService?: boolean | null, deployJob?: boolean | null, image?: string | null, cpu?: string | null, memory?: string | null, updatedAt: Date, disableReason?: DisableReason | null, databaseProvider?: DatabaseProviderType | null, databaseEngine?: DatabaseEngineType | null, name: string, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, projectID?: string | null } | null, gpu?: { __typename?: 'GPUSpec', type?: string | null, count: number } | null, tpu?: { __typename?: 'TPUSpec', tfVersion: string, type: string, cores: number } | null, cluster?: { __typename?: 'Cluster', id: string, name: string, domain?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null } | null, autoscaling?: { __typename?: 'Autoscaling', minReplicas: number, maxReplicas: number } | null, owner: { __typename?: 'User', id: string, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, owner: { __typename?: 'User', id: string, login: any } } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null } }>, pipelineCluster?: { __typename?: 'Cluster', id: string } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string, envs?: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string, visible: boolean, sealed: boolean, source?: { __typename?: 'EnvVarSource', type: EnvVarSourceType } | null }> | null } | null, pipelineLinks?: Array<{ __typename?: 'RepoPipelineLink', id: string, sourceEvent: RepoEvent, targetAction: RepoAction, source: { __typename?: 'Repo', id: string }, targetGroup: { __typename?: 'RepoGroup', id: string, selector?: { __typename?: 'LabelSelectors', matchLabels?: any | null } | null } }> | null, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null } | null, owner: { __typename?: 'User', id: string, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, clusterDomains?: Array<{ __typename?: 'ClusterDomains', id: string, cluster: { __typename?: 'Cluster', id: string, name: string }, domains?: Array<{ __typename?: 'CustomDomain', id: string, domain: string, isApex: boolean, cnameTargets?: Array<string> | null, ipTargets?: Array<string> | null, disableCertManager?: boolean | null, certManagerChallengeType?: CertManagerChallengeType | null, syncDomain?: { __typename?: 'CustomDomain', id: string } | null, instructions?: Array<{ __typename?: 'DNSRecord', domain: string, type: DnsRecordType, value?: string | null }> | null, certificate?: { __typename?: 'Certificate', dnsNames?: Array<string> | null, ready: boolean, issuing: boolean, challenges?: Array<{ __typename?: 'CertificateChallenge', dnsName: string, solver: string, statusReason: string, statusState: string, type: string, wildcard: boolean }> | null, instructions?: Array<{ __typename?: 'DNSRecord', domain: string, type: DnsRecordType, value?: string | null }> | null } | null }> | null }> | null, cdns?: Array<{ __typename?: 'CDN', id: string, endpoint?: string | null, state: string, domains?: Array<{ __typename?: 'CDNDomain', domain: string, certReady?: boolean | null, routeReady?: boolean | null, instruction?: { __typename?: 'DNSRecord', domain: string, type: DnsRecordType, value?: string | null } | null }> | null, certificate?: { __typename?: 'Certificate', dnsNames?: Array<string> | null, ready: boolean, issuing: boolean, instructions?: Array<{ __typename?: 'DNSRecord', name?: string | null, domain: string, type: DnsRecordType, value?: string | null }> | null } | null }> | null, ports?: Array<{ __typename?: 'Port', port: string, externalPort: string, protocol: string, public: boolean, https: boolean, grpc: boolean, loadBalancer: boolean }> | null, buildMethod?: { __typename?: 'BuildMethod', name: string, type: BuildType, workingDirectory?: string | null, dockerfilePath?: string | null, buildCommand?: string | null, staticPath?: string | null, runCommand?: string | null, releaseCommand?: string | null, nodejsVersion?: string | null, pythonVersion?: string | null, golangVersion?: string | null } | null, buildResources?: { __typename?: 'ContainerResourcesSpec', cpu?: number | null, memory?: number | null, ephemeralStorage?: number | null, spot?: boolean | null } | null, buildSpec?: { __typename?: 'ContainerSpec', cpu?: number | null, memory?: number | null } | null, kanikoFlags?: { __typename?: 'KanikoFlags', compressedCaching?: boolean | null } | null } };

export type AddContainerRegistryMutationVariables = Exact<{
  input: AddContainerRegistryInput;
}>;


export type AddContainerRegistryMutation = { __typename?: 'Mutation', addContainerRegistry: { __typename?: 'ContainerRegistry', id: string, name: string, registry: string, username?: string | null } };

export type RemoveContainerRegistryMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type RemoveContainerRegistryMutation = { __typename?: 'Mutation', removeContainerRegistry: boolean };

export type CreateRepoPipelineLinkMutationVariables = Exact<{
  input: CreateRepoPipelineLinkInput;
}>;


export type CreateRepoPipelineLinkMutation = { __typename?: 'Mutation', createRepoPipelineLink: { __typename?: 'RepoPipelineLink', id: string, sourceEvent: RepoEvent, targetAction: RepoAction, source: { __typename?: 'Repo', id: string }, targetGroup: { __typename?: 'RepoGroup', id: string, selector?: { __typename?: 'LabelSelectors', matchLabels?: any | null } | null } } };

export type DeleteRepoPipelineLinkMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DeleteRepoPipelineLinkMutation = { __typename?: 'Mutation', deleteRepoPipelineLink?: boolean | null };

export type UpdateRepoPipelineLinkMutationVariables = Exact<{
  input: UpdateRepoPipelineLinkInput;
}>;


export type UpdateRepoPipelineLinkMutation = { __typename?: 'Mutation', updateRepoPipelineLink: { __typename?: 'RepoPipelineLink', id: string, sourceEvent: RepoEvent, targetAction: RepoAction, source: { __typename?: 'Repo', id: string }, targetGroup: { __typename?: 'RepoGroup', id: string, selector?: { __typename?: 'LabelSelectors', matchLabels?: any | null } | null } } };

export type CreateTeamMutationVariables = Exact<{
  input: CreateTeamInput;
}>;


export type CreateTeamMutation = { __typename?: 'Mutation', createTeam: { __typename?: 'Team', id: string, plan: { __typename?: 'Plan', tier: PlanTier, billingPeriod?: PlanBillingPeriod | null }, user: { __typename?: 'User', id: string, email?: string | null, createdAt?: Date | null, freeTrialEndsAt?: Date | null, hasPaymentMethod?: boolean | null, paymentError?: string | null, paymentAuthorizationError?: string | null, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null, billingOverview?: { __typename?: 'BillingOverview', hasUpgradedProducts: boolean, isBillingSetup: boolean, currentProducts?: Array<{ __typename?: 'ApiAccess', name?: string | null, description?: string | null, sku: string, displayPrice?: string | null, benefits: Array<string>, productTypeMetadata?: { __typename?: 'ProductTypeMetadata', productType?: ProductType | null, displayName?: string | null, pricingPageAnchor?: string | null } | null, usage: Array<{ __typename?: 'Usage', unit: string, unitPlural: string, displayName: string, currentUsage?: number | null, maximumUsage?: number | null, description?: string | null }> } | { __typename?: 'PlanTierV2', name?: string | null, description?: string | null, sku: string, displayPrice?: string | null, benefits: Array<string>, productTypeMetadata?: { __typename?: 'ProductTypeMetadata', productType?: ProductType | null, displayName?: string | null, pricingPageAnchor?: string | null } | null, usage: Array<{ __typename?: 'Usage', unit: string, unitPlural: string, displayName: string, currentUsage?: number | null, maximumUsage?: number | null, description?: string | null }> } | { __typename?: 'ProjectPack', name?: string | null, description?: string | null, sku: string, displayPrice?: string | null, benefits: Array<string>, productTypeMetadata?: { __typename?: 'ProductTypeMetadata', productType?: ProductType | null, displayName?: string | null, pricingPageAnchor?: string | null } | null, usage: Array<{ __typename?: 'Usage', unit: string, unitPlural: string, displayName: string, currentUsage?: number | null, maximumUsage?: number | null, description?: string | null }> } | { __typename?: 'SupportTier', name?: string | null, description?: string | null, sku: string, displayPrice?: string | null, benefits: Array<string>, productTypeMetadata?: { __typename?: 'ProductTypeMetadata', productType?: ProductType | null, displayName?: string | null, pricingPageAnchor?: string | null } | null, usage: Array<{ __typename?: 'Usage', unit: string, unitPlural: string, displayName: string, currentUsage?: number | null, maximumUsage?: number | null, description?: string | null }> }> | null, externalLinks?: { __typename?: 'ExternalBillingProviderLinks', invoiceHistory: { __typename?: 'UrlOrContactUs', url?: string | null, contactUs?: ContactUs | null }, managePaymentMethod: { __typename?: 'UrlOrContactUs', url?: string | null, contactUs?: ContactUs | null }, downgrade: { __typename?: 'UrlOrContactUs', url?: string | null, contactUs?: ContactUs | null }, help: { __typename?: 'UrlOrContactUs', url?: string | null, contactUs?: ContactUs | null } } | null, subscriptionUsageAllowed: { __typename?: 'SubscriptionUsageAllowed', seats: boolean, clusters: boolean, cloudAccounts: boolean, projects: boolean, customBlueprints: boolean } } | null } } };

export type UpdateTeamMutationVariables = Exact<{
  input: UpdateTeamInput;
}>;


export type UpdateTeamMutation = { __typename?: 'Mutation', updateTeam: { __typename?: 'Team', id: string, plan: { __typename?: 'Plan', tier: PlanTier, billingPeriod?: PlanBillingPeriod | null }, user: { __typename?: 'User', id: string, email?: string | null, createdAt?: Date | null, freeTrialEndsAt?: Date | null, hasPaymentMethod?: boolean | null, paymentError?: string | null, paymentAuthorizationError?: string | null, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null, billingOverview?: { __typename?: 'BillingOverview', hasUpgradedProducts: boolean, isBillingSetup: boolean, currentProducts?: Array<{ __typename?: 'ApiAccess', name?: string | null, description?: string | null, sku: string, displayPrice?: string | null, benefits: Array<string>, productTypeMetadata?: { __typename?: 'ProductTypeMetadata', productType?: ProductType | null, displayName?: string | null, pricingPageAnchor?: string | null } | null, usage: Array<{ __typename?: 'Usage', unit: string, unitPlural: string, displayName: string, currentUsage?: number | null, maximumUsage?: number | null, description?: string | null }> } | { __typename?: 'PlanTierV2', name?: string | null, description?: string | null, sku: string, displayPrice?: string | null, benefits: Array<string>, productTypeMetadata?: { __typename?: 'ProductTypeMetadata', productType?: ProductType | null, displayName?: string | null, pricingPageAnchor?: string | null } | null, usage: Array<{ __typename?: 'Usage', unit: string, unitPlural: string, displayName: string, currentUsage?: number | null, maximumUsage?: number | null, description?: string | null }> } | { __typename?: 'ProjectPack', name?: string | null, description?: string | null, sku: string, displayPrice?: string | null, benefits: Array<string>, productTypeMetadata?: { __typename?: 'ProductTypeMetadata', productType?: ProductType | null, displayName?: string | null, pricingPageAnchor?: string | null } | null, usage: Array<{ __typename?: 'Usage', unit: string, unitPlural: string, displayName: string, currentUsage?: number | null, maximumUsage?: number | null, description?: string | null }> } | { __typename?: 'SupportTier', name?: string | null, description?: string | null, sku: string, displayPrice?: string | null, benefits: Array<string>, productTypeMetadata?: { __typename?: 'ProductTypeMetadata', productType?: ProductType | null, displayName?: string | null, pricingPageAnchor?: string | null } | null, usage: Array<{ __typename?: 'Usage', unit: string, unitPlural: string, displayName: string, currentUsage?: number | null, maximumUsage?: number | null, description?: string | null }> }> | null, externalLinks?: { __typename?: 'ExternalBillingProviderLinks', invoiceHistory: { __typename?: 'UrlOrContactUs', url?: string | null, contactUs?: ContactUs | null }, managePaymentMethod: { __typename?: 'UrlOrContactUs', url?: string | null, contactUs?: ContactUs | null }, downgrade: { __typename?: 'UrlOrContactUs', url?: string | null, contactUs?: ContactUs | null }, help: { __typename?: 'UrlOrContactUs', url?: string | null, contactUs?: ContactUs | null } } | null, subscriptionUsageAllowed: { __typename?: 'SubscriptionUsageAllowed', seats: boolean, clusters: boolean, cloudAccounts: boolean, projects: boolean, customBlueprints: boolean } } | null } } };

export type AddTeamMemberMutationVariables = Exact<{
  input: AddTeamMemberInput;
}>;


export type AddTeamMemberMutation = { __typename?: 'Mutation', addTeamMember: { __typename?: 'Team', id: string, members: Array<{ __typename?: 'UserTeamEdge', id: string, role: TeamMemberRole, user: { __typename?: 'User', id: string, name: string } }>, user: { __typename?: 'User', id: string, email?: string | null, createdAt?: Date | null, freeTrialEndsAt?: Date | null, hasPaymentMethod?: boolean | null, paymentError?: string | null, paymentAuthorizationError?: string | null, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null, billingOverview?: { __typename?: 'BillingOverview', hasUpgradedProducts: boolean, isBillingSetup: boolean, currentProducts?: Array<{ __typename?: 'ApiAccess', name?: string | null, description?: string | null, sku: string, displayPrice?: string | null, benefits: Array<string>, productTypeMetadata?: { __typename?: 'ProductTypeMetadata', productType?: ProductType | null, displayName?: string | null, pricingPageAnchor?: string | null } | null, usage: Array<{ __typename?: 'Usage', unit: string, unitPlural: string, displayName: string, currentUsage?: number | null, maximumUsage?: number | null, description?: string | null }> } | { __typename?: 'PlanTierV2', name?: string | null, description?: string | null, sku: string, displayPrice?: string | null, benefits: Array<string>, productTypeMetadata?: { __typename?: 'ProductTypeMetadata', productType?: ProductType | null, displayName?: string | null, pricingPageAnchor?: string | null } | null, usage: Array<{ __typename?: 'Usage', unit: string, unitPlural: string, displayName: string, currentUsage?: number | null, maximumUsage?: number | null, description?: string | null }> } | { __typename?: 'ProjectPack', name?: string | null, description?: string | null, sku: string, displayPrice?: string | null, benefits: Array<string>, productTypeMetadata?: { __typename?: 'ProductTypeMetadata', productType?: ProductType | null, displayName?: string | null, pricingPageAnchor?: string | null } | null, usage: Array<{ __typename?: 'Usage', unit: string, unitPlural: string, displayName: string, currentUsage?: number | null, maximumUsage?: number | null, description?: string | null }> } | { __typename?: 'SupportTier', name?: string | null, description?: string | null, sku: string, displayPrice?: string | null, benefits: Array<string>, productTypeMetadata?: { __typename?: 'ProductTypeMetadata', productType?: ProductType | null, displayName?: string | null, pricingPageAnchor?: string | null } | null, usage: Array<{ __typename?: 'Usage', unit: string, unitPlural: string, displayName: string, currentUsage?: number | null, maximumUsage?: number | null, description?: string | null }> }> | null, externalLinks?: { __typename?: 'ExternalBillingProviderLinks', invoiceHistory: { __typename?: 'UrlOrContactUs', url?: string | null, contactUs?: ContactUs | null }, managePaymentMethod: { __typename?: 'UrlOrContactUs', url?: string | null, contactUs?: ContactUs | null }, downgrade: { __typename?: 'UrlOrContactUs', url?: string | null, contactUs?: ContactUs | null }, help: { __typename?: 'UrlOrContactUs', url?: string | null, contactUs?: ContactUs | null } } | null, subscriptionUsageAllowed: { __typename?: 'SubscriptionUsageAllowed', seats: boolean, clusters: boolean, cloudAccounts: boolean, projects: boolean, customBlueprints: boolean } } | null }, plan: { __typename?: 'Plan', tier: PlanTier, billingPeriod?: PlanBillingPeriod | null } } };

export type RemoveTeamMemberMutationVariables = Exact<{
  input: RemoveTeamMemberInput;
}>;


export type RemoveTeamMemberMutation = { __typename?: 'Mutation', removeTeamMember: { __typename?: 'Team', id: string, plan: { __typename?: 'Plan', tier: PlanTier, billingPeriod?: PlanBillingPeriod | null }, user: { __typename?: 'User', id: string, email?: string | null, createdAt?: Date | null, freeTrialEndsAt?: Date | null, hasPaymentMethod?: boolean | null, paymentError?: string | null, paymentAuthorizationError?: string | null, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null, billingOverview?: { __typename?: 'BillingOverview', hasUpgradedProducts: boolean, isBillingSetup: boolean, currentProducts?: Array<{ __typename?: 'ApiAccess', name?: string | null, description?: string | null, sku: string, displayPrice?: string | null, benefits: Array<string>, productTypeMetadata?: { __typename?: 'ProductTypeMetadata', productType?: ProductType | null, displayName?: string | null, pricingPageAnchor?: string | null } | null, usage: Array<{ __typename?: 'Usage', unit: string, unitPlural: string, displayName: string, currentUsage?: number | null, maximumUsage?: number | null, description?: string | null }> } | { __typename?: 'PlanTierV2', name?: string | null, description?: string | null, sku: string, displayPrice?: string | null, benefits: Array<string>, productTypeMetadata?: { __typename?: 'ProductTypeMetadata', productType?: ProductType | null, displayName?: string | null, pricingPageAnchor?: string | null } | null, usage: Array<{ __typename?: 'Usage', unit: string, unitPlural: string, displayName: string, currentUsage?: number | null, maximumUsage?: number | null, description?: string | null }> } | { __typename?: 'ProjectPack', name?: string | null, description?: string | null, sku: string, displayPrice?: string | null, benefits: Array<string>, productTypeMetadata?: { __typename?: 'ProductTypeMetadata', productType?: ProductType | null, displayName?: string | null, pricingPageAnchor?: string | null } | null, usage: Array<{ __typename?: 'Usage', unit: string, unitPlural: string, displayName: string, currentUsage?: number | null, maximumUsage?: number | null, description?: string | null }> } | { __typename?: 'SupportTier', name?: string | null, description?: string | null, sku: string, displayPrice?: string | null, benefits: Array<string>, productTypeMetadata?: { __typename?: 'ProductTypeMetadata', productType?: ProductType | null, displayName?: string | null, pricingPageAnchor?: string | null } | null, usage: Array<{ __typename?: 'Usage', unit: string, unitPlural: string, displayName: string, currentUsage?: number | null, maximumUsage?: number | null, description?: string | null }> }> | null, externalLinks?: { __typename?: 'ExternalBillingProviderLinks', invoiceHistory: { __typename?: 'UrlOrContactUs', url?: string | null, contactUs?: ContactUs | null }, managePaymentMethod: { __typename?: 'UrlOrContactUs', url?: string | null, contactUs?: ContactUs | null }, downgrade: { __typename?: 'UrlOrContactUs', url?: string | null, contactUs?: ContactUs | null }, help: { __typename?: 'UrlOrContactUs', url?: string | null, contactUs?: ContactUs | null } } | null, subscriptionUsageAllowed: { __typename?: 'SubscriptionUsageAllowed', seats: boolean, clusters: boolean, cloudAccounts: boolean, projects: boolean, customBlueprints: boolean } } | null } } };

export type DeleteTeamMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DeleteTeamMutation = { __typename?: 'Mutation', deleteTeam: boolean };

export type TransferProjectMutationVariables = Exact<{
  input: TransferProjectInput;
}>;


export type TransferProjectMutation = { __typename?: 'Mutation', transferProject: { __typename?: 'Repo', id: string, name: string } };

export type TeamInviteFragment = { __typename?: 'TeamMemberInvitation', id: string, role: TeamMemberRole, link: string, email?: string | null, expiresAt?: Date | null, createdAt: Date };

export type InviteTeamMemberMutationVariables = Exact<{
  input: InviteTeamMemberInput;
}>;


export type InviteTeamMemberMutation = { __typename?: 'Mutation', inviteTeamMember: { __typename?: 'TeamMemberInvitation', id: string, role: TeamMemberRole, link: string, email?: string | null, expiresAt?: Date | null, createdAt: Date } };

export type DeleteTeamMemberInvitationMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DeleteTeamMemberInvitationMutation = { __typename?: 'Mutation', deleteTeamMemberInvitation: boolean };

export type ResendTeamMemberInvitationMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type ResendTeamMemberInvitationMutation = { __typename?: 'Mutation', resendTeamMemberInvitation: boolean };

export type AcceptTeamMemberInvitationMutationVariables = Exact<{
  token: Scalars['String'];
}>;


export type AcceptTeamMemberInvitationMutation = { __typename?: 'Mutation', acceptTeamMemberInvitation: { __typename?: 'Team', id: string, plan: { __typename?: 'Plan', tier: PlanTier, billingPeriod?: PlanBillingPeriod | null }, user: { __typename?: 'User', id: string, email?: string | null, createdAt?: Date | null, freeTrialEndsAt?: Date | null, hasPaymentMethod?: boolean | null, paymentError?: string | null, paymentAuthorizationError?: string | null, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null, billingOverview?: { __typename?: 'BillingOverview', hasUpgradedProducts: boolean, isBillingSetup: boolean, currentProducts?: Array<{ __typename?: 'ApiAccess', name?: string | null, description?: string | null, sku: string, displayPrice?: string | null, benefits: Array<string>, productTypeMetadata?: { __typename?: 'ProductTypeMetadata', productType?: ProductType | null, displayName?: string | null, pricingPageAnchor?: string | null } | null, usage: Array<{ __typename?: 'Usage', unit: string, unitPlural: string, displayName: string, currentUsage?: number | null, maximumUsage?: number | null, description?: string | null }> } | { __typename?: 'PlanTierV2', name?: string | null, description?: string | null, sku: string, displayPrice?: string | null, benefits: Array<string>, productTypeMetadata?: { __typename?: 'ProductTypeMetadata', productType?: ProductType | null, displayName?: string | null, pricingPageAnchor?: string | null } | null, usage: Array<{ __typename?: 'Usage', unit: string, unitPlural: string, displayName: string, currentUsage?: number | null, maximumUsage?: number | null, description?: string | null }> } | { __typename?: 'ProjectPack', name?: string | null, description?: string | null, sku: string, displayPrice?: string | null, benefits: Array<string>, productTypeMetadata?: { __typename?: 'ProductTypeMetadata', productType?: ProductType | null, displayName?: string | null, pricingPageAnchor?: string | null } | null, usage: Array<{ __typename?: 'Usage', unit: string, unitPlural: string, displayName: string, currentUsage?: number | null, maximumUsage?: number | null, description?: string | null }> } | { __typename?: 'SupportTier', name?: string | null, description?: string | null, sku: string, displayPrice?: string | null, benefits: Array<string>, productTypeMetadata?: { __typename?: 'ProductTypeMetadata', productType?: ProductType | null, displayName?: string | null, pricingPageAnchor?: string | null } | null, usage: Array<{ __typename?: 'Usage', unit: string, unitPlural: string, displayName: string, currentUsage?: number | null, maximumUsage?: number | null, description?: string | null }> }> | null, externalLinks?: { __typename?: 'ExternalBillingProviderLinks', invoiceHistory: { __typename?: 'UrlOrContactUs', url?: string | null, contactUs?: ContactUs | null }, managePaymentMethod: { __typename?: 'UrlOrContactUs', url?: string | null, contactUs?: ContactUs | null }, downgrade: { __typename?: 'UrlOrContactUs', url?: string | null, contactUs?: ContactUs | null }, help: { __typename?: 'UrlOrContactUs', url?: string | null, contactUs?: ContactUs | null } } | null, subscriptionUsageAllowed: { __typename?: 'SubscriptionUsageAllowed', seats: boolean, clusters: boolean, cloudAccounts: boolean, projects: boolean, customBlueprints: boolean } } | null } } };

export type UpdateTeamMemberRoleMutationVariables = Exact<{
  input: UpdateTeamMemberRoleInput;
}>;


export type UpdateTeamMemberRoleMutation = { __typename?: 'Mutation', updateTeamMemberRole: { __typename?: 'UserTeamEdge', role: TeamMemberRole, id: string } };

export type ConnectUserToIamMutationVariables = Exact<{
  input: ConnectUserToIamInput;
}>;


export type ConnectUserToIamMutation = { __typename?: 'Mutation', connectUserToIam: boolean };

export type DisconnectUserFromIamMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DisconnectUserFromIamMutation = { __typename?: 'Mutation', disconnectUserFromIam: boolean };

export type AttachAwsPolicyToUserMutationVariables = Exact<{
  input: AttachAwsPolicyToUser;
}>;


export type AttachAwsPolicyToUserMutation = { __typename?: 'Mutation', attachAwsPolicyToUser: boolean };

export type CreateProjectsFromTemplateMutationVariables = Exact<{
  input: CreateProjectsFromTemplateInput;
}>;


export type CreateProjectsFromTemplateMutation = { __typename?: 'Mutation', createProjectsFromTemplate: Array<{ __typename?: 'Repo', id: string, path: string, enabled: boolean, productionBranch?: string | null, deployTarget?: DeployTarget | null, deployType?: DeployType | null, deployService?: boolean | null, deployJob?: boolean | null, image?: string | null, cpu?: string | null, memory?: string | null, updatedAt: Date, disableReason?: DisableReason | null, databaseProvider?: DatabaseProviderType | null, databaseEngine?: DatabaseEngineType | null, name: string, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, projectID?: string | null } | null, gpu?: { __typename?: 'GPUSpec', type?: string | null, count: number } | null, tpu?: { __typename?: 'TPUSpec', tfVersion: string, type: string, cores: number } | null, cluster?: { __typename?: 'Cluster', id: string, name: string, domain?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null } | null, autoscaling?: { __typename?: 'Autoscaling', minReplicas: number, maxReplicas: number } | null, owner: { __typename?: 'User', id: string, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, owner: { __typename?: 'User', id: string, login: any } } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null }> };

export type CreateEphemeralContainerMutationVariables = Exact<{
  deploymentId: Scalars['UUID'];
  input: CreateEphemeralContainerInput;
}>;


export type CreateEphemeralContainerMutation = { __typename?: 'Mutation', createEphemeralContainer: { __typename?: 'EphemeralContainer', name: string, image: string } };

export type UpdateProjectSettingsMutationVariables = Exact<{
  input: UpdateProjectInput;
}>;


export type UpdateProjectSettingsMutation = { __typename?: 'Mutation', updateProject: { __typename?: 'Repo', id: string, appID?: string | null, defaultIngressDomain?: string | null, kappID?: string | null, useHumanReadableKubernetesName?: boolean | null, namespace?: string | null, deployTarget?: DeployTarget | null, manualDeploy?: boolean | null, deployStrategy?: DeployStrategy | null, free?: boolean | null, cpu?: string | null, memory?: string | null, ephemeralStorage?: number | null, dedicated?: boolean | null, productionBranch?: string | null, serverlessRegion?: string | null, helmValues?: string | null, terraformVersion?: string | null, terraformVariables?: any | null, deployService?: boolean | null, deployJob?: boolean | null, preStopSleep?: number | null, terminationGracePeriodSeconds?: number | null, databaseProvider?: DatabaseProviderType | null, databaseEngine?: DatabaseEngineType | null, databaseVersion?: string | null, autoRetry?: boolean | null, autoRollback?: boolean | null, canDeploy?: boolean | null, awsIamRole?: string | null, gcpServiceAccount?: string | null, datadogApmEnabled?: boolean | null, deployTimeoutSeconds?: number | null, path: string, enabled: boolean, deployType?: DeployType | null, image?: string | null, updatedAt: Date, disableReason?: DisableReason | null, hostNetwork?: boolean | null, staticIP?: boolean | null, noBuildCache?: boolean | null, gitSubmodules?: GitSubmodulesType | null, alternativeImageTagTemplates?: Array<string> | null, name: string, secretMounts?: Array<{ __typename?: 'KubernetesSecretMount', secretName: string, mountPath: string, readOnly: boolean }> | null, kubernetesCustomization?: { __typename?: 'KubernetesCustomization', serviceAccountName?: string | null, podAnnotations?: any | null, serviceAnnotations?: any | null, ingressAnnotations?: any | null } | null, manifest?: { __typename?: 'Manifest', manifests?: Array<string> | null, manifestValue?: string | null, kustomizeDirs?: Array<string> | null } | null, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, environments: Array<{ __typename?: 'ProjectEnvironment', id: string, name: string }>, envs?: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string, visible: boolean, sealed: boolean, source?: { __typename?: 'EnvVarSource', type: EnvVarSourceType } | null }> | null, owner: { __typename?: 'User', id: string, login: any } } | null, productionDeployment?: { __typename?: 'Deployment', id: string, description?: string | null, version: string, status: DeploymentStatus, branch?: string | null, endpoints?: Array<string> | null, privateEndpoint?: string | null, errorMessage?: string | null, updatedAt: Date, createdAt: Date, awsLinks?: { __typename?: 'AWSLinks', rds?: string | null, cloudformation?: string | null, lambda?: string | null, apiGateway?: string | null, cloudwatchLogs?: string | null, cloudwatchMetrics?: string | null } | null, gcpLinks?: { __typename?: 'GCPLinks', deploymentManager?: string | null, cloudRun?: string | null, cloudFunctions?: string | null, cloudFunctionsTrigger?: string | null, cloudLogging?: string | null, cloudMonitoring?: string | null } | null, loadBalancers?: Array<{ __typename?: 'LoadBalancer', dns: Array<string>, ips: Array<string>, ports?: Array<number> | null }> | null, deployStatus?: { __typename?: 'DeployStatus', active: boolean, replicas: number, publicIPs?: Array<string> | null, state: string, errorMessage?: string | null, troubleshooting?: { __typename?: 'Troubleshooting', issue?: { __typename?: 'TroubleshootingIssue', blocks?: Array<{ __typename?: 'TroubleshootingIssueBlock', blockType?: TroubleshootingIssueBlockType | null, content?: string | null }> | null } | null } | null } | null, build?: { __typename?: 'Build', id: string, image?: string | null } | null, alternativeImages?: Array<{ __typename?: 'AlternativeImage', reference?: string | null, tag?: string | null, name?: string | null }> | null } | null, envs?: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string, visible: boolean, sealed: boolean, source?: { __typename?: 'EnvVarSource', type: EnvVarSourceType } | null }> | null, collaborators?: Array<{ __typename?: 'ProjectCollaborator', id: string, role: ProjectCollaboratorRole, user: { __typename?: 'User', id: string, name: string, login: any, avatar?: string | null, isTeam?: boolean | null } }> | null, volumes?: Array<{ __typename?: 'VolumeSpec', mountPath: string, size: number }> | null, replication?: Array<{ __typename?: 'Replication', region: string, replicas?: number | null, cluster?: { __typename?: 'Cluster', id: string, name: string, region?: string | null } | null }> | null, cluster?: { __typename?: 'Cluster', id: string, name: string, region?: string | null, ingressIP?: string | null, connected?: boolean | null, staticIPs?: Array<string> | null, cloudProvider?: CloudProvider | null, clusterProvider?: ClusterProvider | null, state: ClusterState, domain?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, projectID?: string | null } | null, logShipper?: { __typename?: 'LogShipper', type: LogShipperType, logz?: { __typename?: 'LogzIntegration', token: string, url?: string | null } | null, syslog?: { __typename?: 'SyslogIntegration', host: string, port: string, mode: string } | null, logDNA?: { __typename?: 'LogDNAIntegration', key: string } | null, datadog?: { __typename?: 'DatadogLogIntegration', key: string, host?: string | null } | null, betterstack?: { __typename?: 'BetterStackIntegration', token: string } | null } | null, readinessProbe?: { __typename?: 'Probe', command?: string | null, initialDelaySeconds: number, periodSeconds: number, successThreshold: number, failureThreshold: number, timeoutSeconds: number, http?: { __typename?: 'HTTPProbe', host?: string | null, port: string, path?: string | null } | null, tcp?: { __typename?: 'TCPProbe', host?: string | null, port: string } | null } | null, livenessProbe?: { __typename?: 'Probe', command?: string | null, initialDelaySeconds: number, periodSeconds: number, successThreshold: number, failureThreshold: number, timeoutSeconds: number, http?: { __typename?: 'HTTPProbe', host?: string | null, port: string, path?: string | null } | null, tcp?: { __typename?: 'TCPProbe', host?: string | null, port: string } | null } | null, startupProbe?: { __typename?: 'Probe', command?: string | null, initialDelaySeconds: number, periodSeconds: number, successThreshold: number, failureThreshold: number, timeoutSeconds: number, http?: { __typename?: 'HTTPProbe', host?: string | null, port: string, path?: string | null } | null, tcp?: { __typename?: 'TCPProbe', host?: string | null, port: string } | null } | null, gpu?: { __typename?: 'GPUSpec', type?: string | null, count: number } | null, tpu?: { __typename?: 'TPUSpec', type: string, cores: number, tfVersion: string } | null, githubIntegration?: { __typename?: 'GitHubRepoIntegration', id: string, autoDeployBranch: boolean, autoStopBranch: boolean, branchIgnore: string, branchStopIgnore: string, githubRepository?: { __typename?: 'GitHubRepository', id: string, owner: string, name: string } | null } | null, gitlabIntegration?: { __typename?: 'GitlabRepoIntegration', id: string, autoDeployBranch: boolean, autoStopBranch: boolean, branchIgnore: string, branchStopIgnore: string } | null, branchResources?: { __typename?: 'ContainerResourcesSpec', cpu?: number | null, memory?: number | null, ephemeralStorage?: number | null, spot?: boolean | null, accelerator?: { __typename?: 'AcceleratorSpec', type?: string | null, count?: number | null } | null } | null, serverlessResources?: { __typename?: 'ServerlessResourceSpec', cpu?: number | null, memory?: number | null } | null, prometheusScrape?: { __typename?: 'PrometheusScrape', path: string, port: number } | null, jobRuns?: { __typename?: 'JobRunConnection', totalCount: number } | null, autoscaling?: { __typename?: 'Autoscaling', kedaScaledObjectSpec?: string | null, minReplicas: number, maxReplicas: number, coolDownPeriod?: number | null, triggers?: Array<{ __typename?: 'AutoscalingTrigger', type: AutoscalingType, spec: any }> | null } | null, containerRegistry?: { __typename?: 'ContainerRegistry', id: string } | null, databaseEnvs: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string }>, databaseLinks: Array<{ __typename?: 'DatabaseLink', id: string, envPrefix?: string | null, envs?: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string }> | null, database: { __typename?: 'Repo', id: string, path: string, enabled: boolean, productionBranch?: string | null, deployTarget?: DeployTarget | null, deployType?: DeployType | null, deployService?: boolean | null, deployJob?: boolean | null, image?: string | null, cpu?: string | null, memory?: string | null, updatedAt: Date, disableReason?: DisableReason | null, databaseProvider?: DatabaseProviderType | null, databaseEngine?: DatabaseEngineType | null, name: string, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, projectID?: string | null } | null, gpu?: { __typename?: 'GPUSpec', type?: string | null, count: number } | null, tpu?: { __typename?: 'TPUSpec', tfVersion: string, type: string, cores: number } | null, cluster?: { __typename?: 'Cluster', id: string, name: string, domain?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null } | null, autoscaling?: { __typename?: 'Autoscaling', minReplicas: number, maxReplicas: number } | null, owner: { __typename?: 'User', id: string, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, owner: { __typename?: 'User', id: string, login: any } } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null } }>, linkedProjects: Array<{ __typename?: 'DatabaseLink', id: string, envPrefix?: string | null, repo: { __typename?: 'Repo', id: string, path: string, enabled: boolean, productionBranch?: string | null, deployTarget?: DeployTarget | null, deployType?: DeployType | null, deployService?: boolean | null, deployJob?: boolean | null, image?: string | null, cpu?: string | null, memory?: string | null, updatedAt: Date, disableReason?: DisableReason | null, databaseProvider?: DatabaseProviderType | null, databaseEngine?: DatabaseEngineType | null, name: string, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, projectID?: string | null } | null, gpu?: { __typename?: 'GPUSpec', type?: string | null, count: number } | null, tpu?: { __typename?: 'TPUSpec', tfVersion: string, type: string, cores: number } | null, cluster?: { __typename?: 'Cluster', id: string, name: string, domain?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null } | null, autoscaling?: { __typename?: 'Autoscaling', minReplicas: number, maxReplicas: number } | null, owner: { __typename?: 'User', id: string, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, owner: { __typename?: 'User', id: string, login: any } } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null } }>, pipelineCluster?: { __typename?: 'Cluster', id: string } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string, envs?: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string, visible: boolean, sealed: boolean, source?: { __typename?: 'EnvVarSource', type: EnvVarSourceType } | null }> | null } | null, pipelineLinks?: Array<{ __typename?: 'RepoPipelineLink', id: string, sourceEvent: RepoEvent, targetAction: RepoAction, source: { __typename?: 'Repo', id: string }, targetGroup: { __typename?: 'RepoGroup', id: string, selector?: { __typename?: 'LabelSelectors', matchLabels?: any | null } | null } }> | null, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null } | null, owner: { __typename?: 'User', id: string, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, clusterDomains?: Array<{ __typename?: 'ClusterDomains', id: string, cluster: { __typename?: 'Cluster', id: string, name: string }, domains?: Array<{ __typename?: 'CustomDomain', id: string, domain: string, isApex: boolean, cnameTargets?: Array<string> | null, ipTargets?: Array<string> | null, disableCertManager?: boolean | null, certManagerChallengeType?: CertManagerChallengeType | null, syncDomain?: { __typename?: 'CustomDomain', id: string } | null, instructions?: Array<{ __typename?: 'DNSRecord', domain: string, type: DnsRecordType, value?: string | null }> | null, certificate?: { __typename?: 'Certificate', dnsNames?: Array<string> | null, ready: boolean, issuing: boolean, challenges?: Array<{ __typename?: 'CertificateChallenge', dnsName: string, solver: string, statusReason: string, statusState: string, type: string, wildcard: boolean }> | null, instructions?: Array<{ __typename?: 'DNSRecord', domain: string, type: DnsRecordType, value?: string | null }> | null } | null }> | null }> | null, cdns?: Array<{ __typename?: 'CDN', id: string, endpoint?: string | null, state: string, domains?: Array<{ __typename?: 'CDNDomain', domain: string, certReady?: boolean | null, routeReady?: boolean | null, instruction?: { __typename?: 'DNSRecord', domain: string, type: DnsRecordType, value?: string | null } | null }> | null, certificate?: { __typename?: 'Certificate', dnsNames?: Array<string> | null, ready: boolean, issuing: boolean, instructions?: Array<{ __typename?: 'DNSRecord', name?: string | null, domain: string, type: DnsRecordType, value?: string | null }> | null } | null }> | null, ports?: Array<{ __typename?: 'Port', port: string, externalPort: string, protocol: string, public: boolean, https: boolean, grpc: boolean, loadBalancer: boolean }> | null, buildMethod?: { __typename?: 'BuildMethod', name: string, type: BuildType, workingDirectory?: string | null, dockerfilePath?: string | null, buildCommand?: string | null, staticPath?: string | null, runCommand?: string | null, releaseCommand?: string | null, nodejsVersion?: string | null, pythonVersion?: string | null, golangVersion?: string | null } | null, buildResources?: { __typename?: 'ContainerResourcesSpec', cpu?: number | null, memory?: number | null, ephemeralStorage?: number | null, spot?: boolean | null } | null, buildSpec?: { __typename?: 'ContainerSpec', cpu?: number | null, memory?: number | null } | null, kanikoFlags?: { __typename?: 'KanikoFlags', compressedCaching?: boolean | null } | null } };

export type UpdateProjectDangerSettingsMutationVariables = Exact<{
  input: UpdateProjectDangerInput;
}>;


export type UpdateProjectDangerSettingsMutation = { __typename?: 'Mutation', updateProjectDanger: { __typename?: 'Repo', id: string, appID?: string | null, defaultIngressDomain?: string | null, kappID?: string | null, useHumanReadableKubernetesName?: boolean | null, namespace?: string | null, deployTarget?: DeployTarget | null, manualDeploy?: boolean | null, deployStrategy?: DeployStrategy | null, free?: boolean | null, cpu?: string | null, memory?: string | null, ephemeralStorage?: number | null, dedicated?: boolean | null, productionBranch?: string | null, serverlessRegion?: string | null, helmValues?: string | null, terraformVersion?: string | null, terraformVariables?: any | null, deployService?: boolean | null, deployJob?: boolean | null, preStopSleep?: number | null, terminationGracePeriodSeconds?: number | null, databaseProvider?: DatabaseProviderType | null, databaseEngine?: DatabaseEngineType | null, databaseVersion?: string | null, autoRetry?: boolean | null, autoRollback?: boolean | null, canDeploy?: boolean | null, awsIamRole?: string | null, gcpServiceAccount?: string | null, datadogApmEnabled?: boolean | null, deployTimeoutSeconds?: number | null, path: string, enabled: boolean, deployType?: DeployType | null, image?: string | null, updatedAt: Date, disableReason?: DisableReason | null, hostNetwork?: boolean | null, staticIP?: boolean | null, noBuildCache?: boolean | null, gitSubmodules?: GitSubmodulesType | null, alternativeImageTagTemplates?: Array<string> | null, name: string, secretMounts?: Array<{ __typename?: 'KubernetesSecretMount', secretName: string, mountPath: string, readOnly: boolean }> | null, kubernetesCustomization?: { __typename?: 'KubernetesCustomization', serviceAccountName?: string | null, podAnnotations?: any | null, serviceAnnotations?: any | null, ingressAnnotations?: any | null } | null, manifest?: { __typename?: 'Manifest', manifests?: Array<string> | null, manifestValue?: string | null, kustomizeDirs?: Array<string> | null } | null, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, environments: Array<{ __typename?: 'ProjectEnvironment', id: string, name: string }>, envs?: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string, visible: boolean, sealed: boolean, source?: { __typename?: 'EnvVarSource', type: EnvVarSourceType } | null }> | null, owner: { __typename?: 'User', id: string, login: any } } | null, productionDeployment?: { __typename?: 'Deployment', id: string, description?: string | null, version: string, status: DeploymentStatus, branch?: string | null, endpoints?: Array<string> | null, privateEndpoint?: string | null, errorMessage?: string | null, updatedAt: Date, createdAt: Date, awsLinks?: { __typename?: 'AWSLinks', rds?: string | null, cloudformation?: string | null, lambda?: string | null, apiGateway?: string | null, cloudwatchLogs?: string | null, cloudwatchMetrics?: string | null } | null, gcpLinks?: { __typename?: 'GCPLinks', deploymentManager?: string | null, cloudRun?: string | null, cloudFunctions?: string | null, cloudFunctionsTrigger?: string | null, cloudLogging?: string | null, cloudMonitoring?: string | null } | null, loadBalancers?: Array<{ __typename?: 'LoadBalancer', dns: Array<string>, ips: Array<string>, ports?: Array<number> | null }> | null, deployStatus?: { __typename?: 'DeployStatus', active: boolean, replicas: number, publicIPs?: Array<string> | null, state: string, errorMessage?: string | null, troubleshooting?: { __typename?: 'Troubleshooting', issue?: { __typename?: 'TroubleshootingIssue', blocks?: Array<{ __typename?: 'TroubleshootingIssueBlock', blockType?: TroubleshootingIssueBlockType | null, content?: string | null }> | null } | null } | null } | null, build?: { __typename?: 'Build', id: string, image?: string | null } | null, alternativeImages?: Array<{ __typename?: 'AlternativeImage', reference?: string | null, tag?: string | null, name?: string | null }> | null } | null, envs?: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string, visible: boolean, sealed: boolean, source?: { __typename?: 'EnvVarSource', type: EnvVarSourceType } | null }> | null, collaborators?: Array<{ __typename?: 'ProjectCollaborator', id: string, role: ProjectCollaboratorRole, user: { __typename?: 'User', id: string, name: string, login: any, avatar?: string | null, isTeam?: boolean | null } }> | null, volumes?: Array<{ __typename?: 'VolumeSpec', mountPath: string, size: number }> | null, replication?: Array<{ __typename?: 'Replication', region: string, replicas?: number | null, cluster?: { __typename?: 'Cluster', id: string, name: string, region?: string | null } | null }> | null, cluster?: { __typename?: 'Cluster', id: string, name: string, region?: string | null, ingressIP?: string | null, connected?: boolean | null, staticIPs?: Array<string> | null, cloudProvider?: CloudProvider | null, clusterProvider?: ClusterProvider | null, state: ClusterState, domain?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, projectID?: string | null } | null, logShipper?: { __typename?: 'LogShipper', type: LogShipperType, logz?: { __typename?: 'LogzIntegration', token: string, url?: string | null } | null, syslog?: { __typename?: 'SyslogIntegration', host: string, port: string, mode: string } | null, logDNA?: { __typename?: 'LogDNAIntegration', key: string } | null, datadog?: { __typename?: 'DatadogLogIntegration', key: string, host?: string | null } | null, betterstack?: { __typename?: 'BetterStackIntegration', token: string } | null } | null, readinessProbe?: { __typename?: 'Probe', command?: string | null, initialDelaySeconds: number, periodSeconds: number, successThreshold: number, failureThreshold: number, timeoutSeconds: number, http?: { __typename?: 'HTTPProbe', host?: string | null, port: string, path?: string | null } | null, tcp?: { __typename?: 'TCPProbe', host?: string | null, port: string } | null } | null, livenessProbe?: { __typename?: 'Probe', command?: string | null, initialDelaySeconds: number, periodSeconds: number, successThreshold: number, failureThreshold: number, timeoutSeconds: number, http?: { __typename?: 'HTTPProbe', host?: string | null, port: string, path?: string | null } | null, tcp?: { __typename?: 'TCPProbe', host?: string | null, port: string } | null } | null, startupProbe?: { __typename?: 'Probe', command?: string | null, initialDelaySeconds: number, periodSeconds: number, successThreshold: number, failureThreshold: number, timeoutSeconds: number, http?: { __typename?: 'HTTPProbe', host?: string | null, port: string, path?: string | null } | null, tcp?: { __typename?: 'TCPProbe', host?: string | null, port: string } | null } | null, gpu?: { __typename?: 'GPUSpec', type?: string | null, count: number } | null, tpu?: { __typename?: 'TPUSpec', type: string, cores: number, tfVersion: string } | null, githubIntegration?: { __typename?: 'GitHubRepoIntegration', id: string, autoDeployBranch: boolean, autoStopBranch: boolean, branchIgnore: string, branchStopIgnore: string, githubRepository?: { __typename?: 'GitHubRepository', id: string, owner: string, name: string } | null } | null, gitlabIntegration?: { __typename?: 'GitlabRepoIntegration', id: string, autoDeployBranch: boolean, autoStopBranch: boolean, branchIgnore: string, branchStopIgnore: string } | null, branchResources?: { __typename?: 'ContainerResourcesSpec', cpu?: number | null, memory?: number | null, ephemeralStorage?: number | null, spot?: boolean | null, accelerator?: { __typename?: 'AcceleratorSpec', type?: string | null, count?: number | null } | null } | null, serverlessResources?: { __typename?: 'ServerlessResourceSpec', cpu?: number | null, memory?: number | null } | null, prometheusScrape?: { __typename?: 'PrometheusScrape', path: string, port: number } | null, jobRuns?: { __typename?: 'JobRunConnection', totalCount: number } | null, autoscaling?: { __typename?: 'Autoscaling', kedaScaledObjectSpec?: string | null, minReplicas: number, maxReplicas: number, coolDownPeriod?: number | null, triggers?: Array<{ __typename?: 'AutoscalingTrigger', type: AutoscalingType, spec: any }> | null } | null, containerRegistry?: { __typename?: 'ContainerRegistry', id: string } | null, databaseEnvs: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string }>, databaseLinks: Array<{ __typename?: 'DatabaseLink', id: string, envPrefix?: string | null, envs?: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string }> | null, database: { __typename?: 'Repo', id: string, path: string, enabled: boolean, productionBranch?: string | null, deployTarget?: DeployTarget | null, deployType?: DeployType | null, deployService?: boolean | null, deployJob?: boolean | null, image?: string | null, cpu?: string | null, memory?: string | null, updatedAt: Date, disableReason?: DisableReason | null, databaseProvider?: DatabaseProviderType | null, databaseEngine?: DatabaseEngineType | null, name: string, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, projectID?: string | null } | null, gpu?: { __typename?: 'GPUSpec', type?: string | null, count: number } | null, tpu?: { __typename?: 'TPUSpec', tfVersion: string, type: string, cores: number } | null, cluster?: { __typename?: 'Cluster', id: string, name: string, domain?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null } | null, autoscaling?: { __typename?: 'Autoscaling', minReplicas: number, maxReplicas: number } | null, owner: { __typename?: 'User', id: string, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, owner: { __typename?: 'User', id: string, login: any } } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null } }>, linkedProjects: Array<{ __typename?: 'DatabaseLink', id: string, envPrefix?: string | null, repo: { __typename?: 'Repo', id: string, path: string, enabled: boolean, productionBranch?: string | null, deployTarget?: DeployTarget | null, deployType?: DeployType | null, deployService?: boolean | null, deployJob?: boolean | null, image?: string | null, cpu?: string | null, memory?: string | null, updatedAt: Date, disableReason?: DisableReason | null, databaseProvider?: DatabaseProviderType | null, databaseEngine?: DatabaseEngineType | null, name: string, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, projectID?: string | null } | null, gpu?: { __typename?: 'GPUSpec', type?: string | null, count: number } | null, tpu?: { __typename?: 'TPUSpec', tfVersion: string, type: string, cores: number } | null, cluster?: { __typename?: 'Cluster', id: string, name: string, domain?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null } | null, autoscaling?: { __typename?: 'Autoscaling', minReplicas: number, maxReplicas: number } | null, owner: { __typename?: 'User', id: string, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, owner: { __typename?: 'User', id: string, login: any } } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null } }>, pipelineCluster?: { __typename?: 'Cluster', id: string } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string, envs?: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string, visible: boolean, sealed: boolean, source?: { __typename?: 'EnvVarSource', type: EnvVarSourceType } | null }> | null } | null, pipelineLinks?: Array<{ __typename?: 'RepoPipelineLink', id: string, sourceEvent: RepoEvent, targetAction: RepoAction, source: { __typename?: 'Repo', id: string }, targetGroup: { __typename?: 'RepoGroup', id: string, selector?: { __typename?: 'LabelSelectors', matchLabels?: any | null } | null } }> | null, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null } | null, owner: { __typename?: 'User', id: string, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, clusterDomains?: Array<{ __typename?: 'ClusterDomains', id: string, cluster: { __typename?: 'Cluster', id: string, name: string }, domains?: Array<{ __typename?: 'CustomDomain', id: string, domain: string, isApex: boolean, cnameTargets?: Array<string> | null, ipTargets?: Array<string> | null, disableCertManager?: boolean | null, certManagerChallengeType?: CertManagerChallengeType | null, syncDomain?: { __typename?: 'CustomDomain', id: string } | null, instructions?: Array<{ __typename?: 'DNSRecord', domain: string, type: DnsRecordType, value?: string | null }> | null, certificate?: { __typename?: 'Certificate', dnsNames?: Array<string> | null, ready: boolean, issuing: boolean, challenges?: Array<{ __typename?: 'CertificateChallenge', dnsName: string, solver: string, statusReason: string, statusState: string, type: string, wildcard: boolean }> | null, instructions?: Array<{ __typename?: 'DNSRecord', domain: string, type: DnsRecordType, value?: string | null }> | null } | null }> | null }> | null, cdns?: Array<{ __typename?: 'CDN', id: string, endpoint?: string | null, state: string, domains?: Array<{ __typename?: 'CDNDomain', domain: string, certReady?: boolean | null, routeReady?: boolean | null, instruction?: { __typename?: 'DNSRecord', domain: string, type: DnsRecordType, value?: string | null } | null }> | null, certificate?: { __typename?: 'Certificate', dnsNames?: Array<string> | null, ready: boolean, issuing: boolean, instructions?: Array<{ __typename?: 'DNSRecord', name?: string | null, domain: string, type: DnsRecordType, value?: string | null }> | null } | null }> | null, ports?: Array<{ __typename?: 'Port', port: string, externalPort: string, protocol: string, public: boolean, https: boolean, grpc: boolean, loadBalancer: boolean }> | null, buildMethod?: { __typename?: 'BuildMethod', name: string, type: BuildType, workingDirectory?: string | null, dockerfilePath?: string | null, buildCommand?: string | null, staticPath?: string | null, runCommand?: string | null, releaseCommand?: string | null, nodejsVersion?: string | null, pythonVersion?: string | null, golangVersion?: string | null } | null, buildResources?: { __typename?: 'ContainerResourcesSpec', cpu?: number | null, memory?: number | null, ephemeralStorage?: number | null, spot?: boolean | null } | null, buildSpec?: { __typename?: 'ContainerSpec', cpu?: number | null, memory?: number | null } | null, kanikoFlags?: { __typename?: 'KanikoFlags', compressedCaching?: boolean | null } | null } };

export type UpdateResourceAlphaMutationVariables = Exact<{
  id: Scalars['UUID'];
  input: UpdateResourceAlphaInput;
}>;


export type UpdateResourceAlphaMutation = { __typename?: 'Mutation', updateResourceAlpha: { __typename?: 'Repo', id: string } };

export type UpdateUserMutationVariables = Exact<{
  input: UpdateUserInput;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'User', id: string, hasZeetCloud?: boolean | null, hasOnboarded?: boolean | null, canDeploy?: boolean | null, email?: string | null, createdAt?: Date | null, freeTrialEndsAt?: Date | null, hasPaymentMethod?: boolean | null, paymentError?: string | null, paymentAuthorizationError?: string | null, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null } };

export type DeleteUserMutationVariables = Exact<{ [key: string]: never; }>;


export type DeleteUserMutation = { __typename?: 'Mutation', deleteUser: boolean };

export type UserApiKeysQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UserApiKeysQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, apiKeys?: Array<{ __typename?: 'APIKey', id: string, token: string, name: string, description: string, createdAt: Date }> | null } };

export type BillingOverviewDetailFragment = { __typename?: 'BillingOverview', hasUpgradedProducts: boolean, isBillingSetup: boolean, currentProducts?: Array<{ __typename?: 'ApiAccess', name?: string | null, description?: string | null, sku: string, displayPrice?: string | null, benefits: Array<string>, productTypeMetadata?: { __typename?: 'ProductTypeMetadata', productType?: ProductType | null, displayName?: string | null, pricingPageAnchor?: string | null } | null, usage: Array<{ __typename?: 'Usage', unit: string, unitPlural: string, displayName: string, currentUsage?: number | null, maximumUsage?: number | null, description?: string | null }> } | { __typename?: 'PlanTierV2', name?: string | null, description?: string | null, sku: string, displayPrice?: string | null, benefits: Array<string>, productTypeMetadata?: { __typename?: 'ProductTypeMetadata', productType?: ProductType | null, displayName?: string | null, pricingPageAnchor?: string | null } | null, usage: Array<{ __typename?: 'Usage', unit: string, unitPlural: string, displayName: string, currentUsage?: number | null, maximumUsage?: number | null, description?: string | null }> } | { __typename?: 'ProjectPack', name?: string | null, description?: string | null, sku: string, displayPrice?: string | null, benefits: Array<string>, productTypeMetadata?: { __typename?: 'ProductTypeMetadata', productType?: ProductType | null, displayName?: string | null, pricingPageAnchor?: string | null } | null, usage: Array<{ __typename?: 'Usage', unit: string, unitPlural: string, displayName: string, currentUsage?: number | null, maximumUsage?: number | null, description?: string | null }> } | { __typename?: 'SupportTier', name?: string | null, description?: string | null, sku: string, displayPrice?: string | null, benefits: Array<string>, productTypeMetadata?: { __typename?: 'ProductTypeMetadata', productType?: ProductType | null, displayName?: string | null, pricingPageAnchor?: string | null } | null, usage: Array<{ __typename?: 'Usage', unit: string, unitPlural: string, displayName: string, currentUsage?: number | null, maximumUsage?: number | null, description?: string | null }> }> | null, externalLinks?: { __typename?: 'ExternalBillingProviderLinks', invoiceHistory: { __typename?: 'UrlOrContactUs', url?: string | null, contactUs?: ContactUs | null }, managePaymentMethod: { __typename?: 'UrlOrContactUs', url?: string | null, contactUs?: ContactUs | null }, downgrade: { __typename?: 'UrlOrContactUs', url?: string | null, contactUs?: ContactUs | null }, help: { __typename?: 'UrlOrContactUs', url?: string | null, contactUs?: ContactUs | null } } | null, subscriptionUsageAllowed: { __typename?: 'SubscriptionUsageAllowed', seats: boolean, clusters: boolean, cloudAccounts: boolean, projects: boolean, customBlueprints: boolean } };

type ProductDetail_ApiAccess_Fragment = { __typename?: 'ApiAccess', name?: string | null, description?: string | null, sku: string, displayPrice?: string | null, benefits: Array<string>, productTypeMetadata?: { __typename?: 'ProductTypeMetadata', productType?: ProductType | null, displayName?: string | null, pricingPageAnchor?: string | null } | null, usage: Array<{ __typename?: 'Usage', unit: string, unitPlural: string, displayName: string, currentUsage?: number | null, maximumUsage?: number | null, description?: string | null }> };

type ProductDetail_PlanTierV2_Fragment = { __typename?: 'PlanTierV2', name?: string | null, description?: string | null, sku: string, displayPrice?: string | null, benefits: Array<string>, productTypeMetadata?: { __typename?: 'ProductTypeMetadata', productType?: ProductType | null, displayName?: string | null, pricingPageAnchor?: string | null } | null, usage: Array<{ __typename?: 'Usage', unit: string, unitPlural: string, displayName: string, currentUsage?: number | null, maximumUsage?: number | null, description?: string | null }> };

type ProductDetail_ProjectPack_Fragment = { __typename?: 'ProjectPack', name?: string | null, description?: string | null, sku: string, displayPrice?: string | null, benefits: Array<string>, productTypeMetadata?: { __typename?: 'ProductTypeMetadata', productType?: ProductType | null, displayName?: string | null, pricingPageAnchor?: string | null } | null, usage: Array<{ __typename?: 'Usage', unit: string, unitPlural: string, displayName: string, currentUsage?: number | null, maximumUsage?: number | null, description?: string | null }> };

type ProductDetail_SupportTier_Fragment = { __typename?: 'SupportTier', name?: string | null, description?: string | null, sku: string, displayPrice?: string | null, benefits: Array<string>, productTypeMetadata?: { __typename?: 'ProductTypeMetadata', productType?: ProductType | null, displayName?: string | null, pricingPageAnchor?: string | null } | null, usage: Array<{ __typename?: 'Usage', unit: string, unitPlural: string, displayName: string, currentUsage?: number | null, maximumUsage?: number | null, description?: string | null }> };

export type ProductDetailFragment = ProductDetail_ApiAccess_Fragment | ProductDetail_PlanTierV2_Fragment | ProductDetail_ProjectPack_Fragment | ProductDetail_SupportTier_Fragment;

export type UrlOrContactUsDetailFragment = { __typename?: 'UrlOrContactUs', url?: string | null, contactUs?: ContactUs | null };

export type ProductCatalogSectionDetailFragment = { __typename?: 'ProductCatalogSection', sectionName: string, productTypeMetadata?: { __typename?: 'ProductTypeMetadata', productType?: ProductType | null, displayName?: string | null, pricingPageAnchor?: string | null } | null, allProducts: Array<{ __typename?: 'CatalogProductView', description?: string | null, status?: CatalogProductStatus | null, available: boolean, product: { __typename?: 'ApiAccess', name?: string | null, description?: string | null, sku: string, displayPrice?: string | null, benefits: Array<string>, productTypeMetadata?: { __typename?: 'ProductTypeMetadata', productType?: ProductType | null, displayName?: string | null, pricingPageAnchor?: string | null } | null, usage: Array<{ __typename?: 'Usage', unit: string, unitPlural: string, displayName: string, currentUsage?: number | null, maximumUsage?: number | null, description?: string | null }> } | { __typename?: 'PlanTierV2', name?: string | null, description?: string | null, sku: string, displayPrice?: string | null, benefits: Array<string>, productTypeMetadata?: { __typename?: 'ProductTypeMetadata', productType?: ProductType | null, displayName?: string | null, pricingPageAnchor?: string | null } | null, usage: Array<{ __typename?: 'Usage', unit: string, unitPlural: string, displayName: string, currentUsage?: number | null, maximumUsage?: number | null, description?: string | null }> } | { __typename?: 'ProjectPack', name?: string | null, description?: string | null, sku: string, displayPrice?: string | null, benefits: Array<string>, productTypeMetadata?: { __typename?: 'ProductTypeMetadata', productType?: ProductType | null, displayName?: string | null, pricingPageAnchor?: string | null } | null, usage: Array<{ __typename?: 'Usage', unit: string, unitPlural: string, displayName: string, currentUsage?: number | null, maximumUsage?: number | null, description?: string | null }> } | { __typename?: 'SupportTier', name?: string | null, description?: string | null, sku: string, displayPrice?: string | null, benefits: Array<string>, productTypeMetadata?: { __typename?: 'ProductTypeMetadata', productType?: ProductType | null, displayName?: string | null, pricingPageAnchor?: string | null } | null, usage: Array<{ __typename?: 'Usage', unit: string, unitPlural: string, displayName: string, currentUsage?: number | null, maximumUsage?: number | null, description?: string | null }> } }> };

export type UserProductCatalogQueryVariables = Exact<{
  forUserID: Scalars['UUID'];
}>;


export type UserProductCatalogQuery = { __typename?: 'Query', productCatalog: { __typename?: 'ProductCatalog', products: Array<{ __typename?: 'ProductCatalogSection', sectionName: string, productTypeMetadata?: { __typename?: 'ProductTypeMetadata', productType?: ProductType | null, displayName?: string | null, pricingPageAnchor?: string | null } | null, allProducts: Array<{ __typename?: 'CatalogProductView', description?: string | null, status?: CatalogProductStatus | null, available: boolean, product: { __typename?: 'ApiAccess', name?: string | null, description?: string | null, sku: string, displayPrice?: string | null, benefits: Array<string>, productTypeMetadata?: { __typename?: 'ProductTypeMetadata', productType?: ProductType | null, displayName?: string | null, pricingPageAnchor?: string | null } | null, usage: Array<{ __typename?: 'Usage', unit: string, unitPlural: string, displayName: string, currentUsage?: number | null, maximumUsage?: number | null, description?: string | null }> } | { __typename?: 'PlanTierV2', name?: string | null, description?: string | null, sku: string, displayPrice?: string | null, benefits: Array<string>, productTypeMetadata?: { __typename?: 'ProductTypeMetadata', productType?: ProductType | null, displayName?: string | null, pricingPageAnchor?: string | null } | null, usage: Array<{ __typename?: 'Usage', unit: string, unitPlural: string, displayName: string, currentUsage?: number | null, maximumUsage?: number | null, description?: string | null }> } | { __typename?: 'ProjectPack', name?: string | null, description?: string | null, sku: string, displayPrice?: string | null, benefits: Array<string>, productTypeMetadata?: { __typename?: 'ProductTypeMetadata', productType?: ProductType | null, displayName?: string | null, pricingPageAnchor?: string | null } | null, usage: Array<{ __typename?: 'Usage', unit: string, unitPlural: string, displayName: string, currentUsage?: number | null, maximumUsage?: number | null, description?: string | null }> } | { __typename?: 'SupportTier', name?: string | null, description?: string | null, sku: string, displayPrice?: string | null, benefits: Array<string>, productTypeMetadata?: { __typename?: 'ProductTypeMetadata', productType?: ProductType | null, displayName?: string | null, pricingPageAnchor?: string | null } | null, usage: Array<{ __typename?: 'Usage', unit: string, unitPlural: string, displayName: string, currentUsage?: number | null, maximumUsage?: number | null, description?: string | null }> } }> }> } };

export type UserBillingOverviewQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UserBillingOverviewQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, billingOverview?: { __typename?: 'BillingOverview', hasUpgradedProducts: boolean, isBillingSetup: boolean, currentProducts?: Array<{ __typename?: 'ApiAccess', name?: string | null, description?: string | null, sku: string, displayPrice?: string | null, benefits: Array<string>, productTypeMetadata?: { __typename?: 'ProductTypeMetadata', productType?: ProductType | null, displayName?: string | null, pricingPageAnchor?: string | null } | null, usage: Array<{ __typename?: 'Usage', unit: string, unitPlural: string, displayName: string, currentUsage?: number | null, maximumUsage?: number | null, description?: string | null }> } | { __typename?: 'PlanTierV2', name?: string | null, description?: string | null, sku: string, displayPrice?: string | null, benefits: Array<string>, productTypeMetadata?: { __typename?: 'ProductTypeMetadata', productType?: ProductType | null, displayName?: string | null, pricingPageAnchor?: string | null } | null, usage: Array<{ __typename?: 'Usage', unit: string, unitPlural: string, displayName: string, currentUsage?: number | null, maximumUsage?: number | null, description?: string | null }> } | { __typename?: 'ProjectPack', name?: string | null, description?: string | null, sku: string, displayPrice?: string | null, benefits: Array<string>, productTypeMetadata?: { __typename?: 'ProductTypeMetadata', productType?: ProductType | null, displayName?: string | null, pricingPageAnchor?: string | null } | null, usage: Array<{ __typename?: 'Usage', unit: string, unitPlural: string, displayName: string, currentUsage?: number | null, maximumUsage?: number | null, description?: string | null }> } | { __typename?: 'SupportTier', name?: string | null, description?: string | null, sku: string, displayPrice?: string | null, benefits: Array<string>, productTypeMetadata?: { __typename?: 'ProductTypeMetadata', productType?: ProductType | null, displayName?: string | null, pricingPageAnchor?: string | null } | null, usage: Array<{ __typename?: 'Usage', unit: string, unitPlural: string, displayName: string, currentUsage?: number | null, maximumUsage?: number | null, description?: string | null }> }> | null, externalLinks?: { __typename?: 'ExternalBillingProviderLinks', invoiceHistory: { __typename?: 'UrlOrContactUs', url?: string | null, contactUs?: ContactUs | null }, managePaymentMethod: { __typename?: 'UrlOrContactUs', url?: string | null, contactUs?: ContactUs | null }, downgrade: { __typename?: 'UrlOrContactUs', url?: string | null, contactUs?: ContactUs | null }, help: { __typename?: 'UrlOrContactUs', url?: string | null, contactUs?: ContactUs | null } } | null, subscriptionUsageAllowed: { __typename?: 'SubscriptionUsageAllowed', seats: boolean, clusters: boolean, cloudAccounts: boolean, projects: boolean, customBlueprints: boolean } } | null } };

export type SubscriptionFeatureQueryVariables = Exact<{
  id: Scalars['ID'];
  featureKey: FeatureKey;
}>;


export type SubscriptionFeatureQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, billingOverview?: { __typename?: 'BillingOverview', subscriptionFeatures: { __typename?: 'SubscriptionFeatures', byKey?: { __typename?: 'SubscriptionFeature', key: FeatureKey, enabled?: boolean | null } | null } } | null } };

export type PreviewSubscriptionQueryVariables = Exact<{
  forUserID: Scalars['UUID'];
  subscriptionCart: SubscriptionCart;
}>;


export type PreviewSubscriptionQuery = { __typename?: 'Query', productCatalog: { __typename?: 'ProductCatalog', previewSubscription: { __typename?: 'SubscriptionPurchasePreview', paymentMethodName?: string | null, products?: Array<{ __typename?: 'ProductPurchasePreview', newProductStatus?: CatalogProductStatus | null, sectionName: string, currentProduct?: { __typename?: 'ApiAccess', name?: string | null, description?: string | null, sku: string, displayPrice?: string | null, benefits: Array<string>, productTypeMetadata?: { __typename?: 'ProductTypeMetadata', productType?: ProductType | null, displayName?: string | null, pricingPageAnchor?: string | null } | null, usage: Array<{ __typename?: 'Usage', unit: string, unitPlural: string, displayName: string, currentUsage?: number | null, maximumUsage?: number | null, description?: string | null }> } | { __typename?: 'PlanTierV2', name?: string | null, description?: string | null, sku: string, displayPrice?: string | null, benefits: Array<string>, productTypeMetadata?: { __typename?: 'ProductTypeMetadata', productType?: ProductType | null, displayName?: string | null, pricingPageAnchor?: string | null } | null, usage: Array<{ __typename?: 'Usage', unit: string, unitPlural: string, displayName: string, currentUsage?: number | null, maximumUsage?: number | null, description?: string | null }> } | { __typename?: 'ProjectPack', name?: string | null, description?: string | null, sku: string, displayPrice?: string | null, benefits: Array<string>, productTypeMetadata?: { __typename?: 'ProductTypeMetadata', productType?: ProductType | null, displayName?: string | null, pricingPageAnchor?: string | null } | null, usage: Array<{ __typename?: 'Usage', unit: string, unitPlural: string, displayName: string, currentUsage?: number | null, maximumUsage?: number | null, description?: string | null }> } | { __typename?: 'SupportTier', name?: string | null, description?: string | null, sku: string, displayPrice?: string | null, benefits: Array<string>, productTypeMetadata?: { __typename?: 'ProductTypeMetadata', productType?: ProductType | null, displayName?: string | null, pricingPageAnchor?: string | null } | null, usage: Array<{ __typename?: 'Usage', unit: string, unitPlural: string, displayName: string, currentUsage?: number | null, maximumUsage?: number | null, description?: string | null }> } | null, newProduct?: { __typename?: 'ApiAccess', name?: string | null, description?: string | null, sku: string, displayPrice?: string | null, benefits: Array<string>, productTypeMetadata?: { __typename?: 'ProductTypeMetadata', productType?: ProductType | null, displayName?: string | null, pricingPageAnchor?: string | null } | null, usage: Array<{ __typename?: 'Usage', unit: string, unitPlural: string, displayName: string, currentUsage?: number | null, maximumUsage?: number | null, description?: string | null }> } | { __typename?: 'PlanTierV2', name?: string | null, description?: string | null, sku: string, displayPrice?: string | null, benefits: Array<string>, productTypeMetadata?: { __typename?: 'ProductTypeMetadata', productType?: ProductType | null, displayName?: string | null, pricingPageAnchor?: string | null } | null, usage: Array<{ __typename?: 'Usage', unit: string, unitPlural: string, displayName: string, currentUsage?: number | null, maximumUsage?: number | null, description?: string | null }> } | { __typename?: 'ProjectPack', name?: string | null, description?: string | null, sku: string, displayPrice?: string | null, benefits: Array<string>, productTypeMetadata?: { __typename?: 'ProductTypeMetadata', productType?: ProductType | null, displayName?: string | null, pricingPageAnchor?: string | null } | null, usage: Array<{ __typename?: 'Usage', unit: string, unitPlural: string, displayName: string, currentUsage?: number | null, maximumUsage?: number | null, description?: string | null }> } | { __typename?: 'SupportTier', name?: string | null, description?: string | null, sku: string, displayPrice?: string | null, benefits: Array<string>, productTypeMetadata?: { __typename?: 'ProductTypeMetadata', productType?: ProductType | null, displayName?: string | null, pricingPageAnchor?: string | null } | null, usage: Array<{ __typename?: 'Usage', unit: string, unitPlural: string, displayName: string, currentUsage?: number | null, maximumUsage?: number | null, description?: string | null }> } | null }> | null } } };

type ProjectBlueprintConfigurationDetail_BlueprintHelmConfiguration_Fragment = { __typename?: 'BlueprintHelmConfiguration', source?: { __typename?: 'Source', git?: { __typename?: 'GitSource', repository: string, path?: string | null, ref?: string | null, integration?: { __typename?: 'GitSourceIntegration', githubInstallationID?: number | null, bitbucketIntegrationID?: string | null, gitlabIntegrationID?: string | null } | null } | null, helmRepository?: { __typename?: 'HelmRepositorySource', chart: string, version?: string | null, repositoryURL: string } | null, containerRegistry?: { __typename?: 'ContainerRegistrySource', registryID?: string | null, registryURL?: string | null, repository: string, tag?: string | null } | null } | null };

type ProjectBlueprintConfigurationDetail_BlueprintManifestConfiguration_Fragment = { __typename?: 'BlueprintManifestConfiguration', source?: { __typename?: 'Source', git?: { __typename?: 'GitSource', repository: string, path?: string | null, ref?: string | null, integration?: { __typename?: 'GitSourceIntegration', githubInstallationID?: number | null, bitbucketIntegrationID?: string | null, gitlabIntegrationID?: string | null } | null } | null } | null };

type ProjectBlueprintConfigurationDetail_BlueprintTerraformConfiguration_Fragment = { __typename?: 'BlueprintTerraformConfiguration', registrySource?: string | null, moduleVersionConstraint?: string | null, githubSource?: string | null, moduleSource?: { __typename?: 'TerraformModuleSource', source: string, version?: string | null, integration?: { __typename?: 'TerraformModuleSourceIntegration', git?: { __typename?: 'GitSourceIntegration', githubInstallationID?: number | null, bitbucketIntegrationID?: string | null, gitlabIntegrationID?: string | null } | null } | null } | null };

export type ProjectBlueprintConfigurationDetailFragment = ProjectBlueprintConfigurationDetail_BlueprintHelmConfiguration_Fragment | ProjectBlueprintConfigurationDetail_BlueprintManifestConfiguration_Fragment | ProjectBlueprintConfigurationDetail_BlueprintTerraformConfiguration_Fragment;

export type BlueprintListFragment = { __typename?: 'Blueprint', id: string, description?: string | null, displayName: string, isOfficial?: boolean | null, logoUrl?: string | null, enabled?: boolean | null, published: boolean, projectCount: number, richInputSchema?: any | null, allowedCloudProviders: Array<CloudProvider>, slug: string, tags: Array<string>, type: BlueprintType, configuration?: { __typename?: 'BlueprintHelmConfiguration', source?: { __typename?: 'Source', git?: { __typename?: 'GitSource', repository: string, path?: string | null, ref?: string | null, integration?: { __typename?: 'GitSourceIntegration', githubInstallationID?: number | null, bitbucketIntegrationID?: string | null, gitlabIntegrationID?: string | null } | null } | null, helmRepository?: { __typename?: 'HelmRepositorySource', chart: string, version?: string | null, repositoryURL: string } | null, containerRegistry?: { __typename?: 'ContainerRegistrySource', registryID?: string | null, registryURL?: string | null, repository: string, tag?: string | null } | null } | null } | { __typename?: 'BlueprintManifestConfiguration', source?: { __typename?: 'Source', git?: { __typename?: 'GitSource', repository: string, path?: string | null, ref?: string | null, integration?: { __typename?: 'GitSourceIntegration', githubInstallationID?: number | null, bitbucketIntegrationID?: string | null, gitlabIntegrationID?: string | null } | null } | null } | null } | { __typename?: 'BlueprintTerraformConfiguration', registrySource?: string | null, moduleVersionConstraint?: string | null, githubSource?: string | null, moduleSource?: { __typename?: 'TerraformModuleSource', source: string, version?: string | null, integration?: { __typename?: 'TerraformModuleSourceIntegration', git?: { __typename?: 'GitSourceIntegration', githubInstallationID?: number | null, bitbucketIntegrationID?: string | null, gitlabIntegrationID?: string | null } | null } | null } | null } | null, owner?: { __typename?: 'BlueprintOwner', name: string, login: any } | null, variables: Array<{ __typename?: 'BlueprintVariableSpec', id: string, name: string, type: BlueprintVariableType, required: boolean }> };

export type BlueprintMetadataListFragment = { __typename?: 'BlueprintMetadata', id: string, slug: string, name: string, displayName: string, type: BlueprintType, description?: string | null, tags: Array<string>, logoUrl?: string | null, version?: string | null, latestVersion?: string | null, availableVersions: Array<string>, applicationVersion?: string | null, organizationName?: string | null, organizationDisplayName?: string | null, createdAt?: Date | null, updatedAt?: Date | null, metatags?: Array<{ __typename?: 'BlueprintMetadataMetaTag', name: string, value: string } | null> | null, versions: Array<{ __typename?: 'BlueprintMetadataVersion', version: string, prerelease?: boolean | null, timestamp?: Date | null }> };

export type BlueprintsQueryVariables = Exact<{
  userId: Scalars['ID'];
  permissionsUserId: Scalars['UUID'];
  pageInput: PageInput;
}>;


export type BlueprintsQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, permissions?: { __typename?: 'UserPermissionsConnection', user?: { __typename?: 'UserPermissionsUserConnection', mutations: Array<any> } | null } | null }, user: { __typename?: 'User', id: string, blueprints?: { __typename?: 'BlueprintConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor: string, endCursor: string, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'Blueprint', id: string, description?: string | null, displayName: string, isOfficial?: boolean | null, logoUrl?: string | null, enabled?: boolean | null, published: boolean, projectCount: number, richInputSchema?: any | null, allowedCloudProviders: Array<CloudProvider>, slug: string, tags: Array<string>, type: BlueprintType, configuration?: { __typename?: 'BlueprintHelmConfiguration', source?: { __typename?: 'Source', git?: { __typename?: 'GitSource', repository: string, path?: string | null, ref?: string | null, integration?: { __typename?: 'GitSourceIntegration', githubInstallationID?: number | null, bitbucketIntegrationID?: string | null, gitlabIntegrationID?: string | null } | null } | null, helmRepository?: { __typename?: 'HelmRepositorySource', chart: string, version?: string | null, repositoryURL: string } | null, containerRegistry?: { __typename?: 'ContainerRegistrySource', registryID?: string | null, registryURL?: string | null, repository: string, tag?: string | null } | null } | null } | { __typename?: 'BlueprintManifestConfiguration', source?: { __typename?: 'Source', git?: { __typename?: 'GitSource', repository: string, path?: string | null, ref?: string | null, integration?: { __typename?: 'GitSourceIntegration', githubInstallationID?: number | null, bitbucketIntegrationID?: string | null, gitlabIntegrationID?: string | null } | null } | null } | null } | { __typename?: 'BlueprintTerraformConfiguration', registrySource?: string | null, moduleVersionConstraint?: string | null, githubSource?: string | null, moduleSource?: { __typename?: 'TerraformModuleSource', source: string, version?: string | null, integration?: { __typename?: 'TerraformModuleSourceIntegration', git?: { __typename?: 'GitSourceIntegration', githubInstallationID?: number | null, bitbucketIntegrationID?: string | null, gitlabIntegrationID?: string | null } | null } | null } | null } | null, owner?: { __typename?: 'BlueprintOwner', name: string, login: any } | null, variables: Array<{ __typename?: 'BlueprintVariableSpec', id: string, name: string, type: BlueprintVariableType, required: boolean }> }> } | null } };

export type LambdaCloudRunBlueprintsQueryVariables = Exact<{
  owner: Scalars['Login'];
  lambdaBlueprintSlug: Scalars['String'];
  cloudRunBlueprintSlug: Scalars['String'];
}>;


export type LambdaCloudRunBlueprintsQuery = { __typename?: 'Query', blueprintsMarketplace?: { __typename?: 'BlueprintsMarketplace', lambdaBlueprint?: { __typename?: 'Blueprint', id: string, description?: string | null, displayName: string, isOfficial?: boolean | null, logoUrl?: string | null, enabled?: boolean | null, published: boolean, projectCount: number, richInputSchema?: any | null, allowedCloudProviders: Array<CloudProvider>, slug: string, tags: Array<string>, type: BlueprintType, configuration?: { __typename?: 'BlueprintHelmConfiguration', source?: { __typename?: 'Source', git?: { __typename?: 'GitSource', repository: string, path?: string | null, ref?: string | null, integration?: { __typename?: 'GitSourceIntegration', githubInstallationID?: number | null, bitbucketIntegrationID?: string | null, gitlabIntegrationID?: string | null } | null } | null, helmRepository?: { __typename?: 'HelmRepositorySource', chart: string, version?: string | null, repositoryURL: string } | null, containerRegistry?: { __typename?: 'ContainerRegistrySource', registryID?: string | null, registryURL?: string | null, repository: string, tag?: string | null } | null } | null } | { __typename?: 'BlueprintManifestConfiguration', source?: { __typename?: 'Source', git?: { __typename?: 'GitSource', repository: string, path?: string | null, ref?: string | null, integration?: { __typename?: 'GitSourceIntegration', githubInstallationID?: number | null, bitbucketIntegrationID?: string | null, gitlabIntegrationID?: string | null } | null } | null } | null } | { __typename?: 'BlueprintTerraformConfiguration', registrySource?: string | null, moduleVersionConstraint?: string | null, githubSource?: string | null, moduleSource?: { __typename?: 'TerraformModuleSource', source: string, version?: string | null, integration?: { __typename?: 'TerraformModuleSourceIntegration', git?: { __typename?: 'GitSourceIntegration', githubInstallationID?: number | null, bitbucketIntegrationID?: string | null, gitlabIntegrationID?: string | null } | null } | null } | null } | null, owner?: { __typename?: 'BlueprintOwner', name: string, login: any } | null, variables: Array<{ __typename?: 'BlueprintVariableSpec', id: string, name: string, type: BlueprintVariableType, required: boolean }> } | null, cloudRunBlueprint?: { __typename?: 'Blueprint', id: string, description?: string | null, displayName: string, isOfficial?: boolean | null, logoUrl?: string | null, enabled?: boolean | null, published: boolean, projectCount: number, richInputSchema?: any | null, allowedCloudProviders: Array<CloudProvider>, slug: string, tags: Array<string>, type: BlueprintType, configuration?: { __typename?: 'BlueprintHelmConfiguration', source?: { __typename?: 'Source', git?: { __typename?: 'GitSource', repository: string, path?: string | null, ref?: string | null, integration?: { __typename?: 'GitSourceIntegration', githubInstallationID?: number | null, bitbucketIntegrationID?: string | null, gitlabIntegrationID?: string | null } | null } | null, helmRepository?: { __typename?: 'HelmRepositorySource', chart: string, version?: string | null, repositoryURL: string } | null, containerRegistry?: { __typename?: 'ContainerRegistrySource', registryID?: string | null, registryURL?: string | null, repository: string, tag?: string | null } | null } | null } | { __typename?: 'BlueprintManifestConfiguration', source?: { __typename?: 'Source', git?: { __typename?: 'GitSource', repository: string, path?: string | null, ref?: string | null, integration?: { __typename?: 'GitSourceIntegration', githubInstallationID?: number | null, bitbucketIntegrationID?: string | null, gitlabIntegrationID?: string | null } | null } | null } | null } | { __typename?: 'BlueprintTerraformConfiguration', registrySource?: string | null, moduleVersionConstraint?: string | null, githubSource?: string | null, moduleSource?: { __typename?: 'TerraformModuleSource', source: string, version?: string | null, integration?: { __typename?: 'TerraformModuleSourceIntegration', git?: { __typename?: 'GitSourceIntegration', githubInstallationID?: number | null, bitbucketIntegrationID?: string | null, gitlabIntegrationID?: string | null } | null } | null } | null } | null, owner?: { __typename?: 'BlueprintOwner', name: string, login: any } | null, variables: Array<{ __typename?: 'BlueprintVariableSpec', id: string, name: string, type: BlueprintVariableType, required: boolean }> } | null } | null };

export type MarketplaceBlueprintsQueryVariables = Exact<{
  pageInput: PageInput;
}>;


export type MarketplaceBlueprintsQuery = { __typename?: 'Query', blueprintsMarketplace?: { __typename?: 'BlueprintsMarketplace', blueprints?: { __typename?: 'BlueprintConnection', nodes: Array<{ __typename?: 'Blueprint', id: string, description?: string | null, displayName: string, isOfficial?: boolean | null, logoUrl?: string | null, enabled?: boolean | null, published: boolean, projectCount: number, richInputSchema?: any | null, allowedCloudProviders: Array<CloudProvider>, slug: string, tags: Array<string>, type: BlueprintType, configuration?: { __typename?: 'BlueprintHelmConfiguration', source?: { __typename?: 'Source', git?: { __typename?: 'GitSource', repository: string, path?: string | null, ref?: string | null, integration?: { __typename?: 'GitSourceIntegration', githubInstallationID?: number | null, bitbucketIntegrationID?: string | null, gitlabIntegrationID?: string | null } | null } | null, helmRepository?: { __typename?: 'HelmRepositorySource', chart: string, version?: string | null, repositoryURL: string } | null, containerRegistry?: { __typename?: 'ContainerRegistrySource', registryID?: string | null, registryURL?: string | null, repository: string, tag?: string | null } | null } | null } | { __typename?: 'BlueprintManifestConfiguration', source?: { __typename?: 'Source', git?: { __typename?: 'GitSource', repository: string, path?: string | null, ref?: string | null, integration?: { __typename?: 'GitSourceIntegration', githubInstallationID?: number | null, bitbucketIntegrationID?: string | null, gitlabIntegrationID?: string | null } | null } | null } | null } | { __typename?: 'BlueprintTerraformConfiguration', registrySource?: string | null, moduleVersionConstraint?: string | null, githubSource?: string | null, moduleSource?: { __typename?: 'TerraformModuleSource', source: string, version?: string | null, integration?: { __typename?: 'TerraformModuleSourceIntegration', git?: { __typename?: 'GitSourceIntegration', githubInstallationID?: number | null, bitbucketIntegrationID?: string | null, gitlabIntegrationID?: string | null } | null } | null } | null } | null, owner?: { __typename?: 'BlueprintOwner', name: string, login: any } | null, variables: Array<{ __typename?: 'BlueprintVariableSpec', id: string, name: string, type: BlueprintVariableType, required: boolean }> }> } | null } | null };

export type MarketplaceBlueprintMetadataListQueryVariables = Exact<{
  filterInput: FilterInput;
}>;


export type MarketplaceBlueprintMetadataListQuery = { __typename?: 'Query', blueprintsMarketplace?: { __typename?: 'BlueprintsMarketplace', blueprintMetadataList?: { __typename?: 'BlueprintMetadataConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor: string, endCursor: string, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'BlueprintMetadata', id: string, slug: string, name: string, displayName: string, type: BlueprintType, description?: string | null, tags: Array<string>, logoUrl?: string | null, version?: string | null, latestVersion?: string | null, availableVersions: Array<string>, applicationVersion?: string | null, organizationName?: string | null, organizationDisplayName?: string | null, createdAt?: Date | null, updatedAt?: Date | null, metatags?: Array<{ __typename?: 'BlueprintMetadataMetaTag', name: string, value: string } | null> | null, versions: Array<{ __typename?: 'BlueprintMetadataVersion', version: string, prerelease?: boolean | null, timestamp?: Date | null }> }> } | null } | null };

export type MarketplaceBlueprintQueryVariables = Exact<{
  owner: Scalars['Login'];
  slug: Scalars['String'];
}>;


export type MarketplaceBlueprintQuery = { __typename?: 'Query', blueprintsMarketplace?: { __typename?: 'BlueprintsMarketplace', blueprint?: { __typename?: 'Blueprint', id: string, description?: string | null, displayName: string, isOfficial?: boolean | null, logoUrl?: string | null, enabled?: boolean | null, published: boolean, projectCount: number, richInputSchema?: any | null, allowedCloudProviders: Array<CloudProvider>, slug: string, tags: Array<string>, type: BlueprintType, configuration?: { __typename?: 'BlueprintHelmConfiguration', source?: { __typename?: 'Source', git?: { __typename?: 'GitSource', repository: string, path?: string | null, ref?: string | null, integration?: { __typename?: 'GitSourceIntegration', githubInstallationID?: number | null, bitbucketIntegrationID?: string | null, gitlabIntegrationID?: string | null } | null } | null, helmRepository?: { __typename?: 'HelmRepositorySource', chart: string, version?: string | null, repositoryURL: string } | null, containerRegistry?: { __typename?: 'ContainerRegistrySource', registryID?: string | null, registryURL?: string | null, repository: string, tag?: string | null } | null } | null } | { __typename?: 'BlueprintManifestConfiguration', source?: { __typename?: 'Source', git?: { __typename?: 'GitSource', repository: string, path?: string | null, ref?: string | null, integration?: { __typename?: 'GitSourceIntegration', githubInstallationID?: number | null, bitbucketIntegrationID?: string | null, gitlabIntegrationID?: string | null } | null } | null } | null } | { __typename?: 'BlueprintTerraformConfiguration', registrySource?: string | null, moduleVersionConstraint?: string | null, githubSource?: string | null, moduleSource?: { __typename?: 'TerraformModuleSource', source: string, version?: string | null, integration?: { __typename?: 'TerraformModuleSourceIntegration', git?: { __typename?: 'GitSourceIntegration', githubInstallationID?: number | null, bitbucketIntegrationID?: string | null, gitlabIntegrationID?: string | null } | null } | null } | null } | null, owner?: { __typename?: 'BlueprintOwner', name: string, login: any } | null, variables: Array<{ __typename?: 'BlueprintVariableSpec', id: string, name: string, type: BlueprintVariableType, required: boolean }> } | null } | null };

export type MarketplaceBlueprintMetadataQueryVariables = Exact<{
  owner?: InputMaybe<Scalars['Login']>;
  slug: Scalars['String'];
  version?: InputMaybe<Scalars['String']>;
}>;


export type MarketplaceBlueprintMetadataQuery = { __typename?: 'Query', blueprintsMarketplace?: { __typename?: 'BlueprintsMarketplace', blueprintMetadata?: { __typename?: 'BlueprintMetadata', id: string, slug: string, name: string, displayName: string, type: BlueprintType, description?: string | null, tags: Array<string>, logoUrl?: string | null, version?: string | null, latestVersion?: string | null, availableVersions: Array<string>, applicationVersion?: string | null, organizationName?: string | null, organizationDisplayName?: string | null, createdAt?: Date | null, updatedAt?: Date | null, metatags?: Array<{ __typename?: 'BlueprintMetadataMetaTag', name: string, value: string } | null> | null, versions: Array<{ __typename?: 'BlueprintMetadataVersion', version: string, prerelease?: boolean | null, timestamp?: Date | null }> } | null } | null };

export type BlueprintQueryVariables = Exact<{
  userId: Scalars['ID'];
  permissionsUserId: Scalars['UUID'];
  blueprintId: Scalars['UUID'];
}>;


export type BlueprintQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, permissions?: { __typename?: 'UserPermissionsConnection', user?: { __typename?: 'UserPermissionsUserConnection', mutations: Array<any> } | null } | null }, user: { __typename?: 'User', id: string, login: any, blueprint?: { __typename?: 'Blueprint', id: string, description?: string | null, displayName: string, isOfficial?: boolean | null, logoUrl?: string | null, enabled?: boolean | null, published: boolean, projectCount: number, richInputSchema?: any | null, allowedCloudProviders: Array<CloudProvider>, slug: string, tags: Array<string>, type: BlueprintType, configuration?: { __typename?: 'BlueprintHelmConfiguration', source?: { __typename?: 'Source', git?: { __typename?: 'GitSource', repository: string, path?: string | null, ref?: string | null, integration?: { __typename?: 'GitSourceIntegration', githubInstallationID?: number | null, bitbucketIntegrationID?: string | null, gitlabIntegrationID?: string | null } | null } | null, helmRepository?: { __typename?: 'HelmRepositorySource', chart: string, version?: string | null, repositoryURL: string } | null, containerRegistry?: { __typename?: 'ContainerRegistrySource', registryID?: string | null, registryURL?: string | null, repository: string, tag?: string | null } | null } | null } | { __typename?: 'BlueprintManifestConfiguration', source?: { __typename?: 'Source', git?: { __typename?: 'GitSource', repository: string, path?: string | null, ref?: string | null, integration?: { __typename?: 'GitSourceIntegration', githubInstallationID?: number | null, bitbucketIntegrationID?: string | null, gitlabIntegrationID?: string | null } | null } | null } | null } | { __typename?: 'BlueprintTerraformConfiguration', registrySource?: string | null, moduleVersionConstraint?: string | null, githubSource?: string | null, moduleSource?: { __typename?: 'TerraformModuleSource', source: string, version?: string | null, integration?: { __typename?: 'TerraformModuleSourceIntegration', git?: { __typename?: 'GitSourceIntegration', githubInstallationID?: number | null, bitbucketIntegrationID?: string | null, gitlabIntegrationID?: string | null } | null } | null } | null } | null, owner?: { __typename?: 'BlueprintOwner', name: string, login: any } | null, variables: Array<{ __typename?: 'BlueprintVariableSpec', id: string, name: string, type: BlueprintVariableType, required: boolean }> } | null } };

export type BlueprintNameQueryVariables = Exact<{
  userId: Scalars['ID'];
  blueprintId: Scalars['UUID'];
}>;


export type BlueprintNameQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, blueprint?: { __typename?: 'Blueprint', id: string, displayName: string } | null } };

export type BlueprintWithProjectsQueryVariables = Exact<{
  userId: Scalars['ID'];
  permissionsUserId: Scalars['UUID'];
  blueprintId: Scalars['UUID'];
}>;


export type BlueprintWithProjectsQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, permissions?: { __typename?: 'UserPermissionsConnection', user?: { __typename?: 'UserPermissionsUserConnection', mutations: Array<any> } | null } | null }, user: { __typename?: 'User', id: string, login: any, blueprint?: { __typename?: 'Blueprint', id: string, description?: string | null, displayName: string, isOfficial?: boolean | null, logoUrl?: string | null, enabled?: boolean | null, published: boolean, projectCount: number, richInputSchema?: any | null, allowedCloudProviders: Array<CloudProvider>, slug: string, tags: Array<string>, type: BlueprintType, configuration?: { __typename?: 'BlueprintHelmConfiguration', source?: { __typename?: 'Source', git?: { __typename?: 'GitSource', repository: string, path?: string | null, ref?: string | null, integration?: { __typename?: 'GitSourceIntegration', githubInstallationID?: number | null, bitbucketIntegrationID?: string | null, gitlabIntegrationID?: string | null } | null } | null, helmRepository?: { __typename?: 'HelmRepositorySource', chart: string, version?: string | null, repositoryURL: string } | null, containerRegistry?: { __typename?: 'ContainerRegistrySource', registryID?: string | null, registryURL?: string | null, repository: string, tag?: string | null } | null } | null } | { __typename?: 'BlueprintManifestConfiguration', source?: { __typename?: 'Source', git?: { __typename?: 'GitSource', repository: string, path?: string | null, ref?: string | null, integration?: { __typename?: 'GitSourceIntegration', githubInstallationID?: number | null, bitbucketIntegrationID?: string | null, gitlabIntegrationID?: string | null } | null } | null } | null } | { __typename?: 'BlueprintTerraformConfiguration', registrySource?: string | null, moduleVersionConstraint?: string | null, githubSource?: string | null, moduleSource?: { __typename?: 'TerraformModuleSource', source: string, version?: string | null, integration?: { __typename?: 'TerraformModuleSourceIntegration', git?: { __typename?: 'GitSourceIntegration', githubInstallationID?: number | null, bitbucketIntegrationID?: string | null, gitlabIntegrationID?: string | null } | null } | null } | null } | null, owner?: { __typename?: 'BlueprintOwner', name: string, login: any } | null, variables: Array<{ __typename?: 'BlueprintVariableSpec', id: string, name: string, type: BlueprintVariableType, required: boolean }> } | null, projectV3Adapters?: { __typename?: 'ProjectV3AdapterConnection', totalCount: number, nodes: Array<{ __typename?: 'ProjectV3Adapter', name: string, id: string, status?: ProjectV3AdapterStatus | null, isDeployV2: boolean, updatedAt: Date, projectV3?: { __typename?: 'ProjectV3', id: string, name: string, blueprintID: string } | null, repo?: { __typename?: 'Repo', id: string, path: string, enabled: boolean, productionBranch?: string | null, deployTarget?: DeployTarget | null, deployType?: DeployType | null, deployService?: boolean | null, deployJob?: boolean | null, image?: string | null, cpu?: string | null, memory?: string | null, updatedAt: Date, disableReason?: DisableReason | null, databaseProvider?: DatabaseProviderType | null, databaseEngine?: DatabaseEngineType | null, name: string, productionDeployment?: { __typename?: 'Deployment', id: string, description?: string | null, version: string, status: DeploymentStatus, branch?: string | null, endpoints?: Array<string> | null, privateEndpoint?: string | null, errorMessage?: string | null, updatedAt: Date, createdAt: Date, deployStatus?: { __typename?: 'DeployStatus', active: boolean, replicas: number, publicIPs?: Array<string> | null, state: string, errorMessage?: string | null, troubleshooting?: { __typename?: 'Troubleshooting', issue?: { __typename?: 'TroubleshootingIssue', blocks?: Array<{ __typename?: 'TroubleshootingIssueBlock', blockType?: TroubleshootingIssueBlockType | null, content?: string | null }> | null } | null } | null } | null, build?: { __typename?: 'Build', id: string, image?: string | null } | null, alternativeImages?: Array<{ __typename?: 'AlternativeImage', reference?: string | null, tag?: string | null, name?: string | null }> | null } | null, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, projectID?: string | null } | null, gpu?: { __typename?: 'GPUSpec', type?: string | null, count: number } | null, tpu?: { __typename?: 'TPUSpec', tfVersion: string, type: string, cores: number } | null, cluster?: { __typename?: 'Cluster', id: string, name: string, domain?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null } | null, autoscaling?: { __typename?: 'Autoscaling', minReplicas: number, maxReplicas: number } | null, owner: { __typename?: 'User', id: string, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, owner: { __typename?: 'User', id: string, login: any } } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null } | null, project?: { __typename?: 'Project', id: string, name: string } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null }> } | null } };

export type BranchCommonFragment = { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null, createdAt: Date, updatedAt: Date, state?: string | null, endpoints?: Array<string> | null, latestDeployment?: { __typename?: 'Deployment', id: string, description?: string | null, version: string, status: DeploymentStatus, branch?: string | null, endpoints?: Array<string> | null, privateEndpoint?: string | null, errorMessage?: string | null, updatedAt: Date, createdAt: Date, deployStatus?: { __typename?: 'DeployStatus', active: boolean, replicas: number, publicIPs?: Array<string> | null, state: string, errorMessage?: string | null, troubleshooting?: { __typename?: 'Troubleshooting', issue?: { __typename?: 'TroubleshootingIssue', blocks?: Array<{ __typename?: 'TroubleshootingIssueBlock', blockType?: TroubleshootingIssueBlockType | null, content?: string | null }> | null } | null } | null } | null, build?: { __typename?: 'Build', id: string, image?: string | null } | null, alternativeImages?: Array<{ __typename?: 'AlternativeImage', reference?: string | null, tag?: string | null, name?: string | null }> | null } | null };

export type ProjectActiveBranchesCountQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ProjectActiveBranchesCountQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, repo?: { __typename?: 'Repo', id: string, branchesV2?: { __typename?: 'RepoBranchConnection', totalCount: number } | null } | null } };

export type ProjectBranchesQueryVariables = Exact<{
  id: Scalars['ID'];
  active?: InputMaybe<Scalars['Boolean']>;
}>;


export type ProjectBranchesQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, repo?: { __typename?: 'Repo', id: string, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null, createdAt: Date, updatedAt: Date, state?: string | null, endpoints?: Array<string> | null, latestDeployment?: { __typename?: 'Deployment', id: string, description?: string | null, version: string, status: DeploymentStatus, branch?: string | null, endpoints?: Array<string> | null, privateEndpoint?: string | null, errorMessage?: string | null, updatedAt: Date, createdAt: Date, deployStatus?: { __typename?: 'DeployStatus', active: boolean, replicas: number, publicIPs?: Array<string> | null, state: string, errorMessage?: string | null, troubleshooting?: { __typename?: 'Troubleshooting', issue?: { __typename?: 'TroubleshootingIssue', blocks?: Array<{ __typename?: 'TroubleshootingIssueBlock', blockType?: TroubleshootingIssueBlockType | null, content?: string | null }> | null } | null } | null } | null, build?: { __typename?: 'Build', id: string, image?: string | null } | null, alternativeImages?: Array<{ __typename?: 'AlternativeImage', reference?: string | null, tag?: string | null, name?: string | null }> | null } | null } | null, branchesV2?: { __typename?: 'RepoBranchConnection', nodes: Array<{ __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null, createdAt: Date, updatedAt: Date, state?: string | null, endpoints?: Array<string> | null, latestDeployment?: { __typename?: 'Deployment', id: string, description?: string | null, version: string, status: DeploymentStatus, branch?: string | null, endpoints?: Array<string> | null, privateEndpoint?: string | null, errorMessage?: string | null, updatedAt: Date, createdAt: Date, deployStatus?: { __typename?: 'DeployStatus', active: boolean, replicas: number, publicIPs?: Array<string> | null, state: string, errorMessage?: string | null, troubleshooting?: { __typename?: 'Troubleshooting', issue?: { __typename?: 'TroubleshootingIssue', blocks?: Array<{ __typename?: 'TroubleshootingIssueBlock', blockType?: TroubleshootingIssueBlockType | null, content?: string | null }> | null } | null } | null } | null, build?: { __typename?: 'Build', id: string, image?: string | null } | null, alternativeImages?: Array<{ __typename?: 'AlternativeImage', reference?: string | null, tag?: string | null, name?: string | null }> | null } | null }> } | null } | null } };

export type AwsAccountDetailFragment = { __typename?: 'AWSAccount', id: string, name: string, state: AwsAccountState, accountID?: string | null, roleARN?: string | null, cloudFormationURL: string, connected?: boolean | null };

export type GcpAccountDetailFragment = { __typename?: 'GCPAccount', id: string, name: string, state: GcpAccountState, projectID?: string | null, clientEmail?: string | null, connected?: boolean | null, error?: string | null };

export type DoAccountDetailFragment = { __typename?: 'DOAccount', id: string, name: string, state: DoAccountState, accessTokenPrefix?: string | null, defaultProject?: string | null, connected?: boolean | null };

export type LinodeAccountDetailFragment = { __typename?: 'LinodeAccount', id: string, name: string, state: CloudAccountState, accessTokenPrefix?: string | null, connected?: boolean | null };

export type VultrAccountDetailFragment = { __typename?: 'VultrAccount', id: string, name: string, state: CloudAccountState, connected?: boolean | null };

export type CwAccountDetailFragment = { __typename?: 'CoreWeaveAccount', id: string, name: string, state: CloudAccountState, namespace?: string | null, connected?: boolean | null };

export type AzureAccountDetailFragment = { __typename?: 'AzureAccount', id: string, name: string, state: CloudAccountState, connected?: boolean | null, subscriptionID?: string | null, tenantID?: string | null, clientID?: string | null };

export type UserAwsAccountsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UserAwsAccountsQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, awsAccounts?: Array<{ __typename?: 'AWSAccount', id: string, name: string, state: AwsAccountState, accountID?: string | null, roleARN?: string | null, cloudFormationURL: string, connected?: boolean | null }> | null } };

export type UserAwsAccountsWithCqQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UserAwsAccountsWithCqQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, awsAccounts?: Array<{ __typename?: 'AWSAccount', id: string, name: string, state: AwsAccountState, accountID?: string | null, roleARN?: string | null, cloudFormationURL: string, connected?: boolean | null, cloudQuery?: { __typename?: 'CloudQueryService', id: string, state: CloudQueryState } | null }> | null } };

export type UserGcpAccountsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UserGcpAccountsQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, gcpAccounts?: Array<{ __typename?: 'GCPAccount', id: string, name: string, state: GcpAccountState, projectID?: string | null, clientEmail?: string | null, connected?: boolean | null, error?: string | null }> | null } };

export type UserDoAccountsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UserDoAccountsQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, doAccounts?: Array<{ __typename?: 'DOAccount', id: string, name: string, state: DoAccountState, accessTokenPrefix?: string | null, defaultProject?: string | null, connected?: boolean | null }> | null } };

export type UserLinodeAccountsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UserLinodeAccountsQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, linodeAccounts?: Array<{ __typename?: 'LinodeAccount', id: string, name: string, state: CloudAccountState, accessTokenPrefix?: string | null, connected?: boolean | null }> | null } };

export type UserCoreWeaveAccountsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UserCoreWeaveAccountsQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, coreweaveAccounts?: Array<{ __typename?: 'CoreWeaveAccount', id: string, name: string, state: CloudAccountState, namespace?: string | null, connected?: boolean | null }> | null } };

export type UserAwsResourcesQueryVariables = Exact<{
  userId: Scalars['ID'];
  awsResourceSearchInput: AwsResourceSearchInput;
  awsId: Scalars['UUID'];
}>;


export type UserAwsResourcesQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, awsAccount?: { __typename?: 'AWSAccount', id: string, accountID?: string | null, awsResources: { __typename?: 'AwsResourcesOutput', nextToken?: string | null, awsResources?: Array<{ __typename?: 'AwsResource', arn: string, type: string, region?: string | null }> | null } } | null } };

export type UserCloudsFragment = { __typename?: 'User', awsAccounts?: Array<{ __typename?: 'AWSAccount', id: string, updatedAt: Date, name: string, state: AwsAccountState, accountID?: string | null, roleARN?: string | null, cloudFormationURL: string, connected?: boolean | null, clusters?: Array<{ __typename?: 'Cluster', id: string, name: string }> | null, projectV3Adapters?: { __typename?: 'ProjectV3AdapterConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor: string, endCursor: string, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'ProjectV3Adapter', id: string, name: string, project?: { __typename?: 'Project', id: string, name: string } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null }> } | null }> | null, gcpAccounts?: Array<{ __typename?: 'GCPAccount', id: string, updatedAt: Date, name: string, state: GcpAccountState, projectID?: string | null, clientEmail?: string | null, connected?: boolean | null, error?: string | null, projectV3Adapters?: { __typename?: 'ProjectV3AdapterConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor: string, endCursor: string, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'ProjectV3Adapter', id: string, name: string, project?: { __typename?: 'Project', id: string, name: string } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null }> } | null, clusters?: Array<{ __typename?: 'Cluster', id: string, name: string }> | null }> | null, doAccounts?: Array<{ __typename?: 'DOAccount', id: string, updatedAt: Date, name: string, state: DoAccountState, accessTokenPrefix?: string | null, defaultProject?: string | null, connected?: boolean | null, projectV3Adapters?: { __typename?: 'ProjectV3AdapterConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor: string, endCursor: string, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'ProjectV3Adapter', id: string, name: string, project?: { __typename?: 'Project', id: string, name: string } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null }> } | null, clusters?: Array<{ __typename?: 'Cluster', id: string, name: string }> | null }> | null, coreweaveAccounts?: Array<{ __typename?: 'CoreWeaveAccount', id: string, updatedAt: Date, name: string, state: CloudAccountState, namespace?: string | null, connected?: boolean | null, clusters?: Array<{ __typename?: 'Cluster', id: string, name: string, projectV3Adapters?: { __typename?: 'ProjectV3AdapterConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor: string, endCursor: string, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'ProjectV3Adapter', id: string, name: string, project?: { __typename?: 'Project', id: string, name: string } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null }> } | null }> | null }> | null, linodeAccounts?: Array<{ __typename?: 'LinodeAccount', id: string, updatedAt: Date, name: string, state: CloudAccountState, accessTokenPrefix?: string | null, connected?: boolean | null, projectV3Adapters?: { __typename?: 'ProjectV3AdapterConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor: string, endCursor: string, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'ProjectV3Adapter', id: string, name: string, project?: { __typename?: 'Project', id: string, name: string } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null }> } | null, clusters?: Array<{ __typename?: 'Cluster', id: string, name: string }> | null }> | null, vultrAccounts?: Array<{ __typename?: 'VultrAccount', id: string, updatedAt: Date, name: string, state: CloudAccountState, connected?: boolean | null, clusters?: Array<{ __typename?: 'Cluster', id: string, name: string }> | null, projectV3Adapters?: { __typename?: 'ProjectV3AdapterConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor: string, endCursor: string, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'ProjectV3Adapter', id: string, name: string, project?: { __typename?: 'Project', id: string, name: string } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null }> } | null }> | null, azureAccounts?: Array<{ __typename?: 'AzureAccount', id: string, updatedAt: Date, name: string, state: CloudAccountState, connected?: boolean | null, subscriptionID?: string | null, tenantID?: string | null, clientID?: string | null, clusters?: Array<{ __typename?: 'Cluster', id: string, name: string }> | null, projectV3Adapters?: { __typename?: 'ProjectV3AdapterConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor: string, endCursor: string, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'ProjectV3Adapter', id: string, name: string, project?: { __typename?: 'Project', id: string, name: string } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null }> } | null }> | null };

export type UserCloudsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UserCloudsQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, awsAccounts?: Array<{ __typename?: 'AWSAccount', id: string, updatedAt: Date, name: string, state: AwsAccountState, accountID?: string | null, roleARN?: string | null, cloudFormationURL: string, connected?: boolean | null, clusters?: Array<{ __typename?: 'Cluster', id: string, name: string }> | null, projectV3Adapters?: { __typename?: 'ProjectV3AdapterConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor: string, endCursor: string, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'ProjectV3Adapter', id: string, name: string, project?: { __typename?: 'Project', id: string, name: string } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null }> } | null }> | null, gcpAccounts?: Array<{ __typename?: 'GCPAccount', id: string, updatedAt: Date, name: string, state: GcpAccountState, projectID?: string | null, clientEmail?: string | null, connected?: boolean | null, error?: string | null, projectV3Adapters?: { __typename?: 'ProjectV3AdapterConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor: string, endCursor: string, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'ProjectV3Adapter', id: string, name: string, project?: { __typename?: 'Project', id: string, name: string } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null }> } | null, clusters?: Array<{ __typename?: 'Cluster', id: string, name: string }> | null }> | null, doAccounts?: Array<{ __typename?: 'DOAccount', id: string, updatedAt: Date, name: string, state: DoAccountState, accessTokenPrefix?: string | null, defaultProject?: string | null, connected?: boolean | null, projectV3Adapters?: { __typename?: 'ProjectV3AdapterConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor: string, endCursor: string, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'ProjectV3Adapter', id: string, name: string, project?: { __typename?: 'Project', id: string, name: string } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null }> } | null, clusters?: Array<{ __typename?: 'Cluster', id: string, name: string }> | null }> | null, coreweaveAccounts?: Array<{ __typename?: 'CoreWeaveAccount', id: string, updatedAt: Date, name: string, state: CloudAccountState, namespace?: string | null, connected?: boolean | null, clusters?: Array<{ __typename?: 'Cluster', id: string, name: string, projectV3Adapters?: { __typename?: 'ProjectV3AdapterConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor: string, endCursor: string, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'ProjectV3Adapter', id: string, name: string, project?: { __typename?: 'Project', id: string, name: string } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null }> } | null }> | null }> | null, linodeAccounts?: Array<{ __typename?: 'LinodeAccount', id: string, updatedAt: Date, name: string, state: CloudAccountState, accessTokenPrefix?: string | null, connected?: boolean | null, projectV3Adapters?: { __typename?: 'ProjectV3AdapterConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor: string, endCursor: string, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'ProjectV3Adapter', id: string, name: string, project?: { __typename?: 'Project', id: string, name: string } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null }> } | null, clusters?: Array<{ __typename?: 'Cluster', id: string, name: string }> | null }> | null, vultrAccounts?: Array<{ __typename?: 'VultrAccount', id: string, updatedAt: Date, name: string, state: CloudAccountState, connected?: boolean | null, clusters?: Array<{ __typename?: 'Cluster', id: string, name: string }> | null, projectV3Adapters?: { __typename?: 'ProjectV3AdapterConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor: string, endCursor: string, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'ProjectV3Adapter', id: string, name: string, project?: { __typename?: 'Project', id: string, name: string } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null }> } | null }> | null, azureAccounts?: Array<{ __typename?: 'AzureAccount', id: string, updatedAt: Date, name: string, state: CloudAccountState, connected?: boolean | null, subscriptionID?: string | null, tenantID?: string | null, clientID?: string | null, clusters?: Array<{ __typename?: 'Cluster', id: string, name: string }> | null, projectV3Adapters?: { __typename?: 'ProjectV3AdapterConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor: string, endCursor: string, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'ProjectV3Adapter', id: string, name: string, project?: { __typename?: 'Project', id: string, name: string } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null }> } | null }> | null } };

export type CloudNamesQueryVariables = Exact<{
  teamId: Scalars['ID'];
}>;


export type CloudNamesQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, awsAccounts?: Array<{ __typename?: 'AWSAccount', id: string, name: string }> | null, gcpAccounts?: Array<{ __typename?: 'GCPAccount', id: string, name: string }> | null, doAccounts?: Array<{ __typename?: 'DOAccount', id: string, name: string }> | null, coreweaveAccounts?: Array<{ __typename?: 'CoreWeaveAccount', id: string, name: string }> | null, linodeAccounts?: Array<{ __typename?: 'LinodeAccount', id: string, name: string }> | null, vultrAccounts?: Array<{ __typename?: 'VultrAccount', id: string, name: string }> | null, azureAccounts?: Array<{ __typename?: 'AzureAccount', id: string, name: string }> | null } };

export type CloudDetailsAwsQueryVariables = Exact<{
  id: Scalars['ID'];
  accountId: Scalars['UUID'];
}>;


export type CloudDetailsAwsQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, state: AwsAccountState, accountID?: string | null, roleARN?: string | null, cloudFormationURL: string, connected?: boolean | null } | null } };

export type CloudDetailsGcpQueryVariables = Exact<{
  id: Scalars['ID'];
  accountId: Scalars['UUID'];
}>;


export type CloudDetailsGcpQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, state: GcpAccountState, projectID?: string | null, clientEmail?: string | null, connected?: boolean | null, error?: string | null } | null } };

export type CloudDetailsDoQueryVariables = Exact<{
  id: Scalars['ID'];
  accountId: Scalars['UUID'];
}>;


export type CloudDetailsDoQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, doAccount?: { __typename?: 'DOAccount', id: string, name: string, state: DoAccountState, accessTokenPrefix?: string | null, defaultProject?: string | null, connected?: boolean | null } | null } };

export type CloudDetailsLinodeQueryVariables = Exact<{
  id: Scalars['ID'];
  accountId: Scalars['UUID'];
}>;


export type CloudDetailsLinodeQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, state: CloudAccountState, accessTokenPrefix?: string | null, connected?: boolean | null } | null } };

export type CloudDetailsCoreweaveQueryVariables = Exact<{
  id: Scalars['ID'];
  accountId: Scalars['UUID'];
}>;


export type CloudDetailsCoreweaveQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, coreweaveAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, state: CloudAccountState, namespace?: string | null, connected?: boolean | null } | null } };

export type CloudDetailsVultrQueryVariables = Exact<{
  id: Scalars['ID'];
  accountId: Scalars['UUID'];
}>;


export type CloudDetailsVultrQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string, state: CloudAccountState, connected?: boolean | null } | null } };

export type CloudDetailsAzureQueryVariables = Exact<{
  id: Scalars['ID'];
  accountId: Scalars['UUID'];
}>;


export type CloudDetailsAzureQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, state: CloudAccountState, connected?: boolean | null, subscriptionID?: string | null, tenantID?: string | null, clientID?: string | null } | null } };

export type ClusterComponentsFragment = { __typename?: 'Cluster', id: string, terraformProjectUrl?: string | null, components?: Array<{ __typename?: 'ClusterComponent', name: string, type: ClusterComponentType, status: ClusterComponentEjectedStatus, isInstalledByZeet: boolean, exists: boolean, project?: { __typename?: 'ProjectV3Adapter', id: string, name: string, project?: { __typename?: 'Project', name: string } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', name: string } | null } | null, helmMetadata?: { __typename?: 'HelmClusterComponentMetadata', values: string, namespace: string, releaseName: string, chartRepoGuess?: string | null, chartVersion: string, chartName: string } | null, terraformMetadata?: { __typename?: 'TerraformClusterComponentMetadata', jobRunState?: JobRunState | null } | null } | null> | null };

export type ClusterDetailFragment = { __typename?: 'Cluster', id: string, ingressIP?: string | null, ingressDNS?: string | null, clusterProvider?: ClusterProvider | null, cloudProvider?: CloudProvider | null, terraformProjectUrl?: string | null, containerRepository?: string | null, containerCacheRepository?: string | null, name: string, region?: string | null, state: ClusterState, status?: ClusterStatus | null, connected?: boolean | null, domain?: string | null, isExternal?: boolean | null, isEjected?: boolean | null, updatedAt: Date, createdAt: Date, prometheus?: { __typename?: 'Prometheus', url: string, user?: string | null, password?: string | null, token?: string | null } | null, grafana?: { __typename?: 'Grafana', url: string, user?: string | null, password?: string | null } | null, deployJob?: { __typename?: 'JobRun', id: string, state: JobRunState } | null, projects?: { __typename?: 'ProjectConnection', pageInfo: { __typename?: 'PageInfo', startCursor: string, endCursor: string, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'Project', id: string, repo?: { __typename?: 'Repo', id: string, path: string, enabled: boolean, productionBranch?: string | null, deployTarget?: DeployTarget | null, deployType?: DeployType | null, deployService?: boolean | null, deployJob?: boolean | null, image?: string | null, cpu?: string | null, memory?: string | null, updatedAt: Date, disableReason?: DisableReason | null, databaseProvider?: DatabaseProviderType | null, databaseEngine?: DatabaseEngineType | null, name: string, productionDeployment?: { __typename?: 'Deployment', id: string, description?: string | null, version: string, status: DeploymentStatus, branch?: string | null, endpoints?: Array<string> | null, privateEndpoint?: string | null, errorMessage?: string | null, updatedAt: Date, createdAt: Date, deployStatus?: { __typename?: 'DeployStatus', active: boolean, replicas: number, publicIPs?: Array<string> | null, state: string, errorMessage?: string | null, troubleshooting?: { __typename?: 'Troubleshooting', issue?: { __typename?: 'TroubleshootingIssue', blocks?: Array<{ __typename?: 'TroubleshootingIssueBlock', blockType?: TroubleshootingIssueBlockType | null, content?: string | null }> | null } | null } | null } | null, build?: { __typename?: 'Build', id: string, image?: string | null } | null, alternativeImages?: Array<{ __typename?: 'AlternativeImage', reference?: string | null, tag?: string | null, name?: string | null }> | null } | null, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, projectID?: string | null } | null, gpu?: { __typename?: 'GPUSpec', type?: string | null, count: number } | null, tpu?: { __typename?: 'TPUSpec', tfVersion: string, type: string, cores: number } | null, cluster?: { __typename?: 'Cluster', id: string, name: string, domain?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null } | null, autoscaling?: { __typename?: 'Autoscaling', minReplicas: number, maxReplicas: number } | null, owner: { __typename?: 'User', id: string, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, owner: { __typename?: 'User', id: string, login: any } } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null } | null }> } | null, projectV3Adapters?: { __typename?: 'ProjectV3AdapterConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor: string, endCursor: string, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'ProjectV3Adapter', id: string, name: string, project?: { __typename?: 'Project', id: string, name: string } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null }> } | null, components?: Array<{ __typename?: 'ClusterComponent', name: string, type: ClusterComponentType, status: ClusterComponentEjectedStatus, isInstalledByZeet: boolean, exists: boolean, project?: { __typename?: 'ProjectV3Adapter', id: string, name: string, project?: { __typename?: 'Project', name: string } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', name: string } | null } | null, helmMetadata?: { __typename?: 'HelmClusterComponentMetadata', values: string, namespace: string, releaseName: string, chartRepoGuess?: string | null, chartVersion: string, chartName: string } | null, terraformMetadata?: { __typename?: 'TerraformClusterComponentMetadata', jobRunState?: JobRunState | null } | null } | null> | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null, cloudAccount?: { __typename?: 'AWSAccount', id: string } | { __typename?: 'AzureAccount', id: string } | { __typename?: 'CoreWeaveAccount', id: string } | { __typename?: 'DOAccount', id: string } | { __typename?: 'GCPAccount', id: string } | { __typename?: 'LinodeAccount', id: string } | { __typename?: 'VultrAccount', id: string } | null, containerRegistry?: { __typename?: 'ContainerRegistry', id: string, name: string, credentialProvider?: ContainerRegistryCredentialProvider | null, username?: string | null } | null };

export type ClusterListItemFragment = { __typename?: 'Cluster', id: string, ingressIP?: string | null, ingressDNS?: string | null, clusterProvider?: ClusterProvider | null, cloudProvider?: CloudProvider | null, name: string, region?: string | null, state: ClusterState, status?: ClusterStatus | null, connected?: boolean | null, domain?: string | null, isExternal?: boolean | null, isEjected?: boolean | null, updatedAt: Date, createdAt: Date, containerRepository?: string | null, containerCacheRepository?: string | null, projects?: { __typename?: 'ProjectConnection', pageInfo: { __typename?: 'PageInfo', startCursor: string, endCursor: string, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'Project', id: string, repo?: { __typename?: 'Repo', id: string, path: string, enabled: boolean, productionBranch?: string | null, deployTarget?: DeployTarget | null, deployType?: DeployType | null, deployService?: boolean | null, deployJob?: boolean | null, image?: string | null, cpu?: string | null, memory?: string | null, updatedAt: Date, disableReason?: DisableReason | null, databaseProvider?: DatabaseProviderType | null, databaseEngine?: DatabaseEngineType | null, name: string, productionDeployment?: { __typename?: 'Deployment', id: string, description?: string | null, version: string, status: DeploymentStatus, branch?: string | null, endpoints?: Array<string> | null, privateEndpoint?: string | null, errorMessage?: string | null, updatedAt: Date, createdAt: Date, deployStatus?: { __typename?: 'DeployStatus', active: boolean, replicas: number, publicIPs?: Array<string> | null, state: string, errorMessage?: string | null, troubleshooting?: { __typename?: 'Troubleshooting', issue?: { __typename?: 'TroubleshootingIssue', blocks?: Array<{ __typename?: 'TroubleshootingIssueBlock', blockType?: TroubleshootingIssueBlockType | null, content?: string | null }> | null } | null } | null } | null, build?: { __typename?: 'Build', id: string, image?: string | null } | null, alternativeImages?: Array<{ __typename?: 'AlternativeImage', reference?: string | null, tag?: string | null, name?: string | null }> | null } | null, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, projectID?: string | null } | null, gpu?: { __typename?: 'GPUSpec', type?: string | null, count: number } | null, tpu?: { __typename?: 'TPUSpec', tfVersion: string, type: string, cores: number } | null, cluster?: { __typename?: 'Cluster', id: string, name: string, domain?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null } | null, autoscaling?: { __typename?: 'Autoscaling', minReplicas: number, maxReplicas: number } | null, owner: { __typename?: 'User', id: string, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, owner: { __typename?: 'User', id: string, login: any } } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null } | null }> } | null, projectV3Adapters?: { __typename?: 'ProjectV3AdapterConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor: string, endCursor: string, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'ProjectV3Adapter', id: string, name: string, project?: { __typename?: 'Project', id: string, name: string } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null }> } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null, containerRegistry?: { __typename?: 'ContainerRegistry', id: string, name: string, credentialProvider?: ContainerRegistryCredentialProvider | null, username?: string | null } | null };

export type ClusterContainerRegistryFragment = { __typename?: 'Cluster', id: string, containerRepository?: string | null, containerCacheRepository?: string | null, containerRegistry?: { __typename?: 'ContainerRegistry', id: string, name: string, credentialProvider?: ContainerRegistryCredentialProvider | null, username?: string | null } | null };

export type ClusterDeployTargetFragment = { __typename?: 'Cluster', id: string, clusterProvider?: ClusterProvider | null, cloudProvider?: CloudProvider | null, name: string, region?: string | null, state: ClusterState, status?: ClusterStatus | null, connected?: boolean | null, domain?: string | null, isExternal?: boolean | null, isEjected?: boolean | null, updatedAt: Date, createdAt: Date, containerRepository?: string | null, containerCacheRepository?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null, cloudAccount?: { __typename?: 'AWSAccount', id: string } | { __typename?: 'AzureAccount', id: string } | { __typename?: 'CoreWeaveAccount', id: string } | { __typename?: 'DOAccount', id: string } | { __typename?: 'GCPAccount', id: string } | { __typename?: 'LinodeAccount', id: string } | { __typename?: 'VultrAccount', id: string } | null, containerRegistry?: { __typename?: 'ContainerRegistry', id: string, name: string, credentialProvider?: ContainerRegistryCredentialProvider | null, username?: string | null } | null };

export type ClusterCloudAccountIdsFragment = { __typename?: 'Cluster', cloudAccount?: { __typename?: 'AWSAccount', id: string } | { __typename?: 'AzureAccount', id: string } | { __typename?: 'CoreWeaveAccount', id: string } | { __typename?: 'DOAccount', id: string } | { __typename?: 'GCPAccount', id: string } | { __typename?: 'LinodeAccount', id: string } | { __typename?: 'VultrAccount', id: string } | null };

export type UserCloudDeployTargetsFragment = { __typename?: 'User', id: string, hasZeetCloud?: boolean | null, awsAccounts?: Array<{ __typename?: 'AWSAccount', id: string, name: string, state: AwsAccountState, accountID?: string | null, roleARN?: string | null, cloudFormationURL: string, connected?: boolean | null }> | null, gcpAccounts?: Array<{ __typename?: 'GCPAccount', id: string, name: string, state: GcpAccountState, projectID?: string | null, clientEmail?: string | null, connected?: boolean | null, error?: string | null }> | null, doAccounts?: Array<{ __typename?: 'DOAccount', id: string, name: string, state: DoAccountState, accessTokenPrefix?: string | null, defaultProject?: string | null, connected?: boolean | null }> | null, linodeAccounts?: Array<{ __typename?: 'LinodeAccount', id: string, name: string, state: CloudAccountState, accessTokenPrefix?: string | null, connected?: boolean | null }> | null, coreweaveAccounts?: Array<{ __typename?: 'CoreWeaveAccount', id: string, name: string, state: CloudAccountState, namespace?: string | null, connected?: boolean | null }> | null, azureAccounts?: Array<{ __typename?: 'AzureAccount', id: string, name: string, state: CloudAccountState, connected?: boolean | null, subscriptionID?: string | null, tenantID?: string | null, clientID?: string | null }> | null, vultrAccounts?: Array<{ __typename?: 'VultrAccount', id: string, name: string, state: CloudAccountState, connected?: boolean | null }> | null };

export type ClusterCloudNamesFragment = { __typename?: 'Cluster', id: string, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null };

export type ClusterNamesWithCloudNamesFragment = { __typename?: 'Cluster', id: string, name: string, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null };

export type ClusterCommonFragment = { __typename?: 'Cluster', id: string, name: string, region?: string | null, state: ClusterState, status?: ClusterStatus | null, connected?: boolean | null, domain?: string | null, isExternal?: boolean | null, isEjected?: boolean | null, clusterProvider?: ClusterProvider | null, cloudProvider?: CloudProvider | null, updatedAt: Date, createdAt: Date };

export type UserClustersQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UserClustersQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, clusters?: Array<{ __typename?: 'Cluster', id: string, ingressIP?: string | null, ingressDNS?: string | null, clusterProvider?: ClusterProvider | null, cloudProvider?: CloudProvider | null, name: string, region?: string | null, state: ClusterState, status?: ClusterStatus | null, connected?: boolean | null, domain?: string | null, isExternal?: boolean | null, isEjected?: boolean | null, updatedAt: Date, createdAt: Date, containerRepository?: string | null, containerCacheRepository?: string | null, projects?: { __typename?: 'ProjectConnection', pageInfo: { __typename?: 'PageInfo', startCursor: string, endCursor: string, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'Project', id: string, repo?: { __typename?: 'Repo', id: string, path: string, enabled: boolean, productionBranch?: string | null, deployTarget?: DeployTarget | null, deployType?: DeployType | null, deployService?: boolean | null, deployJob?: boolean | null, image?: string | null, cpu?: string | null, memory?: string | null, updatedAt: Date, disableReason?: DisableReason | null, databaseProvider?: DatabaseProviderType | null, databaseEngine?: DatabaseEngineType | null, name: string, productionDeployment?: { __typename?: 'Deployment', id: string, description?: string | null, version: string, status: DeploymentStatus, branch?: string | null, endpoints?: Array<string> | null, privateEndpoint?: string | null, errorMessage?: string | null, updatedAt: Date, createdAt: Date, deployStatus?: { __typename?: 'DeployStatus', active: boolean, replicas: number, publicIPs?: Array<string> | null, state: string, errorMessage?: string | null, troubleshooting?: { __typename?: 'Troubleshooting', issue?: { __typename?: 'TroubleshootingIssue', blocks?: Array<{ __typename?: 'TroubleshootingIssueBlock', blockType?: TroubleshootingIssueBlockType | null, content?: string | null }> | null } | null } | null } | null, build?: { __typename?: 'Build', id: string, image?: string | null } | null, alternativeImages?: Array<{ __typename?: 'AlternativeImage', reference?: string | null, tag?: string | null, name?: string | null }> | null } | null, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, projectID?: string | null } | null, gpu?: { __typename?: 'GPUSpec', type?: string | null, count: number } | null, tpu?: { __typename?: 'TPUSpec', tfVersion: string, type: string, cores: number } | null, cluster?: { __typename?: 'Cluster', id: string, name: string, domain?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null } | null, autoscaling?: { __typename?: 'Autoscaling', minReplicas: number, maxReplicas: number } | null, owner: { __typename?: 'User', id: string, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, owner: { __typename?: 'User', id: string, login: any } } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null } | null }> } | null, projectV3Adapters?: { __typename?: 'ProjectV3AdapterConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor: string, endCursor: string, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'ProjectV3Adapter', id: string, name: string, project?: { __typename?: 'Project', id: string, name: string } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null }> } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null, containerRegistry?: { __typename?: 'ContainerRegistry', id: string, name: string, credentialProvider?: ContainerRegistryCredentialProvider | null, username?: string | null } | null }> | null } };

export type UserDeployTargetsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UserDeployTargetsQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, hasZeetCloud?: boolean | null, defaultCluster?: { __typename?: 'Cluster', id: string, clusterProvider?: ClusterProvider | null, cloudProvider?: CloudProvider | null, name: string, region?: string | null, state: ClusterState, status?: ClusterStatus | null, connected?: boolean | null, domain?: string | null, isExternal?: boolean | null, isEjected?: boolean | null, updatedAt: Date, createdAt: Date, containerRepository?: string | null, containerCacheRepository?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null, cloudAccount?: { __typename?: 'AWSAccount', id: string } | { __typename?: 'AzureAccount', id: string } | { __typename?: 'CoreWeaveAccount', id: string } | { __typename?: 'DOAccount', id: string } | { __typename?: 'GCPAccount', id: string } | { __typename?: 'LinodeAccount', id: string } | { __typename?: 'VultrAccount', id: string } | null, containerRegistry?: { __typename?: 'ContainerRegistry', id: string, name: string, credentialProvider?: ContainerRegistryCredentialProvider | null, username?: string | null } | null } | null, clusters?: Array<{ __typename?: 'Cluster', id: string, clusterProvider?: ClusterProvider | null, cloudProvider?: CloudProvider | null, name: string, region?: string | null, state: ClusterState, status?: ClusterStatus | null, connected?: boolean | null, domain?: string | null, isExternal?: boolean | null, isEjected?: boolean | null, updatedAt: Date, createdAt: Date, containerRepository?: string | null, containerCacheRepository?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null, cloudAccount?: { __typename?: 'AWSAccount', id: string } | { __typename?: 'AzureAccount', id: string } | { __typename?: 'CoreWeaveAccount', id: string } | { __typename?: 'DOAccount', id: string } | { __typename?: 'GCPAccount', id: string } | { __typename?: 'LinodeAccount', id: string } | { __typename?: 'VultrAccount', id: string } | null, containerRegistry?: { __typename?: 'ContainerRegistry', id: string, name: string, credentialProvider?: ContainerRegistryCredentialProvider | null, username?: string | null } | null }> | null, awsAccounts?: Array<{ __typename?: 'AWSAccount', id: string, name: string, state: AwsAccountState, accountID?: string | null, roleARN?: string | null, cloudFormationURL: string, connected?: boolean | null }> | null, gcpAccounts?: Array<{ __typename?: 'GCPAccount', id: string, name: string, state: GcpAccountState, projectID?: string | null, clientEmail?: string | null, connected?: boolean | null, error?: string | null }> | null, doAccounts?: Array<{ __typename?: 'DOAccount', id: string, name: string, state: DoAccountState, accessTokenPrefix?: string | null, defaultProject?: string | null, connected?: boolean | null }> | null, linodeAccounts?: Array<{ __typename?: 'LinodeAccount', id: string, name: string, state: CloudAccountState, accessTokenPrefix?: string | null, connected?: boolean | null }> | null, coreweaveAccounts?: Array<{ __typename?: 'CoreWeaveAccount', id: string, name: string, state: CloudAccountState, namespace?: string | null, connected?: boolean | null }> | null, azureAccounts?: Array<{ __typename?: 'AzureAccount', id: string, name: string, state: CloudAccountState, connected?: boolean | null, subscriptionID?: string | null, tenantID?: string | null, clientID?: string | null }> | null, vultrAccounts?: Array<{ __typename?: 'VultrAccount', id: string, name: string, state: CloudAccountState, connected?: boolean | null }> | null } };

export type ClusterProvisionTargetsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ClusterProvisionTargetsQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, hasZeetCloud?: boolean | null, awsAccounts?: Array<{ __typename?: 'AWSAccount', id: string, name: string, state: AwsAccountState, accountID?: string | null, roleARN?: string | null, cloudFormationURL: string, connected?: boolean | null }> | null, gcpAccounts?: Array<{ __typename?: 'GCPAccount', id: string, name: string, state: GcpAccountState, projectID?: string | null, clientEmail?: string | null, connected?: boolean | null, error?: string | null }> | null, doAccounts?: Array<{ __typename?: 'DOAccount', id: string, name: string, state: DoAccountState, accessTokenPrefix?: string | null, defaultProject?: string | null, connected?: boolean | null }> | null, linodeAccounts?: Array<{ __typename?: 'LinodeAccount', id: string, name: string, state: CloudAccountState, accessTokenPrefix?: string | null, connected?: boolean | null }> | null, coreweaveAccounts?: Array<{ __typename?: 'CoreWeaveAccount', id: string, name: string, state: CloudAccountState, namespace?: string | null, connected?: boolean | null }> | null, azureAccounts?: Array<{ __typename?: 'AzureAccount', id: string, name: string, state: CloudAccountState, connected?: boolean | null, subscriptionID?: string | null, tenantID?: string | null, clientID?: string | null }> | null, vultrAccounts?: Array<{ __typename?: 'VultrAccount', id: string, name: string, state: CloudAccountState, connected?: boolean | null }> | null } };

export type ClusterKubeconfigQueryVariables = Exact<{
  userID: Scalars['ID'];
  clusterID: Scalars['UUID'];
}>;


export type ClusterKubeconfigQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, cluster?: { __typename?: 'Cluster', id: string, name: string, kubeconfig?: string | null } | null } };

export type ClusterCertIssuersQueryVariables = Exact<{
  userID: Scalars['ID'];
  repoID: Scalars['ID'];
  clusterID: Scalars['UUID'];
}>;


export type ClusterCertIssuersQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, cluster?: { __typename?: 'Cluster', id: string, name: string, clusterIssuers?: Array<string> | null } | null, repo?: { __typename?: 'Repo', id: string, name: string, clusterIssuerName?: string | null } | null } };

export type ClusterDomainQueryVariables = Exact<{
  userID: Scalars['ID'];
  clusterID: Scalars['UUID'];
}>;


export type ClusterDomainQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, cluster?: { __typename?: 'Cluster', id: string, domain?: string | null } | null } };

export type ClustersCustomDomainsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ClustersCustomDomainsQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, clusters?: Array<{ __typename?: 'Cluster', id: string, name: string, customDomains?: Array<{ __typename?: 'ClusterCustomDomain', id: string, customDomain?: { __typename?: 'CustomDomain', id: string, domain: string, syncDomain?: { __typename?: 'CustomDomain', id: string, domain: string } | null } | null, repo?: { __typename?: 'Repo', id: string, path: string, enabled: boolean, productionBranch?: string | null, deployTarget?: DeployTarget | null, deployType?: DeployType | null, deployService?: boolean | null, deployJob?: boolean | null, image?: string | null, cpu?: string | null, memory?: string | null, updatedAt: Date, disableReason?: DisableReason | null, databaseProvider?: DatabaseProviderType | null, databaseEngine?: DatabaseEngineType | null, name: string, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, projectID?: string | null } | null, gpu?: { __typename?: 'GPUSpec', type?: string | null, count: number } | null, tpu?: { __typename?: 'TPUSpec', tfVersion: string, type: string, cores: number } | null, cluster?: { __typename?: 'Cluster', id: string, name: string, domain?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null } | null, autoscaling?: { __typename?: 'Autoscaling', minReplicas: number, maxReplicas: number } | null, owner: { __typename?: 'User', id: string, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, owner: { __typename?: 'User', id: string, login: any } } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null } | null }> | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null }> | null } };

export type ClusterNameQueryVariables = Exact<{
  teamId: Scalars['ID'];
  clusterId: Scalars['UUID'];
}>;


export type ClusterNameQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, cluster?: { __typename?: 'Cluster', id: string, cloudProvider?: CloudProvider | null, name: string } | null } };

export type ClusterDetailsQueryVariables = Exact<{
  id: Scalars['ID'];
  clusterId: Scalars['UUID'];
}>;


export type ClusterDetailsQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, cluster?: { __typename?: 'Cluster', id: string, ingressIP?: string | null, ingressDNS?: string | null, clusterProvider?: ClusterProvider | null, cloudProvider?: CloudProvider | null, terraformProjectUrl?: string | null, containerRepository?: string | null, containerCacheRepository?: string | null, name: string, region?: string | null, state: ClusterState, status?: ClusterStatus | null, connected?: boolean | null, domain?: string | null, isExternal?: boolean | null, isEjected?: boolean | null, updatedAt: Date, createdAt: Date, prometheus?: { __typename?: 'Prometheus', url: string, user?: string | null, password?: string | null, token?: string | null } | null, grafana?: { __typename?: 'Grafana', url: string, user?: string | null, password?: string | null } | null, deployJob?: { __typename?: 'JobRun', id: string, state: JobRunState } | null, projects?: { __typename?: 'ProjectConnection', pageInfo: { __typename?: 'PageInfo', startCursor: string, endCursor: string, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'Project', id: string, repo?: { __typename?: 'Repo', id: string, path: string, enabled: boolean, productionBranch?: string | null, deployTarget?: DeployTarget | null, deployType?: DeployType | null, deployService?: boolean | null, deployJob?: boolean | null, image?: string | null, cpu?: string | null, memory?: string | null, updatedAt: Date, disableReason?: DisableReason | null, databaseProvider?: DatabaseProviderType | null, databaseEngine?: DatabaseEngineType | null, name: string, productionDeployment?: { __typename?: 'Deployment', id: string, description?: string | null, version: string, status: DeploymentStatus, branch?: string | null, endpoints?: Array<string> | null, privateEndpoint?: string | null, errorMessage?: string | null, updatedAt: Date, createdAt: Date, deployStatus?: { __typename?: 'DeployStatus', active: boolean, replicas: number, publicIPs?: Array<string> | null, state: string, errorMessage?: string | null, troubleshooting?: { __typename?: 'Troubleshooting', issue?: { __typename?: 'TroubleshootingIssue', blocks?: Array<{ __typename?: 'TroubleshootingIssueBlock', blockType?: TroubleshootingIssueBlockType | null, content?: string | null }> | null } | null } | null } | null, build?: { __typename?: 'Build', id: string, image?: string | null } | null, alternativeImages?: Array<{ __typename?: 'AlternativeImage', reference?: string | null, tag?: string | null, name?: string | null }> | null } | null, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, projectID?: string | null } | null, gpu?: { __typename?: 'GPUSpec', type?: string | null, count: number } | null, tpu?: { __typename?: 'TPUSpec', tfVersion: string, type: string, cores: number } | null, cluster?: { __typename?: 'Cluster', id: string, name: string, domain?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null } | null, autoscaling?: { __typename?: 'Autoscaling', minReplicas: number, maxReplicas: number } | null, owner: { __typename?: 'User', id: string, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, owner: { __typename?: 'User', id: string, login: any } } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null } | null }> } | null, projectV3Adapters?: { __typename?: 'ProjectV3AdapterConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor: string, endCursor: string, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'ProjectV3Adapter', id: string, name: string, project?: { __typename?: 'Project', id: string, name: string } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null }> } | null, components?: Array<{ __typename?: 'ClusterComponent', name: string, type: ClusterComponentType, status: ClusterComponentEjectedStatus, isInstalledByZeet: boolean, exists: boolean, project?: { __typename?: 'ProjectV3Adapter', id: string, name: string, project?: { __typename?: 'Project', name: string } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', name: string } | null } | null, helmMetadata?: { __typename?: 'HelmClusterComponentMetadata', values: string, namespace: string, releaseName: string, chartRepoGuess?: string | null, chartVersion: string, chartName: string } | null, terraformMetadata?: { __typename?: 'TerraformClusterComponentMetadata', jobRunState?: JobRunState | null } | null } | null> | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null, cloudAccount?: { __typename?: 'AWSAccount', id: string } | { __typename?: 'AzureAccount', id: string } | { __typename?: 'CoreWeaveAccount', id: string } | { __typename?: 'DOAccount', id: string } | { __typename?: 'GCPAccount', id: string } | { __typename?: 'LinodeAccount', id: string } | { __typename?: 'VultrAccount', id: string } | null, containerRegistry?: { __typename?: 'ContainerRegistry', id: string, name: string, credentialProvider?: ContainerRegistryCredentialProvider | null, username?: string | null } | null } | null, awsAccounts?: Array<{ __typename?: 'AWSAccount', id: string, updatedAt: Date, name: string, state: AwsAccountState, accountID?: string | null, roleARN?: string | null, cloudFormationURL: string, connected?: boolean | null, clusters?: Array<{ __typename?: 'Cluster', id: string, name: string }> | null, projectV3Adapters?: { __typename?: 'ProjectV3AdapterConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor: string, endCursor: string, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'ProjectV3Adapter', id: string, name: string, project?: { __typename?: 'Project', id: string, name: string } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null }> } | null }> | null, gcpAccounts?: Array<{ __typename?: 'GCPAccount', id: string, updatedAt: Date, name: string, state: GcpAccountState, projectID?: string | null, clientEmail?: string | null, connected?: boolean | null, error?: string | null, projectV3Adapters?: { __typename?: 'ProjectV3AdapterConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor: string, endCursor: string, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'ProjectV3Adapter', id: string, name: string, project?: { __typename?: 'Project', id: string, name: string } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null }> } | null, clusters?: Array<{ __typename?: 'Cluster', id: string, name: string }> | null }> | null, doAccounts?: Array<{ __typename?: 'DOAccount', id: string, updatedAt: Date, name: string, state: DoAccountState, accessTokenPrefix?: string | null, defaultProject?: string | null, connected?: boolean | null, projectV3Adapters?: { __typename?: 'ProjectV3AdapterConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor: string, endCursor: string, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'ProjectV3Adapter', id: string, name: string, project?: { __typename?: 'Project', id: string, name: string } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null }> } | null, clusters?: Array<{ __typename?: 'Cluster', id: string, name: string }> | null }> | null, coreweaveAccounts?: Array<{ __typename?: 'CoreWeaveAccount', id: string, updatedAt: Date, name: string, state: CloudAccountState, namespace?: string | null, connected?: boolean | null, clusters?: Array<{ __typename?: 'Cluster', id: string, name: string, projectV3Adapters?: { __typename?: 'ProjectV3AdapterConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor: string, endCursor: string, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'ProjectV3Adapter', id: string, name: string, project?: { __typename?: 'Project', id: string, name: string } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null }> } | null }> | null }> | null, linodeAccounts?: Array<{ __typename?: 'LinodeAccount', id: string, updatedAt: Date, name: string, state: CloudAccountState, accessTokenPrefix?: string | null, connected?: boolean | null, projectV3Adapters?: { __typename?: 'ProjectV3AdapterConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor: string, endCursor: string, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'ProjectV3Adapter', id: string, name: string, project?: { __typename?: 'Project', id: string, name: string } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null }> } | null, clusters?: Array<{ __typename?: 'Cluster', id: string, name: string }> | null }> | null, vultrAccounts?: Array<{ __typename?: 'VultrAccount', id: string, updatedAt: Date, name: string, state: CloudAccountState, connected?: boolean | null, clusters?: Array<{ __typename?: 'Cluster', id: string, name: string }> | null, projectV3Adapters?: { __typename?: 'ProjectV3AdapterConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor: string, endCursor: string, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'ProjectV3Adapter', id: string, name: string, project?: { __typename?: 'Project', id: string, name: string } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null }> } | null }> | null, azureAccounts?: Array<{ __typename?: 'AzureAccount', id: string, updatedAt: Date, name: string, state: CloudAccountState, connected?: boolean | null, subscriptionID?: string | null, tenantID?: string | null, clientID?: string | null, clusters?: Array<{ __typename?: 'Cluster', id: string, name: string }> | null, projectV3Adapters?: { __typename?: 'ProjectV3AdapterConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor: string, endCursor: string, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'ProjectV3Adapter', id: string, name: string, project?: { __typename?: 'Project', id: string, name: string } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null }> } | null }> | null, containerRegistries?: Array<{ __typename?: 'ContainerRegistry', id: string, name: string, registry: string, username?: string | null }> | null } };

export type ClusterCommonQueryVariables = Exact<{
  id: Scalars['ID'];
  clusterId: Scalars['UUID'];
}>;


export type ClusterCommonQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, cluster?: { __typename?: 'Cluster', id: string, name: string, region?: string | null, state: ClusterState, status?: ClusterStatus | null, connected?: boolean | null, domain?: string | null, isExternal?: boolean | null, isEjected?: boolean | null, clusterProvider?: ClusterProvider | null, cloudProvider?: CloudProvider | null, updatedAt: Date, createdAt: Date } | null } };

export type ClusterDeployLogsQueryVariables = Exact<{
  id: Scalars['ID'];
  clusterId: Scalars['UUID'];
}>;


export type ClusterDeployLogsQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, cluster?: { __typename?: 'Cluster', id: string, deployJob?: { __typename?: 'JobRun', id: string, logs?: { __typename?: 'Logs', id: string, cursor?: string | null, entries?: Array<{ __typename?: 'LogEntry', text: string, timestamp?: Date | null }> | null } | null } | null } | null } };

export type TerraformEjectionStatusQueryVariables = Exact<{
  id: Scalars['ID'];
  clusterId: Scalars['UUID'];
}>;


export type TerraformEjectionStatusQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, cluster?: { __typename?: 'Cluster', id: string, components?: Array<{ __typename?: 'ClusterComponent', type: ClusterComponentType, name: string, status: ClusterComponentEjectedStatus, terraformMetadata?: { __typename?: 'TerraformClusterComponentMetadata', jobRunState?: JobRunState | null } | null } | null> | null } | null } };

export type ValidateCloudForClusterCreationQueryVariables = Exact<{
  userId: Scalars['ID'];
  context: ClusterValidationInput;
}>;


export type ValidateCloudForClusterCreationQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, validateCloud: { __typename?: 'ClusterValidation', errors?: Array<{ __typename?: 'ClusterValidationError', docs: string, fixable: boolean, message: string, type: ClusterValidationErrorType }> | null } } };

export type MonthlyCostForServicesQueryVariables = Exact<{
  awsAccountId: Scalars['UUID'];
  services: Array<Scalars['String']> | Scalars['String'];
}>;


export type MonthlyCostForServicesQuery = { __typename?: 'Query', withoutCredit: Array<{ __typename?: 'Cost', service?: string | null, unblendedCostAmount?: number | null, unblendedCostUnit?: string | null, periodStart?: string | null, periodEnd?: string | null }>, withCredit: Array<{ __typename?: 'Cost', service?: string | null, unblendedCostAmount?: number | null, unblendedCostUnit?: string | null, periodStart?: string | null, periodEnd?: string | null }> };

export type UserDeploymentQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UserDeploymentQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, deployment?: { __typename?: 'Deployment', id: string, branch?: string | null, createdAt: Date, updatedAt: Date, description?: string | null, version: string, status: DeploymentStatus, endpoints?: Array<string> | null, privateEndpoint?: string | null, errorMessage?: string | null, buildStage?: { __typename?: 'BuildStage', id: string } | null, releaseStage?: { __typename?: 'PipelineStage', id: string } | null, deployStage?: { __typename?: 'PipelineStage', id: string } | null, repo?: { __typename?: 'Repo', id: string, path: string, enabled: boolean, productionBranch?: string | null, deployTarget?: DeployTarget | null, deployType?: DeployType | null, deployService?: boolean | null, deployJob?: boolean | null, image?: string | null, cpu?: string | null, memory?: string | null, updatedAt: Date, disableReason?: DisableReason | null, databaseProvider?: DatabaseProviderType | null, databaseEngine?: DatabaseEngineType | null, name: string, ports?: Array<{ __typename?: 'Port', https: boolean, public: boolean }> | null, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, projectID?: string | null } | null, gpu?: { __typename?: 'GPUSpec', type?: string | null, count: number } | null, tpu?: { __typename?: 'TPUSpec', tfVersion: string, type: string, cores: number } | null, cluster?: { __typename?: 'Cluster', id: string, name: string, domain?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null } | null, autoscaling?: { __typename?: 'Autoscaling', minReplicas: number, maxReplicas: number } | null, owner: { __typename?: 'User', id: string, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, owner: { __typename?: 'User', id: string, login: any } } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null } | null, awsLinks?: { __typename?: 'AWSLinks', rds?: string | null, cloudformation?: string | null, lambda?: string | null, apiGateway?: string | null, cloudwatchLogs?: string | null, cloudwatchMetrics?: string | null } | null, gcpLinks?: { __typename?: 'GCPLinks', deploymentManager?: string | null, cloudRun?: string | null, cloudFunctions?: string | null, cloudFunctionsTrigger?: string | null, cloudLogging?: string | null, cloudMonitoring?: string | null } | null, deploymentError?: { __typename?: 'DeploymentError', errorID?: string | null, errorCode?: string | null, message: string } | null, deployStatus?: { __typename?: 'DeployStatus', active: boolean, replicas: number, publicIPs?: Array<string> | null, state: string, errorMessage?: string | null, troubleshooting?: { __typename?: 'Troubleshooting', issue?: { __typename?: 'TroubleshootingIssue', blocks?: Array<{ __typename?: 'TroubleshootingIssueBlock', blockType?: TroubleshootingIssueBlockType | null, content?: string | null }> | null } | null } | null } | null, build?: { __typename?: 'Build', id: string, image?: string | null } | null, alternativeImages?: Array<{ __typename?: 'AlternativeImage', reference?: string | null, tag?: string | null, name?: string | null }> | null } | null } };

export type UserDeploymentMetricQueryVariables = Exact<{
  deploymentID: Scalars['ID'];
  deploymentUUID: Scalars['UUID'];
  queryOptions?: InputMaybe<MetricQueryOptions>;
}>;


export type UserDeploymentMetricQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, deployment?: { __typename?: 'Deployment', id: string, cpuMetrics?: Array<{ __typename?: 'MetricStream', type?: MetricType | null, query: string, annotations?: Array<{ __typename?: 'MetricAnnotation', type: MetricAnnotationType, direction: MetricAnnotationDirection, function?: MetricAnnotationFunction | null, label?: string | null, value?: number | null }> | null, labels?: Array<{ __typename?: 'MetricStreamLabel', label: MetricLabelType, value: string }> | null, entries?: Array<{ __typename?: 'MetricEntry', value?: number | null, timestamp: Date }> | null }> | null, memoryMetrics?: Array<{ __typename?: 'MetricStream', type?: MetricType | null, query: string, annotations?: Array<{ __typename?: 'MetricAnnotation', type: MetricAnnotationType, direction: MetricAnnotationDirection, function?: MetricAnnotationFunction | null, label?: string | null, value?: number | null }> | null, labels?: Array<{ __typename?: 'MetricStreamLabel', label: MetricLabelType, value: string }> | null, entries?: Array<{ __typename?: 'MetricEntry', value?: number | null, timestamp: Date }> | null }> | null, networkMetrics?: Array<{ __typename?: 'MetricStream', type?: MetricType | null, query: string, annotations?: Array<{ __typename?: 'MetricAnnotation', type: MetricAnnotationType, direction: MetricAnnotationDirection, function?: MetricAnnotationFunction | null, label?: string | null, value?: number | null }> | null, labels?: Array<{ __typename?: 'MetricStreamLabel', label: MetricLabelType, value: string }> | null, entries?: Array<{ __typename?: 'MetricEntry', value?: number | null, timestamp: Date }> | null }> | null, diskMetrics?: Array<{ __typename?: 'MetricStream', type?: MetricType | null, query: string, annotations?: Array<{ __typename?: 'MetricAnnotation', type: MetricAnnotationType, direction: MetricAnnotationDirection, function?: MetricAnnotationFunction | null, label?: string | null, value?: number | null }> | null, labels?: Array<{ __typename?: 'MetricStreamLabel', label: MetricLabelType, value: string }> | null, entries?: Array<{ __typename?: 'MetricEntry', value?: number | null, timestamp: Date }> | null }> | null } | null } };

export type UserEphemeralContainersQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UserEphemeralContainersQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, deployment?: { __typename?: 'Deployment', id: string, ephemeralContainers?: Array<{ __typename?: 'EphemeralContainer', name: string, image: string, ready: boolean } | null> | null } | null } };

export type DeploymentBuildLogsFragment = { __typename?: 'Deployment', deploymentError?: { __typename?: 'DeploymentError', errorID?: string | null, errorCode?: string | null, message: string } | null, build?: { __typename?: 'Build', id: string, errorMessage?: string | null, logs?: { __typename?: 'Logs', id: string, completed: boolean, expired: boolean, entries?: Array<{ __typename?: 'LogEntry', timestamp?: Date | null, text: string }> | null } | null } | null };

export type DeploymentBuildLogsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeploymentBuildLogsQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, deployment?: { __typename?: 'Deployment', id: string, deploymentError?: { __typename?: 'DeploymentError', errorID?: string | null, errorCode?: string | null, message: string } | null, build?: { __typename?: 'Build', id: string, errorMessage?: string | null, logs?: { __typename?: 'Logs', id: string, completed: boolean, expired: boolean, entries?: Array<{ __typename?: 'LogEntry', timestamp?: Date | null, text: string }> | null } | null } | null } | null } };

export type DeploymentReleaseLogsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeploymentReleaseLogsQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, deployment?: { __typename?: 'Deployment', id: string, releaseStage?: { __typename?: 'PipelineStage', id: string, logs?: { __typename?: 'Logs', id: string, completed: boolean, expired: boolean, entries?: Array<{ __typename?: 'LogEntry', timestamp?: Date | null, text: string }> | null } | null } | null } | null } };

export type DeploymentDeployLogsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeploymentDeployLogsQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, deployment?: { __typename?: 'Deployment', id: string, deployStage?: { __typename?: 'PipelineStage', id: string, logs?: { __typename?: 'Logs', id: string, completed: boolean, expired: boolean, entries?: Array<{ __typename?: 'LogEntry', timestamp?: Date | null, text: string }> | null } | null } | null } | null } };

export type DeploymentLogsQueryVariables = Exact<{
  repoID: Scalars['ID'];
  deploymentID: Scalars['ID'];
}>;


export type DeploymentLogsQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, repo?: { __typename?: 'Repo', id: string, deployment?: { __typename?: 'Deployment', id: string, logs?: Array<{ __typename?: 'LogEntry', timestamp?: Date | null, text: string }> | null, logsV2?: { __typename?: 'ComplexLogs', previous?: Array<{ __typename?: 'LogEntry', timestamp?: Date | null, text: string }> | null, current?: Array<{ __typename?: 'LogEntry', timestamp?: Date | null, text: string }> | null } | null, awsLinks?: { __typename?: 'AWSLinks', cloudwatchLogs?: string | null } | null, gcpLinks?: { __typename?: 'GCPLinks', cloudLogging?: string | null } | null } | null } | null } };

export type BuildTemplatesQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type BuildTemplatesQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, deployment?: { __typename?: 'Deployment', id: string, buildStage?: { __typename?: 'BuildStage', id: string, buildTemplates?: Array<{ __typename?: 'BuildTemplate', type: BuildTemplateType, output?: string | null }> | null } | null } | null } };

export type DeployTemplatesQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeployTemplatesQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, deployment?: { __typename?: 'Deployment', id: string, deployTemplates?: Array<{ __typename?: 'DeployTemplate', output?: string | null, type: DeployTemplateType } | null> | null } | null } };

export type BuildTemplatesExistQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type BuildTemplatesExistQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, deployment?: { __typename?: 'Deployment', id: string, buildStage?: { __typename?: 'BuildStage', id: string, buildTemplates?: Array<{ __typename?: 'BuildTemplate', type: BuildTemplateType }> | null } | null } | null } };

export type DeployTemplatesExistQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeployTemplatesExistQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, deployment?: { __typename?: 'Deployment', id: string, deployTemplates?: Array<{ __typename?: 'DeployTemplate', type: DeployTemplateType } | null> | null } | null } };

export type DeploymentAlertQueryVariables = Exact<{
  deploymentId: Scalars['ID'];
  alertId: Scalars['UUID'];
}>;


export type DeploymentAlertQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, deployment?: { __typename?: 'Deployment', id: string, alert?: { __typename?: 'DeploymentPodCrashAlert', id: string, namespace?: string | null, podName?: string | null, createdAt: Date, resolvedAt?: Date | null, previousPodLogs?: { __typename?: 'Logs', entries?: Array<{ __typename?: 'LogEntry', text: string }> | null } | null } | null } | null } };

export type DeploymentAlertDetailFragment = { __typename?: 'DeploymentPodCrashAlert', id: string, namespace?: string | null, podName?: string | null, createdAt: Date, resolvedAt?: Date | null, previousPodLogs?: { __typename?: 'Logs', entries?: Array<{ __typename?: 'LogEntry', text: string }> | null } | null };

export type DeploymentAlertsQueryVariables = Exact<{
  deploymentID: Scalars['ID'];
  page?: InputMaybe<PageInput>;
}>;


export type DeploymentAlertsQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, deployment?: { __typename?: 'Deployment', id: string, alerts?: { __typename?: 'DeploymentAlertConnection', pageInfo: { __typename?: 'PageInfo', startCursor: string, endCursor: string, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'DeploymentPodCrashAlert', id: string, namespace?: string | null, podName?: string | null, createdAt: Date, resolvedAt?: Date | null, previousPodLogs?: { __typename?: 'Logs', entries?: Array<{ __typename?: 'LogEntry', text: string }> | null } | null }> } | null } | null } };

export type DockerInfoQueryVariables = Exact<{
  image: Scalars['String'];
}>;


export type DockerInfoQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, dockerRepository?: { __typename?: 'DockerRepository', id: string, name: string, url: string, ports?: Array<{ __typename?: 'Port', port: string, protocol: string, public: boolean, https: boolean }> | null, volumes?: Array<{ __typename?: 'VolumeSpec', mountPath: string, size: number }> | null } | null } };

export type LoggedOutDockerInfoQueryVariables = Exact<{
  image: Scalars['String'];
}>;


export type LoggedOutDockerInfoQuery = { __typename?: 'Query', dockerRepository?: { __typename?: 'DockerRepository', id: string, name: string, url: string, ports?: Array<{ __typename?: 'Port', port: string, protocol: string, public: boolean, https: boolean }> | null, volumes?: Array<{ __typename?: 'VolumeSpec', mountPath: string, size: number }> | null } | null };

export type DockerRepositoryPortsQueryVariables = Exact<{
  image: Scalars['String'];
}>;


export type DockerRepositoryPortsQuery = { __typename?: 'Query', dockerRepository?: { __typename?: 'DockerRepository', id: string, ports?: Array<{ __typename?: 'Port', port: string, protocol: string, public: boolean, https: boolean }> | null } | null };

export type UserGithubReposQueryVariables = Exact<{ [key: string]: never; }>;


export type UserGithubReposQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, login: any, avatar?: string | null, githubInstallations?: Array<{ __typename?: 'GitHubInstallation', id: string, targetType: string, repositorySelection: string, account: { __typename?: 'GitHubUser', id: string, login: string, avatar?: string | null, type: GithubUserType }, repositories?: Array<{ __typename?: 'GitHubRepository', id: string, name: string, owner: string, url: string, description?: string | null, isFork: boolean, isPrivate: boolean, primaryLanguage?: string | null, updatedAt: Date }> | null }> | null } };

export type TeamGithubReposQueryVariables = Exact<{
  path: Scalars['String'];
}>;


export type TeamGithubReposQuery = { __typename?: 'Query', team?: { __typename?: 'Team', id: string, user: { __typename?: 'User', id: string, githubInstallations?: Array<{ __typename?: 'GitHubInstallation', id: string, targetType: string, repositorySelection: string, account: { __typename?: 'GitHubUser', id: string, login: string, avatar?: string | null, type: GithubUserType }, repositories?: Array<{ __typename?: 'GitHubRepository', id: string, name: string, owner: string, url: string, description?: string | null, isFork: boolean, isPrivate: boolean, primaryLanguage?: string | null, updatedAt: Date }> | null }> | null } } | null };

export type UserGithubOrgsQueryVariables = Exact<{ [key: string]: never; }>;


export type UserGithubOrgsQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, githubInstallations?: Array<{ __typename?: 'GitHubInstallation', id: string, account: { __typename?: 'GitHubUser', id: string, login: string, avatar?: string | null, type: GithubUserType } }> | null } };

export type GithubDetailFragment = { __typename?: 'GitHubRepository', defaultBranch?: { __typename?: 'GitBranch', id: string, name: string } | null, ports?: Array<{ __typename?: 'Port', port: string, protocol: string, https: boolean, public: boolean }> | null, volumes?: Array<{ __typename?: 'VolumeSpec', mountPath: string, size: number }> | null, buildMethodSuggestions?: Array<{ __typename?: 'BuildMethod', name: string, type: BuildType, dockerfilePath?: string | null, buildCommand?: string | null, staticPath?: string | null, runCommand?: string | null }> | null };

export type UserGithubRepoQueryVariables = Exact<{
  installationId: Scalars['ID'];
  owner: Scalars['String'];
  repo: Scalars['String'];
}>;


export type UserGithubRepoQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, githubRepository?: { __typename?: 'GitHubRepository', id: string, name: string, owner: string, url: string, description?: string | null, isFork: boolean, isPrivate: boolean, primaryLanguage?: string | null, updatedAt: Date, defaultBranch?: { __typename?: 'GitBranch', id: string, name: string } | null, ports?: Array<{ __typename?: 'Port', port: string, protocol: string, https: boolean, public: boolean }> | null, volumes?: Array<{ __typename?: 'VolumeSpec', mountPath: string, size: number }> | null, buildMethodSuggestions?: Array<{ __typename?: 'BuildMethod', name: string, type: BuildType, dockerfilePath?: string | null, buildCommand?: string | null, staticPath?: string | null, runCommand?: string | null }> | null } | null } };

export type RepoBuildSuggestionQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RepoBuildSuggestionQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, repo?: { __typename?: 'Repo', id: string, buildMethodSuggestions?: Array<{ __typename?: 'BuildMethod', name: string, type: BuildType, dockerfilePath?: string | null, buildCommand?: string | null, staticPath?: string | null, runCommand?: string | null }> | null } | null } };

export type GithubRepoPortQueryVariables = Exact<{
  installationId: Scalars['ID'];
  owner: Scalars['String'];
  repo: Scalars['String'];
}>;


export type GithubRepoPortQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, githubRepository?: { __typename?: 'GitHubRepository', id: string, ports?: Array<{ __typename?: 'Port', https: boolean, port: string, protocol: string, public: boolean }> | null } | null } };

export type UserGithubRepoServerlessQueryVariables = Exact<{
  installationId: Scalars['ID'];
  owner: Scalars['String'];
  repo: Scalars['String'];
}>;


export type UserGithubRepoServerlessQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, githubRepository?: { __typename?: 'GitHubRepository', id: string, name: string, owner: string, url: string, description?: string | null, isFork: boolean, isPrivate: boolean, primaryLanguage?: string | null, updatedAt: Date, serverless?: { __typename?: 'ServerlessConfig', service?: string | null, provider?: { __typename?: 'ServerlessProvider', name?: string | null, region?: string | null, runtime?: string | null, stackName?: string | null, stage?: string | null } | null, functions?: Array<{ __typename?: 'ServerlessFunction', name: string, handler?: string | null }> | null } | null, defaultBranch?: { __typename?: 'GitBranch', id: string, name: string } | null, ports?: Array<{ __typename?: 'Port', port: string, protocol: string, https: boolean, public: boolean }> | null, volumes?: Array<{ __typename?: 'VolumeSpec', mountPath: string, size: number }> | null, buildMethodSuggestions?: Array<{ __typename?: 'BuildMethod', name: string, type: BuildType, dockerfilePath?: string | null, buildCommand?: string | null, staticPath?: string | null, runCommand?: string | null }> | null } | null } };

export type HelmCommonFragment = { __typename?: 'HelmChart', id: string, name?: string | null, description?: string | null, logoImage?: string | null, version?: string | null, app_version?: string | null, repository: { __typename?: 'HelmRepository', id: string, name?: string | null, url?: string | null } };

export type HelmChartQueryVariables = Exact<{
  url: Scalars['String'];
  name: Scalars['String'];
}>;


export type HelmChartQuery = { __typename?: 'Query', helmRepository: { __typename?: 'HelmRepository', id: string, chart: { __typename?: 'HelmChart', id: string, name?: string | null, description?: string | null, logoImage?: string | null, version?: string | null, app_version?: string | null, repository: { __typename?: 'HelmRepository', id: string, name?: string | null, url?: string | null } } } };

export type ProjectHelmChartQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ProjectHelmChartQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, repo?: { __typename?: 'Repo', id: string, helmChart?: { __typename?: 'HelmChart', id: string, name?: string | null, description?: string | null, logoImage?: string | null, version?: string | null, app_version?: string | null, repository: { __typename?: 'HelmRepository', id: string, name?: string | null, url?: string | null } } | null } | null } };

export type SearchHelmChartsQueryVariables = Exact<{
  input: SearchHelmChartsInput;
}>;


export type SearchHelmChartsQuery = { __typename?: 'Query', searchHelmCharts: { __typename?: 'HelmChartConnection', totalCount: number, nodes: Array<{ __typename?: 'HelmChart', id: string, name?: string | null, description?: string | null, logoImage?: string | null, version?: string | null, app_version?: string | null, repository: { __typename?: 'HelmRepository', id: string, name?: string | null, url?: string | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean } } };

export type InsightsAlertsMetricQueryVariables = Exact<{
  teamId: Scalars['ID'];
}>;


export type InsightsAlertsMetricQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, projectV3Adapters?: { __typename?: 'ProjectV3AdapterConnection', nodes: Array<{ __typename?: 'ProjectV3Adapter', id: string, name: string, updatedAt: Date, project?: { __typename?: 'Project', id: string, name: string } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null, repo?: { __typename?: 'Repo', id: string, name: string, image?: string | null, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType }, productionDeployment?: { __typename?: 'Deployment', id: string, alerts?: { __typename?: 'DeploymentAlertConnection', nodes: Array<{ __typename?: 'DeploymentPodCrashAlert', id: string, namespace?: string | null, podName?: string | null, createdAt: Date, resolvedAt?: Date | null, previousPodLogs?: { __typename?: 'Logs', entries?: Array<{ __typename?: 'LogEntry', text: string }> | null } | null }> } | null } | null } | null }> } | null, integrations?: Array<{ __typename?: 'BitbucketIntegration', id: string, type: IntegrationType } | { __typename?: 'DatadogIntegration', id: string, type: IntegrationType } | { __typename?: 'DiscordIntegration', id: string, type: IntegrationType } | { __typename?: 'DiscordWebhookIntegration', id: string, type: IntegrationType } | { __typename?: 'EmailIntegration', id: string, type: IntegrationType } | { __typename?: 'GithubIntegration', id: string, type: IntegrationType } | { __typename?: 'GitlabIntegration', id: string, type: IntegrationType } | { __typename?: 'SlackIntegration', id: string, type: IntegrationType } | { __typename?: 'SlackWebhookIntegration', id: string, type: IntegrationType }> | null } };

export type InsightClusterFragment = { __typename?: 'Cluster', id: string, name: string, status?: ClusterStatus | null, connected?: boolean | null, cloudProvider?: CloudProvider | null };

export type InsightsClustersQueryVariables = Exact<{
  teamId: Scalars['ID'];
}>;


export type InsightsClustersQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, clusters?: Array<{ __typename?: 'Cluster', id: string, name: string, status?: ClusterStatus | null, connected?: boolean | null, cloudProvider?: CloudProvider | null }> | null } };

export type InsightsCloudsQueryVariables = Exact<{
  teamId: Scalars['ID'];
}>;


export type InsightsCloudsQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, awsAccounts?: Array<{ __typename?: 'AWSAccount', id: string, name: string, state: AwsAccountState, connected?: boolean | null }> | null, doAccounts?: Array<{ __typename?: 'DOAccount', id: string, name: string, state: DoAccountState, connected?: boolean | null }> | null, gcpAccounts?: Array<{ __typename?: 'GCPAccount', id: string, name: string, state: GcpAccountState, connected?: boolean | null }> | null, linodeAccounts?: Array<{ __typename?: 'LinodeAccount', id: string, name: string, state: CloudAccountState, connected?: boolean | null }> | null, coreweaveAccounts?: Array<{ __typename?: 'CoreWeaveAccount', id: string, name: string, state: CloudAccountState, connected?: boolean | null }> | null, vultrAccounts?: Array<{ __typename?: 'VultrAccount', id: string, name: string, state: CloudAccountState, connected?: boolean | null }> | null, azureAccounts?: Array<{ __typename?: 'AzureAccount', id: string, name: string, state: CloudAccountState, connected?: boolean | null }> | null } };

type IntegrationCommon_BitbucketIntegration_Fragment = { __typename?: 'BitbucketIntegration', id: string, type: IntegrationType, name: string, description: string, image: string, createdAt: Date, updatedAt: Date };

type IntegrationCommon_DatadogIntegration_Fragment = { __typename?: 'DatadogIntegration', id: string, type: IntegrationType, name: string, description: string, image: string, createdAt: Date, updatedAt: Date };

type IntegrationCommon_DiscordIntegration_Fragment = { __typename?: 'DiscordIntegration', id: string, type: IntegrationType, name: string, description: string, image: string, createdAt: Date, updatedAt: Date };

type IntegrationCommon_DiscordWebhookIntegration_Fragment = { __typename?: 'DiscordWebhookIntegration', id: string, type: IntegrationType, name: string, description: string, image: string, createdAt: Date, updatedAt: Date };

type IntegrationCommon_EmailIntegration_Fragment = { __typename?: 'EmailIntegration', id: string, type: IntegrationType, name: string, description: string, image: string, createdAt: Date, updatedAt: Date };

type IntegrationCommon_GithubIntegration_Fragment = { __typename?: 'GithubIntegration', id: string, type: IntegrationType, name: string, description: string, image: string, createdAt: Date, updatedAt: Date };

type IntegrationCommon_GitlabIntegration_Fragment = { __typename?: 'GitlabIntegration', id: string, type: IntegrationType, name: string, description: string, image: string, createdAt: Date, updatedAt: Date };

type IntegrationCommon_SlackIntegration_Fragment = { __typename?: 'SlackIntegration', id: string, type: IntegrationType, name: string, description: string, image: string, createdAt: Date, updatedAt: Date };

type IntegrationCommon_SlackWebhookIntegration_Fragment = { __typename?: 'SlackWebhookIntegration', id: string, type: IntegrationType, name: string, description: string, image: string, createdAt: Date, updatedAt: Date };

export type IntegrationCommonFragment = IntegrationCommon_BitbucketIntegration_Fragment | IntegrationCommon_DatadogIntegration_Fragment | IntegrationCommon_DiscordIntegration_Fragment | IntegrationCommon_DiscordWebhookIntegration_Fragment | IntegrationCommon_EmailIntegration_Fragment | IntegrationCommon_GithubIntegration_Fragment | IntegrationCommon_GitlabIntegration_Fragment | IntegrationCommon_SlackIntegration_Fragment | IntegrationCommon_SlackWebhookIntegration_Fragment;

type NotificationIntegrationCommon_DiscordWebhookIntegration_Fragment = { __typename?: 'DiscordWebhookIntegration', notificationSettings?: { __typename?: 'NotificationIntegrationSettings', build?: boolean | null, deploy?: boolean | null, podCrash?: boolean | null, conditions?: { __typename?: 'NotificationCondition', key?: NotificationConditionKey | null, operator?: NotificationConditionOperator | null, value?: any | null } | { __typename?: 'NotificationConditionGroup' } | null } | null };

type NotificationIntegrationCommon_EmailIntegration_Fragment = { __typename?: 'EmailIntegration', notificationSettings?: { __typename?: 'NotificationIntegrationSettings', build?: boolean | null, deploy?: boolean | null, podCrash?: boolean | null, conditions?: { __typename?: 'NotificationCondition', key?: NotificationConditionKey | null, operator?: NotificationConditionOperator | null, value?: any | null } | { __typename?: 'NotificationConditionGroup' } | null } | null };

type NotificationIntegrationCommon_SlackWebhookIntegration_Fragment = { __typename?: 'SlackWebhookIntegration', notificationSettings?: { __typename?: 'NotificationIntegrationSettings', build?: boolean | null, deploy?: boolean | null, podCrash?: boolean | null, conditions?: { __typename?: 'NotificationCondition', key?: NotificationConditionKey | null, operator?: NotificationConditionOperator | null, value?: any | null } | { __typename?: 'NotificationConditionGroup' } | null } | null };

export type NotificationIntegrationCommonFragment = NotificationIntegrationCommon_DiscordWebhookIntegration_Fragment | NotificationIntegrationCommon_EmailIntegration_Fragment | NotificationIntegrationCommon_SlackWebhookIntegration_Fragment;

type IntegrationDetail_BitbucketIntegration_Fragment = { __typename?: 'BitbucketIntegration', webhookUrl: string, webhookToken: string, authType: BitbucketIntegrationAuthType, id: string, type: IntegrationType, name: string, description: string, image: string, createdAt: Date, updatedAt: Date, account?: { __typename?: 'BitbucketAccount', username: string } | null };

type IntegrationDetail_DatadogIntegration_Fragment = { __typename?: 'DatadogIntegration', apiKey?: string | null, id: string, type: IntegrationType, name: string, description: string, image: string, createdAt: Date, updatedAt: Date };

type IntegrationDetail_DiscordIntegration_Fragment = { __typename?: 'DiscordIntegration', id: string, type: IntegrationType, name: string, description: string, image: string, createdAt: Date, updatedAt: Date };

type IntegrationDetail_DiscordWebhookIntegration_Fragment = { __typename?: 'DiscordWebhookIntegration', url?: string | null, id: string, type: IntegrationType, name: string, description: string, image: string, createdAt: Date, updatedAt: Date, notificationSettings?: { __typename?: 'NotificationIntegrationSettings', build?: boolean | null, deploy?: boolean | null, podCrash?: boolean | null, conditions?: { __typename?: 'NotificationCondition', key?: NotificationConditionKey | null, operator?: NotificationConditionOperator | null, value?: any | null } | { __typename?: 'NotificationConditionGroup' } | null } | null };

type IntegrationDetail_EmailIntegration_Fragment = { __typename?: 'EmailIntegration', emailAddress: string, activated?: boolean | null, id: string, type: IntegrationType, name: string, description: string, image: string, createdAt: Date, updatedAt: Date, notificationSettings?: { __typename?: 'NotificationIntegrationSettings', build?: boolean | null, deploy?: boolean | null, podCrash?: boolean | null, conditions?: { __typename?: 'NotificationCondition', key?: NotificationConditionKey | null, operator?: NotificationConditionOperator | null, value?: any | null } | { __typename?: 'NotificationConditionGroup' } | null } | null };

type IntegrationDetail_GithubIntegration_Fragment = { __typename?: 'GithubIntegration', login: string, appID: number, installationID: number, targetType: string, id: string, type: IntegrationType, name: string, description: string, image: string, createdAt: Date, updatedAt: Date };

type IntegrationDetail_GitlabIntegration_Fragment = { __typename?: 'GitlabIntegration', accessTokenPrefix?: string | null, webhookUrl: string, webhookToken: string, id: string, type: IntegrationType, name: string, description: string, image: string, createdAt: Date, updatedAt: Date };

type IntegrationDetail_SlackIntegration_Fragment = { __typename?: 'SlackIntegration', id: string, type: IntegrationType, name: string, description: string, image: string, createdAt: Date, updatedAt: Date };

type IntegrationDetail_SlackWebhookIntegration_Fragment = { __typename?: 'SlackWebhookIntegration', url?: string | null, id: string, type: IntegrationType, name: string, description: string, image: string, createdAt: Date, updatedAt: Date, notificationSettings?: { __typename?: 'NotificationIntegrationSettings', build?: boolean | null, deploy?: boolean | null, podCrash?: boolean | null, conditions?: { __typename?: 'NotificationCondition', key?: NotificationConditionKey | null, operator?: NotificationConditionOperator | null, value?: any | null } | { __typename?: 'NotificationConditionGroup' } | null } | null };

export type IntegrationDetailFragment = IntegrationDetail_BitbucketIntegration_Fragment | IntegrationDetail_DatadogIntegration_Fragment | IntegrationDetail_DiscordIntegration_Fragment | IntegrationDetail_DiscordWebhookIntegration_Fragment | IntegrationDetail_EmailIntegration_Fragment | IntegrationDetail_GithubIntegration_Fragment | IntegrationDetail_GitlabIntegration_Fragment | IntegrationDetail_SlackIntegration_Fragment | IntegrationDetail_SlackWebhookIntegration_Fragment;

export type UserIntegrationsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UserIntegrationsQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, integrations?: Array<{ __typename?: 'BitbucketIntegration', id: string, webhookUrl: string, webhookToken: string, authType: BitbucketIntegrationAuthType, type: IntegrationType, name: string, description: string, image: string, createdAt: Date, updatedAt: Date, account?: { __typename?: 'BitbucketAccount', username: string } | null } | { __typename?: 'DatadogIntegration', id: string, apiKey?: string | null, type: IntegrationType, name: string, description: string, image: string, createdAt: Date, updatedAt: Date } | { __typename?: 'DiscordIntegration', id: string, type: IntegrationType, name: string, description: string, image: string, createdAt: Date, updatedAt: Date } | { __typename?: 'DiscordWebhookIntegration', id: string, url?: string | null, type: IntegrationType, name: string, description: string, image: string, createdAt: Date, updatedAt: Date, notificationSettings?: { __typename?: 'NotificationIntegrationSettings', build?: boolean | null, deploy?: boolean | null, podCrash?: boolean | null, conditions?: { __typename?: 'NotificationCondition', key?: NotificationConditionKey | null, operator?: NotificationConditionOperator | null, value?: any | null } | { __typename?: 'NotificationConditionGroup' } | null } | null } | { __typename?: 'EmailIntegration', id: string, emailAddress: string, activated?: boolean | null, type: IntegrationType, name: string, description: string, image: string, createdAt: Date, updatedAt: Date, notificationSettings?: { __typename?: 'NotificationIntegrationSettings', build?: boolean | null, deploy?: boolean | null, podCrash?: boolean | null, conditions?: { __typename?: 'NotificationCondition', key?: NotificationConditionKey | null, operator?: NotificationConditionOperator | null, value?: any | null } | { __typename?: 'NotificationConditionGroup' } | null } | null } | { __typename?: 'GithubIntegration', id: string, login: string, appID: number, installationID: number, targetType: string, type: IntegrationType, name: string, description: string, image: string, createdAt: Date, updatedAt: Date } | { __typename?: 'GitlabIntegration', id: string, accessTokenPrefix?: string | null, webhookUrl: string, webhookToken: string, type: IntegrationType, name: string, description: string, image: string, createdAt: Date, updatedAt: Date } | { __typename?: 'SlackIntegration', id: string, type: IntegrationType, name: string, description: string, image: string, createdAt: Date, updatedAt: Date } | { __typename?: 'SlackWebhookIntegration', id: string, url?: string | null, type: IntegrationType, name: string, description: string, image: string, createdAt: Date, updatedAt: Date, notificationSettings?: { __typename?: 'NotificationIntegrationSettings', build?: boolean | null, deploy?: boolean | null, podCrash?: boolean | null, conditions?: { __typename?: 'NotificationCondition', key?: NotificationConditionKey | null, operator?: NotificationConditionOperator | null, value?: any | null } | { __typename?: 'NotificationConditionGroup' } | null } | null }> | null, notificationIntegrationSettings?: { __typename?: 'NotificationIntegrationSettings', build?: boolean | null, deploy?: boolean | null, podCrash?: boolean | null } | null } };

export type IpfSServicesFragmentFragment = { __typename?: 'IPFSService', id: string, state: IpfsServiceState, apiURL?: string | null, nodeURL?: string | null, accessToken?: string | null, owner: { __typename?: 'User', id: string, email?: string | null, createdAt?: Date | null, freeTrialEndsAt?: Date | null, hasPaymentMethod?: boolean | null, paymentError?: string | null, paymentAuthorizationError?: string | null, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, api?: { __typename?: 'Project', id: string, repo?: { __typename?: 'Repo', id: string, clusterDomains?: Array<{ __typename?: 'ClusterDomains', id: string, domains?: Array<{ __typename?: 'CustomDomain', id: string, domain: string, isApex: boolean, cnameTargets?: Array<string> | null, ipTargets?: Array<string> | null, disableCertManager?: boolean | null, certManagerChallengeType?: CertManagerChallengeType | null, syncDomain?: { __typename?: 'CustomDomain', id: string } | null, instructions?: Array<{ __typename?: 'DNSRecord', domain: string, type: DnsRecordType, value?: string | null }> | null, certificate?: { __typename?: 'Certificate', dnsNames?: Array<string> | null, ready: boolean, issuing: boolean, challenges?: Array<{ __typename?: 'CertificateChallenge', dnsName: string, solver: string, statusReason: string, statusState: string, type: string, wildcard: boolean }> | null, instructions?: Array<{ __typename?: 'DNSRecord', domain: string, type: DnsRecordType, value?: string | null }> | null } | null }> | null }> | null } | null } | null };

export type IpfsServicesQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type IpfsServicesQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, ipfsServices?: Array<{ __typename?: 'IPFSService', id: string, state: IpfsServiceState, apiURL?: string | null, nodeURL?: string | null, accessToken?: string | null, owner: { __typename?: 'User', id: string, email?: string | null, createdAt?: Date | null, freeTrialEndsAt?: Date | null, hasPaymentMethod?: boolean | null, paymentError?: string | null, paymentAuthorizationError?: string | null, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, api?: { __typename?: 'Project', id: string, repo?: { __typename?: 'Repo', id: string, clusterDomains?: Array<{ __typename?: 'ClusterDomains', id: string, domains?: Array<{ __typename?: 'CustomDomain', id: string, domain: string, isApex: boolean, cnameTargets?: Array<string> | null, ipTargets?: Array<string> | null, disableCertManager?: boolean | null, certManagerChallengeType?: CertManagerChallengeType | null, syncDomain?: { __typename?: 'CustomDomain', id: string } | null, instructions?: Array<{ __typename?: 'DNSRecord', domain: string, type: DnsRecordType, value?: string | null }> | null, certificate?: { __typename?: 'Certificate', dnsNames?: Array<string> | null, ready: boolean, issuing: boolean, challenges?: Array<{ __typename?: 'CertificateChallenge', dnsName: string, solver: string, statusReason: string, statusState: string, type: string, wildcard: boolean }> | null, instructions?: Array<{ __typename?: 'DNSRecord', domain: string, type: DnsRecordType, value?: string | null }> | null } | null }> | null }> | null } | null } | null }> | null } };

export type JobCommonFragment = { __typename?: 'JobRun', id: string, state: JobRunState, command: string, exitCode?: number | null, createdAt?: Date | null, build?: { __typename?: 'Build', id: string, version?: string | null } | null };

export type ProjectJobsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ProjectJobsQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, repo?: { __typename?: 'Repo', id: string, jobRuns?: { __typename?: 'JobRunConnection', totalCount: number, nodes: Array<{ __typename?: 'JobRun', id: string, state: JobRunState, command: string, exitCode?: number | null, createdAt?: Date | null, build?: { __typename?: 'Build', id: string, version?: string | null } | null }> } | null } | null } };

export type ProjectJobQueryVariables = Exact<{
  repoID: Scalars['ID'];
  jobID: Scalars['UUID'];
}>;


export type ProjectJobQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, repo?: { __typename?: 'Repo', id: string, jobRun: { __typename?: 'JobRun', id: string, state: JobRunState, command: string, exitCode?: number | null, createdAt?: Date | null, deployment?: { __typename?: 'Deployment', id: string, branch?: string | null } | null, logs?: { __typename?: 'Logs', id: string, completed: boolean, expired: boolean, entries?: Array<{ __typename?: 'LogEntry', timestamp?: Date | null, text: string }> | null } | null, build?: { __typename?: 'Build', id: string, version?: string | null } | null } } | null } };

export type UserJobQueryVariables = Exact<{
  jobID: Scalars['UUID'];
}>;


export type UserJobQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, jobRun: { __typename?: 'JobRun', id: string, state: JobRunState, command: string, exitCode?: number | null, createdAt?: Date | null, logs?: { __typename?: 'Logs', id: string, completed: boolean, expired: boolean, entries?: Array<{ __typename?: 'LogEntry', timestamp?: Date | null, text: string }> | null } | null, build?: { __typename?: 'Build', id: string, version?: string | null } | null } } };

export type DeploymentMetricsQueryVariables = Exact<{
  repoID: Scalars['ID'];
  deploymentID: Scalars['ID'];
  name: Scalars['String'];
}>;


export type DeploymentMetricsQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, repo?: { __typename?: 'Repo', id: string, deployment?: { __typename?: 'Deployment', id: string, metrics?: Array<{ __typename?: 'Metric', timestamp: Date, value?: number | null }> | null } | null } | null } };

export type CombinedDeploymentMetricsQueryVariables = Exact<{
  repoID: Scalars['ID'];
  deploymentID: Scalars['ID'];
}>;


export type CombinedDeploymentMetricsQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, repo?: { __typename?: 'Repo', id: string, deployment?: { __typename?: 'Deployment', id: string, cpuMetrics?: Array<{ __typename?: 'Metric', timestamp: Date, value?: number | null }> | null, memoryMetrics?: Array<{ __typename?: 'Metric', timestamp: Date, value?: number | null }> | null, networkMetrics?: Array<{ __typename?: 'Metric', timestamp: Date, value?: number | null }> | null, diskMetrics?: Array<{ __typename?: 'Metric', timestamp: Date, value?: number | null }> | null } | null } | null } };

export type CdnDetailFragment = { __typename?: 'CDN', id: string, endpoint?: string | null, state: string, domains?: Array<{ __typename?: 'CDNDomain', domain: string, certReady?: boolean | null, routeReady?: boolean | null, instruction?: { __typename?: 'DNSRecord', domain: string, type: DnsRecordType, value?: string | null } | null }> | null, certificate?: { __typename?: 'Certificate', dnsNames?: Array<string> | null, ready: boolean, issuing: boolean, instructions?: Array<{ __typename?: 'DNSRecord', name?: string | null, domain: string, type: DnsRecordType, value?: string | null }> | null } | null };

export type DomainDetailFragment = { __typename?: 'CustomDomain', id: string, domain: string, isApex: boolean, cnameTargets?: Array<string> | null, ipTargets?: Array<string> | null, disableCertManager?: boolean | null, certManagerChallengeType?: CertManagerChallengeType | null, syncDomain?: { __typename?: 'CustomDomain', id: string } | null, instructions?: Array<{ __typename?: 'DNSRecord', domain: string, type: DnsRecordType, value?: string | null }> | null, certificate?: { __typename?: 'Certificate', dnsNames?: Array<string> | null, ready: boolean, issuing: boolean, challenges?: Array<{ __typename?: 'CertificateChallenge', dnsName: string, solver: string, statusReason: string, statusState: string, type: string, wildcard: boolean }> | null, instructions?: Array<{ __typename?: 'DNSRecord', domain: string, type: DnsRecordType, value?: string | null }> | null } | null };

export type ClusterDomainsDetailFragment = { __typename?: 'ClusterDomains', id: string, cluster: { __typename?: 'Cluster', id: string, name: string }, domains?: Array<{ __typename?: 'CustomDomain', id: string, domain: string, isApex: boolean, cnameTargets?: Array<string> | null, ipTargets?: Array<string> | null, disableCertManager?: boolean | null, certManagerChallengeType?: CertManagerChallengeType | null, syncDomain?: { __typename?: 'CustomDomain', id: string } | null, instructions?: Array<{ __typename?: 'DNSRecord', domain: string, type: DnsRecordType, value?: string | null }> | null, certificate?: { __typename?: 'Certificate', dnsNames?: Array<string> | null, ready: boolean, issuing: boolean, challenges?: Array<{ __typename?: 'CertificateChallenge', dnsName: string, solver: string, statusReason: string, statusState: string, type: string, wildcard: boolean }> | null, instructions?: Array<{ __typename?: 'DNSRecord', domain: string, type: DnsRecordType, value?: string | null }> | null } | null }> | null };

export type RepoNetworkFragment = { __typename?: 'Repo', hostNetwork?: boolean | null, staticIP?: boolean | null, id: string, path: string, enabled: boolean, productionBranch?: string | null, deployTarget?: DeployTarget | null, deployType?: DeployType | null, deployService?: boolean | null, deployJob?: boolean | null, image?: string | null, cpu?: string | null, memory?: string | null, updatedAt: Date, disableReason?: DisableReason | null, databaseProvider?: DatabaseProviderType | null, databaseEngine?: DatabaseEngineType | null, name: string, clusterDomains?: Array<{ __typename?: 'ClusterDomains', id: string, cluster: { __typename?: 'Cluster', id: string, name: string }, domains?: Array<{ __typename?: 'CustomDomain', id: string, domain: string, isApex: boolean, cnameTargets?: Array<string> | null, ipTargets?: Array<string> | null, disableCertManager?: boolean | null, certManagerChallengeType?: CertManagerChallengeType | null, syncDomain?: { __typename?: 'CustomDomain', id: string } | null, instructions?: Array<{ __typename?: 'DNSRecord', domain: string, type: DnsRecordType, value?: string | null }> | null, certificate?: { __typename?: 'Certificate', dnsNames?: Array<string> | null, ready: boolean, issuing: boolean, challenges?: Array<{ __typename?: 'CertificateChallenge', dnsName: string, solver: string, statusReason: string, statusState: string, type: string, wildcard: boolean }> | null, instructions?: Array<{ __typename?: 'DNSRecord', domain: string, type: DnsRecordType, value?: string | null }> | null } | null }> | null }> | null, cdns?: Array<{ __typename?: 'CDN', id: string, endpoint?: string | null, state: string, domains?: Array<{ __typename?: 'CDNDomain', domain: string, certReady?: boolean | null, routeReady?: boolean | null, instruction?: { __typename?: 'DNSRecord', domain: string, type: DnsRecordType, value?: string | null } | null }> | null, certificate?: { __typename?: 'Certificate', dnsNames?: Array<string> | null, ready: boolean, issuing: boolean, instructions?: Array<{ __typename?: 'DNSRecord', name?: string | null, domain: string, type: DnsRecordType, value?: string | null }> | null } | null }> | null, ports?: Array<{ __typename?: 'Port', port: string, externalPort: string, protocol: string, public: boolean, https: boolean, grpc: boolean, loadBalancer: boolean }> | null, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, projectID?: string | null } | null, gpu?: { __typename?: 'GPUSpec', type?: string | null, count: number } | null, tpu?: { __typename?: 'TPUSpec', tfVersion: string, type: string, cores: number } | null, cluster?: { __typename?: 'Cluster', id: string, name: string, domain?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null } | null, autoscaling?: { __typename?: 'Autoscaling', minReplicas: number, maxReplicas: number } | null, owner: { __typename?: 'User', id: string, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, owner: { __typename?: 'User', id: string, login: any } } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null };

export type RepoNetworkQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type RepoNetworkQuery = { __typename?: 'Query', repo?: { __typename?: 'Repo', id: string, hostNetwork?: boolean | null, staticIP?: boolean | null, path: string, enabled: boolean, productionBranch?: string | null, deployTarget?: DeployTarget | null, deployType?: DeployType | null, deployService?: boolean | null, deployJob?: boolean | null, image?: string | null, cpu?: string | null, memory?: string | null, updatedAt: Date, disableReason?: DisableReason | null, databaseProvider?: DatabaseProviderType | null, databaseEngine?: DatabaseEngineType | null, name: string, clusterDomains?: Array<{ __typename?: 'ClusterDomains', id: string, cluster: { __typename?: 'Cluster', id: string, name: string }, domains?: Array<{ __typename?: 'CustomDomain', id: string, domain: string, isApex: boolean, cnameTargets?: Array<string> | null, ipTargets?: Array<string> | null, disableCertManager?: boolean | null, certManagerChallengeType?: CertManagerChallengeType | null, syncDomain?: { __typename?: 'CustomDomain', id: string } | null, instructions?: Array<{ __typename?: 'DNSRecord', domain: string, type: DnsRecordType, value?: string | null }> | null, certificate?: { __typename?: 'Certificate', dnsNames?: Array<string> | null, ready: boolean, issuing: boolean, challenges?: Array<{ __typename?: 'CertificateChallenge', dnsName: string, solver: string, statusReason: string, statusState: string, type: string, wildcard: boolean }> | null, instructions?: Array<{ __typename?: 'DNSRecord', domain: string, type: DnsRecordType, value?: string | null }> | null } | null }> | null }> | null, cdns?: Array<{ __typename?: 'CDN', id: string, endpoint?: string | null, state: string, domains?: Array<{ __typename?: 'CDNDomain', domain: string, certReady?: boolean | null, routeReady?: boolean | null, instruction?: { __typename?: 'DNSRecord', domain: string, type: DnsRecordType, value?: string | null } | null }> | null, certificate?: { __typename?: 'Certificate', dnsNames?: Array<string> | null, ready: boolean, issuing: boolean, instructions?: Array<{ __typename?: 'DNSRecord', name?: string | null, domain: string, type: DnsRecordType, value?: string | null }> | null } | null }> | null, ports?: Array<{ __typename?: 'Port', port: string, externalPort: string, protocol: string, public: boolean, https: boolean, grpc: boolean, loadBalancer: boolean }> | null, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, projectID?: string | null } | null, gpu?: { __typename?: 'GPUSpec', type?: string | null, count: number } | null, tpu?: { __typename?: 'TPUSpec', tfVersion: string, type: string, cores: number } | null, cluster?: { __typename?: 'Cluster', id: string, name: string, domain?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null } | null, autoscaling?: { __typename?: 'Autoscaling', minReplicas: number, maxReplicas: number } | null, owner: { __typename?: 'User', id: string, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, owner: { __typename?: 'User', id: string, login: any } } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null } | null };

export type SuggestProjectNameQueryVariables = Exact<{
  user: Scalars['ID'];
  input: SuggestProjectNameInput;
}>;


export type SuggestProjectNameQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, suggestProjectName: string } };

export type CheckProjectNameQueryVariables = Exact<{
  user: Scalars['ID'];
  input: CheckProjectNameInput;
}>;


export type CheckProjectNameQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, checkProjectName: boolean } };

export type UserPaymentQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UserPaymentQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, hasPaymentMethod?: boolean | null, needsPaymentMethod?: boolean | null, freeQuota?: number | null, paymentError?: string | null } };

export type GetPriceTotalQueryVariables = Exact<{
  input: CheckPriceInput;
}>;


export type GetPriceTotalQuery = { __typename?: 'Query', checkPrice: { __typename?: 'CheckPriceOutput', total: { __typename?: 'PriceComponent', explanation: string, cost: number }, subTotal: { __typename?: 'PriceComponent', explanation: string, cost: number } } };

export type UnitPriceQueryVariables = Exact<{ [key: string]: never; }>;


export type UnitPriceQuery = { __typename?: 'Query', prices: { __typename?: 'Prices', ramGB: number, cpuCore: number, dedicatedGPU: number, dedicatedRamGB: number, dedicatedCpuCore: number, storageGB: number } };

export type FreeTierEligibleQueryVariables = Exact<{
  input: CheckPriceInput;
}>;


export type FreeTierEligibleQuery = { __typename?: 'Query', checkPrice: { __typename?: 'CheckPriceOutput', canBeFreeTier: boolean }, currentUser: { __typename?: 'User', id: string, freeQuota?: number | null } };

export type ProjectQueryVariables = Exact<{
  path: Scalars['String'];
}>;


export type ProjectQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id: string, name: string, isMultiRepo: boolean, autoCleanupEnabled: boolean, createdAt: Date, updatedAt: Date, owner: { __typename?: 'User', id: string, login: any } } | null };

export type ProjectByIdQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type ProjectByIdQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, owner: { __typename?: 'User', id: string, login: any } } | null };

export type ProjectsQueryVariables = Exact<{
  userId: Scalars['ID'];
  filterInput: FilterInput;
}>;


export type ProjectsQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, projectV3Adapters?: { __typename?: 'ProjectV3AdapterConnection', nodes: Array<{ __typename?: 'ProjectV3Adapter', id: string, name: string, createdAt: Date, updatedAt: Date, repo?: { __typename?: 'Repo', id: string, cluster?: { __typename?: 'Cluster', id: string, state: ClusterState } | null } | null, project?: { __typename?: 'Project', id: string, name: string } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null }> } | null, projects: { __typename?: 'ProjectConnection', nodes: Array<{ __typename?: 'Project', id: string, name: string, updatedAt: Date, environments: Array<{ __typename?: 'ProjectEnvironment', id: string, name: string, updatedAt: Date }> }> } } };

export type ProjectCountQueryVariables = Exact<{
  userId: Scalars['ID'];
  filterInput: FilterInput;
}>;


export type ProjectCountQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, projectV3Adapters?: { __typename?: 'ProjectV3AdapterConnection', totalCount: number } | null } };

export type GroupListItemFragment = { __typename?: 'Project', id: string, name: string, updatedAt: Date, environments: Array<{ __typename?: 'ProjectEnvironment', id: string, name: string, updatedAt: Date }> };

export type SubgroupListItemFragment = { __typename?: 'ProjectEnvironment', id: string, name: string, updatedAt: Date };

export type ProjectsWithRepoQueryVariables = Exact<{
  userId: Scalars['ID'];
  filterInput: FilterInput;
}>;


export type ProjectsWithRepoQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, projectV3Adapters?: { __typename?: 'ProjectV3AdapterConnection', nodes: Array<{ __typename?: 'ProjectV3Adapter', id: string, repo?: { __typename?: 'Repo', id: string, image?: string | null, deployTarget?: DeployTarget | null, deployJob?: boolean | null, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionDeployment?: { __typename?: 'Deployment', id: string, endpoints?: Array<string> | null, privateEndpoint?: string | null } | null } | null }> } | null } };

export type ProjectListItemFragment = { __typename?: 'ProjectV3Adapter', id: string, name: string, createdAt: Date, updatedAt: Date, repo?: { __typename?: 'Repo', id: string, cluster?: { __typename?: 'Cluster', id: string, state: ClusterState } | null } | null, project?: { __typename?: 'Project', id: string, name: string } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null };

export type ProjectWithRepoFragment = { __typename?: 'ProjectV3Adapter', repo?: { __typename?: 'Repo', id: string, image?: string | null, deployTarget?: DeployTarget | null, deployJob?: boolean | null, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionDeployment?: { __typename?: 'Deployment', id: string, endpoints?: Array<string> | null, privateEndpoint?: string | null } | null } | null };

export type UserProjectsProductionDeploymentsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UserProjectsProductionDeploymentsQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, projects: { __typename?: 'ProjectConnection', nodes: Array<{ __typename?: 'Project', id: string, repo?: { __typename?: 'Repo', id: string, productionDeployment?: { __typename?: 'Deployment', id: string, description?: string | null, version: string, status: DeploymentStatus, branch?: string | null, endpoints?: Array<string> | null, privateEndpoint?: string | null, errorMessage?: string | null, updatedAt: Date, createdAt: Date, deployStatus?: { __typename?: 'DeployStatus', active: boolean, replicas: number, publicIPs?: Array<string> | null, state: string, errorMessage?: string | null, troubleshooting?: { __typename?: 'Troubleshooting', issue?: { __typename?: 'TroubleshootingIssue', blocks?: Array<{ __typename?: 'TroubleshootingIssueBlock', blockType?: TroubleshootingIssueBlockType | null, content?: string | null }> | null } | null } | null } | null, build?: { __typename?: 'Build', id: string, image?: string | null } | null, alternativeImages?: Array<{ __typename?: 'AlternativeImage', reference?: string | null, tag?: string | null, name?: string | null }> | null } | null } | null }> } } };

export type UserBasicProjectsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UserBasicProjectsQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, projects: { __typename?: 'ProjectConnection', nodes: Array<{ __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, owner: { __typename?: 'User', id: string, login: any } }> } } };

export type ProjectRevisionsQueryVariables = Exact<{
  id: Scalars['UUID'];
  page?: InputMaybe<PageInput>;
}>;


export type ProjectRevisionsQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id: string, revisions?: { __typename?: 'ProjectRevisionConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor: string, endCursor: string, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'ProjectRevision', revisionData: any, revisionMetadata: { __typename?: 'RevisionMetadata', id: string, description: string, sequenceId: number, createdAt: Date, createdBy: { __typename?: 'User', id: string, login: any, name: string, avatar?: string | null } } }> } | null } | null };

export type ProjectPermissionsQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type ProjectPermissionsQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id: string, permissions?: { __typename?: 'ProjectPermissions', availableRoles: Array<{ __typename?: 'TeamMemberProjectRole', name: string, description?: string | null }>, users: Array<{ __typename?: 'ProjectUserPermissions', teamRole?: TeamMemberRole | null, user?: { __typename?: 'User', id: string, name: string, login: any, avatar?: string | null, isTeam?: boolean | null } | null, projectRole?: { __typename?: 'TeamMemberProjectRole', name: string, description?: string | null } | null }> } | null } | null };

export type ProjectBasicFragment = { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, owner: { __typename?: 'User', id: string, login: any } };

export type ProjectContextWithoutEnvironmentFragment = { __typename?: 'Project', id: string, name: string, isMultiRepo: boolean, autoCleanupEnabled: boolean, createdAt: Date, updatedAt: Date, owner: { __typename?: 'User', id: string, login: any } };

export type ProjectContextFragment = { __typename?: 'Project', id: string, name: string, isMultiRepo: boolean, autoCleanupEnabled: boolean, createdAt: Date, updatedAt: Date, defaultEnvironment: { __typename?: 'ProjectEnvironment', id: string, name: string, defaultRepo?: { __typename?: 'Repo', id: string, name: string } | null }, owner: { __typename?: 'User', id: string, login: any } };

export type SubgroupOverviewQueryVariables = Exact<{
  path: Scalars['String'];
  environment: Scalars['String'];
}>;


export type SubgroupOverviewQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id: string, environment: { __typename?: 'ProjectEnvironment', id: string, name: string, overviewV2?: Array<{ __typename?: 'EnvironmentOverviewV2', deploymentStatus: ProjectV3AdapterStatus, count: number } | null> | null, projectV3Adapters?: { __typename?: 'ProjectV3AdapterConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor: string, endCursor: string, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'ProjectV3Adapter', id: string, name: string, project?: { __typename?: 'Project', id: string, name: string } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null }> } | null } } | null };

export type ProjectEnvironmentsQueryVariables = Exact<{
  path: Scalars['String'];
}>;


export type ProjectEnvironmentsQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id: string, environments: Array<{ __typename?: 'ProjectEnvironment', updatedAt: Date, id: string, name: string, projectV3Adapters?: { __typename?: 'ProjectV3AdapterConnection', totalCount: number } | null }> } | null };

export type ProjectEnvironmentsAndRepoCountQueryVariables = Exact<{
  path: Scalars['String'];
}>;


export type ProjectEnvironmentsAndRepoCountQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id: string, environments: Array<{ __typename?: 'ProjectEnvironment', id: string, name: string, repoConnection: { __typename?: 'RepoConnection', totalCount: number } }> } | null };

export type ProjectEnvironmentsBasicQueryVariables = Exact<{
  path: Scalars['String'];
}>;


export type ProjectEnvironmentsBasicQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id: string, environments: Array<{ __typename?: 'ProjectEnvironment', id: string, name: string }> } | null };

export type ProjectEnvironmentsByIdQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type ProjectEnvironmentsByIdQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id: string, environments: Array<{ __typename?: 'ProjectEnvironment', id: string, name: string }> } | null };

export type ProjectEnvironmentQueryVariables = Exact<{
  path: Scalars['String'];
  env: Scalars['String'];
}>;


export type ProjectEnvironmentQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id: string, environment: { __typename?: 'ProjectEnvironment', id: string, name: string } } | null };

export type ProjectEnvironmentByIdQueryVariables = Exact<{
  projectId: Scalars['UUID'];
  envId: Scalars['UUID'];
}>;


export type ProjectEnvironmentByIdQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id: string, environment: { __typename?: 'ProjectEnvironment', id: string, name: string } } | null };

export type ProjectEnvironmentVariablesQueryVariables = Exact<{
  path: Scalars['String'];
}>;


export type ProjectEnvironmentVariablesQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id: string, envs?: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string, visible: boolean, sealed: boolean, source?: { __typename?: 'EnvVarSource', type: EnvVarSourceType } | null }> | null } | null };

export type EnvironmentEnvironmentVariablesQueryVariables = Exact<{
  path: Scalars['String'];
  env: Scalars['String'];
}>;


export type EnvironmentEnvironmentVariablesQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id: string, envs?: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string, visible: boolean, sealed: boolean, source?: { __typename?: 'EnvVarSource', type: EnvVarSourceType } | null }> | null, environment: { __typename?: 'ProjectEnvironment', id: string, envs?: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string, visible: boolean, sealed: boolean, source?: { __typename?: 'EnvVarSource', type: EnvVarSourceType } | null }> | null } } | null };

export type ProjectEnvironmentRevisionsQueryVariables = Exact<{
  projectId: Scalars['UUID'];
  id: Scalars['UUID'];
  page?: InputMaybe<PageInput>;
}>;


export type ProjectEnvironmentRevisionsQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id: string, environment: { __typename?: 'ProjectEnvironment', id: string, revisions?: { __typename?: 'ProjectEnvironmentRevisionConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor: string, endCursor: string, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'ProjectEnvironmentRevision', revisionData: any, revisionMetadata: { __typename?: 'RevisionMetadata', id: string, description: string, sequenceId: number, createdAt: Date, createdBy: { __typename?: 'User', id: string, login: any, name: string, avatar?: string | null } } }> } | null } } | null };

export type ProjectEnvironmentBasicFragment = { __typename?: 'ProjectEnvironment', id: string, name: string };

export type ProjectEnvironmentListItemFragment = { __typename?: 'ProjectEnvironment', updatedAt: Date, id: string, name: string, projectV3Adapters?: { __typename?: 'ProjectV3AdapterConnection', totalCount: number } | null };

export type BridgeProjectV3ListFragment = { __typename?: 'ProjectV3Adapter', name: string, id: string, status?: ProjectV3AdapterStatus | null, isDeployV2: boolean, updatedAt: Date, projectV3?: { __typename?: 'ProjectV3', id: string, name: string, blueprintID: string } | null, repo?: { __typename?: 'Repo', id: string, path: string, enabled: boolean, productionBranch?: string | null, deployTarget?: DeployTarget | null, deployType?: DeployType | null, deployService?: boolean | null, deployJob?: boolean | null, image?: string | null, cpu?: string | null, memory?: string | null, updatedAt: Date, disableReason?: DisableReason | null, databaseProvider?: DatabaseProviderType | null, databaseEngine?: DatabaseEngineType | null, name: string, productionDeployment?: { __typename?: 'Deployment', id: string, description?: string | null, version: string, status: DeploymentStatus, branch?: string | null, endpoints?: Array<string> | null, privateEndpoint?: string | null, errorMessage?: string | null, updatedAt: Date, createdAt: Date, deployStatus?: { __typename?: 'DeployStatus', active: boolean, replicas: number, publicIPs?: Array<string> | null, state: string, errorMessage?: string | null, troubleshooting?: { __typename?: 'Troubleshooting', issue?: { __typename?: 'TroubleshootingIssue', blocks?: Array<{ __typename?: 'TroubleshootingIssueBlock', blockType?: TroubleshootingIssueBlockType | null, content?: string | null }> | null } | null } | null } | null, build?: { __typename?: 'Build', id: string, image?: string | null } | null, alternativeImages?: Array<{ __typename?: 'AlternativeImage', reference?: string | null, tag?: string | null, name?: string | null }> | null } | null, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, projectID?: string | null } | null, gpu?: { __typename?: 'GPUSpec', type?: string | null, count: number } | null, tpu?: { __typename?: 'TPUSpec', tfVersion: string, type: string, cores: number } | null, cluster?: { __typename?: 'Cluster', id: string, name: string, domain?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null } | null, autoscaling?: { __typename?: 'Autoscaling', minReplicas: number, maxReplicas: number } | null, owner: { __typename?: 'User', id: string, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, owner: { __typename?: 'User', id: string, login: any } } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null } | null, project?: { __typename?: 'Project', id: string, name: string } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null };

export type WorkflowStepFragment = { __typename?: 'BlueprintDriverWorkflowStep', action: BlueprintDriverWorkflowStepAction, status: BlueprintDriverWorkflowStepStatus, execution?: { __typename?: 'BlueprintDriverActionExecution', id: string, driver: BlueprintDriver, action: BlueprintDriverAction, approvedAt?: Date | null, jobRun?: { __typename?: 'JobRun', id: string, state: JobRunState, createdAt?: Date | null, updatedAt?: Date | null } | null } | null };

export type WorkflowStepWithLogsFragment = { __typename?: 'BlueprintDriverWorkflowStep', action: BlueprintDriverWorkflowStepAction, status: BlueprintDriverWorkflowStepStatus, execution?: { __typename?: 'BlueprintDriverActionExecution', id: string, driver: BlueprintDriver, action: BlueprintDriverAction, approvedAt?: Date | null, jobRun?: { __typename?: 'JobRun', id: string, state: JobRunState, createdAt?: Date | null, updatedAt?: Date | null, logs?: { __typename?: 'Logs', id: string, completed: boolean, expired: boolean, entries?: Array<{ __typename?: 'LogEntry', text: string, timestamp?: Date | null }> | null } | null } | null } | null };

export type BlueprintDriverWorkflowListFragment = { __typename?: 'BlueprintDriverWorkflow', id: string, status: ProjectV3WorkflowStatus, createdAt: Date, updatedAt: Date, steps: Array<{ __typename?: 'BlueprintDriverWorkflowStep', action: BlueprintDriverWorkflowStepAction, status: BlueprintDriverWorkflowStepStatus, execution?: { __typename?: 'BlueprintDriverActionExecution', id: string, driver: BlueprintDriver, action: BlueprintDriverAction, approvedAt?: Date | null, jobRun?: { __typename?: 'JobRun', id: string, state: JobRunState, createdAt?: Date | null, updatedAt?: Date | null } | null } | null }> };

export type BlueprintDriverWorkflowDetailFragment = { __typename?: 'BlueprintDriverWorkflow', id: string, status: ProjectV3WorkflowStatus, createdAt: Date, updatedAt: Date, steps: Array<{ __typename?: 'BlueprintDriverWorkflowStep', action: BlueprintDriverWorkflowStepAction, status: BlueprintDriverWorkflowStepStatus, execution?: { __typename?: 'BlueprintDriverActionExecution', id: string, driver: BlueprintDriver, action: BlueprintDriverAction, approvedAt?: Date | null, jobRun?: { __typename?: 'JobRun', id: string, state: JobRunState, createdAt?: Date | null, updatedAt?: Date | null, logs?: { __typename?: 'Logs', id: string, completed: boolean, expired: boolean, entries?: Array<{ __typename?: 'LogEntry', text: string, timestamp?: Date | null }> | null } | null } | null } | null }> };

export type ProjectV3DetailFragment = { __typename?: 'ProjectV3', id: string, requirePlanApproval: boolean, name: string, blueprintID: string, blueprintConfiguration?: { __typename?: 'BlueprintHelmConfiguration', source?: { __typename?: 'Source', git?: { __typename?: 'GitSource', repository: string, path?: string | null, ref?: string | null, integration?: { __typename?: 'GitSourceIntegration', githubInstallationID?: number | null, bitbucketIntegrationID?: string | null, gitlabIntegrationID?: string | null } | null } | null, helmRepository?: { __typename?: 'HelmRepositorySource', chart: string, version?: string | null, repositoryURL: string } | null, containerRegistry?: { __typename?: 'ContainerRegistrySource', registryID?: string | null, registryURL?: string | null, repository: string, tag?: string | null } | null } | null } | { __typename?: 'BlueprintManifestConfiguration', source?: { __typename?: 'Source', git?: { __typename?: 'GitSource', repository: string, path?: string | null, ref?: string | null, integration?: { __typename?: 'GitSourceIntegration', githubInstallationID?: number | null, bitbucketIntegrationID?: string | null, gitlabIntegrationID?: string | null } | null } | null } | null } | { __typename?: 'BlueprintTerraformConfiguration', registrySource?: string | null, moduleVersionConstraint?: string | null, githubSource?: string | null, moduleSource?: { __typename?: 'TerraformModuleSource', source: string, version?: string | null, integration?: { __typename?: 'TerraformModuleSourceIntegration', git?: { __typename?: 'GitSourceIntegration', githubInstallationID?: number | null, bitbucketIntegrationID?: string | null, gitlabIntegrationID?: string | null } | null } | null } | null } | null, configuration?: { __typename?: 'HelmProjectV3Configuration', clusterID: string, namespace?: string | null, releaseName: string, values?: any | null } | { __typename?: 'ManifestProjectV3Configuration', clusterID: string, namespace?: string | null } | { __typename?: 'TerraformProjectV3Configuration', stateBackend: { __typename?: 'TerraformStateBackend', s3Bucket?: { __typename?: 'S3BucketConfiguration', awsAccountID: string, bucketName: string, region: string, key?: string | null } | null, gcsBucket?: { __typename?: 'GCSBucketConfiguration', gcpAccountID: string, bucketName: string, location: string, prefix?: string | null } | null, linodeBucket?: { __typename?: 'LinodeBucketConfiguration', linodeAccountId: string, bucketName: string, region: string, key: string } | null }, provider?: { __typename?: 'TerraformProvider', region?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string } | null } | null } | null, variables: Array<{ __typename?: 'BlueprintVariableBoolean', id: string, variableSpecID?: string | null, name: string, booleanValue: boolean } | { __typename?: 'BlueprintVariableFloat', id: string, variableSpecID?: string | null, name: string, floatValue: number } | { __typename?: 'BlueprintVariableInt', id: string, variableSpecID?: string | null, name: string, intValue: number } | { __typename?: 'BlueprintVariableJSON', id: string, variableSpecID?: string | null, name: string, jsonValue: any } | { __typename?: 'BlueprintVariableString', id: string, variableSpecID?: string | null, name: string, stringValue: string }>, driverWorkflows?: Array<{ __typename?: 'BlueprintDriverWorkflow', id: string, status: ProjectV3WorkflowStatus, createdAt: Date, updatedAt: Date, steps: Array<{ __typename?: 'BlueprintDriverWorkflowStep', action: BlueprintDriverWorkflowStepAction, status: BlueprintDriverWorkflowStepStatus, execution?: { __typename?: 'BlueprintDriverActionExecution', id: string, driver: BlueprintDriver, action: BlueprintDriverAction, approvedAt?: Date | null, jobRun?: { __typename?: 'JobRun', id: string, state: JobRunState, createdAt?: Date | null, updatedAt?: Date | null } | null } | null }> }> | null };

export type ProjectV3AdapterDetailFragment = { __typename?: 'ProjectV3Adapter', name: string, id: string, status?: ProjectV3AdapterStatus | null, isDeployV2: boolean, repo?: { __typename?: 'Repo', id: string } | null, projectV3?: { __typename?: 'ProjectV3', id: string, requirePlanApproval: boolean, name: string, blueprintID: string, blueprintConfiguration?: { __typename?: 'BlueprintHelmConfiguration', source?: { __typename?: 'Source', git?: { __typename?: 'GitSource', repository: string, path?: string | null, ref?: string | null, integration?: { __typename?: 'GitSourceIntegration', githubInstallationID?: number | null, bitbucketIntegrationID?: string | null, gitlabIntegrationID?: string | null } | null } | null, helmRepository?: { __typename?: 'HelmRepositorySource', chart: string, version?: string | null, repositoryURL: string } | null, containerRegistry?: { __typename?: 'ContainerRegistrySource', registryID?: string | null, registryURL?: string | null, repository: string, tag?: string | null } | null } | null } | { __typename?: 'BlueprintManifestConfiguration', source?: { __typename?: 'Source', git?: { __typename?: 'GitSource', repository: string, path?: string | null, ref?: string | null, integration?: { __typename?: 'GitSourceIntegration', githubInstallationID?: number | null, bitbucketIntegrationID?: string | null, gitlabIntegrationID?: string | null } | null } | null } | null } | { __typename?: 'BlueprintTerraformConfiguration', registrySource?: string | null, moduleVersionConstraint?: string | null, githubSource?: string | null, moduleSource?: { __typename?: 'TerraformModuleSource', source: string, version?: string | null, integration?: { __typename?: 'TerraformModuleSourceIntegration', git?: { __typename?: 'GitSourceIntegration', githubInstallationID?: number | null, bitbucketIntegrationID?: string | null, gitlabIntegrationID?: string | null } | null } | null } | null } | null, configuration?: { __typename?: 'HelmProjectV3Configuration', clusterID: string, namespace?: string | null, releaseName: string, values?: any | null } | { __typename?: 'ManifestProjectV3Configuration', clusterID: string, namespace?: string | null } | { __typename?: 'TerraformProjectV3Configuration', stateBackend: { __typename?: 'TerraformStateBackend', s3Bucket?: { __typename?: 'S3BucketConfiguration', awsAccountID: string, bucketName: string, region: string, key?: string | null } | null, gcsBucket?: { __typename?: 'GCSBucketConfiguration', gcpAccountID: string, bucketName: string, location: string, prefix?: string | null } | null, linodeBucket?: { __typename?: 'LinodeBucketConfiguration', linodeAccountId: string, bucketName: string, region: string, key: string } | null }, provider?: { __typename?: 'TerraformProvider', region?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string } | null } | null } | null, variables: Array<{ __typename?: 'BlueprintVariableBoolean', id: string, variableSpecID?: string | null, name: string, booleanValue: boolean } | { __typename?: 'BlueprintVariableFloat', id: string, variableSpecID?: string | null, name: string, floatValue: number } | { __typename?: 'BlueprintVariableInt', id: string, variableSpecID?: string | null, name: string, intValue: number } | { __typename?: 'BlueprintVariableJSON', id: string, variableSpecID?: string | null, name: string, jsonValue: any } | { __typename?: 'BlueprintVariableString', id: string, variableSpecID?: string | null, name: string, stringValue: string }>, driverWorkflows?: Array<{ __typename?: 'BlueprintDriverWorkflow', id: string, status: ProjectV3WorkflowStatus, createdAt: Date, updatedAt: Date, steps: Array<{ __typename?: 'BlueprintDriverWorkflowStep', action: BlueprintDriverWorkflowStepAction, status: BlueprintDriverWorkflowStepStatus, execution?: { __typename?: 'BlueprintDriverActionExecution', id: string, driver: BlueprintDriver, action: BlueprintDriverAction, approvedAt?: Date | null, jobRun?: { __typename?: 'JobRun', id: string, state: JobRunState, createdAt?: Date | null, updatedAt?: Date | null } | null } | null }> }> | null } | null, project?: { __typename?: 'Project', id: string, name: string } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null };

export type ProjectV3AdapterConnectionListItemFragment = { __typename?: 'ProjectV3AdapterConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor: string, endCursor: string, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'ProjectV3Adapter', id: string, name: string, project?: { __typename?: 'Project', id: string, name: string } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null }> };

export type ProjectV3ListItemFragment = { __typename?: 'ProjectV3', id: string, name: string, blueprintID: string };

export type ProjectV3ListItemConnectionFragment = { __typename?: 'ProjectV3AdapterConnection', nodes: Array<{ __typename?: 'ProjectV3Adapter', name: string, id: string, status?: ProjectV3AdapterStatus | null, isDeployV2: boolean, updatedAt: Date, projectV3?: { __typename?: 'ProjectV3', id: string, name: string, blueprintID: string } | null, repo?: { __typename?: 'Repo', id: string, path: string, enabled: boolean, productionBranch?: string | null, deployTarget?: DeployTarget | null, deployType?: DeployType | null, deployService?: boolean | null, deployJob?: boolean | null, image?: string | null, cpu?: string | null, memory?: string | null, updatedAt: Date, disableReason?: DisableReason | null, databaseProvider?: DatabaseProviderType | null, databaseEngine?: DatabaseEngineType | null, name: string, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, projectID?: string | null } | null, gpu?: { __typename?: 'GPUSpec', type?: string | null, count: number } | null, tpu?: { __typename?: 'TPUSpec', tfVersion: string, type: string, cores: number } | null, cluster?: { __typename?: 'Cluster', id: string, name: string, domain?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null } | null, autoscaling?: { __typename?: 'Autoscaling', minReplicas: number, maxReplicas: number } | null, owner: { __typename?: 'User', id: string, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, owner: { __typename?: 'User', id: string, login: any } } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null } | null, project?: { __typename?: 'Project', id: string, name: string, defaultRepo?: { __typename?: 'Repo', id: string } | null } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null }> };

export type UserProjectV3QueryVariables = Exact<{
  userId: Scalars['ID'];
  projectName: Scalars['String'];
  page: PageInput;
}>;


export type UserProjectV3Query = { __typename?: 'Query', user: { __typename?: 'User', id: string, projectV3Adapters?: { __typename?: 'ProjectV3AdapterConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor: string, endCursor: string, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'ProjectV3Adapter', name: string, id: string, status?: ProjectV3AdapterStatus | null, isDeployV2: boolean, updatedAt: Date, projectV3?: { __typename?: 'ProjectV3', id: string, name: string, blueprintID: string } | null, repo?: { __typename?: 'Repo', id: string, path: string, enabled: boolean, productionBranch?: string | null, deployTarget?: DeployTarget | null, deployType?: DeployType | null, deployService?: boolean | null, deployJob?: boolean | null, image?: string | null, cpu?: string | null, memory?: string | null, updatedAt: Date, disableReason?: DisableReason | null, databaseProvider?: DatabaseProviderType | null, databaseEngine?: DatabaseEngineType | null, name: string, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, projectID?: string | null } | null, gpu?: { __typename?: 'GPUSpec', type?: string | null, count: number } | null, tpu?: { __typename?: 'TPUSpec', tfVersion: string, type: string, cores: number } | null, cluster?: { __typename?: 'Cluster', id: string, name: string, domain?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null } | null, autoscaling?: { __typename?: 'Autoscaling', minReplicas: number, maxReplicas: number } | null, owner: { __typename?: 'User', id: string, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, owner: { __typename?: 'User', id: string, login: any } } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null } | null, project?: { __typename?: 'Project', id: string, name: string, defaultRepo?: { __typename?: 'Repo', id: string } | null } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null }> } | null } };

export type UserProjectV3DeploymentsQueryVariables = Exact<{
  userId: Scalars['ID'];
  projectName: Scalars['String'];
  page: PageInput;
}>;


export type UserProjectV3DeploymentsQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, projectV3Adapters?: { __typename?: 'ProjectV3AdapterConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor: string, endCursor: string, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'ProjectV3Adapter', id: string, repo?: { __typename?: 'Repo', id: string, productionDeployment?: { __typename?: 'Deployment', id: string, description?: string | null, version: string, status: DeploymentStatus, branch?: string | null, endpoints?: Array<string> | null, privateEndpoint?: string | null, errorMessage?: string | null, updatedAt: Date, createdAt: Date, deployStatus?: { __typename?: 'DeployStatus', active: boolean, replicas: number, publicIPs?: Array<string> | null, state: string, errorMessage?: string | null, troubleshooting?: { __typename?: 'Troubleshooting', issue?: { __typename?: 'TroubleshootingIssue', blocks?: Array<{ __typename?: 'TroubleshootingIssueBlock', blockType?: TroubleshootingIssueBlockType | null, content?: string | null }> | null } | null } | null } | null, build?: { __typename?: 'Build', id: string, image?: string | null } | null, alternativeImages?: Array<{ __typename?: 'AlternativeImage', reference?: string | null, tag?: string | null, name?: string | null }> | null } | null } | null }> } | null } };

export type ProjectV3sForEnvironmentQueryVariables = Exact<{
  userId: Scalars['ID'];
  groupName: Scalars['String'];
  subgroupName: Scalars['String'];
  page: PageInput;
  projectName: Scalars['String'];
}>;


export type ProjectV3sForEnvironmentQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, projectV3Adapters?: { __typename?: 'ProjectV3AdapterConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor: string, endCursor: string, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'ProjectV3Adapter', name: string, id: string, status?: ProjectV3AdapterStatus | null, isDeployV2: boolean, updatedAt: Date, projectV3?: { __typename?: 'ProjectV3', id: string, name: string, blueprintID: string } | null, repo?: { __typename?: 'Repo', id: string, path: string, enabled: boolean, productionBranch?: string | null, deployTarget?: DeployTarget | null, deployType?: DeployType | null, deployService?: boolean | null, deployJob?: boolean | null, image?: string | null, cpu?: string | null, memory?: string | null, updatedAt: Date, disableReason?: DisableReason | null, databaseProvider?: DatabaseProviderType | null, databaseEngine?: DatabaseEngineType | null, name: string, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, projectID?: string | null } | null, gpu?: { __typename?: 'GPUSpec', type?: string | null, count: number } | null, tpu?: { __typename?: 'TPUSpec', tfVersion: string, type: string, cores: number } | null, cluster?: { __typename?: 'Cluster', id: string, name: string, domain?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null } | null, autoscaling?: { __typename?: 'Autoscaling', minReplicas: number, maxReplicas: number } | null, owner: { __typename?: 'User', id: string, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, owner: { __typename?: 'User', id: string, login: any } } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null } | null, project?: { __typename?: 'Project', id: string, name: string, defaultRepo?: { __typename?: 'Repo', id: string } | null } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null }> } | null } };

export type ProjectV3ProductionDeploymentConnectionFragment = { __typename?: 'ProjectV3AdapterConnection', nodes: Array<{ __typename?: 'ProjectV3Adapter', id: string, repo?: { __typename?: 'Repo', id: string, productionDeployment?: { __typename?: 'Deployment', id: string, description?: string | null, version: string, status: DeploymentStatus, branch?: string | null, endpoints?: Array<string> | null, privateEndpoint?: string | null, errorMessage?: string | null, updatedAt: Date, createdAt: Date, deployStatus?: { __typename?: 'DeployStatus', active: boolean, replicas: number, publicIPs?: Array<string> | null, state: string, errorMessage?: string | null, troubleshooting?: { __typename?: 'Troubleshooting', issue?: { __typename?: 'TroubleshootingIssue', blocks?: Array<{ __typename?: 'TroubleshootingIssueBlock', blockType?: TroubleshootingIssueBlockType | null, content?: string | null }> | null } | null } | null } | null, build?: { __typename?: 'Build', id: string, image?: string | null } | null, alternativeImages?: Array<{ __typename?: 'AlternativeImage', reference?: string | null, tag?: string | null, name?: string | null }> | null } | null } | null }> };

export type ProjectV3sForEnvironmentProductionDeploymentsQueryVariables = Exact<{
  userId: Scalars['ID'];
  groupName: Scalars['String'];
  subgroupName: Scalars['String'];
  page: PageInput;
  projectName: Scalars['String'];
}>;


export type ProjectV3sForEnvironmentProductionDeploymentsQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, projectV3Adapters?: { __typename?: 'ProjectV3AdapterConnection', nodes: Array<{ __typename?: 'ProjectV3Adapter', id: string, repo?: { __typename?: 'Repo', id: string, productionDeployment?: { __typename?: 'Deployment', id: string, description?: string | null, version: string, status: DeploymentStatus, branch?: string | null, endpoints?: Array<string> | null, privateEndpoint?: string | null, errorMessage?: string | null, updatedAt: Date, createdAt: Date, deployStatus?: { __typename?: 'DeployStatus', active: boolean, replicas: number, publicIPs?: Array<string> | null, state: string, errorMessage?: string | null, troubleshooting?: { __typename?: 'Troubleshooting', issue?: { __typename?: 'TroubleshootingIssue', blocks?: Array<{ __typename?: 'TroubleshootingIssueBlock', blockType?: TroubleshootingIssueBlockType | null, content?: string | null }> | null } | null } | null } | null, build?: { __typename?: 'Build', id: string, image?: string | null } | null, alternativeImages?: Array<{ __typename?: 'AlternativeImage', reference?: string | null, tag?: string | null, name?: string | null }> | null } | null } | null }> } | null } };

export type ProjectV3QueryVariables = Exact<{
  userId: Scalars['ID'];
  projectName: Scalars['String'];
  environmentName: Scalars['String'];
  name: Scalars['String'];
}>;


export type ProjectV3Query = { __typename?: 'Query', user: { __typename?: 'User', id: string, projectV3Adapters?: { __typename?: 'ProjectV3AdapterConnection', totalCount: number, nodes: Array<{ __typename?: 'ProjectV3Adapter', name: string, id: string, status?: ProjectV3AdapterStatus | null, isDeployV2: boolean, repo?: { __typename?: 'Repo', id: string } | null, projectV3?: { __typename?: 'ProjectV3', id: string, requirePlanApproval: boolean, name: string, blueprintID: string, blueprintConfiguration?: { __typename?: 'BlueprintHelmConfiguration', source?: { __typename?: 'Source', git?: { __typename?: 'GitSource', repository: string, path?: string | null, ref?: string | null, integration?: { __typename?: 'GitSourceIntegration', githubInstallationID?: number | null, bitbucketIntegrationID?: string | null, gitlabIntegrationID?: string | null } | null } | null, helmRepository?: { __typename?: 'HelmRepositorySource', chart: string, version?: string | null, repositoryURL: string } | null, containerRegistry?: { __typename?: 'ContainerRegistrySource', registryID?: string | null, registryURL?: string | null, repository: string, tag?: string | null } | null } | null } | { __typename?: 'BlueprintManifestConfiguration', source?: { __typename?: 'Source', git?: { __typename?: 'GitSource', repository: string, path?: string | null, ref?: string | null, integration?: { __typename?: 'GitSourceIntegration', githubInstallationID?: number | null, bitbucketIntegrationID?: string | null, gitlabIntegrationID?: string | null } | null } | null } | null } | { __typename?: 'BlueprintTerraformConfiguration', registrySource?: string | null, moduleVersionConstraint?: string | null, githubSource?: string | null, moduleSource?: { __typename?: 'TerraformModuleSource', source: string, version?: string | null, integration?: { __typename?: 'TerraformModuleSourceIntegration', git?: { __typename?: 'GitSourceIntegration', githubInstallationID?: number | null, bitbucketIntegrationID?: string | null, gitlabIntegrationID?: string | null } | null } | null } | null } | null, configuration?: { __typename?: 'HelmProjectV3Configuration', clusterID: string, namespace?: string | null, releaseName: string, values?: any | null } | { __typename?: 'ManifestProjectV3Configuration', clusterID: string, namespace?: string | null } | { __typename?: 'TerraformProjectV3Configuration', stateBackend: { __typename?: 'TerraformStateBackend', s3Bucket?: { __typename?: 'S3BucketConfiguration', awsAccountID: string, bucketName: string, region: string, key?: string | null } | null, gcsBucket?: { __typename?: 'GCSBucketConfiguration', gcpAccountID: string, bucketName: string, location: string, prefix?: string | null } | null, linodeBucket?: { __typename?: 'LinodeBucketConfiguration', linodeAccountId: string, bucketName: string, region: string, key: string } | null }, provider?: { __typename?: 'TerraformProvider', region?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string } | null } | null } | null, variables: Array<{ __typename?: 'BlueprintVariableBoolean', id: string, variableSpecID?: string | null, name: string, booleanValue: boolean } | { __typename?: 'BlueprintVariableFloat', id: string, variableSpecID?: string | null, name: string, floatValue: number } | { __typename?: 'BlueprintVariableInt', id: string, variableSpecID?: string | null, name: string, intValue: number } | { __typename?: 'BlueprintVariableJSON', id: string, variableSpecID?: string | null, name: string, jsonValue: any } | { __typename?: 'BlueprintVariableString', id: string, variableSpecID?: string | null, name: string, stringValue: string }>, driverWorkflows?: Array<{ __typename?: 'BlueprintDriverWorkflow', id: string, status: ProjectV3WorkflowStatus, createdAt: Date, updatedAt: Date, steps: Array<{ __typename?: 'BlueprintDriverWorkflowStep', action: BlueprintDriverWorkflowStepAction, status: BlueprintDriverWorkflowStepStatus, execution?: { __typename?: 'BlueprintDriverActionExecution', id: string, driver: BlueprintDriver, action: BlueprintDriverAction, approvedAt?: Date | null, jobRun?: { __typename?: 'JobRun', id: string, state: JobRunState, createdAt?: Date | null, updatedAt?: Date | null } | null } | null }> }> | null } | null, project?: { __typename?: 'Project', id: string, name: string } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null }> } | null } };

export type BlueprintDriverWorkflowQueryVariables = Exact<{
  id: Scalars['UUID'];
  userId: Scalars['ID'];
}>;


export type BlueprintDriverWorkflowQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, blueprintDriverWorkflow?: { __typename?: 'BlueprintDriverWorkflow', id: string, status: ProjectV3WorkflowStatus, createdAt: Date, updatedAt: Date, steps: Array<{ __typename?: 'BlueprintDriverWorkflowStep', action: BlueprintDriverWorkflowStepAction, status: BlueprintDriverWorkflowStepStatus, execution?: { __typename?: 'BlueprintDriverActionExecution', id: string, driver: BlueprintDriver, action: BlueprintDriverAction, approvedAt?: Date | null, jobRun?: { __typename?: 'JobRun', id: string, state: JobRunState, createdAt?: Date | null, updatedAt?: Date | null, logs?: { __typename?: 'Logs', id: string, completed: boolean, expired: boolean, entries?: Array<{ __typename?: 'LogEntry', text: string, timestamp?: Date | null }> | null } | null } | null } | null }> } | null } };

export type UserContainerRegistriesFragment = { __typename?: 'User', containerRegistries?: Array<{ __typename?: 'ContainerRegistry', id: string, name: string, registry: string, username?: string | null }> | null };

export type UserContainerRegistriesQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UserContainerRegistriesQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, clusters?: Array<{ __typename?: 'Cluster', id: string, containerRegistry?: { __typename?: 'ContainerRegistry', id: string, name: string, credentialProvider?: ContainerRegistryCredentialProvider | null } | null }> | null, containerRegistries?: Array<{ __typename?: 'ContainerRegistry', id: string, name: string, registry: string, username?: string | null }> | null } };

export type RepoCustomizationFragment = { __typename?: 'Repo', id: string, path: string, enabled: boolean, productionBranch?: string | null, deployTarget?: DeployTarget | null, deployType?: DeployType | null, deployService?: boolean | null, deployJob?: boolean | null, image?: string | null, cpu?: string | null, memory?: string | null, updatedAt: Date, disableReason?: DisableReason | null, databaseProvider?: DatabaseProviderType | null, databaseEngine?: DatabaseEngineType | null, name: string, kubernetesCustomization?: { __typename?: 'KubernetesCustomization', serviceAccountName?: string | null, podAnnotations?: any | null, serviceAnnotations?: any | null, ingressAnnotations?: any | null, podSpecPatch?: any | null, ingressSpecPatch?: any | null } | null, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, projectID?: string | null } | null, gpu?: { __typename?: 'GPUSpec', type?: string | null, count: number } | null, tpu?: { __typename?: 'TPUSpec', tfVersion: string, type: string, cores: number } | null, cluster?: { __typename?: 'Cluster', id: string, name: string, domain?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null } | null, autoscaling?: { __typename?: 'Autoscaling', minReplicas: number, maxReplicas: number } | null, owner: { __typename?: 'User', id: string, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, owner: { __typename?: 'User', id: string, login: any } } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null };

export type RepoCustomizationQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type RepoCustomizationQuery = { __typename?: 'Query', repo?: { __typename?: 'Repo', id: string, path: string, enabled: boolean, productionBranch?: string | null, deployTarget?: DeployTarget | null, deployType?: DeployType | null, deployService?: boolean | null, deployJob?: boolean | null, image?: string | null, cpu?: string | null, memory?: string | null, updatedAt: Date, disableReason?: DisableReason | null, databaseProvider?: DatabaseProviderType | null, databaseEngine?: DatabaseEngineType | null, name: string, kubernetesCustomization?: { __typename?: 'KubernetesCustomization', serviceAccountName?: string | null, podAnnotations?: any | null, serviceAnnotations?: any | null, ingressAnnotations?: any | null, podSpecPatch?: any | null, ingressSpecPatch?: any | null } | null, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, projectID?: string | null } | null, gpu?: { __typename?: 'GPUSpec', type?: string | null, count: number } | null, tpu?: { __typename?: 'TPUSpec', tfVersion: string, type: string, cores: number } | null, cluster?: { __typename?: 'Cluster', id: string, name: string, domain?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null } | null, autoscaling?: { __typename?: 'Autoscaling', minReplicas: number, maxReplicas: number } | null, owner: { __typename?: 'User', id: string, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, owner: { __typename?: 'User', id: string, login: any } } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null } | null };

export type RepoRenderPodSpecPatchQueryVariables = Exact<{
  id: Scalars['UUID'];
  patch?: InputMaybe<Scalars['String']>;
}>;


export type RepoRenderPodSpecPatchQuery = { __typename?: 'Query', repo?: { __typename?: 'Repo', id: string, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, renderPodSpec?: string | null } | null } | null };

export type RepoRenderIngressSpecPatchQueryVariables = Exact<{
  id: Scalars['UUID'];
  patch?: InputMaybe<Scalars['String']>;
}>;


export type RepoRenderIngressSpecPatchQuery = { __typename?: 'Query', repo?: { __typename?: 'Repo', id: string, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, renderIngress?: string | null } | null } | null };

export type TeamCommonFragment = { __typename?: 'Team', id: string, plan: { __typename?: 'Plan', tier: PlanTier, billingPeriod?: PlanBillingPeriod | null }, user: { __typename?: 'User', id: string, email?: string | null, createdAt?: Date | null, freeTrialEndsAt?: Date | null, hasPaymentMethod?: boolean | null, paymentError?: string | null, paymentAuthorizationError?: string | null, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null, billingOverview?: { __typename?: 'BillingOverview', hasUpgradedProducts: boolean, isBillingSetup: boolean, currentProducts?: Array<{ __typename?: 'ApiAccess', name?: string | null, description?: string | null, sku: string, displayPrice?: string | null, benefits: Array<string>, productTypeMetadata?: { __typename?: 'ProductTypeMetadata', productType?: ProductType | null, displayName?: string | null, pricingPageAnchor?: string | null } | null, usage: Array<{ __typename?: 'Usage', unit: string, unitPlural: string, displayName: string, currentUsage?: number | null, maximumUsage?: number | null, description?: string | null }> } | { __typename?: 'PlanTierV2', name?: string | null, description?: string | null, sku: string, displayPrice?: string | null, benefits: Array<string>, productTypeMetadata?: { __typename?: 'ProductTypeMetadata', productType?: ProductType | null, displayName?: string | null, pricingPageAnchor?: string | null } | null, usage: Array<{ __typename?: 'Usage', unit: string, unitPlural: string, displayName: string, currentUsage?: number | null, maximumUsage?: number | null, description?: string | null }> } | { __typename?: 'ProjectPack', name?: string | null, description?: string | null, sku: string, displayPrice?: string | null, benefits: Array<string>, productTypeMetadata?: { __typename?: 'ProductTypeMetadata', productType?: ProductType | null, displayName?: string | null, pricingPageAnchor?: string | null } | null, usage: Array<{ __typename?: 'Usage', unit: string, unitPlural: string, displayName: string, currentUsage?: number | null, maximumUsage?: number | null, description?: string | null }> } | { __typename?: 'SupportTier', name?: string | null, description?: string | null, sku: string, displayPrice?: string | null, benefits: Array<string>, productTypeMetadata?: { __typename?: 'ProductTypeMetadata', productType?: ProductType | null, displayName?: string | null, pricingPageAnchor?: string | null } | null, usage: Array<{ __typename?: 'Usage', unit: string, unitPlural: string, displayName: string, currentUsage?: number | null, maximumUsage?: number | null, description?: string | null }> }> | null, externalLinks?: { __typename?: 'ExternalBillingProviderLinks', invoiceHistory: { __typename?: 'UrlOrContactUs', url?: string | null, contactUs?: ContactUs | null }, managePaymentMethod: { __typename?: 'UrlOrContactUs', url?: string | null, contactUs?: ContactUs | null }, downgrade: { __typename?: 'UrlOrContactUs', url?: string | null, contactUs?: ContactUs | null }, help: { __typename?: 'UrlOrContactUs', url?: string | null, contactUs?: ContactUs | null } } | null, subscriptionUsageAllowed: { __typename?: 'SubscriptionUsageAllowed', seats: boolean, clusters: boolean, cloudAccounts: boolean, projects: boolean, customBlueprints: boolean } } | null } };

export type TeamDetailFragment = { __typename?: 'Team', id: string, user: { __typename?: 'User', id: string, hasZeetCloud?: boolean | null, hasOnboarded?: boolean | null, canDeploy?: boolean | null, email?: string | null, createdAt?: Date | null, freeTrialEndsAt?: Date | null, hasPaymentMethod?: boolean | null, paymentError?: string | null, paymentAuthorizationError?: string | null, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null, billingOverview?: { __typename?: 'BillingOverview', hasUpgradedProducts: boolean, isBillingSetup: boolean, currentProducts?: Array<{ __typename?: 'ApiAccess', name?: string | null, description?: string | null, sku: string, displayPrice?: string | null, benefits: Array<string>, productTypeMetadata?: { __typename?: 'ProductTypeMetadata', productType?: ProductType | null, displayName?: string | null, pricingPageAnchor?: string | null } | null, usage: Array<{ __typename?: 'Usage', unit: string, unitPlural: string, displayName: string, currentUsage?: number | null, maximumUsage?: number | null, description?: string | null }> } | { __typename?: 'PlanTierV2', name?: string | null, description?: string | null, sku: string, displayPrice?: string | null, benefits: Array<string>, productTypeMetadata?: { __typename?: 'ProductTypeMetadata', productType?: ProductType | null, displayName?: string | null, pricingPageAnchor?: string | null } | null, usage: Array<{ __typename?: 'Usage', unit: string, unitPlural: string, displayName: string, currentUsage?: number | null, maximumUsage?: number | null, description?: string | null }> } | { __typename?: 'ProjectPack', name?: string | null, description?: string | null, sku: string, displayPrice?: string | null, benefits: Array<string>, productTypeMetadata?: { __typename?: 'ProductTypeMetadata', productType?: ProductType | null, displayName?: string | null, pricingPageAnchor?: string | null } | null, usage: Array<{ __typename?: 'Usage', unit: string, unitPlural: string, displayName: string, currentUsage?: number | null, maximumUsage?: number | null, description?: string | null }> } | { __typename?: 'SupportTier', name?: string | null, description?: string | null, sku: string, displayPrice?: string | null, benefits: Array<string>, productTypeMetadata?: { __typename?: 'ProductTypeMetadata', productType?: ProductType | null, displayName?: string | null, pricingPageAnchor?: string | null } | null, usage: Array<{ __typename?: 'Usage', unit: string, unitPlural: string, displayName: string, currentUsage?: number | null, maximumUsage?: number | null, description?: string | null }> }> | null, externalLinks?: { __typename?: 'ExternalBillingProviderLinks', invoiceHistory: { __typename?: 'UrlOrContactUs', url?: string | null, contactUs?: ContactUs | null }, managePaymentMethod: { __typename?: 'UrlOrContactUs', url?: string | null, contactUs?: ContactUs | null }, downgrade: { __typename?: 'UrlOrContactUs', url?: string | null, contactUs?: ContactUs | null }, help: { __typename?: 'UrlOrContactUs', url?: string | null, contactUs?: ContactUs | null } } | null, subscriptionUsageAllowed: { __typename?: 'SubscriptionUsageAllowed', seats: boolean, clusters: boolean, cloudAccounts: boolean, projects: boolean, customBlueprints: boolean } } | null }, plan: { __typename?: 'Plan', tier: PlanTier, billingPeriod?: PlanBillingPeriod | null } };

export type TeamMemberFragment = { __typename?: 'Team', id: string, members: Array<{ __typename?: 'UserTeamEdge', id: string, role: TeamMemberRole, user: { __typename?: 'User', id: string, name: string, login: any, avatar?: string | null, isTeam?: boolean | null } }>, memberInvitations: Array<{ __typename?: 'TeamMemberInvitation', id: string, role: TeamMemberRole, link: string, email?: string | null, expiresAt?: Date | null, createdAt: Date }> };

export type TeamCloudQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type TeamCloudQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, team?: { __typename?: 'Team', id: string, awsAccounts?: Array<{ __typename?: 'AWSAccount', accountID?: string | null, id: string, iamUsers?: Array<{ __typename?: 'AwsUser', arn: string, userId: string, username: string, attachedAwsPolicies: Array<{ __typename?: 'AttachedAwsIamPolicy', arn: string, policyName: string, groupName: string } | null> }> | null, userIamConnections?: Array<{ __typename?: 'UserIamConnection', userId: string, awsIamArn: string, awsAccountId: string, id: string }> | null }> | null } | null } };

export type UserTeamQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UserTeamQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, team?: { __typename?: 'Team', id: string, user: { __typename?: 'User', id: string, hasZeetCloud?: boolean | null, hasOnboarded?: boolean | null, canDeploy?: boolean | null, email?: string | null, createdAt?: Date | null, freeTrialEndsAt?: Date | null, hasPaymentMethod?: boolean | null, paymentError?: string | null, paymentAuthorizationError?: string | null, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null, billingOverview?: { __typename?: 'BillingOverview', hasUpgradedProducts: boolean, isBillingSetup: boolean, currentProducts?: Array<{ __typename?: 'ApiAccess', name?: string | null, description?: string | null, sku: string, displayPrice?: string | null, benefits: Array<string>, productTypeMetadata?: { __typename?: 'ProductTypeMetadata', productType?: ProductType | null, displayName?: string | null, pricingPageAnchor?: string | null } | null, usage: Array<{ __typename?: 'Usage', unit: string, unitPlural: string, displayName: string, currentUsage?: number | null, maximumUsage?: number | null, description?: string | null }> } | { __typename?: 'PlanTierV2', name?: string | null, description?: string | null, sku: string, displayPrice?: string | null, benefits: Array<string>, productTypeMetadata?: { __typename?: 'ProductTypeMetadata', productType?: ProductType | null, displayName?: string | null, pricingPageAnchor?: string | null } | null, usage: Array<{ __typename?: 'Usage', unit: string, unitPlural: string, displayName: string, currentUsage?: number | null, maximumUsage?: number | null, description?: string | null }> } | { __typename?: 'ProjectPack', name?: string | null, description?: string | null, sku: string, displayPrice?: string | null, benefits: Array<string>, productTypeMetadata?: { __typename?: 'ProductTypeMetadata', productType?: ProductType | null, displayName?: string | null, pricingPageAnchor?: string | null } | null, usage: Array<{ __typename?: 'Usage', unit: string, unitPlural: string, displayName: string, currentUsage?: number | null, maximumUsage?: number | null, description?: string | null }> } | { __typename?: 'SupportTier', name?: string | null, description?: string | null, sku: string, displayPrice?: string | null, benefits: Array<string>, productTypeMetadata?: { __typename?: 'ProductTypeMetadata', productType?: ProductType | null, displayName?: string | null, pricingPageAnchor?: string | null } | null, usage: Array<{ __typename?: 'Usage', unit: string, unitPlural: string, displayName: string, currentUsage?: number | null, maximumUsage?: number | null, description?: string | null }> }> | null, externalLinks?: { __typename?: 'ExternalBillingProviderLinks', invoiceHistory: { __typename?: 'UrlOrContactUs', url?: string | null, contactUs?: ContactUs | null }, managePaymentMethod: { __typename?: 'UrlOrContactUs', url?: string | null, contactUs?: ContactUs | null }, downgrade: { __typename?: 'UrlOrContactUs', url?: string | null, contactUs?: ContactUs | null }, help: { __typename?: 'UrlOrContactUs', url?: string | null, contactUs?: ContactUs | null } } | null, subscriptionUsageAllowed: { __typename?: 'SubscriptionUsageAllowed', seats: boolean, clusters: boolean, cloudAccounts: boolean, projects: boolean, customBlueprints: boolean } } | null }, plan: { __typename?: 'Plan', tier: PlanTier, billingPeriod?: PlanBillingPeriod | null } } | null } };

export type TeamByNameQueryVariables = Exact<{
  name: Scalars['String'];
}>;


export type TeamByNameQuery = { __typename?: 'Query', team?: { __typename?: 'Team', id: string, user: { __typename?: 'User', id: string, hasZeetCloud?: boolean | null, hasOnboarded?: boolean | null, canDeploy?: boolean | null, email?: string | null, createdAt?: Date | null, freeTrialEndsAt?: Date | null, hasPaymentMethod?: boolean | null, paymentError?: string | null, paymentAuthorizationError?: string | null, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null, billingOverview?: { __typename?: 'BillingOverview', hasUpgradedProducts: boolean, isBillingSetup: boolean, currentProducts?: Array<{ __typename?: 'ApiAccess', name?: string | null, description?: string | null, sku: string, displayPrice?: string | null, benefits: Array<string>, productTypeMetadata?: { __typename?: 'ProductTypeMetadata', productType?: ProductType | null, displayName?: string | null, pricingPageAnchor?: string | null } | null, usage: Array<{ __typename?: 'Usage', unit: string, unitPlural: string, displayName: string, currentUsage?: number | null, maximumUsage?: number | null, description?: string | null }> } | { __typename?: 'PlanTierV2', name?: string | null, description?: string | null, sku: string, displayPrice?: string | null, benefits: Array<string>, productTypeMetadata?: { __typename?: 'ProductTypeMetadata', productType?: ProductType | null, displayName?: string | null, pricingPageAnchor?: string | null } | null, usage: Array<{ __typename?: 'Usage', unit: string, unitPlural: string, displayName: string, currentUsage?: number | null, maximumUsage?: number | null, description?: string | null }> } | { __typename?: 'ProjectPack', name?: string | null, description?: string | null, sku: string, displayPrice?: string | null, benefits: Array<string>, productTypeMetadata?: { __typename?: 'ProductTypeMetadata', productType?: ProductType | null, displayName?: string | null, pricingPageAnchor?: string | null } | null, usage: Array<{ __typename?: 'Usage', unit: string, unitPlural: string, displayName: string, currentUsage?: number | null, maximumUsage?: number | null, description?: string | null }> } | { __typename?: 'SupportTier', name?: string | null, description?: string | null, sku: string, displayPrice?: string | null, benefits: Array<string>, productTypeMetadata?: { __typename?: 'ProductTypeMetadata', productType?: ProductType | null, displayName?: string | null, pricingPageAnchor?: string | null } | null, usage: Array<{ __typename?: 'Usage', unit: string, unitPlural: string, displayName: string, currentUsage?: number | null, maximumUsage?: number | null, description?: string | null }> }> | null, externalLinks?: { __typename?: 'ExternalBillingProviderLinks', invoiceHistory: { __typename?: 'UrlOrContactUs', url?: string | null, contactUs?: ContactUs | null }, managePaymentMethod: { __typename?: 'UrlOrContactUs', url?: string | null, contactUs?: ContactUs | null }, downgrade: { __typename?: 'UrlOrContactUs', url?: string | null, contactUs?: ContactUs | null }, help: { __typename?: 'UrlOrContactUs', url?: string | null, contactUs?: ContactUs | null } } | null, subscriptionUsageAllowed: { __typename?: 'SubscriptionUsageAllowed', seats: boolean, clusters: boolean, cloudAccounts: boolean, projects: boolean, customBlueprints: boolean } } | null }, plan: { __typename?: 'Plan', tier: PlanTier, billingPeriod?: PlanBillingPeriod | null } } | null };

export type UserTeamsQueryVariables = Exact<{ [key: string]: never; }>;


export type UserTeamsQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, email?: string | null, teams?: Array<{ __typename?: 'UserTeamEdge', id: string, role: TeamMemberRole, team: { __typename?: 'Team', id: string, plan: { __typename?: 'Plan', tier: PlanTier, billingPeriod?: PlanBillingPeriod | null }, user: { __typename?: 'User', id: string, email?: string | null, createdAt?: Date | null, freeTrialEndsAt?: Date | null, hasPaymentMethod?: boolean | null, paymentError?: string | null, paymentAuthorizationError?: string | null, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null, billingOverview?: { __typename?: 'BillingOverview', hasUpgradedProducts: boolean, isBillingSetup: boolean, currentProducts?: Array<{ __typename?: 'ApiAccess', name?: string | null, description?: string | null, sku: string, displayPrice?: string | null, benefits: Array<string>, productTypeMetadata?: { __typename?: 'ProductTypeMetadata', productType?: ProductType | null, displayName?: string | null, pricingPageAnchor?: string | null } | null, usage: Array<{ __typename?: 'Usage', unit: string, unitPlural: string, displayName: string, currentUsage?: number | null, maximumUsage?: number | null, description?: string | null }> } | { __typename?: 'PlanTierV2', name?: string | null, description?: string | null, sku: string, displayPrice?: string | null, benefits: Array<string>, productTypeMetadata?: { __typename?: 'ProductTypeMetadata', productType?: ProductType | null, displayName?: string | null, pricingPageAnchor?: string | null } | null, usage: Array<{ __typename?: 'Usage', unit: string, unitPlural: string, displayName: string, currentUsage?: number | null, maximumUsage?: number | null, description?: string | null }> } | { __typename?: 'ProjectPack', name?: string | null, description?: string | null, sku: string, displayPrice?: string | null, benefits: Array<string>, productTypeMetadata?: { __typename?: 'ProductTypeMetadata', productType?: ProductType | null, displayName?: string | null, pricingPageAnchor?: string | null } | null, usage: Array<{ __typename?: 'Usage', unit: string, unitPlural: string, displayName: string, currentUsage?: number | null, maximumUsage?: number | null, description?: string | null }> } | { __typename?: 'SupportTier', name?: string | null, description?: string | null, sku: string, displayPrice?: string | null, benefits: Array<string>, productTypeMetadata?: { __typename?: 'ProductTypeMetadata', productType?: ProductType | null, displayName?: string | null, pricingPageAnchor?: string | null } | null, usage: Array<{ __typename?: 'Usage', unit: string, unitPlural: string, displayName: string, currentUsage?: number | null, maximumUsage?: number | null, description?: string | null }> }> | null, externalLinks?: { __typename?: 'ExternalBillingProviderLinks', invoiceHistory: { __typename?: 'UrlOrContactUs', url?: string | null, contactUs?: ContactUs | null }, managePaymentMethod: { __typename?: 'UrlOrContactUs', url?: string | null, contactUs?: ContactUs | null }, downgrade: { __typename?: 'UrlOrContactUs', url?: string | null, contactUs?: ContactUs | null }, help: { __typename?: 'UrlOrContactUs', url?: string | null, contactUs?: ContactUs | null } } | null, subscriptionUsageAllowed: { __typename?: 'SubscriptionUsageAllowed', seats: boolean, clusters: boolean, cloudAccounts: boolean, projects: boolean, customBlueprints: boolean } } | null } } }> | null } };

export type UserTeamsAnalyticsQueryVariables = Exact<{ [key: string]: never; }>;


export type UserTeamsAnalyticsQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, email?: string | null, teams?: Array<{ __typename?: 'UserTeamEdge', id: string, role: TeamMemberRole, team: { __typename?: 'Team', id: string, name: string, members: Array<{ __typename?: 'UserTeamEdge', id: string }>, clusters: { __typename?: 'User', id: string, clusters?: Array<{ __typename?: 'Cluster', id: string, name: string, status?: ClusterStatus | null }> | null }, plan: { __typename?: 'Plan', tier: PlanTier, billingPeriod?: PlanBillingPeriod | null }, user: { __typename?: 'User', id: string, email?: string | null, createdAt?: Date | null, freeTrialEndsAt?: Date | null, hasPaymentMethod?: boolean | null, paymentError?: string | null, paymentAuthorizationError?: string | null, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null, billingOverview?: { __typename?: 'BillingOverview', hasUpgradedProducts: boolean, isBillingSetup: boolean, currentProducts?: Array<{ __typename?: 'ApiAccess', name?: string | null, description?: string | null, sku: string, displayPrice?: string | null, benefits: Array<string>, productTypeMetadata?: { __typename?: 'ProductTypeMetadata', productType?: ProductType | null, displayName?: string | null, pricingPageAnchor?: string | null } | null, usage: Array<{ __typename?: 'Usage', unit: string, unitPlural: string, displayName: string, currentUsage?: number | null, maximumUsage?: number | null, description?: string | null }> } | { __typename?: 'PlanTierV2', name?: string | null, description?: string | null, sku: string, displayPrice?: string | null, benefits: Array<string>, productTypeMetadata?: { __typename?: 'ProductTypeMetadata', productType?: ProductType | null, displayName?: string | null, pricingPageAnchor?: string | null } | null, usage: Array<{ __typename?: 'Usage', unit: string, unitPlural: string, displayName: string, currentUsage?: number | null, maximumUsage?: number | null, description?: string | null }> } | { __typename?: 'ProjectPack', name?: string | null, description?: string | null, sku: string, displayPrice?: string | null, benefits: Array<string>, productTypeMetadata?: { __typename?: 'ProductTypeMetadata', productType?: ProductType | null, displayName?: string | null, pricingPageAnchor?: string | null } | null, usage: Array<{ __typename?: 'Usage', unit: string, unitPlural: string, displayName: string, currentUsage?: number | null, maximumUsage?: number | null, description?: string | null }> } | { __typename?: 'SupportTier', name?: string | null, description?: string | null, sku: string, displayPrice?: string | null, benefits: Array<string>, productTypeMetadata?: { __typename?: 'ProductTypeMetadata', productType?: ProductType | null, displayName?: string | null, pricingPageAnchor?: string | null } | null, usage: Array<{ __typename?: 'Usage', unit: string, unitPlural: string, displayName: string, currentUsage?: number | null, maximumUsage?: number | null, description?: string | null }> }> | null, externalLinks?: { __typename?: 'ExternalBillingProviderLinks', invoiceHistory: { __typename?: 'UrlOrContactUs', url?: string | null, contactUs?: ContactUs | null }, managePaymentMethod: { __typename?: 'UrlOrContactUs', url?: string | null, contactUs?: ContactUs | null }, downgrade: { __typename?: 'UrlOrContactUs', url?: string | null, contactUs?: ContactUs | null }, help: { __typename?: 'UrlOrContactUs', url?: string | null, contactUs?: ContactUs | null } } | null, subscriptionUsageAllowed: { __typename?: 'SubscriptionUsageAllowed', seats: boolean, clusters: boolean, cloudAccounts: boolean, projects: boolean, customBlueprints: boolean } } | null } } }> | null } };

export type UserTeamMemberQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UserTeamMemberQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, team?: { __typename?: 'Team', id: string, plan: { __typename?: 'Plan', tier: PlanTier, billingPeriod?: PlanBillingPeriod | null }, user: { __typename?: 'User', id: string, email?: string | null, createdAt?: Date | null, freeTrialEndsAt?: Date | null, hasPaymentMethod?: boolean | null, paymentError?: string | null, paymentAuthorizationError?: string | null, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null, billingOverview?: { __typename?: 'BillingOverview', hasUpgradedProducts: boolean, isBillingSetup: boolean, currentProducts?: Array<{ __typename?: 'ApiAccess', name?: string | null, description?: string | null, sku: string, displayPrice?: string | null, benefits: Array<string>, productTypeMetadata?: { __typename?: 'ProductTypeMetadata', productType?: ProductType | null, displayName?: string | null, pricingPageAnchor?: string | null } | null, usage: Array<{ __typename?: 'Usage', unit: string, unitPlural: string, displayName: string, currentUsage?: number | null, maximumUsage?: number | null, description?: string | null }> } | { __typename?: 'PlanTierV2', name?: string | null, description?: string | null, sku: string, displayPrice?: string | null, benefits: Array<string>, productTypeMetadata?: { __typename?: 'ProductTypeMetadata', productType?: ProductType | null, displayName?: string | null, pricingPageAnchor?: string | null } | null, usage: Array<{ __typename?: 'Usage', unit: string, unitPlural: string, displayName: string, currentUsage?: number | null, maximumUsage?: number | null, description?: string | null }> } | { __typename?: 'ProjectPack', name?: string | null, description?: string | null, sku: string, displayPrice?: string | null, benefits: Array<string>, productTypeMetadata?: { __typename?: 'ProductTypeMetadata', productType?: ProductType | null, displayName?: string | null, pricingPageAnchor?: string | null } | null, usage: Array<{ __typename?: 'Usage', unit: string, unitPlural: string, displayName: string, currentUsage?: number | null, maximumUsage?: number | null, description?: string | null }> } | { __typename?: 'SupportTier', name?: string | null, description?: string | null, sku: string, displayPrice?: string | null, benefits: Array<string>, productTypeMetadata?: { __typename?: 'ProductTypeMetadata', productType?: ProductType | null, displayName?: string | null, pricingPageAnchor?: string | null } | null, usage: Array<{ __typename?: 'Usage', unit: string, unitPlural: string, displayName: string, currentUsage?: number | null, maximumUsage?: number | null, description?: string | null }> }> | null, externalLinks?: { __typename?: 'ExternalBillingProviderLinks', invoiceHistory: { __typename?: 'UrlOrContactUs', url?: string | null, contactUs?: ContactUs | null }, managePaymentMethod: { __typename?: 'UrlOrContactUs', url?: string | null, contactUs?: ContactUs | null }, downgrade: { __typename?: 'UrlOrContactUs', url?: string | null, contactUs?: ContactUs | null }, help: { __typename?: 'UrlOrContactUs', url?: string | null, contactUs?: ContactUs | null } } | null, subscriptionUsageAllowed: { __typename?: 'SubscriptionUsageAllowed', seats: boolean, clusters: boolean, cloudAccounts: boolean, projects: boolean, customBlueprints: boolean } } | null }, members: Array<{ __typename?: 'UserTeamEdge', id: string, role: TeamMemberRole, user: { __typename?: 'User', id: string, name: string, login: any, avatar?: string | null, isTeam?: boolean | null } }>, memberInvitations: Array<{ __typename?: 'TeamMemberInvitation', id: string, role: TeamMemberRole, link: string, email?: string | null, expiresAt?: Date | null, createdAt: Date }> } | null } };

export type NewTeamMemberSuggestionsQueryVariables = Exact<{ [key: string]: never; }>;


export type NewTeamMemberSuggestionsQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, repos?: Array<{ __typename?: 'Repo', id: string, collaborators?: Array<{ __typename?: 'ProjectCollaborator', id: string, role: ProjectCollaboratorRole, user: { __typename?: 'User', id: string, name: string, login: any, avatar?: string | null, isTeam?: boolean | null } }> | null }> | null } };

export type NewTeamProjectSuggestionsQueryVariables = Exact<{ [key: string]: never; }>;


export type NewTeamProjectSuggestionsQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, repos?: Array<{ __typename?: 'Repo', id: string, path: string, enabled: boolean, productionBranch?: string | null, deployTarget?: DeployTarget | null, deployType?: DeployType | null, deployService?: boolean | null, deployJob?: boolean | null, image?: string | null, cpu?: string | null, memory?: string | null, updatedAt: Date, disableReason?: DisableReason | null, databaseProvider?: DatabaseProviderType | null, databaseEngine?: DatabaseEngineType | null, name: string, volumes?: Array<{ __typename?: 'VolumeSpec', mountPath: string, size: number }> | null, collaborators?: Array<{ __typename?: 'ProjectCollaborator', id: string, role: ProjectCollaboratorRole, user: { __typename?: 'User', id: string, name: string } }> | null, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, projectID?: string | null } | null, gpu?: { __typename?: 'GPUSpec', type?: string | null, count: number } | null, tpu?: { __typename?: 'TPUSpec', tfVersion: string, type: string, cores: number } | null, cluster?: { __typename?: 'Cluster', id: string, name: string, domain?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null } | null, autoscaling?: { __typename?: 'Autoscaling', minReplicas: number, maxReplicas: number } | null, owner: { __typename?: 'User', id: string, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, owner: { __typename?: 'User', id: string, login: any } } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null }> | null } };

export type CurrentUsageMetricsQueryVariables = Exact<{
  id: Scalars['ID'];
  teamID: Scalars['ID'];
  permissionsUserId: Scalars['UUID'];
  pageInput: PageInput;
}>;


export type CurrentUsageMetricsQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, projectV3Adapters?: { __typename?: 'ProjectV3AdapterConnection', totalCount: number } | null, clusters?: Array<{ __typename?: 'Cluster', id: string }> | null, awsAccounts?: Array<{ __typename?: 'AWSAccount', id: string }> | null, coreweaveAccounts?: Array<{ __typename?: 'CoreWeaveAccount', id: string }> | null, doAccounts?: Array<{ __typename?: 'DOAccount', id: string }> | null, gcpAccounts?: Array<{ __typename?: 'GCPAccount', id: string }> | null, linodeAccounts?: Array<{ __typename?: 'LinodeAccount', id: string }> | null, vultrAccounts?: Array<{ __typename?: 'VultrAccount', id: string }> | null, blueprints?: { __typename?: 'BlueprintConnection', totalCount: number, nodes: Array<{ __typename?: 'Blueprint', id: string, owner?: { __typename?: 'BlueprintOwner', login: any } | null }> } | null }, currentUser: { __typename?: 'User', id: string, permissions?: { __typename?: 'UserPermissionsConnection', user?: { __typename?: 'UserPermissionsUserConnection', mutations: Array<any> } | null } | null, team?: { __typename?: 'Team', id: string, members: Array<{ __typename?: 'UserTeamEdge', id: string, role: TeamMemberRole, user: { __typename?: 'User', id: string, name: string, login: any, avatar?: string | null, isTeam?: boolean | null } }>, memberInvitations: Array<{ __typename?: 'TeamMemberInvitation', id: string, role: TeamMemberRole, link: string, email?: string | null, expiresAt?: Date | null, createdAt: Date }> } | null } };

export type TemplateCommonFragment = { __typename?: 'Template', id: string, name: string, description: string, image: string, homepageURL?: string | null, repositoryURL?: string | null, stats?: { __typename?: 'TemplateStats', deploys: number, forks: number, stars: number } | null, projects: Array<{ __typename?: 'ProjectTemplate', id: string, name: string, description: string, image: string, cpu: number, memory: number, gpu?: number | null, dedicated?: boolean | null, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, envs?: Array<{ __typename?: 'EnvVarTemplate', name: string, description: string, value?: string | null, generator?: string | null, reference?: string | null, required: boolean, locked: boolean, hidden: boolean, options?: Array<string> | null }> | null, ports?: Array<{ __typename?: 'Port', port: string, protocol: string, public: boolean, https: boolean }> | null, volumes?: Array<{ __typename?: 'VolumeSpec', mountPath: string, size: number }> | null, replication?: Array<{ __typename?: 'Replication', region: string, replicas?: number | null }> | null }> };

export type TemplateQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']>;
  slug?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
}>;


export type TemplateQuery = { __typename?: 'Query', template: { __typename?: 'Template', id: string, name: string, description: string, image: string, homepageURL?: string | null, repositoryURL?: string | null, stats?: { __typename?: 'TemplateStats', deploys: number, forks: number, stars: number } | null, projects: Array<{ __typename?: 'ProjectTemplate', id: string, name: string, description: string, image: string, cpu: number, memory: number, gpu?: number | null, dedicated?: boolean | null, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, envs?: Array<{ __typename?: 'EnvVarTemplate', name: string, description: string, value?: string | null, generator?: string | null, reference?: string | null, required: boolean, locked: boolean, hidden: boolean, options?: Array<string> | null }> | null, ports?: Array<{ __typename?: 'Port', port: string, protocol: string, public: boolean, https: boolean }> | null, volumes?: Array<{ __typename?: 'VolumeSpec', mountPath: string, size: number }> | null, replication?: Array<{ __typename?: 'Replication', region: string, replicas?: number | null }> | null }> } };

export type SuggestTemplateNameQueryVariables = Exact<{
  user: Scalars['ID'];
  input: SuggestTemplateNameInput;
}>;


export type SuggestTemplateNameQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, suggestTemplateName: string } };

export type CurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, hasZeetCloud?: boolean | null, hasOnboarded?: boolean | null, canDeploy?: boolean | null, email?: string | null, createdAt?: Date | null, freeTrialEndsAt?: Date | null, hasPaymentMethod?: boolean | null, paymentError?: string | null, paymentAuthorizationError?: string | null, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null } };

export type UserQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UserQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, hasZeetCloud?: boolean | null, hasOnboarded?: boolean | null, canDeploy?: boolean | null, email?: string | null, createdAt?: Date | null, freeTrialEndsAt?: Date | null, hasPaymentMethod?: boolean | null, paymentError?: string | null, paymentAuthorizationError?: string | null, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null } };

export type FreeQuotaQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type FreeQuotaQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, freeQuota?: number | null } };

export type UserBillingQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UserBillingQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, billingURL?: string | null } };

export type UserBalanceQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UserBalanceQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, stripe?: { __typename?: 'StripeUser', id: string, balance: number } | null } };

export type AwsPolicyJsonQueryVariables = Exact<{
  userId: Scalars['ID'];
  awsAccountId: Scalars['UUID'];
  awsPolicyJsonInput: AwsPolicyJsonInput;
}>;


export type AwsPolicyJsonQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, awsAccount?: { __typename?: 'AWSAccount', id: string, awsPolicyJson?: { __typename?: 'AwsPolicyJson', awsPolicyJson: any } | null } | null } };

export type UserAwsAccountConnectedQueryVariables = Exact<{
  id: Scalars['ID'];
  awsAccountId: Scalars['UUID'];
}>;


export type UserAwsAccountConnectedQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, awsAccount?: { __typename?: 'AWSAccount', id: string, connected?: boolean | null, cloudFormationURL: string } | null } };

export type UserCrispAuthQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UserCrispAuthQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, crispAuth?: { __typename?: 'CrispAuth', email: string, hmac: string, nickname: string, participants: string } | null } };

export type UserBranchResourcesQueryVariables = Exact<{
  repoId: Scalars['ID'];
  branch?: InputMaybe<Scalars['String']>;
}>;


export type UserBranchResourcesQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, repo?: { __typename?: 'Repo', id: string, branch?: { __typename?: 'RepoBranchV2', id: string, resources?: Array<{ __typename?: 'CloudResource', id: string, resourceType: CloudResourceType, shared: boolean, region: string }> | null } | null } | null } };

export type UserRepoQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UserRepoQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, repo?: { __typename?: 'Repo', id: string, appID?: string | null, defaultIngressDomain?: string | null, kappID?: string | null, useHumanReadableKubernetesName?: boolean | null, namespace?: string | null, deployTarget?: DeployTarget | null, manualDeploy?: boolean | null, deployStrategy?: DeployStrategy | null, free?: boolean | null, cpu?: string | null, memory?: string | null, ephemeralStorage?: number | null, dedicated?: boolean | null, productionBranch?: string | null, serverlessRegion?: string | null, helmValues?: string | null, terraformVersion?: string | null, terraformVariables?: any | null, deployService?: boolean | null, deployJob?: boolean | null, preStopSleep?: number | null, terminationGracePeriodSeconds?: number | null, databaseProvider?: DatabaseProviderType | null, databaseEngine?: DatabaseEngineType | null, databaseVersion?: string | null, autoRetry?: boolean | null, autoRollback?: boolean | null, canDeploy?: boolean | null, awsIamRole?: string | null, gcpServiceAccount?: string | null, datadogApmEnabled?: boolean | null, deployTimeoutSeconds?: number | null, path: string, enabled: boolean, deployType?: DeployType | null, image?: string | null, updatedAt: Date, disableReason?: DisableReason | null, hostNetwork?: boolean | null, staticIP?: boolean | null, noBuildCache?: boolean | null, gitSubmodules?: GitSubmodulesType | null, alternativeImageTagTemplates?: Array<string> | null, name: string, secretMounts?: Array<{ __typename?: 'KubernetesSecretMount', secretName: string, mountPath: string, readOnly: boolean }> | null, kubernetesCustomization?: { __typename?: 'KubernetesCustomization', serviceAccountName?: string | null, podAnnotations?: any | null, serviceAnnotations?: any | null, ingressAnnotations?: any | null } | null, manifest?: { __typename?: 'Manifest', manifests?: Array<string> | null, manifestValue?: string | null, kustomizeDirs?: Array<string> | null } | null, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, environments: Array<{ __typename?: 'ProjectEnvironment', id: string, name: string }>, envs?: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string, visible: boolean, sealed: boolean, source?: { __typename?: 'EnvVarSource', type: EnvVarSourceType } | null }> | null, owner: { __typename?: 'User', id: string, login: any } } | null, productionDeployment?: { __typename?: 'Deployment', id: string, description?: string | null, version: string, status: DeploymentStatus, branch?: string | null, endpoints?: Array<string> | null, privateEndpoint?: string | null, errorMessage?: string | null, updatedAt: Date, createdAt: Date, awsLinks?: { __typename?: 'AWSLinks', rds?: string | null, cloudformation?: string | null, lambda?: string | null, apiGateway?: string | null, cloudwatchLogs?: string | null, cloudwatchMetrics?: string | null } | null, gcpLinks?: { __typename?: 'GCPLinks', deploymentManager?: string | null, cloudRun?: string | null, cloudFunctions?: string | null, cloudFunctionsTrigger?: string | null, cloudLogging?: string | null, cloudMonitoring?: string | null } | null, loadBalancers?: Array<{ __typename?: 'LoadBalancer', dns: Array<string>, ips: Array<string>, ports?: Array<number> | null }> | null, deployStatus?: { __typename?: 'DeployStatus', active: boolean, replicas: number, publicIPs?: Array<string> | null, state: string, errorMessage?: string | null, troubleshooting?: { __typename?: 'Troubleshooting', issue?: { __typename?: 'TroubleshootingIssue', blocks?: Array<{ __typename?: 'TroubleshootingIssueBlock', blockType?: TroubleshootingIssueBlockType | null, content?: string | null }> | null } | null } | null } | null, build?: { __typename?: 'Build', id: string, image?: string | null } | null, alternativeImages?: Array<{ __typename?: 'AlternativeImage', reference?: string | null, tag?: string | null, name?: string | null }> | null } | null, envs?: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string, visible: boolean, sealed: boolean, source?: { __typename?: 'EnvVarSource', type: EnvVarSourceType } | null }> | null, collaborators?: Array<{ __typename?: 'ProjectCollaborator', id: string, role: ProjectCollaboratorRole, user: { __typename?: 'User', id: string, name: string, login: any, avatar?: string | null, isTeam?: boolean | null } }> | null, volumes?: Array<{ __typename?: 'VolumeSpec', mountPath: string, size: number }> | null, replication?: Array<{ __typename?: 'Replication', region: string, replicas?: number | null, cluster?: { __typename?: 'Cluster', id: string, name: string, region?: string | null } | null }> | null, cluster?: { __typename?: 'Cluster', id: string, name: string, region?: string | null, ingressIP?: string | null, connected?: boolean | null, staticIPs?: Array<string> | null, cloudProvider?: CloudProvider | null, clusterProvider?: ClusterProvider | null, state: ClusterState, domain?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, projectID?: string | null } | null, logShipper?: { __typename?: 'LogShipper', type: LogShipperType, logz?: { __typename?: 'LogzIntegration', token: string, url?: string | null } | null, syslog?: { __typename?: 'SyslogIntegration', host: string, port: string, mode: string } | null, logDNA?: { __typename?: 'LogDNAIntegration', key: string } | null, datadog?: { __typename?: 'DatadogLogIntegration', key: string, host?: string | null } | null, betterstack?: { __typename?: 'BetterStackIntegration', token: string } | null } | null, readinessProbe?: { __typename?: 'Probe', command?: string | null, initialDelaySeconds: number, periodSeconds: number, successThreshold: number, failureThreshold: number, timeoutSeconds: number, http?: { __typename?: 'HTTPProbe', host?: string | null, port: string, path?: string | null } | null, tcp?: { __typename?: 'TCPProbe', host?: string | null, port: string } | null } | null, livenessProbe?: { __typename?: 'Probe', command?: string | null, initialDelaySeconds: number, periodSeconds: number, successThreshold: number, failureThreshold: number, timeoutSeconds: number, http?: { __typename?: 'HTTPProbe', host?: string | null, port: string, path?: string | null } | null, tcp?: { __typename?: 'TCPProbe', host?: string | null, port: string } | null } | null, startupProbe?: { __typename?: 'Probe', command?: string | null, initialDelaySeconds: number, periodSeconds: number, successThreshold: number, failureThreshold: number, timeoutSeconds: number, http?: { __typename?: 'HTTPProbe', host?: string | null, port: string, path?: string | null } | null, tcp?: { __typename?: 'TCPProbe', host?: string | null, port: string } | null } | null, gpu?: { __typename?: 'GPUSpec', type?: string | null, count: number } | null, tpu?: { __typename?: 'TPUSpec', type: string, cores: number, tfVersion: string } | null, githubIntegration?: { __typename?: 'GitHubRepoIntegration', id: string, autoDeployBranch: boolean, autoStopBranch: boolean, branchIgnore: string, branchStopIgnore: string, githubRepository?: { __typename?: 'GitHubRepository', id: string, owner: string, name: string } | null } | null, gitlabIntegration?: { __typename?: 'GitlabRepoIntegration', id: string, autoDeployBranch: boolean, autoStopBranch: boolean, branchIgnore: string, branchStopIgnore: string } | null, branchResources?: { __typename?: 'ContainerResourcesSpec', cpu?: number | null, memory?: number | null, ephemeralStorage?: number | null, spot?: boolean | null, accelerator?: { __typename?: 'AcceleratorSpec', type?: string | null, count?: number | null } | null } | null, serverlessResources?: { __typename?: 'ServerlessResourceSpec', cpu?: number | null, memory?: number | null } | null, prometheusScrape?: { __typename?: 'PrometheusScrape', path: string, port: number } | null, jobRuns?: { __typename?: 'JobRunConnection', totalCount: number } | null, autoscaling?: { __typename?: 'Autoscaling', kedaScaledObjectSpec?: string | null, minReplicas: number, maxReplicas: number, coolDownPeriod?: number | null, triggers?: Array<{ __typename?: 'AutoscalingTrigger', type: AutoscalingType, spec: any }> | null } | null, containerRegistry?: { __typename?: 'ContainerRegistry', id: string } | null, databaseEnvs: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string }>, databaseLinks: Array<{ __typename?: 'DatabaseLink', id: string, envPrefix?: string | null, envs?: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string }> | null, database: { __typename?: 'Repo', id: string, path: string, enabled: boolean, productionBranch?: string | null, deployTarget?: DeployTarget | null, deployType?: DeployType | null, deployService?: boolean | null, deployJob?: boolean | null, image?: string | null, cpu?: string | null, memory?: string | null, updatedAt: Date, disableReason?: DisableReason | null, databaseProvider?: DatabaseProviderType | null, databaseEngine?: DatabaseEngineType | null, name: string, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, projectID?: string | null } | null, gpu?: { __typename?: 'GPUSpec', type?: string | null, count: number } | null, tpu?: { __typename?: 'TPUSpec', tfVersion: string, type: string, cores: number } | null, cluster?: { __typename?: 'Cluster', id: string, name: string, domain?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null } | null, autoscaling?: { __typename?: 'Autoscaling', minReplicas: number, maxReplicas: number } | null, owner: { __typename?: 'User', id: string, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, owner: { __typename?: 'User', id: string, login: any } } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null } }>, linkedProjects: Array<{ __typename?: 'DatabaseLink', id: string, envPrefix?: string | null, repo: { __typename?: 'Repo', id: string, path: string, enabled: boolean, productionBranch?: string | null, deployTarget?: DeployTarget | null, deployType?: DeployType | null, deployService?: boolean | null, deployJob?: boolean | null, image?: string | null, cpu?: string | null, memory?: string | null, updatedAt: Date, disableReason?: DisableReason | null, databaseProvider?: DatabaseProviderType | null, databaseEngine?: DatabaseEngineType | null, name: string, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, projectID?: string | null } | null, gpu?: { __typename?: 'GPUSpec', type?: string | null, count: number } | null, tpu?: { __typename?: 'TPUSpec', tfVersion: string, type: string, cores: number } | null, cluster?: { __typename?: 'Cluster', id: string, name: string, domain?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null } | null, autoscaling?: { __typename?: 'Autoscaling', minReplicas: number, maxReplicas: number } | null, owner: { __typename?: 'User', id: string, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, owner: { __typename?: 'User', id: string, login: any } } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null } }>, pipelineCluster?: { __typename?: 'Cluster', id: string } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string, envs?: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string, visible: boolean, sealed: boolean, source?: { __typename?: 'EnvVarSource', type: EnvVarSourceType } | null }> | null } | null, pipelineLinks?: Array<{ __typename?: 'RepoPipelineLink', id: string, sourceEvent: RepoEvent, targetAction: RepoAction, source: { __typename?: 'Repo', id: string }, targetGroup: { __typename?: 'RepoGroup', id: string, selector?: { __typename?: 'LabelSelectors', matchLabels?: any | null } | null } }> | null, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null } | null, owner: { __typename?: 'User', id: string, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, clusterDomains?: Array<{ __typename?: 'ClusterDomains', id: string, cluster: { __typename?: 'Cluster', id: string, name: string }, domains?: Array<{ __typename?: 'CustomDomain', id: string, domain: string, isApex: boolean, cnameTargets?: Array<string> | null, ipTargets?: Array<string> | null, disableCertManager?: boolean | null, certManagerChallengeType?: CertManagerChallengeType | null, syncDomain?: { __typename?: 'CustomDomain', id: string } | null, instructions?: Array<{ __typename?: 'DNSRecord', domain: string, type: DnsRecordType, value?: string | null }> | null, certificate?: { __typename?: 'Certificate', dnsNames?: Array<string> | null, ready: boolean, issuing: boolean, challenges?: Array<{ __typename?: 'CertificateChallenge', dnsName: string, solver: string, statusReason: string, statusState: string, type: string, wildcard: boolean }> | null, instructions?: Array<{ __typename?: 'DNSRecord', domain: string, type: DnsRecordType, value?: string | null }> | null } | null }> | null }> | null, cdns?: Array<{ __typename?: 'CDN', id: string, endpoint?: string | null, state: string, domains?: Array<{ __typename?: 'CDNDomain', domain: string, certReady?: boolean | null, routeReady?: boolean | null, instruction?: { __typename?: 'DNSRecord', domain: string, type: DnsRecordType, value?: string | null } | null }> | null, certificate?: { __typename?: 'Certificate', dnsNames?: Array<string> | null, ready: boolean, issuing: boolean, instructions?: Array<{ __typename?: 'DNSRecord', name?: string | null, domain: string, type: DnsRecordType, value?: string | null }> | null } | null }> | null, ports?: Array<{ __typename?: 'Port', port: string, externalPort: string, protocol: string, public: boolean, https: boolean, grpc: boolean, loadBalancer: boolean }> | null, buildMethod?: { __typename?: 'BuildMethod', name: string, type: BuildType, workingDirectory?: string | null, dockerfilePath?: string | null, buildCommand?: string | null, staticPath?: string | null, runCommand?: string | null, releaseCommand?: string | null, nodejsVersion?: string | null, pythonVersion?: string | null, golangVersion?: string | null } | null, buildResources?: { __typename?: 'ContainerResourcesSpec', cpu?: number | null, memory?: number | null, ephemeralStorage?: number | null, spot?: boolean | null } | null, buildSpec?: { __typename?: 'ContainerSpec', cpu?: number | null, memory?: number | null } | null, kanikoFlags?: { __typename?: 'KanikoFlags', compressedCaching?: boolean | null } | null } | null } };

export type RepoDeployFragment = { __typename?: 'Repo', id: string, canDeploy?: boolean | null, deployTarget?: DeployTarget | null, path: string, enabled: boolean, productionBranch?: string | null, deployType?: DeployType | null, deployService?: boolean | null, deployJob?: boolean | null, image?: string | null, cpu?: string | null, memory?: string | null, updatedAt: Date, disableReason?: DisableReason | null, databaseProvider?: DatabaseProviderType | null, databaseEngine?: DatabaseEngineType | null, name: string, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, projectID?: string | null } | null, gpu?: { __typename?: 'GPUSpec', type?: string | null, count: number } | null, tpu?: { __typename?: 'TPUSpec', tfVersion: string, type: string, cores: number } | null, cluster?: { __typename?: 'Cluster', id: string, name: string, domain?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null } | null, autoscaling?: { __typename?: 'Autoscaling', minReplicas: number, maxReplicas: number } | null, owner: { __typename?: 'User', id: string, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, owner: { __typename?: 'User', id: string, login: any } } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null };

export type UserRepoCloudOnboardByPathQueryVariables = Exact<{
  projectPath?: InputMaybe<Scalars['String']>;
  projectId?: InputMaybe<Scalars['UUID']>;
  repoName: Scalars['String'];
}>;


export type UserRepoCloudOnboardByPathQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id: string, repo?: { __typename?: 'Repo', id: string, canDeploy?: boolean | null, deployTarget?: DeployTarget | null, path: string, enabled: boolean, productionBranch?: string | null, deployType?: DeployType | null, deployService?: boolean | null, deployJob?: boolean | null, image?: string | null, cpu?: string | null, memory?: string | null, updatedAt: Date, disableReason?: DisableReason | null, databaseProvider?: DatabaseProviderType | null, databaseEngine?: DatabaseEngineType | null, name: string, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, projectID?: string | null } | null, gpu?: { __typename?: 'GPUSpec', type?: string | null, count: number } | null, tpu?: { __typename?: 'TPUSpec', tfVersion: string, type: string, cores: number } | null, cluster?: { __typename?: 'Cluster', id: string, name: string, domain?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null } | null, autoscaling?: { __typename?: 'Autoscaling', minReplicas: number, maxReplicas: number } | null, owner: { __typename?: 'User', id: string, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, owner: { __typename?: 'User', id: string, login: any } } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null } | null } | null };

export type RepoForProjectEnvironmentQueryVariables = Exact<{
  path: Scalars['String'];
  environment: Scalars['String'];
  repo: Scalars['String'];
}>;


export type RepoForProjectEnvironmentQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id: string, environment: { __typename?: 'ProjectEnvironment', id: string, name: string, repo?: { __typename?: 'Repo', appID?: string | null, defaultIngressDomain?: string | null, kappID?: string | null, useHumanReadableKubernetesName?: boolean | null, namespace?: string | null, deployTarget?: DeployTarget | null, manualDeploy?: boolean | null, deployStrategy?: DeployStrategy | null, free?: boolean | null, cpu?: string | null, memory?: string | null, ephemeralStorage?: number | null, dedicated?: boolean | null, productionBranch?: string | null, serverlessRegion?: string | null, helmValues?: string | null, terraformVersion?: string | null, terraformVariables?: any | null, deployService?: boolean | null, deployJob?: boolean | null, preStopSleep?: number | null, terminationGracePeriodSeconds?: number | null, databaseProvider?: DatabaseProviderType | null, databaseEngine?: DatabaseEngineType | null, databaseVersion?: string | null, autoRetry?: boolean | null, autoRollback?: boolean | null, canDeploy?: boolean | null, awsIamRole?: string | null, gcpServiceAccount?: string | null, datadogApmEnabled?: boolean | null, deployTimeoutSeconds?: number | null, id: string, path: string, enabled: boolean, deployType?: DeployType | null, image?: string | null, updatedAt: Date, disableReason?: DisableReason | null, hostNetwork?: boolean | null, staticIP?: boolean | null, noBuildCache?: boolean | null, gitSubmodules?: GitSubmodulesType | null, alternativeImageTagTemplates?: Array<string> | null, name: string, secretMounts?: Array<{ __typename?: 'KubernetesSecretMount', secretName: string, mountPath: string, readOnly: boolean }> | null, kubernetesCustomization?: { __typename?: 'KubernetesCustomization', serviceAccountName?: string | null, podAnnotations?: any | null, serviceAnnotations?: any | null, ingressAnnotations?: any | null } | null, manifest?: { __typename?: 'Manifest', manifests?: Array<string> | null, manifestValue?: string | null, kustomizeDirs?: Array<string> | null } | null, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, environments: Array<{ __typename?: 'ProjectEnvironment', id: string, name: string }>, envs?: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string, visible: boolean, sealed: boolean, source?: { __typename?: 'EnvVarSource', type: EnvVarSourceType } | null }> | null, owner: { __typename?: 'User', id: string, login: any } } | null, productionDeployment?: { __typename?: 'Deployment', id: string, description?: string | null, version: string, status: DeploymentStatus, branch?: string | null, endpoints?: Array<string> | null, privateEndpoint?: string | null, errorMessage?: string | null, updatedAt: Date, createdAt: Date, awsLinks?: { __typename?: 'AWSLinks', rds?: string | null, cloudformation?: string | null, lambda?: string | null, apiGateway?: string | null, cloudwatchLogs?: string | null, cloudwatchMetrics?: string | null } | null, gcpLinks?: { __typename?: 'GCPLinks', deploymentManager?: string | null, cloudRun?: string | null, cloudFunctions?: string | null, cloudFunctionsTrigger?: string | null, cloudLogging?: string | null, cloudMonitoring?: string | null } | null, loadBalancers?: Array<{ __typename?: 'LoadBalancer', dns: Array<string>, ips: Array<string>, ports?: Array<number> | null }> | null, deployStatus?: { __typename?: 'DeployStatus', active: boolean, replicas: number, publicIPs?: Array<string> | null, state: string, errorMessage?: string | null, troubleshooting?: { __typename?: 'Troubleshooting', issue?: { __typename?: 'TroubleshootingIssue', blocks?: Array<{ __typename?: 'TroubleshootingIssueBlock', blockType?: TroubleshootingIssueBlockType | null, content?: string | null }> | null } | null } | null } | null, build?: { __typename?: 'Build', id: string, image?: string | null } | null, alternativeImages?: Array<{ __typename?: 'AlternativeImage', reference?: string | null, tag?: string | null, name?: string | null }> | null } | null, envs?: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string, visible: boolean, sealed: boolean, source?: { __typename?: 'EnvVarSource', type: EnvVarSourceType } | null }> | null, collaborators?: Array<{ __typename?: 'ProjectCollaborator', id: string, role: ProjectCollaboratorRole, user: { __typename?: 'User', id: string, name: string, login: any, avatar?: string | null, isTeam?: boolean | null } }> | null, volumes?: Array<{ __typename?: 'VolumeSpec', mountPath: string, size: number }> | null, replication?: Array<{ __typename?: 'Replication', region: string, replicas?: number | null, cluster?: { __typename?: 'Cluster', id: string, name: string, region?: string | null } | null }> | null, cluster?: { __typename?: 'Cluster', id: string, name: string, region?: string | null, ingressIP?: string | null, connected?: boolean | null, staticIPs?: Array<string> | null, cloudProvider?: CloudProvider | null, clusterProvider?: ClusterProvider | null, state: ClusterState, domain?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, projectID?: string | null } | null, logShipper?: { __typename?: 'LogShipper', type: LogShipperType, logz?: { __typename?: 'LogzIntegration', token: string, url?: string | null } | null, syslog?: { __typename?: 'SyslogIntegration', host: string, port: string, mode: string } | null, logDNA?: { __typename?: 'LogDNAIntegration', key: string } | null, datadog?: { __typename?: 'DatadogLogIntegration', key: string, host?: string | null } | null, betterstack?: { __typename?: 'BetterStackIntegration', token: string } | null } | null, readinessProbe?: { __typename?: 'Probe', command?: string | null, initialDelaySeconds: number, periodSeconds: number, successThreshold: number, failureThreshold: number, timeoutSeconds: number, http?: { __typename?: 'HTTPProbe', host?: string | null, port: string, path?: string | null } | null, tcp?: { __typename?: 'TCPProbe', host?: string | null, port: string } | null } | null, livenessProbe?: { __typename?: 'Probe', command?: string | null, initialDelaySeconds: number, periodSeconds: number, successThreshold: number, failureThreshold: number, timeoutSeconds: number, http?: { __typename?: 'HTTPProbe', host?: string | null, port: string, path?: string | null } | null, tcp?: { __typename?: 'TCPProbe', host?: string | null, port: string } | null } | null, startupProbe?: { __typename?: 'Probe', command?: string | null, initialDelaySeconds: number, periodSeconds: number, successThreshold: number, failureThreshold: number, timeoutSeconds: number, http?: { __typename?: 'HTTPProbe', host?: string | null, port: string, path?: string | null } | null, tcp?: { __typename?: 'TCPProbe', host?: string | null, port: string } | null } | null, gpu?: { __typename?: 'GPUSpec', type?: string | null, count: number } | null, tpu?: { __typename?: 'TPUSpec', type: string, cores: number, tfVersion: string } | null, githubIntegration?: { __typename?: 'GitHubRepoIntegration', id: string, autoDeployBranch: boolean, autoStopBranch: boolean, branchIgnore: string, branchStopIgnore: string, githubRepository?: { __typename?: 'GitHubRepository', id: string, owner: string, name: string } | null } | null, gitlabIntegration?: { __typename?: 'GitlabRepoIntegration', id: string, autoDeployBranch: boolean, autoStopBranch: boolean, branchIgnore: string, branchStopIgnore: string } | null, branchResources?: { __typename?: 'ContainerResourcesSpec', cpu?: number | null, memory?: number | null, ephemeralStorage?: number | null, spot?: boolean | null, accelerator?: { __typename?: 'AcceleratorSpec', type?: string | null, count?: number | null } | null } | null, serverlessResources?: { __typename?: 'ServerlessResourceSpec', cpu?: number | null, memory?: number | null } | null, prometheusScrape?: { __typename?: 'PrometheusScrape', path: string, port: number } | null, jobRuns?: { __typename?: 'JobRunConnection', totalCount: number } | null, autoscaling?: { __typename?: 'Autoscaling', kedaScaledObjectSpec?: string | null, minReplicas: number, maxReplicas: number, coolDownPeriod?: number | null, triggers?: Array<{ __typename?: 'AutoscalingTrigger', type: AutoscalingType, spec: any }> | null } | null, containerRegistry?: { __typename?: 'ContainerRegistry', id: string } | null, databaseEnvs: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string }>, databaseLinks: Array<{ __typename?: 'DatabaseLink', id: string, envPrefix?: string | null, envs?: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string }> | null, database: { __typename?: 'Repo', id: string, path: string, enabled: boolean, productionBranch?: string | null, deployTarget?: DeployTarget | null, deployType?: DeployType | null, deployService?: boolean | null, deployJob?: boolean | null, image?: string | null, cpu?: string | null, memory?: string | null, updatedAt: Date, disableReason?: DisableReason | null, databaseProvider?: DatabaseProviderType | null, databaseEngine?: DatabaseEngineType | null, name: string, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, projectID?: string | null } | null, gpu?: { __typename?: 'GPUSpec', type?: string | null, count: number } | null, tpu?: { __typename?: 'TPUSpec', tfVersion: string, type: string, cores: number } | null, cluster?: { __typename?: 'Cluster', id: string, name: string, domain?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null } | null, autoscaling?: { __typename?: 'Autoscaling', minReplicas: number, maxReplicas: number } | null, owner: { __typename?: 'User', id: string, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, owner: { __typename?: 'User', id: string, login: any } } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null } }>, linkedProjects: Array<{ __typename?: 'DatabaseLink', id: string, envPrefix?: string | null, repo: { __typename?: 'Repo', id: string, path: string, enabled: boolean, productionBranch?: string | null, deployTarget?: DeployTarget | null, deployType?: DeployType | null, deployService?: boolean | null, deployJob?: boolean | null, image?: string | null, cpu?: string | null, memory?: string | null, updatedAt: Date, disableReason?: DisableReason | null, databaseProvider?: DatabaseProviderType | null, databaseEngine?: DatabaseEngineType | null, name: string, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, projectID?: string | null } | null, gpu?: { __typename?: 'GPUSpec', type?: string | null, count: number } | null, tpu?: { __typename?: 'TPUSpec', tfVersion: string, type: string, cores: number } | null, cluster?: { __typename?: 'Cluster', id: string, name: string, domain?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null } | null, autoscaling?: { __typename?: 'Autoscaling', minReplicas: number, maxReplicas: number } | null, owner: { __typename?: 'User', id: string, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, owner: { __typename?: 'User', id: string, login: any } } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null } }>, pipelineCluster?: { __typename?: 'Cluster', id: string } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string, envs?: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string, visible: boolean, sealed: boolean, source?: { __typename?: 'EnvVarSource', type: EnvVarSourceType } | null }> | null } | null, pipelineLinks?: Array<{ __typename?: 'RepoPipelineLink', id: string, sourceEvent: RepoEvent, targetAction: RepoAction, source: { __typename?: 'Repo', id: string }, targetGroup: { __typename?: 'RepoGroup', id: string, selector?: { __typename?: 'LabelSelectors', matchLabels?: any | null } | null } }> | null, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null } | null, owner: { __typename?: 'User', id: string, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, clusterDomains?: Array<{ __typename?: 'ClusterDomains', id: string, cluster: { __typename?: 'Cluster', id: string, name: string }, domains?: Array<{ __typename?: 'CustomDomain', id: string, domain: string, isApex: boolean, cnameTargets?: Array<string> | null, ipTargets?: Array<string> | null, disableCertManager?: boolean | null, certManagerChallengeType?: CertManagerChallengeType | null, syncDomain?: { __typename?: 'CustomDomain', id: string } | null, instructions?: Array<{ __typename?: 'DNSRecord', domain: string, type: DnsRecordType, value?: string | null }> | null, certificate?: { __typename?: 'Certificate', dnsNames?: Array<string> | null, ready: boolean, issuing: boolean, challenges?: Array<{ __typename?: 'CertificateChallenge', dnsName: string, solver: string, statusReason: string, statusState: string, type: string, wildcard: boolean }> | null, instructions?: Array<{ __typename?: 'DNSRecord', domain: string, type: DnsRecordType, value?: string | null }> | null } | null }> | null }> | null, cdns?: Array<{ __typename?: 'CDN', id: string, endpoint?: string | null, state: string, domains?: Array<{ __typename?: 'CDNDomain', domain: string, certReady?: boolean | null, routeReady?: boolean | null, instruction?: { __typename?: 'DNSRecord', domain: string, type: DnsRecordType, value?: string | null } | null }> | null, certificate?: { __typename?: 'Certificate', dnsNames?: Array<string> | null, ready: boolean, issuing: boolean, instructions?: Array<{ __typename?: 'DNSRecord', name?: string | null, domain: string, type: DnsRecordType, value?: string | null }> | null } | null }> | null, ports?: Array<{ __typename?: 'Port', port: string, externalPort: string, protocol: string, public: boolean, https: boolean, grpc: boolean, loadBalancer: boolean }> | null, buildMethod?: { __typename?: 'BuildMethod', name: string, type: BuildType, workingDirectory?: string | null, dockerfilePath?: string | null, buildCommand?: string | null, staticPath?: string | null, runCommand?: string | null, releaseCommand?: string | null, nodejsVersion?: string | null, pythonVersion?: string | null, golangVersion?: string | null } | null, buildResources?: { __typename?: 'ContainerResourcesSpec', cpu?: number | null, memory?: number | null, ephemeralStorage?: number | null, spot?: boolean | null } | null, buildSpec?: { __typename?: 'ContainerSpec', cpu?: number | null, memory?: number | null } | null, kanikoFlags?: { __typename?: 'KanikoFlags', compressedCaching?: boolean | null } | null } | null } } | null };

export type RepoOverviewQueryVariables = Exact<{
  path: Scalars['String'];
  environment: Scalars['String'];
  repo: Scalars['String'];
}>;


export type RepoOverviewQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id: string, environment: { __typename?: 'ProjectEnvironment', id: string, name: string, repo?: { __typename?: 'Repo', id: string, deployTarget?: DeployTarget | null, deployType?: DeployType | null, deployService?: boolean | null, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType }, jobRuns?: { __typename?: 'JobRunConnection', totalCount: number } | null } | null } } | null };

export type RepoForProjectQueryVariables = Exact<{
  path: Scalars['String'];
  repo: Scalars['String'];
}>;


export type RepoForProjectQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id: string, repo?: { __typename?: 'Repo', appID?: string | null, defaultIngressDomain?: string | null, kappID?: string | null, useHumanReadableKubernetesName?: boolean | null, namespace?: string | null, deployTarget?: DeployTarget | null, manualDeploy?: boolean | null, deployStrategy?: DeployStrategy | null, free?: boolean | null, cpu?: string | null, memory?: string | null, ephemeralStorage?: number | null, dedicated?: boolean | null, productionBranch?: string | null, serverlessRegion?: string | null, helmValues?: string | null, terraformVersion?: string | null, terraformVariables?: any | null, deployService?: boolean | null, deployJob?: boolean | null, preStopSleep?: number | null, terminationGracePeriodSeconds?: number | null, databaseProvider?: DatabaseProviderType | null, databaseEngine?: DatabaseEngineType | null, databaseVersion?: string | null, autoRetry?: boolean | null, autoRollback?: boolean | null, canDeploy?: boolean | null, awsIamRole?: string | null, gcpServiceAccount?: string | null, datadogApmEnabled?: boolean | null, deployTimeoutSeconds?: number | null, id: string, path: string, enabled: boolean, deployType?: DeployType | null, image?: string | null, updatedAt: Date, disableReason?: DisableReason | null, hostNetwork?: boolean | null, staticIP?: boolean | null, noBuildCache?: boolean | null, gitSubmodules?: GitSubmodulesType | null, alternativeImageTagTemplates?: Array<string> | null, name: string, secretMounts?: Array<{ __typename?: 'KubernetesSecretMount', secretName: string, mountPath: string, readOnly: boolean }> | null, kubernetesCustomization?: { __typename?: 'KubernetesCustomization', serviceAccountName?: string | null, podAnnotations?: any | null, serviceAnnotations?: any | null, ingressAnnotations?: any | null } | null, manifest?: { __typename?: 'Manifest', manifests?: Array<string> | null, manifestValue?: string | null, kustomizeDirs?: Array<string> | null } | null, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, environments: Array<{ __typename?: 'ProjectEnvironment', id: string, name: string }>, envs?: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string, visible: boolean, sealed: boolean, source?: { __typename?: 'EnvVarSource', type: EnvVarSourceType } | null }> | null, owner: { __typename?: 'User', id: string, login: any } } | null, productionDeployment?: { __typename?: 'Deployment', id: string, description?: string | null, version: string, status: DeploymentStatus, branch?: string | null, endpoints?: Array<string> | null, privateEndpoint?: string | null, errorMessage?: string | null, updatedAt: Date, createdAt: Date, awsLinks?: { __typename?: 'AWSLinks', rds?: string | null, cloudformation?: string | null, lambda?: string | null, apiGateway?: string | null, cloudwatchLogs?: string | null, cloudwatchMetrics?: string | null } | null, gcpLinks?: { __typename?: 'GCPLinks', deploymentManager?: string | null, cloudRun?: string | null, cloudFunctions?: string | null, cloudFunctionsTrigger?: string | null, cloudLogging?: string | null, cloudMonitoring?: string | null } | null, loadBalancers?: Array<{ __typename?: 'LoadBalancer', dns: Array<string>, ips: Array<string>, ports?: Array<number> | null }> | null, deployStatus?: { __typename?: 'DeployStatus', active: boolean, replicas: number, publicIPs?: Array<string> | null, state: string, errorMessage?: string | null, troubleshooting?: { __typename?: 'Troubleshooting', issue?: { __typename?: 'TroubleshootingIssue', blocks?: Array<{ __typename?: 'TroubleshootingIssueBlock', blockType?: TroubleshootingIssueBlockType | null, content?: string | null }> | null } | null } | null } | null, build?: { __typename?: 'Build', id: string, image?: string | null } | null, alternativeImages?: Array<{ __typename?: 'AlternativeImage', reference?: string | null, tag?: string | null, name?: string | null }> | null } | null, envs?: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string, visible: boolean, sealed: boolean, source?: { __typename?: 'EnvVarSource', type: EnvVarSourceType } | null }> | null, collaborators?: Array<{ __typename?: 'ProjectCollaborator', id: string, role: ProjectCollaboratorRole, user: { __typename?: 'User', id: string, name: string, login: any, avatar?: string | null, isTeam?: boolean | null } }> | null, volumes?: Array<{ __typename?: 'VolumeSpec', mountPath: string, size: number }> | null, replication?: Array<{ __typename?: 'Replication', region: string, replicas?: number | null, cluster?: { __typename?: 'Cluster', id: string, name: string, region?: string | null } | null }> | null, cluster?: { __typename?: 'Cluster', id: string, name: string, region?: string | null, ingressIP?: string | null, connected?: boolean | null, staticIPs?: Array<string> | null, cloudProvider?: CloudProvider | null, clusterProvider?: ClusterProvider | null, state: ClusterState, domain?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, projectID?: string | null } | null, logShipper?: { __typename?: 'LogShipper', type: LogShipperType, logz?: { __typename?: 'LogzIntegration', token: string, url?: string | null } | null, syslog?: { __typename?: 'SyslogIntegration', host: string, port: string, mode: string } | null, logDNA?: { __typename?: 'LogDNAIntegration', key: string } | null, datadog?: { __typename?: 'DatadogLogIntegration', key: string, host?: string | null } | null, betterstack?: { __typename?: 'BetterStackIntegration', token: string } | null } | null, readinessProbe?: { __typename?: 'Probe', command?: string | null, initialDelaySeconds: number, periodSeconds: number, successThreshold: number, failureThreshold: number, timeoutSeconds: number, http?: { __typename?: 'HTTPProbe', host?: string | null, port: string, path?: string | null } | null, tcp?: { __typename?: 'TCPProbe', host?: string | null, port: string } | null } | null, livenessProbe?: { __typename?: 'Probe', command?: string | null, initialDelaySeconds: number, periodSeconds: number, successThreshold: number, failureThreshold: number, timeoutSeconds: number, http?: { __typename?: 'HTTPProbe', host?: string | null, port: string, path?: string | null } | null, tcp?: { __typename?: 'TCPProbe', host?: string | null, port: string } | null } | null, startupProbe?: { __typename?: 'Probe', command?: string | null, initialDelaySeconds: number, periodSeconds: number, successThreshold: number, failureThreshold: number, timeoutSeconds: number, http?: { __typename?: 'HTTPProbe', host?: string | null, port: string, path?: string | null } | null, tcp?: { __typename?: 'TCPProbe', host?: string | null, port: string } | null } | null, gpu?: { __typename?: 'GPUSpec', type?: string | null, count: number } | null, tpu?: { __typename?: 'TPUSpec', type: string, cores: number, tfVersion: string } | null, githubIntegration?: { __typename?: 'GitHubRepoIntegration', id: string, autoDeployBranch: boolean, autoStopBranch: boolean, branchIgnore: string, branchStopIgnore: string, githubRepository?: { __typename?: 'GitHubRepository', id: string, owner: string, name: string } | null } | null, gitlabIntegration?: { __typename?: 'GitlabRepoIntegration', id: string, autoDeployBranch: boolean, autoStopBranch: boolean, branchIgnore: string, branchStopIgnore: string } | null, branchResources?: { __typename?: 'ContainerResourcesSpec', cpu?: number | null, memory?: number | null, ephemeralStorage?: number | null, spot?: boolean | null, accelerator?: { __typename?: 'AcceleratorSpec', type?: string | null, count?: number | null } | null } | null, serverlessResources?: { __typename?: 'ServerlessResourceSpec', cpu?: number | null, memory?: number | null } | null, prometheusScrape?: { __typename?: 'PrometheusScrape', path: string, port: number } | null, jobRuns?: { __typename?: 'JobRunConnection', totalCount: number } | null, autoscaling?: { __typename?: 'Autoscaling', kedaScaledObjectSpec?: string | null, minReplicas: number, maxReplicas: number, coolDownPeriod?: number | null, triggers?: Array<{ __typename?: 'AutoscalingTrigger', type: AutoscalingType, spec: any }> | null } | null, containerRegistry?: { __typename?: 'ContainerRegistry', id: string } | null, databaseEnvs: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string }>, databaseLinks: Array<{ __typename?: 'DatabaseLink', id: string, envPrefix?: string | null, envs?: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string }> | null, database: { __typename?: 'Repo', id: string, path: string, enabled: boolean, productionBranch?: string | null, deployTarget?: DeployTarget | null, deployType?: DeployType | null, deployService?: boolean | null, deployJob?: boolean | null, image?: string | null, cpu?: string | null, memory?: string | null, updatedAt: Date, disableReason?: DisableReason | null, databaseProvider?: DatabaseProviderType | null, databaseEngine?: DatabaseEngineType | null, name: string, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, projectID?: string | null } | null, gpu?: { __typename?: 'GPUSpec', type?: string | null, count: number } | null, tpu?: { __typename?: 'TPUSpec', tfVersion: string, type: string, cores: number } | null, cluster?: { __typename?: 'Cluster', id: string, name: string, domain?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null } | null, autoscaling?: { __typename?: 'Autoscaling', minReplicas: number, maxReplicas: number } | null, owner: { __typename?: 'User', id: string, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, owner: { __typename?: 'User', id: string, login: any } } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null } }>, linkedProjects: Array<{ __typename?: 'DatabaseLink', id: string, envPrefix?: string | null, repo: { __typename?: 'Repo', id: string, path: string, enabled: boolean, productionBranch?: string | null, deployTarget?: DeployTarget | null, deployType?: DeployType | null, deployService?: boolean | null, deployJob?: boolean | null, image?: string | null, cpu?: string | null, memory?: string | null, updatedAt: Date, disableReason?: DisableReason | null, databaseProvider?: DatabaseProviderType | null, databaseEngine?: DatabaseEngineType | null, name: string, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, projectID?: string | null } | null, gpu?: { __typename?: 'GPUSpec', type?: string | null, count: number } | null, tpu?: { __typename?: 'TPUSpec', tfVersion: string, type: string, cores: number } | null, cluster?: { __typename?: 'Cluster', id: string, name: string, domain?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null } | null, autoscaling?: { __typename?: 'Autoscaling', minReplicas: number, maxReplicas: number } | null, owner: { __typename?: 'User', id: string, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, owner: { __typename?: 'User', id: string, login: any } } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null } }>, pipelineCluster?: { __typename?: 'Cluster', id: string } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string, envs?: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string, visible: boolean, sealed: boolean, source?: { __typename?: 'EnvVarSource', type: EnvVarSourceType } | null }> | null } | null, pipelineLinks?: Array<{ __typename?: 'RepoPipelineLink', id: string, sourceEvent: RepoEvent, targetAction: RepoAction, source: { __typename?: 'Repo', id: string }, targetGroup: { __typename?: 'RepoGroup', id: string, selector?: { __typename?: 'LabelSelectors', matchLabels?: any | null } | null } }> | null, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null } | null, owner: { __typename?: 'User', id: string, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, clusterDomains?: Array<{ __typename?: 'ClusterDomains', id: string, cluster: { __typename?: 'Cluster', id: string, name: string }, domains?: Array<{ __typename?: 'CustomDomain', id: string, domain: string, isApex: boolean, cnameTargets?: Array<string> | null, ipTargets?: Array<string> | null, disableCertManager?: boolean | null, certManagerChallengeType?: CertManagerChallengeType | null, syncDomain?: { __typename?: 'CustomDomain', id: string } | null, instructions?: Array<{ __typename?: 'DNSRecord', domain: string, type: DnsRecordType, value?: string | null }> | null, certificate?: { __typename?: 'Certificate', dnsNames?: Array<string> | null, ready: boolean, issuing: boolean, challenges?: Array<{ __typename?: 'CertificateChallenge', dnsName: string, solver: string, statusReason: string, statusState: string, type: string, wildcard: boolean }> | null, instructions?: Array<{ __typename?: 'DNSRecord', domain: string, type: DnsRecordType, value?: string | null }> | null } | null }> | null }> | null, cdns?: Array<{ __typename?: 'CDN', id: string, endpoint?: string | null, state: string, domains?: Array<{ __typename?: 'CDNDomain', domain: string, certReady?: boolean | null, routeReady?: boolean | null, instruction?: { __typename?: 'DNSRecord', domain: string, type: DnsRecordType, value?: string | null } | null }> | null, certificate?: { __typename?: 'Certificate', dnsNames?: Array<string> | null, ready: boolean, issuing: boolean, instructions?: Array<{ __typename?: 'DNSRecord', name?: string | null, domain: string, type: DnsRecordType, value?: string | null }> | null } | null }> | null, ports?: Array<{ __typename?: 'Port', port: string, externalPort: string, protocol: string, public: boolean, https: boolean, grpc: boolean, loadBalancer: boolean }> | null, buildMethod?: { __typename?: 'BuildMethod', name: string, type: BuildType, workingDirectory?: string | null, dockerfilePath?: string | null, buildCommand?: string | null, staticPath?: string | null, runCommand?: string | null, releaseCommand?: string | null, nodejsVersion?: string | null, pythonVersion?: string | null, golangVersion?: string | null } | null, buildResources?: { __typename?: 'ContainerResourcesSpec', cpu?: number | null, memory?: number | null, ephemeralStorage?: number | null, spot?: boolean | null } | null, buildSpec?: { __typename?: 'ContainerSpec', cpu?: number | null, memory?: number | null } | null, kanikoFlags?: { __typename?: 'KanikoFlags', compressedCaching?: boolean | null } | null } | null } | null };

export type RepoPrometheusQueryVariables = Exact<{
  userID: Scalars['ID'];
  clusterID: Scalars['UUID'];
  repoID: Scalars['ID'];
}>;


export type RepoPrometheusQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, cluster?: { __typename?: 'Cluster', id: string, prometheus?: { __typename?: 'Prometheus', url: string, user?: string | null, password?: string | null, token?: string | null } | null } | null, repo?: { __typename?: 'Repo', id: string, kappID?: string | null } | null } };

export type RepoDeployRevisionsQueryVariables = Exact<{
  repoId: Scalars['ID'];
}>;


export type RepoDeployRevisionsQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, repo?: { __typename?: 'Repo', id: string, deploymentConfigurationRevisions: { __typename?: 'RepoDeploymentConfigurationConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean }, nodes: Array<{ __typename?: 'RepoDeploymentConfiguration', revisionData: any, revisionMetadata: { __typename?: 'RevisionMetadata', id: string, description: string, sequenceId: number, createdAt: Date, createdBy: { __typename?: 'User', id: string, login: any, name: string, avatar?: string | null } } }> } } | null } };

type RevisableEntityCommonFragment_ProjectEnvironmentRevision_Fragment = { __typename?: 'ProjectEnvironmentRevision', revisionData: any, revisionMetadata: { __typename?: 'RevisionMetadata', id: string, description: string, sequenceId: number, createdAt: Date, createdBy: { __typename?: 'User', id: string, login: any, name: string, avatar?: string | null } } };

type RevisableEntityCommonFragment_ProjectRevision_Fragment = { __typename?: 'ProjectRevision', revisionData: any, revisionMetadata: { __typename?: 'RevisionMetadata', id: string, description: string, sequenceId: number, createdAt: Date, createdBy: { __typename?: 'User', id: string, login: any, name: string, avatar?: string | null } } };

type RevisableEntityCommonFragment_RepoDeploymentConfiguration_Fragment = { __typename?: 'RepoDeploymentConfiguration', revisionData: any, revisionMetadata: { __typename?: 'RevisionMetadata', id: string, description: string, sequenceId: number, createdAt: Date, createdBy: { __typename?: 'User', id: string, login: any, name: string, avatar?: string | null } } };

export type RevisableEntityCommonFragmentFragment = RevisableEntityCommonFragment_ProjectEnvironmentRevision_Fragment | RevisableEntityCommonFragment_ProjectRevision_Fragment | RevisableEntityCommonFragment_RepoDeploymentConfiguration_Fragment;

export type RepoBranchDeploymentsFragment = { __typename?: 'DeploymentConnection', pageInfo: { __typename?: 'PageInfo', startCursor: string, endCursor: string, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'Deployment', id: string, description?: string | null, version: string, status: DeploymentStatus, branch?: string | null, endpoints?: Array<string> | null, privateEndpoint?: string | null, errorMessage?: string | null, updatedAt: Date, createdAt: Date, awsLinks?: { __typename?: 'AWSLinks', cloudwatchLogs?: string | null } | null, gcpLinks?: { __typename?: 'GCPLinks', cloudLogging?: string | null } | null, deployStatus?: { __typename?: 'DeployStatus', active: boolean, replicas: number, publicIPs?: Array<string> | null, state: string, errorMessage?: string | null, troubleshooting?: { __typename?: 'Troubleshooting', issue?: { __typename?: 'TroubleshootingIssue', blocks?: Array<{ __typename?: 'TroubleshootingIssueBlock', blockType?: TroubleshootingIssueBlockType | null, content?: string | null }> | null } | null } | null } | null, build?: { __typename?: 'Build', id: string, image?: string | null } | null, alternativeImages?: Array<{ __typename?: 'AlternativeImage', reference?: string | null, tag?: string | null, name?: string | null }> | null }> };

export type UserRepoBranchesV2QueryVariables = Exact<{
  id: Scalars['ID'];
  branch?: InputMaybe<Scalars['String']>;
  withBranch: Scalars['Boolean'];
  after: Scalars['String'];
  first: Scalars['Int'];
}>;


export type UserRepoBranchesV2Query = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, repo?: { __typename?: 'Repo', id: string, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, deployments?: { __typename?: 'DeploymentConnection', pageInfo: { __typename?: 'PageInfo', startCursor: string, endCursor: string, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'Deployment', id: string, description?: string | null, version: string, status: DeploymentStatus, branch?: string | null, endpoints?: Array<string> | null, privateEndpoint?: string | null, errorMessage?: string | null, updatedAt: Date, createdAt: Date, awsLinks?: { __typename?: 'AWSLinks', cloudwatchLogs?: string | null } | null, gcpLinks?: { __typename?: 'GCPLinks', cloudLogging?: string | null } | null, deployStatus?: { __typename?: 'DeployStatus', active: boolean, replicas: number, publicIPs?: Array<string> | null, state: string, errorMessage?: string | null, troubleshooting?: { __typename?: 'Troubleshooting', issue?: { __typename?: 'TroubleshootingIssue', blocks?: Array<{ __typename?: 'TroubleshootingIssueBlock', blockType?: TroubleshootingIssueBlockType | null, content?: string | null }> | null } | null } | null } | null, build?: { __typename?: 'Build', id: string, image?: string | null } | null, alternativeImages?: Array<{ __typename?: 'AlternativeImage', reference?: string | null, tag?: string | null, name?: string | null }> | null }> } | null } | null, branch?: { __typename?: 'RepoBranchV2', id: string, deployments?: { __typename?: 'DeploymentConnection', pageInfo: { __typename?: 'PageInfo', startCursor: string, endCursor: string, hasNextPage: boolean, hasPreviousPage: boolean }, nodes: Array<{ __typename?: 'Deployment', id: string, description?: string | null, version: string, status: DeploymentStatus, branch?: string | null, endpoints?: Array<string> | null, privateEndpoint?: string | null, errorMessage?: string | null, updatedAt: Date, createdAt: Date, awsLinks?: { __typename?: 'AWSLinks', cloudwatchLogs?: string | null } | null, gcpLinks?: { __typename?: 'GCPLinks', cloudLogging?: string | null } | null, deployStatus?: { __typename?: 'DeployStatus', active: boolean, replicas: number, publicIPs?: Array<string> | null, state: string, errorMessage?: string | null, troubleshooting?: { __typename?: 'Troubleshooting', issue?: { __typename?: 'TroubleshootingIssue', blocks?: Array<{ __typename?: 'TroubleshootingIssueBlock', blockType?: TroubleshootingIssueBlockType | null, content?: string | null }> | null } | null } | null } | null, build?: { __typename?: 'Build', id: string, image?: string | null } | null, alternativeImages?: Array<{ __typename?: 'AlternativeImage', reference?: string | null, tag?: string | null, name?: string | null }> | null }> } | null } | null } | null } };

export type UserRepoDeploymentsQueryVariables = Exact<{
  id: Scalars['ID'];
  branch?: InputMaybe<Scalars['String']>;
}>;


export type UserRepoDeploymentsQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, repo?: { __typename?: 'Repo', id: string, deployments?: Array<{ __typename?: 'Deployment', id: string, description?: string | null, version: string, status: DeploymentStatus, branch?: string | null, endpoints?: Array<string> | null, privateEndpoint?: string | null, errorMessage?: string | null, updatedAt: Date, createdAt: Date, awsLinks?: { __typename?: 'AWSLinks', cloudwatchLogs?: string | null } | null, gcpLinks?: { __typename?: 'GCPLinks', cloudLogging?: string | null } | null, deployStatus?: { __typename?: 'DeployStatus', active: boolean, replicas: number, publicIPs?: Array<string> | null, state: string, errorMessage?: string | null, troubleshooting?: { __typename?: 'Troubleshooting', issue?: { __typename?: 'TroubleshootingIssue', blocks?: Array<{ __typename?: 'TroubleshootingIssueBlock', blockType?: TroubleshootingIssueBlockType | null, content?: string | null }> | null } | null } | null } | null, build?: { __typename?: 'Build', id: string, image?: string | null } | null, alternativeImages?: Array<{ __typename?: 'AlternativeImage', reference?: string | null, tag?: string | null, name?: string | null }> | null }> | null } | null } };

export type UserReposQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UserReposQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, repos?: Array<{ __typename?: 'Repo', id: string, path: string, enabled: boolean, productionBranch?: string | null, deployTarget?: DeployTarget | null, deployType?: DeployType | null, deployService?: boolean | null, deployJob?: boolean | null, image?: string | null, cpu?: string | null, memory?: string | null, updatedAt: Date, disableReason?: DisableReason | null, databaseProvider?: DatabaseProviderType | null, databaseEngine?: DatabaseEngineType | null, name: string, productionDeployment?: { __typename?: 'Deployment', id: string, description?: string | null, version: string, status: DeploymentStatus, branch?: string | null, endpoints?: Array<string> | null, privateEndpoint?: string | null, errorMessage?: string | null, updatedAt: Date, createdAt: Date, deployStatus?: { __typename?: 'DeployStatus', active: boolean, replicas: number, publicIPs?: Array<string> | null, state: string, errorMessage?: string | null, troubleshooting?: { __typename?: 'Troubleshooting', issue?: { __typename?: 'TroubleshootingIssue', blocks?: Array<{ __typename?: 'TroubleshootingIssueBlock', blockType?: TroubleshootingIssueBlockType | null, content?: string | null }> | null } | null } | null } | null, build?: { __typename?: 'Build', id: string, image?: string | null } | null, alternativeImages?: Array<{ __typename?: 'AlternativeImage', reference?: string | null, tag?: string | null, name?: string | null }> | null } | null, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, projectID?: string | null } | null, gpu?: { __typename?: 'GPUSpec', type?: string | null, count: number } | null, tpu?: { __typename?: 'TPUSpec', tfVersion: string, type: string, cores: number } | null, cluster?: { __typename?: 'Cluster', id: string, name: string, domain?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null } | null, autoscaling?: { __typename?: 'Autoscaling', minReplicas: number, maxReplicas: number } | null, owner: { __typename?: 'User', id: string, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, owner: { __typename?: 'User', id: string, login: any } } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null }> | null } };

export type ReposForProjectEnvironmentQueryVariables = Exact<{
  path: Scalars['String'];
  environment: Scalars['String'];
}>;


export type ReposForProjectEnvironmentQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id: string, environment: { __typename?: 'ProjectEnvironment', id: string, name: string, repos: Array<{ __typename?: 'Repo', id: string, path: string, enabled: boolean, productionBranch?: string | null, deployTarget?: DeployTarget | null, deployType?: DeployType | null, deployService?: boolean | null, deployJob?: boolean | null, image?: string | null, cpu?: string | null, memory?: string | null, updatedAt: Date, disableReason?: DisableReason | null, databaseProvider?: DatabaseProviderType | null, databaseEngine?: DatabaseEngineType | null, name: string, productionDeployment?: { __typename?: 'Deployment', id: string, description?: string | null, version: string, status: DeploymentStatus, branch?: string | null, endpoints?: Array<string> | null, privateEndpoint?: string | null, errorMessage?: string | null, updatedAt: Date, createdAt: Date, deployStatus?: { __typename?: 'DeployStatus', active: boolean, replicas: number, publicIPs?: Array<string> | null, state: string, errorMessage?: string | null, troubleshooting?: { __typename?: 'Troubleshooting', issue?: { __typename?: 'TroubleshootingIssue', blocks?: Array<{ __typename?: 'TroubleshootingIssueBlock', blockType?: TroubleshootingIssueBlockType | null, content?: string | null }> | null } | null } | null } | null, build?: { __typename?: 'Build', id: string, image?: string | null } | null, alternativeImages?: Array<{ __typename?: 'AlternativeImage', reference?: string | null, tag?: string | null, name?: string | null }> | null } | null, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, projectID?: string | null } | null, gpu?: { __typename?: 'GPUSpec', type?: string | null, count: number } | null, tpu?: { __typename?: 'TPUSpec', tfVersion: string, type: string, cores: number } | null, cluster?: { __typename?: 'Cluster', id: string, name: string, domain?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null } | null, autoscaling?: { __typename?: 'Autoscaling', minReplicas: number, maxReplicas: number } | null, owner: { __typename?: 'User', id: string, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, owner: { __typename?: 'User', id: string, login: any } } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null }> } } | null };

export type ReposForProjectEnvironmentBasicQueryVariables = Exact<{
  path: Scalars['String'];
  environment: Scalars['String'];
}>;


export type ReposForProjectEnvironmentBasicQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id: string, environment: { __typename?: 'ProjectEnvironment', id: string, name: string, repos: Array<{ __typename?: 'Repo', id: string, path: string, enabled: boolean, image?: string | null, name: string, owner: { __typename?: 'User', id: string, login: any }, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, owner: { __typename?: 'User', id: string, login: any } } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null }> } } | null };

export type PaginatedReposForProjectEnvironmentQueryVariables = Exact<{
  path: Scalars['String'];
  environment: Scalars['String'];
  filter: Scalars['String'];
  first: Scalars['Int'];
  after: Scalars['String'];
  sort?: InputMaybe<Scalars['String']>;
  statusFilter?: InputMaybe<Array<InputMaybe<DeploymentStatus>> | InputMaybe<DeploymentStatus>>;
}>;


export type PaginatedReposForProjectEnvironmentQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id: string, environment: { __typename?: 'ProjectEnvironment', id: string, name: string, overview?: Array<{ __typename?: 'EnvironmentOverview', deploymentStatus?: DeploymentStatus | null, count?: number | null } | null> | null, repoConnection: { __typename?: 'RepoConnection', totalCount: number, nodes: Array<{ __typename?: 'Repo', id: string, path: string, enabled: boolean, productionBranch?: string | null, deployTarget?: DeployTarget | null, deployType?: DeployType | null, deployService?: boolean | null, deployJob?: boolean | null, image?: string | null, cpu?: string | null, memory?: string | null, updatedAt: Date, disableReason?: DisableReason | null, databaseProvider?: DatabaseProviderType | null, databaseEngine?: DatabaseEngineType | null, name: string, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, projectID?: string | null } | null, gpu?: { __typename?: 'GPUSpec', type?: string | null, count: number } | null, tpu?: { __typename?: 'TPUSpec', tfVersion: string, type: string, cores: number } | null, cluster?: { __typename?: 'Cluster', id: string, name: string, domain?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null } | null, autoscaling?: { __typename?: 'Autoscaling', minReplicas: number, maxReplicas: number } | null, owner: { __typename?: 'User', id: string, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, owner: { __typename?: 'User', id: string, login: any } } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null }>, pageInfo: { __typename?: 'PageInfo', startCursor: string, endCursor: string, hasNextPage: boolean, hasPreviousPage: boolean } } } } | null };

export type PaginatedRepoDeploymentsForProjectEnvironmentQueryVariables = Exact<{
  path: Scalars['String'];
  environment: Scalars['String'];
  filter: Scalars['String'];
  first: Scalars['Int'];
  after: Scalars['String'];
  sort?: InputMaybe<Scalars['String']>;
  statusFilter?: InputMaybe<Array<InputMaybe<DeploymentStatus>> | InputMaybe<DeploymentStatus>>;
}>;


export type PaginatedRepoDeploymentsForProjectEnvironmentQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id: string, environment: { __typename?: 'ProjectEnvironment', id: string, name: string, overview?: Array<{ __typename?: 'EnvironmentOverview', deploymentStatus?: DeploymentStatus | null, count?: number | null } | null> | null, repoConnection: { __typename?: 'RepoConnection', totalCount: number, nodes: Array<{ __typename?: 'Repo', id: string, productionDeployment?: { __typename?: 'Deployment', id: string, description?: string | null, version: string, status: DeploymentStatus, branch?: string | null, endpoints?: Array<string> | null, privateEndpoint?: string | null, errorMessage?: string | null, updatedAt: Date, createdAt: Date, deployStatus?: { __typename?: 'DeployStatus', active: boolean, replicas: number, publicIPs?: Array<string> | null, state: string, errorMessage?: string | null, troubleshooting?: { __typename?: 'Troubleshooting', issue?: { __typename?: 'TroubleshootingIssue', blocks?: Array<{ __typename?: 'TroubleshootingIssueBlock', blockType?: TroubleshootingIssueBlockType | null, content?: string | null }> | null } | null } | null } | null, build?: { __typename?: 'Build', id: string, image?: string | null } | null, alternativeImages?: Array<{ __typename?: 'AlternativeImage', reference?: string | null, tag?: string | null, name?: string | null }> | null } | null }>, pageInfo: { __typename?: 'PageInfo', startCursor: string, endCursor: string, hasNextPage: boolean, hasPreviousPage: boolean } } } } | null };

export type ReposForProjectQueryVariables = Exact<{
  project: Scalars['String'];
}>;


export type ReposForProjectQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id: string, name: string, repos: Array<{ __typename?: 'Repo', id: string, path: string, enabled: boolean, productionBranch?: string | null, deployTarget?: DeployTarget | null, deployType?: DeployType | null, deployService?: boolean | null, deployJob?: boolean | null, image?: string | null, cpu?: string | null, memory?: string | null, updatedAt: Date, disableReason?: DisableReason | null, databaseProvider?: DatabaseProviderType | null, databaseEngine?: DatabaseEngineType | null, name: string, productionDeployment?: { __typename?: 'Deployment', id: string, description?: string | null, version: string, status: DeploymentStatus, branch?: string | null, endpoints?: Array<string> | null, privateEndpoint?: string | null, errorMessage?: string | null, updatedAt: Date, createdAt: Date, deployStatus?: { __typename?: 'DeployStatus', active: boolean, replicas: number, publicIPs?: Array<string> | null, state: string, errorMessage?: string | null, troubleshooting?: { __typename?: 'Troubleshooting', issue?: { __typename?: 'TroubleshootingIssue', blocks?: Array<{ __typename?: 'TroubleshootingIssueBlock', blockType?: TroubleshootingIssueBlockType | null, content?: string | null }> | null } | null } | null } | null, build?: { __typename?: 'Build', id: string, image?: string | null } | null, alternativeImages?: Array<{ __typename?: 'AlternativeImage', reference?: string | null, tag?: string | null, name?: string | null }> | null } | null, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, projectID?: string | null } | null, gpu?: { __typename?: 'GPUSpec', type?: string | null, count: number } | null, tpu?: { __typename?: 'TPUSpec', tfVersion: string, type: string, cores: number } | null, cluster?: { __typename?: 'Cluster', id: string, name: string, domain?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null } | null, autoscaling?: { __typename?: 'Autoscaling', minReplicas: number, maxReplicas: number } | null, owner: { __typename?: 'User', id: string, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, owner: { __typename?: 'User', id: string, login: any } } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null }> } | null };

export type RepoCommonWithDbFragment = { __typename?: 'Repo', id: string, databaseProvider?: DatabaseProviderType | null, databaseEngine?: DatabaseEngineType | null, databaseVersion?: string | null, path: string, enabled: boolean, productionBranch?: string | null, deployTarget?: DeployTarget | null, deployType?: DeployType | null, deployService?: boolean | null, deployJob?: boolean | null, image?: string | null, cpu?: string | null, memory?: string | null, updatedAt: Date, disableReason?: DisableReason | null, name: string, databaseLinks: Array<{ __typename?: 'DatabaseLink', id: string, envPrefix?: string | null, envs?: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string }> | null, database: { __typename?: 'Repo', id: string, path: string, enabled: boolean, productionBranch?: string | null, deployTarget?: DeployTarget | null, deployType?: DeployType | null, deployService?: boolean | null, deployJob?: boolean | null, image?: string | null, cpu?: string | null, memory?: string | null, updatedAt: Date, disableReason?: DisableReason | null, databaseProvider?: DatabaseProviderType | null, databaseEngine?: DatabaseEngineType | null, name: string, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, projectID?: string | null } | null, gpu?: { __typename?: 'GPUSpec', type?: string | null, count: number } | null, tpu?: { __typename?: 'TPUSpec', tfVersion: string, type: string, cores: number } | null, cluster?: { __typename?: 'Cluster', id: string, name: string, domain?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null } | null, autoscaling?: { __typename?: 'Autoscaling', minReplicas: number, maxReplicas: number } | null, owner: { __typename?: 'User', id: string, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, owner: { __typename?: 'User', id: string, login: any } } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null } }>, linkedProjects: Array<{ __typename?: 'DatabaseLink', id: string, envPrefix?: string | null, repo: { __typename?: 'Repo', id: string, path: string, enabled: boolean, productionBranch?: string | null, deployTarget?: DeployTarget | null, deployType?: DeployType | null, deployService?: boolean | null, deployJob?: boolean | null, image?: string | null, cpu?: string | null, memory?: string | null, updatedAt: Date, disableReason?: DisableReason | null, databaseProvider?: DatabaseProviderType | null, databaseEngine?: DatabaseEngineType | null, name: string, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, projectID?: string | null } | null, gpu?: { __typename?: 'GPUSpec', type?: string | null, count: number } | null, tpu?: { __typename?: 'TPUSpec', tfVersion: string, type: string, cores: number } | null, cluster?: { __typename?: 'Cluster', id: string, name: string, domain?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null } | null, autoscaling?: { __typename?: 'Autoscaling', minReplicas: number, maxReplicas: number } | null, owner: { __typename?: 'User', id: string, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, owner: { __typename?: 'User', id: string, login: any } } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null } }>, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, projectID?: string | null } | null, gpu?: { __typename?: 'GPUSpec', type?: string | null, count: number } | null, tpu?: { __typename?: 'TPUSpec', tfVersion: string, type: string, cores: number } | null, cluster?: { __typename?: 'Cluster', id: string, name: string, domain?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null } | null, autoscaling?: { __typename?: 'Autoscaling', minReplicas: number, maxReplicas: number } | null, owner: { __typename?: 'User', id: string, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, owner: { __typename?: 'User', id: string, login: any } } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null };

export type UserReposWithDbQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UserReposWithDbQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, repos?: Array<{ __typename?: 'Repo', id: string, databaseProvider?: DatabaseProviderType | null, databaseEngine?: DatabaseEngineType | null, databaseVersion?: string | null, path: string, enabled: boolean, productionBranch?: string | null, deployTarget?: DeployTarget | null, deployType?: DeployType | null, deployService?: boolean | null, deployJob?: boolean | null, image?: string | null, cpu?: string | null, memory?: string | null, updatedAt: Date, disableReason?: DisableReason | null, name: string, databaseLinks: Array<{ __typename?: 'DatabaseLink', id: string, envPrefix?: string | null, envs?: Array<{ __typename?: 'EnvVar', id: string, name: string, value: string }> | null, database: { __typename?: 'Repo', id: string, path: string, enabled: boolean, productionBranch?: string | null, deployTarget?: DeployTarget | null, deployType?: DeployType | null, deployService?: boolean | null, deployJob?: boolean | null, image?: string | null, cpu?: string | null, memory?: string | null, updatedAt: Date, disableReason?: DisableReason | null, databaseProvider?: DatabaseProviderType | null, databaseEngine?: DatabaseEngineType | null, name: string, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, projectID?: string | null } | null, gpu?: { __typename?: 'GPUSpec', type?: string | null, count: number } | null, tpu?: { __typename?: 'TPUSpec', tfVersion: string, type: string, cores: number } | null, cluster?: { __typename?: 'Cluster', id: string, name: string, domain?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null } | null, autoscaling?: { __typename?: 'Autoscaling', minReplicas: number, maxReplicas: number } | null, owner: { __typename?: 'User', id: string, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, owner: { __typename?: 'User', id: string, login: any } } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null } }>, linkedProjects: Array<{ __typename?: 'DatabaseLink', id: string, envPrefix?: string | null, repo: { __typename?: 'Repo', id: string, path: string, enabled: boolean, productionBranch?: string | null, deployTarget?: DeployTarget | null, deployType?: DeployType | null, deployService?: boolean | null, deployJob?: boolean | null, image?: string | null, cpu?: string | null, memory?: string | null, updatedAt: Date, disableReason?: DisableReason | null, databaseProvider?: DatabaseProviderType | null, databaseEngine?: DatabaseEngineType | null, name: string, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, projectID?: string | null } | null, gpu?: { __typename?: 'GPUSpec', type?: string | null, count: number } | null, tpu?: { __typename?: 'TPUSpec', tfVersion: string, type: string, cores: number } | null, cluster?: { __typename?: 'Cluster', id: string, name: string, domain?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null } | null, autoscaling?: { __typename?: 'Autoscaling', minReplicas: number, maxReplicas: number } | null, owner: { __typename?: 'User', id: string, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, owner: { __typename?: 'User', id: string, login: any } } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null } }>, source: { __typename?: 'RepoSource', id: string, type: RepoSourceType, name: string }, productionBranchV2?: { __typename?: 'RepoBranchV2', id: string, name: string, gitRef?: string | null } | null, awsAccount?: { __typename?: 'AWSAccount', id: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, projectID?: string | null } | null, gpu?: { __typename?: 'GPUSpec', type?: string | null, count: number } | null, tpu?: { __typename?: 'TPUSpec', tfVersion: string, type: string, cores: number } | null, cluster?: { __typename?: 'Cluster', id: string, name: string, domain?: string | null, awsAccount?: { __typename?: 'AWSAccount', id: string, name: string, accountID?: string | null } | null, gcpAccount?: { __typename?: 'GCPAccount', id: string, name: string, projectID?: string | null } | null, doAccount?: { __typename?: 'DOAccount', id: string, name: string, defaultProject?: string | null } | null, cwAccount?: { __typename?: 'CoreWeaveAccount', id: string, name: string, namespace?: string | null } | null, linodeAccount?: { __typename?: 'LinodeAccount', id: string, name: string, accessTokenPrefix?: string | null } | null, azureAccount?: { __typename?: 'AzureAccount', id: string, name: string, subscriptionID?: string | null } | null, vultrAccount?: { __typename?: 'VultrAccount', id: string, name: string } | null } | null, autoscaling?: { __typename?: 'Autoscaling', minReplicas: number, maxReplicas: number } | null, owner: { __typename?: 'User', id: string, advanced?: boolean | null, name: string, login: any, avatar?: string | null, isTeam?: boolean | null }, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, owner: { __typename?: 'User', id: string, login: any } } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null }> | null } };

export type UserBasicReposQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UserBasicReposQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, login: any, repos?: Array<{ __typename?: 'Repo', id: string, path: string, enabled: boolean, image?: string | null, name: string, owner: { __typename?: 'User', id: string, login: any }, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, owner: { __typename?: 'User', id: string, login: any } } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null }> | null } };

export type UserAllBasicReposQueryVariables = Exact<{ [key: string]: never; }>;


export type UserAllBasicReposQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, teams?: Array<{ __typename?: 'UserTeamEdge', id: string, team: { __typename?: 'Team', id: string, user: { __typename?: 'User', id: string, login: any, repos?: Array<{ __typename?: 'Repo', id: string, path: string, enabled: boolean, image?: string | null, name: string, owner: { __typename?: 'User', id: string, login: any }, project?: { __typename?: 'Project', id: string, name: string, autoCleanupEnabled: boolean, owner: { __typename?: 'User', id: string, login: any } } | null, projectEnvironment?: { __typename?: 'ProjectEnvironment', id: string, name: string } | null }> | null } } }> | null } };

export type DeploymentUpdatedSubscriptionVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeploymentUpdatedSubscription = { __typename?: 'Subscription', deploymentUpdated: { __typename?: 'Deployment', id: string, status: DeploymentStatus, endpoints?: Array<string> | null, build?: { __typename?: 'Build', id: string } | null } };

export type DeploymentBuildLogsAddedSubscriptionVariables = Exact<{
  input: BuildLogsInput;
}>;


export type DeploymentBuildLogsAddedSubscription = { __typename?: 'Subscription', deploymentBuildLogsAdded: { __typename?: 'LogEntry', text: string, timestamp?: Date | null } };

export type CombinedDeploymentMetricsUpdatedSubscriptionVariables = Exact<{
  deploymentID: Scalars['ID'];
}>;


export type CombinedDeploymentMetricsUpdatedSubscription = { __typename?: 'Subscription', deploymentUpdated: { __typename?: 'Deployment', id: string, cpuMetrics?: Array<{ __typename?: 'Metric', timestamp: Date, value?: number | null }> | null, memoryMetrics?: Array<{ __typename?: 'Metric', timestamp: Date, value?: number | null }> | null, networkMetrics?: Array<{ __typename?: 'Metric', timestamp: Date, value?: number | null }> | null, diskMetrics?: Array<{ __typename?: 'Metric', timestamp: Date, value?: number | null }> | null } };

export type CombinedDeploymentMetricsUpdatedV2SubscriptionVariables = Exact<{
  deploymentID: Scalars['ID'];
  deploymentUUID: Scalars['UUID'];
  queryOptions?: InputMaybe<MetricQueryOptions>;
}>;


export type CombinedDeploymentMetricsUpdatedV2Subscription = { __typename?: 'Subscription', deploymentUpdated: { __typename?: 'Deployment', id: string, cpuMetrics?: Array<{ __typename?: 'MetricStream', type?: MetricType | null, query: string, annotations?: Array<{ __typename?: 'MetricAnnotation', type: MetricAnnotationType, direction: MetricAnnotationDirection, function?: MetricAnnotationFunction | null, label?: string | null, value?: number | null }> | null, labels?: Array<{ __typename?: 'MetricStreamLabel', label: MetricLabelType, value: string }> | null, entries?: Array<{ __typename?: 'MetricEntry', value?: number | null, timestamp: Date }> | null }> | null, memoryMetrics?: Array<{ __typename?: 'MetricStream', type?: MetricType | null, query: string, annotations?: Array<{ __typename?: 'MetricAnnotation', type: MetricAnnotationType, direction: MetricAnnotationDirection, function?: MetricAnnotationFunction | null, label?: string | null, value?: number | null }> | null, labels?: Array<{ __typename?: 'MetricStreamLabel', label: MetricLabelType, value: string }> | null, entries?: Array<{ __typename?: 'MetricEntry', value?: number | null, timestamp: Date }> | null }> | null, networkMetrics?: Array<{ __typename?: 'MetricStream', type?: MetricType | null, query: string, annotations?: Array<{ __typename?: 'MetricAnnotation', type: MetricAnnotationType, direction: MetricAnnotationDirection, function?: MetricAnnotationFunction | null, label?: string | null, value?: number | null }> | null, labels?: Array<{ __typename?: 'MetricStreamLabel', label: MetricLabelType, value: string }> | null, entries?: Array<{ __typename?: 'MetricEntry', value?: number | null, timestamp: Date }> | null }> | null, diskMetrics?: Array<{ __typename?: 'MetricStream', type?: MetricType | null, query: string, annotations?: Array<{ __typename?: 'MetricAnnotation', type: MetricAnnotationType, direction: MetricAnnotationDirection, function?: MetricAnnotationFunction | null, label?: string | null, value?: number | null }> | null, labels?: Array<{ __typename?: 'MetricStreamLabel', label: MetricLabelType, value: string }> | null, entries?: Array<{ __typename?: 'MetricEntry', value?: number | null, timestamp: Date }> | null }> | null } };

export type CombinedLambdaDeploymentMetricsUpdatedSubscriptionVariables = Exact<{
  deploymentID: Scalars['ID'];
}>;


export type CombinedLambdaDeploymentMetricsUpdatedSubscription = { __typename?: 'Subscription', deploymentUpdated: { __typename?: 'Deployment', id: string, awsLinks?: { __typename?: 'AWSLinks', cloudwatchMetrics?: string | null } | null, invocations?: Array<{ __typename?: 'Metric', timestamp: Date, value?: number | null }> | null, errors?: Array<{ __typename?: 'Metric', timestamp: Date, value?: number | null }> | null, duration?: Array<{ __typename?: 'Metric', timestamp: Date, value?: number | null }> | null, concurrentExecutions?: Array<{ __typename?: 'Metric', timestamp: Date, value?: number | null }> | null } };

export type CombinedCloudFunctionDeploymentMetricsUpdatedSubscriptionVariables = Exact<{
  deploymentID: Scalars['ID'];
}>;


export type CombinedCloudFunctionDeploymentMetricsUpdatedSubscription = { __typename?: 'Subscription', deploymentUpdated: { __typename?: 'Deployment', id: string, gcpLinks?: { __typename?: 'GCPLinks', cloudMonitoring?: string | null } | null, executionCount?: Array<{ __typename?: 'Metric', timestamp: Date, value?: number | null }> | null, duration?: Array<{ __typename?: 'Metric', timestamp: Date, value?: number | null }> | null, memoryUsage?: Array<{ __typename?: 'Metric', timestamp: Date, value?: number | null }> | null, activeInstances?: Array<{ __typename?: 'Metric', timestamp: Date, value?: number | null }> | null } };

export type CombinedCloudRunMetricsUpdatedSubscriptionVariables = Exact<{
  deploymentID: Scalars['ID'];
}>;


export type CombinedCloudRunMetricsUpdatedSubscription = { __typename?: 'Subscription', deploymentUpdated: { __typename?: 'Deployment', id: string, gcpLinks?: { __typename?: 'GCPLinks', cloudMonitoring?: string | null } | null, request_count?: Array<{ __typename?: 'Metric', timestamp: Date, value?: number | null }> | null, instance_count?: Array<{ __typename?: 'Metric', timestamp: Date, value?: number | null }> | null, cpu_utilizations?: Array<{ __typename?: 'Metric', timestamp: Date, value?: number | null }> | null, memory_utilizations?: Array<{ __typename?: 'Metric', timestamp: Date, value?: number | null }> | null } };

export type DeploymentBuildMetricsSubscriptionVariables = Exact<{
  deploymentID: Scalars['ID'];
}>;


export type DeploymentBuildMetricsSubscription = { __typename?: 'Subscription', deploymentUpdated: { __typename?: 'Deployment', id: string, build?: { __typename?: 'Build', id: string, cpuMetrics?: Array<{ __typename?: 'Metric', timestamp: Date, value?: number | null }> | null, memoryMetrics?: Array<{ __typename?: 'Metric', timestamp: Date, value?: number | null }> | null } | null } };

export type CombinedAwsRdsMetricsUpdatedSubscriptionVariables = Exact<{
  deploymentID: Scalars['ID'];
}>;


export type CombinedAwsRdsMetricsUpdatedSubscription = { __typename?: 'Subscription', deploymentUpdated: { __typename?: 'Deployment', id: string, awsLinks?: { __typename?: 'AWSLinks', cloudwatchMetrics?: string | null } | null, CPUUtilization?: Array<{ __typename?: 'Metric', timestamp: Date, value?: number | null }> | null, DatabaseConnections?: Array<{ __typename?: 'Metric', timestamp: Date, value?: number | null }> | null, FreeStorageSpace?: Array<{ __typename?: 'Metric', timestamp: Date, value?: number | null }> | null, FreeableMemory?: Array<{ __typename?: 'Metric', timestamp: Date, value?: number | null }> | null, ReadLatency?: Array<{ __typename?: 'Metric', timestamp: Date, value?: number | null }> | null, WriteLatency?: Array<{ __typename?: 'Metric', timestamp: Date, value?: number | null }> | null } };

export const ProjectBasicFragmentDoc = gql`
    fragment ProjectBasic on Project {
  id
  name
  owner {
    id
    login
  }
  autoCleanupEnabled
}
    `;
export const ProjectEnvironmentBasicFragmentDoc = gql`
    fragment ProjectEnvironmentBasic on ProjectEnvironment {
  id
  name
}
    `;
export const RepoBasicFragmentDoc = gql`
    fragment RepoBasic on Repo {
  id
  path
  name: path
  enabled
  image
  owner {
    id
    login
  }
  project {
    id
    ...ProjectBasic
  }
  projectEnvironment {
    id
    ...ProjectEnvironmentBasic
  }
}
    ${ProjectBasicFragmentDoc}
${ProjectEnvironmentBasicFragmentDoc}`;
export const DeploymentCommonFragmentDoc = gql`
    fragment DeploymentCommon on Deployment {
  id
  description
  version
  status
  branch
  endpoints
  privateEndpoint
  errorMessage
  deployStatus {
    active
    replicas
    publicIPs
    state
    errorMessage
    troubleshooting {
      issue {
        blocks {
          blockType
          content
        }
      }
    }
  }
  build {
    id
    image
  }
  alternativeImages {
    reference
    tag
    name
  }
  updatedAt
  createdAt
}
    `;
export const ClusterCloudNamesFragmentDoc = gql`
    fragment ClusterCloudNames on Cluster {
  id
  awsAccount {
    id
    name
    accountID
  }
  gcpAccount {
    id
    name
    projectID
  }
  doAccount {
    id
    name
    defaultProject
  }
  cwAccount {
    id
    name
    namespace
  }
  linodeAccount {
    id
    name
    accessTokenPrefix
  }
  azureAccount {
    id
    name
    subscriptionID
  }
  vultrAccount {
    id
    name
  }
}
    `;
export const UserPublicCommonFragmentDoc = gql`
    fragment UserPublicCommon on User {
  id
  name
  login
  avatar
  isTeam
}
    `;
export const RepoCommonFragmentDoc = gql`
    fragment RepoCommon on Repo {
  id
  path
  name: path
  enabled
  source {
    id
    type
    name
  }
  productionBranch
  productionBranchV2 {
    id
    name
    gitRef
  }
  deployTarget
  deployType
  deployService
  deployJob
  awsAccount {
    id
    accountID
  }
  gcpAccount {
    id
    projectID
  }
  image
  cpu
  memory
  gpu {
    type
    count
  }
  tpu {
    tfVersion
    type
    cores
  }
  updatedAt
  disableReason
  cluster {
    id
    name
    domain
    ...ClusterCloudNames
  }
  databaseProvider
  databaseEngine
  autoscaling {
    minReplicas
    maxReplicas
  }
  owner {
    id
    ...UserPublicCommon
    advanced
  }
  project {
    id
    ...ProjectBasic
  }
  projectEnvironment {
    id
    ...ProjectEnvironmentBasic
  }
}
    ${ClusterCloudNamesFragmentDoc}
${UserPublicCommonFragmentDoc}
${ProjectBasicFragmentDoc}
${ProjectEnvironmentBasicFragmentDoc}`;
export const LambdaLinksFragmentDoc = gql`
    fragment LambdaLinks on AWSLinks {
  cloudformation
  lambda
  apiGateway
  cloudwatchLogs
  cloudwatchMetrics
}
    `;
export const CloudFunctionsLinksFragmentDoc = gql`
    fragment CloudFunctionsLinks on GCPLinks {
  deploymentManager
  cloudRun
  cloudFunctions
  cloudFunctionsTrigger
  cloudLogging
  cloudMonitoring
}
    `;
export const DeploymentDetailFragmentDoc = gql`
    fragment DeploymentDetail on Deployment {
  ...DeploymentCommon
  branch
  buildStage {
    id
  }
  releaseStage {
    id
  }
  deployStage {
    id
  }
  repo {
    id
    ports {
      https
      public
    }
    ...RepoCommon
  }
  awsLinks {
    ...LambdaLinks
    rds
  }
  gcpLinks {
    ...CloudFunctionsLinks
  }
  deploymentError {
    errorID
    errorCode
    message
  }
  createdAt
  updatedAt
}
    ${DeploymentCommonFragmentDoc}
${RepoCommonFragmentDoc}
${LambdaLinksFragmentDoc}
${CloudFunctionsLinksFragmentDoc}`;
export const DomainDetailFragmentDoc = gql`
    fragment DomainDetail on CustomDomain {
  id
  domain
  isApex
  cnameTargets
  ipTargets
  disableCertManager
  certManagerChallengeType
  syncDomain {
    id
  }
  instructions {
    domain
    type
    value
  }
  certificate {
    dnsNames
    ready
    issuing
    challenges {
      dnsName
      solver
      statusReason
      statusState
      type
      wildcard
    }
    instructions {
      domain
      type
      value
    }
  }
}
    `;
export const ClusterDomainsDetailFragmentDoc = gql`
    fragment ClusterDomainsDetail on ClusterDomains {
  id
  cluster {
    id
    name
  }
  domains {
    id
    ...DomainDetail
  }
}
    ${DomainDetailFragmentDoc}`;
export const CdnDetailFragmentDoc = gql`
    fragment CDNDetail on CDN {
  id
  domains {
    domain
    certReady
    routeReady
    instruction {
      domain
      type
      value
    }
  }
  endpoint
  state
  certificate {
    dnsNames
    ready
    issuing
    instructions {
      name
      domain
      type
      value
    }
  }
}
    `;
export const RepoNetworkFragmentDoc = gql`
    fragment RepoNetwork on Repo {
  ...RepoCommon
  clusterDomains {
    id
    ...ClusterDomainsDetail
  }
  cdns {
    id
    ...CDNDetail
  }
  ports {
    port
    externalPort
    protocol
    public
    https
    grpc
    loadBalancer
  }
  hostNetwork
  staticIP
}
    ${RepoCommonFragmentDoc}
${ClusterDomainsDetailFragmentDoc}
${CdnDetailFragmentDoc}`;
export const RepoBuildFragmentDoc = gql`
    fragment RepoBuild on Repo {
  buildMethod {
    name
    type
    workingDirectory
    dockerfilePath
    buildCommand
    staticPath
    runCommand
    releaseCommand
    nodejsVersion
    pythonVersion
    golangVersion
  }
  buildResources {
    cpu
    memory
    ephemeralStorage
    spot
  }
  buildSpec {
    cpu
    memory
  }
  noBuildCache
  gitSubmodules
  kanikoFlags {
    compressedCaching
  }
  alternativeImageTagTemplates
}
    `;
export const CollaboratorCommonFragmentDoc = gql`
    fragment CollaboratorCommon on ProjectCollaborator {
  id
  user {
    ...UserPublicCommon
  }
  role
}
    ${UserPublicCommonFragmentDoc}`;
export const ProbeDetailFragmentDoc = gql`
    fragment ProbeDetail on Probe {
  command
  http {
    host
    port
    path
  }
  tcp {
    host
    port
  }
  initialDelaySeconds
  periodSeconds
  successThreshold
  failureThreshold
  timeoutSeconds
}
    `;
export const ResourcesFragmentDoc = gql`
    fragment Resources on ContainerResourcesSpec {
  cpu
  memory
  ephemeralStorage
  spot
  accelerator {
    type
    count
  }
}
    `;
export const RepoPipelineLinkDetailFragmentDoc = gql`
    fragment RepoPipelineLinkDetail on RepoPipelineLink {
  id
  source {
    id
  }
  sourceEvent
  targetGroup {
    id
    selector {
      matchLabels
    }
  }
  targetAction
}
    `;
export const RepoDetailFragmentDoc = gql`
    fragment RepoDetail on Repo {
  secretMounts {
    secretName
    mountPath
    readOnly
  }
  kubernetesCustomization {
    serviceAccountName
    podAnnotations
    serviceAnnotations
    ingressAnnotations
  }
  manifest {
    manifests
    manifestValue
    kustomizeDirs
  }
  appID
  defaultIngressDomain
  kappID
  useHumanReadableKubernetesName
  ...RepoCommon
  ...RepoNetwork
  ...RepoBuild
  project {
    id
    name
    environments {
      ...ProjectEnvironmentBasic
    }
    envs {
      id
      name
      value
      visible
      sealed
      source {
        type
      }
    }
  }
  productionDeployment {
    ...DeploymentCommon
    awsLinks {
      ...LambdaLinks
      rds
    }
    gcpLinks {
      ...CloudFunctionsLinks
    }
    loadBalancers {
      dns
      ips
      ports
    }
  }
  namespace
  envs {
    id
    name
    value
    visible
    sealed
    source {
      type
    }
  }
  collaborators {
    id
    ...CollaboratorCommon
  }
  volumes {
    mountPath
    size
  }
  replication {
    region
    replicas
    cluster {
      id
      name
      region
    }
  }
  deployTarget
  cluster {
    id
    name
    region
    ingressIP
    connected
    staticIPs
    cloudProvider
    clusterProvider
    state
  }
  awsAccount {
    id
    accountID
  }
  gcpAccount {
    id
    projectID
  }
  logShipper {
    type
    logz {
      token
      url
    }
    syslog {
      host
      port
      mode
    }
    logDNA {
      key
    }
    datadog {
      key
      host
    }
    betterstack {
      token
    }
  }
  readinessProbe {
    ...ProbeDetail
  }
  livenessProbe {
    ...ProbeDetail
  }
  startupProbe {
    ...ProbeDetail
  }
  manualDeploy
  deployStrategy
  free
  cpu
  memory
  gpu {
    type
    count
  }
  tpu {
    type
    cores
    tfVersion
  }
  ephemeralStorage
  dedicated
  githubIntegration {
    id
    githubRepository {
      id
      owner
      name
    }
    autoDeployBranch
    autoStopBranch
    branchIgnore
    branchStopIgnore
  }
  gitlabIntegration {
    id
    autoDeployBranch
    autoStopBranch
    branchIgnore
    branchStopIgnore
  }
  productionBranch
  branchResources {
    ...Resources
  }
  serverlessResources {
    cpu
    memory
  }
  serverlessRegion
  prometheusScrape {
    path
    port
  }
  helmValues
  terraformVersion
  terraformVariables
  jobRuns {
    totalCount
  }
  deployService
  deployJob
  preStopSleep
  terminationGracePeriodSeconds
  autoscaling {
    kedaScaledObjectSpec
    minReplicas
    maxReplicas
    coolDownPeriod
    triggers {
      type
      spec
    }
  }
  containerRegistry {
    id
  }
  databaseProvider
  databaseEngine
  databaseVersion
  databaseEnvs {
    id
    name
    value
  }
  databaseLinks {
    id
    envPrefix
    envs {
      id
      name
      value
    }
    database {
      ...RepoCommon
    }
  }
  linkedProjects {
    id
    envPrefix
    repo {
      ...RepoCommon
    }
  }
  autoRetry
  autoRollback
  canDeploy
  pipelineCluster {
    id
  }
  awsIamRole
  gcpServiceAccount
  datadogApmEnabled
  projectEnvironment {
    id
    name
    envs {
      id
      name
      value
      visible
      sealed
      source {
        type
      }
    }
  }
  pipelineLinks {
    ...RepoPipelineLinkDetail
  }
  deployTimeoutSeconds
}
    ${RepoCommonFragmentDoc}
${RepoNetworkFragmentDoc}
${RepoBuildFragmentDoc}
${ProjectEnvironmentBasicFragmentDoc}
${DeploymentCommonFragmentDoc}
${LambdaLinksFragmentDoc}
${CloudFunctionsLinksFragmentDoc}
${CollaboratorCommonFragmentDoc}
${ProbeDetailFragmentDoc}
${ResourcesFragmentDoc}
${RepoPipelineLinkDetailFragmentDoc}`;
export const GitHubRepoFragmentDoc = gql`
    fragment GitHubRepo on GitHubRepository {
  id
  name
  owner
  url
  description
  isFork
  isPrivate
  primaryLanguage
  updatedAt
}
    `;
export const EnvVarDetailFragmentDoc = gql`
    fragment EnvVarDetail on EnvVar {
  id
  name
  value
  visible
  sealed
  source {
    type
  }
}
    `;
export const MetricStreamFragmentDoc = gql`
    fragment MetricStream on MetricStream {
  type
  query
  annotations {
    type
    direction
    function
    label
    value
  }
  labels {
    label
    value
  }
  entries {
    value
    timestamp
  }
}
    `;
export const ProductDetailFragmentDoc = gql`
    fragment ProductDetail on Product {
  productTypeMetadata {
    productType
    displayName
    pricingPageAnchor
  }
  name
  description
  sku
  displayPrice
  usage {
    unit
    unitPlural
    displayName
    currentUsage
    maximumUsage
    description
  }
  benefits
}
    `;
export const ProductCatalogSectionDetailFragmentDoc = gql`
    fragment ProductCatalogSectionDetail on ProductCatalogSection {
  sectionName
  productTypeMetadata {
    productType
    displayName
    pricingPageAnchor
  }
  allProducts {
    product {
      ...ProductDetail
    }
    description
    status
    available
  }
}
    ${ProductDetailFragmentDoc}`;
export const ProjectBlueprintConfigurationDetailFragmentDoc = gql`
    fragment ProjectBlueprintConfigurationDetail on BlueprintConfiguration {
  ... on BlueprintTerraformConfiguration {
    registrySource
    moduleVersionConstraint
    githubSource
    moduleSource {
      source
      version
      integration {
        git {
          githubInstallationID
          bitbucketIntegrationID
          gitlabIntegrationID
        }
      }
    }
  }
  ... on BlueprintHelmConfiguration {
    source {
      git {
        repository
        path
        ref
        integration {
          githubInstallationID
          bitbucketIntegrationID
          gitlabIntegrationID
        }
      }
      helmRepository {
        chart
        version
        repositoryURL
      }
      containerRegistry {
        registryID
        registryURL
        repository
        tag
      }
    }
  }
  ... on BlueprintManifestConfiguration {
    source {
      git {
        repository
        path
        ref
        integration {
          githubInstallationID
          bitbucketIntegrationID
          gitlabIntegrationID
        }
      }
    }
  }
}
    `;
export const BlueprintListFragmentDoc = gql`
    fragment BlueprintList on Blueprint {
  id
  description
  displayName
  isOfficial
  logoUrl
  enabled
  published
  projectCount
  richInputSchema
  allowedCloudProviders
  slug
  tags
  type
  configuration {
    ...ProjectBlueprintConfigurationDetail
  }
  owner {
    name
    login
  }
  variables {
    id
    name
    type
    required
  }
}
    ${ProjectBlueprintConfigurationDetailFragmentDoc}`;
export const BlueprintMetadataListFragmentDoc = gql`
    fragment BlueprintMetadataList on BlueprintMetadata {
  id
  slug
  name
  displayName
  type
  description
  tags
  logoUrl
  metatags {
    name
    value
  }
  version
  versions {
    version
    prerelease
    timestamp
  }
  latestVersion
  availableVersions
  applicationVersion
  organizationName
  organizationDisplayName
  createdAt
  updatedAt
}
    `;
export const BranchCommonFragmentDoc = gql`
    fragment BranchCommon on RepoBranchV2 {
  id
  name
  gitRef
  createdAt
  updatedAt
  state
  endpoints
  latestDeployment {
    id
    ...DeploymentCommon
  }
}
    ${DeploymentCommonFragmentDoc}`;
export const ProjectV3AdapterConnectionListItemFragmentDoc = gql`
    fragment ProjectV3AdapterConnectionListItem on ProjectV3AdapterConnection {
  pageInfo {
    startCursor
    endCursor
    hasNextPage
    hasPreviousPage
  }
  nodes {
    id
    name
    project {
      id
      name
    }
    projectEnvironment {
      id
      name
    }
  }
  totalCount
}
    `;
export const AwsAccountDetailFragmentDoc = gql`
    fragment AWSAccountDetail on AWSAccount {
  id
  name
  state
  accountID
  roleARN
  cloudFormationURL
  connected
}
    `;
export const GcpAccountDetailFragmentDoc = gql`
    fragment GCPAccountDetail on GCPAccount {
  id
  name
  state
  projectID
  clientEmail
  connected
  error
}
    `;
export const DoAccountDetailFragmentDoc = gql`
    fragment DOAccountDetail on DOAccount {
  id
  name
  state
  accessTokenPrefix
  defaultProject
  connected
}
    `;
export const CwAccountDetailFragmentDoc = gql`
    fragment CWAccountDetail on CoreWeaveAccount {
  id
  name
  state
  namespace
  connected
}
    `;
export const LinodeAccountDetailFragmentDoc = gql`
    fragment LinodeAccountDetail on LinodeAccount {
  id
  name
  state
  accessTokenPrefix
  connected
}
    `;
export const VultrAccountDetailFragmentDoc = gql`
    fragment VultrAccountDetail on VultrAccount {
  id
  name
  state
  connected
}
    `;
export const AzureAccountDetailFragmentDoc = gql`
    fragment AzureAccountDetail on AzureAccount {
  id
  name
  state
  connected
  subscriptionID
  tenantID
  clientID
}
    `;
export const UserCloudsFragmentDoc = gql`
    fragment UserClouds on User {
  awsAccounts {
    id
    clusters {
      id
      name
    }
    projectV3Adapters {
      ...ProjectV3AdapterConnectionListItem
    }
    updatedAt
    ...AWSAccountDetail
  }
  gcpAccounts {
    id
    projectV3Adapters {
      ...ProjectV3AdapterConnectionListItem
    }
    clusters {
      id
      name
    }
    updatedAt
    ...GCPAccountDetail
  }
  doAccounts {
    id
    projectV3Adapters {
      ...ProjectV3AdapterConnectionListItem
    }
    updatedAt
    clusters {
      id
      name
    }
    ...DOAccountDetail
  }
  coreweaveAccounts {
    id
    updatedAt
    clusters {
      id
      name
      projectV3Adapters {
        ...ProjectV3AdapterConnectionListItem
      }
    }
    ...CWAccountDetail
  }
  linodeAccounts {
    id
    projectV3Adapters {
      ...ProjectV3AdapterConnectionListItem
    }
    updatedAt
    clusters {
      id
      name
    }
    ...LinodeAccountDetail
  }
  vultrAccounts {
    id
    clusters {
      id
      name
    }
    projectV3Adapters {
      ...ProjectV3AdapterConnectionListItem
    }
    updatedAt
    ...VultrAccountDetail
  }
  azureAccounts {
    id
    clusters {
      id
      name
    }
    projectV3Adapters {
      ...ProjectV3AdapterConnectionListItem
    }
    updatedAt
    ...AzureAccountDetail
  }
}
    ${ProjectV3AdapterConnectionListItemFragmentDoc}
${AwsAccountDetailFragmentDoc}
${GcpAccountDetailFragmentDoc}
${DoAccountDetailFragmentDoc}
${CwAccountDetailFragmentDoc}
${LinodeAccountDetailFragmentDoc}
${VultrAccountDetailFragmentDoc}
${AzureAccountDetailFragmentDoc}`;
export const ClusterCommonFragmentDoc = gql`
    fragment ClusterCommon on Cluster {
  id
  name
  region
  state
  status
  connected
  domain
  isExternal
  isEjected
  clusterProvider
  cloudProvider
  updatedAt
  createdAt
}
    `;
export const ClusterContainerRegistryFragmentDoc = gql`
    fragment ClusterContainerRegistry on Cluster {
  id
  containerRegistry {
    id
    name
    credentialProvider
    username
  }
  containerRepository
  containerCacheRepository
}
    `;
export const RepoListItemFragmentDoc = gql`
    fragment RepoListItem on Repo {
  ...RepoCommon
  productionDeployment {
    id
    ...DeploymentCommon
  }
}
    ${RepoCommonFragmentDoc}
${DeploymentCommonFragmentDoc}`;
export const ProjectConnectionListItemFragmentDoc = gql`
    fragment ProjectConnectionListItem on ProjectConnection {
  pageInfo {
    startCursor
    endCursor
    hasNextPage
    hasPreviousPage
  }
  nodes {
    id
    repo {
      ...RepoListItem
    }
  }
}
    ${RepoListItemFragmentDoc}`;
export const ClusterListItemFragmentDoc = gql`
    fragment ClusterListItem on Cluster {
  id
  ...ClusterCommon
  ingressIP
  ingressDNS
  clusterProvider
  cloudProvider
  ...ClusterCloudNames
  ...ClusterContainerRegistry
  projects {
    ...ProjectConnectionListItem
  }
  projectV3Adapters {
    ...ProjectV3AdapterConnectionListItem
  }
}
    ${ClusterCommonFragmentDoc}
${ClusterCloudNamesFragmentDoc}
${ClusterContainerRegistryFragmentDoc}
${ProjectConnectionListItemFragmentDoc}
${ProjectV3AdapterConnectionListItemFragmentDoc}`;
export const ClusterComponentsFragmentDoc = gql`
    fragment ClusterComponents on Cluster {
  id
  terraformProjectUrl
  components {
    name
    type
    status
    isInstalledByZeet
    exists
    project {
      id
      project {
        name
      }
      projectEnvironment {
        name
      }
      name
    }
    helmMetadata {
      values
      namespace
      releaseName
      chartRepoGuess
      chartVersion
      chartName
    }
    terraformMetadata {
      jobRunState
    }
  }
}
    `;
export const ClusterCloudAccountIdsFragmentDoc = gql`
    fragment ClusterCloudAccountIds on Cluster {
  cloudAccount {
    ... on AWSAccount {
      id
    }
    ... on AzureAccount {
      id
    }
    ... on CoreWeaveAccount {
      id
    }
    ... on DOAccount {
      id
    }
    ... on GCPAccount {
      id
    }
    ... on LinodeAccount {
      id
    }
    ... on VultrAccount {
      id
    }
  }
}
    `;
export const ClusterDetailFragmentDoc = gql`
    fragment ClusterDetail on Cluster {
  id
  ...ClusterListItem
  ingressIP
  ingressDNS
  ...ClusterComponents
  clusterProvider
  cloudProvider
  ...ClusterCloudNames
  ...ClusterCloudAccountIds
  prometheus {
    url
    user
    password
    token
  }
  grafana {
    url
    user
    password
  }
  ...ClusterContainerRegistry
  deployJob {
    id
    state
  }
}
    ${ClusterListItemFragmentDoc}
${ClusterComponentsFragmentDoc}
${ClusterCloudNamesFragmentDoc}
${ClusterCloudAccountIdsFragmentDoc}
${ClusterContainerRegistryFragmentDoc}`;
export const ClusterDeployTargetFragmentDoc = gql`
    fragment ClusterDeployTarget on Cluster {
  id
  ...ClusterCommon
  clusterProvider
  cloudProvider
  ...ClusterCloudNames
  ...ClusterCloudAccountIds
  ...ClusterContainerRegistry
}
    ${ClusterCommonFragmentDoc}
${ClusterCloudNamesFragmentDoc}
${ClusterCloudAccountIdsFragmentDoc}
${ClusterContainerRegistryFragmentDoc}`;
export const UserCloudDeployTargetsFragmentDoc = gql`
    fragment UserCloudDeployTargets on User {
  id
  hasZeetCloud
  awsAccounts {
    id
    ...AWSAccountDetail
  }
  gcpAccounts {
    id
    ...GCPAccountDetail
  }
  doAccounts {
    id
    ...DOAccountDetail
  }
  linodeAccounts {
    id
    ...LinodeAccountDetail
  }
  coreweaveAccounts {
    id
    ...CWAccountDetail
  }
  azureAccounts {
    id
    ...AzureAccountDetail
  }
  vultrAccounts {
    id
    ...VultrAccountDetail
  }
}
    ${AwsAccountDetailFragmentDoc}
${GcpAccountDetailFragmentDoc}
${DoAccountDetailFragmentDoc}
${LinodeAccountDetailFragmentDoc}
${CwAccountDetailFragmentDoc}
${AzureAccountDetailFragmentDoc}
${VultrAccountDetailFragmentDoc}`;
export const ClusterNamesWithCloudNamesFragmentDoc = gql`
    fragment ClusterNamesWithCloudNames on Cluster {
  id
  name
  ...ClusterCloudNames
}
    ${ClusterCloudNamesFragmentDoc}`;
export const DeploymentBuildLogsFragmentDoc = gql`
    fragment DeploymentBuildLogs on Deployment {
  deploymentError {
    errorID
    errorCode
    message
  }
  build {
    id
    errorMessage
    logs {
      id
      completed
      expired
      entries {
        timestamp
        text
      }
    }
  }
}
    `;
export const DeploymentAlertDetailFragmentDoc = gql`
    fragment DeploymentAlertDetail on DeploymentAlert {
  createdAt
  resolvedAt
  ... on DeploymentPodCrashAlert {
    id
    namespace
    podName
    previousPodLogs {
      entries {
        text
      }
    }
  }
}
    `;
export const GithubDetailFragmentDoc = gql`
    fragment GithubDetail on GitHubRepository {
  defaultBranch {
    id
    name
  }
  ports {
    port
    protocol
    https
    public
  }
  volumes {
    mountPath
    size
  }
  buildMethodSuggestions {
    name
    type
    dockerfilePath
    buildCommand
    staticPath
    runCommand
  }
}
    `;
export const HelmCommonFragmentDoc = gql`
    fragment HelmCommon on HelmChart {
  id
  name
  description
  logoImage
  version
  app_version
  repository {
    id
    name
    url
  }
}
    `;
export const InsightClusterFragmentDoc = gql`
    fragment InsightCluster on Cluster {
  id
  name
  status
  connected
  cloudProvider
}
    `;
export const IntegrationCommonFragmentDoc = gql`
    fragment IntegrationCommon on Integration {
  id
  type
  name
  description
  image
  createdAt
  updatedAt
}
    `;
export const NotificationIntegrationCommonFragmentDoc = gql`
    fragment NotificationIntegrationCommon on NotificationIntegration {
  notificationSettings {
    build
    deploy
    podCrash
    conditions {
      ... on NotificationCondition {
        key
        operator
        value
      }
    }
  }
}
    `;
export const IntegrationDetailFragmentDoc = gql`
    fragment IntegrationDetail on Integration {
  id
  ...IntegrationCommon
  ...NotificationIntegrationCommon
  ... on DiscordWebhookIntegration {
    url
  }
  ... on SlackWebhookIntegration {
    url
  }
  ... on DatadogIntegration {
    apiKey
  }
  ... on GitlabIntegration {
    accessTokenPrefix
    webhookUrl
    webhookToken
  }
  ... on GithubIntegration {
    login
    appID
    installationID
    targetType
  }
  ... on BitbucketIntegration {
    webhookUrl
    webhookToken
    account {
      username
    }
    authType
  }
  ... on EmailIntegration {
    emailAddress
    activated
  }
}
    ${IntegrationCommonFragmentDoc}
${NotificationIntegrationCommonFragmentDoc}`;
export const UserCommonFragmentDoc = gql`
    fragment UserCommon on User {
  id
  ...UserPublicCommon
  email
  createdAt
  freeTrialEndsAt
  hasPaymentMethod
  paymentError
  paymentAuthorizationError
  advanced
}
    ${UserPublicCommonFragmentDoc}`;
export const IpfSServicesFragmentFragmentDoc = gql`
    fragment IpfSServicesFragment on IPFSService {
  id
  state
  apiURL
  nodeURL
  accessToken
  owner {
    id
    ...UserCommon
  }
  api {
    id
    repo {
      id
      clusterDomains {
        id
        domains {
          id
          domain
          ...DomainDetail
        }
      }
    }
  }
}
    ${UserCommonFragmentDoc}
${DomainDetailFragmentDoc}`;
export const JobCommonFragmentDoc = gql`
    fragment JobCommon on JobRun {
  id
  state
  build {
    id
    version
  }
  command
  exitCode
  createdAt
}
    `;
export const SubgroupListItemFragmentDoc = gql`
    fragment SubgroupListItem on ProjectEnvironment {
  id
  name
  updatedAt
}
    `;
export const GroupListItemFragmentDoc = gql`
    fragment GroupListItem on Project {
  id
  name
  updatedAt
  environments {
    ...SubgroupListItem
  }
}
    ${SubgroupListItemFragmentDoc}`;
export const ProjectListItemFragmentDoc = gql`
    fragment ProjectListItem on ProjectV3Adapter {
  id
  name
  repo {
    id
    cluster {
      id
      state
    }
  }
  project {
    id
    name
  }
  projectEnvironment {
    id
    name
  }
  createdAt
  updatedAt
}
    `;
export const ProjectWithRepoFragmentDoc = gql`
    fragment ProjectWithRepo on ProjectV3Adapter {
  repo {
    id
    image
    deployTarget
    deployJob
    source {
      id
      type
      name
    }
    productionDeployment {
      id
      endpoints
      privateEndpoint
    }
  }
}
    `;
export const ProjectContextWithoutEnvironmentFragmentDoc = gql`
    fragment ProjectContextWithoutEnvironment on Project {
  id
  name
  isMultiRepo
  owner {
    id
    login
  }
  autoCleanupEnabled
  createdAt
  updatedAt
}
    `;
export const ProjectContextFragmentDoc = gql`
    fragment ProjectContext on Project {
  id
  name
  isMultiRepo
  defaultEnvironment {
    id
    name
    defaultRepo {
      id
      name
    }
  }
  owner {
    id
    login
  }
  autoCleanupEnabled
  createdAt
  updatedAt
}
    `;
export const ProjectEnvironmentListItemFragmentDoc = gql`
    fragment ProjectEnvironmentListItem on ProjectEnvironment {
  ...ProjectEnvironmentBasic
  updatedAt
  projectV3Adapters {
    totalCount
  }
}
    ${ProjectEnvironmentBasicFragmentDoc}`;
export const ProjectV3ListItemFragmentDoc = gql`
    fragment ProjectV3ListItem on ProjectV3 {
  id
  name
  blueprintID
}
    `;
export const BridgeProjectV3ListFragmentDoc = gql`
    fragment BridgeProjectV3List on ProjectV3Adapter {
  name
  id
  status
  isDeployV2
  projectV3 {
    ...ProjectV3ListItem
  }
  repo {
    ...RepoListItem
  }
  project {
    id
    name
  }
  projectEnvironment {
    id
    name
  }
  updatedAt
}
    ${ProjectV3ListItemFragmentDoc}
${RepoListItemFragmentDoc}`;
export const WorkflowStepWithLogsFragmentDoc = gql`
    fragment WorkflowStepWithLogs on BlueprintDriverWorkflowStep {
  action
  status
  execution {
    id
    driver
    action
    approvedAt
    jobRun {
      id
      state
      logs {
        id
        completed
        expired
        entries {
          text
          timestamp
        }
      }
      createdAt
      updatedAt
    }
  }
}
    `;
export const BlueprintDriverWorkflowDetailFragmentDoc = gql`
    fragment BlueprintDriverWorkflowDetail on BlueprintDriverWorkflow {
  id
  status
  steps {
    ...WorkflowStepWithLogs
  }
  createdAt
  updatedAt
}
    ${WorkflowStepWithLogsFragmentDoc}`;
export const WorkflowStepFragmentDoc = gql`
    fragment WorkflowStep on BlueprintDriverWorkflowStep {
  action
  status
  execution {
    id
    driver
    action
    approvedAt
    jobRun {
      id
      state
      createdAt
      updatedAt
    }
  }
}
    `;
export const BlueprintDriverWorkflowListFragmentDoc = gql`
    fragment BlueprintDriverWorkflowList on BlueprintDriverWorkflow {
  id
  status
  steps {
    ...WorkflowStep
  }
  createdAt
  updatedAt
}
    ${WorkflowStepFragmentDoc}`;
export const ProjectV3DetailFragmentDoc = gql`
    fragment ProjectV3Detail on ProjectV3 {
  id
  requirePlanApproval
  name
  blueprintID
  blueprintConfiguration {
    ...ProjectBlueprintConfigurationDetail
  }
  configuration {
    ... on TerraformProjectV3Configuration {
      stateBackend {
        s3Bucket {
          awsAccountID
          bucketName
          region
          key
        }
        gcsBucket {
          gcpAccountID
          bucketName
          location
          prefix
        }
        linodeBucket {
          linodeAccountId
          bucketName
          region
          key
        }
      }
      provider {
        awsAccount {
          id
        }
        gcpAccount {
          id
        }
        linodeAccount {
          id
        }
        region
      }
    }
    ... on HelmProjectV3Configuration {
      clusterID
      namespace
      releaseName
      values
    }
    ... on ManifestProjectV3Configuration {
      clusterID
      namespace
    }
  }
  variables {
    ... on BlueprintVariableString {
      id
      variableSpecID
      name
      stringValue: value
    }
    ... on BlueprintVariableBoolean {
      id
      variableSpecID
      name
      booleanValue: value
    }
    ... on BlueprintVariableInt {
      id
      variableSpecID
      name
      intValue: value
    }
    ... on BlueprintVariableFloat {
      id
      variableSpecID
      name
      floatValue: value
    }
    ... on BlueprintVariableJSON {
      id
      variableSpecID
      name
      jsonValue: value
    }
  }
  driverWorkflows {
    ...BlueprintDriverWorkflowList
  }
}
    ${ProjectBlueprintConfigurationDetailFragmentDoc}
${BlueprintDriverWorkflowListFragmentDoc}`;
export const ProjectV3AdapterDetailFragmentDoc = gql`
    fragment ProjectV3AdapterDetail on ProjectV3Adapter {
  name
  id
  status
  isDeployV2
  repo {
    id
  }
  projectV3 {
    ...ProjectV3Detail
  }
  project {
    id
    name
  }
  projectEnvironment {
    id
    name
  }
}
    ${ProjectV3DetailFragmentDoc}`;
export const ProjectV3ListItemConnectionFragmentDoc = gql`
    fragment ProjectV3ListItemConnection on ProjectV3AdapterConnection {
  nodes {
    name
    id
    status
    isDeployV2
    projectV3 {
      ...ProjectV3ListItem
    }
    repo {
      ...RepoCommon
    }
    project {
      id
      name
      defaultRepo {
        id
      }
    }
    projectEnvironment {
      id
      name
    }
    updatedAt
  }
}
    ${ProjectV3ListItemFragmentDoc}
${RepoCommonFragmentDoc}`;
export const ProjectV3ProductionDeploymentConnectionFragmentDoc = gql`
    fragment ProjectV3ProductionDeploymentConnection on ProjectV3AdapterConnection {
  nodes {
    id
    repo {
      id
      productionDeployment {
        id
        ...DeploymentCommon
      }
    }
  }
}
    ${DeploymentCommonFragmentDoc}`;
export const UserContainerRegistriesFragmentDoc = gql`
    fragment UserContainerRegistries on User {
  containerRegistries {
    id
    name
    registry
    username
  }
}
    `;
export const RepoCustomizationFragmentDoc = gql`
    fragment RepoCustomization on Repo {
  ...RepoCommon
  kubernetesCustomization {
    serviceAccountName
    podAnnotations
    serviceAnnotations
    ingressAnnotations
    podSpecPatch
    ingressSpecPatch
  }
}
    ${RepoCommonFragmentDoc}`;
export const UrlOrContactUsDetailFragmentDoc = gql`
    fragment UrlOrContactUsDetail on UrlOrContactUs {
  url
  contactUs
}
    `;
export const BillingOverviewDetailFragmentDoc = gql`
    fragment BillingOverviewDetail on BillingOverview {
  currentProducts {
    ...ProductDetail
  }
  hasUpgradedProducts
  isBillingSetup
  externalLinks {
    invoiceHistory {
      ...UrlOrContactUsDetail
    }
    managePaymentMethod {
      ...UrlOrContactUsDetail
    }
    downgrade {
      ...UrlOrContactUsDetail
    }
    help {
      ...UrlOrContactUsDetail
    }
  }
  subscriptionUsageAllowed {
    seats
    clusters
    cloudAccounts
    projects
    customBlueprints
  }
}
    ${ProductDetailFragmentDoc}
${UrlOrContactUsDetailFragmentDoc}`;
export const TeamCommonFragmentDoc = gql`
    fragment TeamCommon on Team {
  id
  plan {
    tier
    billingPeriod
  }
  user {
    id
    ...UserCommon
    billingOverview {
      ...BillingOverviewDetail
    }
  }
}
    ${UserCommonFragmentDoc}
${BillingOverviewDetailFragmentDoc}`;
export const UserDetailFragmentDoc = gql`
    fragment UserDetail on User {
  id
  ...UserCommon
  hasZeetCloud
  hasOnboarded
  canDeploy
}
    ${UserCommonFragmentDoc}`;
export const TeamDetailFragmentDoc = gql`
    fragment TeamDetail on Team {
  id
  ...TeamCommon
  user {
    id
    ...UserDetail
  }
}
    ${TeamCommonFragmentDoc}
${UserDetailFragmentDoc}`;
export const TeamInviteFragmentDoc = gql`
    fragment TeamInvite on TeamMemberInvitation {
  id
  role
  link
  email
  expiresAt
  createdAt
}
    `;
export const TeamMemberFragmentDoc = gql`
    fragment TeamMember on Team {
  id
  members {
    id
    user {
      ...UserPublicCommon
    }
    role
  }
  memberInvitations {
    id
    ...TeamInvite
  }
}
    ${UserPublicCommonFragmentDoc}
${TeamInviteFragmentDoc}`;
export const TemplateCommonFragmentDoc = gql`
    fragment TemplateCommon on Template {
  id
  name
  description
  image
  homepageURL
  repositoryURL
  stats {
    deploys
    forks
    stars
  }
  projects {
    id
    name
    description
    image
    source {
      id
      type
      name
    }
    envs {
      name
      description
      value
      generator
      reference
      required
      locked
      hidden
      options
    }
    ports {
      port
      protocol
      public
      https
    }
    volumes {
      mountPath
      size
    }
    cpu
    memory
    gpu
    dedicated
    replication {
      region
      replicas
    }
  }
}
    `;
export const RepoDeployFragmentDoc = gql`
    fragment RepoDeploy on Repo {
  id
  ...RepoCommon
  canDeploy
  deployTarget
}
    ${RepoCommonFragmentDoc}`;
export const RevisableEntityCommonFragmentFragmentDoc = gql`
    fragment RevisableEntityCommonFragment on RevisableEntity {
  revisionData
  revisionMetadata {
    id
    description
    sequenceId
    createdBy {
      id
      login
      name
      avatar
    }
    createdAt
  }
}
    `;
export const RepoBranchDeploymentsFragmentDoc = gql`
    fragment RepoBranchDeployments on DeploymentConnection {
  pageInfo {
    startCursor
    endCursor
    hasNextPage
    hasPreviousPage
  }
  nodes {
    id
    ...DeploymentCommon
    awsLinks {
      cloudwatchLogs
    }
    gcpLinks {
      cloudLogging
    }
  }
}
    ${DeploymentCommonFragmentDoc}`;
export const RepoCommonWithDbFragmentDoc = gql`
    fragment RepoCommonWithDB on Repo {
  id
  ...RepoCommon
  databaseProvider
  databaseEngine
  databaseVersion
  databaseLinks {
    id
    envPrefix
    envs {
      id
      name
      value
    }
    database {
      ...RepoCommon
    }
  }
  linkedProjects {
    id
    envPrefix
    repo {
      ...RepoCommon
    }
  }
}
    ${RepoCommonFragmentDoc}`;
export const CreateApiKeyDocument = gql`
    mutation createAPIKey($input: CreateAPIKeyInput!) {
  createAPIKey(input: $input) {
    id
    token
    name
    description
    createdAt
  }
}
    `;
export type CreateApiKeyMutationFn = Apollo.MutationFunction<CreateApiKeyMutation, CreateApiKeyMutationVariables>;

/**
 * __useCreateApiKeyMutation__
 *
 * To run a mutation, you first call `useCreateApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createApiKeyMutation, { data, loading, error }] = useCreateApiKeyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateApiKeyMutation(baseOptions?: Apollo.MutationHookOptions<CreateApiKeyMutation, CreateApiKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateApiKeyMutation, CreateApiKeyMutationVariables>(CreateApiKeyDocument, options);
      }
export type CreateApiKeyMutationHookResult = ReturnType<typeof useCreateApiKeyMutation>;
export type CreateApiKeyMutationResult = Apollo.MutationResult<CreateApiKeyMutation>;
export type CreateApiKeyMutationOptions = Apollo.BaseMutationOptions<CreateApiKeyMutation, CreateApiKeyMutationVariables>;
export const DeleteApiKeyDocument = gql`
    mutation deleteAPIKey($id: UUID!) {
  deleteAPIKey(id: $id)
}
    `;
export type DeleteApiKeyMutationFn = Apollo.MutationFunction<DeleteApiKeyMutation, DeleteApiKeyMutationVariables>;

/**
 * __useDeleteApiKeyMutation__
 *
 * To run a mutation, you first call `useDeleteApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteApiKeyMutation, { data, loading, error }] = useDeleteApiKeyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteApiKeyMutation(baseOptions?: Apollo.MutationHookOptions<DeleteApiKeyMutation, DeleteApiKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteApiKeyMutation, DeleteApiKeyMutationVariables>(DeleteApiKeyDocument, options);
      }
export type DeleteApiKeyMutationHookResult = ReturnType<typeof useDeleteApiKeyMutation>;
export type DeleteApiKeyMutationResult = Apollo.MutationResult<DeleteApiKeyMutation>;
export type DeleteApiKeyMutationOptions = Apollo.BaseMutationOptions<DeleteApiKeyMutation, DeleteApiKeyMutationVariables>;
export const PurchaseSubscriptionDocument = gql`
    mutation purchaseSubscription($forUserID: UUID!, $subscriptionCart: SubscriptionCart!) {
  purchaseSubscription(forUserID: $forUserID, subscriptionCart: $subscriptionCart) {
    overview {
      currentProducts {
        ...ProductDetail
      }
    }
  }
}
    ${ProductDetailFragmentDoc}`;
export type PurchaseSubscriptionMutationFn = Apollo.MutationFunction<PurchaseSubscriptionMutation, PurchaseSubscriptionMutationVariables>;

/**
 * __usePurchaseSubscriptionMutation__
 *
 * To run a mutation, you first call `usePurchaseSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePurchaseSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [purchaseSubscriptionMutation, { data, loading, error }] = usePurchaseSubscriptionMutation({
 *   variables: {
 *      forUserID: // value for 'forUserID'
 *      subscriptionCart: // value for 'subscriptionCart'
 *   },
 * });
 */
export function usePurchaseSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<PurchaseSubscriptionMutation, PurchaseSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PurchaseSubscriptionMutation, PurchaseSubscriptionMutationVariables>(PurchaseSubscriptionDocument, options);
      }
export type PurchaseSubscriptionMutationHookResult = ReturnType<typeof usePurchaseSubscriptionMutation>;
export type PurchaseSubscriptionMutationResult = Apollo.MutationResult<PurchaseSubscriptionMutation>;
export type PurchaseSubscriptionMutationOptions = Apollo.BaseMutationOptions<PurchaseSubscriptionMutation, PurchaseSubscriptionMutationVariables>;
export const CreateBlueprintDocument = gql`
    mutation createBlueprint($input: CreateBlueprintInput!) {
  createBlueprint(input: $input) {
    id
  }
}
    `;
export type CreateBlueprintMutationFn = Apollo.MutationFunction<CreateBlueprintMutation, CreateBlueprintMutationVariables>;

/**
 * __useCreateBlueprintMutation__
 *
 * To run a mutation, you first call `useCreateBlueprintMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBlueprintMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBlueprintMutation, { data, loading, error }] = useCreateBlueprintMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBlueprintMutation(baseOptions?: Apollo.MutationHookOptions<CreateBlueprintMutation, CreateBlueprintMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBlueprintMutation, CreateBlueprintMutationVariables>(CreateBlueprintDocument, options);
      }
export type CreateBlueprintMutationHookResult = ReturnType<typeof useCreateBlueprintMutation>;
export type CreateBlueprintMutationResult = Apollo.MutationResult<CreateBlueprintMutation>;
export type CreateBlueprintMutationOptions = Apollo.BaseMutationOptions<CreateBlueprintMutation, CreateBlueprintMutationVariables>;
export const MaybeCreateBlueprintFromMetadataDocument = gql`
    mutation maybeCreateBlueprintFromMetadata($slug: String!, $version: String!) {
  maybeCreateBlueprintFromMetadata(slug: $slug, version: $version) {
    id
  }
}
    `;
export type MaybeCreateBlueprintFromMetadataMutationFn = Apollo.MutationFunction<MaybeCreateBlueprintFromMetadataMutation, MaybeCreateBlueprintFromMetadataMutationVariables>;

/**
 * __useMaybeCreateBlueprintFromMetadataMutation__
 *
 * To run a mutation, you first call `useMaybeCreateBlueprintFromMetadataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMaybeCreateBlueprintFromMetadataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [maybeCreateBlueprintFromMetadataMutation, { data, loading, error }] = useMaybeCreateBlueprintFromMetadataMutation({
 *   variables: {
 *      slug: // value for 'slug'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useMaybeCreateBlueprintFromMetadataMutation(baseOptions?: Apollo.MutationHookOptions<MaybeCreateBlueprintFromMetadataMutation, MaybeCreateBlueprintFromMetadataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MaybeCreateBlueprintFromMetadataMutation, MaybeCreateBlueprintFromMetadataMutationVariables>(MaybeCreateBlueprintFromMetadataDocument, options);
      }
export type MaybeCreateBlueprintFromMetadataMutationHookResult = ReturnType<typeof useMaybeCreateBlueprintFromMetadataMutation>;
export type MaybeCreateBlueprintFromMetadataMutationResult = Apollo.MutationResult<MaybeCreateBlueprintFromMetadataMutation>;
export type MaybeCreateBlueprintFromMetadataMutationOptions = Apollo.BaseMutationOptions<MaybeCreateBlueprintFromMetadataMutation, MaybeCreateBlueprintFromMetadataMutationVariables>;
export const UpdateBlueprintDocument = gql`
    mutation updateBlueprint($id: UUID!, $input: UpdateBlueprintInput!) {
  updateBlueprint(blueprintID: $id, input: $input) {
    id
  }
}
    `;
export type UpdateBlueprintMutationFn = Apollo.MutationFunction<UpdateBlueprintMutation, UpdateBlueprintMutationVariables>;

/**
 * __useUpdateBlueprintMutation__
 *
 * To run a mutation, you first call `useUpdateBlueprintMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBlueprintMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBlueprintMutation, { data, loading, error }] = useUpdateBlueprintMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBlueprintMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBlueprintMutation, UpdateBlueprintMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBlueprintMutation, UpdateBlueprintMutationVariables>(UpdateBlueprintDocument, options);
      }
export type UpdateBlueprintMutationHookResult = ReturnType<typeof useUpdateBlueprintMutation>;
export type UpdateBlueprintMutationResult = Apollo.MutationResult<UpdateBlueprintMutation>;
export type UpdateBlueprintMutationOptions = Apollo.BaseMutationOptions<UpdateBlueprintMutation, UpdateBlueprintMutationVariables>;
export const UpdateMarketplaceBlueprintDocument = gql`
    mutation updateMarketplaceBlueprint($input: UpdateMarketplaceBlueprintInput!) {
  updateMarketplaceBlueprint(input: $input) {
    id
  }
}
    `;
export type UpdateMarketplaceBlueprintMutationFn = Apollo.MutationFunction<UpdateMarketplaceBlueprintMutation, UpdateMarketplaceBlueprintMutationVariables>;

/**
 * __useUpdateMarketplaceBlueprintMutation__
 *
 * To run a mutation, you first call `useUpdateMarketplaceBlueprintMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMarketplaceBlueprintMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMarketplaceBlueprintMutation, { data, loading, error }] = useUpdateMarketplaceBlueprintMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMarketplaceBlueprintMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMarketplaceBlueprintMutation, UpdateMarketplaceBlueprintMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMarketplaceBlueprintMutation, UpdateMarketplaceBlueprintMutationVariables>(UpdateMarketplaceBlueprintDocument, options);
      }
export type UpdateMarketplaceBlueprintMutationHookResult = ReturnType<typeof useUpdateMarketplaceBlueprintMutation>;
export type UpdateMarketplaceBlueprintMutationResult = Apollo.MutationResult<UpdateMarketplaceBlueprintMutation>;
export type UpdateMarketplaceBlueprintMutationOptions = Apollo.BaseMutationOptions<UpdateMarketplaceBlueprintMutation, UpdateMarketplaceBlueprintMutationVariables>;
export const DuplicateBlueprintDocument = gql`
    mutation duplicateBlueprint($input: DuplicateBlueprintInput!) {
  duplicateBlueprint(input: $input) {
    id
  }
}
    `;
export type DuplicateBlueprintMutationFn = Apollo.MutationFunction<DuplicateBlueprintMutation, DuplicateBlueprintMutationVariables>;

/**
 * __useDuplicateBlueprintMutation__
 *
 * To run a mutation, you first call `useDuplicateBlueprintMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateBlueprintMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateBlueprintMutation, { data, loading, error }] = useDuplicateBlueprintMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDuplicateBlueprintMutation(baseOptions?: Apollo.MutationHookOptions<DuplicateBlueprintMutation, DuplicateBlueprintMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DuplicateBlueprintMutation, DuplicateBlueprintMutationVariables>(DuplicateBlueprintDocument, options);
      }
export type DuplicateBlueprintMutationHookResult = ReturnType<typeof useDuplicateBlueprintMutation>;
export type DuplicateBlueprintMutationResult = Apollo.MutationResult<DuplicateBlueprintMutation>;
export type DuplicateBlueprintMutationOptions = Apollo.BaseMutationOptions<DuplicateBlueprintMutation, DuplicateBlueprintMutationVariables>;
export const DeleteBlueprintDocument = gql`
    mutation deleteBlueprint($id: UUID!) {
  deleteBlueprint(id: $id)
}
    `;
export type DeleteBlueprintMutationFn = Apollo.MutationFunction<DeleteBlueprintMutation, DeleteBlueprintMutationVariables>;

/**
 * __useDeleteBlueprintMutation__
 *
 * To run a mutation, you first call `useDeleteBlueprintMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBlueprintMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBlueprintMutation, { data, loading, error }] = useDeleteBlueprintMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteBlueprintMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBlueprintMutation, DeleteBlueprintMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteBlueprintMutation, DeleteBlueprintMutationVariables>(DeleteBlueprintDocument, options);
      }
export type DeleteBlueprintMutationHookResult = ReturnType<typeof useDeleteBlueprintMutation>;
export type DeleteBlueprintMutationResult = Apollo.MutationResult<DeleteBlueprintMutation>;
export type DeleteBlueprintMutationOptions = Apollo.BaseMutationOptions<DeleteBlueprintMutation, DeleteBlueprintMutationVariables>;
export const CreateBranchDocument = gql`
    mutation createBranch($input: UpdateBranchInput!) {
  updateBranch(input: $input) {
    id
    ...BranchCommon
  }
}
    ${BranchCommonFragmentDoc}`;
export type CreateBranchMutationFn = Apollo.MutationFunction<CreateBranchMutation, CreateBranchMutationVariables>;

/**
 * __useCreateBranchMutation__
 *
 * To run a mutation, you first call `useCreateBranchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBranchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBranchMutation, { data, loading, error }] = useCreateBranchMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBranchMutation(baseOptions?: Apollo.MutationHookOptions<CreateBranchMutation, CreateBranchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBranchMutation, CreateBranchMutationVariables>(CreateBranchDocument, options);
      }
export type CreateBranchMutationHookResult = ReturnType<typeof useCreateBranchMutation>;
export type CreateBranchMutationResult = Apollo.MutationResult<CreateBranchMutation>;
export type CreateBranchMutationOptions = Apollo.BaseMutationOptions<CreateBranchMutation, CreateBranchMutationVariables>;
export const DeleteProjectBranchDocument = gql`
    mutation deleteProjectBranch($id: UUID!, $branch: String!) {
  deleteProjectBranch(id: $id, branch: $branch)
}
    `;
export type DeleteProjectBranchMutationFn = Apollo.MutationFunction<DeleteProjectBranchMutation, DeleteProjectBranchMutationVariables>;

/**
 * __useDeleteProjectBranchMutation__
 *
 * To run a mutation, you first call `useDeleteProjectBranchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectBranchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProjectBranchMutation, { data, loading, error }] = useDeleteProjectBranchMutation({
 *   variables: {
 *      id: // value for 'id'
 *      branch: // value for 'branch'
 *   },
 * });
 */
export function useDeleteProjectBranchMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProjectBranchMutation, DeleteProjectBranchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProjectBranchMutation, DeleteProjectBranchMutationVariables>(DeleteProjectBranchDocument, options);
      }
export type DeleteProjectBranchMutationHookResult = ReturnType<typeof useDeleteProjectBranchMutation>;
export type DeleteProjectBranchMutationResult = Apollo.MutationResult<DeleteProjectBranchMutation>;
export type DeleteProjectBranchMutationOptions = Apollo.BaseMutationOptions<DeleteProjectBranchMutation, DeleteProjectBranchMutationVariables>;
export const AddAwsAccountDocument = gql`
    mutation addAWSAccount($input: AddAWSAccountInput!) {
  addAWSAccount(input: $input) {
    id
    ...AWSAccountDetail
  }
}
    ${AwsAccountDetailFragmentDoc}`;
export type AddAwsAccountMutationFn = Apollo.MutationFunction<AddAwsAccountMutation, AddAwsAccountMutationVariables>;

/**
 * __useAddAwsAccountMutation__
 *
 * To run a mutation, you first call `useAddAwsAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAwsAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAwsAccountMutation, { data, loading, error }] = useAddAwsAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddAwsAccountMutation(baseOptions?: Apollo.MutationHookOptions<AddAwsAccountMutation, AddAwsAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddAwsAccountMutation, AddAwsAccountMutationVariables>(AddAwsAccountDocument, options);
      }
export type AddAwsAccountMutationHookResult = ReturnType<typeof useAddAwsAccountMutation>;
export type AddAwsAccountMutationResult = Apollo.MutationResult<AddAwsAccountMutation>;
export type AddAwsAccountMutationOptions = Apollo.BaseMutationOptions<AddAwsAccountMutation, AddAwsAccountMutationVariables>;
export const RemoveAwsAccountDocument = gql`
    mutation removeAWSAccount($id: UUID!) {
  removeAWSAccount(id: $id)
}
    `;
export type RemoveAwsAccountMutationFn = Apollo.MutationFunction<RemoveAwsAccountMutation, RemoveAwsAccountMutationVariables>;

/**
 * __useRemoveAwsAccountMutation__
 *
 * To run a mutation, you first call `useRemoveAwsAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAwsAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAwsAccountMutation, { data, loading, error }] = useRemoveAwsAccountMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveAwsAccountMutation(baseOptions?: Apollo.MutationHookOptions<RemoveAwsAccountMutation, RemoveAwsAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveAwsAccountMutation, RemoveAwsAccountMutationVariables>(RemoveAwsAccountDocument, options);
      }
export type RemoveAwsAccountMutationHookResult = ReturnType<typeof useRemoveAwsAccountMutation>;
export type RemoveAwsAccountMutationResult = Apollo.MutationResult<RemoveAwsAccountMutation>;
export type RemoveAwsAccountMutationOptions = Apollo.BaseMutationOptions<RemoveAwsAccountMutation, RemoveAwsAccountMutationVariables>;
export const UpdateAwsAccountDocument = gql`
    mutation updateAWSAccount($input: UpdateAWSAccountInput!) {
  updateAWSAccount(input: $input)
}
    `;
export type UpdateAwsAccountMutationFn = Apollo.MutationFunction<UpdateAwsAccountMutation, UpdateAwsAccountMutationVariables>;

/**
 * __useUpdateAwsAccountMutation__
 *
 * To run a mutation, you first call `useUpdateAwsAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAwsAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAwsAccountMutation, { data, loading, error }] = useUpdateAwsAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAwsAccountMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAwsAccountMutation, UpdateAwsAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAwsAccountMutation, UpdateAwsAccountMutationVariables>(UpdateAwsAccountDocument, options);
      }
export type UpdateAwsAccountMutationHookResult = ReturnType<typeof useUpdateAwsAccountMutation>;
export type UpdateAwsAccountMutationResult = Apollo.MutationResult<UpdateAwsAccountMutation>;
export type UpdateAwsAccountMutationOptions = Apollo.BaseMutationOptions<UpdateAwsAccountMutation, UpdateAwsAccountMutationVariables>;
export const AddGcpAccountDocument = gql`
    mutation addGCPAccount($input: AddGCPAccountInput!) {
  addGCPAccount(input: $input) {
    id
    ...GCPAccountDetail
  }
}
    ${GcpAccountDetailFragmentDoc}`;
export type AddGcpAccountMutationFn = Apollo.MutationFunction<AddGcpAccountMutation, AddGcpAccountMutationVariables>;

/**
 * __useAddGcpAccountMutation__
 *
 * To run a mutation, you first call `useAddGcpAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddGcpAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addGcpAccountMutation, { data, loading, error }] = useAddGcpAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddGcpAccountMutation(baseOptions?: Apollo.MutationHookOptions<AddGcpAccountMutation, AddGcpAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddGcpAccountMutation, AddGcpAccountMutationVariables>(AddGcpAccountDocument, options);
      }
export type AddGcpAccountMutationHookResult = ReturnType<typeof useAddGcpAccountMutation>;
export type AddGcpAccountMutationResult = Apollo.MutationResult<AddGcpAccountMutation>;
export type AddGcpAccountMutationOptions = Apollo.BaseMutationOptions<AddGcpAccountMutation, AddGcpAccountMutationVariables>;
export const RemoveGcpAccountDocument = gql`
    mutation removeGCPAccount($id: UUID!) {
  removeGCPAccount(id: $id)
}
    `;
export type RemoveGcpAccountMutationFn = Apollo.MutationFunction<RemoveGcpAccountMutation, RemoveGcpAccountMutationVariables>;

/**
 * __useRemoveGcpAccountMutation__
 *
 * To run a mutation, you first call `useRemoveGcpAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveGcpAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeGcpAccountMutation, { data, loading, error }] = useRemoveGcpAccountMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveGcpAccountMutation(baseOptions?: Apollo.MutationHookOptions<RemoveGcpAccountMutation, RemoveGcpAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveGcpAccountMutation, RemoveGcpAccountMutationVariables>(RemoveGcpAccountDocument, options);
      }
export type RemoveGcpAccountMutationHookResult = ReturnType<typeof useRemoveGcpAccountMutation>;
export type RemoveGcpAccountMutationResult = Apollo.MutationResult<RemoveGcpAccountMutation>;
export type RemoveGcpAccountMutationOptions = Apollo.BaseMutationOptions<RemoveGcpAccountMutation, RemoveGcpAccountMutationVariables>;
export const UpdateGcpAccountDocument = gql`
    mutation updateGCPAccount($input: UpdateGCPAccountInput!) {
  updateGCPAccount(input: $input)
}
    `;
export type UpdateGcpAccountMutationFn = Apollo.MutationFunction<UpdateGcpAccountMutation, UpdateGcpAccountMutationVariables>;

/**
 * __useUpdateGcpAccountMutation__
 *
 * To run a mutation, you first call `useUpdateGcpAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGcpAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGcpAccountMutation, { data, loading, error }] = useUpdateGcpAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateGcpAccountMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGcpAccountMutation, UpdateGcpAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGcpAccountMutation, UpdateGcpAccountMutationVariables>(UpdateGcpAccountDocument, options);
      }
export type UpdateGcpAccountMutationHookResult = ReturnType<typeof useUpdateGcpAccountMutation>;
export type UpdateGcpAccountMutationResult = Apollo.MutationResult<UpdateGcpAccountMutation>;
export type UpdateGcpAccountMutationOptions = Apollo.BaseMutationOptions<UpdateGcpAccountMutation, UpdateGcpAccountMutationVariables>;
export const AddDoAccountDocument = gql`
    mutation addDOAccount($input: AddDOAccountInput!) {
  addDOAccount(input: $input) {
    id
    ...DOAccountDetail
  }
}
    ${DoAccountDetailFragmentDoc}`;
export type AddDoAccountMutationFn = Apollo.MutationFunction<AddDoAccountMutation, AddDoAccountMutationVariables>;

/**
 * __useAddDoAccountMutation__
 *
 * To run a mutation, you first call `useAddDoAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddDoAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addDoAccountMutation, { data, loading, error }] = useAddDoAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddDoAccountMutation(baseOptions?: Apollo.MutationHookOptions<AddDoAccountMutation, AddDoAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddDoAccountMutation, AddDoAccountMutationVariables>(AddDoAccountDocument, options);
      }
export type AddDoAccountMutationHookResult = ReturnType<typeof useAddDoAccountMutation>;
export type AddDoAccountMutationResult = Apollo.MutationResult<AddDoAccountMutation>;
export type AddDoAccountMutationOptions = Apollo.BaseMutationOptions<AddDoAccountMutation, AddDoAccountMutationVariables>;
export const RemoveDoAccountDocument = gql`
    mutation removeDOAccount($id: UUID!) {
  removeDOAccount(id: $id)
}
    `;
export type RemoveDoAccountMutationFn = Apollo.MutationFunction<RemoveDoAccountMutation, RemoveDoAccountMutationVariables>;

/**
 * __useRemoveDoAccountMutation__
 *
 * To run a mutation, you first call `useRemoveDoAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveDoAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeDoAccountMutation, { data, loading, error }] = useRemoveDoAccountMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveDoAccountMutation(baseOptions?: Apollo.MutationHookOptions<RemoveDoAccountMutation, RemoveDoAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveDoAccountMutation, RemoveDoAccountMutationVariables>(RemoveDoAccountDocument, options);
      }
export type RemoveDoAccountMutationHookResult = ReturnType<typeof useRemoveDoAccountMutation>;
export type RemoveDoAccountMutationResult = Apollo.MutationResult<RemoveDoAccountMutation>;
export type RemoveDoAccountMutationOptions = Apollo.BaseMutationOptions<RemoveDoAccountMutation, RemoveDoAccountMutationVariables>;
export const UpdateDoAccountDocument = gql`
    mutation updateDOAccount($input: UpdateDOAccountInput!) {
  updateDOAccount(input: $input)
}
    `;
export type UpdateDoAccountMutationFn = Apollo.MutationFunction<UpdateDoAccountMutation, UpdateDoAccountMutationVariables>;

/**
 * __useUpdateDoAccountMutation__
 *
 * To run a mutation, you first call `useUpdateDoAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDoAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDoAccountMutation, { data, loading, error }] = useUpdateDoAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDoAccountMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDoAccountMutation, UpdateDoAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDoAccountMutation, UpdateDoAccountMutationVariables>(UpdateDoAccountDocument, options);
      }
export type UpdateDoAccountMutationHookResult = ReturnType<typeof useUpdateDoAccountMutation>;
export type UpdateDoAccountMutationResult = Apollo.MutationResult<UpdateDoAccountMutation>;
export type UpdateDoAccountMutationOptions = Apollo.BaseMutationOptions<UpdateDoAccountMutation, UpdateDoAccountMutationVariables>;
export const AddLinodeAccountDocument = gql`
    mutation addLinodeAccount($input: AddLinodeAccountInput!) {
  addLinodeAccount(input: $input) {
    id
    ...LinodeAccountDetail
  }
}
    ${LinodeAccountDetailFragmentDoc}`;
export type AddLinodeAccountMutationFn = Apollo.MutationFunction<AddLinodeAccountMutation, AddLinodeAccountMutationVariables>;

/**
 * __useAddLinodeAccountMutation__
 *
 * To run a mutation, you first call `useAddLinodeAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddLinodeAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addLinodeAccountMutation, { data, loading, error }] = useAddLinodeAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddLinodeAccountMutation(baseOptions?: Apollo.MutationHookOptions<AddLinodeAccountMutation, AddLinodeAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddLinodeAccountMutation, AddLinodeAccountMutationVariables>(AddLinodeAccountDocument, options);
      }
export type AddLinodeAccountMutationHookResult = ReturnType<typeof useAddLinodeAccountMutation>;
export type AddLinodeAccountMutationResult = Apollo.MutationResult<AddLinodeAccountMutation>;
export type AddLinodeAccountMutationOptions = Apollo.BaseMutationOptions<AddLinodeAccountMutation, AddLinodeAccountMutationVariables>;
export const RemoveLinodeAccountDocument = gql`
    mutation removeLinodeAccount($id: UUID!) {
  removeLinodeAccount(id: $id)
}
    `;
export type RemoveLinodeAccountMutationFn = Apollo.MutationFunction<RemoveLinodeAccountMutation, RemoveLinodeAccountMutationVariables>;

/**
 * __useRemoveLinodeAccountMutation__
 *
 * To run a mutation, you first call `useRemoveLinodeAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveLinodeAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeLinodeAccountMutation, { data, loading, error }] = useRemoveLinodeAccountMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveLinodeAccountMutation(baseOptions?: Apollo.MutationHookOptions<RemoveLinodeAccountMutation, RemoveLinodeAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveLinodeAccountMutation, RemoveLinodeAccountMutationVariables>(RemoveLinodeAccountDocument, options);
      }
export type RemoveLinodeAccountMutationHookResult = ReturnType<typeof useRemoveLinodeAccountMutation>;
export type RemoveLinodeAccountMutationResult = Apollo.MutationResult<RemoveLinodeAccountMutation>;
export type RemoveLinodeAccountMutationOptions = Apollo.BaseMutationOptions<RemoveLinodeAccountMutation, RemoveLinodeAccountMutationVariables>;
export const UpdateLinodeAccountDocument = gql`
    mutation updateLinodeAccount($input: UpdateLinodeAccountInput!) {
  updateLinodeAccount(input: $input)
}
    `;
export type UpdateLinodeAccountMutationFn = Apollo.MutationFunction<UpdateLinodeAccountMutation, UpdateLinodeAccountMutationVariables>;

/**
 * __useUpdateLinodeAccountMutation__
 *
 * To run a mutation, you first call `useUpdateLinodeAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLinodeAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLinodeAccountMutation, { data, loading, error }] = useUpdateLinodeAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLinodeAccountMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLinodeAccountMutation, UpdateLinodeAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLinodeAccountMutation, UpdateLinodeAccountMutationVariables>(UpdateLinodeAccountDocument, options);
      }
export type UpdateLinodeAccountMutationHookResult = ReturnType<typeof useUpdateLinodeAccountMutation>;
export type UpdateLinodeAccountMutationResult = Apollo.MutationResult<UpdateLinodeAccountMutation>;
export type UpdateLinodeAccountMutationOptions = Apollo.BaseMutationOptions<UpdateLinodeAccountMutation, UpdateLinodeAccountMutationVariables>;
export const AddVultrAccountDocument = gql`
    mutation addVultrAccount($input: AddVultrAccountInput!) {
  addVultrAccount(input: $input) {
    id
    ...VultrAccountDetail
  }
}
    ${VultrAccountDetailFragmentDoc}`;
export type AddVultrAccountMutationFn = Apollo.MutationFunction<AddVultrAccountMutation, AddVultrAccountMutationVariables>;

/**
 * __useAddVultrAccountMutation__
 *
 * To run a mutation, you first call `useAddVultrAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddVultrAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addVultrAccountMutation, { data, loading, error }] = useAddVultrAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddVultrAccountMutation(baseOptions?: Apollo.MutationHookOptions<AddVultrAccountMutation, AddVultrAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddVultrAccountMutation, AddVultrAccountMutationVariables>(AddVultrAccountDocument, options);
      }
export type AddVultrAccountMutationHookResult = ReturnType<typeof useAddVultrAccountMutation>;
export type AddVultrAccountMutationResult = Apollo.MutationResult<AddVultrAccountMutation>;
export type AddVultrAccountMutationOptions = Apollo.BaseMutationOptions<AddVultrAccountMutation, AddVultrAccountMutationVariables>;
export const RemoveVultrAccountDocument = gql`
    mutation removeVultrAccount($id: UUID!) {
  removeVultrAccount(id: $id)
}
    `;
export type RemoveVultrAccountMutationFn = Apollo.MutationFunction<RemoveVultrAccountMutation, RemoveVultrAccountMutationVariables>;

/**
 * __useRemoveVultrAccountMutation__
 *
 * To run a mutation, you first call `useRemoveVultrAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveVultrAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeVultrAccountMutation, { data, loading, error }] = useRemoveVultrAccountMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveVultrAccountMutation(baseOptions?: Apollo.MutationHookOptions<RemoveVultrAccountMutation, RemoveVultrAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveVultrAccountMutation, RemoveVultrAccountMutationVariables>(RemoveVultrAccountDocument, options);
      }
export type RemoveVultrAccountMutationHookResult = ReturnType<typeof useRemoveVultrAccountMutation>;
export type RemoveVultrAccountMutationResult = Apollo.MutationResult<RemoveVultrAccountMutation>;
export type RemoveVultrAccountMutationOptions = Apollo.BaseMutationOptions<RemoveVultrAccountMutation, RemoveVultrAccountMutationVariables>;
export const UpdateVultrAccountDocument = gql`
    mutation updateVultrAccount($input: UpdateVultrAccountInput!) {
  updateVultrAccount(input: $input)
}
    `;
export type UpdateVultrAccountMutationFn = Apollo.MutationFunction<UpdateVultrAccountMutation, UpdateVultrAccountMutationVariables>;

/**
 * __useUpdateVultrAccountMutation__
 *
 * To run a mutation, you first call `useUpdateVultrAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVultrAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVultrAccountMutation, { data, loading, error }] = useUpdateVultrAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateVultrAccountMutation(baseOptions?: Apollo.MutationHookOptions<UpdateVultrAccountMutation, UpdateVultrAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateVultrAccountMutation, UpdateVultrAccountMutationVariables>(UpdateVultrAccountDocument, options);
      }
export type UpdateVultrAccountMutationHookResult = ReturnType<typeof useUpdateVultrAccountMutation>;
export type UpdateVultrAccountMutationResult = Apollo.MutationResult<UpdateVultrAccountMutation>;
export type UpdateVultrAccountMutationOptions = Apollo.BaseMutationOptions<UpdateVultrAccountMutation, UpdateVultrAccountMutationVariables>;
export const AddCoreWeaveAccountDocument = gql`
    mutation addCoreWeaveAccount($input: AddCoreWeaveAccountInput!) {
  addCoreWeaveAccount(input: $input) {
    id
    ...CWAccountDetail
  }
}
    ${CwAccountDetailFragmentDoc}`;
export type AddCoreWeaveAccountMutationFn = Apollo.MutationFunction<AddCoreWeaveAccountMutation, AddCoreWeaveAccountMutationVariables>;

/**
 * __useAddCoreWeaveAccountMutation__
 *
 * To run a mutation, you first call `useAddCoreWeaveAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCoreWeaveAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCoreWeaveAccountMutation, { data, loading, error }] = useAddCoreWeaveAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddCoreWeaveAccountMutation(baseOptions?: Apollo.MutationHookOptions<AddCoreWeaveAccountMutation, AddCoreWeaveAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCoreWeaveAccountMutation, AddCoreWeaveAccountMutationVariables>(AddCoreWeaveAccountDocument, options);
      }
export type AddCoreWeaveAccountMutationHookResult = ReturnType<typeof useAddCoreWeaveAccountMutation>;
export type AddCoreWeaveAccountMutationResult = Apollo.MutationResult<AddCoreWeaveAccountMutation>;
export type AddCoreWeaveAccountMutationOptions = Apollo.BaseMutationOptions<AddCoreWeaveAccountMutation, AddCoreWeaveAccountMutationVariables>;
export const RemoveCoreWeaveAccountDocument = gql`
    mutation removeCoreWeaveAccount($id: UUID!) {
  removeCoreWeaveAccount(id: $id)
}
    `;
export type RemoveCoreWeaveAccountMutationFn = Apollo.MutationFunction<RemoveCoreWeaveAccountMutation, RemoveCoreWeaveAccountMutationVariables>;

/**
 * __useRemoveCoreWeaveAccountMutation__
 *
 * To run a mutation, you first call `useRemoveCoreWeaveAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCoreWeaveAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCoreWeaveAccountMutation, { data, loading, error }] = useRemoveCoreWeaveAccountMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveCoreWeaveAccountMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCoreWeaveAccountMutation, RemoveCoreWeaveAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveCoreWeaveAccountMutation, RemoveCoreWeaveAccountMutationVariables>(RemoveCoreWeaveAccountDocument, options);
      }
export type RemoveCoreWeaveAccountMutationHookResult = ReturnType<typeof useRemoveCoreWeaveAccountMutation>;
export type RemoveCoreWeaveAccountMutationResult = Apollo.MutationResult<RemoveCoreWeaveAccountMutation>;
export type RemoveCoreWeaveAccountMutationOptions = Apollo.BaseMutationOptions<RemoveCoreWeaveAccountMutation, RemoveCoreWeaveAccountMutationVariables>;
export const UpdateCoreWeaveAccountDocument = gql`
    mutation updateCoreWeaveAccount($input: UpdateCoreWeaveAccountInput!) {
  updateCoreWeaveAccount(input: $input)
}
    `;
export type UpdateCoreWeaveAccountMutationFn = Apollo.MutationFunction<UpdateCoreWeaveAccountMutation, UpdateCoreWeaveAccountMutationVariables>;

/**
 * __useUpdateCoreWeaveAccountMutation__
 *
 * To run a mutation, you first call `useUpdateCoreWeaveAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCoreWeaveAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCoreWeaveAccountMutation, { data, loading, error }] = useUpdateCoreWeaveAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCoreWeaveAccountMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCoreWeaveAccountMutation, UpdateCoreWeaveAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCoreWeaveAccountMutation, UpdateCoreWeaveAccountMutationVariables>(UpdateCoreWeaveAccountDocument, options);
      }
export type UpdateCoreWeaveAccountMutationHookResult = ReturnType<typeof useUpdateCoreWeaveAccountMutation>;
export type UpdateCoreWeaveAccountMutationResult = Apollo.MutationResult<UpdateCoreWeaveAccountMutation>;
export type UpdateCoreWeaveAccountMutationOptions = Apollo.BaseMutationOptions<UpdateCoreWeaveAccountMutation, UpdateCoreWeaveAccountMutationVariables>;
export const AddAzureAccountDocument = gql`
    mutation addAzureAccount($input: AddAzureAccountInput!) {
  addAzureAccount(input: $input) {
    id
    ...AzureAccountDetail
  }
}
    ${AzureAccountDetailFragmentDoc}`;
export type AddAzureAccountMutationFn = Apollo.MutationFunction<AddAzureAccountMutation, AddAzureAccountMutationVariables>;

/**
 * __useAddAzureAccountMutation__
 *
 * To run a mutation, you first call `useAddAzureAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAzureAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAzureAccountMutation, { data, loading, error }] = useAddAzureAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddAzureAccountMutation(baseOptions?: Apollo.MutationHookOptions<AddAzureAccountMutation, AddAzureAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddAzureAccountMutation, AddAzureAccountMutationVariables>(AddAzureAccountDocument, options);
      }
export type AddAzureAccountMutationHookResult = ReturnType<typeof useAddAzureAccountMutation>;
export type AddAzureAccountMutationResult = Apollo.MutationResult<AddAzureAccountMutation>;
export type AddAzureAccountMutationOptions = Apollo.BaseMutationOptions<AddAzureAccountMutation, AddAzureAccountMutationVariables>;
export const RemoveAzureAccountDocument = gql`
    mutation removeAzureAccount($id: UUID!) {
  removeAzureAccount(id: $id)
}
    `;
export type RemoveAzureAccountMutationFn = Apollo.MutationFunction<RemoveAzureAccountMutation, RemoveAzureAccountMutationVariables>;

/**
 * __useRemoveAzureAccountMutation__
 *
 * To run a mutation, you first call `useRemoveAzureAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAzureAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAzureAccountMutation, { data, loading, error }] = useRemoveAzureAccountMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveAzureAccountMutation(baseOptions?: Apollo.MutationHookOptions<RemoveAzureAccountMutation, RemoveAzureAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveAzureAccountMutation, RemoveAzureAccountMutationVariables>(RemoveAzureAccountDocument, options);
      }
export type RemoveAzureAccountMutationHookResult = ReturnType<typeof useRemoveAzureAccountMutation>;
export type RemoveAzureAccountMutationResult = Apollo.MutationResult<RemoveAzureAccountMutation>;
export type RemoveAzureAccountMutationOptions = Apollo.BaseMutationOptions<RemoveAzureAccountMutation, RemoveAzureAccountMutationVariables>;
export const UpdateAzureAccountDocument = gql`
    mutation updateAzureAccount($input: UpdateAzureAccountInput!) {
  updateAzureAccount(input: $input)
}
    `;
export type UpdateAzureAccountMutationFn = Apollo.MutationFunction<UpdateAzureAccountMutation, UpdateAzureAccountMutationVariables>;

/**
 * __useUpdateAzureAccountMutation__
 *
 * To run a mutation, you first call `useUpdateAzureAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAzureAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAzureAccountMutation, { data, loading, error }] = useUpdateAzureAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAzureAccountMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAzureAccountMutation, UpdateAzureAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAzureAccountMutation, UpdateAzureAccountMutationVariables>(UpdateAzureAccountDocument, options);
      }
export type UpdateAzureAccountMutationHookResult = ReturnType<typeof useUpdateAzureAccountMutation>;
export type UpdateAzureAccountMutationResult = Apollo.MutationResult<UpdateAzureAccountMutation>;
export type UpdateAzureAccountMutationOptions = Apollo.BaseMutationOptions<UpdateAzureAccountMutation, UpdateAzureAccountMutationVariables>;
export const EnsureCloudqueryEnabledDocument = gql`
    mutation ensureCloudqueryEnabled($awsAccountId: UUID!) {
  ensureCloudqueryEnabled(awsAccountId: $awsAccountId)
}
    `;
export type EnsureCloudqueryEnabledMutationFn = Apollo.MutationFunction<EnsureCloudqueryEnabledMutation, EnsureCloudqueryEnabledMutationVariables>;

/**
 * __useEnsureCloudqueryEnabledMutation__
 *
 * To run a mutation, you first call `useEnsureCloudqueryEnabledMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnsureCloudqueryEnabledMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ensureCloudqueryEnabledMutation, { data, loading, error }] = useEnsureCloudqueryEnabledMutation({
 *   variables: {
 *      awsAccountId: // value for 'awsAccountId'
 *   },
 * });
 */
export function useEnsureCloudqueryEnabledMutation(baseOptions?: Apollo.MutationHookOptions<EnsureCloudqueryEnabledMutation, EnsureCloudqueryEnabledMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnsureCloudqueryEnabledMutation, EnsureCloudqueryEnabledMutationVariables>(EnsureCloudqueryEnabledDocument, options);
      }
export type EnsureCloudqueryEnabledMutationHookResult = ReturnType<typeof useEnsureCloudqueryEnabledMutation>;
export type EnsureCloudqueryEnabledMutationResult = Apollo.MutationResult<EnsureCloudqueryEnabledMutation>;
export type EnsureCloudqueryEnabledMutationOptions = Apollo.BaseMutationOptions<EnsureCloudqueryEnabledMutation, EnsureCloudqueryEnabledMutationVariables>;
export const CreateClusterDocument = gql`
    mutation createCluster($input: CreateClusterInput!) {
  createCluster(input: $input) {
    id
    ...ClusterDetail
  }
}
    ${ClusterDetailFragmentDoc}`;
export type CreateClusterMutationFn = Apollo.MutationFunction<CreateClusterMutation, CreateClusterMutationVariables>;

/**
 * __useCreateClusterMutation__
 *
 * To run a mutation, you first call `useCreateClusterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClusterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClusterMutation, { data, loading, error }] = useCreateClusterMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateClusterMutation(baseOptions?: Apollo.MutationHookOptions<CreateClusterMutation, CreateClusterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateClusterMutation, CreateClusterMutationVariables>(CreateClusterDocument, options);
      }
export type CreateClusterMutationHookResult = ReturnType<typeof useCreateClusterMutation>;
export type CreateClusterMutationResult = Apollo.MutationResult<CreateClusterMutation>;
export type CreateClusterMutationOptions = Apollo.BaseMutationOptions<CreateClusterMutation, CreateClusterMutationVariables>;
export const AddClusterDocument = gql`
    mutation addCluster($input: AddClusterInput!) {
  addCluster(input: $input) {
    id
    ...ClusterDetail
  }
}
    ${ClusterDetailFragmentDoc}`;
export type AddClusterMutationFn = Apollo.MutationFunction<AddClusterMutation, AddClusterMutationVariables>;

/**
 * __useAddClusterMutation__
 *
 * To run a mutation, you first call `useAddClusterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddClusterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addClusterMutation, { data, loading, error }] = useAddClusterMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddClusterMutation(baseOptions?: Apollo.MutationHookOptions<AddClusterMutation, AddClusterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddClusterMutation, AddClusterMutationVariables>(AddClusterDocument, options);
      }
export type AddClusterMutationHookResult = ReturnType<typeof useAddClusterMutation>;
export type AddClusterMutationResult = Apollo.MutationResult<AddClusterMutation>;
export type AddClusterMutationOptions = Apollo.BaseMutationOptions<AddClusterMutation, AddClusterMutationVariables>;
export const UpdateClusterDocument = gql`
    mutation updateCluster($input: UpdateClusterInput!) {
  updateCluster(input: $input) {
    id
    ...ClusterDetail
  }
}
    ${ClusterDetailFragmentDoc}`;
export type UpdateClusterMutationFn = Apollo.MutationFunction<UpdateClusterMutation, UpdateClusterMutationVariables>;

/**
 * __useUpdateClusterMutation__
 *
 * To run a mutation, you first call `useUpdateClusterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClusterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClusterMutation, { data, loading, error }] = useUpdateClusterMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateClusterMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClusterMutation, UpdateClusterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClusterMutation, UpdateClusterMutationVariables>(UpdateClusterDocument, options);
      }
export type UpdateClusterMutationHookResult = ReturnType<typeof useUpdateClusterMutation>;
export type UpdateClusterMutationResult = Apollo.MutationResult<UpdateClusterMutation>;
export type UpdateClusterMutationOptions = Apollo.BaseMutationOptions<UpdateClusterMutation, UpdateClusterMutationVariables>;
export const DeleteClusterDocument = gql`
    mutation deleteCluster($id: UUID!) {
  deleteCluster(id: $id)
}
    `;
export type DeleteClusterMutationFn = Apollo.MutationFunction<DeleteClusterMutation, DeleteClusterMutationVariables>;

/**
 * __useDeleteClusterMutation__
 *
 * To run a mutation, you first call `useDeleteClusterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteClusterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteClusterMutation, { data, loading, error }] = useDeleteClusterMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteClusterMutation(baseOptions?: Apollo.MutationHookOptions<DeleteClusterMutation, DeleteClusterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteClusterMutation, DeleteClusterMutationVariables>(DeleteClusterDocument, options);
      }
export type DeleteClusterMutationHookResult = ReturnType<typeof useDeleteClusterMutation>;
export type DeleteClusterMutationResult = Apollo.MutationResult<DeleteClusterMutation>;
export type DeleteClusterMutationOptions = Apollo.BaseMutationOptions<DeleteClusterMutation, DeleteClusterMutationVariables>;
export const UnlinkClusterDocument = gql`
    mutation unlinkCluster($id: UUID!) {
  unlinkCluster(id: $id)
}
    `;
export type UnlinkClusterMutationFn = Apollo.MutationFunction<UnlinkClusterMutation, UnlinkClusterMutationVariables>;

/**
 * __useUnlinkClusterMutation__
 *
 * To run a mutation, you first call `useUnlinkClusterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkClusterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkClusterMutation, { data, loading, error }] = useUnlinkClusterMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUnlinkClusterMutation(baseOptions?: Apollo.MutationHookOptions<UnlinkClusterMutation, UnlinkClusterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlinkClusterMutation, UnlinkClusterMutationVariables>(UnlinkClusterDocument, options);
      }
export type UnlinkClusterMutationHookResult = ReturnType<typeof useUnlinkClusterMutation>;
export type UnlinkClusterMutationResult = Apollo.MutationResult<UnlinkClusterMutation>;
export type UnlinkClusterMutationOptions = Apollo.BaseMutationOptions<UnlinkClusterMutation, UnlinkClusterMutationVariables>;
export const UpdateClusterDomainDocument = gql`
    mutation UpdateClusterDomain($input: UpdateClusterDomainInput!) {
  updateClusterDomain(input: $input) {
    id
    ...ClusterDetail
  }
}
    ${ClusterDetailFragmentDoc}`;
export type UpdateClusterDomainMutationFn = Apollo.MutationFunction<UpdateClusterDomainMutation, UpdateClusterDomainMutationVariables>;

/**
 * __useUpdateClusterDomainMutation__
 *
 * To run a mutation, you first call `useUpdateClusterDomainMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClusterDomainMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClusterDomainMutation, { data, loading, error }] = useUpdateClusterDomainMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateClusterDomainMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClusterDomainMutation, UpdateClusterDomainMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClusterDomainMutation, UpdateClusterDomainMutationVariables>(UpdateClusterDomainDocument, options);
      }
export type UpdateClusterDomainMutationHookResult = ReturnType<typeof useUpdateClusterDomainMutation>;
export type UpdateClusterDomainMutationResult = Apollo.MutationResult<UpdateClusterDomainMutation>;
export type UpdateClusterDomainMutationOptions = Apollo.BaseMutationOptions<UpdateClusterDomainMutation, UpdateClusterDomainMutationVariables>;
export const LinkClusterToCloudDocument = gql`
    mutation LinkClusterToCloud($input: LinkCloudToClusterInput!) {
  linkCloudToCluster(input: $input) {
    id
    ...ClusterDetail
  }
}
    ${ClusterDetailFragmentDoc}`;
export type LinkClusterToCloudMutationFn = Apollo.MutationFunction<LinkClusterToCloudMutation, LinkClusterToCloudMutationVariables>;

/**
 * __useLinkClusterToCloudMutation__
 *
 * To run a mutation, you first call `useLinkClusterToCloudMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkClusterToCloudMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkClusterToCloudMutation, { data, loading, error }] = useLinkClusterToCloudMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLinkClusterToCloudMutation(baseOptions?: Apollo.MutationHookOptions<LinkClusterToCloudMutation, LinkClusterToCloudMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LinkClusterToCloudMutation, LinkClusterToCloudMutationVariables>(LinkClusterToCloudDocument, options);
      }
export type LinkClusterToCloudMutationHookResult = ReturnType<typeof useLinkClusterToCloudMutation>;
export type LinkClusterToCloudMutationResult = Apollo.MutationResult<LinkClusterToCloudMutation>;
export type LinkClusterToCloudMutationOptions = Apollo.BaseMutationOptions<LinkClusterToCloudMutation, LinkClusterToCloudMutationVariables>;
export const UpdateClusterDetailsExternalDocument = gql`
    mutation UpdateClusterDetailsExternal($updateClusterInput: UpdateClusterInput!, $updateClusterDomainInput: UpdateClusterDomainInput!) {
  updateCluster(input: $updateClusterInput) {
    id
    ...ClusterDetail
  }
  updateClusterDomain(input: $updateClusterDomainInput) {
    id
    ...ClusterDetail
  }
}
    ${ClusterDetailFragmentDoc}`;
export type UpdateClusterDetailsExternalMutationFn = Apollo.MutationFunction<UpdateClusterDetailsExternalMutation, UpdateClusterDetailsExternalMutationVariables>;

/**
 * __useUpdateClusterDetailsExternalMutation__
 *
 * To run a mutation, you first call `useUpdateClusterDetailsExternalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClusterDetailsExternalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClusterDetailsExternalMutation, { data, loading, error }] = useUpdateClusterDetailsExternalMutation({
 *   variables: {
 *      updateClusterInput: // value for 'updateClusterInput'
 *      updateClusterDomainInput: // value for 'updateClusterDomainInput'
 *   },
 * });
 */
export function useUpdateClusterDetailsExternalMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClusterDetailsExternalMutation, UpdateClusterDetailsExternalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClusterDetailsExternalMutation, UpdateClusterDetailsExternalMutationVariables>(UpdateClusterDetailsExternalDocument, options);
      }
export type UpdateClusterDetailsExternalMutationHookResult = ReturnType<typeof useUpdateClusterDetailsExternalMutation>;
export type UpdateClusterDetailsExternalMutationResult = Apollo.MutationResult<UpdateClusterDetailsExternalMutation>;
export type UpdateClusterDetailsExternalMutationOptions = Apollo.BaseMutationOptions<UpdateClusterDetailsExternalMutation, UpdateClusterDetailsExternalMutationVariables>;
export const UpdateClusterDetailsExternalLinkDocument = gql`
    mutation UpdateClusterDetailsExternalLink($updateClusterInput: UpdateClusterInput!, $updateClusterDomainInput: UpdateClusterDomainInput!, $linkCloudToClusterInput: LinkCloudToClusterInput!) {
  updateCluster(input: $updateClusterInput) {
    id
    ...ClusterDetail
  }
  updateClusterDomain(input: $updateClusterDomainInput) {
    id
    ...ClusterDetail
  }
  linkCloudToCluster(input: $linkCloudToClusterInput) {
    id
    ...ClusterDetail
  }
}
    ${ClusterDetailFragmentDoc}`;
export type UpdateClusterDetailsExternalLinkMutationFn = Apollo.MutationFunction<UpdateClusterDetailsExternalLinkMutation, UpdateClusterDetailsExternalLinkMutationVariables>;

/**
 * __useUpdateClusterDetailsExternalLinkMutation__
 *
 * To run a mutation, you first call `useUpdateClusterDetailsExternalLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClusterDetailsExternalLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClusterDetailsExternalLinkMutation, { data, loading, error }] = useUpdateClusterDetailsExternalLinkMutation({
 *   variables: {
 *      updateClusterInput: // value for 'updateClusterInput'
 *      updateClusterDomainInput: // value for 'updateClusterDomainInput'
 *      linkCloudToClusterInput: // value for 'linkCloudToClusterInput'
 *   },
 * });
 */
export function useUpdateClusterDetailsExternalLinkMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClusterDetailsExternalLinkMutation, UpdateClusterDetailsExternalLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClusterDetailsExternalLinkMutation, UpdateClusterDetailsExternalLinkMutationVariables>(UpdateClusterDetailsExternalLinkDocument, options);
      }
export type UpdateClusterDetailsExternalLinkMutationHookResult = ReturnType<typeof useUpdateClusterDetailsExternalLinkMutation>;
export type UpdateClusterDetailsExternalLinkMutationResult = Apollo.MutationResult<UpdateClusterDetailsExternalLinkMutation>;
export type UpdateClusterDetailsExternalLinkMutationOptions = Apollo.BaseMutationOptions<UpdateClusterDetailsExternalLinkMutation, UpdateClusterDetailsExternalLinkMutationVariables>;
export const UpdateClusterDetailsZeetDocument = gql`
    mutation UpdateClusterDetailsZeet($updateClusterInput: UpdateClusterInput!) {
  updateCluster(input: $updateClusterInput) {
    id
    ...ClusterDetail
  }
}
    ${ClusterDetailFragmentDoc}`;
export type UpdateClusterDetailsZeetMutationFn = Apollo.MutationFunction<UpdateClusterDetailsZeetMutation, UpdateClusterDetailsZeetMutationVariables>;

/**
 * __useUpdateClusterDetailsZeetMutation__
 *
 * To run a mutation, you first call `useUpdateClusterDetailsZeetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClusterDetailsZeetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClusterDetailsZeetMutation, { data, loading, error }] = useUpdateClusterDetailsZeetMutation({
 *   variables: {
 *      updateClusterInput: // value for 'updateClusterInput'
 *   },
 * });
 */
export function useUpdateClusterDetailsZeetMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClusterDetailsZeetMutation, UpdateClusterDetailsZeetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClusterDetailsZeetMutation, UpdateClusterDetailsZeetMutationVariables>(UpdateClusterDetailsZeetDocument, options);
      }
export type UpdateClusterDetailsZeetMutationHookResult = ReturnType<typeof useUpdateClusterDetailsZeetMutation>;
export type UpdateClusterDetailsZeetMutationResult = Apollo.MutationResult<UpdateClusterDetailsZeetMutation>;
export type UpdateClusterDetailsZeetMutationOptions = Apollo.BaseMutationOptions<UpdateClusterDetailsZeetMutation, UpdateClusterDetailsZeetMutationVariables>;
export const UpdateClusterDetailsZeetLinkDocument = gql`
    mutation UpdateClusterDetailsZeetLink($updateClusterInput: UpdateClusterInput!, $linkCloudToClusterInput: LinkCloudToClusterInput!) {
  updateCluster(input: $updateClusterInput) {
    id
    ...ClusterDetail
  }
  linkCloudToCluster(input: $linkCloudToClusterInput) {
    id
    ...ClusterDetail
  }
}
    ${ClusterDetailFragmentDoc}`;
export type UpdateClusterDetailsZeetLinkMutationFn = Apollo.MutationFunction<UpdateClusterDetailsZeetLinkMutation, UpdateClusterDetailsZeetLinkMutationVariables>;

/**
 * __useUpdateClusterDetailsZeetLinkMutation__
 *
 * To run a mutation, you first call `useUpdateClusterDetailsZeetLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClusterDetailsZeetLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClusterDetailsZeetLinkMutation, { data, loading, error }] = useUpdateClusterDetailsZeetLinkMutation({
 *   variables: {
 *      updateClusterInput: // value for 'updateClusterInput'
 *      linkCloudToClusterInput: // value for 'linkCloudToClusterInput'
 *   },
 * });
 */
export function useUpdateClusterDetailsZeetLinkMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClusterDetailsZeetLinkMutation, UpdateClusterDetailsZeetLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClusterDetailsZeetLinkMutation, UpdateClusterDetailsZeetLinkMutationVariables>(UpdateClusterDetailsZeetLinkDocument, options);
      }
export type UpdateClusterDetailsZeetLinkMutationHookResult = ReturnType<typeof useUpdateClusterDetailsZeetLinkMutation>;
export type UpdateClusterDetailsZeetLinkMutationResult = Apollo.MutationResult<UpdateClusterDetailsZeetLinkMutation>;
export type UpdateClusterDetailsZeetLinkMutationOptions = Apollo.BaseMutationOptions<UpdateClusterDetailsZeetLinkMutation, UpdateClusterDetailsZeetLinkMutationVariables>;
export const CreateProjectDockerDocument = gql`
    mutation createProjectDocker($input: CreateProjectDockerInput) {
  createProjectDocker(input: $input) {
    ...RepoDetail
  }
}
    ${RepoDetailFragmentDoc}`;
export type CreateProjectDockerMutationFn = Apollo.MutationFunction<CreateProjectDockerMutation, CreateProjectDockerMutationVariables>;

/**
 * __useCreateProjectDockerMutation__
 *
 * To run a mutation, you first call `useCreateProjectDockerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectDockerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectDockerMutation, { data, loading, error }] = useCreateProjectDockerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProjectDockerMutation(baseOptions?: Apollo.MutationHookOptions<CreateProjectDockerMutation, CreateProjectDockerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProjectDockerMutation, CreateProjectDockerMutationVariables>(CreateProjectDockerDocument, options);
      }
export type CreateProjectDockerMutationHookResult = ReturnType<typeof useCreateProjectDockerMutation>;
export type CreateProjectDockerMutationResult = Apollo.MutationResult<CreateProjectDockerMutation>;
export type CreateProjectDockerMutationOptions = Apollo.BaseMutationOptions<CreateProjectDockerMutation, CreateProjectDockerMutationVariables>;
export const CreateProjectGitDocument = gql`
    mutation createProjectGit($input: CreateProjectGitInput) {
  createProjectGit(input: $input) {
    ...RepoDetail
  }
}
    ${RepoDetailFragmentDoc}`;
export type CreateProjectGitMutationFn = Apollo.MutationFunction<CreateProjectGitMutation, CreateProjectGitMutationVariables>;

/**
 * __useCreateProjectGitMutation__
 *
 * To run a mutation, you first call `useCreateProjectGitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectGitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectGitMutation, { data, loading, error }] = useCreateProjectGitMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProjectGitMutation(baseOptions?: Apollo.MutationHookOptions<CreateProjectGitMutation, CreateProjectGitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProjectGitMutation, CreateProjectGitMutationVariables>(CreateProjectGitDocument, options);
      }
export type CreateProjectGitMutationHookResult = ReturnType<typeof useCreateProjectGitMutation>;
export type CreateProjectGitMutationResult = Apollo.MutationResult<CreateProjectGitMutation>;
export type CreateProjectGitMutationOptions = Apollo.BaseMutationOptions<CreateProjectGitMutation, CreateProjectGitMutationVariables>;
export const LinkDatabaseDocument = gql`
    mutation linkDatabase($input: LinkDatabaseInput!) {
  linkDatabase(input: $input) {
    ...RepoDetail
  }
}
    ${RepoDetailFragmentDoc}`;
export type LinkDatabaseMutationFn = Apollo.MutationFunction<LinkDatabaseMutation, LinkDatabaseMutationVariables>;

/**
 * __useLinkDatabaseMutation__
 *
 * To run a mutation, you first call `useLinkDatabaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkDatabaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkDatabaseMutation, { data, loading, error }] = useLinkDatabaseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLinkDatabaseMutation(baseOptions?: Apollo.MutationHookOptions<LinkDatabaseMutation, LinkDatabaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LinkDatabaseMutation, LinkDatabaseMutationVariables>(LinkDatabaseDocument, options);
      }
export type LinkDatabaseMutationHookResult = ReturnType<typeof useLinkDatabaseMutation>;
export type LinkDatabaseMutationResult = Apollo.MutationResult<LinkDatabaseMutation>;
export type LinkDatabaseMutationOptions = Apollo.BaseMutationOptions<LinkDatabaseMutation, LinkDatabaseMutationVariables>;
export const UnlinkDatabaseDocument = gql`
    mutation unlinkDatabase($id: UUID!) {
  unlinkDatabase(id: $id)
}
    `;
export type UnlinkDatabaseMutationFn = Apollo.MutationFunction<UnlinkDatabaseMutation, UnlinkDatabaseMutationVariables>;

/**
 * __useUnlinkDatabaseMutation__
 *
 * To run a mutation, you first call `useUnlinkDatabaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkDatabaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkDatabaseMutation, { data, loading, error }] = useUnlinkDatabaseMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUnlinkDatabaseMutation(baseOptions?: Apollo.MutationHookOptions<UnlinkDatabaseMutation, UnlinkDatabaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlinkDatabaseMutation, UnlinkDatabaseMutationVariables>(UnlinkDatabaseDocument, options);
      }
export type UnlinkDatabaseMutationHookResult = ReturnType<typeof useUnlinkDatabaseMutation>;
export type UnlinkDatabaseMutationResult = Apollo.MutationResult<UnlinkDatabaseMutation>;
export type UnlinkDatabaseMutationOptions = Apollo.BaseMutationOptions<UnlinkDatabaseMutation, UnlinkDatabaseMutationVariables>;
export const UpdateDatabaseLinkDocument = gql`
    mutation updateDatabaseLink($input: updateDatabaseLinkInput!) {
  updateDatabaseLink(input: $input) {
    ...RepoDetail
  }
}
    ${RepoDetailFragmentDoc}`;
export type UpdateDatabaseLinkMutationFn = Apollo.MutationFunction<UpdateDatabaseLinkMutation, UpdateDatabaseLinkMutationVariables>;

/**
 * __useUpdateDatabaseLinkMutation__
 *
 * To run a mutation, you first call `useUpdateDatabaseLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDatabaseLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDatabaseLinkMutation, { data, loading, error }] = useUpdateDatabaseLinkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDatabaseLinkMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDatabaseLinkMutation, UpdateDatabaseLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDatabaseLinkMutation, UpdateDatabaseLinkMutationVariables>(UpdateDatabaseLinkDocument, options);
      }
export type UpdateDatabaseLinkMutationHookResult = ReturnType<typeof useUpdateDatabaseLinkMutation>;
export type UpdateDatabaseLinkMutationResult = Apollo.MutationResult<UpdateDatabaseLinkMutation>;
export type UpdateDatabaseLinkMutationOptions = Apollo.BaseMutationOptions<UpdateDatabaseLinkMutation, UpdateDatabaseLinkMutationVariables>;
export const GenerateDownloadableLogLinkDocument = gql`
    mutation generateDownloadableLogLink($deploymentID: UUID!) {
  generateDownloadableLogLink(deploymentID: $deploymentID)
}
    `;
export type GenerateDownloadableLogLinkMutationFn = Apollo.MutationFunction<GenerateDownloadableLogLinkMutation, GenerateDownloadableLogLinkMutationVariables>;

/**
 * __useGenerateDownloadableLogLinkMutation__
 *
 * To run a mutation, you first call `useGenerateDownloadableLogLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateDownloadableLogLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateDownloadableLogLinkMutation, { data, loading, error }] = useGenerateDownloadableLogLinkMutation({
 *   variables: {
 *      deploymentID: // value for 'deploymentID'
 *   },
 * });
 */
export function useGenerateDownloadableLogLinkMutation(baseOptions?: Apollo.MutationHookOptions<GenerateDownloadableLogLinkMutation, GenerateDownloadableLogLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateDownloadableLogLinkMutation, GenerateDownloadableLogLinkMutationVariables>(GenerateDownloadableLogLinkDocument, options);
      }
export type GenerateDownloadableLogLinkMutationHookResult = ReturnType<typeof useGenerateDownloadableLogLinkMutation>;
export type GenerateDownloadableLogLinkMutationResult = Apollo.MutationResult<GenerateDownloadableLogLinkMutation>;
export type GenerateDownloadableLogLinkMutationOptions = Apollo.BaseMutationOptions<GenerateDownloadableLogLinkMutation, GenerateDownloadableLogLinkMutationVariables>;
export const CreateProjectHelmDocument = gql`
    mutation createProjectHelm($input: CreateProjectHelmInput) {
  createProjectHelm(input: $input) {
    id
    ...RepoCommon
  }
}
    ${RepoCommonFragmentDoc}`;
export type CreateProjectHelmMutationFn = Apollo.MutationFunction<CreateProjectHelmMutation, CreateProjectHelmMutationVariables>;

/**
 * __useCreateProjectHelmMutation__
 *
 * To run a mutation, you first call `useCreateProjectHelmMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectHelmMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectHelmMutation, { data, loading, error }] = useCreateProjectHelmMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProjectHelmMutation(baseOptions?: Apollo.MutationHookOptions<CreateProjectHelmMutation, CreateProjectHelmMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProjectHelmMutation, CreateProjectHelmMutationVariables>(CreateProjectHelmDocument, options);
      }
export type CreateProjectHelmMutationHookResult = ReturnType<typeof useCreateProjectHelmMutation>;
export type CreateProjectHelmMutationResult = Apollo.MutationResult<CreateProjectHelmMutation>;
export type CreateProjectHelmMutationOptions = Apollo.BaseMutationOptions<CreateProjectHelmMutation, CreateProjectHelmMutationVariables>;
export const CreateDiscordWebhookIntegrationDocument = gql`
    mutation createDiscordWebhookIntegration($input: CreateWebhookIntegrationInput!) {
  createDiscordWebhookIntegrationV2(input: $input) {
    id
    ...IntegrationCommon
    ... on DiscordWebhookIntegration {
      url
    }
  }
}
    ${IntegrationCommonFragmentDoc}`;
export type CreateDiscordWebhookIntegrationMutationFn = Apollo.MutationFunction<CreateDiscordWebhookIntegrationMutation, CreateDiscordWebhookIntegrationMutationVariables>;

/**
 * __useCreateDiscordWebhookIntegrationMutation__
 *
 * To run a mutation, you first call `useCreateDiscordWebhookIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDiscordWebhookIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDiscordWebhookIntegrationMutation, { data, loading, error }] = useCreateDiscordWebhookIntegrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDiscordWebhookIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<CreateDiscordWebhookIntegrationMutation, CreateDiscordWebhookIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDiscordWebhookIntegrationMutation, CreateDiscordWebhookIntegrationMutationVariables>(CreateDiscordWebhookIntegrationDocument, options);
      }
export type CreateDiscordWebhookIntegrationMutationHookResult = ReturnType<typeof useCreateDiscordWebhookIntegrationMutation>;
export type CreateDiscordWebhookIntegrationMutationResult = Apollo.MutationResult<CreateDiscordWebhookIntegrationMutation>;
export type CreateDiscordWebhookIntegrationMutationOptions = Apollo.BaseMutationOptions<CreateDiscordWebhookIntegrationMutation, CreateDiscordWebhookIntegrationMutationVariables>;
export const UpdateDiscordWebhookIntegrationDocument = gql`
    mutation updateDiscordWebhookIntegration($input: UpdateWebhookIntegrationInput!) {
  updateDiscordWebhookIntegration(input: $input) {
    id
    ...IntegrationCommon
    ... on DiscordWebhookIntegration {
      url
    }
  }
}
    ${IntegrationCommonFragmentDoc}`;
export type UpdateDiscordWebhookIntegrationMutationFn = Apollo.MutationFunction<UpdateDiscordWebhookIntegrationMutation, UpdateDiscordWebhookIntegrationMutationVariables>;

/**
 * __useUpdateDiscordWebhookIntegrationMutation__
 *
 * To run a mutation, you first call `useUpdateDiscordWebhookIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDiscordWebhookIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDiscordWebhookIntegrationMutation, { data, loading, error }] = useUpdateDiscordWebhookIntegrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDiscordWebhookIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDiscordWebhookIntegrationMutation, UpdateDiscordWebhookIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDiscordWebhookIntegrationMutation, UpdateDiscordWebhookIntegrationMutationVariables>(UpdateDiscordWebhookIntegrationDocument, options);
      }
export type UpdateDiscordWebhookIntegrationMutationHookResult = ReturnType<typeof useUpdateDiscordWebhookIntegrationMutation>;
export type UpdateDiscordWebhookIntegrationMutationResult = Apollo.MutationResult<UpdateDiscordWebhookIntegrationMutation>;
export type UpdateDiscordWebhookIntegrationMutationOptions = Apollo.BaseMutationOptions<UpdateDiscordWebhookIntegrationMutation, UpdateDiscordWebhookIntegrationMutationVariables>;
export const CreateSlackWebhookIntegrationDocument = gql`
    mutation createSlackWebhookIntegration($input: CreateWebhookIntegrationInput!) {
  createSlackWebhookIntegrationV2(input: $input) {
    id
    ...IntegrationCommon
    ... on SlackWebhookIntegration {
      url
    }
  }
}
    ${IntegrationCommonFragmentDoc}`;
export type CreateSlackWebhookIntegrationMutationFn = Apollo.MutationFunction<CreateSlackWebhookIntegrationMutation, CreateSlackWebhookIntegrationMutationVariables>;

/**
 * __useCreateSlackWebhookIntegrationMutation__
 *
 * To run a mutation, you first call `useCreateSlackWebhookIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSlackWebhookIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSlackWebhookIntegrationMutation, { data, loading, error }] = useCreateSlackWebhookIntegrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSlackWebhookIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<CreateSlackWebhookIntegrationMutation, CreateSlackWebhookIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSlackWebhookIntegrationMutation, CreateSlackWebhookIntegrationMutationVariables>(CreateSlackWebhookIntegrationDocument, options);
      }
export type CreateSlackWebhookIntegrationMutationHookResult = ReturnType<typeof useCreateSlackWebhookIntegrationMutation>;
export type CreateSlackWebhookIntegrationMutationResult = Apollo.MutationResult<CreateSlackWebhookIntegrationMutation>;
export type CreateSlackWebhookIntegrationMutationOptions = Apollo.BaseMutationOptions<CreateSlackWebhookIntegrationMutation, CreateSlackWebhookIntegrationMutationVariables>;
export const UpdateSlackWebhookIntegrationDocument = gql`
    mutation updateSlackWebhookIntegration($input: UpdateWebhookIntegrationInput!) {
  updateSlackWebhookIntegration(input: $input) {
    id
    ...IntegrationCommon
    ... on SlackWebhookIntegration {
      url
    }
  }
}
    ${IntegrationCommonFragmentDoc}`;
export type UpdateSlackWebhookIntegrationMutationFn = Apollo.MutationFunction<UpdateSlackWebhookIntegrationMutation, UpdateSlackWebhookIntegrationMutationVariables>;

/**
 * __useUpdateSlackWebhookIntegrationMutation__
 *
 * To run a mutation, you first call `useUpdateSlackWebhookIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSlackWebhookIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSlackWebhookIntegrationMutation, { data, loading, error }] = useUpdateSlackWebhookIntegrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSlackWebhookIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSlackWebhookIntegrationMutation, UpdateSlackWebhookIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSlackWebhookIntegrationMutation, UpdateSlackWebhookIntegrationMutationVariables>(UpdateSlackWebhookIntegrationDocument, options);
      }
export type UpdateSlackWebhookIntegrationMutationHookResult = ReturnType<typeof useUpdateSlackWebhookIntegrationMutation>;
export type UpdateSlackWebhookIntegrationMutationResult = Apollo.MutationResult<UpdateSlackWebhookIntegrationMutation>;
export type UpdateSlackWebhookIntegrationMutationOptions = Apollo.BaseMutationOptions<UpdateSlackWebhookIntegrationMutation, UpdateSlackWebhookIntegrationMutationVariables>;
export const CreateDatadogIntegrationDocument = gql`
    mutation createDatadogIntegration($input: CreateDatadogIntegrationInput!) {
  createDatadogIntegration(input: $input) {
    id
    ...IntegrationCommon
    ... on DatadogIntegration {
      apiKey
    }
  }
}
    ${IntegrationCommonFragmentDoc}`;
export type CreateDatadogIntegrationMutationFn = Apollo.MutationFunction<CreateDatadogIntegrationMutation, CreateDatadogIntegrationMutationVariables>;

/**
 * __useCreateDatadogIntegrationMutation__
 *
 * To run a mutation, you first call `useCreateDatadogIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDatadogIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDatadogIntegrationMutation, { data, loading, error }] = useCreateDatadogIntegrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDatadogIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<CreateDatadogIntegrationMutation, CreateDatadogIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDatadogIntegrationMutation, CreateDatadogIntegrationMutationVariables>(CreateDatadogIntegrationDocument, options);
      }
export type CreateDatadogIntegrationMutationHookResult = ReturnType<typeof useCreateDatadogIntegrationMutation>;
export type CreateDatadogIntegrationMutationResult = Apollo.MutationResult<CreateDatadogIntegrationMutation>;
export type CreateDatadogIntegrationMutationOptions = Apollo.BaseMutationOptions<CreateDatadogIntegrationMutation, CreateDatadogIntegrationMutationVariables>;
export const CreateGitlabIntegrationDocument = gql`
    mutation createGitlabIntegration($input: CreateGitlabIntegrationInput!) {
  createGitlabIntegration(input: $input) {
    id
    ...IntegrationCommon
    ... on GitlabIntegration {
      accessTokenPrefix
      webhookUrl
      webhookToken
    }
  }
}
    ${IntegrationCommonFragmentDoc}`;
export type CreateGitlabIntegrationMutationFn = Apollo.MutationFunction<CreateGitlabIntegrationMutation, CreateGitlabIntegrationMutationVariables>;

/**
 * __useCreateGitlabIntegrationMutation__
 *
 * To run a mutation, you first call `useCreateGitlabIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGitlabIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGitlabIntegrationMutation, { data, loading, error }] = useCreateGitlabIntegrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateGitlabIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<CreateGitlabIntegrationMutation, CreateGitlabIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGitlabIntegrationMutation, CreateGitlabIntegrationMutationVariables>(CreateGitlabIntegrationDocument, options);
      }
export type CreateGitlabIntegrationMutationHookResult = ReturnType<typeof useCreateGitlabIntegrationMutation>;
export type CreateGitlabIntegrationMutationResult = Apollo.MutationResult<CreateGitlabIntegrationMutation>;
export type CreateGitlabIntegrationMutationOptions = Apollo.BaseMutationOptions<CreateGitlabIntegrationMutation, CreateGitlabIntegrationMutationVariables>;
export const CreateEmailIntegrationDocument = gql`
    mutation createEmailIntegration($input: CreateEmailIntegrationInput!) {
  createEmailIntegration(input: $input) {
    id
    ...IntegrationCommon
    ... on EmailIntegration {
      emailAddress
      activated
    }
  }
}
    ${IntegrationCommonFragmentDoc}`;
export type CreateEmailIntegrationMutationFn = Apollo.MutationFunction<CreateEmailIntegrationMutation, CreateEmailIntegrationMutationVariables>;

/**
 * __useCreateEmailIntegrationMutation__
 *
 * To run a mutation, you first call `useCreateEmailIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEmailIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEmailIntegrationMutation, { data, loading, error }] = useCreateEmailIntegrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEmailIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<CreateEmailIntegrationMutation, CreateEmailIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEmailIntegrationMutation, CreateEmailIntegrationMutationVariables>(CreateEmailIntegrationDocument, options);
      }
export type CreateEmailIntegrationMutationHookResult = ReturnType<typeof useCreateEmailIntegrationMutation>;
export type CreateEmailIntegrationMutationResult = Apollo.MutationResult<CreateEmailIntegrationMutation>;
export type CreateEmailIntegrationMutationOptions = Apollo.BaseMutationOptions<CreateEmailIntegrationMutation, CreateEmailIntegrationMutationVariables>;
export const UpdateGitlabIntegrationDocument = gql`
    mutation updateGitlabIntegration($input: UpdateGitlabIntegrationInput!) {
  updateGitlabIntegration(input: $input) {
    id
    ...IntegrationCommon
    ... on GitlabIntegration {
      accessTokenPrefix
      webhookUrl
      webhookToken
    }
  }
}
    ${IntegrationCommonFragmentDoc}`;
export type UpdateGitlabIntegrationMutationFn = Apollo.MutationFunction<UpdateGitlabIntegrationMutation, UpdateGitlabIntegrationMutationVariables>;

/**
 * __useUpdateGitlabIntegrationMutation__
 *
 * To run a mutation, you first call `useUpdateGitlabIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGitlabIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGitlabIntegrationMutation, { data, loading, error }] = useUpdateGitlabIntegrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateGitlabIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGitlabIntegrationMutation, UpdateGitlabIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGitlabIntegrationMutation, UpdateGitlabIntegrationMutationVariables>(UpdateGitlabIntegrationDocument, options);
      }
export type UpdateGitlabIntegrationMutationHookResult = ReturnType<typeof useUpdateGitlabIntegrationMutation>;
export type UpdateGitlabIntegrationMutationResult = Apollo.MutationResult<UpdateGitlabIntegrationMutation>;
export type UpdateGitlabIntegrationMutationOptions = Apollo.BaseMutationOptions<UpdateGitlabIntegrationMutation, UpdateGitlabIntegrationMutationVariables>;
export const DeleteIntegrationDocument = gql`
    mutation deleteIntegration($input: RemoveUserIntegrationInput!) {
  removeUserIntegration(input: $input)
}
    `;
export type DeleteIntegrationMutationFn = Apollo.MutationFunction<DeleteIntegrationMutation, DeleteIntegrationMutationVariables>;

/**
 * __useDeleteIntegrationMutation__
 *
 * To run a mutation, you first call `useDeleteIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteIntegrationMutation, { data, loading, error }] = useDeleteIntegrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteIntegrationMutation, DeleteIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteIntegrationMutation, DeleteIntegrationMutationVariables>(DeleteIntegrationDocument, options);
      }
export type DeleteIntegrationMutationHookResult = ReturnType<typeof useDeleteIntegrationMutation>;
export type DeleteIntegrationMutationResult = Apollo.MutationResult<DeleteIntegrationMutation>;
export type DeleteIntegrationMutationOptions = Apollo.BaseMutationOptions<DeleteIntegrationMutation, DeleteIntegrationMutationVariables>;
export const UpdateNotificationIntegrationSettingsDocument = gql`
    mutation updateNotificationIntegrationSettings($userID: UUID!, $input: NotificationIntegrationSettingsInput!) {
  updateNotificationIntegrationSettings(userID: $userID, input: $input) {
    build
    deploy
    podCrash
  }
}
    `;
export type UpdateNotificationIntegrationSettingsMutationFn = Apollo.MutationFunction<UpdateNotificationIntegrationSettingsMutation, UpdateNotificationIntegrationSettingsMutationVariables>;

/**
 * __useUpdateNotificationIntegrationSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateNotificationIntegrationSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNotificationIntegrationSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNotificationIntegrationSettingsMutation, { data, loading, error }] = useUpdateNotificationIntegrationSettingsMutation({
 *   variables: {
 *      userID: // value for 'userID'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateNotificationIntegrationSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNotificationIntegrationSettingsMutation, UpdateNotificationIntegrationSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNotificationIntegrationSettingsMutation, UpdateNotificationIntegrationSettingsMutationVariables>(UpdateNotificationIntegrationSettingsDocument, options);
      }
export type UpdateNotificationIntegrationSettingsMutationHookResult = ReturnType<typeof useUpdateNotificationIntegrationSettingsMutation>;
export type UpdateNotificationIntegrationSettingsMutationResult = Apollo.MutationResult<UpdateNotificationIntegrationSettingsMutation>;
export type UpdateNotificationIntegrationSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateNotificationIntegrationSettingsMutation, UpdateNotificationIntegrationSettingsMutationVariables>;
export const UpdateNotificationIntegrationSpecificSettingsDocument = gql`
    mutation updateNotificationIntegrationSpecificSettings($userID: UUID!, $integrationID: UUID!, $input: NotificationIntegrationSettingsInput!) {
  updateNotificationIntegrationSettings(
    userID: $userID
    integrationID: $integrationID
    input: $input
  ) {
    build
    deploy
    podCrash
  }
}
    `;
export type UpdateNotificationIntegrationSpecificSettingsMutationFn = Apollo.MutationFunction<UpdateNotificationIntegrationSpecificSettingsMutation, UpdateNotificationIntegrationSpecificSettingsMutationVariables>;

/**
 * __useUpdateNotificationIntegrationSpecificSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateNotificationIntegrationSpecificSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNotificationIntegrationSpecificSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNotificationIntegrationSpecificSettingsMutation, { data, loading, error }] = useUpdateNotificationIntegrationSpecificSettingsMutation({
 *   variables: {
 *      userID: // value for 'userID'
 *      integrationID: // value for 'integrationID'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateNotificationIntegrationSpecificSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNotificationIntegrationSpecificSettingsMutation, UpdateNotificationIntegrationSpecificSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNotificationIntegrationSpecificSettingsMutation, UpdateNotificationIntegrationSpecificSettingsMutationVariables>(UpdateNotificationIntegrationSpecificSettingsDocument, options);
      }
export type UpdateNotificationIntegrationSpecificSettingsMutationHookResult = ReturnType<typeof useUpdateNotificationIntegrationSpecificSettingsMutation>;
export type UpdateNotificationIntegrationSpecificSettingsMutationResult = Apollo.MutationResult<UpdateNotificationIntegrationSpecificSettingsMutation>;
export type UpdateNotificationIntegrationSpecificSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateNotificationIntegrationSpecificSettingsMutation, UpdateNotificationIntegrationSpecificSettingsMutationVariables>;
export const CreateBitbucketIntegrationDocument = gql`
    mutation createBitbucketIntegration($userId: UUID!, $accessToken: String!, $name: String!) {
  createBitbucketIntegration(
    input: {userID: $userId, accessToken: $accessToken, name: $name}
  ) {
    id
  }
}
    `;
export type CreateBitbucketIntegrationMutationFn = Apollo.MutationFunction<CreateBitbucketIntegrationMutation, CreateBitbucketIntegrationMutationVariables>;

/**
 * __useCreateBitbucketIntegrationMutation__
 *
 * To run a mutation, you first call `useCreateBitbucketIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBitbucketIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBitbucketIntegrationMutation, { data, loading, error }] = useCreateBitbucketIntegrationMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      accessToken: // value for 'accessToken'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateBitbucketIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<CreateBitbucketIntegrationMutation, CreateBitbucketIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBitbucketIntegrationMutation, CreateBitbucketIntegrationMutationVariables>(CreateBitbucketIntegrationDocument, options);
      }
export type CreateBitbucketIntegrationMutationHookResult = ReturnType<typeof useCreateBitbucketIntegrationMutation>;
export type CreateBitbucketIntegrationMutationResult = Apollo.MutationResult<CreateBitbucketIntegrationMutation>;
export type CreateBitbucketIntegrationMutationOptions = Apollo.BaseMutationOptions<CreateBitbucketIntegrationMutation, CreateBitbucketIntegrationMutationVariables>;
export const UpdateBitbucketIntegrationDocument = gql`
    mutation updateBitbucketIntegration($id: UUID!, $userId: UUID!, $name: String!) {
  updateBitbucketIntegration(input: {userID: $userId, id: $id, name: $name}) {
    id
  }
}
    `;
export type UpdateBitbucketIntegrationMutationFn = Apollo.MutationFunction<UpdateBitbucketIntegrationMutation, UpdateBitbucketIntegrationMutationVariables>;

/**
 * __useUpdateBitbucketIntegrationMutation__
 *
 * To run a mutation, you first call `useUpdateBitbucketIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBitbucketIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBitbucketIntegrationMutation, { data, loading, error }] = useUpdateBitbucketIntegrationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      userId: // value for 'userId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateBitbucketIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBitbucketIntegrationMutation, UpdateBitbucketIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBitbucketIntegrationMutation, UpdateBitbucketIntegrationMutationVariables>(UpdateBitbucketIntegrationDocument, options);
      }
export type UpdateBitbucketIntegrationMutationHookResult = ReturnType<typeof useUpdateBitbucketIntegrationMutation>;
export type UpdateBitbucketIntegrationMutationResult = Apollo.MutationResult<UpdateBitbucketIntegrationMutation>;
export type UpdateBitbucketIntegrationMutationOptions = Apollo.BaseMutationOptions<UpdateBitbucketIntegrationMutation, UpdateBitbucketIntegrationMutationVariables>;
export const UpdateNotificationIntegrationConditionsDocument = gql`
    mutation updateNotificationIntegrationConditions($userId: UUID!, $integrationId: UUID!, $input: NotificationConditionProviderInput!) {
  updateNotificationIntegrationSettings(
    userID: $userId
    integrationID: $integrationId
    input: {conditions: $input}
  ) {
    conditions {
      ... on NotificationCondition {
        key
        operator
        value
      }
    }
  }
}
    `;
export type UpdateNotificationIntegrationConditionsMutationFn = Apollo.MutationFunction<UpdateNotificationIntegrationConditionsMutation, UpdateNotificationIntegrationConditionsMutationVariables>;

/**
 * __useUpdateNotificationIntegrationConditionsMutation__
 *
 * To run a mutation, you first call `useUpdateNotificationIntegrationConditionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNotificationIntegrationConditionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNotificationIntegrationConditionsMutation, { data, loading, error }] = useUpdateNotificationIntegrationConditionsMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      integrationId: // value for 'integrationId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateNotificationIntegrationConditionsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNotificationIntegrationConditionsMutation, UpdateNotificationIntegrationConditionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNotificationIntegrationConditionsMutation, UpdateNotificationIntegrationConditionsMutationVariables>(UpdateNotificationIntegrationConditionsDocument, options);
      }
export type UpdateNotificationIntegrationConditionsMutationHookResult = ReturnType<typeof useUpdateNotificationIntegrationConditionsMutation>;
export type UpdateNotificationIntegrationConditionsMutationResult = Apollo.MutationResult<UpdateNotificationIntegrationConditionsMutation>;
export type UpdateNotificationIntegrationConditionsMutationOptions = Apollo.BaseMutationOptions<UpdateNotificationIntegrationConditionsMutation, UpdateNotificationIntegrationConditionsMutationVariables>;
export const RunJobDocument = gql`
    mutation runJob($input: RunJobInput!) {
  runJob(input: $input) {
    id
    ...JobCommon
  }
}
    ${JobCommonFragmentDoc}`;
export type RunJobMutationFn = Apollo.MutationFunction<RunJobMutation, RunJobMutationVariables>;

/**
 * __useRunJobMutation__
 *
 * To run a mutation, you first call `useRunJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRunJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [runJobMutation, { data, loading, error }] = useRunJobMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRunJobMutation(baseOptions?: Apollo.MutationHookOptions<RunJobMutation, RunJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RunJobMutation, RunJobMutationVariables>(RunJobDocument, options);
      }
export type RunJobMutationHookResult = ReturnType<typeof useRunJobMutation>;
export type RunJobMutationResult = Apollo.MutationResult<RunJobMutation>;
export type RunJobMutationOptions = Apollo.BaseMutationOptions<RunJobMutation, RunJobMutationVariables>;
export const BuildRepoDocument = gql`
    mutation buildRepo($id: ID!, $branch: String, $noCache: Boolean) {
  buildRepo(id: $id, branch: $branch, noCache: $noCache) {
    ...RepoDetail
  }
}
    ${RepoDetailFragmentDoc}`;
export type BuildRepoMutationFn = Apollo.MutationFunction<BuildRepoMutation, BuildRepoMutationVariables>;

/**
 * __useBuildRepoMutation__
 *
 * To run a mutation, you first call `useBuildRepoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBuildRepoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [buildRepoMutation, { data, loading, error }] = useBuildRepoMutation({
 *   variables: {
 *      id: // value for 'id'
 *      branch: // value for 'branch'
 *      noCache: // value for 'noCache'
 *   },
 * });
 */
export function useBuildRepoMutation(baseOptions?: Apollo.MutationHookOptions<BuildRepoMutation, BuildRepoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BuildRepoMutation, BuildRepoMutationVariables>(BuildRepoDocument, options);
      }
export type BuildRepoMutationHookResult = ReturnType<typeof useBuildRepoMutation>;
export type BuildRepoMutationResult = Apollo.MutationResult<BuildRepoMutation>;
export type BuildRepoMutationOptions = Apollo.BaseMutationOptions<BuildRepoMutation, BuildRepoMutationVariables>;
export const SetPaymentMethodDocument = gql`
    mutation setPaymentMethod($paymentMethod: String!) {
  setPaymentMethod(paymentMethod: $paymentMethod) {
    id
    hasPaymentMethod
  }
}
    `;
export type SetPaymentMethodMutationFn = Apollo.MutationFunction<SetPaymentMethodMutation, SetPaymentMethodMutationVariables>;

/**
 * __useSetPaymentMethodMutation__
 *
 * To run a mutation, you first call `useSetPaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPaymentMethodMutation, { data, loading, error }] = useSetPaymentMethodMutation({
 *   variables: {
 *      paymentMethod: // value for 'paymentMethod'
 *   },
 * });
 */
export function useSetPaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<SetPaymentMethodMutation, SetPaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetPaymentMethodMutation, SetPaymentMethodMutationVariables>(SetPaymentMethodDocument, options);
      }
export type SetPaymentMethodMutationHookResult = ReturnType<typeof useSetPaymentMethodMutation>;
export type SetPaymentMethodMutationResult = Apollo.MutationResult<SetPaymentMethodMutation>;
export type SetPaymentMethodMutationOptions = Apollo.BaseMutationOptions<SetPaymentMethodMutation, SetPaymentMethodMutationVariables>;
export const SetRepoEnvsDocument = gql`
    mutation setRepoEnvs($input: SetRepoEnvsInput!) {
  setRepoEnvs(input: $input) {
    id
    envs {
      id
      name
      value
      visible
      sealed
    }
  }
}
    `;
export type SetRepoEnvsMutationFn = Apollo.MutationFunction<SetRepoEnvsMutation, SetRepoEnvsMutationVariables>;

/**
 * __useSetRepoEnvsMutation__
 *
 * To run a mutation, you first call `useSetRepoEnvsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetRepoEnvsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setRepoEnvsMutation, { data, loading, error }] = useSetRepoEnvsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetRepoEnvsMutation(baseOptions?: Apollo.MutationHookOptions<SetRepoEnvsMutation, SetRepoEnvsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetRepoEnvsMutation, SetRepoEnvsMutationVariables>(SetRepoEnvsDocument, options);
      }
export type SetRepoEnvsMutationHookResult = ReturnType<typeof useSetRepoEnvsMutation>;
export type SetRepoEnvsMutationResult = Apollo.MutationResult<SetRepoEnvsMutation>;
export type SetRepoEnvsMutationOptions = Apollo.BaseMutationOptions<SetRepoEnvsMutation, SetRepoEnvsMutationVariables>;
export const AddProjectCollaboratorDocument = gql`
    mutation addProjectCollaborator($input: AddProjectCollaboratorInput!) {
  addProjectCollaborator(input: $input) {
    id
    collaborators {
      ...CollaboratorCommon
    }
  }
}
    ${CollaboratorCommonFragmentDoc}`;
export type AddProjectCollaboratorMutationFn = Apollo.MutationFunction<AddProjectCollaboratorMutation, AddProjectCollaboratorMutationVariables>;

/**
 * __useAddProjectCollaboratorMutation__
 *
 * To run a mutation, you first call `useAddProjectCollaboratorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProjectCollaboratorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProjectCollaboratorMutation, { data, loading, error }] = useAddProjectCollaboratorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddProjectCollaboratorMutation(baseOptions?: Apollo.MutationHookOptions<AddProjectCollaboratorMutation, AddProjectCollaboratorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddProjectCollaboratorMutation, AddProjectCollaboratorMutationVariables>(AddProjectCollaboratorDocument, options);
      }
export type AddProjectCollaboratorMutationHookResult = ReturnType<typeof useAddProjectCollaboratorMutation>;
export type AddProjectCollaboratorMutationResult = Apollo.MutationResult<AddProjectCollaboratorMutation>;
export type AddProjectCollaboratorMutationOptions = Apollo.BaseMutationOptions<AddProjectCollaboratorMutation, AddProjectCollaboratorMutationVariables>;
export const RemoveProjectCollaboratorDocument = gql`
    mutation removeProjectCollaborator($id: ID!) {
  removeProjectCollaborator(id: $id) {
    id
    collaborators {
      ...CollaboratorCommon
    }
  }
}
    ${CollaboratorCommonFragmentDoc}`;
export type RemoveProjectCollaboratorMutationFn = Apollo.MutationFunction<RemoveProjectCollaboratorMutation, RemoveProjectCollaboratorMutationVariables>;

/**
 * __useRemoveProjectCollaboratorMutation__
 *
 * To run a mutation, you first call `useRemoveProjectCollaboratorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveProjectCollaboratorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeProjectCollaboratorMutation, { data, loading, error }] = useRemoveProjectCollaboratorMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveProjectCollaboratorMutation(baseOptions?: Apollo.MutationHookOptions<RemoveProjectCollaboratorMutation, RemoveProjectCollaboratorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveProjectCollaboratorMutation, RemoveProjectCollaboratorMutationVariables>(RemoveProjectCollaboratorDocument, options);
      }
export type RemoveProjectCollaboratorMutationHookResult = ReturnType<typeof useRemoveProjectCollaboratorMutation>;
export type RemoveProjectCollaboratorMutationResult = Apollo.MutationResult<RemoveProjectCollaboratorMutation>;
export type RemoveProjectCollaboratorMutationOptions = Apollo.BaseMutationOptions<RemoveProjectCollaboratorMutation, RemoveProjectCollaboratorMutationVariables>;
export const CopyEnvVarsDocument = gql`
    mutation copyEnvVars($from: ID!, $to: ID!) {
  copyEnvVars(from: $from, to: $to) {
    id
    envs {
      id
      name
      value
      visible
      sealed
    }
  }
}
    `;
export type CopyEnvVarsMutationFn = Apollo.MutationFunction<CopyEnvVarsMutation, CopyEnvVarsMutationVariables>;

/**
 * __useCopyEnvVarsMutation__
 *
 * To run a mutation, you first call `useCopyEnvVarsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCopyEnvVarsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [copyEnvVarsMutation, { data, loading, error }] = useCopyEnvVarsMutation({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useCopyEnvVarsMutation(baseOptions?: Apollo.MutationHookOptions<CopyEnvVarsMutation, CopyEnvVarsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CopyEnvVarsMutation, CopyEnvVarsMutationVariables>(CopyEnvVarsDocument, options);
      }
export type CopyEnvVarsMutationHookResult = ReturnType<typeof useCopyEnvVarsMutation>;
export type CopyEnvVarsMutationResult = Apollo.MutationResult<CopyEnvVarsMutation>;
export type CopyEnvVarsMutationOptions = Apollo.BaseMutationOptions<CopyEnvVarsMutation, CopyEnvVarsMutationVariables>;
export const ReissueCertDocument = gql`
    mutation reissueCert($input: ReissueCustomDomainCertificateInput!) {
  reissueCustomDomainCertificate(input: $input) {
    id
    ...RepoDetail
  }
}
    ${RepoDetailFragmentDoc}`;
export type ReissueCertMutationFn = Apollo.MutationFunction<ReissueCertMutation, ReissueCertMutationVariables>;

/**
 * __useReissueCertMutation__
 *
 * To run a mutation, you first call `useReissueCertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReissueCertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reissueCertMutation, { data, loading, error }] = useReissueCertMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReissueCertMutation(baseOptions?: Apollo.MutationHookOptions<ReissueCertMutation, ReissueCertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReissueCertMutation, ReissueCertMutationVariables>(ReissueCertDocument, options);
      }
export type ReissueCertMutationHookResult = ReturnType<typeof useReissueCertMutation>;
export type ReissueCertMutationResult = Apollo.MutationResult<ReissueCertMutation>;
export type ReissueCertMutationOptions = Apollo.BaseMutationOptions<ReissueCertMutation, ReissueCertMutationVariables>;
export const UpdateCertDocument = gql`
    mutation updateCert($input: UpdateRepoCustomDomainInput!) {
  updateRepoCustomDomain(input: $input) {
    id
    ...RepoDetail
  }
}
    ${RepoDetailFragmentDoc}`;
export type UpdateCertMutationFn = Apollo.MutationFunction<UpdateCertMutation, UpdateCertMutationVariables>;

/**
 * __useUpdateCertMutation__
 *
 * To run a mutation, you first call `useUpdateCertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCertMutation, { data, loading, error }] = useUpdateCertMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCertMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCertMutation, UpdateCertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCertMutation, UpdateCertMutationVariables>(UpdateCertDocument, options);
      }
export type UpdateCertMutationHookResult = ReturnType<typeof useUpdateCertMutation>;
export type UpdateCertMutationResult = Apollo.MutationResult<UpdateCertMutation>;
export type UpdateCertMutationOptions = Apollo.BaseMutationOptions<UpdateCertMutation, UpdateCertMutationVariables>;
export const AddCdnDocument = gql`
    mutation addCDN($input: AddCDNInput!) {
  addCDN(input: $input) {
    id
    ...CDNDetail
  }
}
    ${CdnDetailFragmentDoc}`;
export type AddCdnMutationFn = Apollo.MutationFunction<AddCdnMutation, AddCdnMutationVariables>;

/**
 * __useAddCdnMutation__
 *
 * To run a mutation, you first call `useAddCdnMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCdnMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCdnMutation, { data, loading, error }] = useAddCdnMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddCdnMutation(baseOptions?: Apollo.MutationHookOptions<AddCdnMutation, AddCdnMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCdnMutation, AddCdnMutationVariables>(AddCdnDocument, options);
      }
export type AddCdnMutationHookResult = ReturnType<typeof useAddCdnMutation>;
export type AddCdnMutationResult = Apollo.MutationResult<AddCdnMutation>;
export type AddCdnMutationOptions = Apollo.BaseMutationOptions<AddCdnMutation, AddCdnMutationVariables>;
export const UpdateCdnDocument = gql`
    mutation updateCDN($input: UpdateCDNInput!) {
  updateCDN(input: $input) {
    id
    ...CDNDetail
  }
}
    ${CdnDetailFragmentDoc}`;
export type UpdateCdnMutationFn = Apollo.MutationFunction<UpdateCdnMutation, UpdateCdnMutationVariables>;

/**
 * __useUpdateCdnMutation__
 *
 * To run a mutation, you first call `useUpdateCdnMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCdnMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCdnMutation, { data, loading, error }] = useUpdateCdnMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCdnMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCdnMutation, UpdateCdnMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCdnMutation, UpdateCdnMutationVariables>(UpdateCdnDocument, options);
      }
export type UpdateCdnMutationHookResult = ReturnType<typeof useUpdateCdnMutation>;
export type UpdateCdnMutationResult = Apollo.MutationResult<UpdateCdnMutation>;
export type UpdateCdnMutationOptions = Apollo.BaseMutationOptions<UpdateCdnMutation, UpdateCdnMutationVariables>;
export const RemoveCdnDocument = gql`
    mutation removeCDN($id: UUID!) {
  removeCDN(id: $id)
}
    `;
export type RemoveCdnMutationFn = Apollo.MutationFunction<RemoveCdnMutation, RemoveCdnMutationVariables>;

/**
 * __useRemoveCdnMutation__
 *
 * To run a mutation, you first call `useRemoveCdnMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCdnMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCdnMutation, { data, loading, error }] = useRemoveCdnMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveCdnMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCdnMutation, RemoveCdnMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveCdnMutation, RemoveCdnMutationVariables>(RemoveCdnDocument, options);
      }
export type RemoveCdnMutationHookResult = ReturnType<typeof useRemoveCdnMutation>;
export type RemoveCdnMutationResult = Apollo.MutationResult<RemoveCdnMutation>;
export type RemoveCdnMutationOptions = Apollo.BaseMutationOptions<RemoveCdnMutation, RemoveCdnMutationVariables>;
export const RemoveProjectLogShipperDocument = gql`
    mutation removeProjectLogShipper($id: UUID!) {
  removeLogShipper(id: $id)
}
    `;
export type RemoveProjectLogShipperMutationFn = Apollo.MutationFunction<RemoveProjectLogShipperMutation, RemoveProjectLogShipperMutationVariables>;

/**
 * __useRemoveProjectLogShipperMutation__
 *
 * To run a mutation, you first call `useRemoveProjectLogShipperMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveProjectLogShipperMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeProjectLogShipperMutation, { data, loading, error }] = useRemoveProjectLogShipperMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveProjectLogShipperMutation(baseOptions?: Apollo.MutationHookOptions<RemoveProjectLogShipperMutation, RemoveProjectLogShipperMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveProjectLogShipperMutation, RemoveProjectLogShipperMutationVariables>(RemoveProjectLogShipperDocument, options);
      }
export type RemoveProjectLogShipperMutationHookResult = ReturnType<typeof useRemoveProjectLogShipperMutation>;
export type RemoveProjectLogShipperMutationResult = Apollo.MutationResult<RemoveProjectLogShipperMutation>;
export type RemoveProjectLogShipperMutationOptions = Apollo.BaseMutationOptions<RemoveProjectLogShipperMutation, RemoveProjectLogShipperMutationVariables>;
export const AddRepoCustomDomainDocument = gql`
    mutation addRepoCustomDomain($input: AddRepoCustomDomainInput!) {
  addRepoCustomDomain(input: $input) {
    id
    clusterDomains {
      id
      ...ClusterDomainsDetail
    }
  }
}
    ${ClusterDomainsDetailFragmentDoc}`;
export type AddRepoCustomDomainMutationFn = Apollo.MutationFunction<AddRepoCustomDomainMutation, AddRepoCustomDomainMutationVariables>;

/**
 * __useAddRepoCustomDomainMutation__
 *
 * To run a mutation, you first call `useAddRepoCustomDomainMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddRepoCustomDomainMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addRepoCustomDomainMutation, { data, loading, error }] = useAddRepoCustomDomainMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddRepoCustomDomainMutation(baseOptions?: Apollo.MutationHookOptions<AddRepoCustomDomainMutation, AddRepoCustomDomainMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddRepoCustomDomainMutation, AddRepoCustomDomainMutationVariables>(AddRepoCustomDomainDocument, options);
      }
export type AddRepoCustomDomainMutationHookResult = ReturnType<typeof useAddRepoCustomDomainMutation>;
export type AddRepoCustomDomainMutationResult = Apollo.MutationResult<AddRepoCustomDomainMutation>;
export type AddRepoCustomDomainMutationOptions = Apollo.BaseMutationOptions<AddRepoCustomDomainMutation, AddRepoCustomDomainMutationVariables>;
export const RemoveRepoCustomDomainDocument = gql`
    mutation removeRepoCustomDomain($input: RemoveRepoCustomDomainInput!) {
  removeRepoCustomDomain(input: $input) {
    id
    clusterDomains {
      id
      ...ClusterDomainsDetail
    }
  }
}
    ${ClusterDomainsDetailFragmentDoc}`;
export type RemoveRepoCustomDomainMutationFn = Apollo.MutationFunction<RemoveRepoCustomDomainMutation, RemoveRepoCustomDomainMutationVariables>;

/**
 * __useRemoveRepoCustomDomainMutation__
 *
 * To run a mutation, you first call `useRemoveRepoCustomDomainMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveRepoCustomDomainMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeRepoCustomDomainMutation, { data, loading, error }] = useRemoveRepoCustomDomainMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveRepoCustomDomainMutation(baseOptions?: Apollo.MutationHookOptions<RemoveRepoCustomDomainMutation, RemoveRepoCustomDomainMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveRepoCustomDomainMutation, RemoveRepoCustomDomainMutationVariables>(RemoveRepoCustomDomainDocument, options);
      }
export type RemoveRepoCustomDomainMutationHookResult = ReturnType<typeof useRemoveRepoCustomDomainMutation>;
export type RemoveRepoCustomDomainMutationResult = Apollo.MutationResult<RemoveRepoCustomDomainMutation>;
export type RemoveRepoCustomDomainMutationOptions = Apollo.BaseMutationOptions<RemoveRepoCustomDomainMutation, RemoveRepoCustomDomainMutationVariables>;
export const RemoveProbeDocument = gql`
    mutation removeProbe($input: RemoveProbeInput!) {
  removeProbe(input: $input) {
    id
    ...RepoDetail
  }
}
    ${RepoDetailFragmentDoc}`;
export type RemoveProbeMutationFn = Apollo.MutationFunction<RemoveProbeMutation, RemoveProbeMutationVariables>;

/**
 * __useRemoveProbeMutation__
 *
 * To run a mutation, you first call `useRemoveProbeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveProbeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeProbeMutation, { data, loading, error }] = useRemoveProbeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveProbeMutation(baseOptions?: Apollo.MutationHookOptions<RemoveProbeMutation, RemoveProbeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveProbeMutation, RemoveProbeMutationVariables>(RemoveProbeDocument, options);
      }
export type RemoveProbeMutationHookResult = ReturnType<typeof useRemoveProbeMutation>;
export type RemoveProbeMutationResult = Apollo.MutationResult<RemoveProbeMutation>;
export type RemoveProbeMutationOptions = Apollo.BaseMutationOptions<RemoveProbeMutation, RemoveProbeMutationVariables>;
export const EnableProjectDocument = gql`
    mutation enableProject($id: ID!) {
  enableRepo(id: $id) {
    ...RepoDetail
  }
}
    ${RepoDetailFragmentDoc}`;
export type EnableProjectMutationFn = Apollo.MutationFunction<EnableProjectMutation, EnableProjectMutationVariables>;

/**
 * __useEnableProjectMutation__
 *
 * To run a mutation, you first call `useEnableProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnableProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enableProjectMutation, { data, loading, error }] = useEnableProjectMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEnableProjectMutation(baseOptions?: Apollo.MutationHookOptions<EnableProjectMutation, EnableProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnableProjectMutation, EnableProjectMutationVariables>(EnableProjectDocument, options);
      }
export type EnableProjectMutationHookResult = ReturnType<typeof useEnableProjectMutation>;
export type EnableProjectMutationResult = Apollo.MutationResult<EnableProjectMutation>;
export type EnableProjectMutationOptions = Apollo.BaseMutationOptions<EnableProjectMutation, EnableProjectMutationVariables>;
export const DisableProjectDocument = gql`
    mutation disableProject($id: ID!) {
  disableRepo(id: $id) {
    ...RepoDetail
  }
}
    ${RepoDetailFragmentDoc}`;
export type DisableProjectMutationFn = Apollo.MutationFunction<DisableProjectMutation, DisableProjectMutationVariables>;

/**
 * __useDisableProjectMutation__
 *
 * To run a mutation, you first call `useDisableProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableProjectMutation, { data, loading, error }] = useDisableProjectMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDisableProjectMutation(baseOptions?: Apollo.MutationHookOptions<DisableProjectMutation, DisableProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisableProjectMutation, DisableProjectMutationVariables>(DisableProjectDocument, options);
      }
export type DisableProjectMutationHookResult = ReturnType<typeof useDisableProjectMutation>;
export type DisableProjectMutationResult = Apollo.MutationResult<DisableProjectMutation>;
export type DisableProjectMutationOptions = Apollo.BaseMutationOptions<DisableProjectMutation, DisableProjectMutationVariables>;
export const DeleteProjectDocument = gql`
    mutation deleteProject($id: ID!) {
  deleteRepo(id: $id)
}
    `;
export type DeleteProjectMutationFn = Apollo.MutationFunction<DeleteProjectMutation, DeleteProjectMutationVariables>;

/**
 * __useDeleteProjectMutation__
 *
 * To run a mutation, you first call `useDeleteProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProjectMutation, { data, loading, error }] = useDeleteProjectMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProjectMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProjectMutation, DeleteProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProjectMutation, DeleteProjectMutationVariables>(DeleteProjectDocument, options);
      }
export type DeleteProjectMutationHookResult = ReturnType<typeof useDeleteProjectMutation>;
export type DeleteProjectMutationResult = Apollo.MutationResult<DeleteProjectMutation>;
export type DeleteProjectMutationOptions = Apollo.BaseMutationOptions<DeleteProjectMutation, DeleteProjectMutationVariables>;
export const UnlinkProjectDocument = gql`
    mutation unlinkProject($id: ID!) {
  unlinkRepo(id: $id)
}
    `;
export type UnlinkProjectMutationFn = Apollo.MutationFunction<UnlinkProjectMutation, UnlinkProjectMutationVariables>;

/**
 * __useUnlinkProjectMutation__
 *
 * To run a mutation, you first call `useUnlinkProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkProjectMutation, { data, loading, error }] = useUnlinkProjectMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUnlinkProjectMutation(baseOptions?: Apollo.MutationHookOptions<UnlinkProjectMutation, UnlinkProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlinkProjectMutation, UnlinkProjectMutationVariables>(UnlinkProjectDocument, options);
      }
export type UnlinkProjectMutationHookResult = ReturnType<typeof useUnlinkProjectMutation>;
export type UnlinkProjectMutationResult = Apollo.MutationResult<UnlinkProjectMutation>;
export type UnlinkProjectMutationOptions = Apollo.BaseMutationOptions<UnlinkProjectMutation, UnlinkProjectMutationVariables>;
export const DuplicateProjectDocument = gql`
    mutation DuplicateProject($input: DuplicateProjectInput!) {
  duplicateProject(input: $input) {
    ...RepoDetail
  }
}
    ${RepoDetailFragmentDoc}`;
export type DuplicateProjectMutationFn = Apollo.MutationFunction<DuplicateProjectMutation, DuplicateProjectMutationVariables>;

/**
 * __useDuplicateProjectMutation__
 *
 * To run a mutation, you first call `useDuplicateProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateProjectMutation, { data, loading, error }] = useDuplicateProjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDuplicateProjectMutation(baseOptions?: Apollo.MutationHookOptions<DuplicateProjectMutation, DuplicateProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DuplicateProjectMutation, DuplicateProjectMutationVariables>(DuplicateProjectDocument, options);
      }
export type DuplicateProjectMutationHookResult = ReturnType<typeof useDuplicateProjectMutation>;
export type DuplicateProjectMutationResult = Apollo.MutationResult<DuplicateProjectMutation>;
export type DuplicateProjectMutationOptions = Apollo.BaseMutationOptions<DuplicateProjectMutation, DuplicateProjectMutationVariables>;
export const DeleteProjectV2Document = gql`
    mutation deleteProjectV2($id: UUID!) {
  deleteProjectV2(id: $id)
}
    `;
export type DeleteProjectV2MutationFn = Apollo.MutationFunction<DeleteProjectV2Mutation, DeleteProjectV2MutationVariables>;

/**
 * __useDeleteProjectV2Mutation__
 *
 * To run a mutation, you first call `useDeleteProjectV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProjectV2Mutation, { data, loading, error }] = useDeleteProjectV2Mutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProjectV2Mutation(baseOptions?: Apollo.MutationHookOptions<DeleteProjectV2Mutation, DeleteProjectV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProjectV2Mutation, DeleteProjectV2MutationVariables>(DeleteProjectV2Document, options);
      }
export type DeleteProjectV2MutationHookResult = ReturnType<typeof useDeleteProjectV2Mutation>;
export type DeleteProjectV2MutationResult = Apollo.MutationResult<DeleteProjectV2Mutation>;
export type DeleteProjectV2MutationOptions = Apollo.BaseMutationOptions<DeleteProjectV2Mutation, DeleteProjectV2MutationVariables>;
export const DeleteProjectV3Document = gql`
    mutation deleteProjectV3($id: UUID!) {
  deleteProjectV3(id: $id)
}
    `;
export type DeleteProjectV3MutationFn = Apollo.MutationFunction<DeleteProjectV3Mutation, DeleteProjectV3MutationVariables>;

/**
 * __useDeleteProjectV3Mutation__
 *
 * To run a mutation, you first call `useDeleteProjectV3Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectV3Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProjectV3Mutation, { data, loading, error }] = useDeleteProjectV3Mutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProjectV3Mutation(baseOptions?: Apollo.MutationHookOptions<DeleteProjectV3Mutation, DeleteProjectV3MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProjectV3Mutation, DeleteProjectV3MutationVariables>(DeleteProjectV3Document, options);
      }
export type DeleteProjectV3MutationHookResult = ReturnType<typeof useDeleteProjectV3Mutation>;
export type DeleteProjectV3MutationResult = Apollo.MutationResult<DeleteProjectV3Mutation>;
export type DeleteProjectV3MutationOptions = Apollo.BaseMutationOptions<DeleteProjectV3Mutation, DeleteProjectV3MutationVariables>;
export const UpdateProjectV2Document = gql`
    mutation updateProjectV2($input: UpdateProjectV2Input!) {
  updateProjectV2(input: $input) {
    ...ProjectBasic
  }
}
    ${ProjectBasicFragmentDoc}`;
export type UpdateProjectV2MutationFn = Apollo.MutationFunction<UpdateProjectV2Mutation, UpdateProjectV2MutationVariables>;

/**
 * __useUpdateProjectV2Mutation__
 *
 * To run a mutation, you first call `useUpdateProjectV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectV2Mutation, { data, loading, error }] = useUpdateProjectV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProjectV2Mutation(baseOptions?: Apollo.MutationHookOptions<UpdateProjectV2Mutation, UpdateProjectV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProjectV2Mutation, UpdateProjectV2MutationVariables>(UpdateProjectV2Document, options);
      }
export type UpdateProjectV2MutationHookResult = ReturnType<typeof useUpdateProjectV2Mutation>;
export type UpdateProjectV2MutationResult = Apollo.MutationResult<UpdateProjectV2Mutation>;
export type UpdateProjectV2MutationOptions = Apollo.BaseMutationOptions<UpdateProjectV2Mutation, UpdateProjectV2MutationVariables>;
export const MoveRepoTargetsDocument = gql`
    query moveRepoTargets($id: ID!) {
  user(id: $id) {
    id
    projects {
      nodes {
        id
        name
        environments {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useMoveRepoTargetsQuery__
 *
 * To run a query within a React component, call `useMoveRepoTargetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMoveRepoTargetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMoveRepoTargetsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMoveRepoTargetsQuery(baseOptions: Apollo.QueryHookOptions<MoveRepoTargetsQuery, MoveRepoTargetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MoveRepoTargetsQuery, MoveRepoTargetsQueryVariables>(MoveRepoTargetsDocument, options);
      }
export function useMoveRepoTargetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MoveRepoTargetsQuery, MoveRepoTargetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MoveRepoTargetsQuery, MoveRepoTargetsQueryVariables>(MoveRepoTargetsDocument, options);
        }
export type MoveRepoTargetsQueryHookResult = ReturnType<typeof useMoveRepoTargetsQuery>;
export type MoveRepoTargetsLazyQueryHookResult = ReturnType<typeof useMoveRepoTargetsLazyQuery>;
export type MoveRepoTargetsQueryResult = Apollo.QueryResult<MoveRepoTargetsQuery, MoveRepoTargetsQueryVariables>;
export function refetchMoveRepoTargetsQuery(variables: MoveRepoTargetsQueryVariables) {
      return { query: MoveRepoTargetsDocument, variables: variables }
    }
export const MoveRepoDocument = gql`
    mutation moveRepo($input: MoveRepoInput!) {
  moveRepoToProjectEnvironment(input: $input) {
    ...RepoDetail
    projectEnvironment {
      id
      name
    }
  }
}
    ${RepoDetailFragmentDoc}`;
export type MoveRepoMutationFn = Apollo.MutationFunction<MoveRepoMutation, MoveRepoMutationVariables>;

/**
 * __useMoveRepoMutation__
 *
 * To run a mutation, you first call `useMoveRepoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveRepoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveRepoMutation, { data, loading, error }] = useMoveRepoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMoveRepoMutation(baseOptions?: Apollo.MutationHookOptions<MoveRepoMutation, MoveRepoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MoveRepoMutation, MoveRepoMutationVariables>(MoveRepoDocument, options);
      }
export type MoveRepoMutationHookResult = ReturnType<typeof useMoveRepoMutation>;
export type MoveRepoMutationResult = Apollo.MutationResult<MoveRepoMutation>;
export type MoveRepoMutationOptions = Apollo.BaseMutationOptions<MoveRepoMutation, MoveRepoMutationVariables>;
export const ConfigureUserProjectPermissionsDocument = gql`
    mutation configureUserProjectPermissions($projectID: UUID!, $permission: ProjectPermissionsInput!) {
  configureProjectPermissions(projectIds: [$projectID], permissions: $permission)
}
    `;
export type ConfigureUserProjectPermissionsMutationFn = Apollo.MutationFunction<ConfigureUserProjectPermissionsMutation, ConfigureUserProjectPermissionsMutationVariables>;

/**
 * __useConfigureUserProjectPermissionsMutation__
 *
 * To run a mutation, you first call `useConfigureUserProjectPermissionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfigureUserProjectPermissionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [configureUserProjectPermissionsMutation, { data, loading, error }] = useConfigureUserProjectPermissionsMutation({
 *   variables: {
 *      projectID: // value for 'projectID'
 *      permission: // value for 'permission'
 *   },
 * });
 */
export function useConfigureUserProjectPermissionsMutation(baseOptions?: Apollo.MutationHookOptions<ConfigureUserProjectPermissionsMutation, ConfigureUserProjectPermissionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfigureUserProjectPermissionsMutation, ConfigureUserProjectPermissionsMutationVariables>(ConfigureUserProjectPermissionsDocument, options);
      }
export type ConfigureUserProjectPermissionsMutationHookResult = ReturnType<typeof useConfigureUserProjectPermissionsMutation>;
export type ConfigureUserProjectPermissionsMutationResult = Apollo.MutationResult<ConfigureUserProjectPermissionsMutation>;
export type ConfigureUserProjectPermissionsMutationOptions = Apollo.BaseMutationOptions<ConfigureUserProjectPermissionsMutation, ConfigureUserProjectPermissionsMutationVariables>;
export const CreateProjectEnvironmentDocument = gql`
    mutation createProjectEnvironment($input: CreateProjectEnvironmentInput!) {
  createProjectEnvironment(input: $input) {
    id
    name
  }
}
    `;
export type CreateProjectEnvironmentMutationFn = Apollo.MutationFunction<CreateProjectEnvironmentMutation, CreateProjectEnvironmentMutationVariables>;

/**
 * __useCreateProjectEnvironmentMutation__
 *
 * To run a mutation, you first call `useCreateProjectEnvironmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectEnvironmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectEnvironmentMutation, { data, loading, error }] = useCreateProjectEnvironmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProjectEnvironmentMutation(baseOptions?: Apollo.MutationHookOptions<CreateProjectEnvironmentMutation, CreateProjectEnvironmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProjectEnvironmentMutation, CreateProjectEnvironmentMutationVariables>(CreateProjectEnvironmentDocument, options);
      }
export type CreateProjectEnvironmentMutationHookResult = ReturnType<typeof useCreateProjectEnvironmentMutation>;
export type CreateProjectEnvironmentMutationResult = Apollo.MutationResult<CreateProjectEnvironmentMutation>;
export type CreateProjectEnvironmentMutationOptions = Apollo.BaseMutationOptions<CreateProjectEnvironmentMutation, CreateProjectEnvironmentMutationVariables>;
export const UpdateProjectEnvironmentDocument = gql`
    mutation updateProjectEnvironment($input: UpdateProjectEnvironmentInput!) {
  updateProjectEnvironment(input: $input) {
    id
    name
  }
}
    `;
export type UpdateProjectEnvironmentMutationFn = Apollo.MutationFunction<UpdateProjectEnvironmentMutation, UpdateProjectEnvironmentMutationVariables>;

/**
 * __useUpdateProjectEnvironmentMutation__
 *
 * To run a mutation, you first call `useUpdateProjectEnvironmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectEnvironmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectEnvironmentMutation, { data, loading, error }] = useUpdateProjectEnvironmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProjectEnvironmentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProjectEnvironmentMutation, UpdateProjectEnvironmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProjectEnvironmentMutation, UpdateProjectEnvironmentMutationVariables>(UpdateProjectEnvironmentDocument, options);
      }
export type UpdateProjectEnvironmentMutationHookResult = ReturnType<typeof useUpdateProjectEnvironmentMutation>;
export type UpdateProjectEnvironmentMutationResult = Apollo.MutationResult<UpdateProjectEnvironmentMutation>;
export type UpdateProjectEnvironmentMutationOptions = Apollo.BaseMutationOptions<UpdateProjectEnvironmentMutation, UpdateProjectEnvironmentMutationVariables>;
export const DeleteProjectEnvironmentDocument = gql`
    mutation deleteProjectEnvironment($id: UUID!) {
  deleteProjectEnvironment(id: $id)
}
    `;
export type DeleteProjectEnvironmentMutationFn = Apollo.MutationFunction<DeleteProjectEnvironmentMutation, DeleteProjectEnvironmentMutationVariables>;

/**
 * __useDeleteProjectEnvironmentMutation__
 *
 * To run a mutation, you first call `useDeleteProjectEnvironmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectEnvironmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProjectEnvironmentMutation, { data, loading, error }] = useDeleteProjectEnvironmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProjectEnvironmentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProjectEnvironmentMutation, DeleteProjectEnvironmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProjectEnvironmentMutation, DeleteProjectEnvironmentMutationVariables>(DeleteProjectEnvironmentDocument, options);
      }
export type DeleteProjectEnvironmentMutationHookResult = ReturnType<typeof useDeleteProjectEnvironmentMutation>;
export type DeleteProjectEnvironmentMutationResult = Apollo.MutationResult<DeleteProjectEnvironmentMutation>;
export type DeleteProjectEnvironmentMutationOptions = Apollo.BaseMutationOptions<DeleteProjectEnvironmentMutation, DeleteProjectEnvironmentMutationVariables>;
export const UpdateProjectEnvironmentVariablesDocument = gql`
    mutation updateProjectEnvironmentVariables($input: UpdateProjectV2Input!) {
  updateProjectV2(input: $input) {
    id
  }
}
    `;
export type UpdateProjectEnvironmentVariablesMutationFn = Apollo.MutationFunction<UpdateProjectEnvironmentVariablesMutation, UpdateProjectEnvironmentVariablesMutationVariables>;

/**
 * __useUpdateProjectEnvironmentVariablesMutation__
 *
 * To run a mutation, you first call `useUpdateProjectEnvironmentVariablesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectEnvironmentVariablesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectEnvironmentVariablesMutation, { data, loading, error }] = useUpdateProjectEnvironmentVariablesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProjectEnvironmentVariablesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProjectEnvironmentVariablesMutation, UpdateProjectEnvironmentVariablesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProjectEnvironmentVariablesMutation, UpdateProjectEnvironmentVariablesMutationVariables>(UpdateProjectEnvironmentVariablesDocument, options);
      }
export type UpdateProjectEnvironmentVariablesMutationHookResult = ReturnType<typeof useUpdateProjectEnvironmentVariablesMutation>;
export type UpdateProjectEnvironmentVariablesMutationResult = Apollo.MutationResult<UpdateProjectEnvironmentVariablesMutation>;
export type UpdateProjectEnvironmentVariablesMutationOptions = Apollo.BaseMutationOptions<UpdateProjectEnvironmentVariablesMutation, UpdateProjectEnvironmentVariablesMutationVariables>;
export const UpdateEnvironmentEnvironmentVariablesDocument = gql`
    mutation updateEnvironmentEnvironmentVariables($input: UpdateProjectEnvironmentInput!) {
  updateProjectEnvironment(input: $input) {
    envs {
      ...EnvVarDetail
    }
    ...ProjectEnvironmentBasic
  }
}
    ${EnvVarDetailFragmentDoc}
${ProjectEnvironmentBasicFragmentDoc}`;
export type UpdateEnvironmentEnvironmentVariablesMutationFn = Apollo.MutationFunction<UpdateEnvironmentEnvironmentVariablesMutation, UpdateEnvironmentEnvironmentVariablesMutationVariables>;

/**
 * __useUpdateEnvironmentEnvironmentVariablesMutation__
 *
 * To run a mutation, you first call `useUpdateEnvironmentEnvironmentVariablesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEnvironmentEnvironmentVariablesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEnvironmentEnvironmentVariablesMutation, { data, loading, error }] = useUpdateEnvironmentEnvironmentVariablesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEnvironmentEnvironmentVariablesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEnvironmentEnvironmentVariablesMutation, UpdateEnvironmentEnvironmentVariablesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEnvironmentEnvironmentVariablesMutation, UpdateEnvironmentEnvironmentVariablesMutationVariables>(UpdateEnvironmentEnvironmentVariablesDocument, options);
      }
export type UpdateEnvironmentEnvironmentVariablesMutationHookResult = ReturnType<typeof useUpdateEnvironmentEnvironmentVariablesMutation>;
export type UpdateEnvironmentEnvironmentVariablesMutationResult = Apollo.MutationResult<UpdateEnvironmentEnvironmentVariablesMutation>;
export type UpdateEnvironmentEnvironmentVariablesMutationOptions = Apollo.BaseMutationOptions<UpdateEnvironmentEnvironmentVariablesMutation, UpdateEnvironmentEnvironmentVariablesMutationVariables>;
export const CreateResourceAlphaDocument = gql`
    mutation createResourceAlpha($input: CreateResourceAlphaInput!) {
  createResourceAlpha(input: $input) {
    id
    name
    project {
      id
      name
    }
    projectEnvironment {
      id
      name
    }
  }
}
    `;
export type CreateResourceAlphaMutationFn = Apollo.MutationFunction<CreateResourceAlphaMutation, CreateResourceAlphaMutationVariables>;

/**
 * __useCreateResourceAlphaMutation__
 *
 * To run a mutation, you first call `useCreateResourceAlphaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateResourceAlphaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createResourceAlphaMutation, { data, loading, error }] = useCreateResourceAlphaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateResourceAlphaMutation(baseOptions?: Apollo.MutationHookOptions<CreateResourceAlphaMutation, CreateResourceAlphaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateResourceAlphaMutation, CreateResourceAlphaMutationVariables>(CreateResourceAlphaDocument, options);
      }
export type CreateResourceAlphaMutationHookResult = ReturnType<typeof useCreateResourceAlphaMutation>;
export type CreateResourceAlphaMutationResult = Apollo.MutationResult<CreateResourceAlphaMutation>;
export type CreateResourceAlphaMutationOptions = Apollo.BaseMutationOptions<CreateResourceAlphaMutation, CreateResourceAlphaMutationVariables>;
export const CreateProjectV3Document = gql`
    mutation createProjectV3($input: CreateProjectV3Input!) {
  createProjectV3(input: $input) {
    ...ProjectV3Detail
  }
}
    ${ProjectV3DetailFragmentDoc}`;
export type CreateProjectV3MutationFn = Apollo.MutationFunction<CreateProjectV3Mutation, CreateProjectV3MutationVariables>;

/**
 * __useCreateProjectV3Mutation__
 *
 * To run a mutation, you first call `useCreateProjectV3Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectV3Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectV3Mutation, { data, loading, error }] = useCreateProjectV3Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProjectV3Mutation(baseOptions?: Apollo.MutationHookOptions<CreateProjectV3Mutation, CreateProjectV3MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProjectV3Mutation, CreateProjectV3MutationVariables>(CreateProjectV3Document, options);
      }
export type CreateProjectV3MutationHookResult = ReturnType<typeof useCreateProjectV3Mutation>;
export type CreateProjectV3MutationResult = Apollo.MutationResult<CreateProjectV3Mutation>;
export type CreateProjectV3MutationOptions = Apollo.BaseMutationOptions<CreateProjectV3Mutation, CreateProjectV3MutationVariables>;
export const DuplicateProjectV3Document = gql`
    mutation duplicateProjectV3($input: DuplicateProjectV3Input!) {
  duplicateProjectV3(input: $input) {
    id
    name
    project {
      id
      name
    }
    projectEnvironment {
      id
      name
    }
  }
}
    `;
export type DuplicateProjectV3MutationFn = Apollo.MutationFunction<DuplicateProjectV3Mutation, DuplicateProjectV3MutationVariables>;

/**
 * __useDuplicateProjectV3Mutation__
 *
 * To run a mutation, you first call `useDuplicateProjectV3Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateProjectV3Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateProjectV3Mutation, { data, loading, error }] = useDuplicateProjectV3Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDuplicateProjectV3Mutation(baseOptions?: Apollo.MutationHookOptions<DuplicateProjectV3Mutation, DuplicateProjectV3MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DuplicateProjectV3Mutation, DuplicateProjectV3MutationVariables>(DuplicateProjectV3Document, options);
      }
export type DuplicateProjectV3MutationHookResult = ReturnType<typeof useDuplicateProjectV3Mutation>;
export type DuplicateProjectV3MutationResult = Apollo.MutationResult<DuplicateProjectV3Mutation>;
export type DuplicateProjectV3MutationOptions = Apollo.BaseMutationOptions<DuplicateProjectV3Mutation, DuplicateProjectV3MutationVariables>;
export const UpdateProjectV3Document = gql`
    mutation updateProjectV3($projectID: UUID!, $input: UpdateProjectV3Input!) {
  updateProjectV3(projectID: $projectID, input: $input) {
    id
  }
}
    `;
export type UpdateProjectV3MutationFn = Apollo.MutationFunction<UpdateProjectV3Mutation, UpdateProjectV3MutationVariables>;

/**
 * __useUpdateProjectV3Mutation__
 *
 * To run a mutation, you first call `useUpdateProjectV3Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectV3Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectV3Mutation, { data, loading, error }] = useUpdateProjectV3Mutation({
 *   variables: {
 *      projectID: // value for 'projectID'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProjectV3Mutation(baseOptions?: Apollo.MutationHookOptions<UpdateProjectV3Mutation, UpdateProjectV3MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProjectV3Mutation, UpdateProjectV3MutationVariables>(UpdateProjectV3Document, options);
      }
export type UpdateProjectV3MutationHookResult = ReturnType<typeof useUpdateProjectV3Mutation>;
export type UpdateProjectV3MutationResult = Apollo.MutationResult<UpdateProjectV3Mutation>;
export type UpdateProjectV3MutationOptions = Apollo.BaseMutationOptions<UpdateProjectV3Mutation, UpdateProjectV3MutationVariables>;
export const CreateBlueprintDriverWorkflowDocument = gql`
    mutation createBlueprintDriverWorkflow($projectID: UUID!, $driver: BlueprintDriver!, $steps: [BlueprintDriverWorkflowStepAction!]!) {
  submitBlueprintDriverWorkflow(
    projectID: $projectID
    input: {driver: $driver, steps: $steps}
  ) {
    id
    ...BlueprintDriverWorkflowDetail
  }
}
    ${BlueprintDriverWorkflowDetailFragmentDoc}`;
export type CreateBlueprintDriverWorkflowMutationFn = Apollo.MutationFunction<CreateBlueprintDriverWorkflowMutation, CreateBlueprintDriverWorkflowMutationVariables>;

/**
 * __useCreateBlueprintDriverWorkflowMutation__
 *
 * To run a mutation, you first call `useCreateBlueprintDriverWorkflowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBlueprintDriverWorkflowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBlueprintDriverWorkflowMutation, { data, loading, error }] = useCreateBlueprintDriverWorkflowMutation({
 *   variables: {
 *      projectID: // value for 'projectID'
 *      driver: // value for 'driver'
 *      steps: // value for 'steps'
 *   },
 * });
 */
export function useCreateBlueprintDriverWorkflowMutation(baseOptions?: Apollo.MutationHookOptions<CreateBlueprintDriverWorkflowMutation, CreateBlueprintDriverWorkflowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBlueprintDriverWorkflowMutation, CreateBlueprintDriverWorkflowMutationVariables>(CreateBlueprintDriverWorkflowDocument, options);
      }
export type CreateBlueprintDriverWorkflowMutationHookResult = ReturnType<typeof useCreateBlueprintDriverWorkflowMutation>;
export type CreateBlueprintDriverWorkflowMutationResult = Apollo.MutationResult<CreateBlueprintDriverWorkflowMutation>;
export type CreateBlueprintDriverWorkflowMutationOptions = Apollo.BaseMutationOptions<CreateBlueprintDriverWorkflowMutation, CreateBlueprintDriverWorkflowMutationVariables>;
export const ApproveBlueprintDriverWorkflowDocument = gql`
    mutation approveBlueprintDriverWorkflow($workflowID: UUID!) {
  approveBlueprintDriverWorkflow(workflowID: $workflowID) {
    id
    ...BlueprintDriverWorkflowDetail
  }
}
    ${BlueprintDriverWorkflowDetailFragmentDoc}`;
export type ApproveBlueprintDriverWorkflowMutationFn = Apollo.MutationFunction<ApproveBlueprintDriverWorkflowMutation, ApproveBlueprintDriverWorkflowMutationVariables>;

/**
 * __useApproveBlueprintDriverWorkflowMutation__
 *
 * To run a mutation, you first call `useApproveBlueprintDriverWorkflowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveBlueprintDriverWorkflowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveBlueprintDriverWorkflowMutation, { data, loading, error }] = useApproveBlueprintDriverWorkflowMutation({
 *   variables: {
 *      workflowID: // value for 'workflowID'
 *   },
 * });
 */
export function useApproveBlueprintDriverWorkflowMutation(baseOptions?: Apollo.MutationHookOptions<ApproveBlueprintDriverWorkflowMutation, ApproveBlueprintDriverWorkflowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveBlueprintDriverWorkflowMutation, ApproveBlueprintDriverWorkflowMutationVariables>(ApproveBlueprintDriverWorkflowDocument, options);
      }
export type ApproveBlueprintDriverWorkflowMutationHookResult = ReturnType<typeof useApproveBlueprintDriverWorkflowMutation>;
export type ApproveBlueprintDriverWorkflowMutationResult = Apollo.MutationResult<ApproveBlueprintDriverWorkflowMutation>;
export type ApproveBlueprintDriverWorkflowMutationOptions = Apollo.BaseMutationOptions<ApproveBlueprintDriverWorkflowMutation, ApproveBlueprintDriverWorkflowMutationVariables>;
export const AbortBlueprintDriverWorkflowDocument = gql`
    mutation abortBlueprintDriverWorkflow($workflowID: UUID!) {
  abortBlueprintDriverWorkflow(workflowID: $workflowID)
}
    `;
export type AbortBlueprintDriverWorkflowMutationFn = Apollo.MutationFunction<AbortBlueprintDriverWorkflowMutation, AbortBlueprintDriverWorkflowMutationVariables>;

/**
 * __useAbortBlueprintDriverWorkflowMutation__
 *
 * To run a mutation, you first call `useAbortBlueprintDriverWorkflowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAbortBlueprintDriverWorkflowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [abortBlueprintDriverWorkflowMutation, { data, loading, error }] = useAbortBlueprintDriverWorkflowMutation({
 *   variables: {
 *      workflowID: // value for 'workflowID'
 *   },
 * });
 */
export function useAbortBlueprintDriverWorkflowMutation(baseOptions?: Apollo.MutationHookOptions<AbortBlueprintDriverWorkflowMutation, AbortBlueprintDriverWorkflowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AbortBlueprintDriverWorkflowMutation, AbortBlueprintDriverWorkflowMutationVariables>(AbortBlueprintDriverWorkflowDocument, options);
      }
export type AbortBlueprintDriverWorkflowMutationHookResult = ReturnType<typeof useAbortBlueprintDriverWorkflowMutation>;
export type AbortBlueprintDriverWorkflowMutationResult = Apollo.MutationResult<AbortBlueprintDriverWorkflowMutation>;
export type AbortBlueprintDriverWorkflowMutationOptions = Apollo.BaseMutationOptions<AbortBlueprintDriverWorkflowMutation, AbortBlueprintDriverWorkflowMutationVariables>;
export const RollbackToDeploymentDocument = gql`
    mutation rollbackToDeployment($projectID: UUID!, $deploymentID: UUID!) {
  rollbackProjectToDeployment(projectID: $projectID, deploymentID: $deploymentID) {
    id
    productionDeployment {
      id
      status
      deployStatus {
        state
        active
      }
    }
  }
}
    `;
export type RollbackToDeploymentMutationFn = Apollo.MutationFunction<RollbackToDeploymentMutation, RollbackToDeploymentMutationVariables>;

/**
 * __useRollbackToDeploymentMutation__
 *
 * To run a mutation, you first call `useRollbackToDeploymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRollbackToDeploymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rollbackToDeploymentMutation, { data, loading, error }] = useRollbackToDeploymentMutation({
 *   variables: {
 *      projectID: // value for 'projectID'
 *      deploymentID: // value for 'deploymentID'
 *   },
 * });
 */
export function useRollbackToDeploymentMutation(baseOptions?: Apollo.MutationHookOptions<RollbackToDeploymentMutation, RollbackToDeploymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RollbackToDeploymentMutation, RollbackToDeploymentMutationVariables>(RollbackToDeploymentDocument, options);
      }
export type RollbackToDeploymentMutationHookResult = ReturnType<typeof useRollbackToDeploymentMutation>;
export type RollbackToDeploymentMutationResult = Apollo.MutationResult<RollbackToDeploymentMutation>;
export type RollbackToDeploymentMutationOptions = Apollo.BaseMutationOptions<RollbackToDeploymentMutation, RollbackToDeploymentMutationVariables>;
export const DeployRepoBranchDocument = gql`
    mutation deployRepoBranch($input: DeployRepoBranchInput!) {
  deployRepoBranch(input: $input) {
    ...RepoDetail
  }
}
    ${RepoDetailFragmentDoc}`;
export type DeployRepoBranchMutationFn = Apollo.MutationFunction<DeployRepoBranchMutation, DeployRepoBranchMutationVariables>;

/**
 * __useDeployRepoBranchMutation__
 *
 * To run a mutation, you first call `useDeployRepoBranchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeployRepoBranchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deployRepoBranchMutation, { data, loading, error }] = useDeployRepoBranchMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeployRepoBranchMutation(baseOptions?: Apollo.MutationHookOptions<DeployRepoBranchMutation, DeployRepoBranchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeployRepoBranchMutation, DeployRepoBranchMutationVariables>(DeployRepoBranchDocument, options);
      }
export type DeployRepoBranchMutationHookResult = ReturnType<typeof useDeployRepoBranchMutation>;
export type DeployRepoBranchMutationResult = Apollo.MutationResult<DeployRepoBranchMutation>;
export type DeployRepoBranchMutationOptions = Apollo.BaseMutationOptions<DeployRepoBranchMutation, DeployRepoBranchMutationVariables>;
export const AbortBuildDocument = gql`
    mutation abortBuild($id: UUID!) {
  abortBuild(id: $id) {
    ...RepoDetail
  }
}
    ${RepoDetailFragmentDoc}`;
export type AbortBuildMutationFn = Apollo.MutationFunction<AbortBuildMutation, AbortBuildMutationVariables>;

/**
 * __useAbortBuildMutation__
 *
 * To run a mutation, you first call `useAbortBuildMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAbortBuildMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [abortBuildMutation, { data, loading, error }] = useAbortBuildMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAbortBuildMutation(baseOptions?: Apollo.MutationHookOptions<AbortBuildMutation, AbortBuildMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AbortBuildMutation, AbortBuildMutationVariables>(AbortBuildDocument, options);
      }
export type AbortBuildMutationHookResult = ReturnType<typeof useAbortBuildMutation>;
export type AbortBuildMutationResult = Apollo.MutationResult<AbortBuildMutation>;
export type AbortBuildMutationOptions = Apollo.BaseMutationOptions<AbortBuildMutation, AbortBuildMutationVariables>;
export const AddContainerRegistryDocument = gql`
    mutation addContainerRegistry($input: AddContainerRegistryInput!) {
  addContainerRegistry(input: $input) {
    id
    name
    registry
    username
  }
}
    `;
export type AddContainerRegistryMutationFn = Apollo.MutationFunction<AddContainerRegistryMutation, AddContainerRegistryMutationVariables>;

/**
 * __useAddContainerRegistryMutation__
 *
 * To run a mutation, you first call `useAddContainerRegistryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddContainerRegistryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addContainerRegistryMutation, { data, loading, error }] = useAddContainerRegistryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddContainerRegistryMutation(baseOptions?: Apollo.MutationHookOptions<AddContainerRegistryMutation, AddContainerRegistryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddContainerRegistryMutation, AddContainerRegistryMutationVariables>(AddContainerRegistryDocument, options);
      }
export type AddContainerRegistryMutationHookResult = ReturnType<typeof useAddContainerRegistryMutation>;
export type AddContainerRegistryMutationResult = Apollo.MutationResult<AddContainerRegistryMutation>;
export type AddContainerRegistryMutationOptions = Apollo.BaseMutationOptions<AddContainerRegistryMutation, AddContainerRegistryMutationVariables>;
export const RemoveContainerRegistryDocument = gql`
    mutation removeContainerRegistry($id: UUID!) {
  removeContainerRegistry(id: $id)
}
    `;
export type RemoveContainerRegistryMutationFn = Apollo.MutationFunction<RemoveContainerRegistryMutation, RemoveContainerRegistryMutationVariables>;

/**
 * __useRemoveContainerRegistryMutation__
 *
 * To run a mutation, you first call `useRemoveContainerRegistryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveContainerRegistryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeContainerRegistryMutation, { data, loading, error }] = useRemoveContainerRegistryMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveContainerRegistryMutation(baseOptions?: Apollo.MutationHookOptions<RemoveContainerRegistryMutation, RemoveContainerRegistryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveContainerRegistryMutation, RemoveContainerRegistryMutationVariables>(RemoveContainerRegistryDocument, options);
      }
export type RemoveContainerRegistryMutationHookResult = ReturnType<typeof useRemoveContainerRegistryMutation>;
export type RemoveContainerRegistryMutationResult = Apollo.MutationResult<RemoveContainerRegistryMutation>;
export type RemoveContainerRegistryMutationOptions = Apollo.BaseMutationOptions<RemoveContainerRegistryMutation, RemoveContainerRegistryMutationVariables>;
export const CreateRepoPipelineLinkDocument = gql`
    mutation createRepoPipelineLink($input: CreateRepoPipelineLinkInput!) {
  createRepoPipelineLink(input: $input) {
    ...RepoPipelineLinkDetail
  }
}
    ${RepoPipelineLinkDetailFragmentDoc}`;
export type CreateRepoPipelineLinkMutationFn = Apollo.MutationFunction<CreateRepoPipelineLinkMutation, CreateRepoPipelineLinkMutationVariables>;

/**
 * __useCreateRepoPipelineLinkMutation__
 *
 * To run a mutation, you first call `useCreateRepoPipelineLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRepoPipelineLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRepoPipelineLinkMutation, { data, loading, error }] = useCreateRepoPipelineLinkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateRepoPipelineLinkMutation(baseOptions?: Apollo.MutationHookOptions<CreateRepoPipelineLinkMutation, CreateRepoPipelineLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRepoPipelineLinkMutation, CreateRepoPipelineLinkMutationVariables>(CreateRepoPipelineLinkDocument, options);
      }
export type CreateRepoPipelineLinkMutationHookResult = ReturnType<typeof useCreateRepoPipelineLinkMutation>;
export type CreateRepoPipelineLinkMutationResult = Apollo.MutationResult<CreateRepoPipelineLinkMutation>;
export type CreateRepoPipelineLinkMutationOptions = Apollo.BaseMutationOptions<CreateRepoPipelineLinkMutation, CreateRepoPipelineLinkMutationVariables>;
export const DeleteRepoPipelineLinkDocument = gql`
    mutation deleteRepoPipelineLink($id: UUID!) {
  deleteRepoPipelineLink(id: $id)
}
    `;
export type DeleteRepoPipelineLinkMutationFn = Apollo.MutationFunction<DeleteRepoPipelineLinkMutation, DeleteRepoPipelineLinkMutationVariables>;

/**
 * __useDeleteRepoPipelineLinkMutation__
 *
 * To run a mutation, you first call `useDeleteRepoPipelineLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRepoPipelineLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRepoPipelineLinkMutation, { data, loading, error }] = useDeleteRepoPipelineLinkMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteRepoPipelineLinkMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRepoPipelineLinkMutation, DeleteRepoPipelineLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRepoPipelineLinkMutation, DeleteRepoPipelineLinkMutationVariables>(DeleteRepoPipelineLinkDocument, options);
      }
export type DeleteRepoPipelineLinkMutationHookResult = ReturnType<typeof useDeleteRepoPipelineLinkMutation>;
export type DeleteRepoPipelineLinkMutationResult = Apollo.MutationResult<DeleteRepoPipelineLinkMutation>;
export type DeleteRepoPipelineLinkMutationOptions = Apollo.BaseMutationOptions<DeleteRepoPipelineLinkMutation, DeleteRepoPipelineLinkMutationVariables>;
export const UpdateRepoPipelineLinkDocument = gql`
    mutation updateRepoPipelineLink($input: UpdateRepoPipelineLinkInput!) {
  updateRepoPipelineLink(input: $input) {
    ...RepoPipelineLinkDetail
  }
}
    ${RepoPipelineLinkDetailFragmentDoc}`;
export type UpdateRepoPipelineLinkMutationFn = Apollo.MutationFunction<UpdateRepoPipelineLinkMutation, UpdateRepoPipelineLinkMutationVariables>;

/**
 * __useUpdateRepoPipelineLinkMutation__
 *
 * To run a mutation, you first call `useUpdateRepoPipelineLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRepoPipelineLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRepoPipelineLinkMutation, { data, loading, error }] = useUpdateRepoPipelineLinkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateRepoPipelineLinkMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRepoPipelineLinkMutation, UpdateRepoPipelineLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRepoPipelineLinkMutation, UpdateRepoPipelineLinkMutationVariables>(UpdateRepoPipelineLinkDocument, options);
      }
export type UpdateRepoPipelineLinkMutationHookResult = ReturnType<typeof useUpdateRepoPipelineLinkMutation>;
export type UpdateRepoPipelineLinkMutationResult = Apollo.MutationResult<UpdateRepoPipelineLinkMutation>;
export type UpdateRepoPipelineLinkMutationOptions = Apollo.BaseMutationOptions<UpdateRepoPipelineLinkMutation, UpdateRepoPipelineLinkMutationVariables>;
export const CreateTeamDocument = gql`
    mutation createTeam($input: CreateTeamInput!) {
  createTeam(input: $input) {
    ...TeamCommon
  }
}
    ${TeamCommonFragmentDoc}`;
export type CreateTeamMutationFn = Apollo.MutationFunction<CreateTeamMutation, CreateTeamMutationVariables>;

/**
 * __useCreateTeamMutation__
 *
 * To run a mutation, you first call `useCreateTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTeamMutation, { data, loading, error }] = useCreateTeamMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTeamMutation(baseOptions?: Apollo.MutationHookOptions<CreateTeamMutation, CreateTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTeamMutation, CreateTeamMutationVariables>(CreateTeamDocument, options);
      }
export type CreateTeamMutationHookResult = ReturnType<typeof useCreateTeamMutation>;
export type CreateTeamMutationResult = Apollo.MutationResult<CreateTeamMutation>;
export type CreateTeamMutationOptions = Apollo.BaseMutationOptions<CreateTeamMutation, CreateTeamMutationVariables>;
export const UpdateTeamDocument = gql`
    mutation updateTeam($input: UpdateTeamInput!) {
  updateTeam(input: $input) {
    ...TeamCommon
  }
}
    ${TeamCommonFragmentDoc}`;
export type UpdateTeamMutationFn = Apollo.MutationFunction<UpdateTeamMutation, UpdateTeamMutationVariables>;

/**
 * __useUpdateTeamMutation__
 *
 * To run a mutation, you first call `useUpdateTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTeamMutation, { data, loading, error }] = useUpdateTeamMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTeamMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTeamMutation, UpdateTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTeamMutation, UpdateTeamMutationVariables>(UpdateTeamDocument, options);
      }
export type UpdateTeamMutationHookResult = ReturnType<typeof useUpdateTeamMutation>;
export type UpdateTeamMutationResult = Apollo.MutationResult<UpdateTeamMutation>;
export type UpdateTeamMutationOptions = Apollo.BaseMutationOptions<UpdateTeamMutation, UpdateTeamMutationVariables>;
export const AddTeamMemberDocument = gql`
    mutation addTeamMember($input: AddTeamMemberInput!) {
  addTeamMember(input: $input) {
    ...TeamCommon
    members {
      id
      user {
        id
        name
      }
      role
    }
    user {
      id
      billingOverview {
        ...BillingOverviewDetail
      }
    }
  }
}
    ${TeamCommonFragmentDoc}
${BillingOverviewDetailFragmentDoc}`;
export type AddTeamMemberMutationFn = Apollo.MutationFunction<AddTeamMemberMutation, AddTeamMemberMutationVariables>;

/**
 * __useAddTeamMemberMutation__
 *
 * To run a mutation, you first call `useAddTeamMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTeamMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTeamMemberMutation, { data, loading, error }] = useAddTeamMemberMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddTeamMemberMutation(baseOptions?: Apollo.MutationHookOptions<AddTeamMemberMutation, AddTeamMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddTeamMemberMutation, AddTeamMemberMutationVariables>(AddTeamMemberDocument, options);
      }
export type AddTeamMemberMutationHookResult = ReturnType<typeof useAddTeamMemberMutation>;
export type AddTeamMemberMutationResult = Apollo.MutationResult<AddTeamMemberMutation>;
export type AddTeamMemberMutationOptions = Apollo.BaseMutationOptions<AddTeamMemberMutation, AddTeamMemberMutationVariables>;
export const RemoveTeamMemberDocument = gql`
    mutation removeTeamMember($input: RemoveTeamMemberInput!) {
  removeTeamMember(input: $input) {
    ...TeamCommon
  }
}
    ${TeamCommonFragmentDoc}`;
export type RemoveTeamMemberMutationFn = Apollo.MutationFunction<RemoveTeamMemberMutation, RemoveTeamMemberMutationVariables>;

/**
 * __useRemoveTeamMemberMutation__
 *
 * To run a mutation, you first call `useRemoveTeamMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTeamMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeTeamMemberMutation, { data, loading, error }] = useRemoveTeamMemberMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveTeamMemberMutation(baseOptions?: Apollo.MutationHookOptions<RemoveTeamMemberMutation, RemoveTeamMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveTeamMemberMutation, RemoveTeamMemberMutationVariables>(RemoveTeamMemberDocument, options);
      }
export type RemoveTeamMemberMutationHookResult = ReturnType<typeof useRemoveTeamMemberMutation>;
export type RemoveTeamMemberMutationResult = Apollo.MutationResult<RemoveTeamMemberMutation>;
export type RemoveTeamMemberMutationOptions = Apollo.BaseMutationOptions<RemoveTeamMemberMutation, RemoveTeamMemberMutationVariables>;
export const DeleteTeamDocument = gql`
    mutation deleteTeam($id: UUID!) {
  deleteTeam(id: $id)
}
    `;
export type DeleteTeamMutationFn = Apollo.MutationFunction<DeleteTeamMutation, DeleteTeamMutationVariables>;

/**
 * __useDeleteTeamMutation__
 *
 * To run a mutation, you first call `useDeleteTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTeamMutation, { data, loading, error }] = useDeleteTeamMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTeamMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTeamMutation, DeleteTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTeamMutation, DeleteTeamMutationVariables>(DeleteTeamDocument, options);
      }
export type DeleteTeamMutationHookResult = ReturnType<typeof useDeleteTeamMutation>;
export type DeleteTeamMutationResult = Apollo.MutationResult<DeleteTeamMutation>;
export type DeleteTeamMutationOptions = Apollo.BaseMutationOptions<DeleteTeamMutation, DeleteTeamMutationVariables>;
export const TransferProjectDocument = gql`
    mutation transferProject($input: TransferProjectInput!) {
  transferProject(input: $input) {
    id
    name
  }
}
    `;
export type TransferProjectMutationFn = Apollo.MutationFunction<TransferProjectMutation, TransferProjectMutationVariables>;

/**
 * __useTransferProjectMutation__
 *
 * To run a mutation, you first call `useTransferProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransferProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transferProjectMutation, { data, loading, error }] = useTransferProjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTransferProjectMutation(baseOptions?: Apollo.MutationHookOptions<TransferProjectMutation, TransferProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TransferProjectMutation, TransferProjectMutationVariables>(TransferProjectDocument, options);
      }
export type TransferProjectMutationHookResult = ReturnType<typeof useTransferProjectMutation>;
export type TransferProjectMutationResult = Apollo.MutationResult<TransferProjectMutation>;
export type TransferProjectMutationOptions = Apollo.BaseMutationOptions<TransferProjectMutation, TransferProjectMutationVariables>;
export const InviteTeamMemberDocument = gql`
    mutation inviteTeamMember($input: InviteTeamMemberInput!) {
  inviteTeamMember(input: $input) {
    id
    ...TeamInvite
  }
}
    ${TeamInviteFragmentDoc}`;
export type InviteTeamMemberMutationFn = Apollo.MutationFunction<InviteTeamMemberMutation, InviteTeamMemberMutationVariables>;

/**
 * __useInviteTeamMemberMutation__
 *
 * To run a mutation, you first call `useInviteTeamMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteTeamMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteTeamMemberMutation, { data, loading, error }] = useInviteTeamMemberMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInviteTeamMemberMutation(baseOptions?: Apollo.MutationHookOptions<InviteTeamMemberMutation, InviteTeamMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteTeamMemberMutation, InviteTeamMemberMutationVariables>(InviteTeamMemberDocument, options);
      }
export type InviteTeamMemberMutationHookResult = ReturnType<typeof useInviteTeamMemberMutation>;
export type InviteTeamMemberMutationResult = Apollo.MutationResult<InviteTeamMemberMutation>;
export type InviteTeamMemberMutationOptions = Apollo.BaseMutationOptions<InviteTeamMemberMutation, InviteTeamMemberMutationVariables>;
export const DeleteTeamMemberInvitationDocument = gql`
    mutation deleteTeamMemberInvitation($id: UUID!) {
  deleteTeamMemberInvitation(id: $id)
}
    `;
export type DeleteTeamMemberInvitationMutationFn = Apollo.MutationFunction<DeleteTeamMemberInvitationMutation, DeleteTeamMemberInvitationMutationVariables>;

/**
 * __useDeleteTeamMemberInvitationMutation__
 *
 * To run a mutation, you first call `useDeleteTeamMemberInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTeamMemberInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTeamMemberInvitationMutation, { data, loading, error }] = useDeleteTeamMemberInvitationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTeamMemberInvitationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTeamMemberInvitationMutation, DeleteTeamMemberInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTeamMemberInvitationMutation, DeleteTeamMemberInvitationMutationVariables>(DeleteTeamMemberInvitationDocument, options);
      }
export type DeleteTeamMemberInvitationMutationHookResult = ReturnType<typeof useDeleteTeamMemberInvitationMutation>;
export type DeleteTeamMemberInvitationMutationResult = Apollo.MutationResult<DeleteTeamMemberInvitationMutation>;
export type DeleteTeamMemberInvitationMutationOptions = Apollo.BaseMutationOptions<DeleteTeamMemberInvitationMutation, DeleteTeamMemberInvitationMutationVariables>;
export const ResendTeamMemberInvitationDocument = gql`
    mutation resendTeamMemberInvitation($id: UUID!) {
  resendTeamMemberInvitation(id: $id)
}
    `;
export type ResendTeamMemberInvitationMutationFn = Apollo.MutationFunction<ResendTeamMemberInvitationMutation, ResendTeamMemberInvitationMutationVariables>;

/**
 * __useResendTeamMemberInvitationMutation__
 *
 * To run a mutation, you first call `useResendTeamMemberInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendTeamMemberInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendTeamMemberInvitationMutation, { data, loading, error }] = useResendTeamMemberInvitationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useResendTeamMemberInvitationMutation(baseOptions?: Apollo.MutationHookOptions<ResendTeamMemberInvitationMutation, ResendTeamMemberInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendTeamMemberInvitationMutation, ResendTeamMemberInvitationMutationVariables>(ResendTeamMemberInvitationDocument, options);
      }
export type ResendTeamMemberInvitationMutationHookResult = ReturnType<typeof useResendTeamMemberInvitationMutation>;
export type ResendTeamMemberInvitationMutationResult = Apollo.MutationResult<ResendTeamMemberInvitationMutation>;
export type ResendTeamMemberInvitationMutationOptions = Apollo.BaseMutationOptions<ResendTeamMemberInvitationMutation, ResendTeamMemberInvitationMutationVariables>;
export const AcceptTeamMemberInvitationDocument = gql`
    mutation acceptTeamMemberInvitation($token: String!) {
  acceptTeamMemberInvitation(token: $token) {
    id
    ...TeamCommon
  }
}
    ${TeamCommonFragmentDoc}`;
export type AcceptTeamMemberInvitationMutationFn = Apollo.MutationFunction<AcceptTeamMemberInvitationMutation, AcceptTeamMemberInvitationMutationVariables>;

/**
 * __useAcceptTeamMemberInvitationMutation__
 *
 * To run a mutation, you first call `useAcceptTeamMemberInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptTeamMemberInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptTeamMemberInvitationMutation, { data, loading, error }] = useAcceptTeamMemberInvitationMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useAcceptTeamMemberInvitationMutation(baseOptions?: Apollo.MutationHookOptions<AcceptTeamMemberInvitationMutation, AcceptTeamMemberInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptTeamMemberInvitationMutation, AcceptTeamMemberInvitationMutationVariables>(AcceptTeamMemberInvitationDocument, options);
      }
export type AcceptTeamMemberInvitationMutationHookResult = ReturnType<typeof useAcceptTeamMemberInvitationMutation>;
export type AcceptTeamMemberInvitationMutationResult = Apollo.MutationResult<AcceptTeamMemberInvitationMutation>;
export type AcceptTeamMemberInvitationMutationOptions = Apollo.BaseMutationOptions<AcceptTeamMemberInvitationMutation, AcceptTeamMemberInvitationMutationVariables>;
export const UpdateTeamMemberRoleDocument = gql`
    mutation UpdateTeamMemberRole($input: UpdateTeamMemberRoleInput!) {
  updateTeamMemberRole(input: $input) {
    role
    id
  }
}
    `;
export type UpdateTeamMemberRoleMutationFn = Apollo.MutationFunction<UpdateTeamMemberRoleMutation, UpdateTeamMemberRoleMutationVariables>;

/**
 * __useUpdateTeamMemberRoleMutation__
 *
 * To run a mutation, you first call `useUpdateTeamMemberRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTeamMemberRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTeamMemberRoleMutation, { data, loading, error }] = useUpdateTeamMemberRoleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTeamMemberRoleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTeamMemberRoleMutation, UpdateTeamMemberRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTeamMemberRoleMutation, UpdateTeamMemberRoleMutationVariables>(UpdateTeamMemberRoleDocument, options);
      }
export type UpdateTeamMemberRoleMutationHookResult = ReturnType<typeof useUpdateTeamMemberRoleMutation>;
export type UpdateTeamMemberRoleMutationResult = Apollo.MutationResult<UpdateTeamMemberRoleMutation>;
export type UpdateTeamMemberRoleMutationOptions = Apollo.BaseMutationOptions<UpdateTeamMemberRoleMutation, UpdateTeamMemberRoleMutationVariables>;
export const ConnectUserToIamDocument = gql`
    mutation ConnectUserToIam($input: ConnectUserToIamInput!) {
  connectUserToIam(input: $input)
}
    `;
export type ConnectUserToIamMutationFn = Apollo.MutationFunction<ConnectUserToIamMutation, ConnectUserToIamMutationVariables>;

/**
 * __useConnectUserToIamMutation__
 *
 * To run a mutation, you first call `useConnectUserToIamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConnectUserToIamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [connectUserToIamMutation, { data, loading, error }] = useConnectUserToIamMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConnectUserToIamMutation(baseOptions?: Apollo.MutationHookOptions<ConnectUserToIamMutation, ConnectUserToIamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConnectUserToIamMutation, ConnectUserToIamMutationVariables>(ConnectUserToIamDocument, options);
      }
export type ConnectUserToIamMutationHookResult = ReturnType<typeof useConnectUserToIamMutation>;
export type ConnectUserToIamMutationResult = Apollo.MutationResult<ConnectUserToIamMutation>;
export type ConnectUserToIamMutationOptions = Apollo.BaseMutationOptions<ConnectUserToIamMutation, ConnectUserToIamMutationVariables>;
export const DisconnectUserFromIamDocument = gql`
    mutation DisconnectUserFromIam($id: UUID!) {
  disconnectUserFromIam(id: $id)
}
    `;
export type DisconnectUserFromIamMutationFn = Apollo.MutationFunction<DisconnectUserFromIamMutation, DisconnectUserFromIamMutationVariables>;

/**
 * __useDisconnectUserFromIamMutation__
 *
 * To run a mutation, you first call `useDisconnectUserFromIamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisconnectUserFromIamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disconnectUserFromIamMutation, { data, loading, error }] = useDisconnectUserFromIamMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDisconnectUserFromIamMutation(baseOptions?: Apollo.MutationHookOptions<DisconnectUserFromIamMutation, DisconnectUserFromIamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisconnectUserFromIamMutation, DisconnectUserFromIamMutationVariables>(DisconnectUserFromIamDocument, options);
      }
export type DisconnectUserFromIamMutationHookResult = ReturnType<typeof useDisconnectUserFromIamMutation>;
export type DisconnectUserFromIamMutationResult = Apollo.MutationResult<DisconnectUserFromIamMutation>;
export type DisconnectUserFromIamMutationOptions = Apollo.BaseMutationOptions<DisconnectUserFromIamMutation, DisconnectUserFromIamMutationVariables>;
export const AttachAwsPolicyToUserDocument = gql`
    mutation AttachAwsPolicyToUser($input: AttachAwsPolicyToUser!) {
  attachAwsPolicyToUser(input: $input)
}
    `;
export type AttachAwsPolicyToUserMutationFn = Apollo.MutationFunction<AttachAwsPolicyToUserMutation, AttachAwsPolicyToUserMutationVariables>;

/**
 * __useAttachAwsPolicyToUserMutation__
 *
 * To run a mutation, you first call `useAttachAwsPolicyToUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAttachAwsPolicyToUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [attachAwsPolicyToUserMutation, { data, loading, error }] = useAttachAwsPolicyToUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAttachAwsPolicyToUserMutation(baseOptions?: Apollo.MutationHookOptions<AttachAwsPolicyToUserMutation, AttachAwsPolicyToUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AttachAwsPolicyToUserMutation, AttachAwsPolicyToUserMutationVariables>(AttachAwsPolicyToUserDocument, options);
      }
export type AttachAwsPolicyToUserMutationHookResult = ReturnType<typeof useAttachAwsPolicyToUserMutation>;
export type AttachAwsPolicyToUserMutationResult = Apollo.MutationResult<AttachAwsPolicyToUserMutation>;
export type AttachAwsPolicyToUserMutationOptions = Apollo.BaseMutationOptions<AttachAwsPolicyToUserMutation, AttachAwsPolicyToUserMutationVariables>;
export const CreateProjectsFromTemplateDocument = gql`
    mutation createProjectsFromTemplate($input: CreateProjectsFromTemplateInput!) {
  createProjectsFromTemplate(input: $input) {
    id
    ...RepoCommon
  }
}
    ${RepoCommonFragmentDoc}`;
export type CreateProjectsFromTemplateMutationFn = Apollo.MutationFunction<CreateProjectsFromTemplateMutation, CreateProjectsFromTemplateMutationVariables>;

/**
 * __useCreateProjectsFromTemplateMutation__
 *
 * To run a mutation, you first call `useCreateProjectsFromTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectsFromTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectsFromTemplateMutation, { data, loading, error }] = useCreateProjectsFromTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProjectsFromTemplateMutation(baseOptions?: Apollo.MutationHookOptions<CreateProjectsFromTemplateMutation, CreateProjectsFromTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProjectsFromTemplateMutation, CreateProjectsFromTemplateMutationVariables>(CreateProjectsFromTemplateDocument, options);
      }
export type CreateProjectsFromTemplateMutationHookResult = ReturnType<typeof useCreateProjectsFromTemplateMutation>;
export type CreateProjectsFromTemplateMutationResult = Apollo.MutationResult<CreateProjectsFromTemplateMutation>;
export type CreateProjectsFromTemplateMutationOptions = Apollo.BaseMutationOptions<CreateProjectsFromTemplateMutation, CreateProjectsFromTemplateMutationVariables>;
export const CreateEphemeralContainerDocument = gql`
    mutation createEphemeralContainer($deploymentId: UUID!, $input: CreateEphemeralContainerInput!) {
  createEphemeralContainer(deploymentId: $deploymentId, input: $input) {
    name
    image
  }
}
    `;
export type CreateEphemeralContainerMutationFn = Apollo.MutationFunction<CreateEphemeralContainerMutation, CreateEphemeralContainerMutationVariables>;

/**
 * __useCreateEphemeralContainerMutation__
 *
 * To run a mutation, you first call `useCreateEphemeralContainerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEphemeralContainerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEphemeralContainerMutation, { data, loading, error }] = useCreateEphemeralContainerMutation({
 *   variables: {
 *      deploymentId: // value for 'deploymentId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEphemeralContainerMutation(baseOptions?: Apollo.MutationHookOptions<CreateEphemeralContainerMutation, CreateEphemeralContainerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEphemeralContainerMutation, CreateEphemeralContainerMutationVariables>(CreateEphemeralContainerDocument, options);
      }
export type CreateEphemeralContainerMutationHookResult = ReturnType<typeof useCreateEphemeralContainerMutation>;
export type CreateEphemeralContainerMutationResult = Apollo.MutationResult<CreateEphemeralContainerMutation>;
export type CreateEphemeralContainerMutationOptions = Apollo.BaseMutationOptions<CreateEphemeralContainerMutation, CreateEphemeralContainerMutationVariables>;
export const UpdateProjectSettingsDocument = gql`
    mutation updateProjectSettings($input: UpdateProjectInput!) {
  updateProject(input: $input) {
    id
    ...RepoDetail
  }
}
    ${RepoDetailFragmentDoc}`;
export type UpdateProjectSettingsMutationFn = Apollo.MutationFunction<UpdateProjectSettingsMutation, UpdateProjectSettingsMutationVariables>;

/**
 * __useUpdateProjectSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateProjectSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectSettingsMutation, { data, loading, error }] = useUpdateProjectSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProjectSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProjectSettingsMutation, UpdateProjectSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProjectSettingsMutation, UpdateProjectSettingsMutationVariables>(UpdateProjectSettingsDocument, options);
      }
export type UpdateProjectSettingsMutationHookResult = ReturnType<typeof useUpdateProjectSettingsMutation>;
export type UpdateProjectSettingsMutationResult = Apollo.MutationResult<UpdateProjectSettingsMutation>;
export type UpdateProjectSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateProjectSettingsMutation, UpdateProjectSettingsMutationVariables>;
export const UpdateProjectDangerSettingsDocument = gql`
    mutation updateProjectDangerSettings($input: UpdateProjectDangerInput!) {
  updateProjectDanger(input: $input) {
    id
    ...RepoDetail
  }
}
    ${RepoDetailFragmentDoc}`;
export type UpdateProjectDangerSettingsMutationFn = Apollo.MutationFunction<UpdateProjectDangerSettingsMutation, UpdateProjectDangerSettingsMutationVariables>;

/**
 * __useUpdateProjectDangerSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateProjectDangerSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectDangerSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectDangerSettingsMutation, { data, loading, error }] = useUpdateProjectDangerSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProjectDangerSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProjectDangerSettingsMutation, UpdateProjectDangerSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProjectDangerSettingsMutation, UpdateProjectDangerSettingsMutationVariables>(UpdateProjectDangerSettingsDocument, options);
      }
export type UpdateProjectDangerSettingsMutationHookResult = ReturnType<typeof useUpdateProjectDangerSettingsMutation>;
export type UpdateProjectDangerSettingsMutationResult = Apollo.MutationResult<UpdateProjectDangerSettingsMutation>;
export type UpdateProjectDangerSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateProjectDangerSettingsMutation, UpdateProjectDangerSettingsMutationVariables>;
export const UpdateResourceAlphaDocument = gql`
    mutation updateResourceAlpha($id: UUID!, $input: UpdateResourceAlphaInput!) {
  updateResourceAlpha(repoID: $id, input: $input) {
    id
  }
}
    `;
export type UpdateResourceAlphaMutationFn = Apollo.MutationFunction<UpdateResourceAlphaMutation, UpdateResourceAlphaMutationVariables>;

/**
 * __useUpdateResourceAlphaMutation__
 *
 * To run a mutation, you first call `useUpdateResourceAlphaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateResourceAlphaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateResourceAlphaMutation, { data, loading, error }] = useUpdateResourceAlphaMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateResourceAlphaMutation(baseOptions?: Apollo.MutationHookOptions<UpdateResourceAlphaMutation, UpdateResourceAlphaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateResourceAlphaMutation, UpdateResourceAlphaMutationVariables>(UpdateResourceAlphaDocument, options);
      }
export type UpdateResourceAlphaMutationHookResult = ReturnType<typeof useUpdateResourceAlphaMutation>;
export type UpdateResourceAlphaMutationResult = Apollo.MutationResult<UpdateResourceAlphaMutation>;
export type UpdateResourceAlphaMutationOptions = Apollo.BaseMutationOptions<UpdateResourceAlphaMutation, UpdateResourceAlphaMutationVariables>;
export const UpdateUserDocument = gql`
    mutation updateUser($input: UpdateUserInput!) {
  updateUser(input: $input) {
    id
    ...UserDetail
  }
}
    ${UserDetailFragmentDoc}`;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const DeleteUserDocument = gql`
    mutation deleteUser {
  deleteUser
}
    `;
export type DeleteUserMutationFn = Apollo.MutationFunction<DeleteUserMutation, DeleteUserMutationVariables>;

/**
 * __useDeleteUserMutation__
 *
 * To run a mutation, you first call `useDeleteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserMutation, { data, loading, error }] = useDeleteUserMutation({
 *   variables: {
 *   },
 * });
 */
export function useDeleteUserMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserMutation, DeleteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserMutation, DeleteUserMutationVariables>(DeleteUserDocument, options);
      }
export type DeleteUserMutationHookResult = ReturnType<typeof useDeleteUserMutation>;
export type DeleteUserMutationResult = Apollo.MutationResult<DeleteUserMutation>;
export type DeleteUserMutationOptions = Apollo.BaseMutationOptions<DeleteUserMutation, DeleteUserMutationVariables>;
export const UserApiKeysDocument = gql`
    query userAPIKeys($id: ID!) {
  user(id: $id) {
    id
    apiKeys {
      id
      token
      name
      description
      createdAt
    }
  }
}
    `;

/**
 * __useUserApiKeysQuery__
 *
 * To run a query within a React component, call `useUserApiKeysQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserApiKeysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserApiKeysQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserApiKeysQuery(baseOptions: Apollo.QueryHookOptions<UserApiKeysQuery, UserApiKeysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserApiKeysQuery, UserApiKeysQueryVariables>(UserApiKeysDocument, options);
      }
export function useUserApiKeysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserApiKeysQuery, UserApiKeysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserApiKeysQuery, UserApiKeysQueryVariables>(UserApiKeysDocument, options);
        }
export type UserApiKeysQueryHookResult = ReturnType<typeof useUserApiKeysQuery>;
export type UserApiKeysLazyQueryHookResult = ReturnType<typeof useUserApiKeysLazyQuery>;
export type UserApiKeysQueryResult = Apollo.QueryResult<UserApiKeysQuery, UserApiKeysQueryVariables>;
export function refetchUserApiKeysQuery(variables: UserApiKeysQueryVariables) {
      return { query: UserApiKeysDocument, variables: variables }
    }
export const UserProductCatalogDocument = gql`
    query userProductCatalog($forUserID: UUID!) {
  productCatalog {
    products(forUserID: $forUserID) {
      ...ProductCatalogSectionDetail
    }
  }
}
    ${ProductCatalogSectionDetailFragmentDoc}`;

/**
 * __useUserProductCatalogQuery__
 *
 * To run a query within a React component, call `useUserProductCatalogQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserProductCatalogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserProductCatalogQuery({
 *   variables: {
 *      forUserID: // value for 'forUserID'
 *   },
 * });
 */
export function useUserProductCatalogQuery(baseOptions: Apollo.QueryHookOptions<UserProductCatalogQuery, UserProductCatalogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserProductCatalogQuery, UserProductCatalogQueryVariables>(UserProductCatalogDocument, options);
      }
export function useUserProductCatalogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserProductCatalogQuery, UserProductCatalogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserProductCatalogQuery, UserProductCatalogQueryVariables>(UserProductCatalogDocument, options);
        }
export type UserProductCatalogQueryHookResult = ReturnType<typeof useUserProductCatalogQuery>;
export type UserProductCatalogLazyQueryHookResult = ReturnType<typeof useUserProductCatalogLazyQuery>;
export type UserProductCatalogQueryResult = Apollo.QueryResult<UserProductCatalogQuery, UserProductCatalogQueryVariables>;
export function refetchUserProductCatalogQuery(variables: UserProductCatalogQueryVariables) {
      return { query: UserProductCatalogDocument, variables: variables }
    }
export const UserBillingOverviewDocument = gql`
    query userBillingOverview($id: ID!) {
  user(id: $id) {
    id
    billingOverview {
      ...BillingOverviewDetail
    }
  }
}
    ${BillingOverviewDetailFragmentDoc}`;

/**
 * __useUserBillingOverviewQuery__
 *
 * To run a query within a React component, call `useUserBillingOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserBillingOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserBillingOverviewQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserBillingOverviewQuery(baseOptions: Apollo.QueryHookOptions<UserBillingOverviewQuery, UserBillingOverviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserBillingOverviewQuery, UserBillingOverviewQueryVariables>(UserBillingOverviewDocument, options);
      }
export function useUserBillingOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserBillingOverviewQuery, UserBillingOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserBillingOverviewQuery, UserBillingOverviewQueryVariables>(UserBillingOverviewDocument, options);
        }
export type UserBillingOverviewQueryHookResult = ReturnType<typeof useUserBillingOverviewQuery>;
export type UserBillingOverviewLazyQueryHookResult = ReturnType<typeof useUserBillingOverviewLazyQuery>;
export type UserBillingOverviewQueryResult = Apollo.QueryResult<UserBillingOverviewQuery, UserBillingOverviewQueryVariables>;
export function refetchUserBillingOverviewQuery(variables: UserBillingOverviewQueryVariables) {
      return { query: UserBillingOverviewDocument, variables: variables }
    }
export const SubscriptionFeatureDocument = gql`
    query subscriptionFeature($id: ID!, $featureKey: FeatureKey!) {
  user(id: $id) {
    id
    billingOverview {
      subscriptionFeatures {
        byKey(featureKey: $featureKey) {
          key
          enabled
        }
      }
    }
  }
}
    `;

/**
 * __useSubscriptionFeatureQuery__
 *
 * To run a query within a React component, call `useSubscriptionFeatureQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionFeatureQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionFeatureQuery({
 *   variables: {
 *      id: // value for 'id'
 *      featureKey: // value for 'featureKey'
 *   },
 * });
 */
export function useSubscriptionFeatureQuery(baseOptions: Apollo.QueryHookOptions<SubscriptionFeatureQuery, SubscriptionFeatureQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubscriptionFeatureQuery, SubscriptionFeatureQueryVariables>(SubscriptionFeatureDocument, options);
      }
export function useSubscriptionFeatureLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubscriptionFeatureQuery, SubscriptionFeatureQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubscriptionFeatureQuery, SubscriptionFeatureQueryVariables>(SubscriptionFeatureDocument, options);
        }
export type SubscriptionFeatureQueryHookResult = ReturnType<typeof useSubscriptionFeatureQuery>;
export type SubscriptionFeatureLazyQueryHookResult = ReturnType<typeof useSubscriptionFeatureLazyQuery>;
export type SubscriptionFeatureQueryResult = Apollo.QueryResult<SubscriptionFeatureQuery, SubscriptionFeatureQueryVariables>;
export function refetchSubscriptionFeatureQuery(variables: SubscriptionFeatureQueryVariables) {
      return { query: SubscriptionFeatureDocument, variables: variables }
    }
export const PreviewSubscriptionDocument = gql`
    query previewSubscription($forUserID: UUID!, $subscriptionCart: SubscriptionCart!) {
  productCatalog {
    previewSubscription(forUserID: $forUserID, subscriptionCart: $subscriptionCart) {
      paymentMethodName
      products {
        currentProduct {
          ...ProductDetail
        }
        newProduct {
          ...ProductDetail
        }
        newProductStatus
        sectionName
      }
    }
  }
}
    ${ProductDetailFragmentDoc}`;

/**
 * __usePreviewSubscriptionQuery__
 *
 * To run a query within a React component, call `usePreviewSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreviewSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreviewSubscriptionQuery({
 *   variables: {
 *      forUserID: // value for 'forUserID'
 *      subscriptionCart: // value for 'subscriptionCart'
 *   },
 * });
 */
export function usePreviewSubscriptionQuery(baseOptions: Apollo.QueryHookOptions<PreviewSubscriptionQuery, PreviewSubscriptionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PreviewSubscriptionQuery, PreviewSubscriptionQueryVariables>(PreviewSubscriptionDocument, options);
      }
export function usePreviewSubscriptionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PreviewSubscriptionQuery, PreviewSubscriptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PreviewSubscriptionQuery, PreviewSubscriptionQueryVariables>(PreviewSubscriptionDocument, options);
        }
export type PreviewSubscriptionQueryHookResult = ReturnType<typeof usePreviewSubscriptionQuery>;
export type PreviewSubscriptionLazyQueryHookResult = ReturnType<typeof usePreviewSubscriptionLazyQuery>;
export type PreviewSubscriptionQueryResult = Apollo.QueryResult<PreviewSubscriptionQuery, PreviewSubscriptionQueryVariables>;
export function refetchPreviewSubscriptionQuery(variables: PreviewSubscriptionQueryVariables) {
      return { query: PreviewSubscriptionDocument, variables: variables }
    }
export const BlueprintsDocument = gql`
    query blueprints($userId: ID!, $permissionsUserId: UUID!, $pageInput: PageInput!) {
  currentUser {
    id
    permissions {
      user(userID: $permissionsUserId) {
        mutations
      }
    }
  }
  user(id: $userId) {
    id
    blueprints(page: $pageInput) {
      totalCount
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      nodes {
        ...BlueprintList
      }
    }
  }
}
    ${BlueprintListFragmentDoc}`;

/**
 * __useBlueprintsQuery__
 *
 * To run a query within a React component, call `useBlueprintsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBlueprintsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBlueprintsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      permissionsUserId: // value for 'permissionsUserId'
 *      pageInput: // value for 'pageInput'
 *   },
 * });
 */
export function useBlueprintsQuery(baseOptions: Apollo.QueryHookOptions<BlueprintsQuery, BlueprintsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BlueprintsQuery, BlueprintsQueryVariables>(BlueprintsDocument, options);
      }
export function useBlueprintsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BlueprintsQuery, BlueprintsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BlueprintsQuery, BlueprintsQueryVariables>(BlueprintsDocument, options);
        }
export type BlueprintsQueryHookResult = ReturnType<typeof useBlueprintsQuery>;
export type BlueprintsLazyQueryHookResult = ReturnType<typeof useBlueprintsLazyQuery>;
export type BlueprintsQueryResult = Apollo.QueryResult<BlueprintsQuery, BlueprintsQueryVariables>;
export function refetchBlueprintsQuery(variables: BlueprintsQueryVariables) {
      return { query: BlueprintsDocument, variables: variables }
    }
export const LambdaCloudRunBlueprintsDocument = gql`
    query lambdaCloudRunBlueprints($owner: Login!, $lambdaBlueprintSlug: String!, $cloudRunBlueprintSlug: String!) {
  blueprintsMarketplace {
    lambdaBlueprint: blueprint(owner: $owner, slug: $lambdaBlueprintSlug) {
      ...BlueprintList
    }
    cloudRunBlueprint: blueprint(owner: $owner, slug: $cloudRunBlueprintSlug) {
      ...BlueprintList
    }
  }
}
    ${BlueprintListFragmentDoc}`;

/**
 * __useLambdaCloudRunBlueprintsQuery__
 *
 * To run a query within a React component, call `useLambdaCloudRunBlueprintsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLambdaCloudRunBlueprintsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLambdaCloudRunBlueprintsQuery({
 *   variables: {
 *      owner: // value for 'owner'
 *      lambdaBlueprintSlug: // value for 'lambdaBlueprintSlug'
 *      cloudRunBlueprintSlug: // value for 'cloudRunBlueprintSlug'
 *   },
 * });
 */
export function useLambdaCloudRunBlueprintsQuery(baseOptions: Apollo.QueryHookOptions<LambdaCloudRunBlueprintsQuery, LambdaCloudRunBlueprintsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LambdaCloudRunBlueprintsQuery, LambdaCloudRunBlueprintsQueryVariables>(LambdaCloudRunBlueprintsDocument, options);
      }
export function useLambdaCloudRunBlueprintsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LambdaCloudRunBlueprintsQuery, LambdaCloudRunBlueprintsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LambdaCloudRunBlueprintsQuery, LambdaCloudRunBlueprintsQueryVariables>(LambdaCloudRunBlueprintsDocument, options);
        }
export type LambdaCloudRunBlueprintsQueryHookResult = ReturnType<typeof useLambdaCloudRunBlueprintsQuery>;
export type LambdaCloudRunBlueprintsLazyQueryHookResult = ReturnType<typeof useLambdaCloudRunBlueprintsLazyQuery>;
export type LambdaCloudRunBlueprintsQueryResult = Apollo.QueryResult<LambdaCloudRunBlueprintsQuery, LambdaCloudRunBlueprintsQueryVariables>;
export function refetchLambdaCloudRunBlueprintsQuery(variables: LambdaCloudRunBlueprintsQueryVariables) {
      return { query: LambdaCloudRunBlueprintsDocument, variables: variables }
    }
export const MarketplaceBlueprintsDocument = gql`
    query marketplaceBlueprints($pageInput: PageInput!) {
  blueprintsMarketplace {
    blueprints(page: $pageInput) {
      nodes {
        ...BlueprintList
      }
    }
  }
}
    ${BlueprintListFragmentDoc}`;

/**
 * __useMarketplaceBlueprintsQuery__
 *
 * To run a query within a React component, call `useMarketplaceBlueprintsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketplaceBlueprintsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketplaceBlueprintsQuery({
 *   variables: {
 *      pageInput: // value for 'pageInput'
 *   },
 * });
 */
export function useMarketplaceBlueprintsQuery(baseOptions: Apollo.QueryHookOptions<MarketplaceBlueprintsQuery, MarketplaceBlueprintsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MarketplaceBlueprintsQuery, MarketplaceBlueprintsQueryVariables>(MarketplaceBlueprintsDocument, options);
      }
export function useMarketplaceBlueprintsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketplaceBlueprintsQuery, MarketplaceBlueprintsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MarketplaceBlueprintsQuery, MarketplaceBlueprintsQueryVariables>(MarketplaceBlueprintsDocument, options);
        }
export type MarketplaceBlueprintsQueryHookResult = ReturnType<typeof useMarketplaceBlueprintsQuery>;
export type MarketplaceBlueprintsLazyQueryHookResult = ReturnType<typeof useMarketplaceBlueprintsLazyQuery>;
export type MarketplaceBlueprintsQueryResult = Apollo.QueryResult<MarketplaceBlueprintsQuery, MarketplaceBlueprintsQueryVariables>;
export function refetchMarketplaceBlueprintsQuery(variables: MarketplaceBlueprintsQueryVariables) {
      return { query: MarketplaceBlueprintsDocument, variables: variables }
    }
export const MarketplaceBlueprintMetadataListDocument = gql`
    query marketplaceBlueprintMetadataList($filterInput: FilterInput!) {
  blueprintsMarketplace {
    blueprintMetadataList(filter: $filterInput) {
      totalCount
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      nodes {
        ...BlueprintMetadataList
      }
    }
  }
}
    ${BlueprintMetadataListFragmentDoc}`;

/**
 * __useMarketplaceBlueprintMetadataListQuery__
 *
 * To run a query within a React component, call `useMarketplaceBlueprintMetadataListQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketplaceBlueprintMetadataListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketplaceBlueprintMetadataListQuery({
 *   variables: {
 *      filterInput: // value for 'filterInput'
 *   },
 * });
 */
export function useMarketplaceBlueprintMetadataListQuery(baseOptions: Apollo.QueryHookOptions<MarketplaceBlueprintMetadataListQuery, MarketplaceBlueprintMetadataListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MarketplaceBlueprintMetadataListQuery, MarketplaceBlueprintMetadataListQueryVariables>(MarketplaceBlueprintMetadataListDocument, options);
      }
export function useMarketplaceBlueprintMetadataListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketplaceBlueprintMetadataListQuery, MarketplaceBlueprintMetadataListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MarketplaceBlueprintMetadataListQuery, MarketplaceBlueprintMetadataListQueryVariables>(MarketplaceBlueprintMetadataListDocument, options);
        }
export type MarketplaceBlueprintMetadataListQueryHookResult = ReturnType<typeof useMarketplaceBlueprintMetadataListQuery>;
export type MarketplaceBlueprintMetadataListLazyQueryHookResult = ReturnType<typeof useMarketplaceBlueprintMetadataListLazyQuery>;
export type MarketplaceBlueprintMetadataListQueryResult = Apollo.QueryResult<MarketplaceBlueprintMetadataListQuery, MarketplaceBlueprintMetadataListQueryVariables>;
export function refetchMarketplaceBlueprintMetadataListQuery(variables: MarketplaceBlueprintMetadataListQueryVariables) {
      return { query: MarketplaceBlueprintMetadataListDocument, variables: variables }
    }
export const MarketplaceBlueprintDocument = gql`
    query marketplaceBlueprint($owner: Login!, $slug: String!) {
  blueprintsMarketplace {
    blueprint(owner: $owner, slug: $slug) {
      ...BlueprintList
    }
  }
}
    ${BlueprintListFragmentDoc}`;

/**
 * __useMarketplaceBlueprintQuery__
 *
 * To run a query within a React component, call `useMarketplaceBlueprintQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketplaceBlueprintQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketplaceBlueprintQuery({
 *   variables: {
 *      owner: // value for 'owner'
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useMarketplaceBlueprintQuery(baseOptions: Apollo.QueryHookOptions<MarketplaceBlueprintQuery, MarketplaceBlueprintQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MarketplaceBlueprintQuery, MarketplaceBlueprintQueryVariables>(MarketplaceBlueprintDocument, options);
      }
export function useMarketplaceBlueprintLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketplaceBlueprintQuery, MarketplaceBlueprintQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MarketplaceBlueprintQuery, MarketplaceBlueprintQueryVariables>(MarketplaceBlueprintDocument, options);
        }
export type MarketplaceBlueprintQueryHookResult = ReturnType<typeof useMarketplaceBlueprintQuery>;
export type MarketplaceBlueprintLazyQueryHookResult = ReturnType<typeof useMarketplaceBlueprintLazyQuery>;
export type MarketplaceBlueprintQueryResult = Apollo.QueryResult<MarketplaceBlueprintQuery, MarketplaceBlueprintQueryVariables>;
export function refetchMarketplaceBlueprintQuery(variables: MarketplaceBlueprintQueryVariables) {
      return { query: MarketplaceBlueprintDocument, variables: variables }
    }
export const MarketplaceBlueprintMetadataDocument = gql`
    query marketplaceBlueprintMetadata($owner: Login, $slug: String!, $version: String) {
  blueprintsMarketplace {
    blueprintMetadata(owner: $owner, slug: $slug, version: $version) {
      ...BlueprintMetadataList
    }
  }
}
    ${BlueprintMetadataListFragmentDoc}`;

/**
 * __useMarketplaceBlueprintMetadataQuery__
 *
 * To run a query within a React component, call `useMarketplaceBlueprintMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketplaceBlueprintMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketplaceBlueprintMetadataQuery({
 *   variables: {
 *      owner: // value for 'owner'
 *      slug: // value for 'slug'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useMarketplaceBlueprintMetadataQuery(baseOptions: Apollo.QueryHookOptions<MarketplaceBlueprintMetadataQuery, MarketplaceBlueprintMetadataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MarketplaceBlueprintMetadataQuery, MarketplaceBlueprintMetadataQueryVariables>(MarketplaceBlueprintMetadataDocument, options);
      }
export function useMarketplaceBlueprintMetadataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketplaceBlueprintMetadataQuery, MarketplaceBlueprintMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MarketplaceBlueprintMetadataQuery, MarketplaceBlueprintMetadataQueryVariables>(MarketplaceBlueprintMetadataDocument, options);
        }
export type MarketplaceBlueprintMetadataQueryHookResult = ReturnType<typeof useMarketplaceBlueprintMetadataQuery>;
export type MarketplaceBlueprintMetadataLazyQueryHookResult = ReturnType<typeof useMarketplaceBlueprintMetadataLazyQuery>;
export type MarketplaceBlueprintMetadataQueryResult = Apollo.QueryResult<MarketplaceBlueprintMetadataQuery, MarketplaceBlueprintMetadataQueryVariables>;
export function refetchMarketplaceBlueprintMetadataQuery(variables: MarketplaceBlueprintMetadataQueryVariables) {
      return { query: MarketplaceBlueprintMetadataDocument, variables: variables }
    }
export const BlueprintDocument = gql`
    query blueprint($userId: ID!, $permissionsUserId: UUID!, $blueprintId: UUID!) {
  currentUser {
    id
    permissions {
      user(userID: $permissionsUserId) {
        mutations
      }
    }
  }
  user(id: $userId) {
    id
    login
    blueprint(id: $blueprintId) {
      ...BlueprintList
    }
  }
}
    ${BlueprintListFragmentDoc}`;

/**
 * __useBlueprintQuery__
 *
 * To run a query within a React component, call `useBlueprintQuery` and pass it any options that fit your needs.
 * When your component renders, `useBlueprintQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBlueprintQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      permissionsUserId: // value for 'permissionsUserId'
 *      blueprintId: // value for 'blueprintId'
 *   },
 * });
 */
export function useBlueprintQuery(baseOptions: Apollo.QueryHookOptions<BlueprintQuery, BlueprintQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BlueprintQuery, BlueprintQueryVariables>(BlueprintDocument, options);
      }
export function useBlueprintLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BlueprintQuery, BlueprintQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BlueprintQuery, BlueprintQueryVariables>(BlueprintDocument, options);
        }
export type BlueprintQueryHookResult = ReturnType<typeof useBlueprintQuery>;
export type BlueprintLazyQueryHookResult = ReturnType<typeof useBlueprintLazyQuery>;
export type BlueprintQueryResult = Apollo.QueryResult<BlueprintQuery, BlueprintQueryVariables>;
export function refetchBlueprintQuery(variables: BlueprintQueryVariables) {
      return { query: BlueprintDocument, variables: variables }
    }
export const BlueprintNameDocument = gql`
    query blueprintName($userId: ID!, $blueprintId: UUID!) {
  user(id: $userId) {
    id
    blueprint(id: $blueprintId) {
      id
      displayName
    }
  }
}
    `;

/**
 * __useBlueprintNameQuery__
 *
 * To run a query within a React component, call `useBlueprintNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useBlueprintNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBlueprintNameQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      blueprintId: // value for 'blueprintId'
 *   },
 * });
 */
export function useBlueprintNameQuery(baseOptions: Apollo.QueryHookOptions<BlueprintNameQuery, BlueprintNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BlueprintNameQuery, BlueprintNameQueryVariables>(BlueprintNameDocument, options);
      }
export function useBlueprintNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BlueprintNameQuery, BlueprintNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BlueprintNameQuery, BlueprintNameQueryVariables>(BlueprintNameDocument, options);
        }
export type BlueprintNameQueryHookResult = ReturnType<typeof useBlueprintNameQuery>;
export type BlueprintNameLazyQueryHookResult = ReturnType<typeof useBlueprintNameLazyQuery>;
export type BlueprintNameQueryResult = Apollo.QueryResult<BlueprintNameQuery, BlueprintNameQueryVariables>;
export function refetchBlueprintNameQuery(variables: BlueprintNameQueryVariables) {
      return { query: BlueprintNameDocument, variables: variables }
    }
export const BlueprintWithProjectsDocument = gql`
    query blueprintWithProjects($userId: ID!, $permissionsUserId: UUID!, $blueprintId: UUID!) {
  currentUser {
    id
    permissions {
      user(userID: $permissionsUserId) {
        mutations
      }
    }
  }
  user(id: $userId) {
    id
    login
    blueprint(id: $blueprintId) {
      ...BlueprintList
    }
    projectV3Adapters(
      filter: {filter: {criterion: {resourceAdapterFilter: {deployableIds: {value: [$blueprintId]}}}}}
    ) {
      totalCount
      nodes {
        ...BridgeProjectV3List
      }
    }
  }
}
    ${BlueprintListFragmentDoc}
${BridgeProjectV3ListFragmentDoc}`;

/**
 * __useBlueprintWithProjectsQuery__
 *
 * To run a query within a React component, call `useBlueprintWithProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBlueprintWithProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBlueprintWithProjectsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      permissionsUserId: // value for 'permissionsUserId'
 *      blueprintId: // value for 'blueprintId'
 *   },
 * });
 */
export function useBlueprintWithProjectsQuery(baseOptions: Apollo.QueryHookOptions<BlueprintWithProjectsQuery, BlueprintWithProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BlueprintWithProjectsQuery, BlueprintWithProjectsQueryVariables>(BlueprintWithProjectsDocument, options);
      }
export function useBlueprintWithProjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BlueprintWithProjectsQuery, BlueprintWithProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BlueprintWithProjectsQuery, BlueprintWithProjectsQueryVariables>(BlueprintWithProjectsDocument, options);
        }
export type BlueprintWithProjectsQueryHookResult = ReturnType<typeof useBlueprintWithProjectsQuery>;
export type BlueprintWithProjectsLazyQueryHookResult = ReturnType<typeof useBlueprintWithProjectsLazyQuery>;
export type BlueprintWithProjectsQueryResult = Apollo.QueryResult<BlueprintWithProjectsQuery, BlueprintWithProjectsQueryVariables>;
export function refetchBlueprintWithProjectsQuery(variables: BlueprintWithProjectsQueryVariables) {
      return { query: BlueprintWithProjectsDocument, variables: variables }
    }
export const ProjectActiveBranchesCountDocument = gql`
    query projectActiveBranchesCount($id: ID!) {
  currentUser {
    id
    repo(id: $id) {
      id
      branchesV2(input: {active: true}) {
        totalCount
      }
    }
  }
}
    `;

/**
 * __useProjectActiveBranchesCountQuery__
 *
 * To run a query within a React component, call `useProjectActiveBranchesCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectActiveBranchesCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectActiveBranchesCountQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProjectActiveBranchesCountQuery(baseOptions: Apollo.QueryHookOptions<ProjectActiveBranchesCountQuery, ProjectActiveBranchesCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectActiveBranchesCountQuery, ProjectActiveBranchesCountQueryVariables>(ProjectActiveBranchesCountDocument, options);
      }
export function useProjectActiveBranchesCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectActiveBranchesCountQuery, ProjectActiveBranchesCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectActiveBranchesCountQuery, ProjectActiveBranchesCountQueryVariables>(ProjectActiveBranchesCountDocument, options);
        }
export type ProjectActiveBranchesCountQueryHookResult = ReturnType<typeof useProjectActiveBranchesCountQuery>;
export type ProjectActiveBranchesCountLazyQueryHookResult = ReturnType<typeof useProjectActiveBranchesCountLazyQuery>;
export type ProjectActiveBranchesCountQueryResult = Apollo.QueryResult<ProjectActiveBranchesCountQuery, ProjectActiveBranchesCountQueryVariables>;
export function refetchProjectActiveBranchesCountQuery(variables: ProjectActiveBranchesCountQueryVariables) {
      return { query: ProjectActiveBranchesCountDocument, variables: variables }
    }
export const ProjectBranchesDocument = gql`
    query projectBranches($id: ID!, $active: Boolean) {
  currentUser {
    id
    repo(id: $id) {
      id
      productionBranchV2 {
        ...BranchCommon
      }
      branchesV2(page: {first: 0}, input: {active: $active}) {
        nodes {
          ...BranchCommon
        }
      }
    }
  }
}
    ${BranchCommonFragmentDoc}`;

/**
 * __useProjectBranchesQuery__
 *
 * To run a query within a React component, call `useProjectBranchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectBranchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectBranchesQuery({
 *   variables: {
 *      id: // value for 'id'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useProjectBranchesQuery(baseOptions: Apollo.QueryHookOptions<ProjectBranchesQuery, ProjectBranchesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectBranchesQuery, ProjectBranchesQueryVariables>(ProjectBranchesDocument, options);
      }
export function useProjectBranchesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectBranchesQuery, ProjectBranchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectBranchesQuery, ProjectBranchesQueryVariables>(ProjectBranchesDocument, options);
        }
export type ProjectBranchesQueryHookResult = ReturnType<typeof useProjectBranchesQuery>;
export type ProjectBranchesLazyQueryHookResult = ReturnType<typeof useProjectBranchesLazyQuery>;
export type ProjectBranchesQueryResult = Apollo.QueryResult<ProjectBranchesQuery, ProjectBranchesQueryVariables>;
export function refetchProjectBranchesQuery(variables: ProjectBranchesQueryVariables) {
      return { query: ProjectBranchesDocument, variables: variables }
    }
export const UserAwsAccountsDocument = gql`
    query userAWSAccounts($id: ID!) {
  user(id: $id) {
    id
    awsAccounts {
      id
      ...AWSAccountDetail
    }
  }
}
    ${AwsAccountDetailFragmentDoc}`;

/**
 * __useUserAwsAccountsQuery__
 *
 * To run a query within a React component, call `useUserAwsAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserAwsAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserAwsAccountsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserAwsAccountsQuery(baseOptions: Apollo.QueryHookOptions<UserAwsAccountsQuery, UserAwsAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserAwsAccountsQuery, UserAwsAccountsQueryVariables>(UserAwsAccountsDocument, options);
      }
export function useUserAwsAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserAwsAccountsQuery, UserAwsAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserAwsAccountsQuery, UserAwsAccountsQueryVariables>(UserAwsAccountsDocument, options);
        }
export type UserAwsAccountsQueryHookResult = ReturnType<typeof useUserAwsAccountsQuery>;
export type UserAwsAccountsLazyQueryHookResult = ReturnType<typeof useUserAwsAccountsLazyQuery>;
export type UserAwsAccountsQueryResult = Apollo.QueryResult<UserAwsAccountsQuery, UserAwsAccountsQueryVariables>;
export function refetchUserAwsAccountsQuery(variables: UserAwsAccountsQueryVariables) {
      return { query: UserAwsAccountsDocument, variables: variables }
    }
export const UserAwsAccountsWithCqDocument = gql`
    query userAWSAccountsWithCQ($id: ID!) {
  user(id: $id) {
    id
    awsAccounts {
      id
      ...AWSAccountDetail
      cloudQuery {
        id
        state
      }
    }
  }
}
    ${AwsAccountDetailFragmentDoc}`;

/**
 * __useUserAwsAccountsWithCqQuery__
 *
 * To run a query within a React component, call `useUserAwsAccountsWithCqQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserAwsAccountsWithCqQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserAwsAccountsWithCqQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserAwsAccountsWithCqQuery(baseOptions: Apollo.QueryHookOptions<UserAwsAccountsWithCqQuery, UserAwsAccountsWithCqQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserAwsAccountsWithCqQuery, UserAwsAccountsWithCqQueryVariables>(UserAwsAccountsWithCqDocument, options);
      }
export function useUserAwsAccountsWithCqLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserAwsAccountsWithCqQuery, UserAwsAccountsWithCqQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserAwsAccountsWithCqQuery, UserAwsAccountsWithCqQueryVariables>(UserAwsAccountsWithCqDocument, options);
        }
export type UserAwsAccountsWithCqQueryHookResult = ReturnType<typeof useUserAwsAccountsWithCqQuery>;
export type UserAwsAccountsWithCqLazyQueryHookResult = ReturnType<typeof useUserAwsAccountsWithCqLazyQuery>;
export type UserAwsAccountsWithCqQueryResult = Apollo.QueryResult<UserAwsAccountsWithCqQuery, UserAwsAccountsWithCqQueryVariables>;
export function refetchUserAwsAccountsWithCqQuery(variables: UserAwsAccountsWithCqQueryVariables) {
      return { query: UserAwsAccountsWithCqDocument, variables: variables }
    }
export const UserGcpAccountsDocument = gql`
    query userGCPAccounts($id: ID!) {
  user(id: $id) {
    id
    gcpAccounts {
      id
      ...GCPAccountDetail
    }
  }
}
    ${GcpAccountDetailFragmentDoc}`;

/**
 * __useUserGcpAccountsQuery__
 *
 * To run a query within a React component, call `useUserGcpAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserGcpAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserGcpAccountsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserGcpAccountsQuery(baseOptions: Apollo.QueryHookOptions<UserGcpAccountsQuery, UserGcpAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserGcpAccountsQuery, UserGcpAccountsQueryVariables>(UserGcpAccountsDocument, options);
      }
export function useUserGcpAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserGcpAccountsQuery, UserGcpAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserGcpAccountsQuery, UserGcpAccountsQueryVariables>(UserGcpAccountsDocument, options);
        }
export type UserGcpAccountsQueryHookResult = ReturnType<typeof useUserGcpAccountsQuery>;
export type UserGcpAccountsLazyQueryHookResult = ReturnType<typeof useUserGcpAccountsLazyQuery>;
export type UserGcpAccountsQueryResult = Apollo.QueryResult<UserGcpAccountsQuery, UserGcpAccountsQueryVariables>;
export function refetchUserGcpAccountsQuery(variables: UserGcpAccountsQueryVariables) {
      return { query: UserGcpAccountsDocument, variables: variables }
    }
export const UserDoAccountsDocument = gql`
    query userDOAccounts($id: ID!) {
  user(id: $id) {
    id
    doAccounts {
      id
      ...DOAccountDetail
    }
  }
}
    ${DoAccountDetailFragmentDoc}`;

/**
 * __useUserDoAccountsQuery__
 *
 * To run a query within a React component, call `useUserDoAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserDoAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserDoAccountsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserDoAccountsQuery(baseOptions: Apollo.QueryHookOptions<UserDoAccountsQuery, UserDoAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserDoAccountsQuery, UserDoAccountsQueryVariables>(UserDoAccountsDocument, options);
      }
export function useUserDoAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserDoAccountsQuery, UserDoAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserDoAccountsQuery, UserDoAccountsQueryVariables>(UserDoAccountsDocument, options);
        }
export type UserDoAccountsQueryHookResult = ReturnType<typeof useUserDoAccountsQuery>;
export type UserDoAccountsLazyQueryHookResult = ReturnType<typeof useUserDoAccountsLazyQuery>;
export type UserDoAccountsQueryResult = Apollo.QueryResult<UserDoAccountsQuery, UserDoAccountsQueryVariables>;
export function refetchUserDoAccountsQuery(variables: UserDoAccountsQueryVariables) {
      return { query: UserDoAccountsDocument, variables: variables }
    }
export const UserLinodeAccountsDocument = gql`
    query userLinodeAccounts($id: ID!) {
  user(id: $id) {
    id
    linodeAccounts {
      id
      ...LinodeAccountDetail
    }
  }
}
    ${LinodeAccountDetailFragmentDoc}`;

/**
 * __useUserLinodeAccountsQuery__
 *
 * To run a query within a React component, call `useUserLinodeAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserLinodeAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserLinodeAccountsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserLinodeAccountsQuery(baseOptions: Apollo.QueryHookOptions<UserLinodeAccountsQuery, UserLinodeAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserLinodeAccountsQuery, UserLinodeAccountsQueryVariables>(UserLinodeAccountsDocument, options);
      }
export function useUserLinodeAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserLinodeAccountsQuery, UserLinodeAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserLinodeAccountsQuery, UserLinodeAccountsQueryVariables>(UserLinodeAccountsDocument, options);
        }
export type UserLinodeAccountsQueryHookResult = ReturnType<typeof useUserLinodeAccountsQuery>;
export type UserLinodeAccountsLazyQueryHookResult = ReturnType<typeof useUserLinodeAccountsLazyQuery>;
export type UserLinodeAccountsQueryResult = Apollo.QueryResult<UserLinodeAccountsQuery, UserLinodeAccountsQueryVariables>;
export function refetchUserLinodeAccountsQuery(variables: UserLinodeAccountsQueryVariables) {
      return { query: UserLinodeAccountsDocument, variables: variables }
    }
export const UserCoreWeaveAccountsDocument = gql`
    query userCoreWeaveAccounts($id: ID!) {
  user(id: $id) {
    id
    coreweaveAccounts {
      id
      ...CWAccountDetail
    }
  }
}
    ${CwAccountDetailFragmentDoc}`;

/**
 * __useUserCoreWeaveAccountsQuery__
 *
 * To run a query within a React component, call `useUserCoreWeaveAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserCoreWeaveAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserCoreWeaveAccountsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserCoreWeaveAccountsQuery(baseOptions: Apollo.QueryHookOptions<UserCoreWeaveAccountsQuery, UserCoreWeaveAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserCoreWeaveAccountsQuery, UserCoreWeaveAccountsQueryVariables>(UserCoreWeaveAccountsDocument, options);
      }
export function useUserCoreWeaveAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserCoreWeaveAccountsQuery, UserCoreWeaveAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserCoreWeaveAccountsQuery, UserCoreWeaveAccountsQueryVariables>(UserCoreWeaveAccountsDocument, options);
        }
export type UserCoreWeaveAccountsQueryHookResult = ReturnType<typeof useUserCoreWeaveAccountsQuery>;
export type UserCoreWeaveAccountsLazyQueryHookResult = ReturnType<typeof useUserCoreWeaveAccountsLazyQuery>;
export type UserCoreWeaveAccountsQueryResult = Apollo.QueryResult<UserCoreWeaveAccountsQuery, UserCoreWeaveAccountsQueryVariables>;
export function refetchUserCoreWeaveAccountsQuery(variables: UserCoreWeaveAccountsQueryVariables) {
      return { query: UserCoreWeaveAccountsDocument, variables: variables }
    }
export const UserAwsResourcesDocument = gql`
    query userAwsResources($userId: ID!, $awsResourceSearchInput: AwsResourceSearchInput!, $awsId: UUID!) {
  user(id: $userId) {
    id
    awsAccount(id: $awsId) {
      id
      awsResources(input: $awsResourceSearchInput) {
        nextToken
        awsResources {
          arn
          type
          region
        }
      }
      accountID
    }
  }
}
    `;

/**
 * __useUserAwsResourcesQuery__
 *
 * To run a query within a React component, call `useUserAwsResourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserAwsResourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserAwsResourcesQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      awsResourceSearchInput: // value for 'awsResourceSearchInput'
 *      awsId: // value for 'awsId'
 *   },
 * });
 */
export function useUserAwsResourcesQuery(baseOptions: Apollo.QueryHookOptions<UserAwsResourcesQuery, UserAwsResourcesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserAwsResourcesQuery, UserAwsResourcesQueryVariables>(UserAwsResourcesDocument, options);
      }
export function useUserAwsResourcesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserAwsResourcesQuery, UserAwsResourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserAwsResourcesQuery, UserAwsResourcesQueryVariables>(UserAwsResourcesDocument, options);
        }
export type UserAwsResourcesQueryHookResult = ReturnType<typeof useUserAwsResourcesQuery>;
export type UserAwsResourcesLazyQueryHookResult = ReturnType<typeof useUserAwsResourcesLazyQuery>;
export type UserAwsResourcesQueryResult = Apollo.QueryResult<UserAwsResourcesQuery, UserAwsResourcesQueryVariables>;
export function refetchUserAwsResourcesQuery(variables: UserAwsResourcesQueryVariables) {
      return { query: UserAwsResourcesDocument, variables: variables }
    }
export const UserCloudsDocument = gql`
    query userClouds($id: ID!) {
  user(id: $id) {
    id
    ...UserClouds
  }
}
    ${UserCloudsFragmentDoc}`;

/**
 * __useUserCloudsQuery__
 *
 * To run a query within a React component, call `useUserCloudsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserCloudsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserCloudsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserCloudsQuery(baseOptions: Apollo.QueryHookOptions<UserCloudsQuery, UserCloudsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserCloudsQuery, UserCloudsQueryVariables>(UserCloudsDocument, options);
      }
export function useUserCloudsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserCloudsQuery, UserCloudsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserCloudsQuery, UserCloudsQueryVariables>(UserCloudsDocument, options);
        }
export type UserCloudsQueryHookResult = ReturnType<typeof useUserCloudsQuery>;
export type UserCloudsLazyQueryHookResult = ReturnType<typeof useUserCloudsLazyQuery>;
export type UserCloudsQueryResult = Apollo.QueryResult<UserCloudsQuery, UserCloudsQueryVariables>;
export function refetchUserCloudsQuery(variables: UserCloudsQueryVariables) {
      return { query: UserCloudsDocument, variables: variables }
    }
export const CloudNamesDocument = gql`
    query cloudNames($teamId: ID!) {
  user(id: $teamId) {
    id
    awsAccounts {
      id
      name
    }
    gcpAccounts {
      id
      name
    }
    doAccounts {
      id
      name
    }
    coreweaveAccounts {
      id
      name
    }
    linodeAccounts {
      id
      name
    }
    vultrAccounts {
      id
      name
    }
    azureAccounts {
      id
      name
    }
  }
}
    `;

/**
 * __useCloudNamesQuery__
 *
 * To run a query within a React component, call `useCloudNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCloudNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCloudNamesQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useCloudNamesQuery(baseOptions: Apollo.QueryHookOptions<CloudNamesQuery, CloudNamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CloudNamesQuery, CloudNamesQueryVariables>(CloudNamesDocument, options);
      }
export function useCloudNamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CloudNamesQuery, CloudNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CloudNamesQuery, CloudNamesQueryVariables>(CloudNamesDocument, options);
        }
export type CloudNamesQueryHookResult = ReturnType<typeof useCloudNamesQuery>;
export type CloudNamesLazyQueryHookResult = ReturnType<typeof useCloudNamesLazyQuery>;
export type CloudNamesQueryResult = Apollo.QueryResult<CloudNamesQuery, CloudNamesQueryVariables>;
export function refetchCloudNamesQuery(variables: CloudNamesQueryVariables) {
      return { query: CloudNamesDocument, variables: variables }
    }
export const CloudDetailsAwsDocument = gql`
    query cloudDetailsAws($id: ID!, $accountId: UUID!) {
  user(id: $id) {
    id
    awsAccount(id: $accountId) {
      id
      ...AWSAccountDetail
    }
  }
}
    ${AwsAccountDetailFragmentDoc}`;

/**
 * __useCloudDetailsAwsQuery__
 *
 * To run a query within a React component, call `useCloudDetailsAwsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCloudDetailsAwsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCloudDetailsAwsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useCloudDetailsAwsQuery(baseOptions: Apollo.QueryHookOptions<CloudDetailsAwsQuery, CloudDetailsAwsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CloudDetailsAwsQuery, CloudDetailsAwsQueryVariables>(CloudDetailsAwsDocument, options);
      }
export function useCloudDetailsAwsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CloudDetailsAwsQuery, CloudDetailsAwsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CloudDetailsAwsQuery, CloudDetailsAwsQueryVariables>(CloudDetailsAwsDocument, options);
        }
export type CloudDetailsAwsQueryHookResult = ReturnType<typeof useCloudDetailsAwsQuery>;
export type CloudDetailsAwsLazyQueryHookResult = ReturnType<typeof useCloudDetailsAwsLazyQuery>;
export type CloudDetailsAwsQueryResult = Apollo.QueryResult<CloudDetailsAwsQuery, CloudDetailsAwsQueryVariables>;
export function refetchCloudDetailsAwsQuery(variables: CloudDetailsAwsQueryVariables) {
      return { query: CloudDetailsAwsDocument, variables: variables }
    }
export const CloudDetailsGcpDocument = gql`
    query cloudDetailsGcp($id: ID!, $accountId: UUID!) {
  user(id: $id) {
    id
    gcpAccount(id: $accountId) {
      id
      ...GCPAccountDetail
    }
  }
}
    ${GcpAccountDetailFragmentDoc}`;

/**
 * __useCloudDetailsGcpQuery__
 *
 * To run a query within a React component, call `useCloudDetailsGcpQuery` and pass it any options that fit your needs.
 * When your component renders, `useCloudDetailsGcpQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCloudDetailsGcpQuery({
 *   variables: {
 *      id: // value for 'id'
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useCloudDetailsGcpQuery(baseOptions: Apollo.QueryHookOptions<CloudDetailsGcpQuery, CloudDetailsGcpQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CloudDetailsGcpQuery, CloudDetailsGcpQueryVariables>(CloudDetailsGcpDocument, options);
      }
export function useCloudDetailsGcpLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CloudDetailsGcpQuery, CloudDetailsGcpQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CloudDetailsGcpQuery, CloudDetailsGcpQueryVariables>(CloudDetailsGcpDocument, options);
        }
export type CloudDetailsGcpQueryHookResult = ReturnType<typeof useCloudDetailsGcpQuery>;
export type CloudDetailsGcpLazyQueryHookResult = ReturnType<typeof useCloudDetailsGcpLazyQuery>;
export type CloudDetailsGcpQueryResult = Apollo.QueryResult<CloudDetailsGcpQuery, CloudDetailsGcpQueryVariables>;
export function refetchCloudDetailsGcpQuery(variables: CloudDetailsGcpQueryVariables) {
      return { query: CloudDetailsGcpDocument, variables: variables }
    }
export const CloudDetailsDoDocument = gql`
    query cloudDetailsDo($id: ID!, $accountId: UUID!) {
  user(id: $id) {
    id
    doAccount(id: $accountId) {
      id
      ...DOAccountDetail
    }
  }
}
    ${DoAccountDetailFragmentDoc}`;

/**
 * __useCloudDetailsDoQuery__
 *
 * To run a query within a React component, call `useCloudDetailsDoQuery` and pass it any options that fit your needs.
 * When your component renders, `useCloudDetailsDoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCloudDetailsDoQuery({
 *   variables: {
 *      id: // value for 'id'
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useCloudDetailsDoQuery(baseOptions: Apollo.QueryHookOptions<CloudDetailsDoQuery, CloudDetailsDoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CloudDetailsDoQuery, CloudDetailsDoQueryVariables>(CloudDetailsDoDocument, options);
      }
export function useCloudDetailsDoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CloudDetailsDoQuery, CloudDetailsDoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CloudDetailsDoQuery, CloudDetailsDoQueryVariables>(CloudDetailsDoDocument, options);
        }
export type CloudDetailsDoQueryHookResult = ReturnType<typeof useCloudDetailsDoQuery>;
export type CloudDetailsDoLazyQueryHookResult = ReturnType<typeof useCloudDetailsDoLazyQuery>;
export type CloudDetailsDoQueryResult = Apollo.QueryResult<CloudDetailsDoQuery, CloudDetailsDoQueryVariables>;
export function refetchCloudDetailsDoQuery(variables: CloudDetailsDoQueryVariables) {
      return { query: CloudDetailsDoDocument, variables: variables }
    }
export const CloudDetailsLinodeDocument = gql`
    query cloudDetailsLinode($id: ID!, $accountId: UUID!) {
  user(id: $id) {
    id
    linodeAccount(id: $accountId) {
      id
      ...LinodeAccountDetail
    }
  }
}
    ${LinodeAccountDetailFragmentDoc}`;

/**
 * __useCloudDetailsLinodeQuery__
 *
 * To run a query within a React component, call `useCloudDetailsLinodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useCloudDetailsLinodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCloudDetailsLinodeQuery({
 *   variables: {
 *      id: // value for 'id'
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useCloudDetailsLinodeQuery(baseOptions: Apollo.QueryHookOptions<CloudDetailsLinodeQuery, CloudDetailsLinodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CloudDetailsLinodeQuery, CloudDetailsLinodeQueryVariables>(CloudDetailsLinodeDocument, options);
      }
export function useCloudDetailsLinodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CloudDetailsLinodeQuery, CloudDetailsLinodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CloudDetailsLinodeQuery, CloudDetailsLinodeQueryVariables>(CloudDetailsLinodeDocument, options);
        }
export type CloudDetailsLinodeQueryHookResult = ReturnType<typeof useCloudDetailsLinodeQuery>;
export type CloudDetailsLinodeLazyQueryHookResult = ReturnType<typeof useCloudDetailsLinodeLazyQuery>;
export type CloudDetailsLinodeQueryResult = Apollo.QueryResult<CloudDetailsLinodeQuery, CloudDetailsLinodeQueryVariables>;
export function refetchCloudDetailsLinodeQuery(variables: CloudDetailsLinodeQueryVariables) {
      return { query: CloudDetailsLinodeDocument, variables: variables }
    }
export const CloudDetailsCoreweaveDocument = gql`
    query cloudDetailsCoreweave($id: ID!, $accountId: UUID!) {
  user(id: $id) {
    id
    coreweaveAccount(id: $accountId) {
      id
      ...CWAccountDetail
    }
  }
}
    ${CwAccountDetailFragmentDoc}`;

/**
 * __useCloudDetailsCoreweaveQuery__
 *
 * To run a query within a React component, call `useCloudDetailsCoreweaveQuery` and pass it any options that fit your needs.
 * When your component renders, `useCloudDetailsCoreweaveQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCloudDetailsCoreweaveQuery({
 *   variables: {
 *      id: // value for 'id'
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useCloudDetailsCoreweaveQuery(baseOptions: Apollo.QueryHookOptions<CloudDetailsCoreweaveQuery, CloudDetailsCoreweaveQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CloudDetailsCoreweaveQuery, CloudDetailsCoreweaveQueryVariables>(CloudDetailsCoreweaveDocument, options);
      }
export function useCloudDetailsCoreweaveLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CloudDetailsCoreweaveQuery, CloudDetailsCoreweaveQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CloudDetailsCoreweaveQuery, CloudDetailsCoreweaveQueryVariables>(CloudDetailsCoreweaveDocument, options);
        }
export type CloudDetailsCoreweaveQueryHookResult = ReturnType<typeof useCloudDetailsCoreweaveQuery>;
export type CloudDetailsCoreweaveLazyQueryHookResult = ReturnType<typeof useCloudDetailsCoreweaveLazyQuery>;
export type CloudDetailsCoreweaveQueryResult = Apollo.QueryResult<CloudDetailsCoreweaveQuery, CloudDetailsCoreweaveQueryVariables>;
export function refetchCloudDetailsCoreweaveQuery(variables: CloudDetailsCoreweaveQueryVariables) {
      return { query: CloudDetailsCoreweaveDocument, variables: variables }
    }
export const CloudDetailsVultrDocument = gql`
    query cloudDetailsVultr($id: ID!, $accountId: UUID!) {
  user(id: $id) {
    id
    vultrAccount(id: $accountId) {
      id
      ...VultrAccountDetail
    }
  }
}
    ${VultrAccountDetailFragmentDoc}`;

/**
 * __useCloudDetailsVultrQuery__
 *
 * To run a query within a React component, call `useCloudDetailsVultrQuery` and pass it any options that fit your needs.
 * When your component renders, `useCloudDetailsVultrQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCloudDetailsVultrQuery({
 *   variables: {
 *      id: // value for 'id'
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useCloudDetailsVultrQuery(baseOptions: Apollo.QueryHookOptions<CloudDetailsVultrQuery, CloudDetailsVultrQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CloudDetailsVultrQuery, CloudDetailsVultrQueryVariables>(CloudDetailsVultrDocument, options);
      }
export function useCloudDetailsVultrLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CloudDetailsVultrQuery, CloudDetailsVultrQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CloudDetailsVultrQuery, CloudDetailsVultrQueryVariables>(CloudDetailsVultrDocument, options);
        }
export type CloudDetailsVultrQueryHookResult = ReturnType<typeof useCloudDetailsVultrQuery>;
export type CloudDetailsVultrLazyQueryHookResult = ReturnType<typeof useCloudDetailsVultrLazyQuery>;
export type CloudDetailsVultrQueryResult = Apollo.QueryResult<CloudDetailsVultrQuery, CloudDetailsVultrQueryVariables>;
export function refetchCloudDetailsVultrQuery(variables: CloudDetailsVultrQueryVariables) {
      return { query: CloudDetailsVultrDocument, variables: variables }
    }
export const CloudDetailsAzureDocument = gql`
    query cloudDetailsAzure($id: ID!, $accountId: UUID!) {
  user(id: $id) {
    id
    azureAccount(id: $accountId) {
      id
      ...AzureAccountDetail
    }
  }
}
    ${AzureAccountDetailFragmentDoc}`;

/**
 * __useCloudDetailsAzureQuery__
 *
 * To run a query within a React component, call `useCloudDetailsAzureQuery` and pass it any options that fit your needs.
 * When your component renders, `useCloudDetailsAzureQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCloudDetailsAzureQuery({
 *   variables: {
 *      id: // value for 'id'
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useCloudDetailsAzureQuery(baseOptions: Apollo.QueryHookOptions<CloudDetailsAzureQuery, CloudDetailsAzureQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CloudDetailsAzureQuery, CloudDetailsAzureQueryVariables>(CloudDetailsAzureDocument, options);
      }
export function useCloudDetailsAzureLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CloudDetailsAzureQuery, CloudDetailsAzureQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CloudDetailsAzureQuery, CloudDetailsAzureQueryVariables>(CloudDetailsAzureDocument, options);
        }
export type CloudDetailsAzureQueryHookResult = ReturnType<typeof useCloudDetailsAzureQuery>;
export type CloudDetailsAzureLazyQueryHookResult = ReturnType<typeof useCloudDetailsAzureLazyQuery>;
export type CloudDetailsAzureQueryResult = Apollo.QueryResult<CloudDetailsAzureQuery, CloudDetailsAzureQueryVariables>;
export function refetchCloudDetailsAzureQuery(variables: CloudDetailsAzureQueryVariables) {
      return { query: CloudDetailsAzureDocument, variables: variables }
    }
export const UserClustersDocument = gql`
    query userClusters($id: ID!) {
  user(id: $id) {
    id
    clusters {
      id
      ...ClusterListItem
    }
  }
}
    ${ClusterListItemFragmentDoc}`;

/**
 * __useUserClustersQuery__
 *
 * To run a query within a React component, call `useUserClustersQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserClustersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserClustersQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserClustersQuery(baseOptions: Apollo.QueryHookOptions<UserClustersQuery, UserClustersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserClustersQuery, UserClustersQueryVariables>(UserClustersDocument, options);
      }
export function useUserClustersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserClustersQuery, UserClustersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserClustersQuery, UserClustersQueryVariables>(UserClustersDocument, options);
        }
export type UserClustersQueryHookResult = ReturnType<typeof useUserClustersQuery>;
export type UserClustersLazyQueryHookResult = ReturnType<typeof useUserClustersLazyQuery>;
export type UserClustersQueryResult = Apollo.QueryResult<UserClustersQuery, UserClustersQueryVariables>;
export function refetchUserClustersQuery(variables: UserClustersQueryVariables) {
      return { query: UserClustersDocument, variables: variables }
    }
export const UserDeployTargetsDocument = gql`
    query userDeployTargets($id: ID!) {
  user(id: $id) {
    id
    ...UserCloudDeployTargets
    defaultCluster {
      id
      ...ClusterDeployTarget
    }
    clusters {
      id
      ...ClusterDeployTarget
    }
  }
}
    ${UserCloudDeployTargetsFragmentDoc}
${ClusterDeployTargetFragmentDoc}`;

/**
 * __useUserDeployTargetsQuery__
 *
 * To run a query within a React component, call `useUserDeployTargetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserDeployTargetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserDeployTargetsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserDeployTargetsQuery(baseOptions: Apollo.QueryHookOptions<UserDeployTargetsQuery, UserDeployTargetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserDeployTargetsQuery, UserDeployTargetsQueryVariables>(UserDeployTargetsDocument, options);
      }
export function useUserDeployTargetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserDeployTargetsQuery, UserDeployTargetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserDeployTargetsQuery, UserDeployTargetsQueryVariables>(UserDeployTargetsDocument, options);
        }
export type UserDeployTargetsQueryHookResult = ReturnType<typeof useUserDeployTargetsQuery>;
export type UserDeployTargetsLazyQueryHookResult = ReturnType<typeof useUserDeployTargetsLazyQuery>;
export type UserDeployTargetsQueryResult = Apollo.QueryResult<UserDeployTargetsQuery, UserDeployTargetsQueryVariables>;
export function refetchUserDeployTargetsQuery(variables: UserDeployTargetsQueryVariables) {
      return { query: UserDeployTargetsDocument, variables: variables }
    }
export const ClusterProvisionTargetsDocument = gql`
    query clusterProvisionTargets($id: ID!) {
  user(id: $id) {
    id
    ...UserCloudDeployTargets
  }
}
    ${UserCloudDeployTargetsFragmentDoc}`;

/**
 * __useClusterProvisionTargetsQuery__
 *
 * To run a query within a React component, call `useClusterProvisionTargetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useClusterProvisionTargetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClusterProvisionTargetsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useClusterProvisionTargetsQuery(baseOptions: Apollo.QueryHookOptions<ClusterProvisionTargetsQuery, ClusterProvisionTargetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClusterProvisionTargetsQuery, ClusterProvisionTargetsQueryVariables>(ClusterProvisionTargetsDocument, options);
      }
export function useClusterProvisionTargetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClusterProvisionTargetsQuery, ClusterProvisionTargetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClusterProvisionTargetsQuery, ClusterProvisionTargetsQueryVariables>(ClusterProvisionTargetsDocument, options);
        }
export type ClusterProvisionTargetsQueryHookResult = ReturnType<typeof useClusterProvisionTargetsQuery>;
export type ClusterProvisionTargetsLazyQueryHookResult = ReturnType<typeof useClusterProvisionTargetsLazyQuery>;
export type ClusterProvisionTargetsQueryResult = Apollo.QueryResult<ClusterProvisionTargetsQuery, ClusterProvisionTargetsQueryVariables>;
export function refetchClusterProvisionTargetsQuery(variables: ClusterProvisionTargetsQueryVariables) {
      return { query: ClusterProvisionTargetsDocument, variables: variables }
    }
export const ClusterKubeconfigDocument = gql`
    query clusterKubeconfig($userID: ID!, $clusterID: UUID!) {
  user(id: $userID) {
    id
    cluster(id: $clusterID) {
      id
      name
      kubeconfig
    }
  }
}
    `;

/**
 * __useClusterKubeconfigQuery__
 *
 * To run a query within a React component, call `useClusterKubeconfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useClusterKubeconfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClusterKubeconfigQuery({
 *   variables: {
 *      userID: // value for 'userID'
 *      clusterID: // value for 'clusterID'
 *   },
 * });
 */
export function useClusterKubeconfigQuery(baseOptions: Apollo.QueryHookOptions<ClusterKubeconfigQuery, ClusterKubeconfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClusterKubeconfigQuery, ClusterKubeconfigQueryVariables>(ClusterKubeconfigDocument, options);
      }
export function useClusterKubeconfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClusterKubeconfigQuery, ClusterKubeconfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClusterKubeconfigQuery, ClusterKubeconfigQueryVariables>(ClusterKubeconfigDocument, options);
        }
export type ClusterKubeconfigQueryHookResult = ReturnType<typeof useClusterKubeconfigQuery>;
export type ClusterKubeconfigLazyQueryHookResult = ReturnType<typeof useClusterKubeconfigLazyQuery>;
export type ClusterKubeconfigQueryResult = Apollo.QueryResult<ClusterKubeconfigQuery, ClusterKubeconfigQueryVariables>;
export function refetchClusterKubeconfigQuery(variables: ClusterKubeconfigQueryVariables) {
      return { query: ClusterKubeconfigDocument, variables: variables }
    }
export const ClusterCertIssuersDocument = gql`
    query clusterCertIssuers($userID: ID!, $repoID: ID!, $clusterID: UUID!) {
  user(id: $userID) {
    id
    cluster(id: $clusterID) {
      id
      name
      clusterIssuers
    }
    repo(id: $repoID) {
      id
      name
      clusterIssuerName
    }
  }
}
    `;

/**
 * __useClusterCertIssuersQuery__
 *
 * To run a query within a React component, call `useClusterCertIssuersQuery` and pass it any options that fit your needs.
 * When your component renders, `useClusterCertIssuersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClusterCertIssuersQuery({
 *   variables: {
 *      userID: // value for 'userID'
 *      repoID: // value for 'repoID'
 *      clusterID: // value for 'clusterID'
 *   },
 * });
 */
export function useClusterCertIssuersQuery(baseOptions: Apollo.QueryHookOptions<ClusterCertIssuersQuery, ClusterCertIssuersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClusterCertIssuersQuery, ClusterCertIssuersQueryVariables>(ClusterCertIssuersDocument, options);
      }
export function useClusterCertIssuersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClusterCertIssuersQuery, ClusterCertIssuersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClusterCertIssuersQuery, ClusterCertIssuersQueryVariables>(ClusterCertIssuersDocument, options);
        }
export type ClusterCertIssuersQueryHookResult = ReturnType<typeof useClusterCertIssuersQuery>;
export type ClusterCertIssuersLazyQueryHookResult = ReturnType<typeof useClusterCertIssuersLazyQuery>;
export type ClusterCertIssuersQueryResult = Apollo.QueryResult<ClusterCertIssuersQuery, ClusterCertIssuersQueryVariables>;
export function refetchClusterCertIssuersQuery(variables: ClusterCertIssuersQueryVariables) {
      return { query: ClusterCertIssuersDocument, variables: variables }
    }
export const ClusterDomainDocument = gql`
    query clusterDomain($userID: ID!, $clusterID: UUID!) {
  user(id: $userID) {
    id
    cluster(id: $clusterID) {
      id
      domain
    }
  }
}
    `;

/**
 * __useClusterDomainQuery__
 *
 * To run a query within a React component, call `useClusterDomainQuery` and pass it any options that fit your needs.
 * When your component renders, `useClusterDomainQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClusterDomainQuery({
 *   variables: {
 *      userID: // value for 'userID'
 *      clusterID: // value for 'clusterID'
 *   },
 * });
 */
export function useClusterDomainQuery(baseOptions: Apollo.QueryHookOptions<ClusterDomainQuery, ClusterDomainQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClusterDomainQuery, ClusterDomainQueryVariables>(ClusterDomainDocument, options);
      }
export function useClusterDomainLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClusterDomainQuery, ClusterDomainQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClusterDomainQuery, ClusterDomainQueryVariables>(ClusterDomainDocument, options);
        }
export type ClusterDomainQueryHookResult = ReturnType<typeof useClusterDomainQuery>;
export type ClusterDomainLazyQueryHookResult = ReturnType<typeof useClusterDomainLazyQuery>;
export type ClusterDomainQueryResult = Apollo.QueryResult<ClusterDomainQuery, ClusterDomainQueryVariables>;
export function refetchClusterDomainQuery(variables: ClusterDomainQueryVariables) {
      return { query: ClusterDomainDocument, variables: variables }
    }
export const ClustersCustomDomainsDocument = gql`
    query clustersCustomDomains($id: ID!) {
  user(id: $id) {
    id
    clusters {
      id
      customDomains {
        id
        customDomain {
          id
          domain
          syncDomain {
            id
            domain
          }
        }
        repo {
          ...RepoCommon
        }
      }
      ...ClusterNamesWithCloudNames
    }
  }
}
    ${RepoCommonFragmentDoc}
${ClusterNamesWithCloudNamesFragmentDoc}`;

/**
 * __useClustersCustomDomainsQuery__
 *
 * To run a query within a React component, call `useClustersCustomDomainsQuery` and pass it any options that fit your needs.
 * When your component renders, `useClustersCustomDomainsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClustersCustomDomainsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useClustersCustomDomainsQuery(baseOptions: Apollo.QueryHookOptions<ClustersCustomDomainsQuery, ClustersCustomDomainsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClustersCustomDomainsQuery, ClustersCustomDomainsQueryVariables>(ClustersCustomDomainsDocument, options);
      }
export function useClustersCustomDomainsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClustersCustomDomainsQuery, ClustersCustomDomainsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClustersCustomDomainsQuery, ClustersCustomDomainsQueryVariables>(ClustersCustomDomainsDocument, options);
        }
export type ClustersCustomDomainsQueryHookResult = ReturnType<typeof useClustersCustomDomainsQuery>;
export type ClustersCustomDomainsLazyQueryHookResult = ReturnType<typeof useClustersCustomDomainsLazyQuery>;
export type ClustersCustomDomainsQueryResult = Apollo.QueryResult<ClustersCustomDomainsQuery, ClustersCustomDomainsQueryVariables>;
export function refetchClustersCustomDomainsQuery(variables: ClustersCustomDomainsQueryVariables) {
      return { query: ClustersCustomDomainsDocument, variables: variables }
    }
export const ClusterNameDocument = gql`
    query clusterName($teamId: ID!, $clusterId: UUID!) {
  user(id: $teamId) {
    id
    cluster(id: $clusterId) {
      id
      cloudProvider
      name
    }
  }
}
    `;

/**
 * __useClusterNameQuery__
 *
 * To run a query within a React component, call `useClusterNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useClusterNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClusterNameQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      clusterId: // value for 'clusterId'
 *   },
 * });
 */
export function useClusterNameQuery(baseOptions: Apollo.QueryHookOptions<ClusterNameQuery, ClusterNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClusterNameQuery, ClusterNameQueryVariables>(ClusterNameDocument, options);
      }
export function useClusterNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClusterNameQuery, ClusterNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClusterNameQuery, ClusterNameQueryVariables>(ClusterNameDocument, options);
        }
export type ClusterNameQueryHookResult = ReturnType<typeof useClusterNameQuery>;
export type ClusterNameLazyQueryHookResult = ReturnType<typeof useClusterNameLazyQuery>;
export type ClusterNameQueryResult = Apollo.QueryResult<ClusterNameQuery, ClusterNameQueryVariables>;
export function refetchClusterNameQuery(variables: ClusterNameQueryVariables) {
      return { query: ClusterNameDocument, variables: variables }
    }
export const ClusterDetailsDocument = gql`
    query clusterDetails($id: ID!, $clusterId: UUID!) {
  user(id: $id) {
    id
    cluster(id: $clusterId) {
      id
      ...ClusterDetail
    }
    ...UserClouds
    ...UserContainerRegistries
  }
}
    ${ClusterDetailFragmentDoc}
${UserCloudsFragmentDoc}
${UserContainerRegistriesFragmentDoc}`;

/**
 * __useClusterDetailsQuery__
 *
 * To run a query within a React component, call `useClusterDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useClusterDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClusterDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      clusterId: // value for 'clusterId'
 *   },
 * });
 */
export function useClusterDetailsQuery(baseOptions: Apollo.QueryHookOptions<ClusterDetailsQuery, ClusterDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClusterDetailsQuery, ClusterDetailsQueryVariables>(ClusterDetailsDocument, options);
      }
export function useClusterDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClusterDetailsQuery, ClusterDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClusterDetailsQuery, ClusterDetailsQueryVariables>(ClusterDetailsDocument, options);
        }
export type ClusterDetailsQueryHookResult = ReturnType<typeof useClusterDetailsQuery>;
export type ClusterDetailsLazyQueryHookResult = ReturnType<typeof useClusterDetailsLazyQuery>;
export type ClusterDetailsQueryResult = Apollo.QueryResult<ClusterDetailsQuery, ClusterDetailsQueryVariables>;
export function refetchClusterDetailsQuery(variables: ClusterDetailsQueryVariables) {
      return { query: ClusterDetailsDocument, variables: variables }
    }
export const ClusterCommonDocument = gql`
    query clusterCommon($id: ID!, $clusterId: UUID!) {
  user(id: $id) {
    id
    cluster(id: $clusterId) {
      id
      ...ClusterCommon
    }
  }
}
    ${ClusterCommonFragmentDoc}`;

/**
 * __useClusterCommonQuery__
 *
 * To run a query within a React component, call `useClusterCommonQuery` and pass it any options that fit your needs.
 * When your component renders, `useClusterCommonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClusterCommonQuery({
 *   variables: {
 *      id: // value for 'id'
 *      clusterId: // value for 'clusterId'
 *   },
 * });
 */
export function useClusterCommonQuery(baseOptions: Apollo.QueryHookOptions<ClusterCommonQuery, ClusterCommonQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClusterCommonQuery, ClusterCommonQueryVariables>(ClusterCommonDocument, options);
      }
export function useClusterCommonLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClusterCommonQuery, ClusterCommonQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClusterCommonQuery, ClusterCommonQueryVariables>(ClusterCommonDocument, options);
        }
export type ClusterCommonQueryHookResult = ReturnType<typeof useClusterCommonQuery>;
export type ClusterCommonLazyQueryHookResult = ReturnType<typeof useClusterCommonLazyQuery>;
export type ClusterCommonQueryResult = Apollo.QueryResult<ClusterCommonQuery, ClusterCommonQueryVariables>;
export function refetchClusterCommonQuery(variables: ClusterCommonQueryVariables) {
      return { query: ClusterCommonDocument, variables: variables }
    }
export const ClusterDeployLogsDocument = gql`
    query clusterDeployLogs($id: ID!, $clusterId: UUID!) {
  user(id: $id) {
    id
    cluster(id: $clusterId) {
      id
      deployJob {
        id
        logs {
          id
          cursor
          entries {
            text
            timestamp
          }
        }
      }
    }
  }
}
    `;

/**
 * __useClusterDeployLogsQuery__
 *
 * To run a query within a React component, call `useClusterDeployLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useClusterDeployLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClusterDeployLogsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      clusterId: // value for 'clusterId'
 *   },
 * });
 */
export function useClusterDeployLogsQuery(baseOptions: Apollo.QueryHookOptions<ClusterDeployLogsQuery, ClusterDeployLogsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClusterDeployLogsQuery, ClusterDeployLogsQueryVariables>(ClusterDeployLogsDocument, options);
      }
export function useClusterDeployLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClusterDeployLogsQuery, ClusterDeployLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClusterDeployLogsQuery, ClusterDeployLogsQueryVariables>(ClusterDeployLogsDocument, options);
        }
export type ClusterDeployLogsQueryHookResult = ReturnType<typeof useClusterDeployLogsQuery>;
export type ClusterDeployLogsLazyQueryHookResult = ReturnType<typeof useClusterDeployLogsLazyQuery>;
export type ClusterDeployLogsQueryResult = Apollo.QueryResult<ClusterDeployLogsQuery, ClusterDeployLogsQueryVariables>;
export function refetchClusterDeployLogsQuery(variables: ClusterDeployLogsQueryVariables) {
      return { query: ClusterDeployLogsDocument, variables: variables }
    }
export const TerraformEjectionStatusDocument = gql`
    query terraformEjectionStatus($id: ID!, $clusterId: UUID!) {
  user(id: $id) {
    id
    cluster(id: $clusterId) {
      id
      components {
        type
        name
        status
        terraformMetadata {
          jobRunState
        }
      }
    }
  }
}
    `;

/**
 * __useTerraformEjectionStatusQuery__
 *
 * To run a query within a React component, call `useTerraformEjectionStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useTerraformEjectionStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTerraformEjectionStatusQuery({
 *   variables: {
 *      id: // value for 'id'
 *      clusterId: // value for 'clusterId'
 *   },
 * });
 */
export function useTerraformEjectionStatusQuery(baseOptions: Apollo.QueryHookOptions<TerraformEjectionStatusQuery, TerraformEjectionStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TerraformEjectionStatusQuery, TerraformEjectionStatusQueryVariables>(TerraformEjectionStatusDocument, options);
      }
export function useTerraformEjectionStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TerraformEjectionStatusQuery, TerraformEjectionStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TerraformEjectionStatusQuery, TerraformEjectionStatusQueryVariables>(TerraformEjectionStatusDocument, options);
        }
export type TerraformEjectionStatusQueryHookResult = ReturnType<typeof useTerraformEjectionStatusQuery>;
export type TerraformEjectionStatusLazyQueryHookResult = ReturnType<typeof useTerraformEjectionStatusLazyQuery>;
export type TerraformEjectionStatusQueryResult = Apollo.QueryResult<TerraformEjectionStatusQuery, TerraformEjectionStatusQueryVariables>;
export function refetchTerraformEjectionStatusQuery(variables: TerraformEjectionStatusQueryVariables) {
      return { query: TerraformEjectionStatusDocument, variables: variables }
    }
export const ValidateCloudForClusterCreationDocument = gql`
    query validateCloudForClusterCreation($userId: ID!, $context: ClusterValidationInput!) {
  user(id: $userId) {
    id
    validateCloud(context: $context) {
      errors {
        docs
        fixable
        message
        type
      }
    }
  }
}
    `;

/**
 * __useValidateCloudForClusterCreationQuery__
 *
 * To run a query within a React component, call `useValidateCloudForClusterCreationQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateCloudForClusterCreationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateCloudForClusterCreationQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      context: // value for 'context'
 *   },
 * });
 */
export function useValidateCloudForClusterCreationQuery(baseOptions: Apollo.QueryHookOptions<ValidateCloudForClusterCreationQuery, ValidateCloudForClusterCreationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidateCloudForClusterCreationQuery, ValidateCloudForClusterCreationQueryVariables>(ValidateCloudForClusterCreationDocument, options);
      }
export function useValidateCloudForClusterCreationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidateCloudForClusterCreationQuery, ValidateCloudForClusterCreationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidateCloudForClusterCreationQuery, ValidateCloudForClusterCreationQueryVariables>(ValidateCloudForClusterCreationDocument, options);
        }
export type ValidateCloudForClusterCreationQueryHookResult = ReturnType<typeof useValidateCloudForClusterCreationQuery>;
export type ValidateCloudForClusterCreationLazyQueryHookResult = ReturnType<typeof useValidateCloudForClusterCreationLazyQuery>;
export type ValidateCloudForClusterCreationQueryResult = Apollo.QueryResult<ValidateCloudForClusterCreationQuery, ValidateCloudForClusterCreationQueryVariables>;
export function refetchValidateCloudForClusterCreationQuery(variables: ValidateCloudForClusterCreationQueryVariables) {
      return { query: ValidateCloudForClusterCreationDocument, variables: variables }
    }
export const MonthlyCostForServicesDocument = gql`
    query monthlyCostForServices($awsAccountId: UUID!, $services: [String!]!) {
  withoutCredit: awsCostUsage2(
    awsAccountId: $awsAccountId
    where: {granularity: "MONTHLY", dimensionType1: "SERVICE", dimensionType2: "RECORD_TYPE", dimension2NotIn: ["Credit"], dimension1In: $services}
  ) {
    service
    unblendedCostAmount
    unblendedCostUnit
    periodStart
    periodEnd
  }
  withCredit: awsCostByService(
    awsAccountId: $awsAccountId
    where: {services: $services}
  ) {
    service
    unblendedCostAmount
    unblendedCostUnit
    periodStart
    periodEnd
  }
}
    `;

/**
 * __useMonthlyCostForServicesQuery__
 *
 * To run a query within a React component, call `useMonthlyCostForServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMonthlyCostForServicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMonthlyCostForServicesQuery({
 *   variables: {
 *      awsAccountId: // value for 'awsAccountId'
 *      services: // value for 'services'
 *   },
 * });
 */
export function useMonthlyCostForServicesQuery(baseOptions: Apollo.QueryHookOptions<MonthlyCostForServicesQuery, MonthlyCostForServicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MonthlyCostForServicesQuery, MonthlyCostForServicesQueryVariables>(MonthlyCostForServicesDocument, options);
      }
export function useMonthlyCostForServicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MonthlyCostForServicesQuery, MonthlyCostForServicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MonthlyCostForServicesQuery, MonthlyCostForServicesQueryVariables>(MonthlyCostForServicesDocument, options);
        }
export type MonthlyCostForServicesQueryHookResult = ReturnType<typeof useMonthlyCostForServicesQuery>;
export type MonthlyCostForServicesLazyQueryHookResult = ReturnType<typeof useMonthlyCostForServicesLazyQuery>;
export type MonthlyCostForServicesQueryResult = Apollo.QueryResult<MonthlyCostForServicesQuery, MonthlyCostForServicesQueryVariables>;
export function refetchMonthlyCostForServicesQuery(variables: MonthlyCostForServicesQueryVariables) {
      return { query: MonthlyCostForServicesDocument, variables: variables }
    }
export const UserDeploymentDocument = gql`
    query userDeployment($id: ID!) {
  currentUser {
    id
    deployment(id: $id) {
      id
      ...DeploymentDetail
    }
  }
}
    ${DeploymentDetailFragmentDoc}`;

/**
 * __useUserDeploymentQuery__
 *
 * To run a query within a React component, call `useUserDeploymentQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserDeploymentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserDeploymentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserDeploymentQuery(baseOptions: Apollo.QueryHookOptions<UserDeploymentQuery, UserDeploymentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserDeploymentQuery, UserDeploymentQueryVariables>(UserDeploymentDocument, options);
      }
export function useUserDeploymentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserDeploymentQuery, UserDeploymentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserDeploymentQuery, UserDeploymentQueryVariables>(UserDeploymentDocument, options);
        }
export type UserDeploymentQueryHookResult = ReturnType<typeof useUserDeploymentQuery>;
export type UserDeploymentLazyQueryHookResult = ReturnType<typeof useUserDeploymentLazyQuery>;
export type UserDeploymentQueryResult = Apollo.QueryResult<UserDeploymentQuery, UserDeploymentQueryVariables>;
export function refetchUserDeploymentQuery(variables: UserDeploymentQueryVariables) {
      return { query: UserDeploymentDocument, variables: variables }
    }
export const UserDeploymentMetricDocument = gql`
    query userDeploymentMetric($deploymentID: ID!, $deploymentUUID: UUID!, $queryOptions: MetricQueryOptions) {
  currentUser {
    id
    deployment(id: $deploymentID) {
      id
      cpuMetrics: metricsV2(
        deploymentID: $deploymentUUID
        metricType: CPU
        queryOptions: $queryOptions
      ) {
        ...MetricStream
      }
      memoryMetrics: metricsV2(
        deploymentID: $deploymentUUID
        metricType: MEMORY
        queryOptions: $queryOptions
      ) {
        ...MetricStream
      }
      networkMetrics: metricsV2(
        deploymentID: $deploymentUUID
        metricType: NETWORK
        queryOptions: $queryOptions
      ) {
        ...MetricStream
      }
      diskMetrics: metricsV2(
        deploymentID: $deploymentUUID
        metricType: STORAGE
        queryOptions: $queryOptions
      ) {
        ...MetricStream
      }
    }
  }
}
    ${MetricStreamFragmentDoc}`;

/**
 * __useUserDeploymentMetricQuery__
 *
 * To run a query within a React component, call `useUserDeploymentMetricQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserDeploymentMetricQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserDeploymentMetricQuery({
 *   variables: {
 *      deploymentID: // value for 'deploymentID'
 *      deploymentUUID: // value for 'deploymentUUID'
 *      queryOptions: // value for 'queryOptions'
 *   },
 * });
 */
export function useUserDeploymentMetricQuery(baseOptions: Apollo.QueryHookOptions<UserDeploymentMetricQuery, UserDeploymentMetricQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserDeploymentMetricQuery, UserDeploymentMetricQueryVariables>(UserDeploymentMetricDocument, options);
      }
export function useUserDeploymentMetricLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserDeploymentMetricQuery, UserDeploymentMetricQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserDeploymentMetricQuery, UserDeploymentMetricQueryVariables>(UserDeploymentMetricDocument, options);
        }
export type UserDeploymentMetricQueryHookResult = ReturnType<typeof useUserDeploymentMetricQuery>;
export type UserDeploymentMetricLazyQueryHookResult = ReturnType<typeof useUserDeploymentMetricLazyQuery>;
export type UserDeploymentMetricQueryResult = Apollo.QueryResult<UserDeploymentMetricQuery, UserDeploymentMetricQueryVariables>;
export function refetchUserDeploymentMetricQuery(variables: UserDeploymentMetricQueryVariables) {
      return { query: UserDeploymentMetricDocument, variables: variables }
    }
export const UserEphemeralContainersDocument = gql`
    query userEphemeralContainers($id: ID!) {
  currentUser {
    id
    deployment(id: $id) {
      id
      ephemeralContainers {
        name
        image
        ready
      }
    }
  }
}
    `;

/**
 * __useUserEphemeralContainersQuery__
 *
 * To run a query within a React component, call `useUserEphemeralContainersQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserEphemeralContainersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserEphemeralContainersQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserEphemeralContainersQuery(baseOptions: Apollo.QueryHookOptions<UserEphemeralContainersQuery, UserEphemeralContainersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserEphemeralContainersQuery, UserEphemeralContainersQueryVariables>(UserEphemeralContainersDocument, options);
      }
export function useUserEphemeralContainersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserEphemeralContainersQuery, UserEphemeralContainersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserEphemeralContainersQuery, UserEphemeralContainersQueryVariables>(UserEphemeralContainersDocument, options);
        }
export type UserEphemeralContainersQueryHookResult = ReturnType<typeof useUserEphemeralContainersQuery>;
export type UserEphemeralContainersLazyQueryHookResult = ReturnType<typeof useUserEphemeralContainersLazyQuery>;
export type UserEphemeralContainersQueryResult = Apollo.QueryResult<UserEphemeralContainersQuery, UserEphemeralContainersQueryVariables>;
export function refetchUserEphemeralContainersQuery(variables: UserEphemeralContainersQueryVariables) {
      return { query: UserEphemeralContainersDocument, variables: variables }
    }
export const DeploymentBuildLogsDocument = gql`
    query deploymentBuildLogs($id: ID!) {
  currentUser {
    id
    deployment(id: $id) {
      id
      ...DeploymentBuildLogs
    }
  }
}
    ${DeploymentBuildLogsFragmentDoc}`;

/**
 * __useDeploymentBuildLogsQuery__
 *
 * To run a query within a React component, call `useDeploymentBuildLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeploymentBuildLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeploymentBuildLogsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeploymentBuildLogsQuery(baseOptions: Apollo.QueryHookOptions<DeploymentBuildLogsQuery, DeploymentBuildLogsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DeploymentBuildLogsQuery, DeploymentBuildLogsQueryVariables>(DeploymentBuildLogsDocument, options);
      }
export function useDeploymentBuildLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DeploymentBuildLogsQuery, DeploymentBuildLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DeploymentBuildLogsQuery, DeploymentBuildLogsQueryVariables>(DeploymentBuildLogsDocument, options);
        }
export type DeploymentBuildLogsQueryHookResult = ReturnType<typeof useDeploymentBuildLogsQuery>;
export type DeploymentBuildLogsLazyQueryHookResult = ReturnType<typeof useDeploymentBuildLogsLazyQuery>;
export type DeploymentBuildLogsQueryResult = Apollo.QueryResult<DeploymentBuildLogsQuery, DeploymentBuildLogsQueryVariables>;
export function refetchDeploymentBuildLogsQuery(variables: DeploymentBuildLogsQueryVariables) {
      return { query: DeploymentBuildLogsDocument, variables: variables }
    }
export const DeploymentReleaseLogsDocument = gql`
    query deploymentReleaseLogs($id: ID!) {
  currentUser {
    id
    deployment(id: $id) {
      id
      releaseStage {
        id
        logs {
          id
          completed
          expired
          entries {
            timestamp
            text
          }
        }
      }
    }
  }
}
    `;

/**
 * __useDeploymentReleaseLogsQuery__
 *
 * To run a query within a React component, call `useDeploymentReleaseLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeploymentReleaseLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeploymentReleaseLogsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeploymentReleaseLogsQuery(baseOptions: Apollo.QueryHookOptions<DeploymentReleaseLogsQuery, DeploymentReleaseLogsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DeploymentReleaseLogsQuery, DeploymentReleaseLogsQueryVariables>(DeploymentReleaseLogsDocument, options);
      }
export function useDeploymentReleaseLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DeploymentReleaseLogsQuery, DeploymentReleaseLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DeploymentReleaseLogsQuery, DeploymentReleaseLogsQueryVariables>(DeploymentReleaseLogsDocument, options);
        }
export type DeploymentReleaseLogsQueryHookResult = ReturnType<typeof useDeploymentReleaseLogsQuery>;
export type DeploymentReleaseLogsLazyQueryHookResult = ReturnType<typeof useDeploymentReleaseLogsLazyQuery>;
export type DeploymentReleaseLogsQueryResult = Apollo.QueryResult<DeploymentReleaseLogsQuery, DeploymentReleaseLogsQueryVariables>;
export function refetchDeploymentReleaseLogsQuery(variables: DeploymentReleaseLogsQueryVariables) {
      return { query: DeploymentReleaseLogsDocument, variables: variables }
    }
export const DeploymentDeployLogsDocument = gql`
    query deploymentDeployLogs($id: ID!) {
  currentUser {
    id
    deployment(id: $id) {
      id
      deployStage {
        id
        logs {
          id
          completed
          expired
          entries {
            timestamp
            text
          }
        }
      }
    }
  }
}
    `;

/**
 * __useDeploymentDeployLogsQuery__
 *
 * To run a query within a React component, call `useDeploymentDeployLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeploymentDeployLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeploymentDeployLogsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeploymentDeployLogsQuery(baseOptions: Apollo.QueryHookOptions<DeploymentDeployLogsQuery, DeploymentDeployLogsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DeploymentDeployLogsQuery, DeploymentDeployLogsQueryVariables>(DeploymentDeployLogsDocument, options);
      }
export function useDeploymentDeployLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DeploymentDeployLogsQuery, DeploymentDeployLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DeploymentDeployLogsQuery, DeploymentDeployLogsQueryVariables>(DeploymentDeployLogsDocument, options);
        }
export type DeploymentDeployLogsQueryHookResult = ReturnType<typeof useDeploymentDeployLogsQuery>;
export type DeploymentDeployLogsLazyQueryHookResult = ReturnType<typeof useDeploymentDeployLogsLazyQuery>;
export type DeploymentDeployLogsQueryResult = Apollo.QueryResult<DeploymentDeployLogsQuery, DeploymentDeployLogsQueryVariables>;
export function refetchDeploymentDeployLogsQuery(variables: DeploymentDeployLogsQueryVariables) {
      return { query: DeploymentDeployLogsDocument, variables: variables }
    }
export const DeploymentLogsDocument = gql`
    query deploymentLogs($repoID: ID!, $deploymentID: ID!) {
  currentUser {
    id
    repo(id: $repoID) {
      id
      deployment(id: $deploymentID) {
        id
        logs {
          timestamp
          text
        }
        logsV2 {
          previous {
            timestamp
            text
          }
          current {
            timestamp
            text
          }
        }
        awsLinks {
          cloudwatchLogs
        }
        gcpLinks {
          cloudLogging
        }
      }
    }
  }
}
    `;

/**
 * __useDeploymentLogsQuery__
 *
 * To run a query within a React component, call `useDeploymentLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeploymentLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeploymentLogsQuery({
 *   variables: {
 *      repoID: // value for 'repoID'
 *      deploymentID: // value for 'deploymentID'
 *   },
 * });
 */
export function useDeploymentLogsQuery(baseOptions: Apollo.QueryHookOptions<DeploymentLogsQuery, DeploymentLogsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DeploymentLogsQuery, DeploymentLogsQueryVariables>(DeploymentLogsDocument, options);
      }
export function useDeploymentLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DeploymentLogsQuery, DeploymentLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DeploymentLogsQuery, DeploymentLogsQueryVariables>(DeploymentLogsDocument, options);
        }
export type DeploymentLogsQueryHookResult = ReturnType<typeof useDeploymentLogsQuery>;
export type DeploymentLogsLazyQueryHookResult = ReturnType<typeof useDeploymentLogsLazyQuery>;
export type DeploymentLogsQueryResult = Apollo.QueryResult<DeploymentLogsQuery, DeploymentLogsQueryVariables>;
export function refetchDeploymentLogsQuery(variables: DeploymentLogsQueryVariables) {
      return { query: DeploymentLogsDocument, variables: variables }
    }
export const BuildTemplatesDocument = gql`
    query buildTemplates($id: ID!) {
  currentUser {
    id
    deployment(id: $id) {
      id
      buildStage {
        id
        buildTemplates {
          type
          output
        }
      }
    }
  }
}
    `;

/**
 * __useBuildTemplatesQuery__
 *
 * To run a query within a React component, call `useBuildTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBuildTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBuildTemplatesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBuildTemplatesQuery(baseOptions: Apollo.QueryHookOptions<BuildTemplatesQuery, BuildTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BuildTemplatesQuery, BuildTemplatesQueryVariables>(BuildTemplatesDocument, options);
      }
export function useBuildTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BuildTemplatesQuery, BuildTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BuildTemplatesQuery, BuildTemplatesQueryVariables>(BuildTemplatesDocument, options);
        }
export type BuildTemplatesQueryHookResult = ReturnType<typeof useBuildTemplatesQuery>;
export type BuildTemplatesLazyQueryHookResult = ReturnType<typeof useBuildTemplatesLazyQuery>;
export type BuildTemplatesQueryResult = Apollo.QueryResult<BuildTemplatesQuery, BuildTemplatesQueryVariables>;
export function refetchBuildTemplatesQuery(variables: BuildTemplatesQueryVariables) {
      return { query: BuildTemplatesDocument, variables: variables }
    }
export const DeployTemplatesDocument = gql`
    query deployTemplates($id: ID!) {
  currentUser {
    id
    deployment(id: $id) {
      id
      deployTemplates {
        output
        type
      }
    }
  }
}
    `;

/**
 * __useDeployTemplatesQuery__
 *
 * To run a query within a React component, call `useDeployTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeployTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeployTemplatesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeployTemplatesQuery(baseOptions: Apollo.QueryHookOptions<DeployTemplatesQuery, DeployTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DeployTemplatesQuery, DeployTemplatesQueryVariables>(DeployTemplatesDocument, options);
      }
export function useDeployTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DeployTemplatesQuery, DeployTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DeployTemplatesQuery, DeployTemplatesQueryVariables>(DeployTemplatesDocument, options);
        }
export type DeployTemplatesQueryHookResult = ReturnType<typeof useDeployTemplatesQuery>;
export type DeployTemplatesLazyQueryHookResult = ReturnType<typeof useDeployTemplatesLazyQuery>;
export type DeployTemplatesQueryResult = Apollo.QueryResult<DeployTemplatesQuery, DeployTemplatesQueryVariables>;
export function refetchDeployTemplatesQuery(variables: DeployTemplatesQueryVariables) {
      return { query: DeployTemplatesDocument, variables: variables }
    }
export const BuildTemplatesExistDocument = gql`
    query buildTemplatesExist($id: ID!) {
  currentUser {
    id
    deployment(id: $id) {
      id
      buildStage {
        id
        buildTemplates {
          type
        }
      }
    }
  }
}
    `;

/**
 * __useBuildTemplatesExistQuery__
 *
 * To run a query within a React component, call `useBuildTemplatesExistQuery` and pass it any options that fit your needs.
 * When your component renders, `useBuildTemplatesExistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBuildTemplatesExistQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBuildTemplatesExistQuery(baseOptions: Apollo.QueryHookOptions<BuildTemplatesExistQuery, BuildTemplatesExistQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BuildTemplatesExistQuery, BuildTemplatesExistQueryVariables>(BuildTemplatesExistDocument, options);
      }
export function useBuildTemplatesExistLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BuildTemplatesExistQuery, BuildTemplatesExistQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BuildTemplatesExistQuery, BuildTemplatesExistQueryVariables>(BuildTemplatesExistDocument, options);
        }
export type BuildTemplatesExistQueryHookResult = ReturnType<typeof useBuildTemplatesExistQuery>;
export type BuildTemplatesExistLazyQueryHookResult = ReturnType<typeof useBuildTemplatesExistLazyQuery>;
export type BuildTemplatesExistQueryResult = Apollo.QueryResult<BuildTemplatesExistQuery, BuildTemplatesExistQueryVariables>;
export function refetchBuildTemplatesExistQuery(variables: BuildTemplatesExistQueryVariables) {
      return { query: BuildTemplatesExistDocument, variables: variables }
    }
export const DeployTemplatesExistDocument = gql`
    query deployTemplatesExist($id: ID!) {
  currentUser {
    id
    deployment(id: $id) {
      id
      deployTemplates {
        type
      }
    }
  }
}
    `;

/**
 * __useDeployTemplatesExistQuery__
 *
 * To run a query within a React component, call `useDeployTemplatesExistQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeployTemplatesExistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeployTemplatesExistQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeployTemplatesExistQuery(baseOptions: Apollo.QueryHookOptions<DeployTemplatesExistQuery, DeployTemplatesExistQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DeployTemplatesExistQuery, DeployTemplatesExistQueryVariables>(DeployTemplatesExistDocument, options);
      }
export function useDeployTemplatesExistLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DeployTemplatesExistQuery, DeployTemplatesExistQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DeployTemplatesExistQuery, DeployTemplatesExistQueryVariables>(DeployTemplatesExistDocument, options);
        }
export type DeployTemplatesExistQueryHookResult = ReturnType<typeof useDeployTemplatesExistQuery>;
export type DeployTemplatesExistLazyQueryHookResult = ReturnType<typeof useDeployTemplatesExistLazyQuery>;
export type DeployTemplatesExistQueryResult = Apollo.QueryResult<DeployTemplatesExistQuery, DeployTemplatesExistQueryVariables>;
export function refetchDeployTemplatesExistQuery(variables: DeployTemplatesExistQueryVariables) {
      return { query: DeployTemplatesExistDocument, variables: variables }
    }
export const DeploymentAlertDocument = gql`
    query deploymentAlert($deploymentId: ID!, $alertId: UUID!) {
  currentUser {
    id
    deployment(id: $deploymentId) {
      id
      alert(id: $alertId) {
        ...DeploymentAlertDetail
      }
    }
  }
}
    ${DeploymentAlertDetailFragmentDoc}`;

/**
 * __useDeploymentAlertQuery__
 *
 * To run a query within a React component, call `useDeploymentAlertQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeploymentAlertQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeploymentAlertQuery({
 *   variables: {
 *      deploymentId: // value for 'deploymentId'
 *      alertId: // value for 'alertId'
 *   },
 * });
 */
export function useDeploymentAlertQuery(baseOptions: Apollo.QueryHookOptions<DeploymentAlertQuery, DeploymentAlertQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DeploymentAlertQuery, DeploymentAlertQueryVariables>(DeploymentAlertDocument, options);
      }
export function useDeploymentAlertLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DeploymentAlertQuery, DeploymentAlertQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DeploymentAlertQuery, DeploymentAlertQueryVariables>(DeploymentAlertDocument, options);
        }
export type DeploymentAlertQueryHookResult = ReturnType<typeof useDeploymentAlertQuery>;
export type DeploymentAlertLazyQueryHookResult = ReturnType<typeof useDeploymentAlertLazyQuery>;
export type DeploymentAlertQueryResult = Apollo.QueryResult<DeploymentAlertQuery, DeploymentAlertQueryVariables>;
export function refetchDeploymentAlertQuery(variables: DeploymentAlertQueryVariables) {
      return { query: DeploymentAlertDocument, variables: variables }
    }
export const DeploymentAlertsDocument = gql`
    query deploymentAlerts($deploymentID: ID!, $page: PageInput) {
  currentUser {
    id
    deployment(id: $deploymentID) {
      id
      alerts(page: $page) {
        pageInfo {
          startCursor
          endCursor
          hasNextPage
          hasPreviousPage
        }
        nodes {
          ...DeploymentAlertDetail
        }
      }
    }
  }
}
    ${DeploymentAlertDetailFragmentDoc}`;

/**
 * __useDeploymentAlertsQuery__
 *
 * To run a query within a React component, call `useDeploymentAlertsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeploymentAlertsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeploymentAlertsQuery({
 *   variables: {
 *      deploymentID: // value for 'deploymentID'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useDeploymentAlertsQuery(baseOptions: Apollo.QueryHookOptions<DeploymentAlertsQuery, DeploymentAlertsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DeploymentAlertsQuery, DeploymentAlertsQueryVariables>(DeploymentAlertsDocument, options);
      }
export function useDeploymentAlertsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DeploymentAlertsQuery, DeploymentAlertsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DeploymentAlertsQuery, DeploymentAlertsQueryVariables>(DeploymentAlertsDocument, options);
        }
export type DeploymentAlertsQueryHookResult = ReturnType<typeof useDeploymentAlertsQuery>;
export type DeploymentAlertsLazyQueryHookResult = ReturnType<typeof useDeploymentAlertsLazyQuery>;
export type DeploymentAlertsQueryResult = Apollo.QueryResult<DeploymentAlertsQuery, DeploymentAlertsQueryVariables>;
export function refetchDeploymentAlertsQuery(variables: DeploymentAlertsQueryVariables) {
      return { query: DeploymentAlertsDocument, variables: variables }
    }
export const DockerInfoDocument = gql`
    query dockerInfo($image: String!) {
  currentUser {
    id
    dockerRepository(image: $image) {
      id
      name
      url
      ports {
        port
        protocol
        public
        https
      }
      volumes {
        mountPath
        size
      }
    }
  }
}
    `;

/**
 * __useDockerInfoQuery__
 *
 * To run a query within a React component, call `useDockerInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useDockerInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDockerInfoQuery({
 *   variables: {
 *      image: // value for 'image'
 *   },
 * });
 */
export function useDockerInfoQuery(baseOptions: Apollo.QueryHookOptions<DockerInfoQuery, DockerInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DockerInfoQuery, DockerInfoQueryVariables>(DockerInfoDocument, options);
      }
export function useDockerInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DockerInfoQuery, DockerInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DockerInfoQuery, DockerInfoQueryVariables>(DockerInfoDocument, options);
        }
export type DockerInfoQueryHookResult = ReturnType<typeof useDockerInfoQuery>;
export type DockerInfoLazyQueryHookResult = ReturnType<typeof useDockerInfoLazyQuery>;
export type DockerInfoQueryResult = Apollo.QueryResult<DockerInfoQuery, DockerInfoQueryVariables>;
export function refetchDockerInfoQuery(variables: DockerInfoQueryVariables) {
      return { query: DockerInfoDocument, variables: variables }
    }
export const LoggedOutDockerInfoDocument = gql`
    query loggedOutDockerInfo($image: String!) {
  dockerRepository(image: $image) {
    id
    name
    url
    ports {
      port
      protocol
      public
      https
    }
    volumes {
      mountPath
      size
    }
  }
}
    `;

/**
 * __useLoggedOutDockerInfoQuery__
 *
 * To run a query within a React component, call `useLoggedOutDockerInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoggedOutDockerInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoggedOutDockerInfoQuery({
 *   variables: {
 *      image: // value for 'image'
 *   },
 * });
 */
export function useLoggedOutDockerInfoQuery(baseOptions: Apollo.QueryHookOptions<LoggedOutDockerInfoQuery, LoggedOutDockerInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LoggedOutDockerInfoQuery, LoggedOutDockerInfoQueryVariables>(LoggedOutDockerInfoDocument, options);
      }
export function useLoggedOutDockerInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LoggedOutDockerInfoQuery, LoggedOutDockerInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LoggedOutDockerInfoQuery, LoggedOutDockerInfoQueryVariables>(LoggedOutDockerInfoDocument, options);
        }
export type LoggedOutDockerInfoQueryHookResult = ReturnType<typeof useLoggedOutDockerInfoQuery>;
export type LoggedOutDockerInfoLazyQueryHookResult = ReturnType<typeof useLoggedOutDockerInfoLazyQuery>;
export type LoggedOutDockerInfoQueryResult = Apollo.QueryResult<LoggedOutDockerInfoQuery, LoggedOutDockerInfoQueryVariables>;
export function refetchLoggedOutDockerInfoQuery(variables: LoggedOutDockerInfoQueryVariables) {
      return { query: LoggedOutDockerInfoDocument, variables: variables }
    }
export const DockerRepositoryPortsDocument = gql`
    query dockerRepositoryPorts($image: String!) {
  dockerRepository(image: $image) {
    id
    ports {
      port
      protocol
      public
      https
    }
  }
}
    `;

/**
 * __useDockerRepositoryPortsQuery__
 *
 * To run a query within a React component, call `useDockerRepositoryPortsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDockerRepositoryPortsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDockerRepositoryPortsQuery({
 *   variables: {
 *      image: // value for 'image'
 *   },
 * });
 */
export function useDockerRepositoryPortsQuery(baseOptions: Apollo.QueryHookOptions<DockerRepositoryPortsQuery, DockerRepositoryPortsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DockerRepositoryPortsQuery, DockerRepositoryPortsQueryVariables>(DockerRepositoryPortsDocument, options);
      }
export function useDockerRepositoryPortsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DockerRepositoryPortsQuery, DockerRepositoryPortsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DockerRepositoryPortsQuery, DockerRepositoryPortsQueryVariables>(DockerRepositoryPortsDocument, options);
        }
export type DockerRepositoryPortsQueryHookResult = ReturnType<typeof useDockerRepositoryPortsQuery>;
export type DockerRepositoryPortsLazyQueryHookResult = ReturnType<typeof useDockerRepositoryPortsLazyQuery>;
export type DockerRepositoryPortsQueryResult = Apollo.QueryResult<DockerRepositoryPortsQuery, DockerRepositoryPortsQueryVariables>;
export function refetchDockerRepositoryPortsQuery(variables: DockerRepositoryPortsQueryVariables) {
      return { query: DockerRepositoryPortsDocument, variables: variables }
    }
export const UserGithubReposDocument = gql`
    query userGithubRepos {
  currentUser {
    id
    login
    avatar
    githubInstallations {
      id
      targetType
      account {
        id
        login
        avatar
        type
      }
      repositorySelection
      repositories {
        ...GitHubRepo
      }
    }
  }
}
    ${GitHubRepoFragmentDoc}`;

/**
 * __useUserGithubReposQuery__
 *
 * To run a query within a React component, call `useUserGithubReposQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserGithubReposQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserGithubReposQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserGithubReposQuery(baseOptions?: Apollo.QueryHookOptions<UserGithubReposQuery, UserGithubReposQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserGithubReposQuery, UserGithubReposQueryVariables>(UserGithubReposDocument, options);
      }
export function useUserGithubReposLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserGithubReposQuery, UserGithubReposQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserGithubReposQuery, UserGithubReposQueryVariables>(UserGithubReposDocument, options);
        }
export type UserGithubReposQueryHookResult = ReturnType<typeof useUserGithubReposQuery>;
export type UserGithubReposLazyQueryHookResult = ReturnType<typeof useUserGithubReposLazyQuery>;
export type UserGithubReposQueryResult = Apollo.QueryResult<UserGithubReposQuery, UserGithubReposQueryVariables>;
export function refetchUserGithubReposQuery(variables?: UserGithubReposQueryVariables) {
      return { query: UserGithubReposDocument, variables: variables }
    }
export const TeamGithubReposDocument = gql`
    query teamGithubRepos($path: String!) {
  team(path: $path) {
    id
    user {
      id
      githubInstallations {
        id
        targetType
        account {
          id
          login
          avatar
          type
        }
        repositorySelection
        repositories {
          ...GitHubRepo
        }
      }
    }
  }
}
    ${GitHubRepoFragmentDoc}`;

/**
 * __useTeamGithubReposQuery__
 *
 * To run a query within a React component, call `useTeamGithubReposQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamGithubReposQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamGithubReposQuery({
 *   variables: {
 *      path: // value for 'path'
 *   },
 * });
 */
export function useTeamGithubReposQuery(baseOptions: Apollo.QueryHookOptions<TeamGithubReposQuery, TeamGithubReposQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeamGithubReposQuery, TeamGithubReposQueryVariables>(TeamGithubReposDocument, options);
      }
export function useTeamGithubReposLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeamGithubReposQuery, TeamGithubReposQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeamGithubReposQuery, TeamGithubReposQueryVariables>(TeamGithubReposDocument, options);
        }
export type TeamGithubReposQueryHookResult = ReturnType<typeof useTeamGithubReposQuery>;
export type TeamGithubReposLazyQueryHookResult = ReturnType<typeof useTeamGithubReposLazyQuery>;
export type TeamGithubReposQueryResult = Apollo.QueryResult<TeamGithubReposQuery, TeamGithubReposQueryVariables>;
export function refetchTeamGithubReposQuery(variables: TeamGithubReposQueryVariables) {
      return { query: TeamGithubReposDocument, variables: variables }
    }
export const UserGithubOrgsDocument = gql`
    query userGithubOrgs {
  currentUser {
    id
    githubInstallations {
      id
      account {
        id
        login
        avatar
        type
      }
    }
  }
}
    `;

/**
 * __useUserGithubOrgsQuery__
 *
 * To run a query within a React component, call `useUserGithubOrgsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserGithubOrgsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserGithubOrgsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserGithubOrgsQuery(baseOptions?: Apollo.QueryHookOptions<UserGithubOrgsQuery, UserGithubOrgsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserGithubOrgsQuery, UserGithubOrgsQueryVariables>(UserGithubOrgsDocument, options);
      }
export function useUserGithubOrgsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserGithubOrgsQuery, UserGithubOrgsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserGithubOrgsQuery, UserGithubOrgsQueryVariables>(UserGithubOrgsDocument, options);
        }
export type UserGithubOrgsQueryHookResult = ReturnType<typeof useUserGithubOrgsQuery>;
export type UserGithubOrgsLazyQueryHookResult = ReturnType<typeof useUserGithubOrgsLazyQuery>;
export type UserGithubOrgsQueryResult = Apollo.QueryResult<UserGithubOrgsQuery, UserGithubOrgsQueryVariables>;
export function refetchUserGithubOrgsQuery(variables?: UserGithubOrgsQueryVariables) {
      return { query: UserGithubOrgsDocument, variables: variables }
    }
export const UserGithubRepoDocument = gql`
    query userGithubRepo($installationId: ID!, $owner: String!, $repo: String!) {
  currentUser {
    id
    githubRepository(installationID: $installationId, owner: $owner, repo: $repo) {
      id
      ...GitHubRepo
      ...GithubDetail
    }
  }
}
    ${GitHubRepoFragmentDoc}
${GithubDetailFragmentDoc}`;

/**
 * __useUserGithubRepoQuery__
 *
 * To run a query within a React component, call `useUserGithubRepoQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserGithubRepoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserGithubRepoQuery({
 *   variables: {
 *      installationId: // value for 'installationId'
 *      owner: // value for 'owner'
 *      repo: // value for 'repo'
 *   },
 * });
 */
export function useUserGithubRepoQuery(baseOptions: Apollo.QueryHookOptions<UserGithubRepoQuery, UserGithubRepoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserGithubRepoQuery, UserGithubRepoQueryVariables>(UserGithubRepoDocument, options);
      }
export function useUserGithubRepoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserGithubRepoQuery, UserGithubRepoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserGithubRepoQuery, UserGithubRepoQueryVariables>(UserGithubRepoDocument, options);
        }
export type UserGithubRepoQueryHookResult = ReturnType<typeof useUserGithubRepoQuery>;
export type UserGithubRepoLazyQueryHookResult = ReturnType<typeof useUserGithubRepoLazyQuery>;
export type UserGithubRepoQueryResult = Apollo.QueryResult<UserGithubRepoQuery, UserGithubRepoQueryVariables>;
export function refetchUserGithubRepoQuery(variables: UserGithubRepoQueryVariables) {
      return { query: UserGithubRepoDocument, variables: variables }
    }
export const RepoBuildSuggestionDocument = gql`
    query repoBuildSuggestion($id: ID!) {
  currentUser {
    id
    repo(id: $id) {
      id
      buildMethodSuggestions {
        name
        type
        dockerfilePath
        buildCommand
        staticPath
        runCommand
      }
    }
  }
}
    `;

/**
 * __useRepoBuildSuggestionQuery__
 *
 * To run a query within a React component, call `useRepoBuildSuggestionQuery` and pass it any options that fit your needs.
 * When your component renders, `useRepoBuildSuggestionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRepoBuildSuggestionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRepoBuildSuggestionQuery(baseOptions: Apollo.QueryHookOptions<RepoBuildSuggestionQuery, RepoBuildSuggestionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RepoBuildSuggestionQuery, RepoBuildSuggestionQueryVariables>(RepoBuildSuggestionDocument, options);
      }
export function useRepoBuildSuggestionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RepoBuildSuggestionQuery, RepoBuildSuggestionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RepoBuildSuggestionQuery, RepoBuildSuggestionQueryVariables>(RepoBuildSuggestionDocument, options);
        }
export type RepoBuildSuggestionQueryHookResult = ReturnType<typeof useRepoBuildSuggestionQuery>;
export type RepoBuildSuggestionLazyQueryHookResult = ReturnType<typeof useRepoBuildSuggestionLazyQuery>;
export type RepoBuildSuggestionQueryResult = Apollo.QueryResult<RepoBuildSuggestionQuery, RepoBuildSuggestionQueryVariables>;
export function refetchRepoBuildSuggestionQuery(variables: RepoBuildSuggestionQueryVariables) {
      return { query: RepoBuildSuggestionDocument, variables: variables }
    }
export const GithubRepoPortDocument = gql`
    query githubRepoPort($installationId: ID!, $owner: String!, $repo: String!) {
  currentUser {
    id
    githubRepository(installationID: $installationId, owner: $owner, repo: $repo) {
      id
      ports {
        https
        port
        protocol
        public
      }
    }
  }
}
    `;

/**
 * __useGithubRepoPortQuery__
 *
 * To run a query within a React component, call `useGithubRepoPortQuery` and pass it any options that fit your needs.
 * When your component renders, `useGithubRepoPortQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGithubRepoPortQuery({
 *   variables: {
 *      installationId: // value for 'installationId'
 *      owner: // value for 'owner'
 *      repo: // value for 'repo'
 *   },
 * });
 */
export function useGithubRepoPortQuery(baseOptions: Apollo.QueryHookOptions<GithubRepoPortQuery, GithubRepoPortQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GithubRepoPortQuery, GithubRepoPortQueryVariables>(GithubRepoPortDocument, options);
      }
export function useGithubRepoPortLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GithubRepoPortQuery, GithubRepoPortQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GithubRepoPortQuery, GithubRepoPortQueryVariables>(GithubRepoPortDocument, options);
        }
export type GithubRepoPortQueryHookResult = ReturnType<typeof useGithubRepoPortQuery>;
export type GithubRepoPortLazyQueryHookResult = ReturnType<typeof useGithubRepoPortLazyQuery>;
export type GithubRepoPortQueryResult = Apollo.QueryResult<GithubRepoPortQuery, GithubRepoPortQueryVariables>;
export function refetchGithubRepoPortQuery(variables: GithubRepoPortQueryVariables) {
      return { query: GithubRepoPortDocument, variables: variables }
    }
export const UserGithubRepoServerlessDocument = gql`
    query userGithubRepoServerless($installationId: ID!, $owner: String!, $repo: String!) {
  currentUser {
    id
    githubRepository(installationID: $installationId, owner: $owner, repo: $repo) {
      id
      ...GitHubRepo
      ...GithubDetail
      serverless {
        service
        provider {
          name
          region
          runtime
          stackName
          stage
        }
        functions {
          name
          handler
        }
      }
    }
  }
}
    ${GitHubRepoFragmentDoc}
${GithubDetailFragmentDoc}`;

/**
 * __useUserGithubRepoServerlessQuery__
 *
 * To run a query within a React component, call `useUserGithubRepoServerlessQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserGithubRepoServerlessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserGithubRepoServerlessQuery({
 *   variables: {
 *      installationId: // value for 'installationId'
 *      owner: // value for 'owner'
 *      repo: // value for 'repo'
 *   },
 * });
 */
export function useUserGithubRepoServerlessQuery(baseOptions: Apollo.QueryHookOptions<UserGithubRepoServerlessQuery, UserGithubRepoServerlessQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserGithubRepoServerlessQuery, UserGithubRepoServerlessQueryVariables>(UserGithubRepoServerlessDocument, options);
      }
export function useUserGithubRepoServerlessLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserGithubRepoServerlessQuery, UserGithubRepoServerlessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserGithubRepoServerlessQuery, UserGithubRepoServerlessQueryVariables>(UserGithubRepoServerlessDocument, options);
        }
export type UserGithubRepoServerlessQueryHookResult = ReturnType<typeof useUserGithubRepoServerlessQuery>;
export type UserGithubRepoServerlessLazyQueryHookResult = ReturnType<typeof useUserGithubRepoServerlessLazyQuery>;
export type UserGithubRepoServerlessQueryResult = Apollo.QueryResult<UserGithubRepoServerlessQuery, UserGithubRepoServerlessQueryVariables>;
export function refetchUserGithubRepoServerlessQuery(variables: UserGithubRepoServerlessQueryVariables) {
      return { query: UserGithubRepoServerlessDocument, variables: variables }
    }
export const HelmChartDocument = gql`
    query helmChart($url: String!, $name: String!) {
  helmRepository(url: $url) {
    id
    chart(name: $name) {
      id
      ...HelmCommon
    }
  }
}
    ${HelmCommonFragmentDoc}`;

/**
 * __useHelmChartQuery__
 *
 * To run a query within a React component, call `useHelmChartQuery` and pass it any options that fit your needs.
 * When your component renders, `useHelmChartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHelmChartQuery({
 *   variables: {
 *      url: // value for 'url'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useHelmChartQuery(baseOptions: Apollo.QueryHookOptions<HelmChartQuery, HelmChartQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HelmChartQuery, HelmChartQueryVariables>(HelmChartDocument, options);
      }
export function useHelmChartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HelmChartQuery, HelmChartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HelmChartQuery, HelmChartQueryVariables>(HelmChartDocument, options);
        }
export type HelmChartQueryHookResult = ReturnType<typeof useHelmChartQuery>;
export type HelmChartLazyQueryHookResult = ReturnType<typeof useHelmChartLazyQuery>;
export type HelmChartQueryResult = Apollo.QueryResult<HelmChartQuery, HelmChartQueryVariables>;
export function refetchHelmChartQuery(variables: HelmChartQueryVariables) {
      return { query: HelmChartDocument, variables: variables }
    }
export const ProjectHelmChartDocument = gql`
    query projectHelmChart($id: ID!) {
  currentUser {
    id
    repo(id: $id) {
      id
      helmChart {
        id
        ...HelmCommon
      }
    }
  }
}
    ${HelmCommonFragmentDoc}`;

/**
 * __useProjectHelmChartQuery__
 *
 * To run a query within a React component, call `useProjectHelmChartQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectHelmChartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectHelmChartQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProjectHelmChartQuery(baseOptions: Apollo.QueryHookOptions<ProjectHelmChartQuery, ProjectHelmChartQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectHelmChartQuery, ProjectHelmChartQueryVariables>(ProjectHelmChartDocument, options);
      }
export function useProjectHelmChartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectHelmChartQuery, ProjectHelmChartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectHelmChartQuery, ProjectHelmChartQueryVariables>(ProjectHelmChartDocument, options);
        }
export type ProjectHelmChartQueryHookResult = ReturnType<typeof useProjectHelmChartQuery>;
export type ProjectHelmChartLazyQueryHookResult = ReturnType<typeof useProjectHelmChartLazyQuery>;
export type ProjectHelmChartQueryResult = Apollo.QueryResult<ProjectHelmChartQuery, ProjectHelmChartQueryVariables>;
export function refetchProjectHelmChartQuery(variables: ProjectHelmChartQueryVariables) {
      return { query: ProjectHelmChartDocument, variables: variables }
    }
export const SearchHelmChartsDocument = gql`
    query searchHelmCharts($input: SearchHelmChartsInput!) {
  searchHelmCharts(input: $input) {
    totalCount
    nodes {
      id
      ...HelmCommon
    }
    pageInfo {
      hasNextPage
    }
  }
}
    ${HelmCommonFragmentDoc}`;

/**
 * __useSearchHelmChartsQuery__
 *
 * To run a query within a React component, call `useSearchHelmChartsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchHelmChartsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchHelmChartsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSearchHelmChartsQuery(baseOptions: Apollo.QueryHookOptions<SearchHelmChartsQuery, SearchHelmChartsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchHelmChartsQuery, SearchHelmChartsQueryVariables>(SearchHelmChartsDocument, options);
      }
export function useSearchHelmChartsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchHelmChartsQuery, SearchHelmChartsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchHelmChartsQuery, SearchHelmChartsQueryVariables>(SearchHelmChartsDocument, options);
        }
export type SearchHelmChartsQueryHookResult = ReturnType<typeof useSearchHelmChartsQuery>;
export type SearchHelmChartsLazyQueryHookResult = ReturnType<typeof useSearchHelmChartsLazyQuery>;
export type SearchHelmChartsQueryResult = Apollo.QueryResult<SearchHelmChartsQuery, SearchHelmChartsQueryVariables>;
export function refetchSearchHelmChartsQuery(variables: SearchHelmChartsQueryVariables) {
      return { query: SearchHelmChartsDocument, variables: variables }
    }
export const InsightsAlertsMetricDocument = gql`
    query insightsAlertsMetric($teamId: ID!) {
  user(id: $teamId) {
    id
    projectV3Adapters(filter: {filter: {}}) {
      nodes {
        id
        name
        project {
          id
          name
        }
        projectEnvironment {
          id
          name
        }
        repo {
          id
          name
          source {
            id
            type
          }
          image
          productionDeployment {
            id
            alerts(page: {first: 1}) {
              nodes {
                ...DeploymentAlertDetail
              }
            }
          }
        }
        updatedAt
      }
    }
    integrations {
      id
      type
    }
  }
}
    ${DeploymentAlertDetailFragmentDoc}`;

/**
 * __useInsightsAlertsMetricQuery__
 *
 * To run a query within a React component, call `useInsightsAlertsMetricQuery` and pass it any options that fit your needs.
 * When your component renders, `useInsightsAlertsMetricQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInsightsAlertsMetricQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useInsightsAlertsMetricQuery(baseOptions: Apollo.QueryHookOptions<InsightsAlertsMetricQuery, InsightsAlertsMetricQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InsightsAlertsMetricQuery, InsightsAlertsMetricQueryVariables>(InsightsAlertsMetricDocument, options);
      }
export function useInsightsAlertsMetricLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InsightsAlertsMetricQuery, InsightsAlertsMetricQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InsightsAlertsMetricQuery, InsightsAlertsMetricQueryVariables>(InsightsAlertsMetricDocument, options);
        }
export type InsightsAlertsMetricQueryHookResult = ReturnType<typeof useInsightsAlertsMetricQuery>;
export type InsightsAlertsMetricLazyQueryHookResult = ReturnType<typeof useInsightsAlertsMetricLazyQuery>;
export type InsightsAlertsMetricQueryResult = Apollo.QueryResult<InsightsAlertsMetricQuery, InsightsAlertsMetricQueryVariables>;
export function refetchInsightsAlertsMetricQuery(variables: InsightsAlertsMetricQueryVariables) {
      return { query: InsightsAlertsMetricDocument, variables: variables }
    }
export const InsightsClustersDocument = gql`
    query insightsClusters($teamId: ID!) {
  user(id: $teamId) {
    id
    clusters {
      ...InsightCluster
    }
  }
}
    ${InsightClusterFragmentDoc}`;

/**
 * __useInsightsClustersQuery__
 *
 * To run a query within a React component, call `useInsightsClustersQuery` and pass it any options that fit your needs.
 * When your component renders, `useInsightsClustersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInsightsClustersQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useInsightsClustersQuery(baseOptions: Apollo.QueryHookOptions<InsightsClustersQuery, InsightsClustersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InsightsClustersQuery, InsightsClustersQueryVariables>(InsightsClustersDocument, options);
      }
export function useInsightsClustersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InsightsClustersQuery, InsightsClustersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InsightsClustersQuery, InsightsClustersQueryVariables>(InsightsClustersDocument, options);
        }
export type InsightsClustersQueryHookResult = ReturnType<typeof useInsightsClustersQuery>;
export type InsightsClustersLazyQueryHookResult = ReturnType<typeof useInsightsClustersLazyQuery>;
export type InsightsClustersQueryResult = Apollo.QueryResult<InsightsClustersQuery, InsightsClustersQueryVariables>;
export function refetchInsightsClustersQuery(variables: InsightsClustersQueryVariables) {
      return { query: InsightsClustersDocument, variables: variables }
    }
export const InsightsCloudsDocument = gql`
    query insightsClouds($teamId: ID!) {
  user(id: $teamId) {
    id
    awsAccounts {
      id
      name
      state
      connected
    }
    doAccounts {
      id
      name
      state
      connected
    }
    gcpAccounts {
      id
      name
      state
      connected
    }
    linodeAccounts {
      id
      name
      state
      connected
    }
    coreweaveAccounts {
      id
      name
      state
      connected
    }
    vultrAccounts {
      id
      name
      state
      connected
    }
    azureAccounts {
      id
      name
      state
      connected
    }
  }
}
    `;

/**
 * __useInsightsCloudsQuery__
 *
 * To run a query within a React component, call `useInsightsCloudsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInsightsCloudsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInsightsCloudsQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useInsightsCloudsQuery(baseOptions: Apollo.QueryHookOptions<InsightsCloudsQuery, InsightsCloudsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InsightsCloudsQuery, InsightsCloudsQueryVariables>(InsightsCloudsDocument, options);
      }
export function useInsightsCloudsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InsightsCloudsQuery, InsightsCloudsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InsightsCloudsQuery, InsightsCloudsQueryVariables>(InsightsCloudsDocument, options);
        }
export type InsightsCloudsQueryHookResult = ReturnType<typeof useInsightsCloudsQuery>;
export type InsightsCloudsLazyQueryHookResult = ReturnType<typeof useInsightsCloudsLazyQuery>;
export type InsightsCloudsQueryResult = Apollo.QueryResult<InsightsCloudsQuery, InsightsCloudsQueryVariables>;
export function refetchInsightsCloudsQuery(variables: InsightsCloudsQueryVariables) {
      return { query: InsightsCloudsDocument, variables: variables }
    }
export const UserIntegrationsDocument = gql`
    query userIntegrations($id: ID!) {
  user(id: $id) {
    id
    integrations {
      id
      ...IntegrationDetail
    }
    notificationIntegrationSettings {
      build
      deploy
      podCrash
    }
  }
}
    ${IntegrationDetailFragmentDoc}`;

/**
 * __useUserIntegrationsQuery__
 *
 * To run a query within a React component, call `useUserIntegrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserIntegrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserIntegrationsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserIntegrationsQuery(baseOptions: Apollo.QueryHookOptions<UserIntegrationsQuery, UserIntegrationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserIntegrationsQuery, UserIntegrationsQueryVariables>(UserIntegrationsDocument, options);
      }
export function useUserIntegrationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserIntegrationsQuery, UserIntegrationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserIntegrationsQuery, UserIntegrationsQueryVariables>(UserIntegrationsDocument, options);
        }
export type UserIntegrationsQueryHookResult = ReturnType<typeof useUserIntegrationsQuery>;
export type UserIntegrationsLazyQueryHookResult = ReturnType<typeof useUserIntegrationsLazyQuery>;
export type UserIntegrationsQueryResult = Apollo.QueryResult<UserIntegrationsQuery, UserIntegrationsQueryVariables>;
export function refetchUserIntegrationsQuery(variables: UserIntegrationsQueryVariables) {
      return { query: UserIntegrationsDocument, variables: variables }
    }
export const IpfsServicesDocument = gql`
    query IpfsServices($id: ID!) {
  user(id: $id) {
    id
    ipfsServices {
      id
      ...IpfSServicesFragment
    }
  }
}
    ${IpfSServicesFragmentFragmentDoc}`;

/**
 * __useIpfsServicesQuery__
 *
 * To run a query within a React component, call `useIpfsServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useIpfsServicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIpfsServicesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useIpfsServicesQuery(baseOptions: Apollo.QueryHookOptions<IpfsServicesQuery, IpfsServicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IpfsServicesQuery, IpfsServicesQueryVariables>(IpfsServicesDocument, options);
      }
export function useIpfsServicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IpfsServicesQuery, IpfsServicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IpfsServicesQuery, IpfsServicesQueryVariables>(IpfsServicesDocument, options);
        }
export type IpfsServicesQueryHookResult = ReturnType<typeof useIpfsServicesQuery>;
export type IpfsServicesLazyQueryHookResult = ReturnType<typeof useIpfsServicesLazyQuery>;
export type IpfsServicesQueryResult = Apollo.QueryResult<IpfsServicesQuery, IpfsServicesQueryVariables>;
export function refetchIpfsServicesQuery(variables: IpfsServicesQueryVariables) {
      return { query: IpfsServicesDocument, variables: variables }
    }
export const ProjectJobsDocument = gql`
    query projectJobs($id: ID!) {
  currentUser {
    id
    repo(id: $id) {
      id
      jobRuns {
        totalCount
        nodes {
          id
          ...JobCommon
        }
      }
    }
  }
}
    ${JobCommonFragmentDoc}`;

/**
 * __useProjectJobsQuery__
 *
 * To run a query within a React component, call `useProjectJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectJobsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProjectJobsQuery(baseOptions: Apollo.QueryHookOptions<ProjectJobsQuery, ProjectJobsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectJobsQuery, ProjectJobsQueryVariables>(ProjectJobsDocument, options);
      }
export function useProjectJobsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectJobsQuery, ProjectJobsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectJobsQuery, ProjectJobsQueryVariables>(ProjectJobsDocument, options);
        }
export type ProjectJobsQueryHookResult = ReturnType<typeof useProjectJobsQuery>;
export type ProjectJobsLazyQueryHookResult = ReturnType<typeof useProjectJobsLazyQuery>;
export type ProjectJobsQueryResult = Apollo.QueryResult<ProjectJobsQuery, ProjectJobsQueryVariables>;
export function refetchProjectJobsQuery(variables: ProjectJobsQueryVariables) {
      return { query: ProjectJobsDocument, variables: variables }
    }
export const ProjectJobDocument = gql`
    query projectJob($repoID: ID!, $jobID: UUID!) {
  currentUser {
    id
    repo(id: $repoID) {
      id
      jobRun(id: $jobID) {
        id
        deployment {
          id
          branch
        }
        ...JobCommon
        logs {
          id
          completed
          expired
          entries {
            timestamp
            text
          }
        }
      }
    }
  }
}
    ${JobCommonFragmentDoc}`;

/**
 * __useProjectJobQuery__
 *
 * To run a query within a React component, call `useProjectJobQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectJobQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectJobQuery({
 *   variables: {
 *      repoID: // value for 'repoID'
 *      jobID: // value for 'jobID'
 *   },
 * });
 */
export function useProjectJobQuery(baseOptions: Apollo.QueryHookOptions<ProjectJobQuery, ProjectJobQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectJobQuery, ProjectJobQueryVariables>(ProjectJobDocument, options);
      }
export function useProjectJobLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectJobQuery, ProjectJobQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectJobQuery, ProjectJobQueryVariables>(ProjectJobDocument, options);
        }
export type ProjectJobQueryHookResult = ReturnType<typeof useProjectJobQuery>;
export type ProjectJobLazyQueryHookResult = ReturnType<typeof useProjectJobLazyQuery>;
export type ProjectJobQueryResult = Apollo.QueryResult<ProjectJobQuery, ProjectJobQueryVariables>;
export function refetchProjectJobQuery(variables: ProjectJobQueryVariables) {
      return { query: ProjectJobDocument, variables: variables }
    }
export const UserJobDocument = gql`
    query userJob($jobID: UUID!) {
  currentUser {
    id
    jobRun(id: $jobID) {
      id
      ...JobCommon
      logs {
        id
        completed
        expired
        entries {
          timestamp
          text
        }
      }
    }
  }
}
    ${JobCommonFragmentDoc}`;

/**
 * __useUserJobQuery__
 *
 * To run a query within a React component, call `useUserJobQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserJobQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserJobQuery({
 *   variables: {
 *      jobID: // value for 'jobID'
 *   },
 * });
 */
export function useUserJobQuery(baseOptions: Apollo.QueryHookOptions<UserJobQuery, UserJobQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserJobQuery, UserJobQueryVariables>(UserJobDocument, options);
      }
export function useUserJobLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserJobQuery, UserJobQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserJobQuery, UserJobQueryVariables>(UserJobDocument, options);
        }
export type UserJobQueryHookResult = ReturnType<typeof useUserJobQuery>;
export type UserJobLazyQueryHookResult = ReturnType<typeof useUserJobLazyQuery>;
export type UserJobQueryResult = Apollo.QueryResult<UserJobQuery, UserJobQueryVariables>;
export function refetchUserJobQuery(variables: UserJobQueryVariables) {
      return { query: UserJobDocument, variables: variables }
    }
export const DeploymentMetricsDocument = gql`
    query deploymentMetrics($repoID: ID!, $deploymentID: ID!, $name: String!) {
  currentUser {
    id
    repo(id: $repoID) {
      id
      deployment(id: $deploymentID) {
        id
        metrics(name: $name) {
          timestamp
          value
        }
      }
    }
  }
}
    `;

/**
 * __useDeploymentMetricsQuery__
 *
 * To run a query within a React component, call `useDeploymentMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeploymentMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeploymentMetricsQuery({
 *   variables: {
 *      repoID: // value for 'repoID'
 *      deploymentID: // value for 'deploymentID'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useDeploymentMetricsQuery(baseOptions: Apollo.QueryHookOptions<DeploymentMetricsQuery, DeploymentMetricsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DeploymentMetricsQuery, DeploymentMetricsQueryVariables>(DeploymentMetricsDocument, options);
      }
export function useDeploymentMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DeploymentMetricsQuery, DeploymentMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DeploymentMetricsQuery, DeploymentMetricsQueryVariables>(DeploymentMetricsDocument, options);
        }
export type DeploymentMetricsQueryHookResult = ReturnType<typeof useDeploymentMetricsQuery>;
export type DeploymentMetricsLazyQueryHookResult = ReturnType<typeof useDeploymentMetricsLazyQuery>;
export type DeploymentMetricsQueryResult = Apollo.QueryResult<DeploymentMetricsQuery, DeploymentMetricsQueryVariables>;
export function refetchDeploymentMetricsQuery(variables: DeploymentMetricsQueryVariables) {
      return { query: DeploymentMetricsDocument, variables: variables }
    }
export const CombinedDeploymentMetricsDocument = gql`
    query combinedDeploymentMetrics($repoID: ID!, $deploymentID: ID!) {
  currentUser {
    id
    repo(id: $repoID) {
      id
      deployment(id: $deploymentID) {
        id
        cpuMetrics: metrics(name: "cpu") {
          timestamp
          value
        }
        memoryMetrics: metrics(name: "memory") {
          timestamp
          value
        }
        networkMetrics: metrics(name: "network_out") {
          timestamp
          value
        }
        diskMetrics: metrics(name: "disk_usage") {
          timestamp
          value
        }
      }
    }
  }
}
    `;

/**
 * __useCombinedDeploymentMetricsQuery__
 *
 * To run a query within a React component, call `useCombinedDeploymentMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCombinedDeploymentMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCombinedDeploymentMetricsQuery({
 *   variables: {
 *      repoID: // value for 'repoID'
 *      deploymentID: // value for 'deploymentID'
 *   },
 * });
 */
export function useCombinedDeploymentMetricsQuery(baseOptions: Apollo.QueryHookOptions<CombinedDeploymentMetricsQuery, CombinedDeploymentMetricsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CombinedDeploymentMetricsQuery, CombinedDeploymentMetricsQueryVariables>(CombinedDeploymentMetricsDocument, options);
      }
export function useCombinedDeploymentMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CombinedDeploymentMetricsQuery, CombinedDeploymentMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CombinedDeploymentMetricsQuery, CombinedDeploymentMetricsQueryVariables>(CombinedDeploymentMetricsDocument, options);
        }
export type CombinedDeploymentMetricsQueryHookResult = ReturnType<typeof useCombinedDeploymentMetricsQuery>;
export type CombinedDeploymentMetricsLazyQueryHookResult = ReturnType<typeof useCombinedDeploymentMetricsLazyQuery>;
export type CombinedDeploymentMetricsQueryResult = Apollo.QueryResult<CombinedDeploymentMetricsQuery, CombinedDeploymentMetricsQueryVariables>;
export function refetchCombinedDeploymentMetricsQuery(variables: CombinedDeploymentMetricsQueryVariables) {
      return { query: CombinedDeploymentMetricsDocument, variables: variables }
    }
export const RepoNetworkDocument = gql`
    query repoNetwork($id: UUID!) {
  repo(id: $id) {
    id
    ...RepoNetwork
  }
}
    ${RepoNetworkFragmentDoc}`;

/**
 * __useRepoNetworkQuery__
 *
 * To run a query within a React component, call `useRepoNetworkQuery` and pass it any options that fit your needs.
 * When your component renders, `useRepoNetworkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRepoNetworkQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRepoNetworkQuery(baseOptions: Apollo.QueryHookOptions<RepoNetworkQuery, RepoNetworkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RepoNetworkQuery, RepoNetworkQueryVariables>(RepoNetworkDocument, options);
      }
export function useRepoNetworkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RepoNetworkQuery, RepoNetworkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RepoNetworkQuery, RepoNetworkQueryVariables>(RepoNetworkDocument, options);
        }
export type RepoNetworkQueryHookResult = ReturnType<typeof useRepoNetworkQuery>;
export type RepoNetworkLazyQueryHookResult = ReturnType<typeof useRepoNetworkLazyQuery>;
export type RepoNetworkQueryResult = Apollo.QueryResult<RepoNetworkQuery, RepoNetworkQueryVariables>;
export function refetchRepoNetworkQuery(variables: RepoNetworkQueryVariables) {
      return { query: RepoNetworkDocument, variables: variables }
    }
export const SuggestProjectNameDocument = gql`
    query suggestProjectName($user: ID!, $input: SuggestProjectNameInput!) {
  user(id: $user) {
    id
    suggestProjectName(input: $input)
  }
}
    `;

/**
 * __useSuggestProjectNameQuery__
 *
 * To run a query within a React component, call `useSuggestProjectNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuggestProjectNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuggestProjectNameQuery({
 *   variables: {
 *      user: // value for 'user'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSuggestProjectNameQuery(baseOptions: Apollo.QueryHookOptions<SuggestProjectNameQuery, SuggestProjectNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SuggestProjectNameQuery, SuggestProjectNameQueryVariables>(SuggestProjectNameDocument, options);
      }
export function useSuggestProjectNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SuggestProjectNameQuery, SuggestProjectNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SuggestProjectNameQuery, SuggestProjectNameQueryVariables>(SuggestProjectNameDocument, options);
        }
export type SuggestProjectNameQueryHookResult = ReturnType<typeof useSuggestProjectNameQuery>;
export type SuggestProjectNameLazyQueryHookResult = ReturnType<typeof useSuggestProjectNameLazyQuery>;
export type SuggestProjectNameQueryResult = Apollo.QueryResult<SuggestProjectNameQuery, SuggestProjectNameQueryVariables>;
export function refetchSuggestProjectNameQuery(variables: SuggestProjectNameQueryVariables) {
      return { query: SuggestProjectNameDocument, variables: variables }
    }
export const CheckProjectNameDocument = gql`
    query checkProjectName($user: ID!, $input: CheckProjectNameInput!) {
  user(id: $user) {
    id
    checkProjectName(input: $input)
  }
}
    `;

/**
 * __useCheckProjectNameQuery__
 *
 * To run a query within a React component, call `useCheckProjectNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckProjectNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckProjectNameQuery({
 *   variables: {
 *      user: // value for 'user'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCheckProjectNameQuery(baseOptions: Apollo.QueryHookOptions<CheckProjectNameQuery, CheckProjectNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckProjectNameQuery, CheckProjectNameQueryVariables>(CheckProjectNameDocument, options);
      }
export function useCheckProjectNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckProjectNameQuery, CheckProjectNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckProjectNameQuery, CheckProjectNameQueryVariables>(CheckProjectNameDocument, options);
        }
export type CheckProjectNameQueryHookResult = ReturnType<typeof useCheckProjectNameQuery>;
export type CheckProjectNameLazyQueryHookResult = ReturnType<typeof useCheckProjectNameLazyQuery>;
export type CheckProjectNameQueryResult = Apollo.QueryResult<CheckProjectNameQuery, CheckProjectNameQueryVariables>;
export function refetchCheckProjectNameQuery(variables: CheckProjectNameQueryVariables) {
      return { query: CheckProjectNameDocument, variables: variables }
    }
export const UserPaymentDocument = gql`
    query userPayment($id: ID!) {
  user(id: $id) {
    id
    hasPaymentMethod
    needsPaymentMethod
    freeQuota
    paymentError
  }
}
    `;

/**
 * __useUserPaymentQuery__
 *
 * To run a query within a React component, call `useUserPaymentQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserPaymentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserPaymentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserPaymentQuery(baseOptions: Apollo.QueryHookOptions<UserPaymentQuery, UserPaymentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserPaymentQuery, UserPaymentQueryVariables>(UserPaymentDocument, options);
      }
export function useUserPaymentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserPaymentQuery, UserPaymentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserPaymentQuery, UserPaymentQueryVariables>(UserPaymentDocument, options);
        }
export type UserPaymentQueryHookResult = ReturnType<typeof useUserPaymentQuery>;
export type UserPaymentLazyQueryHookResult = ReturnType<typeof useUserPaymentLazyQuery>;
export type UserPaymentQueryResult = Apollo.QueryResult<UserPaymentQuery, UserPaymentQueryVariables>;
export function refetchUserPaymentQuery(variables: UserPaymentQueryVariables) {
      return { query: UserPaymentDocument, variables: variables }
    }
export const GetPriceTotalDocument = gql`
    query getPriceTotal($input: CheckPriceInput!) {
  checkPrice(input: $input) {
    total {
      explanation
      cost
    }
    subTotal {
      explanation
      cost
    }
  }
}
    `;

/**
 * __useGetPriceTotalQuery__
 *
 * To run a query within a React component, call `useGetPriceTotalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPriceTotalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPriceTotalQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetPriceTotalQuery(baseOptions: Apollo.QueryHookOptions<GetPriceTotalQuery, GetPriceTotalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPriceTotalQuery, GetPriceTotalQueryVariables>(GetPriceTotalDocument, options);
      }
export function useGetPriceTotalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPriceTotalQuery, GetPriceTotalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPriceTotalQuery, GetPriceTotalQueryVariables>(GetPriceTotalDocument, options);
        }
export type GetPriceTotalQueryHookResult = ReturnType<typeof useGetPriceTotalQuery>;
export type GetPriceTotalLazyQueryHookResult = ReturnType<typeof useGetPriceTotalLazyQuery>;
export type GetPriceTotalQueryResult = Apollo.QueryResult<GetPriceTotalQuery, GetPriceTotalQueryVariables>;
export function refetchGetPriceTotalQuery(variables: GetPriceTotalQueryVariables) {
      return { query: GetPriceTotalDocument, variables: variables }
    }
export const UnitPriceDocument = gql`
    query unitPrice {
  prices {
    ramGB
    cpuCore
    dedicatedGPU
    dedicatedRamGB
    dedicatedCpuCore
    storageGB
  }
}
    `;

/**
 * __useUnitPriceQuery__
 *
 * To run a query within a React component, call `useUnitPriceQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnitPriceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnitPriceQuery({
 *   variables: {
 *   },
 * });
 */
export function useUnitPriceQuery(baseOptions?: Apollo.QueryHookOptions<UnitPriceQuery, UnitPriceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UnitPriceQuery, UnitPriceQueryVariables>(UnitPriceDocument, options);
      }
export function useUnitPriceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UnitPriceQuery, UnitPriceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UnitPriceQuery, UnitPriceQueryVariables>(UnitPriceDocument, options);
        }
export type UnitPriceQueryHookResult = ReturnType<typeof useUnitPriceQuery>;
export type UnitPriceLazyQueryHookResult = ReturnType<typeof useUnitPriceLazyQuery>;
export type UnitPriceQueryResult = Apollo.QueryResult<UnitPriceQuery, UnitPriceQueryVariables>;
export function refetchUnitPriceQuery(variables?: UnitPriceQueryVariables) {
      return { query: UnitPriceDocument, variables: variables }
    }
export const FreeTierEligibleDocument = gql`
    query freeTierEligible($input: CheckPriceInput!) {
  checkPrice(input: $input) {
    canBeFreeTier
  }
  currentUser {
    id
    freeQuota
  }
}
    `;

/**
 * __useFreeTierEligibleQuery__
 *
 * To run a query within a React component, call `useFreeTierEligibleQuery` and pass it any options that fit your needs.
 * When your component renders, `useFreeTierEligibleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFreeTierEligibleQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFreeTierEligibleQuery(baseOptions: Apollo.QueryHookOptions<FreeTierEligibleQuery, FreeTierEligibleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FreeTierEligibleQuery, FreeTierEligibleQueryVariables>(FreeTierEligibleDocument, options);
      }
export function useFreeTierEligibleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FreeTierEligibleQuery, FreeTierEligibleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FreeTierEligibleQuery, FreeTierEligibleQueryVariables>(FreeTierEligibleDocument, options);
        }
export type FreeTierEligibleQueryHookResult = ReturnType<typeof useFreeTierEligibleQuery>;
export type FreeTierEligibleLazyQueryHookResult = ReturnType<typeof useFreeTierEligibleLazyQuery>;
export type FreeTierEligibleQueryResult = Apollo.QueryResult<FreeTierEligibleQuery, FreeTierEligibleQueryVariables>;
export function refetchFreeTierEligibleQuery(variables: FreeTierEligibleQueryVariables) {
      return { query: FreeTierEligibleDocument, variables: variables }
    }
export const ProjectDocument = gql`
    query project($path: String!) {
  project(path: $path) {
    ...ProjectContextWithoutEnvironment
  }
}
    ${ProjectContextWithoutEnvironmentFragmentDoc}`;

/**
 * __useProjectQuery__
 *
 * To run a query within a React component, call `useProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectQuery({
 *   variables: {
 *      path: // value for 'path'
 *   },
 * });
 */
export function useProjectQuery(baseOptions: Apollo.QueryHookOptions<ProjectQuery, ProjectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectQuery, ProjectQueryVariables>(ProjectDocument, options);
      }
export function useProjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectQuery, ProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectQuery, ProjectQueryVariables>(ProjectDocument, options);
        }
export type ProjectQueryHookResult = ReturnType<typeof useProjectQuery>;
export type ProjectLazyQueryHookResult = ReturnType<typeof useProjectLazyQuery>;
export type ProjectQueryResult = Apollo.QueryResult<ProjectQuery, ProjectQueryVariables>;
export function refetchProjectQuery(variables: ProjectQueryVariables) {
      return { query: ProjectDocument, variables: variables }
    }
export const ProjectByIdDocument = gql`
    query projectById($id: UUID!) {
  project(id: $id) {
    ...ProjectBasic
  }
}
    ${ProjectBasicFragmentDoc}`;

/**
 * __useProjectByIdQuery__
 *
 * To run a query within a React component, call `useProjectByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProjectByIdQuery(baseOptions: Apollo.QueryHookOptions<ProjectByIdQuery, ProjectByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectByIdQuery, ProjectByIdQueryVariables>(ProjectByIdDocument, options);
      }
export function useProjectByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectByIdQuery, ProjectByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectByIdQuery, ProjectByIdQueryVariables>(ProjectByIdDocument, options);
        }
export type ProjectByIdQueryHookResult = ReturnType<typeof useProjectByIdQuery>;
export type ProjectByIdLazyQueryHookResult = ReturnType<typeof useProjectByIdLazyQuery>;
export type ProjectByIdQueryResult = Apollo.QueryResult<ProjectByIdQuery, ProjectByIdQueryVariables>;
export function refetchProjectByIdQuery(variables: ProjectByIdQueryVariables) {
      return { query: ProjectByIdDocument, variables: variables }
    }
export const ProjectsDocument = gql`
    query projects($userId: ID!, $filterInput: FilterInput!) {
  user(id: $userId) {
    id
    projectV3Adapters(filter: $filterInput) {
      nodes {
        ...ProjectListItem
      }
    }
    projects {
      nodes {
        ...GroupListItem
      }
    }
  }
}
    ${ProjectListItemFragmentDoc}
${GroupListItemFragmentDoc}`;

/**
 * __useProjectsQuery__
 *
 * To run a query within a React component, call `useProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      filterInput: // value for 'filterInput'
 *   },
 * });
 */
export function useProjectsQuery(baseOptions: Apollo.QueryHookOptions<ProjectsQuery, ProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectsQuery, ProjectsQueryVariables>(ProjectsDocument, options);
      }
export function useProjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectsQuery, ProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectsQuery, ProjectsQueryVariables>(ProjectsDocument, options);
        }
export type ProjectsQueryHookResult = ReturnType<typeof useProjectsQuery>;
export type ProjectsLazyQueryHookResult = ReturnType<typeof useProjectsLazyQuery>;
export type ProjectsQueryResult = Apollo.QueryResult<ProjectsQuery, ProjectsQueryVariables>;
export function refetchProjectsQuery(variables: ProjectsQueryVariables) {
      return { query: ProjectsDocument, variables: variables }
    }
export const ProjectCountDocument = gql`
    query projectCount($userId: ID!, $filterInput: FilterInput!) {
  user(id: $userId) {
    id
    projectV3Adapters(filter: $filterInput) {
      totalCount
    }
  }
}
    `;

/**
 * __useProjectCountQuery__
 *
 * To run a query within a React component, call `useProjectCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectCountQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      filterInput: // value for 'filterInput'
 *   },
 * });
 */
export function useProjectCountQuery(baseOptions: Apollo.QueryHookOptions<ProjectCountQuery, ProjectCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectCountQuery, ProjectCountQueryVariables>(ProjectCountDocument, options);
      }
export function useProjectCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectCountQuery, ProjectCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectCountQuery, ProjectCountQueryVariables>(ProjectCountDocument, options);
        }
export type ProjectCountQueryHookResult = ReturnType<typeof useProjectCountQuery>;
export type ProjectCountLazyQueryHookResult = ReturnType<typeof useProjectCountLazyQuery>;
export type ProjectCountQueryResult = Apollo.QueryResult<ProjectCountQuery, ProjectCountQueryVariables>;
export function refetchProjectCountQuery(variables: ProjectCountQueryVariables) {
      return { query: ProjectCountDocument, variables: variables }
    }
export const ProjectsWithRepoDocument = gql`
    query projectsWithRepo($userId: ID!, $filterInput: FilterInput!) {
  user(id: $userId) {
    id
    projectV3Adapters(filter: $filterInput) {
      nodes {
        id
        ...ProjectWithRepo
      }
    }
  }
}
    ${ProjectWithRepoFragmentDoc}`;

/**
 * __useProjectsWithRepoQuery__
 *
 * To run a query within a React component, call `useProjectsWithRepoQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectsWithRepoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectsWithRepoQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      filterInput: // value for 'filterInput'
 *   },
 * });
 */
export function useProjectsWithRepoQuery(baseOptions: Apollo.QueryHookOptions<ProjectsWithRepoQuery, ProjectsWithRepoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectsWithRepoQuery, ProjectsWithRepoQueryVariables>(ProjectsWithRepoDocument, options);
      }
export function useProjectsWithRepoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectsWithRepoQuery, ProjectsWithRepoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectsWithRepoQuery, ProjectsWithRepoQueryVariables>(ProjectsWithRepoDocument, options);
        }
export type ProjectsWithRepoQueryHookResult = ReturnType<typeof useProjectsWithRepoQuery>;
export type ProjectsWithRepoLazyQueryHookResult = ReturnType<typeof useProjectsWithRepoLazyQuery>;
export type ProjectsWithRepoQueryResult = Apollo.QueryResult<ProjectsWithRepoQuery, ProjectsWithRepoQueryVariables>;
export function refetchProjectsWithRepoQuery(variables: ProjectsWithRepoQueryVariables) {
      return { query: ProjectsWithRepoDocument, variables: variables }
    }
export const UserProjectsProductionDeploymentsDocument = gql`
    query userProjectsProductionDeployments($id: ID!) {
  user(id: $id) {
    id
    projects(input: {page: {first: 0}}) {
      nodes {
        id
        repo {
          id
          productionDeployment {
            id
            ...DeploymentCommon
          }
        }
      }
    }
  }
}
    ${DeploymentCommonFragmentDoc}`;

/**
 * __useUserProjectsProductionDeploymentsQuery__
 *
 * To run a query within a React component, call `useUserProjectsProductionDeploymentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserProjectsProductionDeploymentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserProjectsProductionDeploymentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserProjectsProductionDeploymentsQuery(baseOptions: Apollo.QueryHookOptions<UserProjectsProductionDeploymentsQuery, UserProjectsProductionDeploymentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserProjectsProductionDeploymentsQuery, UserProjectsProductionDeploymentsQueryVariables>(UserProjectsProductionDeploymentsDocument, options);
      }
export function useUserProjectsProductionDeploymentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserProjectsProductionDeploymentsQuery, UserProjectsProductionDeploymentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserProjectsProductionDeploymentsQuery, UserProjectsProductionDeploymentsQueryVariables>(UserProjectsProductionDeploymentsDocument, options);
        }
export type UserProjectsProductionDeploymentsQueryHookResult = ReturnType<typeof useUserProjectsProductionDeploymentsQuery>;
export type UserProjectsProductionDeploymentsLazyQueryHookResult = ReturnType<typeof useUserProjectsProductionDeploymentsLazyQuery>;
export type UserProjectsProductionDeploymentsQueryResult = Apollo.QueryResult<UserProjectsProductionDeploymentsQuery, UserProjectsProductionDeploymentsQueryVariables>;
export function refetchUserProjectsProductionDeploymentsQuery(variables: UserProjectsProductionDeploymentsQueryVariables) {
      return { query: UserProjectsProductionDeploymentsDocument, variables: variables }
    }
export const UserBasicProjectsDocument = gql`
    query userBasicProjects($id: ID!) {
  user(id: $id) {
    id
    projects(input: {page: {first: 0}}) {
      nodes {
        id
        ...ProjectBasic
      }
    }
  }
}
    ${ProjectBasicFragmentDoc}`;

/**
 * __useUserBasicProjectsQuery__
 *
 * To run a query within a React component, call `useUserBasicProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserBasicProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserBasicProjectsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserBasicProjectsQuery(baseOptions: Apollo.QueryHookOptions<UserBasicProjectsQuery, UserBasicProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserBasicProjectsQuery, UserBasicProjectsQueryVariables>(UserBasicProjectsDocument, options);
      }
export function useUserBasicProjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserBasicProjectsQuery, UserBasicProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserBasicProjectsQuery, UserBasicProjectsQueryVariables>(UserBasicProjectsDocument, options);
        }
export type UserBasicProjectsQueryHookResult = ReturnType<typeof useUserBasicProjectsQuery>;
export type UserBasicProjectsLazyQueryHookResult = ReturnType<typeof useUserBasicProjectsLazyQuery>;
export type UserBasicProjectsQueryResult = Apollo.QueryResult<UserBasicProjectsQuery, UserBasicProjectsQueryVariables>;
export function refetchUserBasicProjectsQuery(variables: UserBasicProjectsQueryVariables) {
      return { query: UserBasicProjectsDocument, variables: variables }
    }
export const ProjectRevisionsDocument = gql`
    query projectRevisions($id: UUID!, $page: PageInput) {
  project(id: $id) {
    id
    revisions(page: $page) {
      totalCount
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      nodes {
        ...RevisableEntityCommonFragment
      }
    }
  }
}
    ${RevisableEntityCommonFragmentFragmentDoc}`;

/**
 * __useProjectRevisionsQuery__
 *
 * To run a query within a React component, call `useProjectRevisionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectRevisionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectRevisionsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useProjectRevisionsQuery(baseOptions: Apollo.QueryHookOptions<ProjectRevisionsQuery, ProjectRevisionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectRevisionsQuery, ProjectRevisionsQueryVariables>(ProjectRevisionsDocument, options);
      }
export function useProjectRevisionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectRevisionsQuery, ProjectRevisionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectRevisionsQuery, ProjectRevisionsQueryVariables>(ProjectRevisionsDocument, options);
        }
export type ProjectRevisionsQueryHookResult = ReturnType<typeof useProjectRevisionsQuery>;
export type ProjectRevisionsLazyQueryHookResult = ReturnType<typeof useProjectRevisionsLazyQuery>;
export type ProjectRevisionsQueryResult = Apollo.QueryResult<ProjectRevisionsQuery, ProjectRevisionsQueryVariables>;
export function refetchProjectRevisionsQuery(variables: ProjectRevisionsQueryVariables) {
      return { query: ProjectRevisionsDocument, variables: variables }
    }
export const ProjectPermissionsDocument = gql`
    query projectPermissions($id: UUID!) {
  project(id: $id) {
    id
    permissions {
      availableRoles {
        name
        description
      }
      users {
        user {
          ...UserPublicCommon
        }
        teamRole
        projectRole {
          name
          description
        }
      }
    }
  }
}
    ${UserPublicCommonFragmentDoc}`;

/**
 * __useProjectPermissionsQuery__
 *
 * To run a query within a React component, call `useProjectPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectPermissionsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProjectPermissionsQuery(baseOptions: Apollo.QueryHookOptions<ProjectPermissionsQuery, ProjectPermissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectPermissionsQuery, ProjectPermissionsQueryVariables>(ProjectPermissionsDocument, options);
      }
export function useProjectPermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectPermissionsQuery, ProjectPermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectPermissionsQuery, ProjectPermissionsQueryVariables>(ProjectPermissionsDocument, options);
        }
export type ProjectPermissionsQueryHookResult = ReturnType<typeof useProjectPermissionsQuery>;
export type ProjectPermissionsLazyQueryHookResult = ReturnType<typeof useProjectPermissionsLazyQuery>;
export type ProjectPermissionsQueryResult = Apollo.QueryResult<ProjectPermissionsQuery, ProjectPermissionsQueryVariables>;
export function refetchProjectPermissionsQuery(variables: ProjectPermissionsQueryVariables) {
      return { query: ProjectPermissionsDocument, variables: variables }
    }
export const SubgroupOverviewDocument = gql`
    query subgroupOverview($path: String!, $environment: String!) {
  project(path: $path) {
    id
    environment(name: $environment) {
      id
      name
      overviewV2 {
        deploymentStatus
        count
      }
      projectV3Adapters {
        ...ProjectV3AdapterConnectionListItem
      }
    }
  }
}
    ${ProjectV3AdapterConnectionListItemFragmentDoc}`;

/**
 * __useSubgroupOverviewQuery__
 *
 * To run a query within a React component, call `useSubgroupOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubgroupOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubgroupOverviewQuery({
 *   variables: {
 *      path: // value for 'path'
 *      environment: // value for 'environment'
 *   },
 * });
 */
export function useSubgroupOverviewQuery(baseOptions: Apollo.QueryHookOptions<SubgroupOverviewQuery, SubgroupOverviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubgroupOverviewQuery, SubgroupOverviewQueryVariables>(SubgroupOverviewDocument, options);
      }
export function useSubgroupOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubgroupOverviewQuery, SubgroupOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubgroupOverviewQuery, SubgroupOverviewQueryVariables>(SubgroupOverviewDocument, options);
        }
export type SubgroupOverviewQueryHookResult = ReturnType<typeof useSubgroupOverviewQuery>;
export type SubgroupOverviewLazyQueryHookResult = ReturnType<typeof useSubgroupOverviewLazyQuery>;
export type SubgroupOverviewQueryResult = Apollo.QueryResult<SubgroupOverviewQuery, SubgroupOverviewQueryVariables>;
export function refetchSubgroupOverviewQuery(variables: SubgroupOverviewQueryVariables) {
      return { query: SubgroupOverviewDocument, variables: variables }
    }
export const ProjectEnvironmentsDocument = gql`
    query projectEnvironments($path: String!) {
  project(path: $path) {
    id
    environments {
      ...ProjectEnvironmentListItem
    }
  }
}
    ${ProjectEnvironmentListItemFragmentDoc}`;

/**
 * __useProjectEnvironmentsQuery__
 *
 * To run a query within a React component, call `useProjectEnvironmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectEnvironmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectEnvironmentsQuery({
 *   variables: {
 *      path: // value for 'path'
 *   },
 * });
 */
export function useProjectEnvironmentsQuery(baseOptions: Apollo.QueryHookOptions<ProjectEnvironmentsQuery, ProjectEnvironmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectEnvironmentsQuery, ProjectEnvironmentsQueryVariables>(ProjectEnvironmentsDocument, options);
      }
export function useProjectEnvironmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectEnvironmentsQuery, ProjectEnvironmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectEnvironmentsQuery, ProjectEnvironmentsQueryVariables>(ProjectEnvironmentsDocument, options);
        }
export type ProjectEnvironmentsQueryHookResult = ReturnType<typeof useProjectEnvironmentsQuery>;
export type ProjectEnvironmentsLazyQueryHookResult = ReturnType<typeof useProjectEnvironmentsLazyQuery>;
export type ProjectEnvironmentsQueryResult = Apollo.QueryResult<ProjectEnvironmentsQuery, ProjectEnvironmentsQueryVariables>;
export function refetchProjectEnvironmentsQuery(variables: ProjectEnvironmentsQueryVariables) {
      return { query: ProjectEnvironmentsDocument, variables: variables }
    }
export const ProjectEnvironmentsAndRepoCountDocument = gql`
    query projectEnvironmentsAndRepoCount($path: String!) {
  project(path: $path) {
    id
    environments {
      repoConnection(page: {}) {
        totalCount
      }
      ...ProjectEnvironmentBasic
    }
  }
}
    ${ProjectEnvironmentBasicFragmentDoc}`;

/**
 * __useProjectEnvironmentsAndRepoCountQuery__
 *
 * To run a query within a React component, call `useProjectEnvironmentsAndRepoCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectEnvironmentsAndRepoCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectEnvironmentsAndRepoCountQuery({
 *   variables: {
 *      path: // value for 'path'
 *   },
 * });
 */
export function useProjectEnvironmentsAndRepoCountQuery(baseOptions: Apollo.QueryHookOptions<ProjectEnvironmentsAndRepoCountQuery, ProjectEnvironmentsAndRepoCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectEnvironmentsAndRepoCountQuery, ProjectEnvironmentsAndRepoCountQueryVariables>(ProjectEnvironmentsAndRepoCountDocument, options);
      }
export function useProjectEnvironmentsAndRepoCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectEnvironmentsAndRepoCountQuery, ProjectEnvironmentsAndRepoCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectEnvironmentsAndRepoCountQuery, ProjectEnvironmentsAndRepoCountQueryVariables>(ProjectEnvironmentsAndRepoCountDocument, options);
        }
export type ProjectEnvironmentsAndRepoCountQueryHookResult = ReturnType<typeof useProjectEnvironmentsAndRepoCountQuery>;
export type ProjectEnvironmentsAndRepoCountLazyQueryHookResult = ReturnType<typeof useProjectEnvironmentsAndRepoCountLazyQuery>;
export type ProjectEnvironmentsAndRepoCountQueryResult = Apollo.QueryResult<ProjectEnvironmentsAndRepoCountQuery, ProjectEnvironmentsAndRepoCountQueryVariables>;
export function refetchProjectEnvironmentsAndRepoCountQuery(variables: ProjectEnvironmentsAndRepoCountQueryVariables) {
      return { query: ProjectEnvironmentsAndRepoCountDocument, variables: variables }
    }
export const ProjectEnvironmentsBasicDocument = gql`
    query projectEnvironmentsBasic($path: String!) {
  project(path: $path) {
    id
    environments {
      ...ProjectEnvironmentBasic
    }
  }
}
    ${ProjectEnvironmentBasicFragmentDoc}`;

/**
 * __useProjectEnvironmentsBasicQuery__
 *
 * To run a query within a React component, call `useProjectEnvironmentsBasicQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectEnvironmentsBasicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectEnvironmentsBasicQuery({
 *   variables: {
 *      path: // value for 'path'
 *   },
 * });
 */
export function useProjectEnvironmentsBasicQuery(baseOptions: Apollo.QueryHookOptions<ProjectEnvironmentsBasicQuery, ProjectEnvironmentsBasicQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectEnvironmentsBasicQuery, ProjectEnvironmentsBasicQueryVariables>(ProjectEnvironmentsBasicDocument, options);
      }
export function useProjectEnvironmentsBasicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectEnvironmentsBasicQuery, ProjectEnvironmentsBasicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectEnvironmentsBasicQuery, ProjectEnvironmentsBasicQueryVariables>(ProjectEnvironmentsBasicDocument, options);
        }
export type ProjectEnvironmentsBasicQueryHookResult = ReturnType<typeof useProjectEnvironmentsBasicQuery>;
export type ProjectEnvironmentsBasicLazyQueryHookResult = ReturnType<typeof useProjectEnvironmentsBasicLazyQuery>;
export type ProjectEnvironmentsBasicQueryResult = Apollo.QueryResult<ProjectEnvironmentsBasicQuery, ProjectEnvironmentsBasicQueryVariables>;
export function refetchProjectEnvironmentsBasicQuery(variables: ProjectEnvironmentsBasicQueryVariables) {
      return { query: ProjectEnvironmentsBasicDocument, variables: variables }
    }
export const ProjectEnvironmentsByIdDocument = gql`
    query projectEnvironmentsById($id: UUID!) {
  project(id: $id) {
    id
    environments {
      ...ProjectEnvironmentBasic
    }
  }
}
    ${ProjectEnvironmentBasicFragmentDoc}`;

/**
 * __useProjectEnvironmentsByIdQuery__
 *
 * To run a query within a React component, call `useProjectEnvironmentsByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectEnvironmentsByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectEnvironmentsByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProjectEnvironmentsByIdQuery(baseOptions: Apollo.QueryHookOptions<ProjectEnvironmentsByIdQuery, ProjectEnvironmentsByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectEnvironmentsByIdQuery, ProjectEnvironmentsByIdQueryVariables>(ProjectEnvironmentsByIdDocument, options);
      }
export function useProjectEnvironmentsByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectEnvironmentsByIdQuery, ProjectEnvironmentsByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectEnvironmentsByIdQuery, ProjectEnvironmentsByIdQueryVariables>(ProjectEnvironmentsByIdDocument, options);
        }
export type ProjectEnvironmentsByIdQueryHookResult = ReturnType<typeof useProjectEnvironmentsByIdQuery>;
export type ProjectEnvironmentsByIdLazyQueryHookResult = ReturnType<typeof useProjectEnvironmentsByIdLazyQuery>;
export type ProjectEnvironmentsByIdQueryResult = Apollo.QueryResult<ProjectEnvironmentsByIdQuery, ProjectEnvironmentsByIdQueryVariables>;
export function refetchProjectEnvironmentsByIdQuery(variables: ProjectEnvironmentsByIdQueryVariables) {
      return { query: ProjectEnvironmentsByIdDocument, variables: variables }
    }
export const ProjectEnvironmentDocument = gql`
    query projectEnvironment($path: String!, $env: String!) {
  project(path: $path) {
    id
    environment(name: $env) {
      ...ProjectEnvironmentBasic
    }
  }
}
    ${ProjectEnvironmentBasicFragmentDoc}`;

/**
 * __useProjectEnvironmentQuery__
 *
 * To run a query within a React component, call `useProjectEnvironmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectEnvironmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectEnvironmentQuery({
 *   variables: {
 *      path: // value for 'path'
 *      env: // value for 'env'
 *   },
 * });
 */
export function useProjectEnvironmentQuery(baseOptions: Apollo.QueryHookOptions<ProjectEnvironmentQuery, ProjectEnvironmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectEnvironmentQuery, ProjectEnvironmentQueryVariables>(ProjectEnvironmentDocument, options);
      }
export function useProjectEnvironmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectEnvironmentQuery, ProjectEnvironmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectEnvironmentQuery, ProjectEnvironmentQueryVariables>(ProjectEnvironmentDocument, options);
        }
export type ProjectEnvironmentQueryHookResult = ReturnType<typeof useProjectEnvironmentQuery>;
export type ProjectEnvironmentLazyQueryHookResult = ReturnType<typeof useProjectEnvironmentLazyQuery>;
export type ProjectEnvironmentQueryResult = Apollo.QueryResult<ProjectEnvironmentQuery, ProjectEnvironmentQueryVariables>;
export function refetchProjectEnvironmentQuery(variables: ProjectEnvironmentQueryVariables) {
      return { query: ProjectEnvironmentDocument, variables: variables }
    }
export const ProjectEnvironmentByIdDocument = gql`
    query projectEnvironmentById($projectId: UUID!, $envId: UUID!) {
  project(id: $projectId) {
    id
    environment(id: $envId) {
      ...ProjectEnvironmentBasic
    }
  }
}
    ${ProjectEnvironmentBasicFragmentDoc}`;

/**
 * __useProjectEnvironmentByIdQuery__
 *
 * To run a query within a React component, call `useProjectEnvironmentByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectEnvironmentByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectEnvironmentByIdQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      envId: // value for 'envId'
 *   },
 * });
 */
export function useProjectEnvironmentByIdQuery(baseOptions: Apollo.QueryHookOptions<ProjectEnvironmentByIdQuery, ProjectEnvironmentByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectEnvironmentByIdQuery, ProjectEnvironmentByIdQueryVariables>(ProjectEnvironmentByIdDocument, options);
      }
export function useProjectEnvironmentByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectEnvironmentByIdQuery, ProjectEnvironmentByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectEnvironmentByIdQuery, ProjectEnvironmentByIdQueryVariables>(ProjectEnvironmentByIdDocument, options);
        }
export type ProjectEnvironmentByIdQueryHookResult = ReturnType<typeof useProjectEnvironmentByIdQuery>;
export type ProjectEnvironmentByIdLazyQueryHookResult = ReturnType<typeof useProjectEnvironmentByIdLazyQuery>;
export type ProjectEnvironmentByIdQueryResult = Apollo.QueryResult<ProjectEnvironmentByIdQuery, ProjectEnvironmentByIdQueryVariables>;
export function refetchProjectEnvironmentByIdQuery(variables: ProjectEnvironmentByIdQueryVariables) {
      return { query: ProjectEnvironmentByIdDocument, variables: variables }
    }
export const ProjectEnvironmentVariablesDocument = gql`
    query projectEnvironmentVariables($path: String!) {
  project(path: $path) {
    id
    envs {
      ...EnvVarDetail
    }
  }
}
    ${EnvVarDetailFragmentDoc}`;

/**
 * __useProjectEnvironmentVariablesQuery__
 *
 * To run a query within a React component, call `useProjectEnvironmentVariablesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectEnvironmentVariablesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectEnvironmentVariablesQuery({
 *   variables: {
 *      path: // value for 'path'
 *   },
 * });
 */
export function useProjectEnvironmentVariablesQuery(baseOptions: Apollo.QueryHookOptions<ProjectEnvironmentVariablesQuery, ProjectEnvironmentVariablesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectEnvironmentVariablesQuery, ProjectEnvironmentVariablesQueryVariables>(ProjectEnvironmentVariablesDocument, options);
      }
export function useProjectEnvironmentVariablesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectEnvironmentVariablesQuery, ProjectEnvironmentVariablesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectEnvironmentVariablesQuery, ProjectEnvironmentVariablesQueryVariables>(ProjectEnvironmentVariablesDocument, options);
        }
export type ProjectEnvironmentVariablesQueryHookResult = ReturnType<typeof useProjectEnvironmentVariablesQuery>;
export type ProjectEnvironmentVariablesLazyQueryHookResult = ReturnType<typeof useProjectEnvironmentVariablesLazyQuery>;
export type ProjectEnvironmentVariablesQueryResult = Apollo.QueryResult<ProjectEnvironmentVariablesQuery, ProjectEnvironmentVariablesQueryVariables>;
export function refetchProjectEnvironmentVariablesQuery(variables: ProjectEnvironmentVariablesQueryVariables) {
      return { query: ProjectEnvironmentVariablesDocument, variables: variables }
    }
export const EnvironmentEnvironmentVariablesDocument = gql`
    query environmentEnvironmentVariables($path: String!, $env: String!) {
  project(path: $path) {
    id
    envs {
      ...EnvVarDetail
    }
    environment(name: $env) {
      id
      envs {
        ...EnvVarDetail
      }
    }
  }
}
    ${EnvVarDetailFragmentDoc}`;

/**
 * __useEnvironmentEnvironmentVariablesQuery__
 *
 * To run a query within a React component, call `useEnvironmentEnvironmentVariablesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnvironmentEnvironmentVariablesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnvironmentEnvironmentVariablesQuery({
 *   variables: {
 *      path: // value for 'path'
 *      env: // value for 'env'
 *   },
 * });
 */
export function useEnvironmentEnvironmentVariablesQuery(baseOptions: Apollo.QueryHookOptions<EnvironmentEnvironmentVariablesQuery, EnvironmentEnvironmentVariablesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EnvironmentEnvironmentVariablesQuery, EnvironmentEnvironmentVariablesQueryVariables>(EnvironmentEnvironmentVariablesDocument, options);
      }
export function useEnvironmentEnvironmentVariablesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EnvironmentEnvironmentVariablesQuery, EnvironmentEnvironmentVariablesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EnvironmentEnvironmentVariablesQuery, EnvironmentEnvironmentVariablesQueryVariables>(EnvironmentEnvironmentVariablesDocument, options);
        }
export type EnvironmentEnvironmentVariablesQueryHookResult = ReturnType<typeof useEnvironmentEnvironmentVariablesQuery>;
export type EnvironmentEnvironmentVariablesLazyQueryHookResult = ReturnType<typeof useEnvironmentEnvironmentVariablesLazyQuery>;
export type EnvironmentEnvironmentVariablesQueryResult = Apollo.QueryResult<EnvironmentEnvironmentVariablesQuery, EnvironmentEnvironmentVariablesQueryVariables>;
export function refetchEnvironmentEnvironmentVariablesQuery(variables: EnvironmentEnvironmentVariablesQueryVariables) {
      return { query: EnvironmentEnvironmentVariablesDocument, variables: variables }
    }
export const ProjectEnvironmentRevisionsDocument = gql`
    query projectEnvironmentRevisions($projectId: UUID!, $id: UUID!, $page: PageInput) {
  project(id: $projectId) {
    id
    environment(id: $id) {
      id
      revisions(page: $page) {
        totalCount
        pageInfo {
          startCursor
          endCursor
          hasNextPage
          hasPreviousPage
        }
        nodes {
          ...RevisableEntityCommonFragment
        }
      }
    }
  }
}
    ${RevisableEntityCommonFragmentFragmentDoc}`;

/**
 * __useProjectEnvironmentRevisionsQuery__
 *
 * To run a query within a React component, call `useProjectEnvironmentRevisionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectEnvironmentRevisionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectEnvironmentRevisionsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      id: // value for 'id'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useProjectEnvironmentRevisionsQuery(baseOptions: Apollo.QueryHookOptions<ProjectEnvironmentRevisionsQuery, ProjectEnvironmentRevisionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectEnvironmentRevisionsQuery, ProjectEnvironmentRevisionsQueryVariables>(ProjectEnvironmentRevisionsDocument, options);
      }
export function useProjectEnvironmentRevisionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectEnvironmentRevisionsQuery, ProjectEnvironmentRevisionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectEnvironmentRevisionsQuery, ProjectEnvironmentRevisionsQueryVariables>(ProjectEnvironmentRevisionsDocument, options);
        }
export type ProjectEnvironmentRevisionsQueryHookResult = ReturnType<typeof useProjectEnvironmentRevisionsQuery>;
export type ProjectEnvironmentRevisionsLazyQueryHookResult = ReturnType<typeof useProjectEnvironmentRevisionsLazyQuery>;
export type ProjectEnvironmentRevisionsQueryResult = Apollo.QueryResult<ProjectEnvironmentRevisionsQuery, ProjectEnvironmentRevisionsQueryVariables>;
export function refetchProjectEnvironmentRevisionsQuery(variables: ProjectEnvironmentRevisionsQueryVariables) {
      return { query: ProjectEnvironmentRevisionsDocument, variables: variables }
    }
export const UserProjectV3Document = gql`
    query userProjectV3($userId: ID!, $projectName: String!, $page: PageInput!) {
  user(id: $userId) {
    id
    projectV3Adapters(
      filter: {filter: {criterion: {resourceAdapterFilter: {name: {value: $projectName, operator: CONTAINS}}}}, page: $page}
    ) {
      totalCount
      ...ProjectV3ListItemConnection
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
}
    ${ProjectV3ListItemConnectionFragmentDoc}`;

/**
 * __useUserProjectV3Query__
 *
 * To run a query within a React component, call `useUserProjectV3Query` and pass it any options that fit your needs.
 * When your component renders, `useUserProjectV3Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserProjectV3Query({
 *   variables: {
 *      userId: // value for 'userId'
 *      projectName: // value for 'projectName'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useUserProjectV3Query(baseOptions: Apollo.QueryHookOptions<UserProjectV3Query, UserProjectV3QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserProjectV3Query, UserProjectV3QueryVariables>(UserProjectV3Document, options);
      }
export function useUserProjectV3LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserProjectV3Query, UserProjectV3QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserProjectV3Query, UserProjectV3QueryVariables>(UserProjectV3Document, options);
        }
export type UserProjectV3QueryHookResult = ReturnType<typeof useUserProjectV3Query>;
export type UserProjectV3LazyQueryHookResult = ReturnType<typeof useUserProjectV3LazyQuery>;
export type UserProjectV3QueryResult = Apollo.QueryResult<UserProjectV3Query, UserProjectV3QueryVariables>;
export function refetchUserProjectV3Query(variables: UserProjectV3QueryVariables) {
      return { query: UserProjectV3Document, variables: variables }
    }
export const UserProjectV3DeploymentsDocument = gql`
    query userProjectV3Deployments($userId: ID!, $projectName: String!, $page: PageInput!) {
  user(id: $userId) {
    id
    projectV3Adapters(
      filter: {filter: {criterion: {resourceAdapterFilter: {name: {value: $projectName, operator: CONTAINS}}}}, page: $page}
    ) {
      totalCount
      ...ProjectV3ProductionDeploymentConnection
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
}
    ${ProjectV3ProductionDeploymentConnectionFragmentDoc}`;

/**
 * __useUserProjectV3DeploymentsQuery__
 *
 * To run a query within a React component, call `useUserProjectV3DeploymentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserProjectV3DeploymentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserProjectV3DeploymentsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      projectName: // value for 'projectName'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useUserProjectV3DeploymentsQuery(baseOptions: Apollo.QueryHookOptions<UserProjectV3DeploymentsQuery, UserProjectV3DeploymentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserProjectV3DeploymentsQuery, UserProjectV3DeploymentsQueryVariables>(UserProjectV3DeploymentsDocument, options);
      }
export function useUserProjectV3DeploymentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserProjectV3DeploymentsQuery, UserProjectV3DeploymentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserProjectV3DeploymentsQuery, UserProjectV3DeploymentsQueryVariables>(UserProjectV3DeploymentsDocument, options);
        }
export type UserProjectV3DeploymentsQueryHookResult = ReturnType<typeof useUserProjectV3DeploymentsQuery>;
export type UserProjectV3DeploymentsLazyQueryHookResult = ReturnType<typeof useUserProjectV3DeploymentsLazyQuery>;
export type UserProjectV3DeploymentsQueryResult = Apollo.QueryResult<UserProjectV3DeploymentsQuery, UserProjectV3DeploymentsQueryVariables>;
export function refetchUserProjectV3DeploymentsQuery(variables: UserProjectV3DeploymentsQueryVariables) {
      return { query: UserProjectV3DeploymentsDocument, variables: variables }
    }
export const ProjectV3sForEnvironmentDocument = gql`
    query projectV3sForEnvironment($userId: ID!, $groupName: String!, $subgroupName: String!, $page: PageInput!, $projectName: String!) {
  user(id: $userId) {
    id
    projectV3Adapters(
      filter: {filter: {criterion: {resourceAdapterFilter: {projectName: {value: $groupName, operator: EQUALS}, environmentName: {value: $subgroupName, operator: EQUALS}, name: {value: $projectName, operator: CONTAINS}}}}, page: $page}
    ) {
      totalCount
      ...ProjectV3ListItemConnection
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
}
    ${ProjectV3ListItemConnectionFragmentDoc}`;

/**
 * __useProjectV3sForEnvironmentQuery__
 *
 * To run a query within a React component, call `useProjectV3sForEnvironmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectV3sForEnvironmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectV3sForEnvironmentQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      groupName: // value for 'groupName'
 *      subgroupName: // value for 'subgroupName'
 *      page: // value for 'page'
 *      projectName: // value for 'projectName'
 *   },
 * });
 */
export function useProjectV3sForEnvironmentQuery(baseOptions: Apollo.QueryHookOptions<ProjectV3sForEnvironmentQuery, ProjectV3sForEnvironmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectV3sForEnvironmentQuery, ProjectV3sForEnvironmentQueryVariables>(ProjectV3sForEnvironmentDocument, options);
      }
export function useProjectV3sForEnvironmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectV3sForEnvironmentQuery, ProjectV3sForEnvironmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectV3sForEnvironmentQuery, ProjectV3sForEnvironmentQueryVariables>(ProjectV3sForEnvironmentDocument, options);
        }
export type ProjectV3sForEnvironmentQueryHookResult = ReturnType<typeof useProjectV3sForEnvironmentQuery>;
export type ProjectV3sForEnvironmentLazyQueryHookResult = ReturnType<typeof useProjectV3sForEnvironmentLazyQuery>;
export type ProjectV3sForEnvironmentQueryResult = Apollo.QueryResult<ProjectV3sForEnvironmentQuery, ProjectV3sForEnvironmentQueryVariables>;
export function refetchProjectV3sForEnvironmentQuery(variables: ProjectV3sForEnvironmentQueryVariables) {
      return { query: ProjectV3sForEnvironmentDocument, variables: variables }
    }
export const ProjectV3sForEnvironmentProductionDeploymentsDocument = gql`
    query projectV3sForEnvironmentProductionDeployments($userId: ID!, $groupName: String!, $subgroupName: String!, $page: PageInput!, $projectName: String!) {
  user(id: $userId) {
    id
    projectV3Adapters(
      filter: {filter: {criterion: {resourceAdapterFilter: {projectName: {value: $groupName, operator: EQUALS}, environmentName: {value: $subgroupName, operator: EQUALS}, name: {value: $projectName, operator: CONTAINS}}}}, page: $page}
    ) {
      ...ProjectV3ProductionDeploymentConnection
    }
  }
}
    ${ProjectV3ProductionDeploymentConnectionFragmentDoc}`;

/**
 * __useProjectV3sForEnvironmentProductionDeploymentsQuery__
 *
 * To run a query within a React component, call `useProjectV3sForEnvironmentProductionDeploymentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectV3sForEnvironmentProductionDeploymentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectV3sForEnvironmentProductionDeploymentsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      groupName: // value for 'groupName'
 *      subgroupName: // value for 'subgroupName'
 *      page: // value for 'page'
 *      projectName: // value for 'projectName'
 *   },
 * });
 */
export function useProjectV3sForEnvironmentProductionDeploymentsQuery(baseOptions: Apollo.QueryHookOptions<ProjectV3sForEnvironmentProductionDeploymentsQuery, ProjectV3sForEnvironmentProductionDeploymentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectV3sForEnvironmentProductionDeploymentsQuery, ProjectV3sForEnvironmentProductionDeploymentsQueryVariables>(ProjectV3sForEnvironmentProductionDeploymentsDocument, options);
      }
export function useProjectV3sForEnvironmentProductionDeploymentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectV3sForEnvironmentProductionDeploymentsQuery, ProjectV3sForEnvironmentProductionDeploymentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectV3sForEnvironmentProductionDeploymentsQuery, ProjectV3sForEnvironmentProductionDeploymentsQueryVariables>(ProjectV3sForEnvironmentProductionDeploymentsDocument, options);
        }
export type ProjectV3sForEnvironmentProductionDeploymentsQueryHookResult = ReturnType<typeof useProjectV3sForEnvironmentProductionDeploymentsQuery>;
export type ProjectV3sForEnvironmentProductionDeploymentsLazyQueryHookResult = ReturnType<typeof useProjectV3sForEnvironmentProductionDeploymentsLazyQuery>;
export type ProjectV3sForEnvironmentProductionDeploymentsQueryResult = Apollo.QueryResult<ProjectV3sForEnvironmentProductionDeploymentsQuery, ProjectV3sForEnvironmentProductionDeploymentsQueryVariables>;
export function refetchProjectV3sForEnvironmentProductionDeploymentsQuery(variables: ProjectV3sForEnvironmentProductionDeploymentsQueryVariables) {
      return { query: ProjectV3sForEnvironmentProductionDeploymentsDocument, variables: variables }
    }
export const ProjectV3Document = gql`
    query projectV3($userId: ID!, $projectName: String!, $environmentName: String!, $name: String!) {
  user(id: $userId) {
    id
    projectV3Adapters(
      filter: {filter: {criterion: {resourceAdapterFilter: {projectName: {value: $projectName, operator: EQUALS}, environmentName: {value: $environmentName, operator: EQUALS}, name: {value: $name, operator: EQUALS}}}}, page: {first: 1}}
    ) {
      totalCount
      nodes {
        ...ProjectV3AdapterDetail
      }
    }
  }
}
    ${ProjectV3AdapterDetailFragmentDoc}`;

/**
 * __useProjectV3Query__
 *
 * To run a query within a React component, call `useProjectV3Query` and pass it any options that fit your needs.
 * When your component renders, `useProjectV3Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectV3Query({
 *   variables: {
 *      userId: // value for 'userId'
 *      projectName: // value for 'projectName'
 *      environmentName: // value for 'environmentName'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useProjectV3Query(baseOptions: Apollo.QueryHookOptions<ProjectV3Query, ProjectV3QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectV3Query, ProjectV3QueryVariables>(ProjectV3Document, options);
      }
export function useProjectV3LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectV3Query, ProjectV3QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectV3Query, ProjectV3QueryVariables>(ProjectV3Document, options);
        }
export type ProjectV3QueryHookResult = ReturnType<typeof useProjectV3Query>;
export type ProjectV3LazyQueryHookResult = ReturnType<typeof useProjectV3LazyQuery>;
export type ProjectV3QueryResult = Apollo.QueryResult<ProjectV3Query, ProjectV3QueryVariables>;
export function refetchProjectV3Query(variables: ProjectV3QueryVariables) {
      return { query: ProjectV3Document, variables: variables }
    }
export const BlueprintDriverWorkflowDocument = gql`
    query blueprintDriverWorkflow($id: UUID!, $userId: ID!) {
  user(id: $userId) {
    id
    blueprintDriverWorkflow(id: $id) {
      ...BlueprintDriverWorkflowDetail
    }
  }
}
    ${BlueprintDriverWorkflowDetailFragmentDoc}`;

/**
 * __useBlueprintDriverWorkflowQuery__
 *
 * To run a query within a React component, call `useBlueprintDriverWorkflowQuery` and pass it any options that fit your needs.
 * When your component renders, `useBlueprintDriverWorkflowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBlueprintDriverWorkflowQuery({
 *   variables: {
 *      id: // value for 'id'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useBlueprintDriverWorkflowQuery(baseOptions: Apollo.QueryHookOptions<BlueprintDriverWorkflowQuery, BlueprintDriverWorkflowQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BlueprintDriverWorkflowQuery, BlueprintDriverWorkflowQueryVariables>(BlueprintDriverWorkflowDocument, options);
      }
export function useBlueprintDriverWorkflowLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BlueprintDriverWorkflowQuery, BlueprintDriverWorkflowQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BlueprintDriverWorkflowQuery, BlueprintDriverWorkflowQueryVariables>(BlueprintDriverWorkflowDocument, options);
        }
export type BlueprintDriverWorkflowQueryHookResult = ReturnType<typeof useBlueprintDriverWorkflowQuery>;
export type BlueprintDriverWorkflowLazyQueryHookResult = ReturnType<typeof useBlueprintDriverWorkflowLazyQuery>;
export type BlueprintDriverWorkflowQueryResult = Apollo.QueryResult<BlueprintDriverWorkflowQuery, BlueprintDriverWorkflowQueryVariables>;
export function refetchBlueprintDriverWorkflowQuery(variables: BlueprintDriverWorkflowQueryVariables) {
      return { query: BlueprintDriverWorkflowDocument, variables: variables }
    }
export const UserContainerRegistriesDocument = gql`
    query userContainerRegistries($id: ID!) {
  user(id: $id) {
    id
    clusters {
      id
      containerRegistry {
        id
        name
        credentialProvider
      }
    }
    ...UserContainerRegistries
  }
}
    ${UserContainerRegistriesFragmentDoc}`;

/**
 * __useUserContainerRegistriesQuery__
 *
 * To run a query within a React component, call `useUserContainerRegistriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserContainerRegistriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserContainerRegistriesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserContainerRegistriesQuery(baseOptions: Apollo.QueryHookOptions<UserContainerRegistriesQuery, UserContainerRegistriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserContainerRegistriesQuery, UserContainerRegistriesQueryVariables>(UserContainerRegistriesDocument, options);
      }
export function useUserContainerRegistriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserContainerRegistriesQuery, UserContainerRegistriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserContainerRegistriesQuery, UserContainerRegistriesQueryVariables>(UserContainerRegistriesDocument, options);
        }
export type UserContainerRegistriesQueryHookResult = ReturnType<typeof useUserContainerRegistriesQuery>;
export type UserContainerRegistriesLazyQueryHookResult = ReturnType<typeof useUserContainerRegistriesLazyQuery>;
export type UserContainerRegistriesQueryResult = Apollo.QueryResult<UserContainerRegistriesQuery, UserContainerRegistriesQueryVariables>;
export function refetchUserContainerRegistriesQuery(variables: UserContainerRegistriesQueryVariables) {
      return { query: UserContainerRegistriesDocument, variables: variables }
    }
export const RepoCustomizationDocument = gql`
    query repoCustomization($id: UUID!) {
  repo(id: $id) {
    id
    ...RepoCustomization
  }
}
    ${RepoCustomizationFragmentDoc}`;

/**
 * __useRepoCustomizationQuery__
 *
 * To run a query within a React component, call `useRepoCustomizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useRepoCustomizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRepoCustomizationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRepoCustomizationQuery(baseOptions: Apollo.QueryHookOptions<RepoCustomizationQuery, RepoCustomizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RepoCustomizationQuery, RepoCustomizationQueryVariables>(RepoCustomizationDocument, options);
      }
export function useRepoCustomizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RepoCustomizationQuery, RepoCustomizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RepoCustomizationQuery, RepoCustomizationQueryVariables>(RepoCustomizationDocument, options);
        }
export type RepoCustomizationQueryHookResult = ReturnType<typeof useRepoCustomizationQuery>;
export type RepoCustomizationLazyQueryHookResult = ReturnType<typeof useRepoCustomizationLazyQuery>;
export type RepoCustomizationQueryResult = Apollo.QueryResult<RepoCustomizationQuery, RepoCustomizationQueryVariables>;
export function refetchRepoCustomizationQuery(variables: RepoCustomizationQueryVariables) {
      return { query: RepoCustomizationDocument, variables: variables }
    }
export const RepoRenderPodSpecPatchDocument = gql`
    query repoRenderPodSpecPatch($id: UUID!, $patch: String) {
  repo(id: $id) {
    id
    productionBranchV2 {
      id
      renderPodSpec(patch: $patch)
    }
  }
}
    `;

/**
 * __useRepoRenderPodSpecPatchQuery__
 *
 * To run a query within a React component, call `useRepoRenderPodSpecPatchQuery` and pass it any options that fit your needs.
 * When your component renders, `useRepoRenderPodSpecPatchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRepoRenderPodSpecPatchQuery({
 *   variables: {
 *      id: // value for 'id'
 *      patch: // value for 'patch'
 *   },
 * });
 */
export function useRepoRenderPodSpecPatchQuery(baseOptions: Apollo.QueryHookOptions<RepoRenderPodSpecPatchQuery, RepoRenderPodSpecPatchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RepoRenderPodSpecPatchQuery, RepoRenderPodSpecPatchQueryVariables>(RepoRenderPodSpecPatchDocument, options);
      }
export function useRepoRenderPodSpecPatchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RepoRenderPodSpecPatchQuery, RepoRenderPodSpecPatchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RepoRenderPodSpecPatchQuery, RepoRenderPodSpecPatchQueryVariables>(RepoRenderPodSpecPatchDocument, options);
        }
export type RepoRenderPodSpecPatchQueryHookResult = ReturnType<typeof useRepoRenderPodSpecPatchQuery>;
export type RepoRenderPodSpecPatchLazyQueryHookResult = ReturnType<typeof useRepoRenderPodSpecPatchLazyQuery>;
export type RepoRenderPodSpecPatchQueryResult = Apollo.QueryResult<RepoRenderPodSpecPatchQuery, RepoRenderPodSpecPatchQueryVariables>;
export function refetchRepoRenderPodSpecPatchQuery(variables: RepoRenderPodSpecPatchQueryVariables) {
      return { query: RepoRenderPodSpecPatchDocument, variables: variables }
    }
export const RepoRenderIngressSpecPatchDocument = gql`
    query repoRenderIngressSpecPatch($id: UUID!, $patch: String) {
  repo(id: $id) {
    id
    productionBranchV2 {
      id
      renderIngress(patch: $patch)
    }
  }
}
    `;

/**
 * __useRepoRenderIngressSpecPatchQuery__
 *
 * To run a query within a React component, call `useRepoRenderIngressSpecPatchQuery` and pass it any options that fit your needs.
 * When your component renders, `useRepoRenderIngressSpecPatchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRepoRenderIngressSpecPatchQuery({
 *   variables: {
 *      id: // value for 'id'
 *      patch: // value for 'patch'
 *   },
 * });
 */
export function useRepoRenderIngressSpecPatchQuery(baseOptions: Apollo.QueryHookOptions<RepoRenderIngressSpecPatchQuery, RepoRenderIngressSpecPatchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RepoRenderIngressSpecPatchQuery, RepoRenderIngressSpecPatchQueryVariables>(RepoRenderIngressSpecPatchDocument, options);
      }
export function useRepoRenderIngressSpecPatchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RepoRenderIngressSpecPatchQuery, RepoRenderIngressSpecPatchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RepoRenderIngressSpecPatchQuery, RepoRenderIngressSpecPatchQueryVariables>(RepoRenderIngressSpecPatchDocument, options);
        }
export type RepoRenderIngressSpecPatchQueryHookResult = ReturnType<typeof useRepoRenderIngressSpecPatchQuery>;
export type RepoRenderIngressSpecPatchLazyQueryHookResult = ReturnType<typeof useRepoRenderIngressSpecPatchLazyQuery>;
export type RepoRenderIngressSpecPatchQueryResult = Apollo.QueryResult<RepoRenderIngressSpecPatchQuery, RepoRenderIngressSpecPatchQueryVariables>;
export function refetchRepoRenderIngressSpecPatchQuery(variables: RepoRenderIngressSpecPatchQueryVariables) {
      return { query: RepoRenderIngressSpecPatchDocument, variables: variables }
    }
export const TeamCloudDocument = gql`
    query teamCloud($id: ID!) {
  currentUser {
    id
    team(id: $id) {
      id
      awsAccounts {
        iamUsers {
          arn
          userId
          username
          attachedAwsPolicies {
            arn
            policyName
            groupName
          }
        }
        userIamConnections {
          userId
          awsIamArn
          awsAccountId
          id
        }
        accountID
        id
      }
    }
  }
}
    `;

/**
 * __useTeamCloudQuery__
 *
 * To run a query within a React component, call `useTeamCloudQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamCloudQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamCloudQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTeamCloudQuery(baseOptions: Apollo.QueryHookOptions<TeamCloudQuery, TeamCloudQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeamCloudQuery, TeamCloudQueryVariables>(TeamCloudDocument, options);
      }
export function useTeamCloudLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeamCloudQuery, TeamCloudQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeamCloudQuery, TeamCloudQueryVariables>(TeamCloudDocument, options);
        }
export type TeamCloudQueryHookResult = ReturnType<typeof useTeamCloudQuery>;
export type TeamCloudLazyQueryHookResult = ReturnType<typeof useTeamCloudLazyQuery>;
export type TeamCloudQueryResult = Apollo.QueryResult<TeamCloudQuery, TeamCloudQueryVariables>;
export function refetchTeamCloudQuery(variables: TeamCloudQueryVariables) {
      return { query: TeamCloudDocument, variables: variables }
    }
export const UserTeamDocument = gql`
    query userTeam($id: ID!) {
  currentUser {
    id
    team(id: $id) {
      id
      ...TeamDetail
    }
  }
}
    ${TeamDetailFragmentDoc}`;

/**
 * __useUserTeamQuery__
 *
 * To run a query within a React component, call `useUserTeamQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserTeamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserTeamQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserTeamQuery(baseOptions: Apollo.QueryHookOptions<UserTeamQuery, UserTeamQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserTeamQuery, UserTeamQueryVariables>(UserTeamDocument, options);
      }
export function useUserTeamLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserTeamQuery, UserTeamQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserTeamQuery, UserTeamQueryVariables>(UserTeamDocument, options);
        }
export type UserTeamQueryHookResult = ReturnType<typeof useUserTeamQuery>;
export type UserTeamLazyQueryHookResult = ReturnType<typeof useUserTeamLazyQuery>;
export type UserTeamQueryResult = Apollo.QueryResult<UserTeamQuery, UserTeamQueryVariables>;
export function refetchUserTeamQuery(variables: UserTeamQueryVariables) {
      return { query: UserTeamDocument, variables: variables }
    }
export const TeamByNameDocument = gql`
    query teamByName($name: String!) {
  team(path: $name) {
    id
    ...TeamDetail
  }
}
    ${TeamDetailFragmentDoc}`;

/**
 * __useTeamByNameQuery__
 *
 * To run a query within a React component, call `useTeamByNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamByNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamByNameQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useTeamByNameQuery(baseOptions: Apollo.QueryHookOptions<TeamByNameQuery, TeamByNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeamByNameQuery, TeamByNameQueryVariables>(TeamByNameDocument, options);
      }
export function useTeamByNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeamByNameQuery, TeamByNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeamByNameQuery, TeamByNameQueryVariables>(TeamByNameDocument, options);
        }
export type TeamByNameQueryHookResult = ReturnType<typeof useTeamByNameQuery>;
export type TeamByNameLazyQueryHookResult = ReturnType<typeof useTeamByNameLazyQuery>;
export type TeamByNameQueryResult = Apollo.QueryResult<TeamByNameQuery, TeamByNameQueryVariables>;
export function refetchTeamByNameQuery(variables: TeamByNameQueryVariables) {
      return { query: TeamByNameDocument, variables: variables }
    }
export const UserTeamsDocument = gql`
    query userTeams {
  currentUser {
    id
    email
    teams {
      id
      team {
        id
        ...TeamCommon
      }
      role
    }
  }
}
    ${TeamCommonFragmentDoc}`;

/**
 * __useUserTeamsQuery__
 *
 * To run a query within a React component, call `useUserTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserTeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserTeamsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserTeamsQuery(baseOptions?: Apollo.QueryHookOptions<UserTeamsQuery, UserTeamsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserTeamsQuery, UserTeamsQueryVariables>(UserTeamsDocument, options);
      }
export function useUserTeamsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserTeamsQuery, UserTeamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserTeamsQuery, UserTeamsQueryVariables>(UserTeamsDocument, options);
        }
export type UserTeamsQueryHookResult = ReturnType<typeof useUserTeamsQuery>;
export type UserTeamsLazyQueryHookResult = ReturnType<typeof useUserTeamsLazyQuery>;
export type UserTeamsQueryResult = Apollo.QueryResult<UserTeamsQuery, UserTeamsQueryVariables>;
export function refetchUserTeamsQuery(variables?: UserTeamsQueryVariables) {
      return { query: UserTeamsDocument, variables: variables }
    }
export const UserTeamsAnalyticsDocument = gql`
    query userTeamsAnalytics {
  currentUser {
    id
    email
    teams {
      id
      team {
        id
        name
        ...TeamCommon
        members {
          id
        }
        clusters: user {
          id
          clusters {
            id
            name
            status
          }
        }
      }
      role
    }
  }
}
    ${TeamCommonFragmentDoc}`;

/**
 * __useUserTeamsAnalyticsQuery__
 *
 * To run a query within a React component, call `useUserTeamsAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserTeamsAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserTeamsAnalyticsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserTeamsAnalyticsQuery(baseOptions?: Apollo.QueryHookOptions<UserTeamsAnalyticsQuery, UserTeamsAnalyticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserTeamsAnalyticsQuery, UserTeamsAnalyticsQueryVariables>(UserTeamsAnalyticsDocument, options);
      }
export function useUserTeamsAnalyticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserTeamsAnalyticsQuery, UserTeamsAnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserTeamsAnalyticsQuery, UserTeamsAnalyticsQueryVariables>(UserTeamsAnalyticsDocument, options);
        }
export type UserTeamsAnalyticsQueryHookResult = ReturnType<typeof useUserTeamsAnalyticsQuery>;
export type UserTeamsAnalyticsLazyQueryHookResult = ReturnType<typeof useUserTeamsAnalyticsLazyQuery>;
export type UserTeamsAnalyticsQueryResult = Apollo.QueryResult<UserTeamsAnalyticsQuery, UserTeamsAnalyticsQueryVariables>;
export function refetchUserTeamsAnalyticsQuery(variables?: UserTeamsAnalyticsQueryVariables) {
      return { query: UserTeamsAnalyticsDocument, variables: variables }
    }
export const UserTeamMemberDocument = gql`
    query userTeamMember($id: ID!) {
  currentUser {
    id
    team(id: $id) {
      id
      ...TeamCommon
      ...TeamMember
    }
  }
}
    ${TeamCommonFragmentDoc}
${TeamMemberFragmentDoc}`;

/**
 * __useUserTeamMemberQuery__
 *
 * To run a query within a React component, call `useUserTeamMemberQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserTeamMemberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserTeamMemberQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserTeamMemberQuery(baseOptions: Apollo.QueryHookOptions<UserTeamMemberQuery, UserTeamMemberQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserTeamMemberQuery, UserTeamMemberQueryVariables>(UserTeamMemberDocument, options);
      }
export function useUserTeamMemberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserTeamMemberQuery, UserTeamMemberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserTeamMemberQuery, UserTeamMemberQueryVariables>(UserTeamMemberDocument, options);
        }
export type UserTeamMemberQueryHookResult = ReturnType<typeof useUserTeamMemberQuery>;
export type UserTeamMemberLazyQueryHookResult = ReturnType<typeof useUserTeamMemberLazyQuery>;
export type UserTeamMemberQueryResult = Apollo.QueryResult<UserTeamMemberQuery, UserTeamMemberQueryVariables>;
export function refetchUserTeamMemberQuery(variables: UserTeamMemberQueryVariables) {
      return { query: UserTeamMemberDocument, variables: variables }
    }
export const NewTeamMemberSuggestionsDocument = gql`
    query newTeamMemberSuggestions {
  currentUser {
    id
    repos {
      id
      collaborators {
        id
        user {
          ...UserPublicCommon
        }
        role
      }
    }
  }
}
    ${UserPublicCommonFragmentDoc}`;

/**
 * __useNewTeamMemberSuggestionsQuery__
 *
 * To run a query within a React component, call `useNewTeamMemberSuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewTeamMemberSuggestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewTeamMemberSuggestionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useNewTeamMemberSuggestionsQuery(baseOptions?: Apollo.QueryHookOptions<NewTeamMemberSuggestionsQuery, NewTeamMemberSuggestionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NewTeamMemberSuggestionsQuery, NewTeamMemberSuggestionsQueryVariables>(NewTeamMemberSuggestionsDocument, options);
      }
export function useNewTeamMemberSuggestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NewTeamMemberSuggestionsQuery, NewTeamMemberSuggestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NewTeamMemberSuggestionsQuery, NewTeamMemberSuggestionsQueryVariables>(NewTeamMemberSuggestionsDocument, options);
        }
export type NewTeamMemberSuggestionsQueryHookResult = ReturnType<typeof useNewTeamMemberSuggestionsQuery>;
export type NewTeamMemberSuggestionsLazyQueryHookResult = ReturnType<typeof useNewTeamMemberSuggestionsLazyQuery>;
export type NewTeamMemberSuggestionsQueryResult = Apollo.QueryResult<NewTeamMemberSuggestionsQuery, NewTeamMemberSuggestionsQueryVariables>;
export function refetchNewTeamMemberSuggestionsQuery(variables?: NewTeamMemberSuggestionsQueryVariables) {
      return { query: NewTeamMemberSuggestionsDocument, variables: variables }
    }
export const NewTeamProjectSuggestionsDocument = gql`
    query newTeamProjectSuggestions {
  currentUser {
    id
    repos {
      ...RepoCommon
      volumes {
        mountPath
        size
      }
      collaborators {
        id
        user {
          id
          name
        }
        role
      }
    }
  }
}
    ${RepoCommonFragmentDoc}`;

/**
 * __useNewTeamProjectSuggestionsQuery__
 *
 * To run a query within a React component, call `useNewTeamProjectSuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewTeamProjectSuggestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewTeamProjectSuggestionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useNewTeamProjectSuggestionsQuery(baseOptions?: Apollo.QueryHookOptions<NewTeamProjectSuggestionsQuery, NewTeamProjectSuggestionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NewTeamProjectSuggestionsQuery, NewTeamProjectSuggestionsQueryVariables>(NewTeamProjectSuggestionsDocument, options);
      }
export function useNewTeamProjectSuggestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NewTeamProjectSuggestionsQuery, NewTeamProjectSuggestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NewTeamProjectSuggestionsQuery, NewTeamProjectSuggestionsQueryVariables>(NewTeamProjectSuggestionsDocument, options);
        }
export type NewTeamProjectSuggestionsQueryHookResult = ReturnType<typeof useNewTeamProjectSuggestionsQuery>;
export type NewTeamProjectSuggestionsLazyQueryHookResult = ReturnType<typeof useNewTeamProjectSuggestionsLazyQuery>;
export type NewTeamProjectSuggestionsQueryResult = Apollo.QueryResult<NewTeamProjectSuggestionsQuery, NewTeamProjectSuggestionsQueryVariables>;
export function refetchNewTeamProjectSuggestionsQuery(variables?: NewTeamProjectSuggestionsQueryVariables) {
      return { query: NewTeamProjectSuggestionsDocument, variables: variables }
    }
export const CurrentUsageMetricsDocument = gql`
    query currentUsageMetrics($id: ID!, $teamID: ID!, $permissionsUserId: UUID!, $pageInput: PageInput!) {
  user(id: $id) {
    id
    projectV3Adapters(filter: {filter: {}}) {
      totalCount
    }
    clusters {
      id
    }
    awsAccounts {
      id
    }
    coreweaveAccounts {
      id
    }
    doAccounts {
      id
    }
    gcpAccounts {
      id
    }
    linodeAccounts {
      id
    }
    vultrAccounts {
      id
    }
    blueprints(page: $pageInput) {
      totalCount
      nodes {
        id
        owner {
          login
        }
      }
    }
  }
  currentUser {
    id
    permissions {
      user(userID: $permissionsUserId) {
        mutations
      }
    }
    team(id: $teamID) {
      id
      ...TeamMember
    }
  }
}
    ${TeamMemberFragmentDoc}`;

/**
 * __useCurrentUsageMetricsQuery__
 *
 * To run a query within a React component, call `useCurrentUsageMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUsageMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUsageMetricsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      teamID: // value for 'teamID'
 *      permissionsUserId: // value for 'permissionsUserId'
 *      pageInput: // value for 'pageInput'
 *   },
 * });
 */
export function useCurrentUsageMetricsQuery(baseOptions: Apollo.QueryHookOptions<CurrentUsageMetricsQuery, CurrentUsageMetricsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUsageMetricsQuery, CurrentUsageMetricsQueryVariables>(CurrentUsageMetricsDocument, options);
      }
export function useCurrentUsageMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUsageMetricsQuery, CurrentUsageMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUsageMetricsQuery, CurrentUsageMetricsQueryVariables>(CurrentUsageMetricsDocument, options);
        }
export type CurrentUsageMetricsQueryHookResult = ReturnType<typeof useCurrentUsageMetricsQuery>;
export type CurrentUsageMetricsLazyQueryHookResult = ReturnType<typeof useCurrentUsageMetricsLazyQuery>;
export type CurrentUsageMetricsQueryResult = Apollo.QueryResult<CurrentUsageMetricsQuery, CurrentUsageMetricsQueryVariables>;
export function refetchCurrentUsageMetricsQuery(variables: CurrentUsageMetricsQueryVariables) {
      return { query: CurrentUsageMetricsDocument, variables: variables }
    }
export const TemplateDocument = gql`
    query template($id: UUID, $slug: String, $url: String) {
  template(id: $id, slug: $slug, url: $url) {
    id
    ...TemplateCommon
  }
}
    ${TemplateCommonFragmentDoc}`;

/**
 * __useTemplateQuery__
 *
 * To run a query within a React component, call `useTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTemplateQuery({
 *   variables: {
 *      id: // value for 'id'
 *      slug: // value for 'slug'
 *      url: // value for 'url'
 *   },
 * });
 */
export function useTemplateQuery(baseOptions?: Apollo.QueryHookOptions<TemplateQuery, TemplateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TemplateQuery, TemplateQueryVariables>(TemplateDocument, options);
      }
export function useTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TemplateQuery, TemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TemplateQuery, TemplateQueryVariables>(TemplateDocument, options);
        }
export type TemplateQueryHookResult = ReturnType<typeof useTemplateQuery>;
export type TemplateLazyQueryHookResult = ReturnType<typeof useTemplateLazyQuery>;
export type TemplateQueryResult = Apollo.QueryResult<TemplateQuery, TemplateQueryVariables>;
export function refetchTemplateQuery(variables?: TemplateQueryVariables) {
      return { query: TemplateDocument, variables: variables }
    }
export const SuggestTemplateNameDocument = gql`
    query suggestTemplateName($user: ID!, $input: SuggestTemplateNameInput!) {
  user(id: $user) {
    id
    suggestTemplateName(input: $input)
  }
}
    `;

/**
 * __useSuggestTemplateNameQuery__
 *
 * To run a query within a React component, call `useSuggestTemplateNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuggestTemplateNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuggestTemplateNameQuery({
 *   variables: {
 *      user: // value for 'user'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSuggestTemplateNameQuery(baseOptions: Apollo.QueryHookOptions<SuggestTemplateNameQuery, SuggestTemplateNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SuggestTemplateNameQuery, SuggestTemplateNameQueryVariables>(SuggestTemplateNameDocument, options);
      }
export function useSuggestTemplateNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SuggestTemplateNameQuery, SuggestTemplateNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SuggestTemplateNameQuery, SuggestTemplateNameQueryVariables>(SuggestTemplateNameDocument, options);
        }
export type SuggestTemplateNameQueryHookResult = ReturnType<typeof useSuggestTemplateNameQuery>;
export type SuggestTemplateNameLazyQueryHookResult = ReturnType<typeof useSuggestTemplateNameLazyQuery>;
export type SuggestTemplateNameQueryResult = Apollo.QueryResult<SuggestTemplateNameQuery, SuggestTemplateNameQueryVariables>;
export function refetchSuggestTemplateNameQuery(variables: SuggestTemplateNameQueryVariables) {
      return { query: SuggestTemplateNameDocument, variables: variables }
    }
export const CurrentUserDocument = gql`
    query currentUser {
  currentUser {
    id
    ...UserDetail
  }
}
    ${UserDetailFragmentDoc}`;

/**
 * __useCurrentUserQuery__
 *
 * To run a query within a React component, call `useCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
      }
export function useCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
        }
export type CurrentUserQueryHookResult = ReturnType<typeof useCurrentUserQuery>;
export type CurrentUserLazyQueryHookResult = ReturnType<typeof useCurrentUserLazyQuery>;
export type CurrentUserQueryResult = Apollo.QueryResult<CurrentUserQuery, CurrentUserQueryVariables>;
export function refetchCurrentUserQuery(variables?: CurrentUserQueryVariables) {
      return { query: CurrentUserDocument, variables: variables }
    }
export const UserDocument = gql`
    query user($id: ID!) {
  user(id: $id) {
    id
    ...UserDetail
  }
}
    ${UserDetailFragmentDoc}`;

/**
 * __useUserQuery__
 *
 * To run a query within a React component, call `useUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserQuery(baseOptions: Apollo.QueryHookOptions<UserQuery, UserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserQuery, UserQueryVariables>(UserDocument, options);
      }
export function useUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserQuery, UserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserQuery, UserQueryVariables>(UserDocument, options);
        }
export type UserQueryHookResult = ReturnType<typeof useUserQuery>;
export type UserLazyQueryHookResult = ReturnType<typeof useUserLazyQuery>;
export type UserQueryResult = Apollo.QueryResult<UserQuery, UserQueryVariables>;
export function refetchUserQuery(variables: UserQueryVariables) {
      return { query: UserDocument, variables: variables }
    }
export const FreeQuotaDocument = gql`
    query freeQuota($id: ID!) {
  user(id: $id) {
    id
    freeQuota
  }
}
    `;

/**
 * __useFreeQuotaQuery__
 *
 * To run a query within a React component, call `useFreeQuotaQuery` and pass it any options that fit your needs.
 * When your component renders, `useFreeQuotaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFreeQuotaQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFreeQuotaQuery(baseOptions: Apollo.QueryHookOptions<FreeQuotaQuery, FreeQuotaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FreeQuotaQuery, FreeQuotaQueryVariables>(FreeQuotaDocument, options);
      }
export function useFreeQuotaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FreeQuotaQuery, FreeQuotaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FreeQuotaQuery, FreeQuotaQueryVariables>(FreeQuotaDocument, options);
        }
export type FreeQuotaQueryHookResult = ReturnType<typeof useFreeQuotaQuery>;
export type FreeQuotaLazyQueryHookResult = ReturnType<typeof useFreeQuotaLazyQuery>;
export type FreeQuotaQueryResult = Apollo.QueryResult<FreeQuotaQuery, FreeQuotaQueryVariables>;
export function refetchFreeQuotaQuery(variables: FreeQuotaQueryVariables) {
      return { query: FreeQuotaDocument, variables: variables }
    }
export const UserBillingDocument = gql`
    query userBilling($id: ID!) {
  user(id: $id) {
    id
    billingURL
  }
}
    `;

/**
 * __useUserBillingQuery__
 *
 * To run a query within a React component, call `useUserBillingQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserBillingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserBillingQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserBillingQuery(baseOptions: Apollo.QueryHookOptions<UserBillingQuery, UserBillingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserBillingQuery, UserBillingQueryVariables>(UserBillingDocument, options);
      }
export function useUserBillingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserBillingQuery, UserBillingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserBillingQuery, UserBillingQueryVariables>(UserBillingDocument, options);
        }
export type UserBillingQueryHookResult = ReturnType<typeof useUserBillingQuery>;
export type UserBillingLazyQueryHookResult = ReturnType<typeof useUserBillingLazyQuery>;
export type UserBillingQueryResult = Apollo.QueryResult<UserBillingQuery, UserBillingQueryVariables>;
export function refetchUserBillingQuery(variables: UserBillingQueryVariables) {
      return { query: UserBillingDocument, variables: variables }
    }
export const UserBalanceDocument = gql`
    query userBalance($id: ID!) {
  user(id: $id) {
    id
    stripe {
      id
      balance
    }
  }
}
    `;

/**
 * __useUserBalanceQuery__
 *
 * To run a query within a React component, call `useUserBalanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserBalanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserBalanceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserBalanceQuery(baseOptions: Apollo.QueryHookOptions<UserBalanceQuery, UserBalanceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserBalanceQuery, UserBalanceQueryVariables>(UserBalanceDocument, options);
      }
export function useUserBalanceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserBalanceQuery, UserBalanceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserBalanceQuery, UserBalanceQueryVariables>(UserBalanceDocument, options);
        }
export type UserBalanceQueryHookResult = ReturnType<typeof useUserBalanceQuery>;
export type UserBalanceLazyQueryHookResult = ReturnType<typeof useUserBalanceLazyQuery>;
export type UserBalanceQueryResult = Apollo.QueryResult<UserBalanceQuery, UserBalanceQueryVariables>;
export function refetchUserBalanceQuery(variables: UserBalanceQueryVariables) {
      return { query: UserBalanceDocument, variables: variables }
    }
export const AwsPolicyJsonDocument = gql`
    query awsPolicyJson($userId: ID!, $awsAccountId: UUID!, $awsPolicyJsonInput: awsPolicyJsonInput!) {
  user(id: $userId) {
    id
    awsAccount(id: $awsAccountId) {
      id
      awsPolicyJson(input: $awsPolicyJsonInput) {
        awsPolicyJson
      }
    }
  }
}
    `;

/**
 * __useAwsPolicyJsonQuery__
 *
 * To run a query within a React component, call `useAwsPolicyJsonQuery` and pass it any options that fit your needs.
 * When your component renders, `useAwsPolicyJsonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAwsPolicyJsonQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      awsAccountId: // value for 'awsAccountId'
 *      awsPolicyJsonInput: // value for 'awsPolicyJsonInput'
 *   },
 * });
 */
export function useAwsPolicyJsonQuery(baseOptions: Apollo.QueryHookOptions<AwsPolicyJsonQuery, AwsPolicyJsonQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AwsPolicyJsonQuery, AwsPolicyJsonQueryVariables>(AwsPolicyJsonDocument, options);
      }
export function useAwsPolicyJsonLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AwsPolicyJsonQuery, AwsPolicyJsonQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AwsPolicyJsonQuery, AwsPolicyJsonQueryVariables>(AwsPolicyJsonDocument, options);
        }
export type AwsPolicyJsonQueryHookResult = ReturnType<typeof useAwsPolicyJsonQuery>;
export type AwsPolicyJsonLazyQueryHookResult = ReturnType<typeof useAwsPolicyJsonLazyQuery>;
export type AwsPolicyJsonQueryResult = Apollo.QueryResult<AwsPolicyJsonQuery, AwsPolicyJsonQueryVariables>;
export function refetchAwsPolicyJsonQuery(variables: AwsPolicyJsonQueryVariables) {
      return { query: AwsPolicyJsonDocument, variables: variables }
    }
export const UserAwsAccountConnectedDocument = gql`
    query userAwsAccountConnected($id: ID!, $awsAccountId: UUID!) {
  user(id: $id) {
    id
    awsAccount(id: $awsAccountId) {
      id
      connected
      cloudFormationURL
    }
  }
}
    `;

/**
 * __useUserAwsAccountConnectedQuery__
 *
 * To run a query within a React component, call `useUserAwsAccountConnectedQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserAwsAccountConnectedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserAwsAccountConnectedQuery({
 *   variables: {
 *      id: // value for 'id'
 *      awsAccountId: // value for 'awsAccountId'
 *   },
 * });
 */
export function useUserAwsAccountConnectedQuery(baseOptions: Apollo.QueryHookOptions<UserAwsAccountConnectedQuery, UserAwsAccountConnectedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserAwsAccountConnectedQuery, UserAwsAccountConnectedQueryVariables>(UserAwsAccountConnectedDocument, options);
      }
export function useUserAwsAccountConnectedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserAwsAccountConnectedQuery, UserAwsAccountConnectedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserAwsAccountConnectedQuery, UserAwsAccountConnectedQueryVariables>(UserAwsAccountConnectedDocument, options);
        }
export type UserAwsAccountConnectedQueryHookResult = ReturnType<typeof useUserAwsAccountConnectedQuery>;
export type UserAwsAccountConnectedLazyQueryHookResult = ReturnType<typeof useUserAwsAccountConnectedLazyQuery>;
export type UserAwsAccountConnectedQueryResult = Apollo.QueryResult<UserAwsAccountConnectedQuery, UserAwsAccountConnectedQueryVariables>;
export function refetchUserAwsAccountConnectedQuery(variables: UserAwsAccountConnectedQueryVariables) {
      return { query: UserAwsAccountConnectedDocument, variables: variables }
    }
export const UserCrispAuthDocument = gql`
    query userCrispAuth($id: ID!) {
  user(id: $id) {
    id
    crispAuth {
      email
      hmac
      nickname
      participants
    }
  }
}
    `;

/**
 * __useUserCrispAuthQuery__
 *
 * To run a query within a React component, call `useUserCrispAuthQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserCrispAuthQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserCrispAuthQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserCrispAuthQuery(baseOptions: Apollo.QueryHookOptions<UserCrispAuthQuery, UserCrispAuthQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserCrispAuthQuery, UserCrispAuthQueryVariables>(UserCrispAuthDocument, options);
      }
export function useUserCrispAuthLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserCrispAuthQuery, UserCrispAuthQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserCrispAuthQuery, UserCrispAuthQueryVariables>(UserCrispAuthDocument, options);
        }
export type UserCrispAuthQueryHookResult = ReturnType<typeof useUserCrispAuthQuery>;
export type UserCrispAuthLazyQueryHookResult = ReturnType<typeof useUserCrispAuthLazyQuery>;
export type UserCrispAuthQueryResult = Apollo.QueryResult<UserCrispAuthQuery, UserCrispAuthQueryVariables>;
export function refetchUserCrispAuthQuery(variables: UserCrispAuthQueryVariables) {
      return { query: UserCrispAuthDocument, variables: variables }
    }
export const UserBranchResourcesDocument = gql`
    query userBranchResources($repoId: ID!, $branch: String) {
  currentUser {
    id
    repo(id: $repoId) {
      id
      branch(name: $branch) {
        id
        resources {
          id
          resourceType
          shared
          region
        }
      }
    }
  }
}
    `;

/**
 * __useUserBranchResourcesQuery__
 *
 * To run a query within a React component, call `useUserBranchResourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserBranchResourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserBranchResourcesQuery({
 *   variables: {
 *      repoId: // value for 'repoId'
 *      branch: // value for 'branch'
 *   },
 * });
 */
export function useUserBranchResourcesQuery(baseOptions: Apollo.QueryHookOptions<UserBranchResourcesQuery, UserBranchResourcesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserBranchResourcesQuery, UserBranchResourcesQueryVariables>(UserBranchResourcesDocument, options);
      }
export function useUserBranchResourcesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserBranchResourcesQuery, UserBranchResourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserBranchResourcesQuery, UserBranchResourcesQueryVariables>(UserBranchResourcesDocument, options);
        }
export type UserBranchResourcesQueryHookResult = ReturnType<typeof useUserBranchResourcesQuery>;
export type UserBranchResourcesLazyQueryHookResult = ReturnType<typeof useUserBranchResourcesLazyQuery>;
export type UserBranchResourcesQueryResult = Apollo.QueryResult<UserBranchResourcesQuery, UserBranchResourcesQueryVariables>;
export function refetchUserBranchResourcesQuery(variables: UserBranchResourcesQueryVariables) {
      return { query: UserBranchResourcesDocument, variables: variables }
    }
export const UserRepoDocument = gql`
    query userRepo($id: ID!) {
  currentUser {
    id
    repo(id: $id) {
      id
      ...RepoDetail
    }
  }
}
    ${RepoDetailFragmentDoc}`;

/**
 * __useUserRepoQuery__
 *
 * To run a query within a React component, call `useUserRepoQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserRepoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserRepoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserRepoQuery(baseOptions: Apollo.QueryHookOptions<UserRepoQuery, UserRepoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserRepoQuery, UserRepoQueryVariables>(UserRepoDocument, options);
      }
export function useUserRepoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserRepoQuery, UserRepoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserRepoQuery, UserRepoQueryVariables>(UserRepoDocument, options);
        }
export type UserRepoQueryHookResult = ReturnType<typeof useUserRepoQuery>;
export type UserRepoLazyQueryHookResult = ReturnType<typeof useUserRepoLazyQuery>;
export type UserRepoQueryResult = Apollo.QueryResult<UserRepoQuery, UserRepoQueryVariables>;
export function refetchUserRepoQuery(variables: UserRepoQueryVariables) {
      return { query: UserRepoDocument, variables: variables }
    }
export const UserRepoCloudOnboardByPathDocument = gql`
    query userRepoCloudOnboardByPath($projectPath: String, $projectId: UUID, $repoName: String!) {
  project(path: $projectPath, id: $projectId) {
    id
    repo(name: $repoName) {
      id
      ...RepoDeploy
    }
  }
}
    ${RepoDeployFragmentDoc}`;

/**
 * __useUserRepoCloudOnboardByPathQuery__
 *
 * To run a query within a React component, call `useUserRepoCloudOnboardByPathQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserRepoCloudOnboardByPathQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserRepoCloudOnboardByPathQuery({
 *   variables: {
 *      projectPath: // value for 'projectPath'
 *      projectId: // value for 'projectId'
 *      repoName: // value for 'repoName'
 *   },
 * });
 */
export function useUserRepoCloudOnboardByPathQuery(baseOptions: Apollo.QueryHookOptions<UserRepoCloudOnboardByPathQuery, UserRepoCloudOnboardByPathQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserRepoCloudOnboardByPathQuery, UserRepoCloudOnboardByPathQueryVariables>(UserRepoCloudOnboardByPathDocument, options);
      }
export function useUserRepoCloudOnboardByPathLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserRepoCloudOnboardByPathQuery, UserRepoCloudOnboardByPathQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserRepoCloudOnboardByPathQuery, UserRepoCloudOnboardByPathQueryVariables>(UserRepoCloudOnboardByPathDocument, options);
        }
export type UserRepoCloudOnboardByPathQueryHookResult = ReturnType<typeof useUserRepoCloudOnboardByPathQuery>;
export type UserRepoCloudOnboardByPathLazyQueryHookResult = ReturnType<typeof useUserRepoCloudOnboardByPathLazyQuery>;
export type UserRepoCloudOnboardByPathQueryResult = Apollo.QueryResult<UserRepoCloudOnboardByPathQuery, UserRepoCloudOnboardByPathQueryVariables>;
export function refetchUserRepoCloudOnboardByPathQuery(variables: UserRepoCloudOnboardByPathQueryVariables) {
      return { query: UserRepoCloudOnboardByPathDocument, variables: variables }
    }
export const RepoForProjectEnvironmentDocument = gql`
    query repoForProjectEnvironment($path: String!, $environment: String!, $repo: String!) {
  project(path: $path) {
    id
    environment(name: $environment) {
      id
      name
      repo(name: $repo) {
        ...RepoDetail
      }
    }
  }
}
    ${RepoDetailFragmentDoc}`;

/**
 * __useRepoForProjectEnvironmentQuery__
 *
 * To run a query within a React component, call `useRepoForProjectEnvironmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useRepoForProjectEnvironmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRepoForProjectEnvironmentQuery({
 *   variables: {
 *      path: // value for 'path'
 *      environment: // value for 'environment'
 *      repo: // value for 'repo'
 *   },
 * });
 */
export function useRepoForProjectEnvironmentQuery(baseOptions: Apollo.QueryHookOptions<RepoForProjectEnvironmentQuery, RepoForProjectEnvironmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RepoForProjectEnvironmentQuery, RepoForProjectEnvironmentQueryVariables>(RepoForProjectEnvironmentDocument, options);
      }
export function useRepoForProjectEnvironmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RepoForProjectEnvironmentQuery, RepoForProjectEnvironmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RepoForProjectEnvironmentQuery, RepoForProjectEnvironmentQueryVariables>(RepoForProjectEnvironmentDocument, options);
        }
export type RepoForProjectEnvironmentQueryHookResult = ReturnType<typeof useRepoForProjectEnvironmentQuery>;
export type RepoForProjectEnvironmentLazyQueryHookResult = ReturnType<typeof useRepoForProjectEnvironmentLazyQuery>;
export type RepoForProjectEnvironmentQueryResult = Apollo.QueryResult<RepoForProjectEnvironmentQuery, RepoForProjectEnvironmentQueryVariables>;
export function refetchRepoForProjectEnvironmentQuery(variables: RepoForProjectEnvironmentQueryVariables) {
      return { query: RepoForProjectEnvironmentDocument, variables: variables }
    }
export const RepoOverviewDocument = gql`
    query repoOverview($path: String!, $environment: String!, $repo: String!) {
  project(path: $path) {
    id
    environment(name: $environment) {
      id
      name
      repo(name: $repo) {
        id
        deployTarget
        deployType
        source {
          id
          type
        }
        jobRuns {
          totalCount
        }
        deployService
      }
    }
  }
}
    `;

/**
 * __useRepoOverviewQuery__
 *
 * To run a query within a React component, call `useRepoOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useRepoOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRepoOverviewQuery({
 *   variables: {
 *      path: // value for 'path'
 *      environment: // value for 'environment'
 *      repo: // value for 'repo'
 *   },
 * });
 */
export function useRepoOverviewQuery(baseOptions: Apollo.QueryHookOptions<RepoOverviewQuery, RepoOverviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RepoOverviewQuery, RepoOverviewQueryVariables>(RepoOverviewDocument, options);
      }
export function useRepoOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RepoOverviewQuery, RepoOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RepoOverviewQuery, RepoOverviewQueryVariables>(RepoOverviewDocument, options);
        }
export type RepoOverviewQueryHookResult = ReturnType<typeof useRepoOverviewQuery>;
export type RepoOverviewLazyQueryHookResult = ReturnType<typeof useRepoOverviewLazyQuery>;
export type RepoOverviewQueryResult = Apollo.QueryResult<RepoOverviewQuery, RepoOverviewQueryVariables>;
export function refetchRepoOverviewQuery(variables: RepoOverviewQueryVariables) {
      return { query: RepoOverviewDocument, variables: variables }
    }
export const RepoForProjectDocument = gql`
    query repoForProject($path: String!, $repo: String!) {
  project(path: $path) {
    id
    repo(name: $repo) {
      ...RepoDetail
    }
  }
}
    ${RepoDetailFragmentDoc}`;

/**
 * __useRepoForProjectQuery__
 *
 * To run a query within a React component, call `useRepoForProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useRepoForProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRepoForProjectQuery({
 *   variables: {
 *      path: // value for 'path'
 *      repo: // value for 'repo'
 *   },
 * });
 */
export function useRepoForProjectQuery(baseOptions: Apollo.QueryHookOptions<RepoForProjectQuery, RepoForProjectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RepoForProjectQuery, RepoForProjectQueryVariables>(RepoForProjectDocument, options);
      }
export function useRepoForProjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RepoForProjectQuery, RepoForProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RepoForProjectQuery, RepoForProjectQueryVariables>(RepoForProjectDocument, options);
        }
export type RepoForProjectQueryHookResult = ReturnType<typeof useRepoForProjectQuery>;
export type RepoForProjectLazyQueryHookResult = ReturnType<typeof useRepoForProjectLazyQuery>;
export type RepoForProjectQueryResult = Apollo.QueryResult<RepoForProjectQuery, RepoForProjectQueryVariables>;
export function refetchRepoForProjectQuery(variables: RepoForProjectQueryVariables) {
      return { query: RepoForProjectDocument, variables: variables }
    }
export const RepoPrometheusDocument = gql`
    query repoPrometheus($userID: ID!, $clusterID: UUID!, $repoID: ID!) {
  user(id: $userID) {
    id
    cluster(id: $clusterID) {
      id
      prometheus {
        url
        user
        password
        token
      }
    }
    repo(id: $repoID) {
      id
      kappID
    }
  }
}
    `;

/**
 * __useRepoPrometheusQuery__
 *
 * To run a query within a React component, call `useRepoPrometheusQuery` and pass it any options that fit your needs.
 * When your component renders, `useRepoPrometheusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRepoPrometheusQuery({
 *   variables: {
 *      userID: // value for 'userID'
 *      clusterID: // value for 'clusterID'
 *      repoID: // value for 'repoID'
 *   },
 * });
 */
export function useRepoPrometheusQuery(baseOptions: Apollo.QueryHookOptions<RepoPrometheusQuery, RepoPrometheusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RepoPrometheusQuery, RepoPrometheusQueryVariables>(RepoPrometheusDocument, options);
      }
export function useRepoPrometheusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RepoPrometheusQuery, RepoPrometheusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RepoPrometheusQuery, RepoPrometheusQueryVariables>(RepoPrometheusDocument, options);
        }
export type RepoPrometheusQueryHookResult = ReturnType<typeof useRepoPrometheusQuery>;
export type RepoPrometheusLazyQueryHookResult = ReturnType<typeof useRepoPrometheusLazyQuery>;
export type RepoPrometheusQueryResult = Apollo.QueryResult<RepoPrometheusQuery, RepoPrometheusQueryVariables>;
export function refetchRepoPrometheusQuery(variables: RepoPrometheusQueryVariables) {
      return { query: RepoPrometheusDocument, variables: variables }
    }
export const RepoDeployRevisionsDocument = gql`
    query repoDeployRevisions($repoId: ID!) {
  currentUser {
    id
    repo(id: $repoId) {
      id
      deploymentConfigurationRevisions(page: {first: 50}) {
        pageInfo {
          hasNextPage
        }
        totalCount
        nodes {
          ...RevisableEntityCommonFragment
        }
      }
    }
  }
}
    ${RevisableEntityCommonFragmentFragmentDoc}`;

/**
 * __useRepoDeployRevisionsQuery__
 *
 * To run a query within a React component, call `useRepoDeployRevisionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRepoDeployRevisionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRepoDeployRevisionsQuery({
 *   variables: {
 *      repoId: // value for 'repoId'
 *   },
 * });
 */
export function useRepoDeployRevisionsQuery(baseOptions: Apollo.QueryHookOptions<RepoDeployRevisionsQuery, RepoDeployRevisionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RepoDeployRevisionsQuery, RepoDeployRevisionsQueryVariables>(RepoDeployRevisionsDocument, options);
      }
export function useRepoDeployRevisionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RepoDeployRevisionsQuery, RepoDeployRevisionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RepoDeployRevisionsQuery, RepoDeployRevisionsQueryVariables>(RepoDeployRevisionsDocument, options);
        }
export type RepoDeployRevisionsQueryHookResult = ReturnType<typeof useRepoDeployRevisionsQuery>;
export type RepoDeployRevisionsLazyQueryHookResult = ReturnType<typeof useRepoDeployRevisionsLazyQuery>;
export type RepoDeployRevisionsQueryResult = Apollo.QueryResult<RepoDeployRevisionsQuery, RepoDeployRevisionsQueryVariables>;
export function refetchRepoDeployRevisionsQuery(variables: RepoDeployRevisionsQueryVariables) {
      return { query: RepoDeployRevisionsDocument, variables: variables }
    }
export const UserRepoBranchesV2Document = gql`
    query userRepoBranchesV2($id: ID!, $branch: String, $withBranch: Boolean!, $after: String!, $first: Int!) {
  currentUser {
    id
    repo(id: $id) {
      id
      productionBranchV2 @skip(if: $withBranch) {
        id
        deployments(page: {after: $after, first: $first}) {
          ...RepoBranchDeployments
        }
      }
      branch(name: $branch) @include(if: $withBranch) {
        id
        deployments(page: {after: $after, first: $first}) {
          ...RepoBranchDeployments
        }
      }
    }
  }
}
    ${RepoBranchDeploymentsFragmentDoc}`;

/**
 * __useUserRepoBranchesV2Query__
 *
 * To run a query within a React component, call `useUserRepoBranchesV2Query` and pass it any options that fit your needs.
 * When your component renders, `useUserRepoBranchesV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserRepoBranchesV2Query({
 *   variables: {
 *      id: // value for 'id'
 *      branch: // value for 'branch'
 *      withBranch: // value for 'withBranch'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useUserRepoBranchesV2Query(baseOptions: Apollo.QueryHookOptions<UserRepoBranchesV2Query, UserRepoBranchesV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserRepoBranchesV2Query, UserRepoBranchesV2QueryVariables>(UserRepoBranchesV2Document, options);
      }
export function useUserRepoBranchesV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserRepoBranchesV2Query, UserRepoBranchesV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserRepoBranchesV2Query, UserRepoBranchesV2QueryVariables>(UserRepoBranchesV2Document, options);
        }
export type UserRepoBranchesV2QueryHookResult = ReturnType<typeof useUserRepoBranchesV2Query>;
export type UserRepoBranchesV2LazyQueryHookResult = ReturnType<typeof useUserRepoBranchesV2LazyQuery>;
export type UserRepoBranchesV2QueryResult = Apollo.QueryResult<UserRepoBranchesV2Query, UserRepoBranchesV2QueryVariables>;
export function refetchUserRepoBranchesV2Query(variables: UserRepoBranchesV2QueryVariables) {
      return { query: UserRepoBranchesV2Document, variables: variables }
    }
export const UserRepoDeploymentsDocument = gql`
    query userRepoDeployments($id: ID!, $branch: String) {
  currentUser {
    id
    repo(id: $id) {
      id
      deployments(input: {branch: $branch}) {
        id
        ...DeploymentCommon
        awsLinks {
          cloudwatchLogs
        }
        gcpLinks {
          cloudLogging
        }
      }
    }
  }
}
    ${DeploymentCommonFragmentDoc}`;

/**
 * __useUserRepoDeploymentsQuery__
 *
 * To run a query within a React component, call `useUserRepoDeploymentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserRepoDeploymentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserRepoDeploymentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      branch: // value for 'branch'
 *   },
 * });
 */
export function useUserRepoDeploymentsQuery(baseOptions: Apollo.QueryHookOptions<UserRepoDeploymentsQuery, UserRepoDeploymentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserRepoDeploymentsQuery, UserRepoDeploymentsQueryVariables>(UserRepoDeploymentsDocument, options);
      }
export function useUserRepoDeploymentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserRepoDeploymentsQuery, UserRepoDeploymentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserRepoDeploymentsQuery, UserRepoDeploymentsQueryVariables>(UserRepoDeploymentsDocument, options);
        }
export type UserRepoDeploymentsQueryHookResult = ReturnType<typeof useUserRepoDeploymentsQuery>;
export type UserRepoDeploymentsLazyQueryHookResult = ReturnType<typeof useUserRepoDeploymentsLazyQuery>;
export type UserRepoDeploymentsQueryResult = Apollo.QueryResult<UserRepoDeploymentsQuery, UserRepoDeploymentsQueryVariables>;
export function refetchUserRepoDeploymentsQuery(variables: UserRepoDeploymentsQueryVariables) {
      return { query: UserRepoDeploymentsDocument, variables: variables }
    }
export const UserReposDocument = gql`
    query userRepos($id: ID!) {
  user(id: $id) {
    id
    repos(input: {showDisabled: true}) {
      id
      ...RepoListItem
    }
  }
}
    ${RepoListItemFragmentDoc}`;

/**
 * __useUserReposQuery__
 *
 * To run a query within a React component, call `useUserReposQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserReposQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserReposQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserReposQuery(baseOptions: Apollo.QueryHookOptions<UserReposQuery, UserReposQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserReposQuery, UserReposQueryVariables>(UserReposDocument, options);
      }
export function useUserReposLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserReposQuery, UserReposQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserReposQuery, UserReposQueryVariables>(UserReposDocument, options);
        }
export type UserReposQueryHookResult = ReturnType<typeof useUserReposQuery>;
export type UserReposLazyQueryHookResult = ReturnType<typeof useUserReposLazyQuery>;
export type UserReposQueryResult = Apollo.QueryResult<UserReposQuery, UserReposQueryVariables>;
export function refetchUserReposQuery(variables: UserReposQueryVariables) {
      return { query: UserReposDocument, variables: variables }
    }
export const ReposForProjectEnvironmentDocument = gql`
    query reposForProjectEnvironment($path: String!, $environment: String!) {
  project(path: $path) {
    id
    environment(name: $environment) {
      id
      name
      repos {
        ...RepoListItem
      }
    }
  }
}
    ${RepoListItemFragmentDoc}`;

/**
 * __useReposForProjectEnvironmentQuery__
 *
 * To run a query within a React component, call `useReposForProjectEnvironmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useReposForProjectEnvironmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReposForProjectEnvironmentQuery({
 *   variables: {
 *      path: // value for 'path'
 *      environment: // value for 'environment'
 *   },
 * });
 */
export function useReposForProjectEnvironmentQuery(baseOptions: Apollo.QueryHookOptions<ReposForProjectEnvironmentQuery, ReposForProjectEnvironmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReposForProjectEnvironmentQuery, ReposForProjectEnvironmentQueryVariables>(ReposForProjectEnvironmentDocument, options);
      }
export function useReposForProjectEnvironmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReposForProjectEnvironmentQuery, ReposForProjectEnvironmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReposForProjectEnvironmentQuery, ReposForProjectEnvironmentQueryVariables>(ReposForProjectEnvironmentDocument, options);
        }
export type ReposForProjectEnvironmentQueryHookResult = ReturnType<typeof useReposForProjectEnvironmentQuery>;
export type ReposForProjectEnvironmentLazyQueryHookResult = ReturnType<typeof useReposForProjectEnvironmentLazyQuery>;
export type ReposForProjectEnvironmentQueryResult = Apollo.QueryResult<ReposForProjectEnvironmentQuery, ReposForProjectEnvironmentQueryVariables>;
export function refetchReposForProjectEnvironmentQuery(variables: ReposForProjectEnvironmentQueryVariables) {
      return { query: ReposForProjectEnvironmentDocument, variables: variables }
    }
export const ReposForProjectEnvironmentBasicDocument = gql`
    query reposForProjectEnvironmentBasic($path: String!, $environment: String!) {
  project(path: $path) {
    id
    environment(name: $environment) {
      id
      name
      repos {
        ...RepoBasic
      }
    }
  }
}
    ${RepoBasicFragmentDoc}`;

/**
 * __useReposForProjectEnvironmentBasicQuery__
 *
 * To run a query within a React component, call `useReposForProjectEnvironmentBasicQuery` and pass it any options that fit your needs.
 * When your component renders, `useReposForProjectEnvironmentBasicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReposForProjectEnvironmentBasicQuery({
 *   variables: {
 *      path: // value for 'path'
 *      environment: // value for 'environment'
 *   },
 * });
 */
export function useReposForProjectEnvironmentBasicQuery(baseOptions: Apollo.QueryHookOptions<ReposForProjectEnvironmentBasicQuery, ReposForProjectEnvironmentBasicQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReposForProjectEnvironmentBasicQuery, ReposForProjectEnvironmentBasicQueryVariables>(ReposForProjectEnvironmentBasicDocument, options);
      }
export function useReposForProjectEnvironmentBasicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReposForProjectEnvironmentBasicQuery, ReposForProjectEnvironmentBasicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReposForProjectEnvironmentBasicQuery, ReposForProjectEnvironmentBasicQueryVariables>(ReposForProjectEnvironmentBasicDocument, options);
        }
export type ReposForProjectEnvironmentBasicQueryHookResult = ReturnType<typeof useReposForProjectEnvironmentBasicQuery>;
export type ReposForProjectEnvironmentBasicLazyQueryHookResult = ReturnType<typeof useReposForProjectEnvironmentBasicLazyQuery>;
export type ReposForProjectEnvironmentBasicQueryResult = Apollo.QueryResult<ReposForProjectEnvironmentBasicQuery, ReposForProjectEnvironmentBasicQueryVariables>;
export function refetchReposForProjectEnvironmentBasicQuery(variables: ReposForProjectEnvironmentBasicQueryVariables) {
      return { query: ReposForProjectEnvironmentBasicDocument, variables: variables }
    }
export const PaginatedReposForProjectEnvironmentDocument = gql`
    query paginatedReposForProjectEnvironment($path: String!, $environment: String!, $filter: String!, $first: Int!, $after: String!, $sort: String, $statusFilter: [DeploymentStatus]) {
  project(path: $path) {
    id
    environment(name: $environment) {
      id
      name
      overview {
        deploymentStatus
        count
      }
      repoConnection(
        page: {first: $first, after: $after, filter: $filter, sort: $sort}
        repoFilter: {deploymentStatus: $statusFilter}
      ) {
        totalCount
        nodes {
          ...RepoCommon
        }
        pageInfo {
          startCursor
          endCursor
          hasNextPage
          hasPreviousPage
        }
      }
    }
  }
}
    ${RepoCommonFragmentDoc}`;

/**
 * __usePaginatedReposForProjectEnvironmentQuery__
 *
 * To run a query within a React component, call `usePaginatedReposForProjectEnvironmentQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedReposForProjectEnvironmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedReposForProjectEnvironmentQuery({
 *   variables: {
 *      path: // value for 'path'
 *      environment: // value for 'environment'
 *      filter: // value for 'filter'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      sort: // value for 'sort'
 *      statusFilter: // value for 'statusFilter'
 *   },
 * });
 */
export function usePaginatedReposForProjectEnvironmentQuery(baseOptions: Apollo.QueryHookOptions<PaginatedReposForProjectEnvironmentQuery, PaginatedReposForProjectEnvironmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaginatedReposForProjectEnvironmentQuery, PaginatedReposForProjectEnvironmentQueryVariables>(PaginatedReposForProjectEnvironmentDocument, options);
      }
export function usePaginatedReposForProjectEnvironmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaginatedReposForProjectEnvironmentQuery, PaginatedReposForProjectEnvironmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaginatedReposForProjectEnvironmentQuery, PaginatedReposForProjectEnvironmentQueryVariables>(PaginatedReposForProjectEnvironmentDocument, options);
        }
export type PaginatedReposForProjectEnvironmentQueryHookResult = ReturnType<typeof usePaginatedReposForProjectEnvironmentQuery>;
export type PaginatedReposForProjectEnvironmentLazyQueryHookResult = ReturnType<typeof usePaginatedReposForProjectEnvironmentLazyQuery>;
export type PaginatedReposForProjectEnvironmentQueryResult = Apollo.QueryResult<PaginatedReposForProjectEnvironmentQuery, PaginatedReposForProjectEnvironmentQueryVariables>;
export function refetchPaginatedReposForProjectEnvironmentQuery(variables: PaginatedReposForProjectEnvironmentQueryVariables) {
      return { query: PaginatedReposForProjectEnvironmentDocument, variables: variables }
    }
export const PaginatedRepoDeploymentsForProjectEnvironmentDocument = gql`
    query paginatedRepoDeploymentsForProjectEnvironment($path: String!, $environment: String!, $filter: String!, $first: Int!, $after: String!, $sort: String, $statusFilter: [DeploymentStatus]) {
  project(path: $path) {
    id
    environment(name: $environment) {
      id
      name
      overview {
        deploymentStatus
        count
      }
      repoConnection(
        page: {first: $first, after: $after, filter: $filter, sort: $sort}
        repoFilter: {deploymentStatus: $statusFilter}
      ) {
        totalCount
        nodes {
          id
          productionDeployment {
            id
            ...DeploymentCommon
          }
        }
        pageInfo {
          startCursor
          endCursor
          hasNextPage
          hasPreviousPage
        }
      }
    }
  }
}
    ${DeploymentCommonFragmentDoc}`;

/**
 * __usePaginatedRepoDeploymentsForProjectEnvironmentQuery__
 *
 * To run a query within a React component, call `usePaginatedRepoDeploymentsForProjectEnvironmentQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedRepoDeploymentsForProjectEnvironmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedRepoDeploymentsForProjectEnvironmentQuery({
 *   variables: {
 *      path: // value for 'path'
 *      environment: // value for 'environment'
 *      filter: // value for 'filter'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      sort: // value for 'sort'
 *      statusFilter: // value for 'statusFilter'
 *   },
 * });
 */
export function usePaginatedRepoDeploymentsForProjectEnvironmentQuery(baseOptions: Apollo.QueryHookOptions<PaginatedRepoDeploymentsForProjectEnvironmentQuery, PaginatedRepoDeploymentsForProjectEnvironmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaginatedRepoDeploymentsForProjectEnvironmentQuery, PaginatedRepoDeploymentsForProjectEnvironmentQueryVariables>(PaginatedRepoDeploymentsForProjectEnvironmentDocument, options);
      }
export function usePaginatedRepoDeploymentsForProjectEnvironmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaginatedRepoDeploymentsForProjectEnvironmentQuery, PaginatedRepoDeploymentsForProjectEnvironmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaginatedRepoDeploymentsForProjectEnvironmentQuery, PaginatedRepoDeploymentsForProjectEnvironmentQueryVariables>(PaginatedRepoDeploymentsForProjectEnvironmentDocument, options);
        }
export type PaginatedRepoDeploymentsForProjectEnvironmentQueryHookResult = ReturnType<typeof usePaginatedRepoDeploymentsForProjectEnvironmentQuery>;
export type PaginatedRepoDeploymentsForProjectEnvironmentLazyQueryHookResult = ReturnType<typeof usePaginatedRepoDeploymentsForProjectEnvironmentLazyQuery>;
export type PaginatedRepoDeploymentsForProjectEnvironmentQueryResult = Apollo.QueryResult<PaginatedRepoDeploymentsForProjectEnvironmentQuery, PaginatedRepoDeploymentsForProjectEnvironmentQueryVariables>;
export function refetchPaginatedRepoDeploymentsForProjectEnvironmentQuery(variables: PaginatedRepoDeploymentsForProjectEnvironmentQueryVariables) {
      return { query: PaginatedRepoDeploymentsForProjectEnvironmentDocument, variables: variables }
    }
export const ReposForProjectDocument = gql`
    query reposForProject($project: String!) {
  project(path: $project) {
    id
    name
    repos {
      ...RepoListItem
    }
  }
}
    ${RepoListItemFragmentDoc}`;

/**
 * __useReposForProjectQuery__
 *
 * To run a query within a React component, call `useReposForProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useReposForProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReposForProjectQuery({
 *   variables: {
 *      project: // value for 'project'
 *   },
 * });
 */
export function useReposForProjectQuery(baseOptions: Apollo.QueryHookOptions<ReposForProjectQuery, ReposForProjectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReposForProjectQuery, ReposForProjectQueryVariables>(ReposForProjectDocument, options);
      }
export function useReposForProjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReposForProjectQuery, ReposForProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReposForProjectQuery, ReposForProjectQueryVariables>(ReposForProjectDocument, options);
        }
export type ReposForProjectQueryHookResult = ReturnType<typeof useReposForProjectQuery>;
export type ReposForProjectLazyQueryHookResult = ReturnType<typeof useReposForProjectLazyQuery>;
export type ReposForProjectQueryResult = Apollo.QueryResult<ReposForProjectQuery, ReposForProjectQueryVariables>;
export function refetchReposForProjectQuery(variables: ReposForProjectQueryVariables) {
      return { query: ReposForProjectDocument, variables: variables }
    }
export const UserReposWithDbDocument = gql`
    query userReposWithDB($id: ID!) {
  user(id: $id) {
    id
    repos(input: {showDisabled: true}) {
      id
      ...RepoCommonWithDB
    }
  }
}
    ${RepoCommonWithDbFragmentDoc}`;

/**
 * __useUserReposWithDbQuery__
 *
 * To run a query within a React component, call `useUserReposWithDbQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserReposWithDbQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserReposWithDbQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserReposWithDbQuery(baseOptions: Apollo.QueryHookOptions<UserReposWithDbQuery, UserReposWithDbQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserReposWithDbQuery, UserReposWithDbQueryVariables>(UserReposWithDbDocument, options);
      }
export function useUserReposWithDbLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserReposWithDbQuery, UserReposWithDbQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserReposWithDbQuery, UserReposWithDbQueryVariables>(UserReposWithDbDocument, options);
        }
export type UserReposWithDbQueryHookResult = ReturnType<typeof useUserReposWithDbQuery>;
export type UserReposWithDbLazyQueryHookResult = ReturnType<typeof useUserReposWithDbLazyQuery>;
export type UserReposWithDbQueryResult = Apollo.QueryResult<UserReposWithDbQuery, UserReposWithDbQueryVariables>;
export function refetchUserReposWithDbQuery(variables: UserReposWithDbQueryVariables) {
      return { query: UserReposWithDbDocument, variables: variables }
    }
export const UserBasicReposDocument = gql`
    query userBasicRepos($id: ID!) {
  user(id: $id) {
    id
    login
    repos(input: {showDisabled: true}) {
      id
      ...RepoBasic
    }
  }
}
    ${RepoBasicFragmentDoc}`;

/**
 * __useUserBasicReposQuery__
 *
 * To run a query within a React component, call `useUserBasicReposQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserBasicReposQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserBasicReposQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserBasicReposQuery(baseOptions: Apollo.QueryHookOptions<UserBasicReposQuery, UserBasicReposQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserBasicReposQuery, UserBasicReposQueryVariables>(UserBasicReposDocument, options);
      }
export function useUserBasicReposLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserBasicReposQuery, UserBasicReposQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserBasicReposQuery, UserBasicReposQueryVariables>(UserBasicReposDocument, options);
        }
export type UserBasicReposQueryHookResult = ReturnType<typeof useUserBasicReposQuery>;
export type UserBasicReposLazyQueryHookResult = ReturnType<typeof useUserBasicReposLazyQuery>;
export type UserBasicReposQueryResult = Apollo.QueryResult<UserBasicReposQuery, UserBasicReposQueryVariables>;
export function refetchUserBasicReposQuery(variables: UserBasicReposQueryVariables) {
      return { query: UserBasicReposDocument, variables: variables }
    }
export const UserAllBasicReposDocument = gql`
    query userAllBasicRepos {
  currentUser {
    id
    teams {
      id
      team {
        id
        user {
          id
          login
          repos(input: {showDisabled: true}) {
            id
            ...RepoBasic
          }
        }
      }
    }
  }
}
    ${RepoBasicFragmentDoc}`;

/**
 * __useUserAllBasicReposQuery__
 *
 * To run a query within a React component, call `useUserAllBasicReposQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserAllBasicReposQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserAllBasicReposQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserAllBasicReposQuery(baseOptions?: Apollo.QueryHookOptions<UserAllBasicReposQuery, UserAllBasicReposQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserAllBasicReposQuery, UserAllBasicReposQueryVariables>(UserAllBasicReposDocument, options);
      }
export function useUserAllBasicReposLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserAllBasicReposQuery, UserAllBasicReposQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserAllBasicReposQuery, UserAllBasicReposQueryVariables>(UserAllBasicReposDocument, options);
        }
export type UserAllBasicReposQueryHookResult = ReturnType<typeof useUserAllBasicReposQuery>;
export type UserAllBasicReposLazyQueryHookResult = ReturnType<typeof useUserAllBasicReposLazyQuery>;
export type UserAllBasicReposQueryResult = Apollo.QueryResult<UserAllBasicReposQuery, UserAllBasicReposQueryVariables>;
export function refetchUserAllBasicReposQuery(variables?: UserAllBasicReposQueryVariables) {
      return { query: UserAllBasicReposDocument, variables: variables }
    }
export const DeploymentUpdatedDocument = gql`
    subscription deploymentUpdated($id: ID!) {
  deploymentUpdated(id: $id) {
    id
    status
    endpoints
    build {
      id
    }
  }
}
    `;

/**
 * __useDeploymentUpdatedSubscription__
 *
 * To run a query within a React component, call `useDeploymentUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDeploymentUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeploymentUpdatedSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeploymentUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<DeploymentUpdatedSubscription, DeploymentUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<DeploymentUpdatedSubscription, DeploymentUpdatedSubscriptionVariables>(DeploymentUpdatedDocument, options);
      }
export type DeploymentUpdatedSubscriptionHookResult = ReturnType<typeof useDeploymentUpdatedSubscription>;
export type DeploymentUpdatedSubscriptionResult = Apollo.SubscriptionResult<DeploymentUpdatedSubscription>;
export const DeploymentBuildLogsAddedDocument = gql`
    subscription deploymentBuildLogsAdded($input: BuildLogsInput!) {
  deploymentBuildLogsAdded(input: $input) {
    text
    timestamp
  }
}
    `;

/**
 * __useDeploymentBuildLogsAddedSubscription__
 *
 * To run a query within a React component, call `useDeploymentBuildLogsAddedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDeploymentBuildLogsAddedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeploymentBuildLogsAddedSubscription({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeploymentBuildLogsAddedSubscription(baseOptions: Apollo.SubscriptionHookOptions<DeploymentBuildLogsAddedSubscription, DeploymentBuildLogsAddedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<DeploymentBuildLogsAddedSubscription, DeploymentBuildLogsAddedSubscriptionVariables>(DeploymentBuildLogsAddedDocument, options);
      }
export type DeploymentBuildLogsAddedSubscriptionHookResult = ReturnType<typeof useDeploymentBuildLogsAddedSubscription>;
export type DeploymentBuildLogsAddedSubscriptionResult = Apollo.SubscriptionResult<DeploymentBuildLogsAddedSubscription>;
export const CombinedDeploymentMetricsUpdatedDocument = gql`
    subscription combinedDeploymentMetricsUpdated($deploymentID: ID!) {
  deploymentUpdated(id: $deploymentID) {
    id
    cpuMetrics: metrics(name: "cpu") {
      timestamp
      value
    }
    memoryMetrics: metrics(name: "memory") {
      timestamp
      value
    }
    networkMetrics: metrics(name: "network_out") {
      timestamp
      value
    }
    diskMetrics: metrics(name: "disk_usage") {
      timestamp
      value
    }
  }
}
    `;

/**
 * __useCombinedDeploymentMetricsUpdatedSubscription__
 *
 * To run a query within a React component, call `useCombinedDeploymentMetricsUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCombinedDeploymentMetricsUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCombinedDeploymentMetricsUpdatedSubscription({
 *   variables: {
 *      deploymentID: // value for 'deploymentID'
 *   },
 * });
 */
export function useCombinedDeploymentMetricsUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<CombinedDeploymentMetricsUpdatedSubscription, CombinedDeploymentMetricsUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CombinedDeploymentMetricsUpdatedSubscription, CombinedDeploymentMetricsUpdatedSubscriptionVariables>(CombinedDeploymentMetricsUpdatedDocument, options);
      }
export type CombinedDeploymentMetricsUpdatedSubscriptionHookResult = ReturnType<typeof useCombinedDeploymentMetricsUpdatedSubscription>;
export type CombinedDeploymentMetricsUpdatedSubscriptionResult = Apollo.SubscriptionResult<CombinedDeploymentMetricsUpdatedSubscription>;
export const CombinedDeploymentMetricsUpdatedV2Document = gql`
    subscription combinedDeploymentMetricsUpdatedV2($deploymentID: ID!, $deploymentUUID: UUID!, $queryOptions: MetricQueryOptions) {
  deploymentUpdated(id: $deploymentID) {
    id
    cpuMetrics: metricsV2(
      deploymentID: $deploymentUUID
      metricType: CPU
      queryOptions: $queryOptions
    ) {
      ...MetricStream
    }
    memoryMetrics: metricsV2(
      deploymentID: $deploymentUUID
      metricType: MEMORY
      queryOptions: $queryOptions
    ) {
      ...MetricStream
    }
    networkMetrics: metricsV2(
      deploymentID: $deploymentUUID
      metricType: NETWORK
      queryOptions: $queryOptions
    ) {
      ...MetricStream
    }
    diskMetrics: metricsV2(
      deploymentID: $deploymentUUID
      metricType: STORAGE
      queryOptions: $queryOptions
    ) {
      ...MetricStream
    }
  }
}
    ${MetricStreamFragmentDoc}`;

/**
 * __useCombinedDeploymentMetricsUpdatedV2Subscription__
 *
 * To run a query within a React component, call `useCombinedDeploymentMetricsUpdatedV2Subscription` and pass it any options that fit your needs.
 * When your component renders, `useCombinedDeploymentMetricsUpdatedV2Subscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCombinedDeploymentMetricsUpdatedV2Subscription({
 *   variables: {
 *      deploymentID: // value for 'deploymentID'
 *      deploymentUUID: // value for 'deploymentUUID'
 *      queryOptions: // value for 'queryOptions'
 *   },
 * });
 */
export function useCombinedDeploymentMetricsUpdatedV2Subscription(baseOptions: Apollo.SubscriptionHookOptions<CombinedDeploymentMetricsUpdatedV2Subscription, CombinedDeploymentMetricsUpdatedV2SubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CombinedDeploymentMetricsUpdatedV2Subscription, CombinedDeploymentMetricsUpdatedV2SubscriptionVariables>(CombinedDeploymentMetricsUpdatedV2Document, options);
      }
export type CombinedDeploymentMetricsUpdatedV2SubscriptionHookResult = ReturnType<typeof useCombinedDeploymentMetricsUpdatedV2Subscription>;
export type CombinedDeploymentMetricsUpdatedV2SubscriptionResult = Apollo.SubscriptionResult<CombinedDeploymentMetricsUpdatedV2Subscription>;
export const CombinedLambdaDeploymentMetricsUpdatedDocument = gql`
    subscription combinedLambdaDeploymentMetricsUpdated($deploymentID: ID!) {
  deploymentUpdated(id: $deploymentID) {
    id
    awsLinks {
      cloudwatchMetrics
    }
    invocations: metrics(name: "Invocations") {
      timestamp
      value
    }
    errors: metrics(name: "Errors") {
      timestamp
      value
    }
    duration: metrics(name: "Duration") {
      timestamp
      value
    }
    concurrentExecutions: metrics(name: "ConcurrentExecutions") {
      timestamp
      value
    }
  }
}
    `;

/**
 * __useCombinedLambdaDeploymentMetricsUpdatedSubscription__
 *
 * To run a query within a React component, call `useCombinedLambdaDeploymentMetricsUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCombinedLambdaDeploymentMetricsUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCombinedLambdaDeploymentMetricsUpdatedSubscription({
 *   variables: {
 *      deploymentID: // value for 'deploymentID'
 *   },
 * });
 */
export function useCombinedLambdaDeploymentMetricsUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<CombinedLambdaDeploymentMetricsUpdatedSubscription, CombinedLambdaDeploymentMetricsUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CombinedLambdaDeploymentMetricsUpdatedSubscription, CombinedLambdaDeploymentMetricsUpdatedSubscriptionVariables>(CombinedLambdaDeploymentMetricsUpdatedDocument, options);
      }
export type CombinedLambdaDeploymentMetricsUpdatedSubscriptionHookResult = ReturnType<typeof useCombinedLambdaDeploymentMetricsUpdatedSubscription>;
export type CombinedLambdaDeploymentMetricsUpdatedSubscriptionResult = Apollo.SubscriptionResult<CombinedLambdaDeploymentMetricsUpdatedSubscription>;
export const CombinedCloudFunctionDeploymentMetricsUpdatedDocument = gql`
    subscription combinedCloudFunctionDeploymentMetricsUpdated($deploymentID: ID!) {
  deploymentUpdated(id: $deploymentID) {
    id
    gcpLinks {
      cloudMonitoring
    }
    executionCount: metrics(name: "execution_count") {
      timestamp
      value
    }
    duration: metrics(name: "execution_times") {
      timestamp
      value
    }
    memoryUsage: metrics(name: "user_memory_bytes") {
      timestamp
      value
    }
    activeInstances: metrics(name: "active_instances") {
      timestamp
      value
    }
  }
}
    `;

/**
 * __useCombinedCloudFunctionDeploymentMetricsUpdatedSubscription__
 *
 * To run a query within a React component, call `useCombinedCloudFunctionDeploymentMetricsUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCombinedCloudFunctionDeploymentMetricsUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCombinedCloudFunctionDeploymentMetricsUpdatedSubscription({
 *   variables: {
 *      deploymentID: // value for 'deploymentID'
 *   },
 * });
 */
export function useCombinedCloudFunctionDeploymentMetricsUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<CombinedCloudFunctionDeploymentMetricsUpdatedSubscription, CombinedCloudFunctionDeploymentMetricsUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CombinedCloudFunctionDeploymentMetricsUpdatedSubscription, CombinedCloudFunctionDeploymentMetricsUpdatedSubscriptionVariables>(CombinedCloudFunctionDeploymentMetricsUpdatedDocument, options);
      }
export type CombinedCloudFunctionDeploymentMetricsUpdatedSubscriptionHookResult = ReturnType<typeof useCombinedCloudFunctionDeploymentMetricsUpdatedSubscription>;
export type CombinedCloudFunctionDeploymentMetricsUpdatedSubscriptionResult = Apollo.SubscriptionResult<CombinedCloudFunctionDeploymentMetricsUpdatedSubscription>;
export const CombinedCloudRunMetricsUpdatedDocument = gql`
    subscription combinedCloudRunMetricsUpdated($deploymentID: ID!) {
  deploymentUpdated(id: $deploymentID) {
    id
    gcpLinks {
      cloudMonitoring
    }
    request_count: metrics(name: "request_count") {
      timestamp
      value
    }
    instance_count: metrics(name: "container/instance_count") {
      timestamp
      value
    }
    cpu_utilizations: metrics(name: "container/cpu/utilizations") {
      timestamp
      value
    }
    memory_utilizations: metrics(name: "container/memory/utilizations") {
      timestamp
      value
    }
  }
}
    `;

/**
 * __useCombinedCloudRunMetricsUpdatedSubscription__
 *
 * To run a query within a React component, call `useCombinedCloudRunMetricsUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCombinedCloudRunMetricsUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCombinedCloudRunMetricsUpdatedSubscription({
 *   variables: {
 *      deploymentID: // value for 'deploymentID'
 *   },
 * });
 */
export function useCombinedCloudRunMetricsUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<CombinedCloudRunMetricsUpdatedSubscription, CombinedCloudRunMetricsUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CombinedCloudRunMetricsUpdatedSubscription, CombinedCloudRunMetricsUpdatedSubscriptionVariables>(CombinedCloudRunMetricsUpdatedDocument, options);
      }
export type CombinedCloudRunMetricsUpdatedSubscriptionHookResult = ReturnType<typeof useCombinedCloudRunMetricsUpdatedSubscription>;
export type CombinedCloudRunMetricsUpdatedSubscriptionResult = Apollo.SubscriptionResult<CombinedCloudRunMetricsUpdatedSubscription>;
export const DeploymentBuildMetricsDocument = gql`
    subscription deploymentBuildMetrics($deploymentID: ID!) {
  deploymentUpdated(id: $deploymentID) {
    id
    build {
      id
      cpuMetrics: metrics(name: "cpu") {
        timestamp
        value
      }
      memoryMetrics: metrics(name: "memory") {
        timestamp
        value
      }
    }
  }
}
    `;

/**
 * __useDeploymentBuildMetricsSubscription__
 *
 * To run a query within a React component, call `useDeploymentBuildMetricsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDeploymentBuildMetricsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeploymentBuildMetricsSubscription({
 *   variables: {
 *      deploymentID: // value for 'deploymentID'
 *   },
 * });
 */
export function useDeploymentBuildMetricsSubscription(baseOptions: Apollo.SubscriptionHookOptions<DeploymentBuildMetricsSubscription, DeploymentBuildMetricsSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<DeploymentBuildMetricsSubscription, DeploymentBuildMetricsSubscriptionVariables>(DeploymentBuildMetricsDocument, options);
      }
export type DeploymentBuildMetricsSubscriptionHookResult = ReturnType<typeof useDeploymentBuildMetricsSubscription>;
export type DeploymentBuildMetricsSubscriptionResult = Apollo.SubscriptionResult<DeploymentBuildMetricsSubscription>;
export const CombinedAwsRdsMetricsUpdatedDocument = gql`
    subscription combinedAwsRdsMetricsUpdated($deploymentID: ID!) {
  deploymentUpdated(id: $deploymentID) {
    id
    awsLinks {
      cloudwatchMetrics
    }
    CPUUtilization: metrics(name: "CPUUtilization") {
      timestamp
      value
    }
    DatabaseConnections: metrics(name: "DatabaseConnections") {
      timestamp
      value
    }
    FreeStorageSpace: metrics(name: "FreeStorageSpace") {
      timestamp
      value
    }
    FreeableMemory: metrics(name: "FreeableMemory") {
      timestamp
      value
    }
    ReadLatency: metrics(name: "ReadLatency") {
      timestamp
      value
    }
    WriteLatency: metrics(name: "WriteLatency") {
      timestamp
      value
    }
  }
}
    `;

/**
 * __useCombinedAwsRdsMetricsUpdatedSubscription__
 *
 * To run a query within a React component, call `useCombinedAwsRdsMetricsUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCombinedAwsRdsMetricsUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCombinedAwsRdsMetricsUpdatedSubscription({
 *   variables: {
 *      deploymentID: // value for 'deploymentID'
 *   },
 * });
 */
export function useCombinedAwsRdsMetricsUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<CombinedAwsRdsMetricsUpdatedSubscription, CombinedAwsRdsMetricsUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CombinedAwsRdsMetricsUpdatedSubscription, CombinedAwsRdsMetricsUpdatedSubscriptionVariables>(CombinedAwsRdsMetricsUpdatedDocument, options);
      }
export type CombinedAwsRdsMetricsUpdatedSubscriptionHookResult = ReturnType<typeof useCombinedAwsRdsMetricsUpdatedSubscription>;
export type CombinedAwsRdsMetricsUpdatedSubscriptionResult = Apollo.SubscriptionResult<CombinedAwsRdsMetricsUpdatedSubscription>;

      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "BlueprintConfiguration": [
      "BlueprintHelmConfiguration",
      "BlueprintManifestConfiguration",
      "BlueprintTerraformConfiguration"
    ],
    "BlueprintVariable": [
      "BlueprintVariableBoolean",
      "BlueprintVariableFloat",
      "BlueprintVariableInt",
      "BlueprintVariableJSON",
      "BlueprintVariableString"
    ],
    "CISource": [
      "BitbucketRepository",
      "DockerRepository",
      "GitHubRepository",
      "GitlabRepository"
    ],
    "CloudAccount": [
      "AWSAccount",
      "AzureAccount",
      "CoreWeaveAccount",
      "DOAccount",
      "GCPAccount",
      "LinodeAccount",
      "VultrAccount"
    ],
    "DeploymentAlert": [
      "DeploymentPodCrashAlert"
    ],
    "GitRepoIntegration": [
      "BitbucketRepoIntegration",
      "GitHubRepoIntegration",
      "GitlabRepoIntegration"
    ],
    "GitRepository": [
      "BitbucketRepository",
      "GitHubRepository",
      "GitlabRepository"
    ],
    "IPipelineStage": [
      "BuildStage",
      "PipelineStage"
    ],
    "Integration": [
      "BitbucketIntegration",
      "DatadogIntegration",
      "DiscordIntegration",
      "DiscordWebhookIntegration",
      "EmailIntegration",
      "GithubIntegration",
      "GitlabIntegration",
      "SlackIntegration",
      "SlackWebhookIntegration"
    ],
    "NotificationConditionProvider": [
      "NotificationCondition",
      "NotificationConditionGroup"
    ],
    "NotificationIntegration": [
      "DiscordWebhookIntegration",
      "EmailIntegration",
      "SlackWebhookIntegration"
    ],
    "Product": [
      "ApiAccess",
      "PlanTierV2",
      "ProjectPack",
      "SupportTier"
    ],
    "ProfileOwner": [
      "BlueprintOwner",
      "Team",
      "User"
    ],
    "ProjectOwner": [
      "Team",
      "User"
    ],
    "ProjectV3Configuration": [
      "HelmProjectV3Configuration",
      "ManifestProjectV3Configuration",
      "TerraformProjectV3Configuration"
    ],
    "RevisableEntity": [
      "ProjectEnvironmentRevision",
      "ProjectRevision",
      "RepoDeploymentConfiguration"
    ],
    "RevisionConnection": [
      "ProjectEnvironmentRevisionConnection",
      "ProjectRevisionConnection",
      "RepoDeploymentConfigurationConnection"
    ],
    "Runtime": [
      "CloudRuntime",
      "KubernetesRuntime"
    ],
    "ZeetError": [
      "SimpleZeetError"
    ]
  }
};
      export default result;
    